export default [
  {
    "date": "26.11.2021",
    "now": "12,4229",
    "open": "11,9886",
    "highest": "12,7052",
    "lower": "11,8965",
    "difference": "4,37%"
  },
  {
    "date": "25.11.2021",
    "now": "11,9029",
    "open": "12,0876",
    "highest": "12,2650",
    "lower": "11,8044",
    "difference": "-1,51%"
  },
  {
    "date": "24.11.2021",
    "now": "12,0855",
    "open": "12,8215",
    "highest": "13,1945",
    "lower": "11,5410",
    "difference": "-5,72%"
  },
  {
    "date": "23.11.2021",
    "now": "12,8192",
    "open": "11,3827",
    "highest": "13,5276",
    "lower": "11,3306",
    "difference": "12,66%"
  },
  {
    "date": "22.11.2021",
    "now": "11,3790",
    "open": "11,2305",
    "highest": "11,4909",
    "lower": "10,9373",
    "difference": "1,27%"
  },
  {
    "date": "19.11.2021",
    "now": "11,2360",
    "open": "11,0666",
    "highest": "11,3482",
    "lower": "10,8070",
    "difference": "2,21%"
  },
  {
    "date": "18.11.2021",
    "now": "10,9935",
    "open": "10,6282",
    "highest": "11,3225",
    "lower": "10,4340",
    "difference": "3,61%"
  },
  {
    "date": "17.11.2021",
    "now": "10,6103",
    "open": "10,3441",
    "highest": "10,6950",
    "lower": "10,3002",
    "difference": "2,62%"
  },
  {
    "date": "16.11.2021",
    "now": "10,3395",
    "open": "10,0606",
    "highest": "10,4223",
    "lower": "10,0428",
    "difference": "2,88%"
  },
  {
    "date": "15.11.2021",
    "now": "10,0505",
    "open": "9,9885",
    "highest": "10,0862",
    "lower": "9,9364",
    "difference": "0,72%"
  },
  {
    "date": "12.11.2021",
    "now": "9,9784",
    "open": "9,9045",
    "highest": "10,0280",
    "lower": "9,8652",
    "difference": "0,90%"
  },
  {
    "date": "11.11.2021",
    "now": "9,8899",
    "open": "9,8469",
    "highest": "9,9804",
    "lower": "9,8259",
    "difference": "0,53%"
  },
  {
    "date": "10.11.2021",
    "now": "9,8379",
    "open": "9,7331",
    "highest": "9,8835",
    "lower": "9,7164",
    "difference": "1,16%"
  },
  {
    "date": "09.11.2021",
    "now": "9,7252",
    "open": "9,6853",
    "highest": "9,7439",
    "lower": "9,6512",
    "difference": "0,48%"
  },
  {
    "date": "08.11.2021",
    "now": "9,6791",
    "open": "9,6955",
    "highest": "9,7526",
    "lower": "9,6510",
    "difference": "0,05%"
  },
  {
    "date": "05.11.2021",
    "now": "9,6741",
    "open": "9,6895",
    "highest": "9,7543",
    "lower": "9,6613",
    "difference": "-0,18%"
  },
  {
    "date": "04.11.2021",
    "now": "9,6917",
    "open": "9,6447",
    "highest": "9,7748",
    "lower": "9,6236",
    "difference": "0,65%"
  },
  {
    "date": "03.11.2021",
    "now": "9,6290",
    "open": "9,6034",
    "highest": "9,7757",
    "lower": "9,5774",
    "difference": "0,36%"
  },
  {
    "date": "02.11.2021",
    "now": "9,5944",
    "open": "9,5393",
    "highest": "9,6171",
    "lower": "9,4570",
    "difference": "0,65%"
  },
  {
    "date": "01.11.2021",
    "now": "9,5325",
    "open": "9,6070",
    "highest": "9,6204",
    "lower": "9,4792",
    "difference": "-0,73%"
  },
  {
    "date": "29.10.2021",
    "now": "9,6030",
    "open": "9,5435",
    "highest": "9,6367",
    "lower": "9,5002",
    "difference": "0,81%"
  },
  {
    "date": "28.10.2021",
    "now": "9,5262",
    "open": "9,4960",
    "highest": "9,6377",
    "lower": "9,4653",
    "difference": "0,50%"
  },
  {
    "date": "27.10.2021",
    "now": "9,4789",
    "open": "9,5438",
    "highest": "9,5579",
    "lower": "9,4485",
    "difference": "-0,57%"
  },
  {
    "date": "26.10.2021",
    "now": "9,5335",
    "open": "9,5884",
    "highest": "9,6318",
    "lower": "9,3990",
    "difference": "-0,50%"
  },
  {
    "date": "25.10.2021",
    "now": "9,5811",
    "open": "9,6049",
    "highest": "9,8595",
    "lower": "9,5296",
    "difference": "0,06%"
  },
  {
    "date": "22.10.2021",
    "now": "9,5757",
    "open": "9,5189",
    "highest": "9,6650",
    "lower": "9,4760",
    "difference": "0,74%"
  },
  {
    "date": "21.10.2021",
    "now": "9,5050",
    "open": "9,2163",
    "highest": "9,5532",
    "lower": "9,1961",
    "difference": "3,21%"
  },
  {
    "date": "20.10.2021",
    "now": "9,2098",
    "open": "9,3016",
    "highest": "9,3619",
    "lower": "9,1955",
    "difference": "-0,88%"
  },
  {
    "date": "19.10.2021",
    "now": "9,2918",
    "open": "9,3343",
    "highest": "9,3823",
    "lower": "9,2400",
    "difference": "-0,35%"
  },
  {
    "date": "18.10.2021",
    "now": "9,3248",
    "open": "9,2608",
    "highest": "9,3667",
    "lower": "9,2341",
    "difference": "0,79%"
  },
  {
    "date": "15.10.2021",
    "now": "9,2517",
    "open": "9,1876",
    "highest": "9,2836",
    "lower": "9,1663",
    "difference": "0,84%"
  },
  {
    "date": "14.10.2021",
    "now": "9,1750",
    "open": "9,0675",
    "highest": "9,2083",
    "lower": "9,0564",
    "difference": "1,04%"
  },
  {
    "date": "13.10.2021",
    "now": "9,0806",
    "open": "9,0428",
    "highest": "9,1149",
    "lower": "9,0013",
    "difference": "0,52%"
  },
  {
    "date": "12.10.2021",
    "now": "9,0340",
    "open": "8,9997",
    "highest": "9,0542",
    "lower": "8,9780",
    "difference": "0,50%"
  },
  {
    "date": "11.10.2021",
    "now": "8,9890",
    "open": "8,9822",
    "highest": "9,0209",
    "lower": "8,9085",
    "difference": "0,31%"
  },
  {
    "date": "08.10.2021",
    "now": "8,9614",
    "open": "8,8772",
    "highest": "8,9900",
    "lower": "8,8497",
    "difference": "1,03%"
  },
  {
    "date": "07.10.2021",
    "now": "8,8697",
    "open": "8,8775",
    "highest": "8,9109",
    "lower": "8,8372",
    "difference": "0,00%"
  },
  {
    "date": "06.10.2021",
    "now": "8,8695",
    "open": "8,8740",
    "highest": "8,9447",
    "lower": "8,8571",
    "difference": "0,01%"
  },
  {
    "date": "05.10.2021",
    "now": "8,8688",
    "open": "8,8579",
    "highest": "8,9002",
    "lower": "8,8372",
    "difference": "0,19%"
  },
  {
    "date": "04.10.2021",
    "now": "8,8521",
    "open": "8,8615",
    "highest": "8,8871",
    "lower": "8,8230",
    "difference": "-0,04%"
  },
  {
    "date": "01.10.2021",
    "now": "8,8552",
    "open": "8,8909",
    "highest": "8,9072",
    "lower": "8,8132",
    "difference": "-0,35%"
  },
  {
    "date": "30.09.2021",
    "now": "8,8862",
    "open": "8,9239",
    "highest": "8,9447",
    "lower": "8,8505",
    "difference": "-0,28%"
  },
  {
    "date": "29.09.2021",
    "now": "8,9111",
    "open": "8,8767",
    "highest": "8,9607",
    "lower": "8,8250",
    "difference": "0,51%"
  },
  {
    "date": "28.09.2021",
    "now": "8,8657",
    "open": "8,8224",
    "highest": "8,8979",
    "lower": "8,8113",
    "difference": "0,58%"
  },
  {
    "date": "27.09.2021",
    "now": "8,8146",
    "open": "8,8833",
    "highest": "8,9027",
    "lower": "8,8062",
    "difference": "-0,72%"
  },
  {
    "date": "24.09.2021",
    "now": "8,8786",
    "open": "8,7680",
    "highest": "8,9010",
    "lower": "8,7472",
    "difference": "1,33%"
  },
  {
    "date": "23.09.2021",
    "now": "8,7622",
    "open": "8,6572",
    "highest": "8,8099",
    "lower": "8,6167",
    "difference": "1,38%"
  },
  {
    "date": "22.09.2021",
    "now": "8,6431",
    "open": "8,6275",
    "highest": "8,6741",
    "lower": "8,5918",
    "difference": "0,27%"
  },
  {
    "date": "21.09.2021",
    "now": "8,6200",
    "open": "8,6714",
    "highest": "8,6840",
    "lower": "8,5778",
    "difference": "-0,47%"
  },
  {
    "date": "20.09.2021",
    "now": "8,6604",
    "open": "8,6461",
    "highest": "8,7311",
    "lower": "8,6313",
    "difference": "0,37%"
  },
  {
    "date": "17.09.2021",
    "now": "8,6283",
    "open": "8,5306",
    "highest": "8,6643",
    "lower": "8,4930",
    "difference": "1,22%"
  },
  {
    "date": "16.09.2021",
    "now": "8,5241",
    "open": "8,4354",
    "highest": "8,5497",
    "lower": "8,4154",
    "difference": "1,16%"
  },
  {
    "date": "15.09.2021",
    "now": "8,4263",
    "open": "8,4417",
    "highest": "8,4681",
    "lower": "8,4073",
    "difference": "-0,02%"
  },
  {
    "date": "14.09.2021",
    "now": "8,4276",
    "open": "8,4277",
    "highest": "8,4759",
    "lower": "8,4003",
    "difference": "0,10%"
  },
  {
    "date": "13.09.2021",
    "now": "8,4195",
    "open": "8,4694",
    "highest": "8,4843",
    "lower": "8,4105",
    "difference": "-0,42%"
  },
  {
    "date": "10.09.2021",
    "now": "8,4553",
    "open": "8,4366",
    "highest": "8,4830",
    "lower": "8,3792",
    "difference": "0,29%"
  },
  {
    "date": "09.09.2021",
    "now": "8,4305",
    "open": "8,4734",
    "highest": "8,5257",
    "lower": "8,4239",
    "difference": "-0,35%"
  },
  {
    "date": "08.09.2021",
    "now": "8,4597",
    "open": "8,3532",
    "highest": "8,4906",
    "lower": "8,3324",
    "difference": "1,38%"
  },
  {
    "date": "07.09.2021",
    "now": "8,3447",
    "open": "8,2818",
    "highest": "8,3572",
    "lower": "8,2600",
    "difference": "0,82%"
  },
  {
    "date": "06.09.2021",
    "now": "8,2771",
    "open": "8,3236",
    "highest": "8,3382",
    "lower": "8,2600",
    "difference": "-0,33%"
  },
  {
    "date": "03.09.2021",
    "now": "8,3049",
    "open": "8,2781",
    "highest": "8,3519",
    "lower": "8,2552",
    "difference": "0,39%"
  },
  {
    "date": "02.09.2021",
    "now": "8,2729",
    "open": "8,2967",
    "highest": "8,3149",
    "lower": "8,2556",
    "difference": "-0,22%"
  },
  {
    "date": "01.09.2021",
    "now": "8,2910",
    "open": "8,3164",
    "highest": "8,3374",
    "lower": "8,2675",
    "difference": "-0,16%"
  },
  {
    "date": "31.08.2021",
    "now": "8,3045",
    "open": "8,3807",
    "highest": "8,3949",
    "lower": "8,2845",
    "difference": "-0,84%"
  },
  {
    "date": "30.08.2021",
    "now": "8,3749",
    "open": "8,3546",
    "highest": "8,3969",
    "lower": "8,3221",
    "difference": "0,38%"
  },
  {
    "date": "27.08.2021",
    "now": "8,3434",
    "open": "8,3925",
    "highest": "8,4169",
    "lower": "8,3315",
    "difference": "-0,51%"
  },
  {
    "date": "26.08.2021",
    "now": "8,3865",
    "open": "8,3788",
    "highest": "8,4128",
    "lower": "8,3335",
    "difference": "0,22%"
  },
  {
    "date": "25.08.2021",
    "now": "8,3682",
    "open": "8,4104",
    "highest": "8,4323",
    "lower": "8,3558",
    "difference": "-0,33%"
  },
  {
    "date": "24.08.2021",
    "now": "8,3959",
    "open": "8,4277",
    "highest": "8,4547",
    "lower": "8,3837",
    "difference": "-0,27%"
  },
  {
    "date": "23.08.2021",
    "now": "8,4187",
    "open": "8,4939",
    "highest": "8,5107",
    "lower": "8,4153",
    "difference": "-0,78%"
  },
  {
    "date": "20.08.2021",
    "now": "8,4852",
    "open": "8,5036",
    "highest": "8,5814",
    "lower": "8,2712",
    "difference": "-0,10%"
  },
  {
    "date": "19.08.2021",
    "now": "8,4939",
    "open": "8,4560",
    "highest": "8,5629",
    "lower": "8,3823",
    "difference": "0,54%"
  },
  {
    "date": "18.08.2021",
    "now": "8,4485",
    "open": "8,4330",
    "highest": "8,5069",
    "lower": "8,3998",
    "difference": "0,24%"
  },
  {
    "date": "17.08.2021",
    "now": "8,4284",
    "open": "8,4614",
    "highest": "8,4959",
    "lower": "8,3728",
    "difference": "-0,29%"
  },
  {
    "date": "16.08.2021",
    "now": "8,4530",
    "open": "8,5242",
    "highest": "8,5383",
    "lower": "8,4283",
    "difference": "-0,75%"
  },
  {
    "date": "13.08.2021",
    "now": "8,5171",
    "open": "8,5466",
    "highest": "8,5874",
    "lower": "8,4925",
    "difference": "-0,38%"
  },
  {
    "date": "12.08.2021",
    "now": "8,5497",
    "open": "8,6311",
    "highest": "8,6423",
    "lower": "8,5025",
    "difference": "-0,87%"
  },
  {
    "date": "11.08.2021",
    "now": "8,6246",
    "open": "8,5992",
    "highest": "8,6885",
    "lower": "8,5389",
    "difference": "0,31%"
  },
  {
    "date": "10.08.2021",
    "now": "8,5980",
    "open": "8,6447",
    "highest": "8,6793",
    "lower": "8,5612",
    "difference": "-0,53%"
  },
  {
    "date": "09.08.2021",
    "now": "8,6439",
    "open": "8,6215",
    "highest": "8,6775",
    "lower": "8,6013",
    "difference": "0,32%"
  },
  {
    "date": "06.08.2021",
    "now": "8,6160",
    "open": "8,5270",
    "highest": "8,6490",
    "lower": "8,5080",
    "difference": "1,08%"
  },
  {
    "date": "05.08.2021",
    "now": "8,5240",
    "open": "8,4784",
    "highest": "8,5801",
    "lower": "8,4635",
    "difference": "0,61%"
  },
  {
    "date": "04.08.2021",
    "now": "8,4727",
    "open": "8,4085",
    "highest": "8,4986",
    "lower": "8,3719",
    "difference": "0,84%"
  },
  {
    "date": "03.08.2021",
    "now": "8,4022",
    "open": "8,3541",
    "highest": "8,4543",
    "lower": "8,2840",
    "difference": "0,70%"
  },
  {
    "date": "02.08.2021",
    "now": "8,3440",
    "open": "8,4539",
    "highest": "8,4851",
    "lower": "8,3228",
    "difference": "-1,06%"
  },
  {
    "date": "30.07.2021",
    "now": "8,4333",
    "open": "8,4593",
    "highest": "8,4962",
    "lower": "8,3824",
    "difference": "-0,05%"
  },
  {
    "date": "29.07.2021",
    "now": "8,4375",
    "open": "8,5553",
    "highest": "8,5701",
    "lower": "8,4285",
    "difference": "-1,30%"
  },
  {
    "date": "28.07.2021",
    "now": "8,5488",
    "open": "8,5653",
    "highest": "8,5872",
    "lower": "8,5325",
    "difference": "-0,10%"
  },
  {
    "date": "27.07.2021",
    "now": "8,5577",
    "open": "8,5584",
    "highest": "8,5899",
    "lower": "8,5360",
    "difference": "0,04%"
  },
  {
    "date": "26.07.2021",
    "now": "8,5539",
    "open": "8,5584",
    "highest": "8,6302",
    "lower": "8,5310",
    "difference": "0,08%"
  },
  {
    "date": "23.07.2021",
    "now": "8,5471",
    "open": "8,5642",
    "highest": "8,5749",
    "lower": "8,5086",
    "difference": "-0,08%"
  },
  {
    "date": "22.07.2021",
    "now": "8,5536",
    "open": "8,5380",
    "highest": "8,5871",
    "lower": "8,5153",
    "difference": "-0,05%"
  },
  {
    "date": "21.07.2021",
    "now": "8,5577",
    "open": "8,5683",
    "highest": "8,6107",
    "lower": "8,5222",
    "difference": "-0,06%"
  },
  {
    "date": "20.07.2021",
    "now": "8,5629",
    "open": "8,5877",
    "highest": "8,6094",
    "lower": "8,5063",
    "difference": "-0,09%"
  },
  {
    "date": "19.07.2021",
    "now": "8,5702",
    "open": "8,5255",
    "highest": "8,6187",
    "lower": "8,4881",
    "difference": "0,66%"
  },
  {
    "date": "16.07.2021",
    "now": "8,5144",
    "open": "8,5697",
    "highest": "8,5906",
    "lower": "8,4756",
    "difference": "-0,54%"
  },
  {
    "date": "15.07.2021",
    "now": "8,5610",
    "open": "8,5918",
    "highest": "8,6007",
    "lower": "8,5391",
    "difference": "-0,25%"
  },
  {
    "date": "14.07.2021",
    "now": "8,5828",
    "open": "8,6253",
    "highest": "8,6540",
    "lower": "8,5689",
    "difference": "-0,39%"
  },
  {
    "date": "13.07.2021",
    "now": "8,6162",
    "open": "8,6410",
    "highest": "8,6573",
    "lower": "8,5725",
    "difference": "-0,21%"
  },
  {
    "date": "12.07.2021",
    "now": "8,6344",
    "open": "8,6661",
    "highest": "8,6809",
    "lower": "8,6154",
    "difference": "-0,14%"
  },
  {
    "date": "09.07.2021",
    "now": "8,6461",
    "open": "8,6892",
    "highest": "8,7142",
    "lower": "8,6250",
    "difference": "-0,50%"
  },
  {
    "date": "08.07.2021",
    "now": "8,6897",
    "open": "8,6902",
    "highest": "8,7409",
    "lower": "8,6652",
    "difference": "0,07%"
  },
  {
    "date": "07.07.2021",
    "now": "8,6837",
    "open": "8,6918",
    "highest": "8,7222",
    "lower": "8,6427",
    "difference": "-0,04%"
  },
  {
    "date": "06.07.2021",
    "now": "8,6869",
    "open": "8,6723",
    "highest": "8,7112",
    "lower": "8,6220",
    "difference": "0,27%"
  },
  {
    "date": "05.07.2021",
    "now": "8,6631",
    "open": "8,6900",
    "highest": "8,7157",
    "lower": "8,6459",
    "difference": "-0,19%"
  },
  {
    "date": "02.07.2021",
    "now": "8,6792",
    "open": "8,6634",
    "highest": "8,7262",
    "lower": "8,6433",
    "difference": "0,33%"
  },
  {
    "date": "01.07.2021",
    "now": "8,6508",
    "open": "8,7087",
    "highest": "8,7325",
    "lower": "8,6350",
    "difference": "-0,61%"
  },
  {
    "date": "30.06.2021",
    "now": "8,7037",
    "open": "8,7381",
    "highest": "8,7498",
    "lower": "8,6355",
    "difference": "-0,30%"
  },
  {
    "date": "29.06.2021",
    "now": "8,7299",
    "open": "8,6825",
    "highest": "8,7578",
    "lower": "8,6425",
    "difference": "0,54%"
  },
  {
    "date": "28.06.2021",
    "now": "8,6832",
    "open": "8,7670",
    "highest": "8,7739",
    "lower": "8,6734",
    "difference": "-0,76%"
  },
  {
    "date": "25.06.2021",
    "now": "8,7493",
    "open": "8,6960",
    "highest": "8,8061",
    "lower": "8,6412",
    "difference": "0,57%"
  },
  {
    "date": "24.06.2021",
    "now": "8,7000",
    "open": "8,6428",
    "highest": "8,7220",
    "lower": "8,6243",
    "difference": "0,78%"
  },
  {
    "date": "23.06.2021",
    "now": "8,6323",
    "open": "8,6531",
    "highest": "8,6849",
    "lower": "8,5852",
    "difference": "-0,14%"
  },
  {
    "date": "22.06.2021",
    "now": "8,6444",
    "open": "8,7698",
    "highest": "8,8013",
    "lower": "8,6315",
    "difference": "-1,36%"
  },
  {
    "date": "21.06.2021",
    "now": "8,7633",
    "open": "8,7376",
    "highest": "8,8057",
    "lower": "8,7102",
    "difference": "0,43%"
  },
  {
    "date": "18.06.2021",
    "now": "8,7257",
    "open": "8,7199",
    "highest": "8,7610",
    "lower": "8,6371",
    "difference": "0,19%"
  },
  {
    "date": "17.06.2021",
    "now": "8,7092",
    "open": "8,6073",
    "highest": "8,7375",
    "lower": "8,5900",
    "difference": "1,25%"
  },
  {
    "date": "16.06.2021",
    "now": "8,6021",
    "open": "8,5574",
    "highest": "8,6368",
    "lower": "8,4870",
    "difference": "0,64%"
  },
  {
    "date": "15.06.2021",
    "now": "8,5476",
    "open": "8,4691",
    "highest": "8,5989",
    "lower": "8,4355",
    "difference": "1,05%"
  },
  {
    "date": "14.06.2021",
    "now": "8,4587",
    "open": "8,3881",
    "highest": "8,4868",
    "lower": "8,2915",
    "difference": "0,92%"
  },
  {
    "date": "11.06.2021",
    "now": "8,3818",
    "open": "8,4267",
    "highest": "8,4503",
    "lower": "8,2647",
    "difference": "-0,48%"
  },
  {
    "date": "10.06.2021",
    "now": "8,4219",
    "open": "8,5883",
    "highest": "8,6032",
    "lower": "8,4089",
    "difference": "-1,83%"
  },
  {
    "date": "09.06.2021",
    "now": "8,5787",
    "open": "8,6051",
    "highest": "8,6266",
    "lower": "8,5588",
    "difference": "-0,22%"
  },
  {
    "date": "08.06.2021",
    "now": "8,5979",
    "open": "8,6128",
    "highest": "8,6383",
    "lower": "8,5647",
    "difference": "0,27%"
  },
  {
    "date": "07.06.2021",
    "now": "8,5745",
    "open": "8,6687",
    "highest": "8,6937",
    "lower": "8,5800",
    "difference": "-0,94%"
  },
  {
    "date": "04.06.2021",
    "now": "8,6563",
    "open": "8,7024",
    "highest": "8,7591",
    "lower": "8,6229",
    "difference": "-0,39%"
  },
  {
    "date": "03.06.2021",
    "now": "8,6905",
    "open": "8,5927",
    "highest": "8,7288",
    "lower": "8,5772",
    "difference": "1,26%"
  },
  {
    "date": "02.06.2021",
    "now": "8,5826",
    "open": "8,5369",
    "highest": "8,7855",
    "lower": "8,5262",
    "difference": "0,62%"
  },
  {
    "date": "01.06.2021",
    "now": "8,5301",
    "open": "8,4894",
    "highest": "8,5506",
    "lower": "8,4637",
    "difference": "0,58%"
  },
  {
    "date": "31.05.2021",
    "now": "8,4808",
    "open": "8,5604",
    "highest": "8,5902",
    "lower": "8,4558",
    "difference": "-0,79%"
  },
  {
    "date": "28.05.2021",
    "now": "8,5484",
    "open": "8,5021",
    "highest": "8,6237",
    "lower": "8,4525",
    "difference": "0,61%"
  },
  {
    "date": "27.05.2021",
    "now": "8,4967",
    "open": "8,4562",
    "highest": "8,5488",
    "lower": "8,4160",
    "difference": "0,55%"
  },
  {
    "date": "26.05.2021",
    "now": "8,4501",
    "open": "8,4582",
    "highest": "8,4797",
    "lower": "8,4044",
    "difference": "0,00%"
  },
  {
    "date": "25.05.2021",
    "now": "8,4501",
    "open": "8,3883",
    "highest": "8,4948",
    "lower": "8,3663",
    "difference": "0,85%"
  },
  {
    "date": "24.05.2021",
    "now": "8,3786",
    "open": "8,4170",
    "highest": "8,4378",
    "lower": "8,3604",
    "difference": "-0,33%"
  },
  {
    "date": "21.05.2021",
    "now": "8,4066",
    "open": "8,3800",
    "highest": "8,4258",
    "lower": "8,3282",
    "difference": "0,44%"
  },
  {
    "date": "20.05.2021",
    "now": "8,3700",
    "open": "8,4137",
    "highest": "8,4247",
    "lower": "8,3270",
    "difference": "-0,40%"
  },
  {
    "date": "19.05.2021",
    "now": "8,4033",
    "open": "8,3559",
    "highest": "8,4432",
    "lower": "8,3442",
    "difference": "0,72%"
  },
  {
    "date": "18.05.2021",
    "now": "8,3436",
    "open": "8,3134",
    "highest": "8,3790",
    "lower": "8,2898",
    "difference": "0,42%"
  },
  {
    "date": "17.05.2021",
    "now": "8,3087",
    "open": "8,4680",
    "highest": "8,4718",
    "lower": "8,2969",
    "difference": "-1,57%"
  },
  {
    "date": "14.05.2021",
    "now": "8,4413",
    "open": "8,5026",
    "highest": "8,5140",
    "lower": "8,3795",
    "difference": "-0,65%"
  },
  {
    "date": "13.05.2021",
    "now": "8,4964",
    "open": "8,4323",
    "highest": "8,5152",
    "lower": "8,4093",
    "difference": "0,94%"
  },
  {
    "date": "12.05.2021",
    "now": "8,4170",
    "open": "8,2883",
    "highest": "8,4579",
    "lower": "8,2700",
    "difference": "1,64%"
  },
  {
    "date": "11.05.2021",
    "now": "8,2811",
    "open": "8,2787",
    "highest": "8,3324",
    "lower": "8,2625",
    "difference": "0,18%"
  },
  {
    "date": "10.05.2021",
    "now": "8,2665",
    "open": "8,2429",
    "highest": "8,2913",
    "lower": "8,2140",
    "difference": "0,40%"
  },
  {
    "date": "07.05.2021",
    "now": "8,2336",
    "open": "8,2824",
    "highest": "8,3139",
    "lower": "8,2080",
    "difference": "-0,41%"
  },
  {
    "date": "06.05.2021",
    "now": "8,2679",
    "open": "8,3282",
    "highest": "8,3609",
    "lower": "8,2653",
    "difference": "-0,54%"
  },
  {
    "date": "05.05.2021",
    "now": "8,3125",
    "open": "8,3288",
    "highest": "8,3823",
    "lower": "8,2994",
    "difference": "-0,09%"
  },
  {
    "date": "04.05.2021",
    "now": "8,3203",
    "open": "8,2460",
    "highest": "8,3558",
    "lower": "8,2374",
    "difference": "0,90%"
  },
  {
    "date": "03.05.2021",
    "now": "8,2461",
    "open": "8,2891",
    "highest": "8,3425",
    "lower": "8,2338",
    "difference": "-0,33%"
  },
  {
    "date": "30.04.2021",
    "now": "8,2735",
    "open": "8,2185",
    "highest": "8,3298",
    "lower": "8,1785",
    "difference": "0,77%"
  },
  {
    "date": "29.04.2021",
    "now": "8,2105",
    "open": "8,2007",
    "highest": "8,2837",
    "lower": "8,1213",
    "difference": "0,20%"
  },
  {
    "date": "28.04.2021",
    "now": "8,1945",
    "open": "8,2172",
    "highest": "8,2554",
    "lower": "8,1480",
    "difference": "-0,04%"
  },
  {
    "date": "27.04.2021",
    "now": "8,1977",
    "open": "8,2827",
    "highest": "8,3112",
    "lower": "8,1687",
    "difference": "-0,90%"
  },
  {
    "date": "26.04.2021",
    "now": "8,2724",
    "open": "8,3934",
    "highest": "8,4942",
    "lower": "8,2668",
    "difference": "-1,24%"
  },
  {
    "date": "23.04.2021",
    "now": "8,3762",
    "open": "8,3243",
    "highest": "8,4256",
    "lower": "8,2886",
    "difference": "0,86%"
  },
  {
    "date": "22.04.2021",
    "now": "8,3049",
    "open": "8,1889",
    "highest": "8,3717",
    "lower": "8,1755",
    "difference": "1,54%"
  },
  {
    "date": "21.04.2021",
    "now": "8,1786",
    "open": "8,1165",
    "highest": "8,2168",
    "lower": "8,1006",
    "difference": "0,91%"
  },
  {
    "date": "20.04.2021",
    "now": "8,1052",
    "open": "8,0955",
    "highest": "8,1381",
    "lower": "8,0676",
    "difference": "0,23%"
  },
  {
    "date": "19.04.2021",
    "now": "8,0863",
    "open": "8,0746",
    "highest": "8,1171",
    "lower": "8,0235",
    "difference": "0,37%"
  },
  {
    "date": "16.04.2021",
    "now": "8,0567",
    "open": "8,0205",
    "highest": "8,1204",
    "lower": "8,0082",
    "difference": "0,64%"
  },
  {
    "date": "15.04.2021",
    "now": "8,0053",
    "open": "8,0789",
    "highest": "8,1660",
    "lower": "8,0007",
    "difference": "-0,78%"
  },
  {
    "date": "14.04.2021",
    "now": "8,0682",
    "open": "8,1202",
    "highest": "8,1416",
    "lower": "8,0206",
    "difference": "-0,57%"
  },
  {
    "date": "13.04.2021",
    "now": "8,1146",
    "open": "8,1575",
    "highest": "8,1877",
    "lower": "8,1032",
    "difference": "-0,34%"
  },
  {
    "date": "12.04.2021",
    "now": "8,1421",
    "open": "8,1655",
    "highest": "8,2371",
    "lower": "8,1015",
    "difference": "-0,14%"
  },
  {
    "date": "09.04.2021",
    "now": "8,1534",
    "open": "8,1413",
    "highest": "8,2065",
    "lower": "8,1150",
    "difference": "0,31%"
  },
  {
    "date": "08.04.2021",
    "now": "8,1281",
    "open": "8,1615",
    "highest": "8,1975",
    "lower": "8,1206",
    "difference": "-0,04%"
  },
  {
    "date": "07.04.2021",
    "now": "8,1310",
    "open": "8,1417",
    "highest": "8,2240",
    "lower": "8,1269",
    "difference": "0,05%"
  },
  {
    "date": "06.04.2021",
    "now": "8,1266",
    "open": "8,1112",
    "highest": "8,1873",
    "lower": "8,0805",
    "difference": "0,35%"
  },
  {
    "date": "05.04.2021",
    "now": "8,0981",
    "open": "8,1695",
    "highest": "8,2560",
    "lower": "8,0830",
    "difference": "-0,78%"
  },
  {
    "date": "02.04.2021",
    "now": "8,1619",
    "open": "8,1227",
    "highest": "8,1967",
    "lower": "7,9745",
    "difference": "0,72%"
  },
  {
    "date": "01.04.2021",
    "now": "8,1036",
    "open": "8,2487",
    "highest": "8,3001",
    "lower": "8,0943",
    "difference": "-1,70%"
  },
  {
    "date": "31.03.2021",
    "now": "8,2439",
    "open": "8,3387",
    "highest": "8,4053",
    "lower": "8,2165",
    "difference": "-1,05%"
  },
  {
    "date": "30.03.2021",
    "now": "8,3312",
    "open": "8,2085",
    "highest": "8,4677",
    "lower": "8,1910",
    "difference": "1,71%"
  },
  {
    "date": "29.03.2021",
    "now": "8,1910",
    "open": "8,1192",
    "highest": "8,2245",
    "lower": "8,0048",
    "difference": "0,69%"
  },
  {
    "date": "26.03.2021",
    "now": "8,1350",
    "open": "7,9488",
    "highest": "8,1615",
    "lower": "7,9130",
    "difference": "2,44%"
  },
  {
    "date": "25.03.2021",
    "now": "7,9412",
    "open": "7,9345",
    "highest": "8,0143",
    "lower": "7,8833",
    "difference": "0,28%"
  },
  {
    "date": "24.03.2021",
    "now": "7,9187",
    "open": "7,9400",
    "highest": "8,0633",
    "lower": "7,8230",
    "difference": "-0,26%"
  },
  {
    "date": "23.03.2021",
    "now": "7,9392",
    "open": "7,8026",
    "highest": "7,9756",
    "lower": "7,6807",
    "difference": "1,83%"
  },
  {
    "date": "22.03.2021",
    "now": "7,7963",
    "open": "7,2185",
    "highest": "8,1795",
    "lower": "7,2180",
    "difference": "8,07%"
  },
  {
    "date": "19.03.2021",
    "now": "7,2140",
    "open": "7,3250",
    "highest": "7,3694",
    "lower": "7,1909",
    "difference": "-1,44%"
  },
  {
    "date": "18.03.2021",
    "now": "7,3193",
    "open": "7,5037",
    "highest": "7,5680",
    "lower": "7,2874",
    "difference": "-2,43%"
  },
  {
    "date": "17.03.2021",
    "now": "7,5017",
    "open": "7,4950",
    "highest": "7,6411",
    "lower": "7,4790",
    "difference": "0,15%"
  },
  {
    "date": "16.03.2021",
    "now": "7,4907",
    "open": "7,5378",
    "highest": "7,5547",
    "lower": "7,4645",
    "difference": "-0,54%"
  },
  {
    "date": "15.03.2021",
    "now": "7,5316",
    "open": "7,5635",
    "highest": "7,6212",
    "lower": "7,4955",
    "difference": "-0,36%"
  },
  {
    "date": "12.03.2021",
    "now": "7,5586",
    "open": "7,4805",
    "highest": "7,6231",
    "lower": "7,4690",
    "difference": "1,31%"
  },
  {
    "date": "11.03.2021",
    "now": "7,4612",
    "open": "7,5010",
    "highest": "7,5601",
    "lower": "7,4270",
    "difference": "-0,48%"
  },
  {
    "date": "10.03.2021",
    "now": "7,4974",
    "open": "7,6170",
    "highest": "7,6707",
    "lower": "7,4912",
    "difference": "-1,50%"
  },
  {
    "date": "09.03.2021",
    "now": "7,6116",
    "open": "7,7565",
    "highest": "7,7861",
    "lower": "7,5862",
    "difference": "-2,04%"
  },
  {
    "date": "08.03.2021",
    "now": "7,7698",
    "open": "7,5380",
    "highest": "7,7857",
    "lower": "7,5095",
    "difference": "3,12%"
  },
  {
    "date": "05.03.2021",
    "now": "7,5348",
    "open": "7,5079",
    "highest": "7,5856",
    "lower": "7,4668",
    "difference": "0,48%"
  },
  {
    "date": "04.03.2021",
    "now": "7,4989",
    "open": "7,4618",
    "highest": "7,5833",
    "lower": "7,4011",
    "difference": "0,57%"
  },
  {
    "date": "03.03.2021",
    "now": "7,4565",
    "open": "7,3522",
    "highest": "7,5009",
    "lower": "7,2905",
    "difference": "1,49%"
  },
  {
    "date": "02.03.2021",
    "now": "7,3472",
    "open": "7,2886",
    "highest": "7,4231",
    "lower": "7,2741",
    "difference": "0,97%"
  },
  {
    "date": "01.03.2021",
    "now": "7,2769",
    "open": "7,4269",
    "highest": "7,4296",
    "lower": "7,2181",
    "difference": "-1,96%"
  },
  {
    "date": "26.02.2021",
    "now": "7,4226",
    "open": "7,3418",
    "highest": "7,4925",
    "lower": "7,2979",
    "difference": "1,20%"
  },
  {
    "date": "25.02.2021",
    "now": "7,3345",
    "open": "7,1684",
    "highest": "7,4460",
    "lower": "7,1537",
    "difference": "2,37%"
  },
  {
    "date": "24.02.2021",
    "now": "7,1648",
    "open": "7,1068",
    "highest": "7,2527",
    "lower": "7,0721",
    "difference": "0,88%"
  },
  {
    "date": "23.02.2021",
    "now": "7,1020",
    "open": "7,0201",
    "highest": "7,1178",
    "lower": "7,0017",
    "difference": "1,25%"
  },
  {
    "date": "22.02.2021",
    "now": "7,0144",
    "open": "6,9637",
    "highest": "7,0925",
    "lower": "6,9576",
    "difference": "0,80%"
  },
  {
    "date": "19.02.2021",
    "now": "6,9587",
    "open": "6,9719",
    "highest": "7,0086",
    "lower": "6,9460",
    "difference": "0,01%"
  },
  {
    "date": "18.02.2021",
    "now": "6,9583",
    "open": "6,9710",
    "highest": "7,0118",
    "lower": "6,9201",
    "difference": "-0,15%"
  },
  {
    "date": "17.02.2021",
    "now": "6,9687",
    "open": "6,9928",
    "highest": "7,0603",
    "lower": "6,9565",
    "difference": "-0,25%"
  },
  {
    "date": "16.02.2021",
    "now": "6,9863",
    "open": "6,9655",
    "highest": "7,0213",
    "lower": "6,8882",
    "difference": "0,40%"
  },
  {
    "date": "15.02.2021",
    "now": "6,9584",
    "open": "7,0355",
    "highest": "7,0386",
    "lower": "6,9427",
    "difference": "-1,05%"
  },
  {
    "date": "12.02.2021",
    "now": "7,0319",
    "open": "7,0227",
    "highest": "7,0543",
    "lower": "7,0037",
    "difference": "0,12%"
  },
  {
    "date": "11.02.2021",
    "now": "7,0235",
    "open": "7,0619",
    "highest": "7,0718",
    "lower": "7,0051",
    "difference": "-0,42%"
  },
  {
    "date": "10.02.2021",
    "now": "7,0528",
    "open": "7,0655",
    "highest": "7,0890",
    "lower": "7,0287",
    "difference": "-0,08%"
  },
  {
    "date": "09.02.2021",
    "now": "7,0581",
    "open": "7,0713",
    "highest": "7,1451",
    "lower": "7,0612",
    "difference": "-0,13%"
  },
  {
    "date": "08.02.2021",
    "now": "7,0671",
    "open": "7,0601",
    "highest": "7,1256",
    "lower": "7,0237",
    "difference": "0,26%"
  },
  {
    "date": "05.02.2021",
    "now": "7,0488",
    "open": "7,1373",
    "highest": "7,1491",
    "lower": "7,0289",
    "difference": "-1,18%"
  },
  {
    "date": "04.02.2021",
    "now": "7,1333",
    "open": "7,1624",
    "highest": "7,1836",
    "lower": "7,0952",
    "difference": "-0,33%"
  },
  {
    "date": "03.02.2021",
    "now": "7,1570",
    "open": "7,1967",
    "highest": "7,2058",
    "lower": "7,1198",
    "difference": "-0,48%"
  },
  {
    "date": "02.02.2021",
    "now": "7,1917",
    "open": "7,1920",
    "highest": "7,2042",
    "lower": "7,0851",
    "difference": "0,05%"
  },
  {
    "date": "01.02.2021",
    "now": "7,1883",
    "open": "7,3151",
    "highest": "7,3177",
    "lower": "7,1557",
    "difference": "-1,66%"
  },
  {
    "date": "29.01.2021",
    "now": "7,3099",
    "open": "7,3430",
    "highest": "7,3910",
    "lower": "7,2695",
    "difference": "-0,31%"
  },
  {
    "date": "28.01.2021",
    "now": "7,3324",
    "open": "7,3955",
    "highest": "7,4365",
    "lower": "7,3262",
    "difference": "-0,80%"
  },
  {
    "date": "27.01.2021",
    "now": "7,3918",
    "open": "7,3464",
    "highest": "7,4166",
    "lower": "7,3355",
    "difference": "0,67%"
  },
  {
    "date": "26.01.2021",
    "now": "7,3429",
    "open": "7,4065",
    "highest": "7,4376",
    "lower": "7,3290",
    "difference": "-0,83%"
  },
  {
    "date": "25.01.2021",
    "now": "7,4040",
    "open": "7,4147",
    "highest": "7,4309",
    "lower": "7,3624",
    "difference": "-0,09%"
  },
  {
    "date": "22.01.2021",
    "now": "7,4106",
    "open": "7,3684",
    "highest": "7,4460",
    "lower": "7,3643",
    "difference": "0,64%"
  },
  {
    "date": "21.01.2021",
    "now": "7,3636",
    "open": "7,4201",
    "highest": "7,4292",
    "lower": "7,3440",
    "difference": "-0,72%"
  },
  {
    "date": "20.01.2021",
    "now": "7,4169",
    "open": "7,4770",
    "highest": "7,4888",
    "lower": "7,3846",
    "difference": "-0,70%"
  },
  {
    "date": "19.01.2021",
    "now": "7,4691",
    "open": "7,4818",
    "highest": "7,4914",
    "lower": "7,4132",
    "difference": "-0,10%"
  },
  {
    "date": "18.01.2021",
    "now": "7,4768",
    "open": "7,4729",
    "highest": "7,5458",
    "lower": "7,4551",
    "difference": "0,05%"
  },
  {
    "date": "15.01.2021",
    "now": "7,4733",
    "open": "7,3615",
    "highest": "7,5178",
    "lower": "7,3495",
    "difference": "1,40%"
  },
  {
    "date": "14.01.2021",
    "now": "7,3699",
    "open": "7,4014",
    "highest": "7,4640",
    "lower": "7,3494",
    "difference": "-0,32%"
  },
  {
    "date": "13.01.2021",
    "now": "7,3934",
    "open": "7,4530",
    "highest": "7,4776",
    "lower": "7,3861",
    "difference": "-0,74%"
  },
  {
    "date": "12.01.2021",
    "now": "7,4482",
    "open": "7,4791",
    "highest": "7,5248",
    "lower": "7,4194",
    "difference": "-0,34%"
  },
  {
    "date": "11.01.2021",
    "now": "7,4733",
    "open": "7,3636",
    "highest": "7,5321",
    "lower": "7,3584",
    "difference": "1,38%"
  },
  {
    "date": "08.01.2021",
    "now": "7,3713",
    "open": "7,3198",
    "highest": "7,4194",
    "lower": "7,3045",
    "difference": "0,77%"
  },
  {
    "date": "07.01.2021",
    "now": "7,3149",
    "open": "7,3067",
    "highest": "7,3955",
    "lower": "7,2372",
    "difference": "0,14%"
  },
  {
    "date": "06.01.2021",
    "now": "7,3047",
    "open": "7,3893",
    "highest": "7,3973",
    "lower": "7,2663",
    "difference": "-1,10%"
  },
  {
    "date": "05.01.2021",
    "now": "7,3856",
    "open": "7,4263",
    "highest": "7,4382",
    "lower": "7,3591",
    "difference": "-0,46%"
  },
  {
    "date": "04.01.2021",
    "now": "7,4198",
    "open": "7,4403",
    "highest": "7,4470",
    "lower": "7,3393",
    "difference": "-0,26%"
  },
  {
    "date": "01.01.2021",
    "now": "7,4392",
    "open": "7,4392",
    "highest": "7,4392",
    "lower": "7,4392",
    "difference": "0,10%"
  },
  {
    "date": "31.12.2020",
    "now": "7,4320",
    "open": "7,3815",
    "highest": "7,4983",
    "lower": "7,3444",
    "difference": "0,74%"
  },
  {
    "date": "30.12.2020",
    "now": "7,3774",
    "open": "7,3865",
    "highest": "7,3993",
    "lower": "7,3030",
    "difference": "-0,06%"
  },
  {
    "date": "29.12.2020",
    "now": "7,3815",
    "open": "7,4466",
    "highest": "7,4804",
    "lower": "7,3376",
    "difference": "-0,81%"
  },
  {
    "date": "28.12.2020",
    "now": "7,4416",
    "open": "7,5716",
    "highest": "7,5756",
    "lower": "7,4035",
    "difference": "-1,40%"
  },
  {
    "date": "25.12.2020",
    "now": "7,5470",
    "open": "7,5801",
    "highest": "7,6016",
    "lower": "7,5305",
    "difference": "-0,37%"
  },
  {
    "date": "24.12.2020",
    "now": "7,5747",
    "open": "7,6398",
    "highest": "7,6757",
    "lower": "7,5460",
    "difference": "-0,80%"
  },
  {
    "date": "23.12.2020",
    "now": "7,6361",
    "open": "7,6632",
    "highest": "7,6711",
    "lower": "7,6140",
    "difference": "-0,27%"
  },
  {
    "date": "22.12.2020",
    "now": "7,6570",
    "open": "7,6506",
    "highest": "7,6786",
    "lower": "7,6129",
    "difference": "0,10%"
  },
  {
    "date": "21.12.2020",
    "now": "7,6491",
    "open": "7,6310",
    "highest": "7,7376",
    "lower": "7,6234",
    "difference": "0,33%"
  },
  {
    "date": "18.12.2020",
    "now": "7,6239",
    "open": "7,7009",
    "highest": "7,7607",
    "lower": "7,6122",
    "difference": "-0,94%"
  },
  {
    "date": "17.12.2020",
    "now": "7,6959",
    "open": "7,7999",
    "highest": "7,8097",
    "lower": "7,6896",
    "difference": "-1,27%"
  },
  {
    "date": "16.12.2020",
    "now": "7,7949",
    "open": "7,8440",
    "highest": "7,8492",
    "lower": "7,7573",
    "difference": "-0,45%"
  },
  {
    "date": "15.12.2020",
    "now": "7,8300",
    "open": "7,8534",
    "highest": "7,8734",
    "lower": "7,8113",
    "difference": "-0,23%"
  },
  {
    "date": "14.12.2020",
    "now": "7,8483",
    "open": "7,8601",
    "highest": "7,9392",
    "lower": "7,8234",
    "difference": "-0,10%"
  },
  {
    "date": "11.12.2020",
    "now": "7,8562",
    "open": "7,8841",
    "highest": "8,0347",
    "lower": "7,8149",
    "difference": "-0,38%"
  },
  {
    "date": "10.12.2020",
    "now": "7,8864",
    "open": "7,8263",
    "highest": "7,9256",
    "lower": "7,8163",
    "difference": "0,91%"
  },
  {
    "date": "09.12.2020",
    "now": "7,8156",
    "open": "7,8155",
    "highest": "7,8524",
    "lower": "7,7888",
    "difference": "0,13%"
  },
  {
    "date": "08.12.2020",
    "now": "7,8055",
    "open": "7,8007",
    "highest": "7,8529",
    "lower": "7,7865",
    "difference": "0,11%"
  },
  {
    "date": "07.12.2020",
    "now": "7,7973",
    "open": "7,8029",
    "highest": "7,8774",
    "lower": "7,7958",
    "difference": "-0,01%"
  },
  {
    "date": "04.12.2020",
    "now": "7,7981",
    "open": "7,7739",
    "highest": "7,8498",
    "lower": "7,7477",
    "difference": "0,41%"
  },
  {
    "date": "03.12.2020",
    "now": "7,7665",
    "open": "7,8524",
    "highest": "7,9250",
    "lower": "7,7497",
    "difference": "-1,07%"
  },
  {
    "date": "02.12.2020",
    "now": "7,8502",
    "open": "7,8290",
    "highest": "7,8836",
    "lower": "7,7717",
    "difference": "0,32%"
  },
  {
    "date": "01.12.2020",
    "now": "7,8248",
    "open": "7,8328",
    "highest": "7,9213",
    "lower": "7,7961",
    "difference": "-0,05%"
  },
  {
    "date": "30.11.2020",
    "now": "7,8284",
    "open": "7,8353",
    "highest": "7,8653",
    "lower": "7,7424",
    "difference": "-0,06%"
  },
  {
    "date": "27.11.2020",
    "now": "7,8332",
    "open": "7,8695",
    "highest": "7,8952",
    "lower": "7,7613",
    "difference": "-0,46%"
  },
  {
    "date": "26.11.2020",
    "now": "7,8691",
    "open": "7,9311",
    "highest": "7,9735",
    "lower": "7,8456",
    "difference": "-0,76%"
  },
  {
    "date": "25.11.2020",
    "now": "7,9297",
    "open": "8,0022",
    "highest": "8,0171",
    "lower": "7,9051",
    "difference": "-0,86%"
  },
  {
    "date": "24.11.2020",
    "now": "7,9982",
    "open": "7,8848",
    "highest": "8,0530",
    "lower": "7,8295",
    "difference": "1,49%"
  },
  {
    "date": "23.11.2020",
    "now": "7,8810",
    "open": "7,6400",
    "highest": "7,9569",
    "lower": "7,6349",
    "difference": "3,26%"
  },
  {
    "date": "20.11.2020",
    "now": "7,6323",
    "open": "7,5529",
    "highest": "7,7055",
    "lower": "7,5258",
    "difference": "1,08%"
  },
  {
    "date": "19.11.2020",
    "now": "7,5507",
    "open": "7,7060",
    "highest": "7,7431",
    "lower": "7,5035",
    "difference": "-1,99%"
  },
  {
    "date": "18.11.2020",
    "now": "7,7040",
    "open": "7,7002",
    "highest": "7,7914",
    "lower": "7,6700",
    "difference": "0,10%"
  },
  {
    "date": "17.11.2020",
    "now": "7,6962",
    "open": "7,7015",
    "highest": "7,8061",
    "lower": "7,6603",
    "difference": "-0,02%"
  },
  {
    "date": "16.11.2020",
    "now": "7,6976",
    "open": "7,6612",
    "highest": "7,7680",
    "lower": "7,5920",
    "difference": "0,49%"
  },
  {
    "date": "13.11.2020",
    "now": "7,6602",
    "open": "7,6899",
    "highest": "7,7583",
    "lower": "7,5936",
    "difference": "-0,35%"
  },
  {
    "date": "12.11.2020",
    "now": "7,6869",
    "open": "7,7996",
    "highest": "7,8997",
    "lower": "7,6547",
    "difference": "-1,41%"
  },
  {
    "date": "11.11.2020",
    "now": "7,7966",
    "open": "8,1452",
    "highest": "8,2041",
    "lower": "7,7832",
    "difference": "-4,27%"
  },
  {
    "date": "10.11.2020",
    "now": "8,1446",
    "open": "8,0660",
    "highest": "8,3819",
    "lower": "8,0510",
    "difference": "1,01%"
  },
  {
    "date": "09.11.2020",
    "now": "8,0634",
    "open": "8,4316",
    "highest": "8,4543",
    "lower": "7,9887",
    "difference": "-5,36%"
  },
  {
    "date": "06.11.2020",
    "now": "8,5200",
    "open": "8,4220",
    "highest": "8,5876",
    "lower": "8,3993",
    "difference": "1,19%"
  },
  {
    "date": "05.11.2020",
    "now": "8,4202",
    "open": "8,4262",
    "highest": "8,4859",
    "lower": "8,4023",
    "difference": "-0,06%"
  },
  {
    "date": "04.11.2020",
    "now": "8,4251",
    "open": "8,4041",
    "highest": "8,5320",
    "lower": "8,3827",
    "difference": "0,28%"
  },
  {
    "date": "03.11.2020",
    "now": "8,4016",
    "open": "8,4221",
    "highest": "8,5471",
    "lower": "8,3924",
    "difference": "-0,21%"
  },
  {
    "date": "02.11.2020",
    "now": "8,4190",
    "open": "8,3467",
    "highest": "8,4486",
    "lower": "8,3401",
    "difference": "0,89%"
  },
  {
    "date": "30.10.2020",
    "now": "8,3448",
    "open": "8,2922",
    "highest": "8,3899",
    "lower": "8,2674",
    "difference": "0,68%"
  },
  {
    "date": "29.10.2020",
    "now": "8,2881",
    "open": "8,2576",
    "highest": "8,3315",
    "lower": "8,2568",
    "difference": "0,39%"
  },
  {
    "date": "28.10.2020",
    "now": "8,2559",
    "open": "8,1853",
    "highest": "8,3244",
    "lower": "8,1827",
    "difference": "0,86%"
  },
  {
    "date": "27.10.2020",
    "now": "8,1854",
    "open": "8,0837",
    "highest": "8,1989",
    "lower": "8,0815",
    "difference": "1,31%"
  },
  {
    "date": "26.10.2020",
    "now": "8,0797",
    "open": "7,9645",
    "highest": "8,0995",
    "lower": "7,9585",
    "difference": "1,49%"
  },
  {
    "date": "23.10.2020",
    "now": "7,9610",
    "open": "7,9351",
    "highest": "7,9833",
    "lower": "7,9145",
    "difference": "0,35%"
  },
  {
    "date": "22.10.2020",
    "now": "7,9329",
    "open": "7,8125",
    "highest": "7,9880",
    "lower": "7,7792",
    "difference": "1,60%"
  },
  {
    "date": "21.10.2020",
    "now": "7,8081",
    "open": "7,8663",
    "highest": "7,8847",
    "lower": "7,7880",
    "difference": "-0,67%"
  },
  {
    "date": "20.10.2020",
    "now": "7,8609",
    "open": "7,8837",
    "highest": "7,9109",
    "lower": "7,8542",
    "difference": "-0,24%"
  },
  {
    "date": "19.10.2020",
    "now": "7,8797",
    "open": "7,9353",
    "highest": "7,9416",
    "lower": "7,8691",
    "difference": "-0,64%"
  },
  {
    "date": "16.10.2020",
    "now": "7,9304",
    "open": "7,9356",
    "highest": "7,9599",
    "lower": "7,8856",
    "difference": "-0,01%"
  },
  {
    "date": "15.10.2020",
    "now": "7,9310",
    "open": "7,9118",
    "highest": "7,9538",
    "lower": "7,9059",
    "difference": "0,29%"
  },
  {
    "date": "14.10.2020",
    "now": "7,9084",
    "open": "7,9167",
    "highest": "7,9612",
    "lower": "7,8970",
    "difference": "-0,08%"
  },
  {
    "date": "13.10.2020",
    "now": "7,9146",
    "open": "7,8900",
    "highest": "7,9324",
    "lower": "7,8738",
    "difference": "0,34%"
  },
  {
    "date": "12.10.2020",
    "now": "7,8879",
    "open": "7,8602",
    "highest": "7,9157",
    "lower": "7,8510",
    "difference": "0,40%"
  },
  {
    "date": "09.10.2020",
    "now": "7,8566",
    "open": "7,9447",
    "highest": "7,9591",
    "lower": "7,8372",
    "difference": "-1,06%"
  },
  {
    "date": "08.10.2020",
    "now": "7,9406",
    "open": "7,8847",
    "highest": "7,9485",
    "lower": "7,8741",
    "difference": "0,76%"
  },
  {
    "date": "07.10.2020",
    "now": "7,8808",
    "open": "7,7993",
    "highest": "7,8967",
    "lower": "7,7821",
    "difference": "1,13%"
  },
  {
    "date": "06.10.2020",
    "now": "7,7931",
    "open": "7,7639",
    "highest": "7,8084",
    "lower": "7,7411",
    "difference": "0,43%"
  },
  {
    "date": "05.10.2020",
    "now": "7,7599",
    "open": "7,7714",
    "highest": "7,7906",
    "lower": "7,7206",
    "difference": "-0,14%"
  },
  {
    "date": "02.10.2020",
    "now": "7,7708",
    "open": "7,7498",
    "highest": "7,7931",
    "lower": "7,7066",
    "difference": "0,27%"
  },
  {
    "date": "01.10.2020",
    "now": "7,7500",
    "open": "7,7187",
    "highest": "7,7880",
    "lower": "7,6219",
    "difference": "0,44%"
  },
  {
    "date": "30.09.2020",
    "now": "7,7157",
    "open": "7,8189",
    "highest": "7,8400",
    "lower": "7,6969",
    "difference": "-1,26%"
  },
  {
    "date": "29.09.2020",
    "now": "7,8139",
    "open": "7,8044",
    "highest": "7,8669",
    "lower": "7,7590",
    "difference": "0,15%"
  },
  {
    "date": "28.09.2020",
    "now": "7,8024",
    "open": "7,6648",
    "highest": "7,8409",
    "lower": "7,6531",
    "difference": "1,85%"
  },
  {
    "date": "25.09.2020",
    "now": "7,6607",
    "open": "7,6228",
    "highest": "7,6865",
    "lower": "7,4915",
    "difference": "0,51%"
  },
  {
    "date": "24.09.2020",
    "now": "7,6216",
    "open": "7,7005",
    "highest": "7,7228",
    "lower": "7,5380",
    "difference": "-0,98%"
  },
  {
    "date": "23.09.2020",
    "now": "7,6967",
    "open": "7,6658",
    "highest": "7,7137",
    "lower": "7,6424",
    "difference": "0,45%"
  },
  {
    "date": "22.09.2020",
    "now": "7,6619",
    "open": "7,6318",
    "highest": "7,6751",
    "lower": "7,6118",
    "difference": "0,42%"
  },
  {
    "date": "21.09.2020",
    "now": "7,6299",
    "open": "7,5608",
    "highest": "7,6439",
    "lower": "7,5387",
    "difference": "0,97%"
  },
  {
    "date": "18.09.2020",
    "now": "7,5563",
    "open": "7,5503",
    "highest": "7,5932",
    "lower": "7,5240",
    "difference": "0,13%"
  },
  {
    "date": "17.09.2020",
    "now": "7,5464",
    "open": "7,5052",
    "highest": "7,5663",
    "lower": "7,4825",
    "difference": "0,55%"
  },
  {
    "date": "16.09.2020",
    "now": "7,5054",
    "open": "7,4892",
    "highest": "7,5182",
    "lower": "7,4640",
    "difference": "0,27%"
  },
  {
    "date": "15.09.2020",
    "now": "7,4854",
    "open": "7,4879",
    "highest": "7,5022",
    "lower": "7,4548",
    "difference": "0,02%"
  },
  {
    "date": "14.09.2020",
    "now": "7,4840",
    "open": "7,4720",
    "highest": "7,5038",
    "lower": "7,4590",
    "difference": "0,16%"
  },
  {
    "date": "11.09.2020",
    "now": "7,4724",
    "open": "7,4502",
    "highest": "7,4828",
    "lower": "7,4314",
    "difference": "0,33%"
  },
  {
    "date": "10.09.2020",
    "now": "7,4481",
    "open": "7,4889",
    "highest": "7,5015",
    "lower": "7,3977",
    "difference": "-0,49%"
  },
  {
    "date": "09.09.2020",
    "now": "7,4848",
    "open": "7,4850",
    "highest": "7,5001",
    "lower": "7,4565",
    "difference": "0,04%"
  },
  {
    "date": "08.09.2020",
    "now": "7,4817",
    "open": "7,4577",
    "highest": "7,4921",
    "lower": "7,4390",
    "difference": "0,37%"
  },
  {
    "date": "07.09.2020",
    "now": "7,4542",
    "open": "7,4360",
    "highest": "7,4696",
    "lower": "7,4203",
    "difference": "0,28%"
  },
  {
    "date": "04.09.2020",
    "now": "7,4331",
    "open": "7,4352",
    "highest": "7,4651",
    "lower": "7,3980",
    "difference": "-0,01%"
  },
  {
    "date": "03.09.2020",
    "now": "7,4335",
    "open": "7,3860",
    "highest": "7,4549",
    "lower": "7,3661",
    "difference": "0,69%"
  },
  {
    "date": "02.09.2020",
    "now": "7,3822",
    "open": "7,3694",
    "highest": "7,4036",
    "lower": "7,3475",
    "difference": "0,23%"
  },
  {
    "date": "01.09.2020",
    "now": "7,3652",
    "open": "7,3513",
    "highest": "7,3789",
    "lower": "7,3158",
    "difference": "0,25%"
  },
  {
    "date": "31.08.2020",
    "now": "7,3466",
    "open": "7,3314",
    "highest": "7,3731",
    "lower": "7,3110",
    "difference": "0,19%"
  },
  {
    "date": "28.08.2020",
    "now": "7,3329",
    "open": "7,3604",
    "highest": "7,3797",
    "lower": "7,2727",
    "difference": "-0,35%"
  },
  {
    "date": "27.08.2020",
    "now": "7,3587",
    "open": "7,3703",
    "highest": "7,3915",
    "lower": "7,2857",
    "difference": "-0,10%"
  },
  {
    "date": "26.08.2020",
    "now": "7,3662",
    "open": "7,3932",
    "highest": "7,4212",
    "lower": "7,3133",
    "difference": "-0,31%"
  },
  {
    "date": "25.08.2020",
    "now": "7,3893",
    "open": "7,3783",
    "highest": "7,4085",
    "lower": "7,3533",
    "difference": "0,17%"
  },
  {
    "date": "24.08.2020",
    "now": "7,3768",
    "open": "7,3332",
    "highest": "7,3860",
    "lower": "7,3035",
    "difference": "0,55%"
  },
  {
    "date": "21.08.2020",
    "now": "7,3365",
    "open": "7,2986",
    "highest": "7,3527",
    "lower": "7,1840",
    "difference": "0,59%"
  },
  {
    "date": "20.08.2020",
    "now": "7,2938",
    "open": "7,2923",
    "highest": "7,3588",
    "lower": "7,2640",
    "difference": "0,05%"
  },
  {
    "date": "19.08.2020",
    "now": "7,2905",
    "open": "7,3736",
    "highest": "7,3881",
    "lower": "7,1933",
    "difference": "-1,07%"
  },
  {
    "date": "18.08.2020",
    "now": "7,3696",
    "open": "7,3839",
    "highest": "7,4036",
    "lower": "7,3355",
    "difference": "-0,12%"
  },
  {
    "date": "17.08.2020",
    "now": "7,3787",
    "open": "7,3750",
    "highest": "7,4014",
    "lower": "7,3559",
    "difference": "0,17%"
  },
  {
    "date": "14.08.2020",
    "now": "7,3664",
    "open": "7,3383",
    "highest": "7,3885",
    "lower": "7,3291",
    "difference": "0,42%"
  },
  {
    "date": "13.08.2020",
    "now": "7,3354",
    "open": "7,3328",
    "highest": "7,3665",
    "lower": "7,2655",
    "difference": "0,10%"
  },
  {
    "date": "12.08.2020",
    "now": "7,3282",
    "open": "7,2182",
    "highest": "7,3484",
    "lower": "7,1842",
    "difference": "1,75%"
  },
  {
    "date": "11.08.2020",
    "now": "7,2025",
    "open": "7,3351",
    "highest": "7,3565",
    "lower": "7,1753",
    "difference": "-1,78%"
  },
  {
    "date": "10.08.2020",
    "now": "7,3329",
    "open": "7,2898",
    "highest": "7,3689",
    "lower": "7,2337",
    "difference": "0,57%"
  },
  {
    "date": "07.08.2020",
    "now": "7,2911",
    "open": "7,2396",
    "highest": "7,3755",
    "lower": "7,1085",
    "difference": "0,76%"
  },
  {
    "date": "06.08.2020",
    "now": "7,2362",
    "open": "7,0475",
    "highest": "7,3215",
    "lower": "7,0200",
    "difference": "2,73%"
  },
  {
    "date": "05.08.2020",
    "now": "7,0438",
    "open": "6,9015",
    "highest": "7,0895",
    "lower": "6,8945",
    "difference": "2,13%"
  },
  {
    "date": "04.08.2020",
    "now": "6,8968",
    "open": "6,9576",
    "highest": "7,0342",
    "lower": "6,8868",
    "difference": "-0,85%"
  },
  {
    "date": "03.08.2020",
    "now": "6,9558",
    "open": "6,9745",
    "highest": "6,9943",
    "lower": "6,9472",
    "difference": "-0,21%"
  },
  {
    "date": "31.07.2020",
    "now": "6,9702",
    "open": "6,9974",
    "highest": "7,0153",
    "lower": "6,9570",
    "difference": "-0,31%"
  },
  {
    "date": "30.07.2020",
    "now": "6,9917",
    "open": "6,9832",
    "highest": "7,0151",
    "lower": "6,9402",
    "difference": "0,13%"
  },
  {
    "date": "29.07.2020",
    "now": "6,9828",
    "open": "6,9363",
    "highest": "7,0076",
    "lower": "6,9215",
    "difference": "0,71%"
  },
  {
    "date": "28.07.2020",
    "now": "6,9335",
    "open": "6,8625",
    "highest": "6,9785",
    "lower": "6,8542",
    "difference": "1,08%"
  },
  {
    "date": "27.07.2020",
    "now": "6,8595",
    "open": "6,8468",
    "highest": "6,9655",
    "lower": "6,8355",
    "difference": "0,22%"
  },
  {
    "date": "24.07.2020",
    "now": "6,8446",
    "open": "6,8433",
    "highest": "6,8547",
    "lower": "6,8310",
    "difference": "0,08%"
  },
  {
    "date": "23.07.2020",
    "now": "6,8389",
    "open": "6,8510",
    "highest": "6,8548",
    "lower": "6,8250",
    "difference": "-0,13%"
  },
  {
    "date": "22.07.2020",
    "now": "6,8480",
    "open": "6,8247",
    "highest": "6,8569",
    "lower": "6,8185",
    "difference": "0,39%"
  },
  {
    "date": "21.07.2020",
    "now": "6,8214",
    "open": "6,8577",
    "highest": "6,8671",
    "lower": "6,8165",
    "difference": "-0,50%"
  },
  {
    "date": "20.07.2020",
    "now": "6,8558",
    "open": "6,8586",
    "highest": "6,8688",
    "lower": "6,8445",
    "difference": "0,01%"
  },
  {
    "date": "17.07.2020",
    "now": "6,8553",
    "open": "6,8573",
    "highest": "6,8776",
    "lower": "6,8436",
    "difference": "0,02%"
  },
  {
    "date": "16.07.2020",
    "now": "6,8538",
    "open": "6,8558",
    "highest": "6,8660",
    "lower": "6,8460",
    "difference": "0,01%"
  },
  {
    "date": "15.07.2020",
    "now": "6,8529",
    "open": "6,8639",
    "highest": "6,8705",
    "lower": "6,8510",
    "difference": "-0,14%"
  },
  {
    "date": "14.07.2020",
    "now": "6,8626",
    "open": "6,8602",
    "highest": "6,8721",
    "lower": "6,8523",
    "difference": "0,09%"
  },
  {
    "date": "13.07.2020",
    "now": "6,8562",
    "open": "6,8677",
    "highest": "6,8760",
    "lower": "6,8422",
    "difference": "-0,08%"
  },
  {
    "date": "10.07.2020",
    "now": "6,8618",
    "open": "6,8618",
    "highest": "6,8724",
    "lower": "6,8504",
    "difference": "0,05%"
  },
  {
    "date": "09.07.2020",
    "now": "6,8587",
    "open": "6,8605",
    "highest": "6,8693",
    "lower": "6,8478",
    "difference": "0,03%"
  },
  {
    "date": "08.07.2020",
    "now": "6,8565",
    "open": "6,8595",
    "highest": "6,8689",
    "lower": "6,8457",
    "difference": "0,01%"
  },
  {
    "date": "07.07.2020",
    "now": "6,8555",
    "open": "6,8605",
    "highest": "6,8706",
    "lower": "6,8453",
    "difference": "-0,04%"
  },
  {
    "date": "06.07.2020",
    "now": "6,8580",
    "open": "6,8618",
    "highest": "6,8743",
    "lower": "6,8359",
    "difference": "-0,02%"
  },
  {
    "date": "03.07.2020",
    "now": "6,8596",
    "open": "6,8509",
    "highest": "6,8773",
    "lower": "6,8404",
    "difference": "0,18%"
  },
  {
    "date": "02.07.2020",
    "now": "6,8475",
    "open": "6,8480",
    "highest": "6,8591",
    "lower": "6,8365",
    "difference": "0,05%"
  },
  {
    "date": "01.07.2020",
    "now": "6,8439",
    "open": "6,8534",
    "highest": "6,8598",
    "lower": "6,8385",
    "difference": "-0,09%"
  },
  {
    "date": "30.06.2020",
    "now": "6,8500",
    "open": "6,8549",
    "highest": "6,8590",
    "lower": "6,8386",
    "difference": "-0,04%"
  },
  {
    "date": "29.06.2020",
    "now": "6,8524",
    "open": "6,8539",
    "highest": "6,8592",
    "lower": "6,8415",
    "difference": "0,03%"
  },
  {
    "date": "26.06.2020",
    "now": "6,8506",
    "open": "6,8548",
    "highest": "6,8631",
    "lower": "6,8403",
    "difference": "-0,03%"
  },
  {
    "date": "25.06.2020",
    "now": "6,8526",
    "open": "6,8563",
    "highest": "6,8620",
    "lower": "6,8265",
    "difference": "-0,01%"
  },
  {
    "date": "24.06.2020",
    "now": "6,8533",
    "open": "6,8515",
    "highest": "6,8623",
    "lower": "6,8362",
    "difference": "0,09%"
  },
  {
    "date": "23.06.2020",
    "now": "6,8472",
    "open": "6,8491",
    "highest": "6,8627",
    "lower": "6,8335",
    "difference": "0,01%"
  },
  {
    "date": "22.06.2020",
    "now": "6,8463",
    "open": "6,8478",
    "highest": "6,8611",
    "lower": "6,8313",
    "difference": "-0,05%"
  },
  {
    "date": "19.06.2020",
    "now": "6,8498",
    "open": "6,8563",
    "highest": "6,8628",
    "lower": "6,8260",
    "difference": "-0,07%"
  },
  {
    "date": "18.06.2020",
    "now": "6,8545",
    "open": "6,8448",
    "highest": "6,8641",
    "lower": "6,8292",
    "difference": "0,19%"
  },
  {
    "date": "17.06.2020",
    "now": "6,8418",
    "open": "6,8442",
    "highest": "6,8618",
    "lower": "6,8253",
    "difference": "0,02%"
  },
  {
    "date": "16.06.2020",
    "now": "6,8403",
    "open": "6,8362",
    "highest": "6,8540",
    "lower": "6,8127",
    "difference": "0,10%"
  },
  {
    "date": "15.06.2020",
    "now": "6,8333",
    "open": "6,8136",
    "highest": "6,8637",
    "lower": "6,8054",
    "difference": "0,33%"
  },
  {
    "date": "12.06.2020",
    "now": "6,8106",
    "open": "6,8415",
    "highest": "6,8467",
    "lower": "6,7930",
    "difference": "-0,42%"
  },
  {
    "date": "11.06.2020",
    "now": "6,8394",
    "open": "6,7768",
    "highest": "6,8572",
    "lower": "6,7667",
    "difference": "0,98%"
  },
  {
    "date": "10.06.2020",
    "now": "6,7728",
    "open": "6,7965",
    "highest": "6,8029",
    "lower": "6,7610",
    "difference": "-0,30%"
  },
  {
    "date": "09.06.2020",
    "now": "6,7933",
    "open": "6,7888",
    "highest": "6,8096",
    "lower": "6,7678",
    "difference": "0,17%"
  },
  {
    "date": "08.06.2020",
    "now": "6,7816",
    "open": "6,7673",
    "highest": "6,7969",
    "lower": "6,7570",
    "difference": "0,20%"
  },
  {
    "date": "05.06.2020",
    "now": "6,7680",
    "open": "6,7557",
    "highest": "6,7962",
    "lower": "6,7325",
    "difference": "0,24%"
  },
  {
    "date": "04.06.2020",
    "now": "6,7518",
    "open": "6,7439",
    "highest": "6,7723",
    "lower": "6,7165",
    "difference": "0,15%"
  },
  {
    "date": "03.06.2020",
    "now": "6,7420",
    "open": "6,7048",
    "highest": "6,7705",
    "lower": "6,6835",
    "difference": "0,44%"
  },
  {
    "date": "02.06.2020",
    "now": "6,7125",
    "open": "6,8143",
    "highest": "6,8232",
    "lower": "6,6870",
    "difference": "-1,43%"
  },
  {
    "date": "01.06.2020",
    "now": "6,8102",
    "open": "6,8221",
    "highest": "6,8293",
    "lower": "6,7905",
    "difference": "-0,12%"
  },
  {
    "date": "29.05.2020",
    "now": "6,8182",
    "open": "6,8157",
    "highest": "6,8437",
    "lower": "6,7975",
    "difference": "0,12%"
  },
  {
    "date": "28.05.2020",
    "now": "6,8098",
    "open": "6,7733",
    "highest": "6,8245",
    "lower": "6,7673",
    "difference": "0,59%"
  },
  {
    "date": "27.05.2020",
    "now": "6,7699",
    "open": "6,7280",
    "highest": "6,7862",
    "lower": "6,7190",
    "difference": "0,68%"
  },
  {
    "date": "26.05.2020",
    "now": "6,7245",
    "open": "6,8101",
    "highest": "6,8215",
    "lower": "6,6957",
    "difference": "-1,23%"
  },
  {
    "date": "25.05.2020",
    "now": "6,8080",
    "open": "6,8146",
    "highest": "6,8213",
    "lower": "6,7983",
    "difference": "-0,04%"
  },
  {
    "date": "22.05.2020",
    "now": "6,8107",
    "open": "6,7923",
    "highest": "6,8316",
    "lower": "6,7818",
    "difference": "0,44%"
  },
  {
    "date": "21.05.2020",
    "now": "6,7809",
    "open": "6,7907",
    "highest": "6,8188",
    "lower": "6,7778",
    "difference": "-0,09%"
  },
  {
    "date": "20.05.2020",
    "now": "6,7872",
    "open": "6,7775",
    "highest": "6,8018",
    "lower": "6,7639",
    "difference": "0,20%"
  },
  {
    "date": "19.05.2020",
    "now": "6,7735",
    "open": "6,8850",
    "highest": "6,8878",
    "lower": "6,7536",
    "difference": "-1,59%"
  },
  {
    "date": "18.05.2020",
    "now": "6,8831",
    "open": "6,8991",
    "highest": "6,9036",
    "lower": "6,8235",
    "difference": "-0,23%"
  },
  {
    "date": "15.05.2020",
    "now": "6,8992",
    "open": "6,9221",
    "highest": "6,9323",
    "lower": "6,8928",
    "difference": "-0,27%"
  },
  {
    "date": "14.05.2020",
    "now": "6,9180",
    "open": "6,9745",
    "highest": "6,9868",
    "lower": "6,8988",
    "difference": "-0,76%"
  },
  {
    "date": "13.05.2020",
    "now": "6,9708",
    "open": "6,9971",
    "highest": "7,0004",
    "lower": "6,9647",
    "difference": "-0,37%"
  },
  {
    "date": "12.05.2020",
    "now": "6,9966",
    "open": "7,0713",
    "highest": "7,0784",
    "lower": "6,9699",
    "difference": "-1,10%"
  },
  {
    "date": "11.05.2020",
    "now": "7,0742",
    "open": "7,0844",
    "highest": "7,1118",
    "lower": "7,0530",
    "difference": "-0,11%"
  },
  {
    "date": "08.05.2020",
    "now": "7,0820",
    "open": "7,1195",
    "highest": "7,1802",
    "lower": "7,0575",
    "difference": "-0,48%"
  },
  {
    "date": "07.05.2020",
    "now": "7,1165",
    "open": "7,1954",
    "highest": "7,2712",
    "lower": "7,0623",
    "difference": "-1,11%"
  },
  {
    "date": "06.05.2020",
    "now": "7,1961",
    "open": "7,0745",
    "highest": "7,2115",
    "lower": "7,0624",
    "difference": "1,75%"
  },
  {
    "date": "05.05.2020",
    "now": "7,0726",
    "open": "7,0442",
    "highest": "7,1038",
    "lower": "7,0205",
    "difference": "0,43%"
  },
  {
    "date": "04.05.2020",
    "now": "7,0420",
    "open": "7,0158",
    "highest": "7,0553",
    "lower": "6,9965",
    "difference": "0,49%"
  },
  {
    "date": "01.05.2020",
    "now": "7,0080",
    "open": "6,9866",
    "highest": "7,0441",
    "lower": "6,9785",
    "difference": "0,36%"
  },
  {
    "date": "30.04.2020",
    "now": "6,9829",
    "open": "6,9521",
    "highest": "6,9963",
    "lower": "6,9433",
    "difference": "0,50%"
  },
  {
    "date": "29.04.2020",
    "now": "6,9480",
    "open": "6,9868",
    "highest": "6,9960",
    "lower": "6,9433",
    "difference": "-0,52%"
  },
  {
    "date": "28.04.2020",
    "now": "6,9840",
    "open": "6,9862",
    "highest": "7,0051",
    "lower": "6,9788",
    "difference": "0,02%"
  },
  {
    "date": "27.04.2020",
    "now": "6,9826",
    "open": "6,9707",
    "highest": "6,9973",
    "lower": "6,9450",
    "difference": "0,15%"
  },
  {
    "date": "24.04.2020",
    "now": "6,9722",
    "open": "6,9395",
    "highest": "6,9970",
    "lower": "6,9395",
    "difference": "0,43%"
  },
  {
    "date": "23.04.2020",
    "now": "6,9422",
    "open": "6,9797",
    "highest": "7,0005",
    "lower": "6,9226",
    "difference": "-0,50%"
  },
  {
    "date": "22.04.2020",
    "now": "6,9772",
    "open": "6,9812",
    "highest": "7,0097",
    "lower": "6,9516",
    "difference": "-0,04%"
  },
  {
    "date": "21.04.2020",
    "now": "6,9797",
    "open": "6,9394",
    "highest": "7,0008",
    "lower": "6,9346",
    "difference": "0,63%"
  },
  {
    "date": "20.04.2020",
    "now": "6,9362",
    "open": "6,9314",
    "highest": "6,9575",
    "lower": "6,8714",
    "difference": "0,09%"
  },
  {
    "date": "17.04.2020",
    "now": "6,9300",
    "open": "6,9397",
    "highest": "6,9584",
    "lower": "6,8253",
    "difference": "-0,11%"
  },
  {
    "date": "16.04.2020",
    "now": "6,9377",
    "open": "6,9118",
    "highest": "6,9605",
    "lower": "6,8860",
    "difference": "0,43%"
  },
  {
    "date": "15.04.2020",
    "now": "6,9078",
    "open": "6,8153",
    "highest": "6,9283",
    "lower": "6,8127",
    "difference": "1,36%"
  },
  {
    "date": "14.04.2020",
    "now": "6,8148",
    "open": "6,7723",
    "highest": "6,8256",
    "lower": "6,7603",
    "difference": "0,69%"
  },
  {
    "date": "13.04.2020",
    "now": "6,7681",
    "open": "6,7033",
    "highest": "6,8018",
    "lower": "6,7009",
    "difference": "1,08%"
  },
  {
    "date": "10.04.2020",
    "now": "6,6961",
    "open": "6,6746",
    "highest": "6,7298",
    "lower": "6,6590",
    "difference": "0,35%"
  },
  {
    "date": "09.04.2020",
    "now": "6,6726",
    "open": "6,7737",
    "highest": "6,7979",
    "lower": "6,6164",
    "difference": "-1,43%"
  },
  {
    "date": "08.04.2020",
    "now": "6,7697",
    "open": "6,7550",
    "highest": "6,7968",
    "lower": "6,7512",
    "difference": "0,26%"
  },
  {
    "date": "07.04.2020",
    "now": "6,7520",
    "open": "6,7801",
    "highest": "6,7895",
    "lower": "6,6927",
    "difference": "-0,39%"
  },
  {
    "date": "06.04.2020",
    "now": "6,7785",
    "open": "6,7291",
    "highest": "6,7951",
    "lower": "6,7075",
    "difference": "0,74%"
  },
  {
    "date": "03.04.2020",
    "now": "6,7290",
    "open": "6,6137",
    "highest": "6,7517",
    "lower": "6,6083",
    "difference": "1,73%"
  },
  {
    "date": "02.04.2020",
    "now": "6,6146",
    "open": "6,7024",
    "highest": "6,7205",
    "lower": "6,5891",
    "difference": "-1,25%"
  },
  {
    "date": "01.04.2020",
    "now": "6,6986",
    "open": "6,6149",
    "highest": "6,7140",
    "lower": "6,6087",
    "difference": "1,33%"
  },
  {
    "date": "31.03.2020",
    "now": "6,6110",
    "open": "6,5764",
    "highest": "6,6272",
    "lower": "6,5490",
    "difference": "0,57%"
  },
  {
    "date": "30.03.2020",
    "now": "6,5733",
    "open": "6,4549",
    "highest": "6,5974",
    "lower": "6,4433",
    "difference": "1,86%"
  },
  {
    "date": "27.03.2020",
    "now": "6,4530",
    "open": "6,3982",
    "highest": "6,4764",
    "lower": "6,3885",
    "difference": "0,92%"
  },
  {
    "date": "26.03.2020",
    "now": "6,3939",
    "open": "6,4169",
    "highest": "6,5117",
    "lower": "6,3793",
    "difference": "-0,29%"
  },
  {
    "date": "25.03.2020",
    "now": "6,4125",
    "open": "6,4205",
    "highest": "6,4773",
    "lower": "6,3773",
    "difference": "-0,09%"
  },
  {
    "date": "24.03.2020",
    "now": "6,4183",
    "open": "6,5605",
    "highest": "6,5740",
    "lower": "6,3917",
    "difference": "-2,13%"
  },
  {
    "date": "23.03.2020",
    "now": "6,5580",
    "open": "6,5528",
    "highest": "6,6185",
    "lower": "6,5403",
    "difference": "0,11%"
  },
  {
    "date": "20.03.2020",
    "now": "6,5505",
    "open": "6,5438",
    "highest": "6,5665",
    "lower": "6,4548",
    "difference": "0,17%"
  },
  {
    "date": "19.03.2020",
    "now": "6,5391",
    "open": "6,4840",
    "highest": "6,5582",
    "lower": "6,4653",
    "difference": "0,87%"
  },
  {
    "date": "18.03.2020",
    "now": "6,4828",
    "open": "6,3940",
    "highest": "6,5040",
    "lower": "6,3872",
    "difference": "1,40%"
  },
  {
    "date": "17.03.2020",
    "now": "6,3936",
    "open": "6,4315",
    "highest": "6,4988",
    "lower": "6,3762",
    "difference": "-0,53%"
  },
  {
    "date": "16.03.2020",
    "now": "6,4275",
    "open": "6,3320",
    "highest": "6,4441",
    "lower": "6,2775",
    "difference": "1,54%"
  },
  {
    "date": "13.03.2020",
    "now": "6,3301",
    "open": "6,3158",
    "highest": "6,3400",
    "lower": "6,2435",
    "difference": "0,27%"
  },
  {
    "date": "12.03.2020",
    "now": "6,3132",
    "open": "6,2098",
    "highest": "6,3211",
    "lower": "6,2035",
    "difference": "1,73%"
  },
  {
    "date": "11.03.2020",
    "now": "6,2056",
    "open": "6,1564",
    "highest": "6,2129",
    "lower": "6,1252",
    "difference": "0,91%"
  },
  {
    "date": "10.03.2020",
    "now": "6,1499",
    "open": "6,1429",
    "highest": "6,1684",
    "lower": "6,0978",
    "difference": "0,13%"
  },
  {
    "date": "09.03.2020",
    "now": "6,1422",
    "open": "6,0903",
    "highest": "6,1967",
    "lower": "6,0860",
    "difference": "0,86%"
  },
  {
    "date": "06.03.2020",
    "now": "6,0899",
    "open": "6,1104",
    "highest": "6,1311",
    "lower": "6,0677",
    "difference": "-0,29%"
  },
  {
    "date": "05.03.2020",
    "now": "6,1077",
    "open": "6,0784",
    "highest": "6,1354",
    "lower": "6,0565",
    "difference": "0,54%"
  },
  {
    "date": "04.03.2020",
    "now": "6,0746",
    "open": "6,1070",
    "highest": "6,1487",
    "lower": "6,0567",
    "difference": "-0,47%"
  },
  {
    "date": "03.03.2020",
    "now": "6,1031",
    "open": "6,1790",
    "highest": "6,2239",
    "lower": "6,0303",
    "difference": "-1,11%"
  },
  {
    "date": "02.03.2020",
    "now": "6,1713",
    "open": "6,2432",
    "highest": "6,2610",
    "lower": "6,1575",
    "difference": "-1,08%"
  },
  {
    "date": "28.02.2020",
    "now": "6,2387",
    "open": "6,2075",
    "highest": "6,2579",
    "lower": "6,1958",
    "difference": "0,53%"
  },
  {
    "date": "27.02.2020",
    "now": "6,2056",
    "open": "6,1588",
    "highest": "6,2111",
    "lower": "6,1480",
    "difference": "0,82%"
  },
  {
    "date": "26.02.2020",
    "now": "6,1550",
    "open": "6,1441",
    "highest": "6,1662",
    "lower": "6,1365",
    "difference": "0,24%"
  },
  {
    "date": "25.02.2020",
    "now": "6,1401",
    "open": "6,1173",
    "highest": "6,1586",
    "lower": "6,0662",
    "difference": "0,40%"
  },
  {
    "date": "24.02.2020",
    "now": "6,1154",
    "open": "6,0979",
    "highest": "6,1616",
    "lower": "6,0929",
    "difference": "0,38%"
  },
  {
    "date": "21.02.2020",
    "now": "6,0924",
    "open": "6,1002",
    "highest": "6,1269",
    "lower": "6,0844",
    "difference": "-0,07%"
  },
  {
    "date": "20.02.2020",
    "now": "6,0964",
    "open": "6,0833",
    "highest": "6,1089",
    "lower": "6,0767",
    "difference": "0,28%"
  },
  {
    "date": "19.02.2020",
    "now": "6,0795",
    "open": "6,0642",
    "highest": "6,0875",
    "lower": "6,0469",
    "difference": "0,32%"
  },
  {
    "date": "18.02.2020",
    "now": "6,0602",
    "open": "6,0448",
    "highest": "6,0757",
    "lower": "6,0399",
    "difference": "0,31%"
  },
  {
    "date": "17.02.2020",
    "now": "6,0417",
    "open": "6,0531",
    "highest": "6,0623",
    "lower": "6,0340",
    "difference": "-0,12%"
  },
  {
    "date": "14.02.2020",
    "now": "6,0490",
    "open": "6,0406",
    "highest": "6,0698",
    "lower": "6,0333",
    "difference": "0,21%"
  },
  {
    "date": "13.02.2020",
    "now": "6,0362",
    "open": "6,0447",
    "highest": "6,0686",
    "lower": "6,0340",
    "difference": "-0,05%"
  },
  {
    "date": "12.02.2020",
    "now": "6,0390",
    "open": "6,0130",
    "highest": "6,0662",
    "lower": "5,9980",
    "difference": "0,39%"
  },
  {
    "date": "11.02.2020",
    "now": "6,0153",
    "open": "6,0108",
    "highest": "6,0531",
    "lower": "6,0012",
    "difference": "0,11%"
  },
  {
    "date": "10.02.2020",
    "now": "6,0088",
    "open": "6,0154",
    "highest": "6,0258",
    "lower": "5,9736",
    "difference": "-0,09%"
  },
  {
    "date": "07.02.2020",
    "now": "6,0143",
    "open": "5,9876",
    "highest": "6,0500",
    "lower": "5,9760",
    "difference": "0,48%"
  },
  {
    "date": "06.02.2020",
    "now": "5,9858",
    "open": "5,9826",
    "highest": "5,9911",
    "lower": "5,9742",
    "difference": "0,12%"
  },
  {
    "date": "05.02.2020",
    "now": "5,9789",
    "open": "5,9792",
    "highest": "5,9907",
    "lower": "5,9695",
    "difference": "0,02%"
  },
  {
    "date": "04.02.2020",
    "now": "5,9776",
    "open": "5,9846",
    "highest": "5,9882",
    "lower": "5,9585",
    "difference": "-0,08%"
  },
  {
    "date": "03.02.2020",
    "now": "5,9825",
    "open": "5,9819",
    "highest": "5,9889",
    "lower": "5,9746",
    "difference": "0,02%"
  },
  {
    "date": "31.01.2020",
    "now": "5,9812",
    "open": "5,9755",
    "highest": "5,9883",
    "lower": "5,9671",
    "difference": "0,26%"
  },
  {
    "date": "30.01.2020",
    "now": "5,9657",
    "open": "5,9569",
    "highest": "5,9883",
    "lower": "5,9525",
    "difference": "0,20%"
  },
  {
    "date": "29.01.2020",
    "now": "5,9535",
    "open": "5,9397",
    "highest": "5,9735",
    "lower": "5,9335",
    "difference": "0,26%"
  },
  {
    "date": "28.01.2020",
    "now": "5,9383",
    "open": "5,9435",
    "highest": "5,9535",
    "lower": "5,9278",
    "difference": "-0,08%"
  },
  {
    "date": "27.01.2020",
    "now": "5,9430",
    "open": "5,9392",
    "highest": "5,9579",
    "lower": "5,9317",
    "difference": "0,08%"
  },
  {
    "date": "24.01.2020",
    "now": "5,9381",
    "open": "5,9343",
    "highest": "5,9489",
    "lower": "5,9202",
    "difference": "0,13%"
  },
  {
    "date": "23.01.2020",
    "now": "5,9305",
    "open": "5,9222",
    "highest": "5,9469",
    "lower": "5,8998",
    "difference": "0,21%"
  },
  {
    "date": "22.01.2020",
    "now": "5,9181",
    "open": "5,9380",
    "highest": "5,9459",
    "lower": "5,9145",
    "difference": "-0,28%"
  },
  {
    "date": "21.01.2020",
    "now": "5,9350",
    "open": "5,9115",
    "highest": "5,9409",
    "lower": "5,9107",
    "difference": "0,42%"
  },
  {
    "date": "20.01.2020",
    "now": "5,9102",
    "open": "5,8820",
    "highest": "5,9212",
    "lower": "5,8820",
    "difference": "0,35%"
  },
  {
    "date": "17.01.2020",
    "now": "5,8898",
    "open": "5,8584",
    "highest": "5,9126",
    "lower": "5,8443",
    "difference": "0,60%"
  },
  {
    "date": "16.01.2020",
    "now": "5,8547",
    "open": "5,8762",
    "highest": "5,8937",
    "lower": "5,8341",
    "difference": "-0,34%"
  },
  {
    "date": "15.01.2020",
    "now": "5,8748",
    "open": "5,8815",
    "highest": "5,9016",
    "lower": "5,8678",
    "difference": "-0,07%"
  },
  {
    "date": "14.01.2020",
    "now": "5,8790",
    "open": "5,8676",
    "highest": "5,9039",
    "lower": "5,8590",
    "difference": "0,31%"
  },
  {
    "date": "13.01.2020",
    "now": "5,8607",
    "open": "5,8785",
    "highest": "5,8809",
    "lower": "5,8490",
    "difference": "-0,27%"
  },
  {
    "date": "10.01.2020",
    "now": "5,8767",
    "open": "5,8740",
    "highest": "5,8972",
    "lower": "5,8560",
    "difference": "0,13%"
  },
  {
    "date": "09.01.2020",
    "now": "5,8689",
    "open": "5,9089",
    "highest": "5,9278",
    "lower": "5,8562",
    "difference": "-0,66%"
  },
  {
    "date": "08.01.2020",
    "now": "5,9081",
    "open": "5,9728",
    "highest": "5,9893",
    "lower": "5,8973",
    "difference": "-1,05%"
  },
  {
    "date": "07.01.2020",
    "now": "5,9705",
    "open": "5,9694",
    "highest": "5,9790",
    "lower": "5,9471",
    "difference": "0,10%"
  },
  {
    "date": "06.01.2020",
    "now": "5,9644",
    "open": "5,9722",
    "highest": "5,9783",
    "lower": "5,9619",
    "difference": "-0,12%"
  },
  {
    "date": "03.01.2020",
    "now": "5,9713",
    "open": "5,9570",
    "highest": "5,9792",
    "lower": "5,9495",
    "difference": "0,29%"
  },
  {
    "date": "02.01.2020",
    "now": "5,9541",
    "open": "5,9465",
    "highest": "5,9605",
    "lower": "5,9433",
    "difference": "0,14%"
  },
  {
    "date": "01.01.2020",
    "now": "5,9456",
    "open": "5,9487",
    "highest": "5,9502",
    "lower": "5,9405",
    "difference": "-0,04%"
  },
  {
    "date": "31.12.2019",
    "now": "5,9479",
    "open": "5,9478",
    "highest": "5,9529",
    "lower": "5,9399",
    "difference": "0,06%"
  },
  {
    "date": "30.12.2019",
    "now": "5,9441",
    "open": "5,9493",
    "highest": "5,9527",
    "lower": "5,9350",
    "difference": "-0,09%"
  },
  {
    "date": "27.12.2019",
    "now": "5,9492",
    "open": "5,9335",
    "highest": "5,9617",
    "lower": "5,9257",
    "difference": "0,35%"
  },
  {
    "date": "26.12.2019",
    "now": "5,9286",
    "open": "5,9335",
    "highest": "5,9455",
    "lower": "5,9284",
    "difference": "-0,09%"
  },
  {
    "date": "25.12.2019",
    "now": "5,9340",
    "open": "5,9469",
    "highest": "5,9504",
    "lower": "5,9290",
    "difference": "-0,20%"
  },
  {
    "date": "24.12.2019",
    "now": "5,9458",
    "open": "5,9482",
    "highest": "5,9567",
    "lower": "5,9290",
    "difference": "-0,02%"
  },
  {
    "date": "23.12.2019",
    "now": "5,9471",
    "open": "5,9388",
    "highest": "5,9524",
    "lower": "5,9165",
    "difference": "0,19%"
  },
  {
    "date": "20.12.2019",
    "now": "5,9356",
    "open": "5,9417",
    "highest": "5,9448",
    "lower": "5,9001",
    "difference": "-0,04%"
  },
  {
    "date": "19.12.2019",
    "now": "5,9380",
    "open": "5,9267",
    "highest": "5,9457",
    "lower": "5,9000",
    "difference": "0,27%"
  },
  {
    "date": "18.12.2019",
    "now": "5,9219",
    "open": "5,8861",
    "highest": "5,9323",
    "lower": "5,8829",
    "difference": "0,68%"
  },
  {
    "date": "17.12.2019",
    "now": "5,8819",
    "open": "5,8501",
    "highest": "5,8910",
    "lower": "5,8429",
    "difference": "0,62%"
  },
  {
    "date": "16.12.2019",
    "now": "5,8454",
    "open": "5,8081",
    "highest": "5,8597",
    "lower": "5,8027",
    "difference": "0,66%"
  },
  {
    "date": "13.12.2019",
    "now": "5,8072",
    "open": "5,7906",
    "highest": "5,8268",
    "lower": "5,7670",
    "difference": "0,32%"
  },
  {
    "date": "12.12.2019",
    "now": "5,7889",
    "open": "5,8079",
    "highest": "5,8131",
    "lower": "5,7603",
    "difference": "-0,30%"
  },
  {
    "date": "11.12.2019",
    "now": "5,8064",
    "open": "5,8060",
    "highest": "5,8195",
    "lower": "5,7916",
    "difference": "0,06%"
  },
  {
    "date": "10.12.2019",
    "now": "5,8027",
    "open": "5,8112",
    "highest": "5,8197",
    "lower": "5,7876",
    "difference": "-0,08%"
  },
  {
    "date": "09.12.2019",
    "now": "5,8074",
    "open": "5,7758",
    "highest": "5,8178",
    "lower": "5,7712",
    "difference": "0,55%"
  },
  {
    "date": "06.12.2019",
    "now": "5,7756",
    "open": "5,7485",
    "highest": "5,7906",
    "lower": "5,7378",
    "difference": "0,55%"
  },
  {
    "date": "05.12.2019",
    "now": "5,7441",
    "open": "5,7455",
    "highest": "5,7700",
    "lower": "5,7358",
    "difference": "-0,06%"
  },
  {
    "date": "04.12.2019",
    "now": "5,7474",
    "open": "5,7420",
    "highest": "5,7624",
    "lower": "5,7302",
    "difference": "0,11%"
  },
  {
    "date": "03.12.2019",
    "now": "5,7410",
    "open": "5,7414",
    "highest": "5,7664",
    "lower": "5,7257",
    "difference": "0,05%"
  },
  {
    "date": "02.12.2019",
    "now": "5,7382",
    "open": "5,7465",
    "highest": "5,7655",
    "lower": "5,7302",
    "difference": "-0,14%"
  },
  {
    "date": "29.11.2019",
    "now": "5,7460",
    "open": "5,7575",
    "highest": "5,7984",
    "lower": "5,7343",
    "difference": "-0,08%"
  },
  {
    "date": "28.11.2019",
    "now": "5,7505",
    "open": "5,7769",
    "highest": "5,7852",
    "lower": "5,7510",
    "difference": "-0,46%"
  },
  {
    "date": "27.11.2019",
    "now": "5,7769",
    "open": "5,7599",
    "highest": "5,7923",
    "lower": "5,7480",
    "difference": "0,37%"
  },
  {
    "date": "26.11.2019",
    "now": "5,7556",
    "open": "5,7422",
    "highest": "5,7712",
    "lower": "5,7315",
    "difference": "0,39%"
  },
  {
    "date": "25.11.2019",
    "now": "5,7333",
    "open": "5,7173",
    "highest": "5,7599",
    "lower": "5,6993",
    "difference": "0,37%"
  },
  {
    "date": "22.11.2019",
    "now": "5,7122",
    "open": "5,6940",
    "highest": "5,7255",
    "lower": "5,6875",
    "difference": "0,36%"
  },
  {
    "date": "21.11.2019",
    "now": "5,6915",
    "open": "5,6997",
    "highest": "5,7116",
    "lower": "5,6813",
    "difference": "-0,01%"
  },
  {
    "date": "20.11.2019",
    "now": "5,6921",
    "open": "5,6993",
    "highest": "5,7239",
    "lower": "5,6825",
    "difference": "-0,10%"
  },
  {
    "date": "19.11.2019",
    "now": "5,6980",
    "open": "5,7364",
    "highest": "5,7471",
    "lower": "5,6929",
    "difference": "-0,61%"
  },
  {
    "date": "18.11.2019",
    "now": "5,7328",
    "open": "5,7434",
    "highest": "5,7570",
    "lower": "5,7165",
    "difference": "-0,20%"
  },
  {
    "date": "15.11.2019",
    "now": "5,7443",
    "open": "5,7471",
    "highest": "5,7709",
    "lower": "5,7351",
    "difference": "-0,01%"
  },
  {
    "date": "14.11.2019",
    "now": "5,7446",
    "open": "5,7401",
    "highest": "5,7822",
    "lower": "5,7361",
    "difference": "0,09%"
  },
  {
    "date": "13.11.2019",
    "now": "5,7393",
    "open": "5,7775",
    "highest": "5,7834",
    "lower": "5,7308",
    "difference": "-0,65%"
  },
  {
    "date": "12.11.2019",
    "now": "5,7766",
    "open": "5,7731",
    "highest": "5,7844",
    "lower": "5,7593",
    "difference": "0,14%"
  },
  {
    "date": "11.11.2019",
    "now": "5,7683",
    "open": "5,7671",
    "highest": "5,7973",
    "lower": "5,7583",
    "difference": "0,04%"
  },
  {
    "date": "08.11.2019",
    "now": "5,7658",
    "open": "5,7515",
    "highest": "5,7716",
    "lower": "5,7380",
    "difference": "0,32%"
  },
  {
    "date": "07.11.2019",
    "now": "5,7474",
    "open": "5,7504",
    "highest": "5,7651",
    "lower": "5,7301",
    "difference": "0,02%"
  },
  {
    "date": "06.11.2019",
    "now": "5,7460",
    "open": "5,7534",
    "highest": "5,7737",
    "lower": "5,7422",
    "difference": "-0,05%"
  },
  {
    "date": "05.11.2019",
    "now": "5,7488",
    "open": "5,7387",
    "highest": "5,7642",
    "lower": "5,7140",
    "difference": "0,19%"
  },
  {
    "date": "04.11.2019",
    "now": "5,7377",
    "open": "5,7085",
    "highest": "5,7420",
    "lower": "5,6790",
    "difference": "0,68%"
  },
  {
    "date": "01.11.2019",
    "now": "5,6989",
    "open": "5,7136",
    "highest": "5,7410",
    "lower": "5,6953",
    "difference": "-0,13%"
  },
  {
    "date": "31.10.2019",
    "now": "5,7065",
    "open": "5,7017",
    "highest": "5,7283",
    "lower": "5,6950",
    "difference": "0,10%"
  },
  {
    "date": "30.10.2019",
    "now": "5,7010",
    "open": "5,7380",
    "highest": "5,7727",
    "lower": "5,6950",
    "difference": "-0,56%"
  },
  {
    "date": "29.10.2019",
    "now": "5,7333",
    "open": "5,7312",
    "highest": "5,7642",
    "lower": "5,7145",
    "difference": "0,09%"
  },
  {
    "date": "28.10.2019",
    "now": "5,7281",
    "open": "5,7746",
    "highest": "5,7771",
    "lower": "5,7124",
    "difference": "-0,79%"
  },
  {
    "date": "25.10.2019",
    "now": "5,7738",
    "open": "5,7648",
    "highest": "5,7926",
    "lower": "5,7508",
    "difference": "0,21%"
  },
  {
    "date": "24.10.2019",
    "now": "5,7615",
    "open": "5,7351",
    "highest": "5,7807",
    "lower": "5,7265",
    "difference": "0,52%"
  },
  {
    "date": "23.10.2019",
    "now": "5,7317",
    "open": "5,8085",
    "highest": "5,8212",
    "lower": "5,7234",
    "difference": "-1,28%"
  },
  {
    "date": "22.10.2019",
    "now": "5,8059",
    "open": "5,8581",
    "highest": "5,8645",
    "lower": "5,7853",
    "difference": "-0,83%"
  },
  {
    "date": "21.10.2019",
    "now": "5,8544",
    "open": "5,7920",
    "highest": "5,8678",
    "lower": "5,7783",
    "difference": "1,10%"
  },
  {
    "date": "18.10.2019",
    "now": "5,7909",
    "open": "5,8297",
    "highest": "5,8340",
    "lower": "5,7473",
    "difference": "-0,65%"
  },
  {
    "date": "17.10.2019",
    "now": "5,8289",
    "open": "5,8871",
    "highest": "5,9325",
    "lower": "5,8147",
    "difference": "-0,97%"
  },
  {
    "date": "16.10.2019",
    "now": "5,8860",
    "open": "5,9163",
    "highest": "5,9343",
    "lower": "5,8696",
    "difference": "-0,35%"
  },
  {
    "date": "15.10.2019",
    "now": "5,9068",
    "open": "5,9272",
    "highest": "5,9364",
    "lower": "5,8555",
    "difference": "-0,33%"
  },
  {
    "date": "14.10.2019",
    "now": "5,9261",
    "open": "5,8852",
    "highest": "5,9416",
    "lower": "5,8851",
    "difference": "0,73%"
  },
  {
    "date": "11.10.2019",
    "now": "5,8833",
    "open": "5,8369",
    "highest": "5,9003",
    "lower": "5,8095",
    "difference": "0,88%"
  },
  {
    "date": "10.10.2019",
    "now": "5,8320",
    "open": "5,8708",
    "highest": "5,9018",
    "lower": "5,8149",
    "difference": "-0,61%"
  },
  {
    "date": "09.10.2019",
    "now": "5,8679",
    "open": "5,8320",
    "highest": "5,8782",
    "lower": "5,8130",
    "difference": "0,73%"
  },
  {
    "date": "08.10.2019",
    "now": "5,8251",
    "open": "5,8327",
    "highest": "5,8476",
    "lower": "5,7772",
    "difference": "-0,11%"
  },
  {
    "date": "07.10.2019",
    "now": "5,8318",
    "open": "5,7140",
    "highest": "5,8466",
    "lower": "5,6980",
    "difference": "2,40%"
  },
  {
    "date": "04.10.2019",
    "now": "5,6952",
    "open": "5,6955",
    "highest": "5,7148",
    "lower": "5,6753",
    "difference": "0,10%"
  },
  {
    "date": "03.10.2019",
    "now": "5,6896",
    "open": "5,7010",
    "highest": "5,7162",
    "lower": "5,6635",
    "difference": "-0,09%"
  },
  {
    "date": "02.10.2019",
    "now": "5,6946",
    "open": "5,7231",
    "highest": "5,7599",
    "lower": "5,6929",
    "difference": "-0,48%"
  },
  {
    "date": "01.10.2019",
    "now": "5,7221",
    "open": "5,6494",
    "highest": "5,7330",
    "lower": "5,6398",
    "difference": "1,31%"
  },
  {
    "date": "30.09.2019",
    "now": "5,6479",
    "open": "5,6708",
    "highest": "5,6806",
    "lower": "5,6330",
    "difference": "-0,39%"
  },
  {
    "date": "27.09.2019",
    "now": "5,6698",
    "open": "5,6667",
    "highest": "5,6900",
    "lower": "5,6450",
    "difference": "0,14%"
  },
  {
    "date": "26.09.2019",
    "now": "5,6617",
    "open": "5,6700",
    "highest": "5,6985",
    "lower": "5,6427",
    "difference": "-0,11%"
  },
  {
    "date": "25.09.2019",
    "now": "5,6681",
    "open": "5,6978",
    "highest": "5,7144",
    "lower": "5,6663",
    "difference": "-0,50%"
  },
  {
    "date": "24.09.2019",
    "now": "5,6963",
    "open": "5,7176",
    "highest": "5,7235",
    "lower": "5,6673",
    "difference": "-0,33%"
  },
  {
    "date": "23.09.2019",
    "now": "5,7149",
    "open": "5,7432",
    "highest": "5,7472",
    "lower": "5,7087",
    "difference": "-0,49%"
  },
  {
    "date": "20.09.2019",
    "now": "5,7429",
    "open": "5,7186",
    "highest": "5,7527",
    "lower": "5,6788",
    "difference": "0,49%"
  },
  {
    "date": "19.09.2019",
    "now": "5,7148",
    "open": "5,6771",
    "highest": "5,7236",
    "lower": "5,6677",
    "difference": "0,75%"
  },
  {
    "date": "18.09.2019",
    "now": "5,6720",
    "open": "5,7014",
    "highest": "5,7104",
    "lower": "5,6535",
    "difference": "-0,42%"
  },
  {
    "date": "17.09.2019",
    "now": "5,6962",
    "open": "5,7288",
    "highest": "5,7428",
    "lower": "5,6877",
    "difference": "-0,49%"
  },
  {
    "date": "16.09.2019",
    "now": "5,7245",
    "open": "5,6858",
    "highest": "5,7446",
    "lower": "5,6857",
    "difference": "0,69%"
  },
  {
    "date": "13.09.2019",
    "now": "5,6851",
    "open": "5,6595",
    "highest": "5,6965",
    "lower": "5,6491",
    "difference": "0,64%"
  },
  {
    "date": "12.09.2019",
    "now": "5,6491",
    "open": "5,7495",
    "highest": "5,7726",
    "lower": "5,6501",
    "difference": "-1,68%"
  },
  {
    "date": "11.09.2019",
    "now": "5,7456",
    "open": "5,7682",
    "highest": "5,7944",
    "lower": "5,7417",
    "difference": "-0,32%"
  },
  {
    "date": "10.09.2019",
    "now": "5,7641",
    "open": "5,7499",
    "highest": "5,7896",
    "lower": "5,7404",
    "difference": "0,28%"
  },
  {
    "date": "09.09.2019",
    "now": "5,7479",
    "open": "5,7147",
    "highest": "5,7670",
    "lower": "5,6978",
    "difference": "0,58%"
  },
  {
    "date": "06.09.2019",
    "now": "5,7145",
    "open": "5,6916",
    "highest": "5,7301",
    "lower": "5,6782",
    "difference": "0,53%"
  },
  {
    "date": "05.09.2019",
    "now": "5,6846",
    "open": "5,6678",
    "highest": "5,7031",
    "lower": "5,6435",
    "difference": "0,33%"
  },
  {
    "date": "04.09.2019",
    "now": "5,6660",
    "open": "5,7294",
    "highest": "5,7354",
    "lower": "5,6450",
    "difference": "-1,09%"
  },
  {
    "date": "03.09.2019",
    "now": "5,7283",
    "open": "5,8074",
    "highest": "5,8253",
    "lower": "5,7195",
    "difference": "-1,31%"
  },
  {
    "date": "02.09.2019",
    "now": "5,8044",
    "open": "5,8316",
    "highest": "5,8440",
    "lower": "5,7925",
    "difference": "-0,43%"
  },
  {
    "date": "30.08.2019",
    "now": "5,8296",
    "open": "5,8390",
    "highest": "5,8533",
    "lower": "5,8153",
    "difference": "-0,16%"
  },
  {
    "date": "29.08.2019",
    "now": "5,8390",
    "open": "5,8150",
    "highest": "5,8501",
    "lower": "5,8005",
    "difference": "0,50%"
  },
  {
    "date": "28.08.2019",
    "now": "5,8101",
    "open": "5,8283",
    "highest": "5,8415",
    "lower": "5,7886",
    "difference": "-0,20%"
  },
  {
    "date": "27.08.2019",
    "now": "5,8218",
    "open": "5,8249",
    "highest": "5,8608",
    "lower": "5,7955",
    "difference": "0,03%"
  },
  {
    "date": "26.08.2019",
    "now": "5,8201",
    "open": "5,7612",
    "highest": "5,8495",
    "lower": "5,7606",
    "difference": "1,06%"
  },
  {
    "date": "23.08.2019",
    "now": "5,7589",
    "open": "5,7689",
    "highest": "5,7804",
    "lower": "5,7302",
    "difference": "-0,15%"
  },
  {
    "date": "22.08.2019",
    "now": "5,7678",
    "open": "5,7175",
    "highest": "5,7934",
    "lower": "5,7075",
    "difference": "1,02%"
  },
  {
    "date": "21.08.2019",
    "now": "5,7094",
    "open": "5,7343",
    "highest": "5,7419",
    "lower": "5,6995",
    "difference": "-0,30%"
  },
  {
    "date": "20.08.2019",
    "now": "5,7265",
    "open": "5,6607",
    "highest": "5,7512",
    "lower": "5,6367",
    "difference": "1,30%"
  },
  {
    "date": "19.08.2019",
    "now": "5,6528",
    "open": "5,5792",
    "highest": "5,6741",
    "lower": "5,5578",
    "difference": "1,35%"
  },
  {
    "date": "16.08.2019",
    "now": "5,5775",
    "open": "5,5680",
    "highest": "5,5880",
    "lower": "5,5245",
    "difference": "0,24%"
  },
  {
    "date": "15.08.2019",
    "now": "5,5642",
    "open": "5,6127",
    "highest": "5,6196",
    "lower": "5,5406",
    "difference": "-0,83%"
  },
  {
    "date": "14.08.2019",
    "now": "5,6105",
    "open": "5,5608",
    "highest": "5,6313",
    "lower": "5,5577",
    "difference": "0,93%"
  },
  {
    "date": "13.08.2019",
    "now": "5,5588",
    "open": "5,5642",
    "highest": "5,6369",
    "lower": "5,5470",
    "difference": "-0,01%"
  },
  {
    "date": "12.08.2019",
    "now": "5,5593",
    "open": "5,4914",
    "highest": "5,5757",
    "lower": "5,4886",
    "difference": "1,25%"
  },
  {
    "date": "09.08.2019",
    "now": "5,4907",
    "open": "5,4760",
    "highest": "5,5147",
    "lower": "5,4503",
    "difference": "0,39%"
  },
  {
    "date": "08.08.2019",
    "now": "5,4691",
    "open": "5,4940",
    "highest": "5,5174",
    "lower": "5,4463",
    "difference": "-0,40%"
  },
  {
    "date": "07.08.2019",
    "now": "5,4910",
    "open": "5,5208",
    "highest": "5,5347",
    "lower": "5,4583",
    "difference": "-0,49%"
  },
  {
    "date": "06.08.2019",
    "now": "5,5182",
    "open": "5,5668",
    "highest": "5,5958",
    "lower": "5,5052",
    "difference": "-0,94%"
  },
  {
    "date": "05.08.2019",
    "now": "5,5705",
    "open": "5,5600",
    "highest": "5,6231",
    "lower": "5,5274",
    "difference": "0,21%"
  },
  {
    "date": "02.08.2019",
    "now": "5,5587",
    "open": "5,6041",
    "highest": "5,6264",
    "lower": "5,5448",
    "difference": "-0,77%"
  },
  {
    "date": "01.08.2019",
    "now": "5,6019",
    "open": "5,5813",
    "highest": "5,6297",
    "lower": "5,5545",
    "difference": "0,30%"
  },
  {
    "date": "31.07.2019",
    "now": "5,5854",
    "open": "5,5594",
    "highest": "5,6225",
    "lower": "5,5080",
    "difference": "0,53%"
  },
  {
    "date": "30.07.2019",
    "now": "5,5558",
    "open": "5,6144",
    "highest": "5,6245",
    "lower": "5,5445",
    "difference": "-0,96%"
  },
  {
    "date": "29.07.2019",
    "now": "5,6098",
    "open": "5,6718",
    "highest": "5,6743",
    "lower": "5,5953",
    "difference": "-1,08%"
  },
  {
    "date": "26.07.2019",
    "now": "5,6708",
    "open": "5,7035",
    "highest": "5,7106",
    "lower": "5,6065",
    "difference": "-0,54%"
  },
  {
    "date": "25.07.2019",
    "now": "5,7017",
    "open": "5,7086",
    "highest": "5,7770",
    "lower": "5,6459",
    "difference": "-0,05%"
  },
  {
    "date": "24.07.2019",
    "now": "5,7046",
    "open": "5,7180",
    "highest": "5,7393",
    "lower": "5,6922",
    "difference": "-0,21%"
  },
  {
    "date": "23.07.2019",
    "now": "5,7168",
    "open": "5,6795",
    "highest": "5,7279",
    "lower": "5,6651",
    "difference": "0,74%"
  },
  {
    "date": "22.07.2019",
    "now": "5,6750",
    "open": "5,6525",
    "highest": "5,6976",
    "lower": "5,6395",
    "difference": "0,39%"
  },
  {
    "date": "19.07.2019",
    "now": "5,6531",
    "open": "5,6186",
    "highest": "5,6781",
    "lower": "5,6125",
    "difference": "0,70%"
  },
  {
    "date": "18.07.2019",
    "now": "5,6136",
    "open": "5,6842",
    "highest": "5,7137",
    "lower": "5,6120",
    "difference": "-1,18%"
  },
  {
    "date": "17.07.2019",
    "now": "5,6806",
    "open": "5,7127",
    "highest": "5,7218",
    "lower": "5,6705",
    "difference": "-0,53%"
  },
  {
    "date": "16.07.2019",
    "now": "5,7108",
    "open": "5,7149",
    "highest": "5,7274",
    "lower": "5,6900",
    "difference": "-0,01%"
  },
  {
    "date": "15.07.2019",
    "now": "5,7116",
    "open": "5,7198",
    "highest": "5,7357",
    "lower": "5,6957",
    "difference": "0,06%"
  },
  {
    "date": "12.07.2019",
    "now": "5,7081",
    "open": "5,6737",
    "highest": "5,7802",
    "lower": "5,6563",
    "difference": "0,66%"
  },
  {
    "date": "11.07.2019",
    "now": "5,6704",
    "open": "5,6752",
    "highest": "5,7030",
    "lower": "5,6493",
    "difference": "0,00%"
  },
  {
    "date": "10.07.2019",
    "now": "5,6702",
    "open": "5,7307",
    "highest": "5,7596",
    "lower": "5,6663",
    "difference": "-1,02%"
  },
  {
    "date": "09.07.2019",
    "now": "5,7287",
    "open": "5,7366",
    "highest": "5,7519",
    "lower": "5,6807",
    "difference": "-0,12%"
  },
  {
    "date": "08.07.2019",
    "now": "5,7357",
    "open": "5,6295",
    "highest": "5,7948",
    "lower": "5,6294",
    "difference": "1,92%"
  },
  {
    "date": "05.07.2019",
    "now": "5,6278",
    "open": "5,5952",
    "highest": "5,6471",
    "lower": "5,5845",
    "difference": "0,60%"
  },
  {
    "date": "04.07.2019",
    "now": "5,5943",
    "open": "5,6243",
    "highest": "5,6286",
    "lower": "5,5780",
    "difference": "-0,41%"
  },
  {
    "date": "03.07.2019",
    "now": "5,6171",
    "open": "5,6564",
    "highest": "5,6670",
    "lower": "5,6007",
    "difference": "-0,56%"
  },
  {
    "date": "02.07.2019",
    "now": "5,6485",
    "open": "5,6501",
    "highest": "5,7037",
    "lower": "5,6205",
    "difference": "0,10%"
  },
  {
    "date": "01.07.2019",
    "now": "5,6431",
    "open": "5,7920",
    "highest": "5,7920",
    "lower": "5,6180",
    "difference": "-2,49%"
  },
  {
    "date": "28.06.2019",
    "now": "5,7873",
    "open": "5,7723",
    "highest": "5,8012",
    "lower": "5,7393",
    "difference": "0,30%"
  },
  {
    "date": "27.06.2019",
    "now": "5,7698",
    "open": "5,7753",
    "highest": "5,7966",
    "lower": "5,7540",
    "difference": "-0,04%"
  },
  {
    "date": "26.06.2019",
    "now": "5,7719",
    "open": "5,7947",
    "highest": "5,8181",
    "lower": "5,7453",
    "difference": "-0,38%"
  },
  {
    "date": "25.06.2019",
    "now": "5,7939",
    "open": "5,8089",
    "highest": "5,8338",
    "lower": "5,7515",
    "difference": "-0,24%"
  },
  {
    "date": "24.06.2019",
    "now": "5,8080",
    "open": "5,8213",
    "highest": "5,8341",
    "lower": "5,7025",
    "difference": "-0,21%"
  },
  {
    "date": "21.06.2019",
    "now": "5,8204",
    "open": "5,7643",
    "highest": "5,8407",
    "lower": "5,7513",
    "difference": "1,05%"
  },
  {
    "date": "20.06.2019",
    "now": "5,7600",
    "open": "5,7913",
    "highest": "5,9022",
    "lower": "5,7232",
    "difference": "-0,40%"
  },
  {
    "date": "19.06.2019",
    "now": "5,7833",
    "open": "5,8279",
    "highest": "5,9190",
    "lower": "5,7842",
    "difference": "-0,67%"
  },
  {
    "date": "18.06.2019",
    "now": "5,8225",
    "open": "5,8735",
    "highest": "5,8826",
    "lower": "5,8114",
    "difference": "-0,79%"
  },
  {
    "date": "17.06.2019",
    "now": "5,8687",
    "open": "5,8990",
    "highest": "5,9291",
    "lower": "5,8485",
    "difference": "-0,54%"
  },
  {
    "date": "14.06.2019",
    "now": "5,9005",
    "open": "5,8685",
    "highest": "5,9338",
    "lower": "5,8490",
    "difference": "0,66%"
  },
  {
    "date": "13.06.2019",
    "now": "5,8619",
    "open": "5,8073",
    "highest": "5,9046",
    "lower": "5,8018",
    "difference": "0,95%"
  },
  {
    "date": "12.06.2019",
    "now": "5,8070",
    "open": "5,7977",
    "highest": "5,8327",
    "lower": "5,7610",
    "difference": "0,21%"
  },
  {
    "date": "11.06.2019",
    "now": "5,7946",
    "open": "5,7816",
    "highest": "5,8457",
    "lower": "5,7483",
    "difference": "0,36%"
  },
  {
    "date": "10.06.2019",
    "now": "5,7737",
    "open": "5,8324",
    "highest": "5,8633",
    "lower": "5,7568",
    "difference": "-0,97%"
  },
  {
    "date": "07.06.2019",
    "now": "5,8300",
    "open": "5,7800",
    "highest": "5,8721",
    "lower": "5,7755",
    "difference": "0,94%"
  },
  {
    "date": "06.06.2019",
    "now": "5,7759",
    "open": "5,7300",
    "highest": "5,8074",
    "lower": "5,7126",
    "difference": "0,80%"
  },
  {
    "date": "05.06.2019",
    "now": "5,7300",
    "open": "5,7827",
    "highest": "5,7912",
    "lower": "5,6659",
    "difference": "-0,77%"
  },
  {
    "date": "04.06.2019",
    "now": "5,7746",
    "open": "5,8343",
    "highest": "5,8679",
    "lower": "5,7459",
    "difference": "-0,94%"
  },
  {
    "date": "03.06.2019",
    "now": "5,8293",
    "open": "5,8399",
    "highest": "5,8942",
    "lower": "5,8234",
    "difference": "-0,14%"
  },
  {
    "date": "31.05.2019",
    "now": "5,8372",
    "open": "5,8793",
    "highest": "5,9262",
    "lower": "5,8144",
    "difference": "-0,64%"
  },
  {
    "date": "30.05.2019",
    "now": "5,8746",
    "open": "6,0111",
    "highest": "6,0299",
    "lower": "5,8550",
    "difference": "-2,24%"
  },
  {
    "date": "29.05.2019",
    "now": "6,0090",
    "open": "6,0317",
    "highest": "6,0594",
    "lower": "5,9950",
    "difference": "-0,30%"
  },
  {
    "date": "28.05.2019",
    "now": "6,0271",
    "open": "6,0608",
    "highest": "6,0846",
    "lower": "5,9833",
    "difference": "-0,48%"
  },
  {
    "date": "27.05.2019",
    "now": "6,0560",
    "open": "6,0844",
    "highest": "6,1104",
    "lower": "6,0272",
    "difference": "-0,42%"
  },
  {
    "date": "24.05.2019",
    "now": "6,0815",
    "open": "6,0963",
    "highest": "6,1297",
    "lower": "6,0430",
    "difference": "-0,23%"
  },
  {
    "date": "23.05.2019",
    "now": "6,0954",
    "open": "6,0956",
    "highest": "6,1545",
    "lower": "6,0879",
    "difference": "0,07%"
  },
  {
    "date": "22.05.2019",
    "now": "6,0910",
    "open": "6,0524",
    "highest": "6,1225",
    "lower": "6,0459",
    "difference": "0,65%"
  },
  {
    "date": "21.05.2019",
    "now": "6,0515",
    "open": "6,0287",
    "highest": "6,0907",
    "lower": "6,0094",
    "difference": "0,54%"
  },
  {
    "date": "20.05.2019",
    "now": "6,0189",
    "open": "6,0558",
    "highest": "6,0837",
    "lower": "5,9963",
    "difference": "-0,58%"
  },
  {
    "date": "17.05.2019",
    "now": "6,0540",
    "open": "6,0465",
    "highest": "6,0964",
    "lower": "6,0240",
    "difference": "0,21%"
  },
  {
    "date": "16.05.2019",
    "now": "6,0415",
    "open": "6,0009",
    "highest": "6,0543",
    "lower": "5,9919",
    "difference": "0,74%"
  },
  {
    "date": "15.05.2019",
    "now": "5,9973",
    "open": "6,0311",
    "highest": "6,0894",
    "lower": "5,9882",
    "difference": "-0,46%"
  },
  {
    "date": "14.05.2019",
    "now": "6,0249",
    "open": "6,0594",
    "highest": "6,1143",
    "lower": "5,9805",
    "difference": "-0,50%"
  },
  {
    "date": "13.05.2019",
    "now": "6,0552",
    "open": "6,0032",
    "highest": "6,1335",
    "lower": "5,9570",
    "difference": "1,33%"
  },
  {
    "date": "10.05.2019",
    "now": "5,9757",
    "open": "6,1928",
    "highest": "6,2069",
    "lower": "5,9561",
    "difference": "-3,47%"
  },
  {
    "date": "09.05.2019",
    "now": "6,1907",
    "open": "6,1837",
    "highest": "6,2478",
    "lower": "6,1543",
    "difference": "0,12%"
  },
  {
    "date": "08.05.2019",
    "now": "6,1835",
    "open": "6,1500",
    "highest": "6,2001",
    "lower": "6,1415",
    "difference": "0,54%"
  },
  {
    "date": "07.05.2019",
    "now": "6,1501",
    "open": "6,0805",
    "highest": "6,2000",
    "lower": "6,0743",
    "difference": "1,20%"
  },
  {
    "date": "06.05.2019",
    "now": "6,0769",
    "open": "5,9640",
    "highest": "6,1517",
    "lower": "5,9640",
    "difference": "2,08%"
  },
  {
    "date": "03.05.2019",
    "now": "5,9531",
    "open": "5,9649",
    "highest": "5,9843",
    "lower": "5,9528",
    "difference": "-0,17%"
  },
  {
    "date": "02.05.2019",
    "now": "5,9635",
    "open": "5,9671",
    "highest": "5,9850",
    "lower": "5,9494",
    "difference": "-0,01%"
  },
  {
    "date": "01.05.2019",
    "now": "5,9640",
    "open": "5,9659",
    "highest": "5,9701",
    "lower": "5,9356",
    "difference": "0,04%"
  },
  {
    "date": "30.04.2019",
    "now": "5,9617",
    "open": "5,9486",
    "highest": "5,9858",
    "lower": "5,9278",
    "difference": "0,28%"
  },
  {
    "date": "29.04.2019",
    "now": "5,9448",
    "open": "5,9318",
    "highest": "5,9630",
    "lower": "5,9152",
    "difference": "0,13%"
  },
  {
    "date": "26.04.2019",
    "now": "5,9372",
    "open": "5,9276",
    "highest": "5,9732",
    "lower": "5,9145",
    "difference": "0,22%"
  },
  {
    "date": "25.04.2019",
    "now": "5,9243",
    "open": "5,8735",
    "highest": "5,9823",
    "lower": "5,8650",
    "difference": "0,92%"
  },
  {
    "date": "24.04.2019",
    "now": "5,8705",
    "open": "5,8284",
    "highest": "5,8943",
    "lower": "5,8229",
    "difference": "0,73%"
  },
  {
    "date": "23.04.2019",
    "now": "5,8277",
    "open": "5,8273",
    "highest": "5,8540",
    "lower": "5,8094",
    "difference": "0,03%"
  },
  {
    "date": "22.04.2019",
    "now": "5,8262",
    "open": "5,8112",
    "highest": "5,8615",
    "lower": "5,8064",
    "difference": "0,28%"
  },
  {
    "date": "19.04.2019",
    "now": "5,8102",
    "open": "5,8001",
    "highest": "5,8404",
    "lower": "5,7758",
    "difference": "0,27%"
  },
  {
    "date": "18.04.2019",
    "now": "5,7945",
    "open": "5,7389",
    "highest": "5,8538",
    "lower": "5,7362",
    "difference": "1,01%"
  },
  {
    "date": "17.04.2019",
    "now": "5,7367",
    "open": "5,7719",
    "highest": "5,7966",
    "lower": "5,6965",
    "difference": "-0,51%"
  },
  {
    "date": "16.04.2019",
    "now": "5,7662",
    "open": "5,8042",
    "highest": "5,8316",
    "lower": "5,7368",
    "difference": "-0,58%"
  },
  {
    "date": "15.04.2019",
    "now": "5,7997",
    "open": "5,7643",
    "highest": "5,8272",
    "lower": "5,7590",
    "difference": "0,54%"
  },
  {
    "date": "12.04.2019",
    "now": "5,7683",
    "open": "5,7380",
    "highest": "5,8305",
    "lower": "5,7092",
    "difference": "0,59%"
  },
  {
    "date": "11.04.2019",
    "now": "5,7342",
    "open": "5,6812",
    "highest": "5,7625",
    "lower": "5,6676",
    "difference": "0,94%"
  },
  {
    "date": "10.04.2019",
    "now": "5,6808",
    "open": "5,6942",
    "highest": "5,7292",
    "lower": "5,6623",
    "difference": "-0,17%"
  },
  {
    "date": "09.04.2019",
    "now": "5,6906",
    "open": "5,6897",
    "highest": "5,7337",
    "lower": "5,6347",
    "difference": "0,02%"
  },
  {
    "date": "08.04.2019",
    "now": "5,6893",
    "open": "5,6261",
    "highest": "5,7465",
    "lower": "5,6175",
    "difference": "1,14%"
  },
  {
    "date": "05.04.2019",
    "now": "5,6252",
    "open": "5,5923",
    "highest": "5,6514",
    "lower": "5,5582",
    "difference": "0,66%"
  },
  {
    "date": "04.04.2019",
    "now": "5,5881",
    "open": "5,6262",
    "highest": "5,6666",
    "lower": "5,5460",
    "difference": "-0,60%"
  },
  {
    "date": "03.04.2019",
    "now": "5,6221",
    "open": "5,6050",
    "highest": "5,6751",
    "lower": "5,5672",
    "difference": "0,32%"
  },
  {
    "date": "02.04.2019",
    "now": "5,6040",
    "open": "5,4865",
    "highest": "5,6815",
    "lower": "5,4760",
    "difference": "2,16%"
  },
  {
    "date": "01.04.2019",
    "now": "5,4853",
    "open": "5,5705",
    "highest": "5,7135",
    "lower": "5,4175",
    "difference": "-1,00%"
  },
  {
    "date": "29.03.2019",
    "now": "5,5405",
    "open": "5,5586",
    "highest": "5,6826",
    "lower": "5,5470",
    "difference": "-0,10%"
  },
  {
    "date": "28.03.2019",
    "now": "5,5460",
    "open": "5,3322",
    "highest": "5,6547",
    "lower": "5,3317",
    "difference": "4,12%"
  },
  {
    "date": "27.03.2019",
    "now": "5,3268",
    "open": "5,3393",
    "highest": "5,4712",
    "lower": "5,2758",
    "difference": "-0,00%"
  },
  {
    "date": "26.03.2019",
    "now": "5,3269",
    "open": "5,5506",
    "highest": "5,5949",
    "lower": "5,3018",
    "difference": "-4,01%"
  },
  {
    "date": "25.03.2019",
    "now": "5,5493",
    "open": "5,7631",
    "highest": "5,7736",
    "lower": "5,5442",
    "difference": "-3,69%"
  },
  {
    "date": "22.03.2019",
    "now": "5,7617",
    "open": "5,4654",
    "highest": "5,8486",
    "lower": "5,4505",
    "difference": "5,50%"
  },
  {
    "date": "21.03.2019",
    "now": "5,4612",
    "open": "5,4215",
    "highest": "5,4809",
    "lower": "5,4191",
    "difference": "0,80%"
  },
  {
    "date": "20.03.2019",
    "now": "5,4178",
    "open": "5,4762",
    "highest": "5,4859",
    "lower": "5,4071",
    "difference": "-1,05%"
  },
  {
    "date": "19.03.2019",
    "now": "5,4754",
    "open": "5,4685",
    "highest": "5,4912",
    "lower": "5,4562",
    "difference": "0,17%"
  },
  {
    "date": "18.03.2019",
    "now": "5,4659",
    "open": "5,4466",
    "highest": "5,4759",
    "lower": "5,4437",
    "difference": "0,37%"
  },
  {
    "date": "15.03.2019",
    "now": "5,4457",
    "open": "5,4668",
    "highest": "5,4781",
    "lower": "5,4427",
    "difference": "-0,36%"
  },
  {
    "date": "14.03.2019",
    "now": "5,4653",
    "open": "5,4566",
    "highest": "5,4795",
    "lower": "5,4545",
    "difference": "0,20%"
  },
  {
    "date": "13.03.2019",
    "now": "5,4544",
    "open": "5,4563",
    "highest": "5,4815",
    "lower": "5,4483",
    "difference": "-0,01%"
  },
  {
    "date": "12.03.2019",
    "now": "5,4552",
    "open": "5,4454",
    "highest": "5,4679",
    "lower": "5,4253",
    "difference": "0,20%"
  },
  {
    "date": "11.03.2019",
    "now": "5,4445",
    "open": "5,4320",
    "highest": "5,4636",
    "lower": "5,4241",
    "difference": "0,34%"
  },
  {
    "date": "08.03.2019",
    "now": "5,4260",
    "open": "5,4713",
    "highest": "5,4889",
    "lower": "5,4216",
    "difference": "-0,81%"
  },
  {
    "date": "07.03.2019",
    "now": "5,4702",
    "open": "5,4285",
    "highest": "5,4820",
    "lower": "5,4199",
    "difference": "0,81%"
  },
  {
    "date": "06.03.2019",
    "now": "5,4263",
    "open": "5,3874",
    "highest": "5,4482",
    "lower": "5,3605",
    "difference": "0,78%"
  },
  {
    "date": "05.03.2019",
    "now": "5,3842",
    "open": "5,3740",
    "highest": "5,4030",
    "lower": "5,3615",
    "difference": "0,21%"
  },
  {
    "date": "04.03.2019",
    "now": "5,3727",
    "open": "5,3746",
    "highest": "5,4024",
    "lower": "5,3630",
    "difference": "-0,01%"
  },
  {
    "date": "01.03.2019",
    "now": "5,3732",
    "open": "5,3400",
    "highest": "5,4061",
    "lower": "5,3305",
    "difference": "0,73%"
  },
  {
    "date": "28.02.2019",
    "now": "5,3341",
    "open": "5,3088",
    "highest": "5,3429",
    "lower": "5,3057",
    "difference": "0,44%"
  },
  {
    "date": "27.02.2019",
    "now": "5,3109",
    "open": "5,3060",
    "highest": "5,3259",
    "lower": "5,2832",
    "difference": "0,17%"
  },
  {
    "date": "26.02.2019",
    "now": "5,3020",
    "open": "5,3028",
    "highest": "5,3199",
    "lower": "5,2877",
    "difference": "-0,01%"
  },
  {
    "date": "25.02.2019",
    "now": "5,3026",
    "open": "5,3198",
    "highest": "5,3284",
    "lower": "5,2912",
    "difference": "-0,30%"
  },
  {
    "date": "22.02.2019",
    "now": "5,3186",
    "open": "5,3159",
    "highest": "5,3414",
    "lower": "5,3010",
    "difference": "-0,05%"
  },
  {
    "date": "21.02.2019",
    "now": "5,3214",
    "open": "5,3288",
    "highest": "5,3455",
    "lower": "5,2982",
    "difference": "-0,06%"
  },
  {
    "date": "20.02.2019",
    "now": "5,3244",
    "open": "5,2838",
    "highest": "5,3322",
    "lower": "5,2748",
    "difference": "0,79%"
  },
  {
    "date": "19.02.2019",
    "now": "5,2828",
    "open": "5,2931",
    "highest": "5,3246",
    "lower": "5,2786",
    "difference": "-0,48%"
  },
  {
    "date": "18.02.2019",
    "now": "5,3083",
    "open": "5,2817",
    "highest": "5,3231",
    "lower": "5,2762",
    "difference": "0,70%"
  },
  {
    "date": "15.02.2019",
    "now": "5,2714",
    "open": "5,2704",
    "highest": "5,3111",
    "lower": "5,2430",
    "difference": "-0,03%"
  },
  {
    "date": "14.02.2019",
    "now": "5,2729",
    "open": "5,2830",
    "highest": "5,3253",
    "lower": "5,2572",
    "difference": "-0,23%"
  },
  {
    "date": "13.02.2019",
    "now": "5,2850",
    "open": "5,2538",
    "highest": "5,2985",
    "lower": "5,2352",
    "difference": "0,64%"
  },
  {
    "date": "12.02.2019",
    "now": "5,2516",
    "open": "5,2787",
    "highest": "5,2938",
    "lower": "5,2470",
    "difference": "-0,50%"
  },
  {
    "date": "11.02.2019",
    "now": "5,2780",
    "open": "5,2499",
    "highest": "5,2929",
    "lower": "5,2357",
    "difference": "0,58%"
  },
  {
    "date": "08.02.2019",
    "now": "5,2474",
    "open": "5,2643",
    "highest": "5,2781",
    "lower": "5,2220",
    "difference": "-0,37%"
  },
  {
    "date": "07.02.2019",
    "now": "5,2668",
    "open": "5,2176",
    "highest": "5,2970",
    "lower": "5,2085",
    "difference": "0,96%"
  },
  {
    "date": "06.02.2019",
    "now": "5,2168",
    "open": "5,2014",
    "highest": "5,2414",
    "lower": "5,1977",
    "difference": "0,35%"
  },
  {
    "date": "05.02.2019",
    "now": "5,1985",
    "open": "5,2217",
    "highest": "5,2259",
    "lower": "5,1790",
    "difference": "-0,38%"
  },
  {
    "date": "04.02.2019",
    "now": "5,2182",
    "open": "5,2031",
    "highest": "5,2444",
    "lower": "5,2001",
    "difference": "0,19%"
  },
  {
    "date": "01.02.2019",
    "now": "5,2084",
    "open": "5,1585",
    "highest": "5,2308",
    "lower": "5,1585",
    "difference": "0,85%"
  },
  {
    "date": "31.01.2019",
    "now": "5,1645",
    "open": "5,2265",
    "highest": "5,2462",
    "lower": "5,1589",
    "difference": "-1,16%"
  },
  {
    "date": "30.01.2019",
    "now": "5,2252",
    "open": "5,3095",
    "highest": "5,3253",
    "lower": "5,2090",
    "difference": "-1,59%"
  },
  {
    "date": "29.01.2019",
    "now": "5,3098",
    "open": "5,3238",
    "highest": "5,3647",
    "lower": "5,2963",
    "difference": "-0,34%"
  },
  {
    "date": "28.01.2019",
    "now": "5,3279",
    "open": "5,2585",
    "highest": "5,3432",
    "lower": "5,2432",
    "difference": "1,12%"
  },
  {
    "date": "25.01.2019",
    "now": "5,2688",
    "open": "5,2615",
    "highest": "5,2926",
    "lower": "5,2455",
    "difference": "0,07%"
  },
  {
    "date": "24.01.2019",
    "now": "5,2651",
    "open": "5,2849",
    "highest": "5,3017",
    "lower": "5,2446",
    "difference": "-0,40%"
  },
  {
    "date": "23.01.2019",
    "now": "5,2860",
    "open": "5,3397",
    "highest": "5,3578",
    "lower": "5,2727",
    "difference": "-1,08%"
  },
  {
    "date": "22.01.2019",
    "now": "5,3436",
    "open": "5,3265",
    "highest": "5,3731",
    "lower": "5,3216",
    "difference": "0,35%"
  },
  {
    "date": "21.01.2019",
    "now": "5,3247",
    "open": "5,3258",
    "highest": "5,3589",
    "lower": "5,3144",
    "difference": "-0,07%"
  },
  {
    "date": "18.01.2019",
    "now": "5,3283",
    "open": "5,3426",
    "highest": "5,3777",
    "lower": "5,3152",
    "difference": "-0,37%"
  },
  {
    "date": "17.01.2019",
    "now": "5,3480",
    "open": "5,3326",
    "highest": "5,3921",
    "lower": "5,3321",
    "difference": "0,22%"
  },
  {
    "date": "16.01.2019",
    "now": "5,3363",
    "open": "5,4500",
    "highest": "5,4559",
    "lower": "5,3263",
    "difference": "-2,03%"
  },
  {
    "date": "15.01.2019",
    "now": "5,4466",
    "open": "5,4461",
    "highest": "5,4715",
    "lower": "5,4219",
    "difference": "0,03%"
  },
  {
    "date": "14.01.2019",
    "now": "5,4447",
    "open": "5,4630",
    "highest": "5,5534",
    "lower": "5,4310",
    "difference": "-0,19%"
  },
  {
    "date": "11.01.2019",
    "now": "5,4550",
    "open": "5,4196",
    "highest": "5,5055",
    "lower": "5,4000",
    "difference": "0,71%"
  },
  {
    "date": "10.01.2019",
    "now": "5,4168",
    "open": "5,4801",
    "highest": "5,5083",
    "lower": "5,3975",
    "difference": "-1,10%"
  },
  {
    "date": "09.01.2019",
    "now": "5,4768",
    "open": "5,4805",
    "highest": "5,5486",
    "lower": "5,4375",
    "difference": "-0,08%"
  },
  {
    "date": "08.01.2019",
    "now": "5,4811",
    "open": "5,3814",
    "highest": "5,5155",
    "lower": "5,3740",
    "difference": "1,79%"
  },
  {
    "date": "07.01.2019",
    "now": "5,3848",
    "open": "5,3362",
    "highest": "5,4153",
    "lower": "5,3171",
    "difference": "1,01%"
  },
  {
    "date": "04.01.2019",
    "now": "5,3311",
    "open": "5,4587",
    "highest": "5,4778",
    "lower": "5,3058",
    "difference": "-2,48%"
  },
  {
    "date": "03.01.2019",
    "now": "5,4664",
    "open": "5,4002",
    "highest": "5,8300",
    "lower": "5,3857",
    "difference": "1,22%"
  },
  {
    "date": "02.01.2019",
    "now": "5,4003",
    "open": "5,3010",
    "highest": "5,4215",
    "lower": "5,2737",
    "difference": "2,02%"
  },
  {
    "date": "01.01.2019",
    "now": "5,2933",
    "open": "5,2896",
    "highest": "5,2933",
    "lower": "5,2540",
    "difference": "0,09%"
  },
  {
    "date": "31.12.2018",
    "now": "5,2887",
    "open": "5,2725",
    "highest": "5,3220",
    "lower": "5,2530",
    "difference": "0,31%"
  },
  {
    "date": "28.12.2018",
    "now": "5,2725",
    "open": "5,2850",
    "highest": "5,3008",
    "lower": "5,2430",
    "difference": "-0,24%"
  },
  {
    "date": "27.12.2018",
    "now": "5,2850",
    "open": "5,2749",
    "highest": "5,3073",
    "lower": "5,2644",
    "difference": "0,16%"
  },
  {
    "date": "26.12.2018",
    "now": "5,2766",
    "open": "5,2965",
    "highest": "5,3088",
    "lower": "5,2703",
    "difference": "-0,63%"
  },
  {
    "date": "25.12.2018",
    "now": "5,3101",
    "open": "5,3003",
    "highest": "5,3560",
    "lower": "5,2901",
    "difference": "0,40%"
  },
  {
    "date": "24.12.2018",
    "now": "5,2890",
    "open": "5,3197",
    "highest": "5,3251",
    "lower": "5,2762",
    "difference": "-0,55%"
  },
  {
    "date": "21.12.2018",
    "now": "5,3181",
    "open": "5,2619",
    "highest": "5,3213",
    "lower": "5,2300",
    "difference": "1,01%"
  },
  {
    "date": "20.12.2018",
    "now": "5,2649",
    "open": "5,2929",
    "highest": "5,3303",
    "lower": "5,2255",
    "difference": "-0,40%"
  },
  {
    "date": "19.12.2018",
    "now": "5,2860",
    "open": "5,3430",
    "highest": "5,3551",
    "lower": "5,1968",
    "difference": "-1,10%"
  },
  {
    "date": "18.12.2018",
    "now": "5,3450",
    "open": "5,3697",
    "highest": "5,3902",
    "lower": "5,3250",
    "difference": "-0,44%"
  },
  {
    "date": "17.12.2018",
    "now": "5,3686",
    "open": "5,3639",
    "highest": "5,3973",
    "lower": "5,3570",
    "difference": "0,10%"
  },
  {
    "date": "14.12.2018",
    "now": "5,3635",
    "open": "5,3352",
    "highest": "5,4219",
    "lower": "5,3301",
    "difference": "0,46%"
  },
  {
    "date": "13.12.2018",
    "now": "5,3392",
    "open": "5,3520",
    "highest": "5,3917",
    "lower": "5,2990",
    "difference": "-0,17%"
  },
  {
    "date": "12.12.2018",
    "now": "5,3482",
    "open": "5,3703",
    "highest": "5,4016",
    "lower": "5,3309",
    "difference": "-0,32%"
  },
  {
    "date": "11.12.2018",
    "now": "5,3653",
    "open": "5,3189",
    "highest": "5,4045",
    "lower": "5,3010",
    "difference": "0,76%"
  },
  {
    "date": "10.12.2018",
    "now": "5,3248",
    "open": "5,2993",
    "highest": "5,3580",
    "lower": "5,2666",
    "difference": "0,41%"
  },
  {
    "date": "07.12.2018",
    "now": "5,3029",
    "open": "5,3308",
    "highest": "5,3518",
    "lower": "5,2490",
    "difference": "-0,67%"
  },
  {
    "date": "06.12.2018",
    "now": "5,3386",
    "open": "5,3258",
    "highest": "5,4050",
    "lower": "5,3176",
    "difference": "0,23%"
  },
  {
    "date": "05.12.2018",
    "now": "5,3262",
    "open": "5,3833",
    "highest": "5,4528",
    "lower": "5,3020",
    "difference": "-1,14%"
  },
  {
    "date": "04.12.2018",
    "now": "5,3875",
    "open": "5,2550",
    "highest": "5,4623",
    "lower": "5,2332",
    "difference": "2,62%"
  },
  {
    "date": "03.12.2018",
    "now": "5,2501",
    "open": "5,2207",
    "highest": "5,2939",
    "lower": "5,1448",
    "difference": "0,72%"
  },
  {
    "date": "30.11.2018",
    "now": "5,2128",
    "open": "5,1625",
    "highest": "5,2571",
    "lower": "5,1350",
    "difference": "0,96%"
  },
  {
    "date": "29.11.2018",
    "now": "5,1631",
    "open": "5,2311",
    "highest": "5,2389",
    "lower": "5,1322",
    "difference": "-1,13%"
  },
  {
    "date": "28.11.2018",
    "now": "5,2219",
    "open": "5,2789",
    "highest": "5,2829",
    "lower": "5,2097",
    "difference": "-0,94%"
  },
  {
    "date": "27.11.2018",
    "now": "5,2716",
    "open": "5,2472",
    "highest": "5,3003",
    "lower": "5,2153",
    "difference": "0,46%"
  },
  {
    "date": "26.11.2018",
    "now": "5,2477",
    "open": "5,2877",
    "highest": "5,3009",
    "lower": "5,2110",
    "difference": "-0,75%"
  },
  {
    "date": "23.11.2018",
    "now": "5,2875",
    "open": "5,2870",
    "highest": "5,3121",
    "lower": "5,2520",
    "difference": "-0,16%"
  },
  {
    "date": "22.11.2018",
    "now": "5,2960",
    "open": "5,3121",
    "highest": "5,3517",
    "lower": "5,2730",
    "difference": "-0,23%"
  },
  {
    "date": "21.11.2018",
    "now": "5,3080",
    "open": "5,3768",
    "highest": "5,4008",
    "lower": "5,2787",
    "difference": "-1,29%"
  },
  {
    "date": "20.11.2018",
    "now": "5,3776",
    "open": "5,2995",
    "highest": "5,4387",
    "lower": "5,2970",
    "difference": "1,32%"
  },
  {
    "date": "19.11.2018",
    "now": "5,3075",
    "open": "5,3397",
    "highest": "5,3734",
    "lower": "5,2950",
    "difference": "-0,46%"
  },
  {
    "date": "16.11.2018",
    "now": "5,3318",
    "open": "5,3482",
    "highest": "5,3951",
    "lower": "5,3033",
    "difference": "-0,30%"
  },
  {
    "date": "15.11.2018",
    "now": "5,3481",
    "open": "5,4610",
    "highest": "5,4715",
    "lower": "5,3024",
    "difference": "-2,09%"
  },
  {
    "date": "14.11.2018",
    "now": "5,4624",
    "open": "5,4827",
    "highest": "5,5013",
    "lower": "5,4456",
    "difference": "-0,28%"
  },
  {
    "date": "13.11.2018",
    "now": "5,4776",
    "open": "5,4646",
    "highest": "5,5299",
    "lower": "5,4410",
    "difference": "0,16%"
  },
  {
    "date": "12.11.2018",
    "now": "5,4686",
    "open": "5,4678",
    "highest": "5,5238",
    "lower": "5,4231",
    "difference": "0,15%"
  },
  {
    "date": "09.11.2018",
    "now": "5,4606",
    "open": "5,4500",
    "highest": "5,5421",
    "lower": "5,4285",
    "difference": "0,04%"
  },
  {
    "date": "08.11.2018",
    "now": "5,4583",
    "open": "5,3569",
    "highest": "5,4762",
    "lower": "5,3540",
    "difference": "1,81%"
  },
  {
    "date": "07.11.2018",
    "now": "5,3612",
    "open": "5,3621",
    "highest": "5,4179",
    "lower": "5,3175",
    "difference": "0,10%"
  },
  {
    "date": "06.11.2018",
    "now": "5,3560",
    "open": "5,3129",
    "highest": "5,4181",
    "lower": "5,2940",
    "difference": "0,80%"
  },
  {
    "date": "05.11.2018",
    "now": "5,3134",
    "open": "5,4296",
    "highest": "5,4755",
    "lower": "5,2990",
    "difference": "-2,14%"
  },
  {
    "date": "02.11.2018",
    "now": "5,4296",
    "open": "5,5085",
    "highest": "5,5279",
    "lower": "5,3980",
    "difference": "-1,49%"
  },
  {
    "date": "01.11.2018",
    "now": "5,5118",
    "open": "5,5867",
    "highest": "5,6525",
    "lower": "5,5013",
    "difference": "-1,28%"
  },
  {
    "date": "31.10.2018",
    "now": "5,5835",
    "open": "5,4680",
    "highest": "5,6322",
    "lower": "5,4612",
    "difference": "1,99%"
  },
  {
    "date": "30.10.2018",
    "now": "5,4746",
    "open": "5,5677",
    "highest": "5,5692",
    "lower": "5,4608",
    "difference": "-1,56%"
  },
  {
    "date": "29.10.2018",
    "now": "5,5611",
    "open": "5,5969",
    "highest": "5,6037",
    "lower": "5,5072",
    "difference": "-0,57%"
  },
  {
    "date": "26.10.2018",
    "now": "5,5929",
    "open": "5,6353",
    "highest": "5,6578",
    "lower": "5,5626",
    "difference": "-0,74%"
  },
  {
    "date": "25.10.2018",
    "now": "5,6345",
    "open": "5,7041",
    "highest": "5,7417",
    "lower": "5,6122",
    "difference": "-1,19%"
  },
  {
    "date": "24.10.2018",
    "now": "5,7023",
    "open": "5,7469",
    "highest": "5,7784",
    "lower": "5,6531",
    "difference": "-0,60%"
  },
  {
    "date": "23.10.2018",
    "now": "5,7370",
    "open": "5,6683",
    "highest": "5,8780",
    "lower": "5,6650",
    "difference": "1,20%"
  },
  {
    "date": "22.10.2018",
    "now": "5,6689",
    "open": "5,6521",
    "highest": "5,6958",
    "lower": "5,6145",
    "difference": "0,47%"
  },
  {
    "date": "19.10.2018",
    "now": "5,6425",
    "open": "5,6345",
    "highest": "5,7005",
    "lower": "5,5800",
    "difference": "0,00%"
  },
  {
    "date": "18.10.2018",
    "now": "5,6425",
    "open": "5,5765",
    "highest": "5,6831",
    "lower": "5,5093",
    "difference": "1,06%"
  },
  {
    "date": "17.10.2018",
    "now": "5,5835",
    "open": "5,6815",
    "highest": "5,7207",
    "lower": "5,5285",
    "difference": "-1,79%"
  },
  {
    "date": "16.10.2018",
    "now": "5,6855",
    "open": "5,7896",
    "highest": "5,8115",
    "lower": "5,6623",
    "difference": "-1,75%"
  },
  {
    "date": "15.10.2018",
    "now": "5,7867",
    "open": "5,8698",
    "highest": "5,9051",
    "lower": "5,7424",
    "difference": "-1,45%"
  },
  {
    "date": "12.10.2018",
    "now": "5,8721",
    "open": "5,9253",
    "highest": "5,9845",
    "lower": "5,8068",
    "difference": "-0,91%"
  },
  {
    "date": "11.10.2018",
    "now": "5,9258",
    "open": "6,0720",
    "highest": "6,0849",
    "lower": "5,8945",
    "difference": "-2,47%"
  },
  {
    "date": "10.10.2018",
    "now": "6,0760",
    "open": "6,1042",
    "highest": "6,1357",
    "lower": "5,9971",
    "difference": "-0,41%"
  },
  {
    "date": "09.10.2018",
    "now": "6,1011",
    "open": "6,1064",
    "highest": "6,1604",
    "lower": "6,0610",
    "difference": "-0,16%"
  },
  {
    "date": "08.10.2018",
    "now": "6,1106",
    "open": "6,1380",
    "highest": "6,1948",
    "lower": "6,0908",
    "difference": "-0,37%"
  },
  {
    "date": "05.10.2018",
    "now": "6,1333",
    "open": "6,1520",
    "highest": "6,2123",
    "lower": "6,0700",
    "difference": "-0,48%"
  },
  {
    "date": "04.10.2018",
    "now": "6,1627",
    "open": "6,0390",
    "highest": "6,2332",
    "lower": "6,0339",
    "difference": "1,93%"
  },
  {
    "date": "03.10.2018",
    "now": "6,0458",
    "open": "5,9730",
    "highest": "6,0931",
    "lower": "5,9530",
    "difference": "1,02%"
  },
  {
    "date": "02.10.2018",
    "now": "5,9846",
    "open": "5,9315",
    "highest": "6,0594",
    "lower": "5,9005",
    "difference": "0,82%"
  },
  {
    "date": "01.10.2018",
    "now": "5,9360",
    "open": "6,0670",
    "highest": "6,0792",
    "lower": "5,8870",
    "difference": "-1,98%"
  },
  {
    "date": "28.09.2018",
    "now": "6,0560",
    "open": "6,0093",
    "highest": "6,0942",
    "lower": "5,9320",
    "difference": "0,80%"
  },
  {
    "date": "27.09.2018",
    "now": "6,0080",
    "open": "6,1218",
    "highest": "6,1499",
    "lower": "5,9460",
    "difference": "-1,62%"
  },
  {
    "date": "26.09.2018",
    "now": "6,1070",
    "open": "6,1570",
    "highest": "6,2171",
    "lower": "6,0520",
    "difference": "-0,89%"
  },
  {
    "date": "25.09.2018",
    "now": "6,1618",
    "open": "6,1320",
    "highest": "6,2244",
    "lower": "6,0370",
    "difference": "0,15%"
  },
  {
    "date": "24.09.2018",
    "now": "6,1524",
    "open": "6,2422",
    "highest": "6,3361",
    "lower": "6,0348",
    "difference": "-2,25%"
  },
  {
    "date": "21.09.2018",
    "now": "6,2937",
    "open": "6,2006",
    "highest": "6,3071",
    "lower": "6,1790",
    "difference": "1,58%"
  },
  {
    "date": "20.09.2018",
    "now": "6,1960",
    "open": "6,2639",
    "highest": "6,3907",
    "lower": "6,1180",
    "difference": "-0,85%"
  },
  {
    "date": "19.09.2018",
    "now": "6,2493",
    "open": "6,3887",
    "highest": "6,4205",
    "lower": "6,2119",
    "difference": "-2,12%"
  },
  {
    "date": "18.09.2018",
    "now": "6,3846",
    "open": "6,3258",
    "highest": "6,4803",
    "lower": "6,3064",
    "difference": "1,11%"
  },
  {
    "date": "17.09.2018",
    "now": "6,3144",
    "open": "6,1809",
    "highest": "6,3292",
    "lower": "6,1363",
    "difference": "2,34%"
  },
  {
    "date": "14.09.2018",
    "now": "6,1703",
    "open": "6,0640",
    "highest": "6,1911",
    "lower": "5,9820",
    "difference": "1,47%"
  },
  {
    "date": "13.09.2018",
    "now": "6,0812",
    "open": "6,3549",
    "highest": "6,5653",
    "lower": "5,9989",
    "difference": "-4,11%"
  },
  {
    "date": "12.09.2018",
    "now": "6,3420",
    "open": "6,4270",
    "highest": "6,4821",
    "lower": "6,3110",
    "difference": "-1,37%"
  },
  {
    "date": "11.09.2018",
    "now": "6,4301",
    "open": "6,4705",
    "highest": "6,5002",
    "lower": "6,4133",
    "difference": "-0,49%"
  },
  {
    "date": "10.09.2018",
    "now": "6,4616",
    "open": "6,3960",
    "highest": "6,5071",
    "lower": "6,3793",
    "difference": "1,01%"
  },
  {
    "date": "07.09.2018",
    "now": "6,3970",
    "open": "6,5810",
    "highest": "6,6201",
    "lower": "6,3615",
    "difference": "-2,82%"
  },
  {
    "date": "06.09.2018",
    "now": "6,5827",
    "open": "6,6105",
    "highest": "6,6589",
    "lower": "6,5339",
    "difference": "-0,28%"
  },
  {
    "date": "05.09.2018",
    "now": "6,6012",
    "open": "6,6753",
    "highest": "6,7418",
    "lower": "6,5790",
    "difference": "-1,05%"
  },
  {
    "date": "04.09.2018",
    "now": "6,6711",
    "open": "6,6200",
    "highest": "6,7251",
    "lower": "6,5654",
    "difference": "0,56%"
  },
  {
    "date": "03.09.2018",
    "now": "6,6340",
    "open": "6,5299",
    "highest": "6,7324",
    "lower": "6,4890",
    "difference": "1,47%"
  },
  {
    "date": "31.08.2018",
    "now": "6,5380",
    "open": "6,6740",
    "highest": "6,8125",
    "lower": "6,3765",
    "difference": "-1,71%"
  },
  {
    "date": "30.08.2018",
    "now": "6,6519",
    "open": "6,4520",
    "highest": "6,8350",
    "lower": "6,4021",
    "difference": "2,73%"
  },
  {
    "date": "29.08.2018",
    "now": "6,4752",
    "open": "6,3026",
    "highest": "6,5138",
    "lower": "6,2447",
    "difference": "3,22%"
  },
  {
    "date": "28.08.2018",
    "now": "6,2730",
    "open": "6,1456",
    "highest": "6,3130",
    "lower": "6,1075",
    "difference": "2,47%"
  },
  {
    "date": "27.08.2018",
    "now": "6,1217",
    "open": "6,0058",
    "highest": "6,2978",
    "lower": "5,9629",
    "difference": "1,91%"
  },
  {
    "date": "24.08.2018",
    "now": "6,0068",
    "open": "6,0968",
    "highest": "6,1357",
    "lower": "5,9811",
    "difference": "-1,92%"
  },
  {
    "date": "23.08.2018",
    "now": "6,1247",
    "open": "6,0564",
    "highest": "6,1909",
    "lower": "6,0276",
    "difference": "1,21%"
  },
  {
    "date": "22.08.2018",
    "now": "6,0512",
    "open": "6,0718",
    "highest": "6,1369",
    "lower": "6,0219",
    "difference": "-0,40%"
  },
  {
    "date": "21.08.2018",
    "now": "6,0757",
    "open": "6,1054",
    "highest": "6,1797",
    "lower": "6,0170",
    "difference": "-0,08%"
  },
  {
    "date": "20.08.2018",
    "now": "6,0808",
    "open": "6,0280",
    "highest": "6,2000",
    "lower": "5,9520",
    "difference": "1,11%"
  },
  {
    "date": "17.08.2018",
    "now": "6,0140",
    "open": "5,8200",
    "highest": "6,3416",
    "lower": "5,7180",
    "difference": "3,21%"
  },
  {
    "date": "16.08.2018",
    "now": "5,8270",
    "open": "5,9280",
    "highest": "6,0410",
    "lower": "5,6675",
    "difference": "-2,73%"
  },
  {
    "date": "15.08.2018",
    "now": "5,9905",
    "open": "6,3401",
    "highest": "6,5955",
    "lower": "5,8600",
    "difference": "-5,73%"
  },
  {
    "date": "14.08.2018",
    "now": "6,3544",
    "open": "6,8868",
    "highest": "6,9668",
    "lower": "6,2804",
    "difference": "-7,69%"
  },
  {
    "date": "13.08.2018",
    "now": "6,8834",
    "open": "6,4362",
    "highest": "7,2393",
    "lower": "6,4362",
    "difference": "7,09%"
  },
  {
    "date": "10.08.2018",
    "now": "6,4275",
    "open": "5,5450",
    "highest": "6,8020",
    "lower": "5,5300",
    "difference": "15,90%"
  },
  {
    "date": "09.08.2018",
    "now": "5,5457",
    "open": "5,2840",
    "highest": "5,5720",
    "lower": "5,2777",
    "difference": "5,03%"
  },
  {
    "date": "08.08.2018",
    "now": "5,2800",
    "open": "5,2310",
    "highest": "5,3112",
    "lower": "5,2200",
    "difference": "0,68%"
  },
  {
    "date": "07.08.2018",
    "now": "5,2443",
    "open": "5,3275",
    "highest": "5,3696",
    "lower": "5,1725",
    "difference": "-1,61%"
  },
  {
    "date": "06.08.2018",
    "now": "5,3301",
    "open": "5,0798",
    "highest": "5,4265",
    "lower": "5,0798",
    "difference": "4,89%"
  },
  {
    "date": "03.08.2018",
    "now": "5,0815",
    "open": "5,0655",
    "highest": "5,1135",
    "lower": "5,0528",
    "difference": "0,31%"
  },
  {
    "date": "02.08.2018",
    "now": "5,0660",
    "open": "4,9924",
    "highest": "5,0944",
    "lower": "4,9591",
    "difference": "1,42%"
  },
  {
    "date": "01.08.2018",
    "now": "4,9950",
    "open": "4,9137",
    "highest": "5,0183",
    "lower": "4,9087",
    "difference": "1,64%"
  },
  {
    "date": "31.07.2018",
    "now": "4,9142",
    "open": "4,8845",
    "highest": "4,9324",
    "lower": "4,8734",
    "difference": "0,65%"
  },
  {
    "date": "30.07.2018",
    "now": "4,8823",
    "open": "4,8459",
    "highest": "4,9104",
    "lower": "4,8407",
    "difference": "0,61%"
  },
  {
    "date": "27.07.2018",
    "now": "4,8529",
    "open": "4,8644",
    "highest": "4,8830",
    "lower": "4,8340",
    "difference": "-0,25%"
  },
  {
    "date": "26.07.2018",
    "now": "4,8649",
    "open": "4,7705",
    "highest": "4,8845",
    "lower": "4,7660",
    "difference": "1,93%"
  },
  {
    "date": "25.07.2018",
    "now": "4,7728",
    "open": "4,8883",
    "highest": "4,8924",
    "lower": "4,7728",
    "difference": "-2,32%"
  },
  {
    "date": "24.07.2018",
    "now": "4,8861",
    "open": "4,7415",
    "highest": "4,9403",
    "lower": "4,7345",
    "difference": "3,09%"
  },
  {
    "date": "23.07.2018",
    "now": "4,7395",
    "open": "4,7939",
    "highest": "4,7970",
    "lower": "4,7305",
    "difference": "-1,11%"
  },
  {
    "date": "20.07.2018",
    "now": "4,7927",
    "open": "4,8065",
    "highest": "4,8269",
    "lower": "4,7630",
    "difference": "-0,29%"
  },
  {
    "date": "19.07.2018",
    "now": "4,8066",
    "open": "4,7970",
    "highest": "4,8453",
    "lower": "4,7875",
    "difference": "0,24%"
  },
  {
    "date": "18.07.2018",
    "now": "4,7952",
    "open": "4,8074",
    "highest": "4,8474",
    "lower": "4,7624",
    "difference": "-0,24%"
  },
  {
    "date": "17.07.2018",
    "now": "4,8065",
    "open": "4,8451",
    "highest": "4,8606",
    "lower": "4,7755",
    "difference": "-0,82%"
  },
  {
    "date": "16.07.2018",
    "now": "4,8463",
    "open": "4,8435",
    "highest": "4,8680",
    "lower": "4,8180",
    "difference": "-0,18%"
  },
  {
    "date": "13.07.2018",
    "now": "4,8552",
    "open": "4,8545",
    "highest": "4,8753",
    "lower": "4,8066",
    "difference": "0,00%"
  },
  {
    "date": "12.07.2018",
    "now": "4,8552",
    "open": "4,8735",
    "highest": "4,9721",
    "lower": "4,7792",
    "difference": "-0,43%"
  },
  {
    "date": "11.07.2018",
    "now": "4,8762",
    "open": "4,7035",
    "highest": "4,8789",
    "lower": "4,6923",
    "difference": "3,58%"
  },
  {
    "date": "10.07.2018",
    "now": "4,7077",
    "open": "4,7358",
    "highest": "4,7588",
    "lower": "4,6448",
    "difference": "-0,55%"
  },
  {
    "date": "09.07.2018",
    "now": "4,7338",
    "open": "4,5694",
    "highest": "4,7488",
    "lower": "4,5060",
    "difference": "3,58%"
  },
  {
    "date": "06.07.2018",
    "now": "4,5704",
    "open": "4,5935",
    "highest": "4,6198",
    "lower": "4,5684",
    "difference": "-0,48%"
  },
  {
    "date": "05.07.2018",
    "now": "4,5924",
    "open": "4,6692",
    "highest": "4,6890",
    "lower": "4,5814",
    "difference": "-1,59%"
  },
  {
    "date": "04.07.2018",
    "now": "4,6667",
    "open": "4,6720",
    "highest": "4,7234",
    "lower": "4,6590",
    "difference": "-0,08%"
  },
  {
    "date": "03.07.2018",
    "now": "4,6705",
    "open": "4,6175",
    "highest": "4,6881",
    "lower": "4,6080",
    "difference": "1,18%"
  },
  {
    "date": "02.07.2018",
    "now": "4,6161",
    "open": "4,5908",
    "highest": "4,6448",
    "lower": "4,5813",
    "difference": "0,63%"
  },
  {
    "date": "29.06.2018",
    "now": "4,5872",
    "open": "4,5830",
    "highest": "4,6111",
    "lower": "4,5445",
    "difference": "0,04%"
  },
  {
    "date": "28.06.2018",
    "now": "4,5853",
    "open": "4,6245",
    "highest": "4,6535",
    "lower": "4,5733",
    "difference": "-0,80%"
  },
  {
    "date": "27.06.2018",
    "now": "4,6225",
    "open": "4,6168",
    "highest": "4,6590",
    "lower": "4,5895",
    "difference": "0,15%"
  },
  {
    "date": "26.06.2018",
    "now": "4,6155",
    "open": "4,6792",
    "highest": "4,7169",
    "lower": "4,6045",
    "difference": "-1,40%"
  },
  {
    "date": "25.06.2018",
    "now": "4,6810",
    "open": "4,6600",
    "highest": "4,7249",
    "lower": "4,5350",
    "difference": "0,08%"
  },
  {
    "date": "22.06.2018",
    "now": "4,6773",
    "open": "4,7185",
    "highest": "4,7462",
    "lower": "4,6585",
    "difference": "-0,96%"
  },
  {
    "date": "21.06.2018",
    "now": "4,7225",
    "open": "4,7312",
    "highest": "4,7700",
    "lower": "4,7151",
    "difference": "-0,22%"
  },
  {
    "date": "20.06.2018",
    "now": "4,7327",
    "open": "4,7319",
    "highest": "4,7696",
    "lower": "4,7220",
    "difference": "-0,16%"
  },
  {
    "date": "19.06.2018",
    "now": "4,7402",
    "open": "4,7055",
    "highest": "4,7763",
    "lower": "4,6860",
    "difference": "0,77%"
  },
  {
    "date": "18.06.2018",
    "now": "4,7042",
    "open": "4,7272",
    "highest": "4,7458",
    "lower": "4,6730",
    "difference": "-0,55%"
  },
  {
    "date": "15.06.2018",
    "now": "4,7301",
    "open": "4,7267",
    "highest": "4,7602",
    "lower": "4,7073",
    "difference": "0,09%"
  },
  {
    "date": "14.06.2018",
    "now": "4,7259",
    "open": "4,6319",
    "highest": "4,7329",
    "lower": "4,5910",
    "difference": "1,74%"
  },
  {
    "date": "13.06.2018",
    "now": "4,6453",
    "open": "4,5953",
    "highest": "4,6995",
    "lower": "4,5813",
    "difference": "1,04%"
  },
  {
    "date": "12.06.2018",
    "now": "4,5976",
    "open": "4,5229",
    "highest": "4,5998",
    "lower": "4,5191",
    "difference": "1,63%"
  },
  {
    "date": "11.06.2018",
    "now": "4,5240",
    "open": "4,4774",
    "highest": "4,5420",
    "lower": "4,4610",
    "difference": "1,12%"
  },
  {
    "date": "08.06.2018",
    "now": "4,4740",
    "open": "4,4800",
    "highest": "4,5404",
    "lower": "4,4591",
    "difference": "-0,23%"
  },
  {
    "date": "07.06.2018",
    "now": "4,4844",
    "open": "4,5537",
    "highest": "4,5872",
    "lower": "4,4510",
    "difference": "-1,56%"
  },
  {
    "date": "06.06.2018",
    "now": "4,5554",
    "open": "4,5980",
    "highest": "4,6290",
    "lower": "4,5358",
    "difference": "-0,94%"
  },
  {
    "date": "05.06.2018",
    "now": "4,5985",
    "open": "4,5903",
    "highest": "4,6337",
    "lower": "4,5805",
    "difference": "0,14%"
  },
  {
    "date": "04.06.2018",
    "now": "4,5921",
    "open": "4,6495",
    "highest": "4,6791",
    "lower": "4,5735",
    "difference": "-1,26%"
  },
  {
    "date": "01.06.2018",
    "now": "4,6508",
    "open": "4,5240",
    "highest": "4,6574",
    "lower": "4,5140",
    "difference": "2,79%"
  },
  {
    "date": "31.05.2018",
    "now": "4,5245",
    "open": "4,4590",
    "highest": "4,5463",
    "lower": "4,4495",
    "difference": "1,33%"
  },
  {
    "date": "30.05.2018",
    "now": "4,4650",
    "open": "4,5483",
    "highest": "4,5641",
    "lower": "4,4410",
    "difference": "-1,84%"
  },
  {
    "date": "29.05.2018",
    "now": "4,5488",
    "open": "4,5770",
    "highest": "4,6358",
    "lower": "4,5280",
    "difference": "-0,73%"
  },
  {
    "date": "28.05.2018",
    "now": "4,5822",
    "open": "4,7130",
    "highest": "4,7214",
    "lower": "4,5495",
    "difference": "-2,67%"
  },
  {
    "date": "25.05.2018",
    "now": "4,7081",
    "open": "4,7090",
    "highest": "4,8030",
    "lower": "4,6818",
    "difference": "0,02%"
  },
  {
    "date": "24.05.2018",
    "now": "4,7073",
    "open": "4,5763",
    "highest": "4,8032",
    "lower": "4,5380",
    "difference": "2,86%"
  },
  {
    "date": "23.05.2018",
    "now": "4,5762",
    "open": "4,6660",
    "highest": "4,9241",
    "lower": "4,5395",
    "difference": "-1,99%"
  },
  {
    "date": "22.05.2018",
    "now": "4,6691",
    "open": "4,5744",
    "highest": "4,6738",
    "lower": "4,5375",
    "difference": "2,06%"
  },
  {
    "date": "21.05.2018",
    "now": "4,5749",
    "open": "4,4902",
    "highest": "4,6000",
    "lower": "4,4864",
    "difference": "1,85%"
  },
  {
    "date": "18.05.2018",
    "now": "4,4917",
    "open": "4,4570",
    "highest": "4,5060",
    "lower": "4,4365",
    "difference": "0,70%"
  },
  {
    "date": "17.05.2018",
    "now": "4,4606",
    "open": "4,4110",
    "highest": "4,4674",
    "lower": "4,4095",
    "difference": "1,06%"
  },
  {
    "date": "16.05.2018",
    "now": "4,4139",
    "open": "4,4430",
    "highest": "4,5015",
    "lower": "4,3900",
    "difference": "-0,70%"
  },
  {
    "date": "15.05.2018",
    "now": "4,4450",
    "open": "4,3689",
    "highest": "4,4770",
    "lower": "4,3470",
    "difference": "1,78%"
  },
  {
    "date": "14.05.2018",
    "now": "4,3674",
    "open": "4,3139",
    "highest": "4,3714",
    "lower": "4,3000",
    "difference": "1,25%"
  },
  {
    "date": "11.05.2018",
    "now": "4,3136",
    "open": "4,2347",
    "highest": "4,3180",
    "lower": "4,2261",
    "difference": "1,85%"
  },
  {
    "date": "10.05.2018",
    "now": "4,2352",
    "open": "4,2871",
    "highest": "4,3084",
    "lower": "4,2197",
    "difference": "-1,22%"
  },
  {
    "date": "09.05.2018",
    "now": "4,2876",
    "open": "4,3290",
    "highest": "4,3746",
    "lower": "4,2510",
    "difference": "-1,04%"
  },
  {
    "date": "08.05.2018",
    "now": "4,3327",
    "open": "4,2664",
    "highest": "4,3382",
    "lower": "4,2565",
    "difference": "1,54%"
  },
  {
    "date": "07.05.2018",
    "now": "4,2669",
    "open": "4,2260",
    "highest": "4,2729",
    "lower": "4,2210",
    "difference": "0,97%"
  },
  {
    "date": "04.05.2018",
    "now": "4,2260",
    "open": "4,2153",
    "highest": "4,2921",
    "lower": "4,2137",
    "difference": "0,31%"
  },
  {
    "date": "03.05.2018",
    "now": "4,2131",
    "open": "4,1772",
    "highest": "4,2450",
    "lower": "4,1522",
    "difference": "0,86%"
  },
  {
    "date": "02.05.2018",
    "now": "4,1771",
    "open": "4,1028",
    "highest": "4,1876",
    "lower": "4,0886",
    "difference": "1,81%"
  },
  {
    "date": "01.05.2018",
    "now": "4,1030",
    "open": "4,0610",
    "highest": "4,1254",
    "lower": "4,0530",
    "difference": "1,02%"
  },
  {
    "date": "30.04.2018",
    "now": "4,0617",
    "open": "4,0441",
    "highest": "4,0740",
    "lower": "4,0245",
    "difference": "0,48%"
  },
  {
    "date": "27.04.2018",
    "now": "4,0422",
    "open": "4,0659",
    "highest": "4,0800",
    "lower": "4,0350",
    "difference": "-0,60%"
  },
  {
    "date": "26.04.2018",
    "now": "4,0664",
    "open": "4,0813",
    "highest": "4,0863",
    "lower": "4,0545",
    "difference": "-0,36%"
  },
  {
    "date": "25.04.2018",
    "now": "4,0809",
    "open": "4,0866",
    "highest": "4,1116",
    "lower": "4,0325",
    "difference": "-0,12%"
  },
  {
    "date": "24.04.2018",
    "now": "4,0860",
    "open": "4,1077",
    "highest": "4,1144",
    "lower": "4,0775",
    "difference": "-0,54%"
  },
  {
    "date": "23.04.2018",
    "now": "4,1080",
    "open": "4,0766",
    "highest": "4,1111",
    "lower": "4,0614",
    "difference": "0,77%"
  },
  {
    "date": "20.04.2018",
    "now": "4,0766",
    "open": "4,0398",
    "highest": "4,0790",
    "lower": "4,0225",
    "difference": "0,90%"
  },
  {
    "date": "19.04.2018",
    "now": "4,0403",
    "open": "4,0078",
    "highest": "4,0500",
    "lower": "4,0055",
    "difference": "0,79%"
  },
  {
    "date": "18.04.2018",
    "now": "4,0086",
    "open": "4,0941",
    "highest": "4,1086",
    "lower": "4,0037",
    "difference": "-2,17%"
  },
  {
    "date": "17.04.2018",
    "now": "4,0976",
    "open": "4,0967",
    "highest": "4,1266",
    "lower": "4,0697",
    "difference": "0,03%"
  },
  {
    "date": "16.04.2018",
    "now": "4,0963",
    "open": "4,0984",
    "highest": "4,1213",
    "lower": "4,0865",
    "difference": "-0,01%"
  },
  {
    "date": "13.04.2018",
    "now": "4,0969",
    "open": "4,1097",
    "highest": "4,1173",
    "lower": "4,0650",
    "difference": "-0,32%"
  },
  {
    "date": "12.04.2018",
    "now": "4,1102",
    "open": "4,1308",
    "highest": "4,1615",
    "lower": "4,0813",
    "difference": "-0,62%"
  },
  {
    "date": "11.04.2018",
    "now": "4,1360",
    "open": "4,1120",
    "highest": "4,1950",
    "lower": "4,1067",
    "difference": "0,58%"
  },
  {
    "date": "10.04.2018",
    "now": "4,1121",
    "open": "4,0715",
    "highest": "4,1393",
    "lower": "4,0530",
    "difference": "0,94%"
  },
  {
    "date": "09.04.2018",
    "now": "4,0737",
    "open": "4,0410",
    "highest": "4,0761",
    "lower": "4,0315",
    "difference": "0,71%"
  },
  {
    "date": "06.04.2018",
    "now": "4,0449",
    "open": "4,0531",
    "highest": "4,0680",
    "lower": "4,0263",
    "difference": "-0,16%"
  },
  {
    "date": "05.04.2018",
    "now": "4,0515",
    "open": "3,9970",
    "highest": "4,0538",
    "lower": "3,9942",
    "difference": "1,31%"
  },
  {
    "date": "04.04.2018",
    "now": "3,9991",
    "open": "3,9894",
    "highest": "4,0290",
    "lower": "3,9832",
    "difference": "0,26%"
  },
  {
    "date": "03.04.2018",
    "now": "3,9887",
    "open": "3,9719",
    "highest": "3,9950",
    "lower": "3,9670",
    "difference": "0,38%"
  },
  {
    "date": "02.04.2018",
    "now": "3,9735",
    "open": "3,9542",
    "highest": "3,9808",
    "lower": "3,9496",
    "difference": "0,46%"
  },
  {
    "date": "30.03.2018",
    "now": "3,9552",
    "open": "3,9426",
    "highest": "3,9613",
    "lower": "3,9370",
    "difference": "0,33%"
  },
  {
    "date": "29.03.2018",
    "now": "3,9422",
    "open": "4,0080",
    "highest": "4,0163",
    "lower": "3,9325",
    "difference": "-1,70%"
  },
  {
    "date": "28.03.2018",
    "now": "4,0103",
    "open": "3,9822",
    "highest": "4,0169",
    "lower": "3,9772",
    "difference": "0,71%"
  },
  {
    "date": "27.03.2018",
    "now": "3,9819",
    "open": "3,9657",
    "highest": "3,9981",
    "lower": "3,9579",
    "difference": "0,41%"
  },
  {
    "date": "26.03.2018",
    "now": "3,9657",
    "open": "3,9803",
    "highest": "3,9963",
    "lower": "3,9524",
    "difference": "-0,42%"
  },
  {
    "date": "23.03.2018",
    "now": "3,9824",
    "open": "3,9311",
    "highest": "4,0356",
    "lower": "3,9311",
    "difference": "1,22%"
  },
  {
    "date": "22.03.2018",
    "now": "3,9343",
    "open": "3,9097",
    "highest": "3,9458",
    "lower": "3,8969",
    "difference": "0,66%"
  },
  {
    "date": "21.03.2018",
    "now": "3,9085",
    "open": "3,9350",
    "highest": "3,9407",
    "lower": "3,9062",
    "difference": "-0,65%"
  },
  {
    "date": "20.03.2018",
    "now": "3,9339",
    "open": "3,9356",
    "highest": "3,9535",
    "lower": "3,9180",
    "difference": "-0,06%"
  },
  {
    "date": "19.03.2018",
    "now": "3,9362",
    "open": "3,9119",
    "highest": "3,9546",
    "lower": "3,9119",
    "difference": "0,42%"
  },
  {
    "date": "16.03.2018",
    "now": "3,9196",
    "open": "3,8955",
    "highest": "3,9266",
    "lower": "3,8875",
    "difference": "0,62%"
  },
  {
    "date": "15.03.2018",
    "now": "3,8956",
    "open": "3,8791",
    "highest": "3,9070",
    "lower": "3,8721",
    "difference": "0,41%"
  },
  {
    "date": "14.03.2018",
    "now": "3,8796",
    "open": "3,8731",
    "highest": "3,8954",
    "lower": "3,8524",
    "difference": "0,16%"
  },
  {
    "date": "13.03.2018",
    "now": "3,8733",
    "open": "3,8439",
    "highest": "3,8754",
    "lower": "3,8325",
    "difference": "0,77%"
  },
  {
    "date": "12.03.2018",
    "now": "3,8438",
    "open": "3,8102",
    "highest": "3,8525",
    "lower": "3,8037",
    "difference": "0,86%"
  },
  {
    "date": "09.03.2018",
    "now": "3,8111",
    "open": "3,8238",
    "highest": "3,8290",
    "lower": "3,8000",
    "difference": "-0,33%"
  },
  {
    "date": "08.03.2018",
    "now": "3,8236",
    "open": "3,7994",
    "highest": "3,8285",
    "lower": "3,7977",
    "difference": "0,55%"
  },
  {
    "date": "07.03.2018",
    "now": "3,8027",
    "open": "3,7929",
    "highest": "3,8098",
    "lower": "3,7876",
    "difference": "0,22%"
  },
  {
    "date": "06.03.2018",
    "now": "3,7942",
    "open": "3,8078",
    "highest": "3,8131",
    "lower": "3,7827",
    "difference": "-0,37%"
  },
  {
    "date": "05.03.2018",
    "now": "3,8084",
    "open": "3,8074",
    "highest": "3,8296",
    "lower": "3,8038",
    "difference": "0,03%"
  },
  {
    "date": "02.03.2018",
    "now": "3,8071",
    "open": "3,8057",
    "highest": "3,8252",
    "lower": "3,7990",
    "difference": "0,04%"
  },
  {
    "date": "01.03.2018",
    "now": "3,8056",
    "open": "3,7996",
    "highest": "3,8210",
    "lower": "3,7939",
    "difference": "0,18%"
  },
  {
    "date": "28.02.2018",
    "now": "3,7988",
    "open": "3,8151",
    "highest": "3,8169",
    "lower": "3,7925",
    "difference": "-0,44%"
  },
  {
    "date": "27.02.2018",
    "now": "3,8155",
    "open": "3,7852",
    "highest": "3,8160",
    "lower": "3,7780",
    "difference": "0,77%"
  },
  {
    "date": "26.02.2018",
    "now": "3,7864",
    "open": "3,7879",
    "highest": "3,7985",
    "lower": "3,7729",
    "difference": "-0,11%"
  },
  {
    "date": "23.02.2018",
    "now": "3,7905",
    "open": "3,7845",
    "highest": "3,7965",
    "lower": "3,7760",
    "difference": "0,16%"
  },
  {
    "date": "22.02.2018",
    "now": "3,7843",
    "open": "3,7867",
    "highest": "3,8113",
    "lower": "3,7782",
    "difference": "-0,13%"
  },
  {
    "date": "21.02.2018",
    "now": "3,7892",
    "open": "3,7972",
    "highest": "3,8104",
    "lower": "3,7740",
    "difference": "-0,24%"
  },
  {
    "date": "20.02.2018",
    "now": "3,7984",
    "open": "3,7569",
    "highest": "3,8136",
    "lower": "3,7565",
    "difference": "1,09%"
  },
  {
    "date": "19.02.2018",
    "now": "3,7573",
    "open": "3,7465",
    "highest": "3,7642",
    "lower": "3,7418",
    "difference": "0,26%"
  },
  {
    "date": "16.02.2018",
    "now": "3,7474",
    "open": "3,7644",
    "highest": "3,7730",
    "lower": "3,7345",
    "difference": "-0,45%"
  },
  {
    "date": "15.02.2018",
    "now": "3,7644",
    "open": "3,7826",
    "highest": "3,7866",
    "lower": "3,7619",
    "difference": "-0,48%"
  },
  {
    "date": "14.02.2018",
    "now": "3,7824",
    "open": "3,8122",
    "highest": "3,8254",
    "lower": "3,7778",
    "difference": "-0,74%"
  },
  {
    "date": "13.02.2018",
    "now": "3,8106",
    "open": "3,8002",
    "highest": "3,8134",
    "lower": "3,7875",
    "difference": "0,29%"
  },
  {
    "date": "12.02.2018",
    "now": "3,7997",
    "open": "3,8209",
    "highest": "3,8290",
    "lower": "3,7945",
    "difference": "-0,60%"
  },
  {
    "date": "09.02.2018",
    "now": "3,8226",
    "open": "3,8213",
    "highest": "3,8456",
    "lower": "3,8035",
    "difference": "0,03%"
  },
  {
    "date": "08.02.2018",
    "now": "3,8216",
    "open": "3,8047",
    "highest": "3,8360",
    "lower": "3,7885",
    "difference": "0,44%"
  },
  {
    "date": "07.02.2018",
    "now": "3,8047",
    "open": "3,7697",
    "highest": "3,8077",
    "lower": "3,7605",
    "difference": "0,93%"
  },
  {
    "date": "06.02.2018",
    "now": "3,7695",
    "open": "3,7895",
    "highest": "3,7964",
    "lower": "3,7605",
    "difference": "-0,54%"
  },
  {
    "date": "05.02.2018",
    "now": "3,7900",
    "open": "3,7688",
    "highest": "3,7920",
    "lower": "3,7525",
    "difference": "0,44%"
  },
  {
    "date": "02.02.2018",
    "now": "3,7735",
    "open": "3,7336",
    "highest": "3,7786",
    "lower": "3,7290",
    "difference": "1,13%"
  },
  {
    "date": "01.02.2018",
    "now": "3,7315",
    "open": "3,7547",
    "highest": "3,7724",
    "lower": "3,7260",
    "difference": "-0,64%"
  },
  {
    "date": "31.01.2018",
    "now": "3,7555",
    "open": "3,7811",
    "highest": "3,7837",
    "lower": "3,7441",
    "difference": "-0,67%"
  },
  {
    "date": "30.01.2018",
    "now": "3,7810",
    "open": "3,7929",
    "highest": "3,8000",
    "lower": "3,7584",
    "difference": "-0,33%"
  },
  {
    "date": "29.01.2018",
    "now": "3,7934",
    "open": "3,7539",
    "highest": "3,7973",
    "lower": "3,7408",
    "difference": "1,03%"
  },
  {
    "date": "26.01.2018",
    "now": "3,7547",
    "open": "3,7516",
    "highest": "3,7661",
    "lower": "3,7252",
    "difference": "0,06%"
  },
  {
    "date": "25.01.2018",
    "now": "3,7525",
    "open": "3,7379",
    "highest": "3,7609",
    "lower": "3,7126",
    "difference": "0,38%"
  },
  {
    "date": "24.01.2018",
    "now": "3,7384",
    "open": "3,7670",
    "highest": "3,7754",
    "lower": "3,7298",
    "difference": "-0,77%"
  },
  {
    "date": "23.01.2018",
    "now": "3,7673",
    "open": "3,7760",
    "highest": "3,8049",
    "lower": "3,7638",
    "difference": "-0,20%"
  },
  {
    "date": "22.01.2018",
    "now": "3,7750",
    "open": "3,8316",
    "highest": "3,8491",
    "lower": "3,7695",
    "difference": "-0,83%"
  },
  {
    "date": "19.01.2018",
    "now": "3,8065",
    "open": "3,7708",
    "highest": "3,8177",
    "lower": "3,7585",
    "difference": "0,97%"
  },
  {
    "date": "18.01.2018",
    "now": "3,7701",
    "open": "3,8161",
    "highest": "3,8226",
    "lower": "3,7550",
    "difference": "-1,26%"
  },
  {
    "date": "17.01.2018",
    "now": "3,8182",
    "open": "3,7971",
    "highest": "3,8339",
    "lower": "3,7905",
    "difference": "0,53%"
  },
  {
    "date": "16.01.2018",
    "now": "3,7980",
    "open": "3,8011",
    "highest": "3,8358",
    "lower": "3,7835",
    "difference": "-0,07%"
  },
  {
    "date": "15.01.2018",
    "now": "3,8007",
    "open": "3,7484",
    "highest": "3,8043",
    "lower": "3,7429",
    "difference": "1,40%"
  },
  {
    "date": "12.01.2018",
    "now": "3,7482",
    "open": "3,7767",
    "highest": "3,7847",
    "lower": "3,7438",
    "difference": "-0,69%"
  },
  {
    "date": "11.01.2018",
    "now": "3,7741",
    "open": "3,7996",
    "highest": "3,8064",
    "lower": "3,7670",
    "difference": "-0,67%"
  },
  {
    "date": "10.01.2018",
    "now": "3,7994",
    "open": "3,7675",
    "highest": "3,8092",
    "lower": "3,7646",
    "difference": "0,84%"
  },
  {
    "date": "09.01.2018",
    "now": "3,7679",
    "open": "3,7456",
    "highest": "3,7801",
    "lower": "3,7396",
    "difference": "0,63%"
  },
  {
    "date": "08.01.2018",
    "now": "3,7443",
    "open": "3,7317",
    "highest": "3,7576",
    "lower": "3,7297",
    "difference": "0,20%"
  },
  {
    "date": "05.01.2018",
    "now": "3,7367",
    "open": "3,7496",
    "highest": "3,7618",
    "lower": "3,7275",
    "difference": "-0,30%"
  },
  {
    "date": "04.01.2018",
    "now": "3,7480",
    "open": "3,7834",
    "highest": "3,7883",
    "lower": "3,7440",
    "difference": "-0,88%"
  },
  {
    "date": "03.01.2018",
    "now": "3,7812",
    "open": "3,7660",
    "highest": "3,7879",
    "lower": "3,7520",
    "difference": "0,38%"
  },
  {
    "date": "02.01.2018",
    "now": "3,7667",
    "open": "3,7920",
    "highest": "3,7968",
    "lower": "3,7490",
    "difference": "-0,55%"
  },
  {
    "date": "01.01.2018",
    "now": "3,7875",
    "open": "3,7855",
    "highest": "3,7974",
    "lower": "3,7855",
    "difference": "-0,07%"
  },
  {
    "date": "29.12.2017",
    "now": "3,7900",
    "open": "3,7748",
    "highest": "3,7975",
    "lower": "3,7592",
    "difference": "0,40%"
  },
  {
    "date": "28.12.2017",
    "now": "3,7749",
    "open": "3,8160",
    "highest": "3,8255",
    "lower": "3,7630",
    "difference": "-1,07%"
  },
  {
    "date": "27.12.2017",
    "now": "3,8156",
    "open": "3,8110",
    "highest": "3,8283",
    "lower": "3,8020",
    "difference": "0,09%"
  },
  {
    "date": "26.12.2017",
    "now": "3,8120",
    "open": "3,8091",
    "highest": "3,8200",
    "lower": "3,7946",
    "difference": "0,12%"
  },
  {
    "date": "25.12.2017",
    "now": "3,8074",
    "open": "3,8097",
    "highest": "3,8200",
    "lower": "3,7910",
    "difference": "-0,22%"
  },
  {
    "date": "22.12.2017",
    "now": "3,8157",
    "open": "3,8182",
    "highest": "3,8277",
    "lower": "3,8067",
    "difference": "-0,05%"
  },
  {
    "date": "21.12.2017",
    "now": "3,8175",
    "open": "3,8193",
    "highest": "3,8342",
    "lower": "3,8138",
    "difference": "-0,07%"
  },
  {
    "date": "20.12.2017",
    "now": "3,8203",
    "open": "3,8331",
    "highest": "3,8453",
    "lower": "3,8133",
    "difference": "-0,35%"
  },
  {
    "date": "19.12.2017",
    "now": "3,8336",
    "open": "3,8297",
    "highest": "3,8455",
    "lower": "3,8198",
    "difference": "0,09%"
  },
  {
    "date": "18.12.2017",
    "now": "3,8300",
    "open": "3,8628",
    "highest": "3,8706",
    "lower": "3,8203",
    "difference": "-0,82%"
  },
  {
    "date": "15.12.2017",
    "now": "3,8617",
    "open": "3,8888",
    "highest": "3,8902",
    "lower": "3,8478",
    "difference": "-0,65%"
  },
  {
    "date": "14.12.2017",
    "now": "3,8869",
    "open": "3,8114",
    "highest": "3,8972",
    "lower": "3,8076",
    "difference": "1,97%"
  },
  {
    "date": "13.12.2017",
    "now": "3,8119",
    "open": "3,8479",
    "highest": "3,8655",
    "lower": "3,8083",
    "difference": "-0,94%"
  },
  {
    "date": "12.12.2017",
    "now": "3,8479",
    "open": "3,8380",
    "highest": "3,8609",
    "lower": "3,8213",
    "difference": "0,29%"
  },
  {
    "date": "11.12.2017",
    "now": "3,8367",
    "open": "3,8387",
    "highest": "3,8400",
    "lower": "3,8140",
    "difference": "-0,05%"
  },
  {
    "date": "08.12.2017",
    "now": "3,8388",
    "open": "3,8594",
    "highest": "3,8746",
    "lower": "3,8238",
    "difference": "-0,63%"
  },
  {
    "date": "07.12.2017",
    "now": "3,8631",
    "open": "3,8507",
    "highest": "3,8740",
    "lower": "3,8465",
    "difference": "0,32%"
  },
  {
    "date": "06.12.2017",
    "now": "3,8506",
    "open": "3,8438",
    "highest": "3,8640",
    "lower": "3,8385",
    "difference": "0,16%"
  },
  {
    "date": "05.12.2017",
    "now": "3,8444",
    "open": "3,8742",
    "highest": "3,8801",
    "lower": "3,8375",
    "difference": "-0,77%"
  },
  {
    "date": "04.12.2017",
    "now": "3,8742",
    "open": "3,9162",
    "highest": "3,9466",
    "lower": "3,8621",
    "difference": "-0,99%"
  },
  {
    "date": "01.12.2017",
    "now": "3,9131",
    "open": "3,9178",
    "highest": "3,9475",
    "lower": "3,9059",
    "difference": "-0,15%"
  },
  {
    "date": "30.11.2017",
    "now": "3,9190",
    "open": "3,9618",
    "highest": "3,9626",
    "lower": "3,9030",
    "difference": "-1,07%"
  },
  {
    "date": "29.11.2017",
    "now": "3,9613",
    "open": "3,9641",
    "highest": "3,9737",
    "lower": "3,9400",
    "difference": "-0,08%"
  },
  {
    "date": "28.11.2017",
    "now": "3,9645",
    "open": "3,9059",
    "highest": "3,9736",
    "lower": "3,9017",
    "difference": "1,49%"
  },
  {
    "date": "27.11.2017",
    "now": "3,9062",
    "open": "3,9498",
    "highest": "3,9562",
    "lower": "3,8875",
    "difference": "-0,95%"
  },
  {
    "date": "24.11.2017",
    "now": "3,9437",
    "open": "3,9200",
    "highest": "3,9576",
    "lower": "3,9090",
    "difference": "0,60%"
  },
  {
    "date": "23.11.2017",
    "now": "3,9201",
    "open": "3,9179",
    "highest": "3,9475",
    "lower": "3,8960",
    "difference": "0,04%"
  },
  {
    "date": "22.11.2017",
    "now": "3,9184",
    "open": "3,9548",
    "highest": "3,9825",
    "lower": "3,9115",
    "difference": "-0,97%"
  },
  {
    "date": "21.11.2017",
    "now": "3,9566",
    "open": "3,9289",
    "highest": "3,9778",
    "lower": "3,9180",
    "difference": "0,71%"
  },
  {
    "date": "20.11.2017",
    "now": "3,9286",
    "open": "3,8772",
    "highest": "3,9300",
    "lower": "3,8537",
    "difference": "1,32%"
  },
  {
    "date": "17.11.2017",
    "now": "3,8773",
    "open": "3,8647",
    "highest": "3,9055",
    "lower": "3,8513",
    "difference": "0,37%"
  },
  {
    "date": "16.11.2017",
    "now": "3,8629",
    "open": "3,8808",
    "highest": "3,8891",
    "lower": "3,8485",
    "difference": "-0,47%"
  },
  {
    "date": "15.11.2017",
    "now": "3,8811",
    "open": "3,8852",
    "highest": "3,9015",
    "lower": "3,8690",
    "difference": "-0,13%"
  },
  {
    "date": "14.11.2017",
    "now": "3,8860",
    "open": "3,8685",
    "highest": "3,9109",
    "lower": "3,8577",
    "difference": "0,40%"
  },
  {
    "date": "13.11.2017",
    "now": "3,8706",
    "open": "3,8602",
    "highest": "3,8892",
    "lower": "3,8460",
    "difference": "0,18%"
  },
  {
    "date": "10.11.2017",
    "now": "3,8636",
    "open": "3,8612",
    "highest": "3,8818",
    "lower": "3,8450",
    "difference": "-0,03%"
  },
  {
    "date": "09.11.2017",
    "now": "3,8647",
    "open": "3,8677",
    "highest": "3,8824",
    "lower": "3,8367",
    "difference": "-0,05%"
  },
  {
    "date": "08.11.2017",
    "now": "3,8665",
    "open": "3,8851",
    "highest": "3,9020",
    "lower": "3,8549",
    "difference": "-0,46%"
  },
  {
    "date": "07.11.2017",
    "now": "3,8844",
    "open": "3,8278",
    "highest": "3,8966",
    "lower": "3,8235",
    "difference": "1,47%"
  },
  {
    "date": "06.11.2017",
    "now": "3,8280",
    "open": "3,8825",
    "highest": "3,8904",
    "lower": "3,8205",
    "difference": "-1,50%"
  },
  {
    "date": "03.11.2017",
    "now": "3,8864",
    "open": "3,7973",
    "highest": "3,8899",
    "lower": "3,7944",
    "difference": "2,34%"
  },
  {
    "date": "02.11.2017",
    "now": "3,7975",
    "open": "3,8122",
    "highest": "3,8270",
    "lower": "3,7894",
    "difference": "-0,41%"
  },
  {
    "date": "01.11.2017",
    "now": "3,8130",
    "open": "3,7917",
    "highest": "3,8340",
    "lower": "3,7830",
    "difference": "0,55%"
  },
  {
    "date": "31.10.2017",
    "now": "3,7920",
    "open": "3,7793",
    "highest": "3,8151",
    "lower": "3,7620",
    "difference": "0,32%"
  },
  {
    "date": "30.10.2017",
    "now": "3,7798",
    "open": "3,7910",
    "highest": "3,7948",
    "lower": "3,7610",
    "difference": "-0,23%"
  },
  {
    "date": "27.10.2017",
    "now": "3,7885",
    "open": "3,8198",
    "highest": "3,8432",
    "lower": "3,7830",
    "difference": "-0,83%"
  },
  {
    "date": "26.10.2017",
    "now": "3,8203",
    "open": "3,7667",
    "highest": "3,8353",
    "lower": "3,7489",
    "difference": "1,42%"
  },
  {
    "date": "25.10.2017",
    "now": "3,7668",
    "open": "3,7421",
    "highest": "3,8082",
    "lower": "3,7167",
    "difference": "0,68%"
  },
  {
    "date": "24.10.2017",
    "now": "3,7414",
    "open": "3,7158",
    "highest": "3,7593",
    "lower": "3,7011",
    "difference": "0,68%"
  },
  {
    "date": "23.10.2017",
    "now": "3,7163",
    "open": "3,6709",
    "highest": "3,7230",
    "lower": "3,6707",
    "difference": "1,22%"
  },
  {
    "date": "20.10.2017",
    "now": "3,6714",
    "open": "3,6454",
    "highest": "3,6840",
    "lower": "3,6438",
    "difference": "0,71%"
  },
  {
    "date": "19.10.2017",
    "now": "3,6456",
    "open": "3,6791",
    "highest": "3,6814",
    "lower": "3,6422",
    "difference": "-0,85%"
  },
  {
    "date": "18.10.2017",
    "now": "3,6768",
    "open": "3,6665",
    "highest": "3,6880",
    "lower": "3,6602",
    "difference": "0,29%"
  },
  {
    "date": "17.10.2017",
    "now": "3,6663",
    "open": "3,6477",
    "highest": "3,6919",
    "lower": "3,6440",
    "difference": "0,55%"
  },
  {
    "date": "16.10.2017",
    "now": "3,6463",
    "open": "3,6303",
    "highest": "3,6525",
    "lower": "3,6279",
    "difference": "0,31%"
  },
  {
    "date": "13.10.2017",
    "now": "3,6349",
    "open": "3,6543",
    "highest": "3,6637",
    "lower": "3,6215",
    "difference": "-0,52%"
  },
  {
    "date": "12.10.2017",
    "now": "3,6540",
    "open": "3,6500",
    "highest": "3,6721",
    "lower": "3,6280",
    "difference": "0,15%"
  },
  {
    "date": "11.10.2017",
    "now": "3,6484",
    "open": "3,7090",
    "highest": "3,7131",
    "lower": "3,6425",
    "difference": "-1,70%"
  },
  {
    "date": "10.10.2017",
    "now": "3,7114",
    "open": "3,7006",
    "highest": "3,7129",
    "lower": "3,6585",
    "difference": "0,28%"
  },
  {
    "date": "09.10.2017",
    "now": "3,7011",
    "open": "3,6157",
    "highest": "3,7704",
    "lower": "3,6157",
    "difference": "2,38%"
  },
  {
    "date": "06.10.2017",
    "now": "3,6149",
    "open": "3,5831",
    "highest": "3,6380",
    "lower": "3,5782",
    "difference": "0,87%"
  },
  {
    "date": "05.10.2017",
    "now": "3,5836",
    "open": "3,5718",
    "highest": "3,5891",
    "lower": "3,5618",
    "difference": "0,32%"
  },
  {
    "date": "04.10.2017",
    "now": "3,5723",
    "open": "3,5714",
    "highest": "3,5800",
    "lower": "3,5575",
    "difference": "0,01%"
  },
  {
    "date": "03.10.2017",
    "now": "3,5718",
    "open": "3,5645",
    "highest": "3,5960",
    "lower": "3,5631",
    "difference": "0,23%"
  },
  {
    "date": "02.10.2017",
    "now": "3,5635",
    "open": "3,5654",
    "highest": "3,5882",
    "lower": "3,5620",
    "difference": "-0,01%"
  },
  {
    "date": "29.09.2017",
    "now": "3,5637",
    "open": "3,5580",
    "highest": "3,5671",
    "lower": "3,5369",
    "difference": "0,10%"
  },
  {
    "date": "28.09.2017",
    "now": "3,5603",
    "open": "3,5789",
    "highest": "3,5990",
    "lower": "3,5550",
    "difference": "-0,48%"
  },
  {
    "date": "27.09.2017",
    "now": "3,5774",
    "open": "3,5375",
    "highest": "3,5870",
    "lower": "3,5355",
    "difference": "0,99%"
  },
  {
    "date": "26.09.2017",
    "now": "3,5424",
    "open": "3,5499",
    "highest": "3,5586",
    "lower": "3,5225",
    "difference": "-0,20%"
  },
  {
    "date": "25.09.2017",
    "now": "3,5494",
    "open": "3,4920",
    "highest": "3,5530",
    "lower": "3,4920",
    "difference": "1,52%"
  },
  {
    "date": "22.09.2017",
    "now": "3,4962",
    "open": "3,5029",
    "highest": "3,5090",
    "lower": "3,4775",
    "difference": "-0,17%"
  },
  {
    "date": "21.09.2017",
    "now": "3,5023",
    "open": "3,5035",
    "highest": "3,5210",
    "lower": "3,4935",
    "difference": "-0,02%"
  },
  {
    "date": "20.09.2017",
    "now": "3,5030",
    "open": "3,4896",
    "highest": "3,5198",
    "lower": "3,4644",
    "difference": "0,41%"
  },
  {
    "date": "19.09.2017",
    "now": "3,4887",
    "open": "3,4899",
    "highest": "3,5074",
    "lower": "3,4767",
    "difference": "-0,02%"
  },
  {
    "date": "18.09.2017",
    "now": "3,4894",
    "open": "3,4398",
    "highest": "3,5008",
    "lower": "3,4290",
    "difference": "1,51%"
  },
  {
    "date": "15.09.2017",
    "now": "3,4376",
    "open": "3,4326",
    "highest": "3,4447",
    "lower": "3,4189",
    "difference": "0,13%"
  },
  {
    "date": "14.09.2017",
    "now": "3,4331",
    "open": "3,4578",
    "highest": "3,4780",
    "lower": "3,4285",
    "difference": "-0,72%"
  },
  {
    "date": "13.09.2017",
    "now": "3,4579",
    "open": "3,4325",
    "highest": "3,4629",
    "lower": "3,4215",
    "difference": "0,72%"
  },
  {
    "date": "12.09.2017",
    "now": "3,4331",
    "open": "3,4059",
    "highest": "3,4450",
    "lower": "3,4012",
    "difference": "0,80%"
  },
  {
    "date": "11.09.2017",
    "now": "3,4060",
    "open": "3,4117",
    "highest": "3,4150",
    "lower": "3,3845",
    "difference": "-0,17%"
  },
  {
    "date": "08.09.2017",
    "now": "3,4117",
    "open": "3,4038",
    "highest": "3,4226",
    "lower": "3,3944",
    "difference": "0,21%"
  },
  {
    "date": "07.09.2017",
    "now": "3,4045",
    "open": "3,4273",
    "highest": "3,4356",
    "lower": "3,4011",
    "difference": "-0,62%"
  },
  {
    "date": "06.09.2017",
    "now": "3,4257",
    "open": "3,4340",
    "highest": "3,4505",
    "lower": "3,4195",
    "difference": "-0,34%"
  },
  {
    "date": "05.09.2017",
    "now": "3,4375",
    "open": "3,4342",
    "highest": "3,4535",
    "lower": "3,4224",
    "difference": "0,08%"
  },
  {
    "date": "04.09.2017",
    "now": "3,4348",
    "open": "3,4263",
    "highest": "3,4411",
    "lower": "3,4206",
    "difference": "0,19%"
  },
  {
    "date": "01.09.2017",
    "now": "3,4284",
    "open": "3,4500",
    "highest": "3,4546",
    "lower": "3,4132",
    "difference": "-0,70%"
  },
  {
    "date": "31.08.2017",
    "now": "3,4527",
    "open": "3,4517",
    "highest": "3,4733",
    "lower": "3,4422",
    "difference": "0,03%"
  },
  {
    "date": "30.08.2017",
    "now": "3,4517",
    "open": "3,4459",
    "highest": "3,4639",
    "lower": "3,4369",
    "difference": "0,15%"
  },
  {
    "date": "29.08.2017",
    "now": "3,4465",
    "open": "3,4439",
    "highest": "3,4590",
    "lower": "3,4310",
    "difference": "0,07%"
  },
  {
    "date": "28.08.2017",
    "now": "3,4441",
    "open": "3,4381",
    "highest": "3,4540",
    "lower": "3,4340",
    "difference": "0,15%"
  },
  {
    "date": "25.08.2017",
    "now": "3,4389",
    "open": "3,4837",
    "highest": "3,4914",
    "lower": "3,4331",
    "difference": "-1,29%"
  },
  {
    "date": "24.08.2017",
    "now": "3,4838",
    "open": "3,4756",
    "highest": "3,4876",
    "lower": "3,4727",
    "difference": "0,15%"
  },
  {
    "date": "23.08.2017",
    "now": "3,4787",
    "open": "3,4935",
    "highest": "3,5043",
    "lower": "3,4748",
    "difference": "-0,45%"
  },
  {
    "date": "22.08.2017",
    "now": "3,4944",
    "open": "3,4955",
    "highest": "3,5060",
    "lower": "3,4880",
    "difference": "-0,07%"
  },
  {
    "date": "21.08.2017",
    "now": "3,4970",
    "open": "3,5136",
    "highest": "3,5259",
    "lower": "3,4899",
    "difference": "-0,61%"
  },
  {
    "date": "18.08.2017",
    "now": "3,5185",
    "open": "3,5251",
    "highest": "3,5327",
    "lower": "3,5080",
    "difference": "-0,20%"
  },
  {
    "date": "17.08.2017",
    "now": "3,5254",
    "open": "3,5159",
    "highest": "3,5299",
    "lower": "3,5103",
    "difference": "0,28%"
  },
  {
    "date": "16.08.2017",
    "now": "3,5156",
    "open": "3,5369",
    "highest": "3,5417",
    "lower": "3,5141",
    "difference": "-0,55%"
  },
  {
    "date": "15.08.2017",
    "now": "3,5352",
    "open": "3,5250",
    "highest": "3,5489",
    "lower": "3,5166",
    "difference": "0,27%"
  },
  {
    "date": "14.08.2017",
    "now": "3,5257",
    "open": "3,5396",
    "highest": "3,5397",
    "lower": "3,5174",
    "difference": "-0,32%"
  },
  {
    "date": "11.08.2017",
    "now": "3,5369",
    "open": "3,5417",
    "highest": "3,5596",
    "lower": "3,5296",
    "difference": "-0,14%"
  },
  {
    "date": "10.08.2017",
    "now": "3,5418",
    "open": "3,5373",
    "highest": "3,5453",
    "lower": "3,5242",
    "difference": "0,12%"
  },
  {
    "date": "09.08.2017",
    "now": "3,5376",
    "open": "3,5330",
    "highest": "3,5499",
    "lower": "3,5267",
    "difference": "0,11%"
  },
  {
    "date": "08.08.2017",
    "now": "3,5338",
    "open": "3,5288",
    "highest": "3,5353",
    "lower": "3,5232",
    "difference": "0,13%"
  },
  {
    "date": "07.08.2017",
    "now": "3,5291",
    "open": "3,5281",
    "highest": "3,5381",
    "lower": "3,5200",
    "difference": "0,03%"
  },
  {
    "date": "04.08.2017",
    "now": "3,5279",
    "open": "3,5392",
    "highest": "3,5439",
    "lower": "3,5230",
    "difference": "-0,33%"
  },
  {
    "date": "03.08.2017",
    "now": "3,5396",
    "open": "3,5330",
    "highest": "3,5488",
    "lower": "3,5280",
    "difference": "0,26%"
  },
  {
    "date": "02.08.2017",
    "now": "3,5305",
    "open": "3,5281",
    "highest": "3,5430",
    "lower": "3,5225",
    "difference": "0,10%"
  },
  {
    "date": "01.08.2017",
    "now": "3,5271",
    "open": "3,5198",
    "highest": "3,5322",
    "lower": "3,5080",
    "difference": "0,22%"
  },
  {
    "date": "31.07.2017",
    "now": "3,5193",
    "open": "3,5291",
    "highest": "3,5380",
    "lower": "3,5140",
    "difference": "-0,24%"
  },
  {
    "date": "28.07.2017",
    "now": "3,5279",
    "open": "3,5351",
    "highest": "3,5416",
    "lower": "3,5224",
    "difference": "-0,24%"
  },
  {
    "date": "27.07.2017",
    "now": "3,5363",
    "open": "3,5368",
    "highest": "3,5440",
    "lower": "3,5160",
    "difference": "-0,06%"
  },
  {
    "date": "26.07.2017",
    "now": "3,5385",
    "open": "3,5734",
    "highest": "3,5787",
    "lower": "3,5325",
    "difference": "-0,95%"
  },
  {
    "date": "25.07.2017",
    "now": "3,5724",
    "open": "3,5566",
    "highest": "3,5768",
    "lower": "3,5470",
    "difference": "0,44%"
  },
  {
    "date": "24.07.2017",
    "now": "3,5567",
    "open": "3,5369",
    "highest": "3,5715",
    "lower": "3,5236",
    "difference": "0,58%"
  },
  {
    "date": "21.07.2017",
    "now": "3,5363",
    "open": "3,5263",
    "highest": "3,5434",
    "lower": "3,5187",
    "difference": "0,28%"
  },
  {
    "date": "20.07.2017",
    "now": "3,5264",
    "open": "3,5220",
    "highest": "3,5453",
    "lower": "3,5175",
    "difference": "0,12%"
  },
  {
    "date": "19.07.2017",
    "now": "3,5220",
    "open": "3,5223",
    "highest": "3,5405",
    "lower": "3,5090",
    "difference": "-0,03%"
  },
  {
    "date": "18.07.2017",
    "now": "3,5231",
    "open": "3,5281",
    "highest": "3,5382",
    "lower": "3,5181",
    "difference": "-0,15%"
  },
  {
    "date": "17.07.2017",
    "now": "3,5284",
    "open": "3,5379",
    "highest": "3,5525",
    "lower": "3,5220",
    "difference": "-0,27%"
  },
  {
    "date": "14.07.2017",
    "now": "3,5381",
    "open": "3,5650",
    "highest": "3,5720",
    "lower": "3,5249",
    "difference": "-0,77%"
  },
  {
    "date": "13.07.2017",
    "now": "3,5657",
    "open": "3,5663",
    "highest": "3,5779",
    "lower": "3,5569",
    "difference": "-0,04%"
  },
  {
    "date": "12.07.2017",
    "now": "3,5672",
    "open": "3,6133",
    "highest": "3,6234",
    "lower": "3,5632",
    "difference": "-1,29%"
  },
  {
    "date": "11.07.2017",
    "now": "3,6139",
    "open": "3,6088",
    "highest": "3,6452",
    "lower": "3,6042",
    "difference": "0,16%"
  },
  {
    "date": "10.07.2017",
    "now": "3,6083",
    "open": "3,6166",
    "highest": "3,6248",
    "lower": "3,5985",
    "difference": "-0,27%"
  },
  {
    "date": "07.07.2017",
    "now": "3,6182",
    "open": "3,6189",
    "highest": "3,6474",
    "lower": "3,6079",
    "difference": "-0,08%"
  },
  {
    "date": "06.07.2017",
    "now": "3,6212",
    "open": "3,6069",
    "highest": "3,6415",
    "lower": "3,6007",
    "difference": "0,42%"
  },
  {
    "date": "05.07.2017",
    "now": "3,6062",
    "open": "3,5589",
    "highest": "3,6173",
    "lower": "3,5480",
    "difference": "1,31%"
  },
  {
    "date": "04.07.2017",
    "now": "3,5594",
    "open": "3,5566",
    "highest": "3,5700",
    "lower": "3,5430",
    "difference": "0,06%"
  },
  {
    "date": "03.07.2017",
    "now": "3,5571",
    "open": "3,5206",
    "highest": "3,5673",
    "lower": "3,5110",
    "difference": "1,02%"
  },
  {
    "date": "30.06.2017",
    "now": "3,5212",
    "open": "3,5255",
    "highest": "3,5340",
    "lower": "3,5047",
    "difference": "-0,15%"
  },
  {
    "date": "29.06.2017",
    "now": "3,5265",
    "open": "3,5137",
    "highest": "3,5395",
    "lower": "3,4980",
    "difference": "0,39%"
  },
  {
    "date": "28.06.2017",
    "now": "3,5128",
    "open": "3,5261",
    "highest": "3,5390",
    "lower": "3,5084",
    "difference": "-0,38%"
  },
  {
    "date": "27.06.2017",
    "now": "3,5263",
    "open": "3,5011",
    "highest": "3,5278",
    "lower": "3,4903",
    "difference": "0,73%"
  },
  {
    "date": "26.06.2017",
    "now": "3,5008",
    "open": "3,5089",
    "highest": "3,5125",
    "lower": "3,4897",
    "difference": "-0,23%"
  },
  {
    "date": "23.06.2017",
    "now": "3,5088",
    "open": "3,5084",
    "highest": "3,5161",
    "lower": "3,4957",
    "difference": "0,03%"
  },
  {
    "date": "22.06.2017",
    "now": "3,5077",
    "open": "3,5306",
    "highest": "3,5329",
    "lower": "3,5020",
    "difference": "-0,66%"
  },
  {
    "date": "21.06.2017",
    "now": "3,5310",
    "open": "3,5410",
    "highest": "3,5492",
    "lower": "3,5200",
    "difference": "-0,38%"
  },
  {
    "date": "20.06.2017",
    "now": "3,5445",
    "open": "3,5225",
    "highest": "3,5514",
    "lower": "3,5100",
    "difference": "0,62%"
  },
  {
    "date": "19.06.2017",
    "now": "3,5228",
    "open": "3,5025",
    "highest": "3,5259",
    "lower": "3,4835",
    "difference": "0,57%"
  },
  {
    "date": "16.06.2017",
    "now": "3,5027",
    "open": "3,5125",
    "highest": "3,5327",
    "lower": "3,4940",
    "difference": "-0,29%"
  },
  {
    "date": "15.06.2017",
    "now": "3,5130",
    "open": "3,4876",
    "highest": "3,5256",
    "lower": "3,4811",
    "difference": "0,72%"
  },
  {
    "date": "14.06.2017",
    "now": "3,4878",
    "open": "3,5188",
    "highest": "3,5238",
    "lower": "3,4733",
    "difference": "-0,91%"
  },
  {
    "date": "13.06.2017",
    "now": "3,5198",
    "open": "3,5168",
    "highest": "3,5343",
    "lower": "3,5065",
    "difference": "0,10%"
  },
  {
    "date": "12.06.2017",
    "now": "3,5164",
    "open": "3,5368",
    "highest": "3,5407",
    "lower": "3,5085",
    "difference": "-0,59%"
  },
  {
    "date": "09.06.2017",
    "now": "3,5373",
    "open": "3,5236",
    "highest": "3,5443",
    "lower": "3,5150",
    "difference": "0,37%"
  },
  {
    "date": "08.06.2017",
    "now": "3,5244",
    "open": "3,5465",
    "highest": "3,5570",
    "lower": "3,5180",
    "difference": "-0,73%"
  },
  {
    "date": "07.06.2017",
    "now": "3,5503",
    "open": "3,5152",
    "highest": "3,5587",
    "lower": "3,5060",
    "difference": "1,00%"
  },
  {
    "date": "06.06.2017",
    "now": "3,5151",
    "open": "3,5232",
    "highest": "3,5438",
    "lower": "3,5105",
    "difference": "-0,24%"
  },
  {
    "date": "05.06.2017",
    "now": "3,5237",
    "open": "3,5083",
    "highest": "3,5340",
    "lower": "3,4935",
    "difference": "0,40%"
  },
  {
    "date": "02.06.2017",
    "now": "3,5098",
    "open": "3,5246",
    "highest": "3,5395",
    "lower": "3,5017",
    "difference": "-0,42%"
  },
  {
    "date": "01.06.2017",
    "now": "3,5246",
    "open": "3,5278",
    "highest": "3,5446",
    "lower": "3,5210",
    "difference": "-0,07%"
  },
  {
    "date": "31.05.2017",
    "now": "3,5270",
    "open": "3,5495",
    "highest": "3,5600",
    "lower": "3,5240",
    "difference": "-0,62%"
  },
  {
    "date": "30.05.2017",
    "now": "3,5491",
    "open": "3,5726",
    "highest": "3,5890",
    "lower": "3,5387",
    "difference": "-0,78%"
  },
  {
    "date": "29.05.2017",
    "now": "3,5771",
    "open": "3,5804",
    "highest": "3,5865",
    "lower": "3,5727",
    "difference": "-0,02%"
  },
  {
    "date": "26.05.2017",
    "now": "3,5777",
    "open": "3,5663",
    "highest": "3,5857",
    "lower": "3,5595",
    "difference": "0,31%"
  },
  {
    "date": "25.05.2017",
    "now": "3,5667",
    "open": "3,5603",
    "highest": "3,5760",
    "lower": "3,5450",
    "difference": "0,18%"
  },
  {
    "date": "24.05.2017",
    "now": "3,5604",
    "open": "3,5694",
    "highest": "3,5802",
    "lower": "3,5540",
    "difference": "-0,28%"
  },
  {
    "date": "23.05.2017",
    "now": "3,5704",
    "open": "3,5603",
    "highest": "3,5802",
    "lower": "3,5535",
    "difference": "0,31%"
  },
  {
    "date": "22.05.2017",
    "now": "3,5593",
    "open": "3,5765",
    "highest": "3,5946",
    "lower": "3,5483",
    "difference": "-0,45%"
  },
  {
    "date": "19.05.2017",
    "now": "3,5753",
    "open": "3,6236",
    "highest": "3,6324",
    "lower": "3,5647",
    "difference": "-1,37%"
  },
  {
    "date": "18.05.2017",
    "now": "3,6251",
    "open": "3,5688",
    "highest": "3,6423",
    "lower": "3,5666",
    "difference": "1,60%"
  },
  {
    "date": "17.05.2017",
    "now": "3,5681",
    "open": "3,5391",
    "highest": "3,5727",
    "lower": "3,5363",
    "difference": "0,82%"
  },
  {
    "date": "16.05.2017",
    "now": "3,5392",
    "open": "3,5472",
    "highest": "3,5638",
    "lower": "3,5340",
    "difference": "-0,26%"
  },
  {
    "date": "15.05.2017",
    "now": "3,5483",
    "open": "3,5712",
    "highest": "3,5747",
    "lower": "3,5458",
    "difference": "-0,69%"
  },
  {
    "date": "12.05.2017",
    "now": "3,5731",
    "open": "3,5753",
    "highest": "3,5993",
    "lower": "3,5630",
    "difference": "-0,08%"
  },
  {
    "date": "11.05.2017",
    "now": "3,5758",
    "open": "3,5863",
    "highest": "3,5930",
    "lower": "3,5640",
    "difference": "-0,32%"
  },
  {
    "date": "10.05.2017",
    "now": "3,5874",
    "open": "3,6238",
    "highest": "3,6287",
    "lower": "3,5790",
    "difference": "-1,01%"
  },
  {
    "date": "09.05.2017",
    "now": "3,6239",
    "open": "3,5852",
    "highest": "3,6260",
    "lower": "3,5796",
    "difference": "1,08%"
  },
  {
    "date": "08.05.2017",
    "now": "3,5851",
    "open": "3,5364",
    "highest": "3,5960",
    "lower": "3,5270",
    "difference": "1,16%"
  },
  {
    "date": "05.05.2017",
    "now": "3,5441",
    "open": "3,5535",
    "highest": "3,5782",
    "lower": "3,5402",
    "difference": "-0,28%"
  },
  {
    "date": "04.05.2017",
    "now": "3,5540",
    "open": "3,5356",
    "highest": "3,5692",
    "lower": "3,5258",
    "difference": "0,54%"
  },
  {
    "date": "03.05.2017",
    "now": "3,5349",
    "open": "3,5268",
    "highest": "3,5411",
    "lower": "3,5176",
    "difference": "0,22%"
  },
  {
    "date": "02.05.2017",
    "now": "3,5273",
    "open": "3,5544",
    "highest": "3,5565",
    "lower": "3,5173",
    "difference": "-0,77%"
  },
  {
    "date": "01.05.2017",
    "now": "3,5545",
    "open": "3,5516",
    "highest": "3,5584",
    "lower": "3,5465",
    "difference": "0,08%"
  },
  {
    "date": "28.04.2017",
    "now": "3,5516",
    "open": "3,5607",
    "highest": "3,5728",
    "lower": "3,5350",
    "difference": "-0,27%"
  },
  {
    "date": "27.04.2017",
    "now": "3,5612",
    "open": "3,5776",
    "highest": "3,5789",
    "lower": "3,5540",
    "difference": "-0,48%"
  },
  {
    "date": "26.04.2017",
    "now": "3,5783",
    "open": "3,5792",
    "highest": "3,5991",
    "lower": "3,5595",
    "difference": "-0,04%"
  },
  {
    "date": "25.04.2017",
    "now": "3,5797",
    "open": "3,5717",
    "highest": "3,6047",
    "lower": "3,5690",
    "difference": "0,19%"
  },
  {
    "date": "24.04.2017",
    "now": "3,5730",
    "open": "3,6411",
    "highest": "3,6411",
    "lower": "3,5702",
    "difference": "-1,84%"
  },
  {
    "date": "21.04.2017",
    "now": "3,6401",
    "open": "3,6407",
    "highest": "3,6556",
    "lower": "3,6290",
    "difference": "-0,04%"
  },
  {
    "date": "20.04.2017",
    "now": "3,6415",
    "open": "3,6732",
    "highest": "3,6776",
    "lower": "3,6262",
    "difference": "-0,86%"
  },
  {
    "date": "19.04.2017",
    "now": "3,6730",
    "open": "3,6609",
    "highest": "3,6852",
    "lower": "3,6529",
    "difference": "0,33%"
  },
  {
    "date": "18.04.2017",
    "now": "3,6608",
    "open": "3,7024",
    "highest": "3,7142",
    "lower": "3,6531",
    "difference": "-1,09%"
  },
  {
    "date": "17.04.2017",
    "now": "3,7011",
    "open": "3,6330",
    "highest": "3,7172",
    "lower": "3,6270",
    "difference": "-0,85%"
  },
  {
    "date": "14.04.2017",
    "now": "3,7327",
    "open": "3,6641",
    "highest": "3,7376",
    "lower": "3,6597",
    "difference": "1,89%"
  },
  {
    "date": "13.04.2017",
    "now": "3,6633",
    "open": "3,6474",
    "highest": "3,6790",
    "lower": "3,6397",
    "difference": "0,39%"
  },
  {
    "date": "12.04.2017",
    "now": "3,6492",
    "open": "3,6971",
    "highest": "3,7043",
    "lower": "3,6458",
    "difference": "-1,30%"
  },
  {
    "date": "11.04.2017",
    "now": "3,6972",
    "open": "3,7289",
    "highest": "3,7333",
    "lower": "3,6949",
    "difference": "-0,86%"
  },
  {
    "date": "10.04.2017",
    "now": "3,7294",
    "open": "3,7330",
    "highest": "3,7378",
    "lower": "3,7128",
    "difference": "-0,01%"
  },
  {
    "date": "07.04.2017",
    "now": "3,7299",
    "open": "3,7111",
    "highest": "3,7447",
    "lower": "3,7054",
    "difference": "0,51%"
  },
  {
    "date": "06.04.2017",
    "now": "3,7111",
    "open": "3,6990",
    "highest": "3,7293",
    "lower": "3,6938",
    "difference": "0,32%"
  },
  {
    "date": "05.04.2017",
    "now": "3,6991",
    "open": "3,6797",
    "highest": "3,7121",
    "lower": "3,6668",
    "difference": "0,55%"
  },
  {
    "date": "04.04.2017",
    "now": "3,6790",
    "open": "3,6456",
    "highest": "3,6905",
    "lower": "3,6367",
    "difference": "0,94%"
  },
  {
    "date": "03.04.2017",
    "now": "3,6449",
    "open": "3,6347",
    "highest": "3,6510",
    "lower": "3,6210",
    "difference": "0,27%"
  },
  {
    "date": "31.03.2017",
    "now": "3,6352",
    "open": "3,6515",
    "highest": "3,6578",
    "lower": "3,6240",
    "difference": "-0,46%"
  },
  {
    "date": "30.03.2017",
    "now": "3,6520",
    "open": "3,6454",
    "highest": "3,6546",
    "lower": "3,6240",
    "difference": "0,17%"
  },
  {
    "date": "29.03.2017",
    "now": "3,6459",
    "open": "3,6586",
    "highest": "3,6623",
    "lower": "3,6373",
    "difference": "-0,34%"
  },
  {
    "date": "28.03.2017",
    "now": "3,6582",
    "open": "3,6173",
    "highest": "3,6643",
    "lower": "3,6063",
    "difference": "1,15%"
  },
  {
    "date": "27.03.2017",
    "now": "3,6166",
    "open": "3,6072",
    "highest": "3,6254",
    "lower": "3,5847",
    "difference": "0,16%"
  },
  {
    "date": "24.03.2017",
    "now": "3,6108",
    "open": "3,6343",
    "highest": "3,6387",
    "lower": "3,5969",
    "difference": "-0,66%"
  },
  {
    "date": "23.03.2017",
    "now": "3,6348",
    "open": "3,6184",
    "highest": "3,6410",
    "lower": "3,6050",
    "difference": "0,45%"
  },
  {
    "date": "22.03.2017",
    "now": "3,6184",
    "open": "3,6320",
    "highest": "3,6447",
    "lower": "3,6040",
    "difference": "-0,40%"
  },
  {
    "date": "21.03.2017",
    "now": "3,6329",
    "open": "3,6161",
    "highest": "3,6388",
    "lower": "3,5870",
    "difference": "0,47%"
  },
  {
    "date": "20.03.2017",
    "now": "3,6160",
    "open": "3,6344",
    "highest": "3,6389",
    "lower": "3,6140",
    "difference": "-0,51%"
  },
  {
    "date": "17.03.2017",
    "now": "3,6344",
    "open": "3,6264",
    "highest": "3,6458",
    "lower": "3,5980",
    "difference": "0,24%"
  },
  {
    "date": "16.03.2017",
    "now": "3,6256",
    "open": "3,6769",
    "highest": "3,6942",
    "lower": "3,6115",
    "difference": "-1,35%"
  },
  {
    "date": "15.03.2017",
    "now": "3,6754",
    "open": "3,7426",
    "highest": "3,7484",
    "lower": "3,6714",
    "difference": "-1,80%"
  },
  {
    "date": "14.03.2017",
    "now": "3,7426",
    "open": "3,7418",
    "highest": "3,7624",
    "lower": "3,7378",
    "difference": "0,02%"
  },
  {
    "date": "13.03.2017",
    "now": "3,7418",
    "open": "3,7300",
    "highest": "3,7541",
    "lower": "3,7300",
    "difference": "0,32%"
  },
  {
    "date": "10.03.2017",
    "now": "3,7299",
    "open": "3,7747",
    "highest": "3,7787",
    "lower": "3,7225",
    "difference": "-1,19%"
  },
  {
    "date": "09.03.2017",
    "now": "3,7747",
    "open": "3,7462",
    "highest": "3,7861",
    "lower": "3,7360",
    "difference": "0,75%"
  },
  {
    "date": "08.03.2017",
    "now": "3,7467",
    "open": "3,6806",
    "highest": "3,7496",
    "lower": "3,6690",
    "difference": "1,79%"
  },
  {
    "date": "07.03.2017",
    "now": "3,6807",
    "open": "3,7142",
    "highest": "3,7193",
    "lower": "3,6712",
    "difference": "-0,88%"
  },
  {
    "date": "06.03.2017",
    "now": "3,7132",
    "open": "3,7045",
    "highest": "3,7300",
    "lower": "3,7033",
    "difference": "0,28%"
  },
  {
    "date": "03.03.2017",
    "now": "3,7030",
    "open": "3,7282",
    "highest": "3,7470",
    "lower": "3,7016",
    "difference": "-0,67%"
  },
  {
    "date": "02.03.2017",
    "now": "3,7280",
    "open": "3,6555",
    "highest": "3,7362",
    "lower": "3,6485",
    "difference": "2,02%"
  },
  {
    "date": "01.03.2017",
    "now": "3,6543",
    "open": "3,6467",
    "highest": "3,6791",
    "lower": "3,6257",
    "difference": "0,19%"
  },
  {
    "date": "28.02.2017",
    "now": "3,6472",
    "open": "3,6075",
    "highest": "3,6495",
    "lower": "3,5960",
    "difference": "1,11%"
  },
  {
    "date": "27.02.2017",
    "now": "3,6072",
    "open": "3,6076",
    "highest": "3,6103",
    "lower": "3,5797",
    "difference": "0,01%"
  },
  {
    "date": "24.02.2017",
    "now": "3,6070",
    "open": "3,5695",
    "highest": "3,6094",
    "lower": "3,5625",
    "difference": "1,06%"
  },
  {
    "date": "23.02.2017",
    "now": "3,5691",
    "open": "3,5806",
    "highest": "3,5904",
    "lower": "3,5562",
    "difference": "-0,31%"
  },
  {
    "date": "22.02.2017",
    "now": "3,5802",
    "open": "3,6197",
    "highest": "3,6270",
    "lower": "3,5777",
    "difference": "-1,11%"
  },
  {
    "date": "21.02.2017",
    "now": "3,6203",
    "open": "3,6245",
    "highest": "3,6360",
    "lower": "3,6130",
    "difference": "-0,12%"
  },
  {
    "date": "20.02.2017",
    "now": "3,6245",
    "open": "3,6304",
    "highest": "3,6380",
    "lower": "3,6113",
    "difference": "-0,12%"
  },
  {
    "date": "17.02.2017",
    "now": "3,6290",
    "open": "3,6675",
    "highest": "3,6823",
    "lower": "3,6255",
    "difference": "-1,03%"
  },
  {
    "date": "16.02.2017",
    "now": "3,6666",
    "open": "3,6591",
    "highest": "3,6882",
    "lower": "3,6491",
    "difference": "0,18%"
  },
  {
    "date": "15.02.2017",
    "now": "3,6601",
    "open": "3,6498",
    "highest": "3,7027",
    "lower": "3,6370",
    "difference": "0,27%"
  },
  {
    "date": "14.02.2017",
    "now": "3,6503",
    "open": "3,6712",
    "highest": "3,6812",
    "lower": "3,6379",
    "difference": "-0,58%"
  },
  {
    "date": "13.02.2017",
    "now": "3,6717",
    "open": "3,6943",
    "highest": "3,7003",
    "lower": "3,6625",
    "difference": "-0,64%"
  },
  {
    "date": "10.02.2017",
    "now": "3,6953",
    "open": "3,6826",
    "highest": "3,7113",
    "lower": "3,6615",
    "difference": "0,33%"
  },
  {
    "date": "09.02.2017",
    "now": "3,6831",
    "open": "3,7191",
    "highest": "3,7246",
    "lower": "3,6745",
    "difference": "-0,93%"
  },
  {
    "date": "08.02.2017",
    "now": "3,7178",
    "open": "3,7458",
    "highest": "3,7608",
    "lower": "3,6966",
    "difference": "-0,73%"
  },
  {
    "date": "07.02.2017",
    "now": "3,7451",
    "open": "3,6837",
    "highest": "3,7506",
    "lower": "3,6773",
    "difference": "1,66%"
  },
  {
    "date": "06.02.2017",
    "now": "3,6839",
    "open": "3,6983",
    "highest": "3,7075",
    "lower": "3,6622",
    "difference": "-0,37%"
  },
  {
    "date": "03.02.2017",
    "now": "3,6976",
    "open": "3,7366",
    "highest": "3,7576",
    "lower": "3,6869",
    "difference": "-1,06%"
  },
  {
    "date": "02.02.2017",
    "now": "3,7371",
    "open": "3,7700",
    "highest": "3,7747",
    "lower": "3,7181",
    "difference": "-0,89%"
  },
  {
    "date": "01.02.2017",
    "now": "3,7705",
    "open": "3,7727",
    "highest": "3,7952",
    "lower": "3,7580",
    "difference": "-0,08%"
  },
  {
    "date": "31.01.2017",
    "now": "3,7734",
    "open": "3,7814",
    "highest": "3,8048",
    "lower": "3,7668",
    "difference": "-0,22%"
  },
  {
    "date": "30.01.2017",
    "now": "3,7818",
    "open": "3,8675",
    "highest": "3,8798",
    "lower": "3,7712",
    "difference": "-2,47%"
  },
  {
    "date": "27.01.2017",
    "now": "3,8775",
    "open": "3,8515",
    "highest": "3,9107",
    "lower": "3,8490",
    "difference": "0,87%"
  },
  {
    "date": "26.01.2017",
    "now": "3,8440",
    "open": "3,8345",
    "highest": "3,8729",
    "lower": "3,8075",
    "difference": "0,33%"
  },
  {
    "date": "25.01.2017",
    "now": "3,8313",
    "open": "3,7846",
    "highest": "3,8583",
    "lower": "3,7800",
    "difference": "1,27%"
  },
  {
    "date": "24.01.2017",
    "now": "3,7833",
    "open": "3,7570",
    "highest": "3,8275",
    "lower": "3,7359",
    "difference": "0,69%"
  },
  {
    "date": "23.01.2017",
    "now": "3,7573",
    "open": "3,7663",
    "highest": "3,7877",
    "lower": "3,7517",
    "difference": "-0,22%"
  },
  {
    "date": "20.01.2017",
    "now": "3,7655",
    "open": "3,8279",
    "highest": "3,8361",
    "lower": "3,7640",
    "difference": "-1,61%"
  },
  {
    "date": "19.01.2017",
    "now": "3,8273",
    "open": "3,7961",
    "highest": "3,8430",
    "lower": "3,7860",
    "difference": "0,81%"
  },
  {
    "date": "18.01.2017",
    "now": "3,7966",
    "open": "3,7605",
    "highest": "3,7989",
    "lower": "3,7555",
    "difference": "0,95%"
  },
  {
    "date": "17.01.2017",
    "now": "3,7610",
    "open": "3,8045",
    "highest": "3,8168",
    "lower": "3,7560",
    "difference": "-1,14%"
  },
  {
    "date": "16.01.2017",
    "now": "3,8042",
    "open": "3,7261",
    "highest": "3,8175",
    "lower": "3,7248",
    "difference": "2,18%"
  },
  {
    "date": "13.01.2017",
    "now": "3,7230",
    "open": "3,7602",
    "highest": "3,8285",
    "lower": "3,7181",
    "difference": "-0,98%"
  },
  {
    "date": "12.01.2017",
    "now": "3,7597",
    "open": "3,8634",
    "highest": "3,9296",
    "lower": "3,7476",
    "difference": "-2,72%"
  },
  {
    "date": "11.01.2017",
    "now": "3,8647",
    "open": "3,7910",
    "highest": "3,9423",
    "lower": "3,7881",
    "difference": "2,01%"
  },
  {
    "date": "10.01.2017",
    "now": "3,7885",
    "open": "3,7139",
    "highest": "3,8003",
    "lower": "3,7078",
    "difference": "2,04%"
  },
  {
    "date": "09.01.2017",
    "now": "3,7129",
    "open": "3,6446",
    "highest": "3,7440",
    "lower": "3,6380",
    "difference": "1,88%"
  },
  {
    "date": "06.01.2017",
    "now": "3,6445",
    "open": "3,5915",
    "highest": "3,6498",
    "lower": "3,5915",
    "difference": "1,44%"
  },
  {
    "date": "05.01.2017",
    "now": "3,5927",
    "open": "3,5720",
    "highest": "3,6400",
    "lower": "3,5549",
    "difference": "0,60%"
  },
  {
    "date": "04.01.2017",
    "now": "3,5713",
    "open": "3,5939",
    "highest": "3,5942",
    "lower": "3,5670",
    "difference": "-0,64%"
  },
  {
    "date": "03.01.2017",
    "now": "3,5944",
    "open": "3,5450",
    "highest": "3,6052",
    "lower": "3,5332",
    "difference": "1,41%"
  },
  {
    "date": "02.01.2017",
    "now": "3,5445",
    "open": "3,5253",
    "highest": "3,5460",
    "lower": "3,5253",
    "difference": "0,48%"
  },
  {
    "date": "30.12.2016",
    "now": "3,5277",
    "open": "3,5224",
    "highest": "3,5325",
    "lower": "3,5095",
    "difference": "0,13%"
  },
  {
    "date": "29.12.2016",
    "now": "3,5230",
    "open": "3,5395",
    "highest": "3,5441",
    "lower": "3,5145",
    "difference": "-0,48%"
  },
  {
    "date": "28.12.2016",
    "now": "3,5400",
    "open": "3,5220",
    "highest": "3,5505",
    "lower": "3,5170",
    "difference": "0,53%"
  },
  {
    "date": "27.12.2016",
    "now": "3,5214",
    "open": "3,5123",
    "highest": "3,5273",
    "lower": "3,5010",
    "difference": "0,27%"
  },
  {
    "date": "26.12.2016",
    "now": "3,5118",
    "open": "3,5180",
    "highest": "3,5209",
    "lower": "3,5046",
    "difference": "-0,15%"
  },
  {
    "date": "23.12.2016",
    "now": "3,5169",
    "open": "3,5121",
    "highest": "3,5189",
    "lower": "3,4975",
    "difference": "0,16%"
  },
  {
    "date": "22.12.2016",
    "now": "3,5114",
    "open": "3,5091",
    "highest": "3,5191",
    "lower": "3,4981",
    "difference": "0,07%"
  },
  {
    "date": "21.12.2016",
    "now": "3,5089",
    "open": "3,5270",
    "highest": "3,5341",
    "lower": "3,5040",
    "difference": "-0,53%"
  },
  {
    "date": "20.12.2016",
    "now": "3,5275",
    "open": "3,5338",
    "highest": "3,5425",
    "lower": "3,5005",
    "difference": "-0,16%"
  },
  {
    "date": "19.12.2016",
    "now": "3,5331",
    "open": "3,5067",
    "highest": "3,5370",
    "lower": "3,4870",
    "difference": "0,75%"
  },
  {
    "date": "16.12.2016",
    "now": "3,5068",
    "open": "3,5114",
    "highest": "3,5207",
    "lower": "3,4820",
    "difference": "-0,15%"
  },
  {
    "date": "15.12.2016",
    "now": "3,5119",
    "open": "3,5323",
    "highest": "3,5438",
    "lower": "3,4990",
    "difference": "-0,58%"
  },
  {
    "date": "14.12.2016",
    "now": "3,5323",
    "open": "3,4906",
    "highest": "3,5402",
    "lower": "3,4545",
    "difference": "1,22%"
  },
  {
    "date": "13.12.2016",
    "now": "3,4898",
    "open": "3,4688",
    "highest": "3,5054",
    "lower": "3,4515",
    "difference": "0,61%"
  },
  {
    "date": "12.12.2016",
    "now": "3,4688",
    "open": "3,4816",
    "highest": "3,5495",
    "lower": "3,4654",
    "difference": "-0,52%"
  },
  {
    "date": "09.12.2016",
    "now": "3,4869",
    "open": "3,4422",
    "highest": "3,5058",
    "lower": "3,4185",
    "difference": "1,27%"
  },
  {
    "date": "08.12.2016",
    "now": "3,4433",
    "open": "3,3892",
    "highest": "3,4970",
    "lower": "3,3384",
    "difference": "1,57%"
  },
  {
    "date": "07.12.2016",
    "now": "3,3902",
    "open": "3,4470",
    "highest": "3,4600",
    "lower": "3,3803",
    "difference": "-1,61%"
  },
  {
    "date": "06.12.2016",
    "now": "3,4456",
    "open": "3,5226",
    "highest": "3,5415",
    "lower": "3,4312",
    "difference": "-2,20%"
  },
  {
    "date": "05.12.2016",
    "now": "3,5231",
    "open": "3,5200",
    "highest": "3,5626",
    "lower": "3,5149",
    "difference": "0,12%"
  },
  {
    "date": "02.12.2016",
    "now": "3,5190",
    "open": "3,5042",
    "highest": "3,5860",
    "lower": "3,4822",
    "difference": "0,44%"
  },
  {
    "date": "01.12.2016",
    "now": "3,5037",
    "open": "3,4365",
    "highest": "3,5064",
    "lower": "3,4255",
    "difference": "1,94%"
  },
  {
    "date": "30.11.2016",
    "now": "3,4370",
    "open": "3,4083",
    "highest": "3,4421",
    "lower": "3,4045",
    "difference": "0,83%"
  },
  {
    "date": "29.11.2016",
    "now": "3,4088",
    "open": "3,4143",
    "highest": "3,4350",
    "lower": "3,4045",
    "difference": "-0,18%"
  },
  {
    "date": "28.11.2016",
    "now": "3,4148",
    "open": "3,4515",
    "highest": "3,4579",
    "lower": "3,4071",
    "difference": "-0,93%"
  },
  {
    "date": "25.11.2016",
    "now": "3,4467",
    "open": "3,4458",
    "highest": "3,4764",
    "lower": "3,4341",
    "difference": "0,03%"
  },
  {
    "date": "24.11.2016",
    "now": "3,4455",
    "open": "3,3967",
    "highest": "3,4546",
    "lower": "3,3697",
    "difference": "1,51%"
  },
  {
    "date": "23.11.2016",
    "now": "3,3941",
    "open": "3,3854",
    "highest": "3,4181",
    "lower": "3,3681",
    "difference": "0,29%"
  },
  {
    "date": "22.11.2016",
    "now": "3,3844",
    "open": "3,3616",
    "highest": "3,3943",
    "lower": "3,3500",
    "difference": "0,68%"
  },
  {
    "date": "21.11.2016",
    "now": "3,3616",
    "open": "3,3735",
    "highest": "3,3960",
    "lower": "3,3500",
    "difference": "-0,41%"
  },
  {
    "date": "18.11.2016",
    "now": "3,3753",
    "open": "3,3701",
    "highest": "3,4088",
    "lower": "3,3540",
    "difference": "0,14%"
  },
  {
    "date": "17.11.2016",
    "now": "3,3706",
    "open": "3,3238",
    "highest": "3,3782",
    "lower": "3,3080",
    "difference": "1,42%"
  },
  {
    "date": "16.11.2016",
    "now": "3,3234",
    "open": "3,2916",
    "highest": "3,3298",
    "lower": "3,2835",
    "difference": "1,00%"
  },
  {
    "date": "15.11.2016",
    "now": "3,2906",
    "open": "3,2900",
    "highest": "3,2985",
    "lower": "3,2630",
    "difference": "0,02%"
  },
  {
    "date": "14.11.2016",
    "now": "3,2900",
    "open": "3,2510",
    "highest": "3,2995",
    "lower": "3,2440",
    "difference": "1,16%"
  },
  {
    "date": "11.11.2016",
    "now": "3,2522",
    "open": "3,2510",
    "highest": "3,2795",
    "lower": "3,2340",
    "difference": "0,04%"
  },
  {
    "date": "10.11.2016",
    "now": "3,2509",
    "open": "3,2094",
    "highest": "3,2635",
    "lower": "3,1928",
    "difference": "1,28%"
  },
  {
    "date": "09.11.2016",
    "now": "3,2099",
    "open": "3,1550",
    "highest": "3,2905",
    "lower": "3,1540",
    "difference": "1,74%"
  },
  {
    "date": "08.11.2016",
    "now": "3,1550",
    "open": "3,1680",
    "highest": "3,1859",
    "lower": "3,1515",
    "difference": "-0,41%"
  },
  {
    "date": "07.11.2016",
    "now": "3,1681",
    "open": "3,1568",
    "highest": "3,1806",
    "lower": "3,1420",
    "difference": "0,35%"
  },
  {
    "date": "04.11.2016",
    "now": "3,1569",
    "open": "3,1101",
    "highest": "3,1755",
    "lower": "3,1091",
    "difference": "1,50%"
  },
  {
    "date": "03.11.2016",
    "now": "3,1101",
    "open": "3,1150",
    "highest": "3,1242",
    "lower": "3,1038",
    "difference": "-0,12%"
  },
  {
    "date": "02.11.2016",
    "now": "3,1138",
    "open": "3,1123",
    "highest": "3,1265",
    "lower": "3,1080",
    "difference": "0,07%"
  },
  {
    "date": "01.11.2016",
    "now": "3,1116",
    "open": "3,0938",
    "highest": "3,1229",
    "lower": "3,0909",
    "difference": "0,57%"
  },
  {
    "date": "31.10.2016",
    "now": "3,0939",
    "open": "3,1033",
    "highest": "3,1172",
    "lower": "3,0913",
    "difference": "-0,42%"
  },
  {
    "date": "28.10.2016",
    "now": "3,1069",
    "open": "3,1138",
    "highest": "3,1283",
    "lower": "3,1030",
    "difference": "-0,22%"
  },
  {
    "date": "27.10.2016",
    "now": "3,1138",
    "open": "3,0808",
    "highest": "3,1152",
    "lower": "3,0796",
    "difference": "1,05%"
  },
  {
    "date": "26.10.2016",
    "now": "3,0813",
    "open": "3,0711",
    "highest": "3,0910",
    "lower": "3,0680",
    "difference": "0,33%"
  },
  {
    "date": "25.10.2016",
    "now": "3,0711",
    "open": "3,0745",
    "highest": "3,0913",
    "lower": "3,0685",
    "difference": "-0,16%"
  },
  {
    "date": "24.10.2016",
    "now": "3,0760",
    "open": "3,0839",
    "highest": "3,0895",
    "lower": "3,0685",
    "difference": "-0,18%"
  },
  {
    "date": "21.10.2016",
    "now": "3,0814",
    "open": "3,0602",
    "highest": "3,0905",
    "lower": "3,0537",
    "difference": "0,70%"
  },
  {
    "date": "20.10.2016",
    "now": "3,0601",
    "open": "3,0605",
    "highest": "3,0767",
    "lower": "3,0510",
    "difference": "-0,05%"
  },
  {
    "date": "19.10.2016",
    "now": "3,0616",
    "open": "3,0941",
    "highest": "3,0981",
    "lower": "3,0535",
    "difference": "-1,09%"
  },
  {
    "date": "18.10.2016",
    "now": "3,0953",
    "open": "3,0963",
    "highest": "3,1145",
    "lower": "3,0870",
    "difference": "-0,02%"
  },
  {
    "date": "17.10.2016",
    "now": "3,0960",
    "open": "3,0855",
    "highest": "3,1130",
    "lower": "3,0855",
    "difference": "0,18%"
  },
  {
    "date": "14.10.2016",
    "now": "3,0905",
    "open": "3,0873",
    "highest": "3,0997",
    "lower": "3,0698",
    "difference": "0,15%"
  },
  {
    "date": "13.10.2016",
    "now": "3,0858",
    "open": "3,0848",
    "highest": "3,1140",
    "lower": "3,0785",
    "difference": "0,02%"
  },
  {
    "date": "12.10.2016",
    "now": "3,0853",
    "open": "3,0835",
    "highest": "3,0981",
    "lower": "3,0704",
    "difference": "0,04%"
  },
  {
    "date": "11.10.2016",
    "now": "3,0840",
    "open": "3,0713",
    "highest": "3,0896",
    "lower": "3,0665",
    "difference": "0,40%"
  },
  {
    "date": "10.10.2016",
    "now": "3,0718",
    "open": "3,0498",
    "highest": "3,0786",
    "lower": "3,0415",
    "difference": "0,68%"
  },
  {
    "date": "07.10.2016",
    "now": "3,0510",
    "open": "3,0398",
    "highest": "3,0644",
    "lower": "3,0330",
    "difference": "0,37%"
  },
  {
    "date": "06.10.2016",
    "now": "3,0397",
    "open": "3,0516",
    "highest": "3,0610",
    "lower": "3,0380",
    "difference": "-0,39%"
  },
  {
    "date": "05.10.2016",
    "now": "3,0516",
    "open": "3,0598",
    "highest": "3,0664",
    "lower": "3,0479",
    "difference": "-0,20%"
  },
  {
    "date": "04.10.2016",
    "now": "3,0578",
    "open": "3,0193",
    "highest": "3,0663",
    "lower": "3,0173",
    "difference": "1,29%"
  },
  {
    "date": "03.10.2016",
    "now": "3,0188",
    "open": "3,0020",
    "highest": "3,0280",
    "lower": "2,9979",
    "difference": "0,65%"
  },
  {
    "date": "30.09.2016",
    "now": "2,9992",
    "open": "2,9998",
    "highest": "3,0128",
    "lower": "2,9945",
    "difference": "-0,02%"
  },
  {
    "date": "29.09.2016",
    "now": "2,9997",
    "open": "2,9799",
    "highest": "3,0106",
    "lower": "2,9766",
    "difference": "0,67%"
  },
  {
    "date": "28.09.2016",
    "now": "2,9798",
    "open": "2,9741",
    "highest": "2,9898",
    "lower": "2,9705",
    "difference": "0,17%"
  },
  {
    "date": "27.09.2016",
    "now": "2,9746",
    "open": "2,9805",
    "highest": "2,9860",
    "lower": "2,9638",
    "difference": "-0,21%"
  },
  {
    "date": "26.09.2016",
    "now": "2,9810",
    "open": "2,9917",
    "highest": "2,9991",
    "lower": "2,9720",
    "difference": "0,47%"
  },
  {
    "date": "23.09.2016",
    "now": "2,9672",
    "open": "2,9425",
    "highest": "2,9683",
    "lower": "2,9406",
    "difference": "0,79%"
  },
  {
    "date": "22.09.2016",
    "now": "2,9440",
    "open": "2,9556",
    "highest": "2,9585",
    "lower": "2,9378",
    "difference": "-0,38%"
  },
  {
    "date": "21.09.2016",
    "now": "2,9551",
    "open": "2,9779",
    "highest": "2,9886",
    "lower": "2,9493",
    "difference": "-0,78%"
  },
  {
    "date": "20.09.2016",
    "now": "2,9782",
    "open": "2,9763",
    "highest": "2,9824",
    "lower": "2,9703",
    "difference": "0,04%"
  },
  {
    "date": "19.09.2016",
    "now": "2,9771",
    "open": "2,9836",
    "highest": "2,9851",
    "lower": "2,9702",
    "difference": "-0,13%"
  },
  {
    "date": "16.09.2016",
    "now": "2,9809",
    "open": "2,9682",
    "highest": "2,9860",
    "lower": "2,9610",
    "difference": "0,41%"
  },
  {
    "date": "15.09.2016",
    "now": "2,9687",
    "open": "2,9798",
    "highest": "2,9890",
    "lower": "2,9625",
    "difference": "-0,36%"
  },
  {
    "date": "14.09.2016",
    "now": "2,9794",
    "open": "2,9841",
    "highest": "2,9882",
    "lower": "2,9725",
    "difference": "-0,17%"
  },
  {
    "date": "13.09.2016",
    "now": "2,9846",
    "open": "2,9677",
    "highest": "2,9897",
    "lower": "2,9615",
    "difference": "0,58%"
  },
  {
    "date": "12.09.2016",
    "now": "2,9675",
    "open": "2,9693",
    "highest": "2,9939",
    "lower": "2,9615",
    "difference": "0,15%"
  },
  {
    "date": "09.09.2016",
    "now": "2,9630",
    "open": "2,9528",
    "highest": "2,9797",
    "lower": "2,9470",
    "difference": "0,40%"
  },
  {
    "date": "08.09.2016",
    "now": "2,9512",
    "open": "2,9363",
    "highest": "2,9570",
    "lower": "2,9289",
    "difference": "0,50%"
  },
  {
    "date": "07.09.2016",
    "now": "2,9364",
    "open": "2,9225",
    "highest": "2,9440",
    "lower": "2,9185",
    "difference": "0,48%"
  },
  {
    "date": "06.09.2016",
    "now": "2,9224",
    "open": "2,9457",
    "highest": "2,9485",
    "lower": "2,9196",
    "difference": "-0,79%"
  },
  {
    "date": "05.09.2016",
    "now": "2,9457",
    "open": "2,9491",
    "highest": "2,9521",
    "lower": "2,9401",
    "difference": "-0,18%"
  },
  {
    "date": "02.09.2016",
    "now": "2,9509",
    "open": "2,9611",
    "highest": "2,9669",
    "lower": "2,9411",
    "difference": "-0,35%"
  },
  {
    "date": "01.09.2016",
    "now": "2,9612",
    "open": "2,9580",
    "highest": "2,9730",
    "lower": "2,9536",
    "difference": "0,11%"
  },
  {
    "date": "31.08.2016",
    "now": "2,9580",
    "open": "2,9630",
    "highest": "2,9669",
    "lower": "2,9520",
    "difference": "-0,17%"
  },
  {
    "date": "30.08.2016",
    "now": "2,9631",
    "open": "2,9502",
    "highest": "2,9679",
    "lower": "2,9485",
    "difference": "0,42%"
  },
  {
    "date": "29.08.2016",
    "now": "2,9507",
    "open": "2,9569",
    "highest": "2,9613",
    "lower": "2,9475",
    "difference": "-0,10%"
  },
  {
    "date": "26.08.2016",
    "now": "2,9538",
    "open": "2,9339",
    "highest": "2,9597",
    "lower": "2,9220",
    "difference": "0,66%"
  },
  {
    "date": "25.08.2016",
    "now": "2,9344",
    "open": "2,9518",
    "highest": "2,9545",
    "lower": "2,9309",
    "difference": "-0,59%"
  },
  {
    "date": "24.08.2016",
    "now": "2,9517",
    "open": "2,9520",
    "highest": "2,9691",
    "lower": "2,9440",
    "difference": "0,02%"
  },
  {
    "date": "23.08.2016",
    "now": "2,9510",
    "open": "2,9429",
    "highest": "2,9561",
    "lower": "2,9295",
    "difference": "0,31%"
  },
  {
    "date": "22.08.2016",
    "now": "2,9419",
    "open": "2,9301",
    "highest": "2,9518",
    "lower": "2,9276",
    "difference": "0,43%"
  },
  {
    "date": "19.08.2016",
    "now": "2,9293",
    "open": "2,9267",
    "highest": "2,9453",
    "lower": "2,9240",
    "difference": "0,07%"
  },
  {
    "date": "18.08.2016",
    "now": "2,9273",
    "open": "2,9217",
    "highest": "2,9360",
    "lower": "2,9128",
    "difference": "0,17%"
  },
  {
    "date": "17.08.2016",
    "now": "2,9222",
    "open": "2,9290",
    "highest": "2,9410",
    "lower": "2,9173",
    "difference": "-0,25%"
  },
  {
    "date": "16.08.2016",
    "now": "2,9295",
    "open": "2,9402",
    "highest": "2,9439",
    "lower": "2,9141",
    "difference": "-0,38%"
  },
  {
    "date": "15.08.2016",
    "now": "2,9407",
    "open": "2,9572",
    "highest": "2,9617",
    "lower": "2,9387",
    "difference": "-0,63%"
  },
  {
    "date": "12.08.2016",
    "now": "2,9594",
    "open": "2,9573",
    "highest": "2,9649",
    "lower": "2,9425",
    "difference": "0,07%"
  },
  {
    "date": "11.08.2016",
    "now": "2,9573",
    "open": "2,9571",
    "highest": "2,9710",
    "lower": "2,9503",
    "difference": "-0,01%"
  },
  {
    "date": "10.08.2016",
    "now": "2,9576",
    "open": "2,9679",
    "highest": "2,9707",
    "lower": "2,9441",
    "difference": "-0,36%"
  },
  {
    "date": "09.08.2016",
    "now": "2,9682",
    "open": "2,9823",
    "highest": "2,9891",
    "lower": "2,9661",
    "difference": "-0,55%"
  },
  {
    "date": "08.08.2016",
    "now": "2,9845",
    "open": "3,0018",
    "highest": "3,0055",
    "lower": "2,9796",
    "difference": "-0,47%"
  },
  {
    "date": "05.08.2016",
    "now": "2,9987",
    "open": "3,0106",
    "highest": "3,0206",
    "lower": "2,9950",
    "difference": "-0,41%"
  },
  {
    "date": "04.08.2016",
    "now": "3,0111",
    "open": "3,0133",
    "highest": "3,0285",
    "lower": "3,0065",
    "difference": "-0,09%"
  },
  {
    "date": "03.08.2016",
    "now": "3,0139",
    "open": "2,9926",
    "highest": "3,0231",
    "lower": "2,9909",
    "difference": "0,75%"
  },
  {
    "date": "02.08.2016",
    "now": "2,9915",
    "open": "2,9911",
    "highest": "3,0036",
    "lower": "2,9810",
    "difference": "0,04%"
  },
  {
    "date": "01.08.2016",
    "now": "2,9904",
    "open": "2,9936",
    "highest": "2,9984",
    "lower": "2,9708",
    "difference": "0,07%"
  },
  {
    "date": "29.07.2016",
    "now": "2,9883",
    "open": "3,0124",
    "highest": "3,0259",
    "lower": "2,9845",
    "difference": "-0,81%"
  },
  {
    "date": "28.07.2016",
    "now": "3,0126",
    "open": "3,0182",
    "highest": "3,0252",
    "lower": "3,0070",
    "difference": "-0,20%"
  },
  {
    "date": "27.07.2016",
    "now": "3,0187",
    "open": "3,0453",
    "highest": "3,0495",
    "lower": "3,0145",
    "difference": "-0,87%"
  },
  {
    "date": "26.07.2016",
    "now": "3,0453",
    "open": "3,0380",
    "highest": "3,0526",
    "lower": "3,0170",
    "difference": "0,28%"
  },
  {
    "date": "25.07.2016",
    "now": "3,0369",
    "open": "3,0655",
    "highest": "3,0755",
    "lower": "3,0200",
    "difference": "-0,92%"
  },
  {
    "date": "22.07.2016",
    "now": "3,0650",
    "open": "3,0716",
    "highest": "3,0819",
    "lower": "3,0403",
    "difference": "-0,18%"
  },
  {
    "date": "21.07.2016",
    "now": "3,0706",
    "open": "3,0894",
    "highest": "3,0943",
    "lower": "3,0490",
    "difference": "-0,62%"
  },
  {
    "date": "20.07.2016",
    "now": "3,0899",
    "open": "3,0435",
    "highest": "3,0965",
    "lower": "3,0100",
    "difference": "1,47%"
  },
  {
    "date": "19.07.2016",
    "now": "3,0450",
    "open": "2,9800",
    "highest": "3,0630",
    "lower": "2,9675",
    "difference": "2,26%"
  },
  {
    "date": "18.07.2016",
    "now": "2,9777",
    "open": "3,0199",
    "highest": "3,0199",
    "lower": "2,9235",
    "difference": "-1,39%"
  },
  {
    "date": "15.07.2016",
    "now": "3,0198",
    "open": "2,8774",
    "highest": "3,0486",
    "lower": "2,8765",
    "difference": "4,92%"
  },
  {
    "date": "14.07.2016",
    "now": "2,8782",
    "open": "2,8990",
    "highest": "2,9050",
    "lower": "2,8761",
    "difference": "-0,74%"
  },
  {
    "date": "13.07.2016",
    "now": "2,8998",
    "open": "2,8854",
    "highest": "2,9089",
    "lower": "2,8849",
    "difference": "0,44%"
  },
  {
    "date": "12.07.2016",
    "now": "2,8870",
    "open": "2,9045",
    "highest": "2,9065",
    "lower": "2,8815",
    "difference": "-0,60%"
  },
  {
    "date": "11.07.2016",
    "now": "2,9045",
    "open": "2,8914",
    "highest": "2,9080",
    "lower": "2,8870",
    "difference": "0,46%"
  },
  {
    "date": "08.07.2016",
    "now": "2,8913",
    "open": "2,9378",
    "highest": "2,9410",
    "lower": "2,8862",
    "difference": "-1,55%"
  },
  {
    "date": "07.07.2016",
    "now": "2,9367",
    "open": "2,9371",
    "highest": "2,9431",
    "lower": "2,9225",
    "difference": "-0,01%"
  },
  {
    "date": "06.07.2016",
    "now": "2,9371",
    "open": "2,9297",
    "highest": "2,9560",
    "lower": "2,9235",
    "difference": "0,27%"
  },
  {
    "date": "05.07.2016",
    "now": "2,9293",
    "open": "2,9068",
    "highest": "2,9354",
    "lower": "2,9015",
    "difference": "0,78%"
  },
  {
    "date": "04.07.2016",
    "now": "2,9066",
    "open": "2,9029",
    "highest": "2,9093",
    "lower": "2,8805",
    "difference": "0,16%"
  },
  {
    "date": "01.07.2016",
    "now": "2,9019",
    "open": "2,8766",
    "highest": "2,9042",
    "lower": "2,8697",
    "difference": "0,84%"
  },
  {
    "date": "30.06.2016",
    "now": "2,8777",
    "open": "2,8918",
    "highest": "2,9064",
    "lower": "2,8689",
    "difference": "-0,40%"
  },
  {
    "date": "29.06.2016",
    "now": "2,8892",
    "open": "2,9038",
    "highest": "2,9105",
    "lower": "2,8833",
    "difference": "-0,52%"
  },
  {
    "date": "28.06.2016",
    "now": "2,9043",
    "open": "2,9390",
    "highest": "2,9415",
    "lower": "2,8873",
    "difference": "-1,25%"
  },
  {
    "date": "27.06.2016",
    "now": "2,9410",
    "open": "2,9285",
    "highest": "2,9538",
    "lower": "2,9218",
    "difference": "0,40%"
  },
  {
    "date": "24.06.2016",
    "now": "2,9292",
    "open": "2,8522",
    "highest": "3,0057",
    "lower": "2,8403",
    "difference": "2,61%"
  },
  {
    "date": "23.06.2016",
    "now": "2,8548",
    "open": "2,8956",
    "highest": "2,8986",
    "lower": "2,8527",
    "difference": "-1,34%"
  },
  {
    "date": "22.06.2016",
    "now": "2,8936",
    "open": "2,9106",
    "highest": "2,9190",
    "lower": "2,8901",
    "difference": "-0,55%"
  },
  {
    "date": "21.06.2016",
    "now": "2,9097",
    "open": "2,9060",
    "highest": "2,9159",
    "lower": "2,8919",
    "difference": "0,12%"
  },
  {
    "date": "20.06.2016",
    "now": "2,9062",
    "open": "2,9316",
    "highest": "2,9316",
    "lower": "2,8960",
    "difference": "-0,71%"
  },
  {
    "date": "17.06.2016",
    "now": "2,9271",
    "open": "2,9324",
    "highest": "2,9381",
    "lower": "2,9242",
    "difference": "-0,13%"
  },
  {
    "date": "16.06.2016",
    "now": "2,9310",
    "open": "2,9250",
    "highest": "2,9600",
    "lower": "2,9210",
    "difference": "0,21%"
  },
  {
    "date": "15.06.2016",
    "now": "2,9250",
    "open": "2,9370",
    "highest": "2,9405",
    "lower": "2,9160",
    "difference": "-0,34%"
  },
  {
    "date": "14.06.2016",
    "now": "2,9350",
    "open": "2,9198",
    "highest": "2,9420",
    "lower": "2,9132",
    "difference": "0,53%"
  },
  {
    "date": "13.06.2016",
    "now": "2,9196",
    "open": "2,9293",
    "highest": "2,9350",
    "lower": "2,9084",
    "difference": "-0,32%"
  },
  {
    "date": "10.06.2016",
    "now": "2,9291",
    "open": "2,8922",
    "highest": "2,9398",
    "lower": "2,8922",
    "difference": "1,29%"
  },
  {
    "date": "09.06.2016",
    "now": "2,8919",
    "open": "2,8914",
    "highest": "2,9026",
    "lower": "2,8858",
    "difference": "-0,04%"
  },
  {
    "date": "08.06.2016",
    "now": "2,8931",
    "open": "2,8966",
    "highest": "2,9013",
    "lower": "2,8790",
    "difference": "-0,14%"
  },
  {
    "date": "07.06.2016",
    "now": "2,8971",
    "open": "2,9044",
    "highest": "2,9125",
    "lower": "2,8915",
    "difference": "-0,23%"
  },
  {
    "date": "06.06.2016",
    "now": "2,9039",
    "open": "2,9112",
    "highest": "2,9172",
    "lower": "2,9023",
    "difference": "0,04%"
  },
  {
    "date": "03.06.2016",
    "now": "2,9028",
    "open": "2,9488",
    "highest": "2,9538",
    "lower": "2,9009",
    "difference": "-1,56%"
  },
  {
    "date": "02.06.2016",
    "now": "2,9488",
    "open": "2,9421",
    "highest": "2,9546",
    "lower": "2,9336",
    "difference": "0,23%"
  },
  {
    "date": "01.06.2016",
    "now": "2,9419",
    "open": "2,9499",
    "highest": "2,9585",
    "lower": "2,9325",
    "difference": "-0,25%"
  },
  {
    "date": "31.05.2016",
    "now": "2,9494",
    "open": "2,9550",
    "highest": "2,9604",
    "lower": "2,9425",
    "difference": "-0,22%"
  },
  {
    "date": "30.05.2016",
    "now": "2,9560",
    "open": "2,9575",
    "highest": "2,9700",
    "lower": "2,9477",
    "difference": "-0,05%"
  },
  {
    "date": "27.05.2016",
    "now": "2,9575",
    "open": "2,9341",
    "highest": "2,9639",
    "lower": "2,9330",
    "difference": "0,78%"
  },
  {
    "date": "26.05.2016",
    "now": "2,9345",
    "open": "2,9372",
    "highest": "2,9480",
    "lower": "2,9240",
    "difference": "-0,08%"
  },
  {
    "date": "25.05.2016",
    "now": "2,9368",
    "open": "2,9435",
    "highest": "2,9550",
    "lower": "2,9290",
    "difference": "-0,26%"
  },
  {
    "date": "24.05.2016",
    "now": "2,9445",
    "open": "2,9962",
    "highest": "3,0145",
    "lower": "2,9405",
    "difference": "-1,69%"
  },
  {
    "date": "23.05.2016",
    "now": "2,9952",
    "open": "2,9770",
    "highest": "2,9985",
    "lower": "2,9729",
    "difference": "0,64%"
  },
  {
    "date": "20.05.2016",
    "now": "2,9762",
    "open": "2,9850",
    "highest": "2,9915",
    "lower": "2,9670",
    "difference": "-0,36%"
  },
  {
    "date": "19.05.2016",
    "now": "2,9870",
    "open": "2,9905",
    "highest": "3,0040",
    "lower": "2,9820",
    "difference": "-0,11%"
  },
  {
    "date": "18.05.2016",
    "now": "2,9902",
    "open": "2,9631",
    "highest": "2,9942",
    "lower": "2,9600",
    "difference": "0,89%"
  },
  {
    "date": "17.05.2016",
    "now": "2,9637",
    "open": "2,9762",
    "highest": "2,9774",
    "lower": "2,9570",
    "difference": "-0,44%"
  },
  {
    "date": "16.05.2016",
    "now": "2,9767",
    "open": "2,9670",
    "highest": "2,9878",
    "lower": "2,9588",
    "difference": "0,22%"
  },
  {
    "date": "13.05.2016",
    "now": "2,9702",
    "open": "2,9605",
    "highest": "2,9755",
    "lower": "2,9510",
    "difference": "0,27%"
  },
  {
    "date": "12.05.2016",
    "now": "2,9623",
    "open": "2,9545",
    "highest": "2,9671",
    "lower": "2,9398",
    "difference": "0,33%"
  },
  {
    "date": "11.05.2016",
    "now": "2,9527",
    "open": "2,9502",
    "highest": "2,9760",
    "lower": "2,9400",
    "difference": "0,04%"
  },
  {
    "date": "10.05.2016",
    "now": "2,9516",
    "open": "2,9440",
    "highest": "2,9581",
    "lower": "2,9291",
    "difference": "0,23%"
  },
  {
    "date": "09.05.2016",
    "now": "2,9449",
    "open": "2,9277",
    "highest": "2,9503",
    "lower": "2,9110",
    "difference": "0,60%"
  },
  {
    "date": "06.05.2016",
    "now": "2,9273",
    "open": "2,9226",
    "highest": "2,9436",
    "lower": "2,9080",
    "difference": "0,11%"
  },
  {
    "date": "05.05.2016",
    "now": "2,9242",
    "open": "2,9623",
    "highest": "2,9623",
    "lower": "2,8937",
    "difference": "-1,29%"
  },
  {
    "date": "04.05.2016",
    "now": "2,9625",
    "open": "2,8508",
    "highest": "2,9788",
    "lower": "2,8438",
    "difference": "3,98%"
  },
  {
    "date": "03.05.2016",
    "now": "2,8491",
    "open": "2,8046",
    "highest": "2,8518",
    "lower": "2,7885",
    "difference": "1,58%"
  },
  {
    "date": "02.05.2016",
    "now": "2,8049",
    "open": "2,7954",
    "highest": "2,8077",
    "lower": "2,7880",
    "difference": "0,34%"
  },
  {
    "date": "29.04.2016",
    "now": "2,7955",
    "open": "2,8125",
    "highest": "2,8150",
    "lower": "2,7880",
    "difference": "-0,62%"
  },
  {
    "date": "28.04.2016",
    "now": "2,8129",
    "open": "2,8184",
    "highest": "2,8349",
    "lower": "2,8030",
    "difference": "-0,21%"
  },
  {
    "date": "27.04.2016",
    "now": "2,8189",
    "open": "2,8203",
    "highest": "2,8405",
    "lower": "2,8130",
    "difference": "-0,07%"
  },
  {
    "date": "26.04.2016",
    "now": "2,8208",
    "open": "2,8440",
    "highest": "2,8491",
    "lower": "2,8140",
    "difference": "-0,82%"
  },
  {
    "date": "25.04.2016",
    "now": "2,8440",
    "open": "2,8444",
    "highest": "2,8535",
    "lower": "2,8400",
    "difference": "-0,17%"
  },
  {
    "date": "22.04.2016",
    "now": "2,8489",
    "open": "2,8317",
    "highest": "2,8540",
    "lower": "2,8225",
    "difference": "0,56%"
  },
  {
    "date": "21.04.2016",
    "now": "2,8331",
    "open": "2,8149",
    "highest": "2,8362",
    "lower": "2,8084",
    "difference": "0,68%"
  },
  {
    "date": "20.04.2016",
    "now": "2,8140",
    "open": "2,8327",
    "highest": "2,8420",
    "lower": "2,8070",
    "difference": "-0,61%"
  },
  {
    "date": "19.04.2016",
    "now": "2,8312",
    "open": "2,8393",
    "highest": "2,8430",
    "lower": "2,8220",
    "difference": "-0,30%"
  },
  {
    "date": "18.04.2016",
    "now": "2,8398",
    "open": "2,8525",
    "highest": "2,8661",
    "lower": "2,8350",
    "difference": "-0,51%"
  },
  {
    "date": "15.04.2016",
    "now": "2,8545",
    "open": "2,8504",
    "highest": "2,8635",
    "lower": "2,8474",
    "difference": "0,16%"
  },
  {
    "date": "14.04.2016",
    "now": "2,8499",
    "open": "2,8462",
    "highest": "2,8720",
    "lower": "2,8420",
    "difference": "0,11%"
  },
  {
    "date": "13.04.2016",
    "now": "2,8467",
    "open": "2,8349",
    "highest": "2,8590",
    "lower": "2,8310",
    "difference": "0,40%"
  },
  {
    "date": "12.04.2016",
    "now": "2,8354",
    "open": "2,8326",
    "highest": "2,8490",
    "lower": "2,8180",
    "difference": "0,08%"
  },
  {
    "date": "11.04.2016",
    "now": "2,8331",
    "open": "2,8486",
    "highest": "2,8541",
    "lower": "2,8175",
    "difference": "-0,56%"
  },
  {
    "date": "08.04.2016",
    "now": "2,8491",
    "open": "2,8613",
    "highest": "2,8716",
    "lower": "2,8420",
    "difference": "-0,44%"
  },
  {
    "date": "07.04.2016",
    "now": "2,8618",
    "open": "2,8407",
    "highest": "2,8650",
    "lower": "2,8245",
    "difference": "0,75%"
  },
  {
    "date": "06.04.2016",
    "now": "2,8406",
    "open": "2,8319",
    "highest": "2,8590",
    "lower": "2,8220",
    "difference": "0,29%"
  },
  {
    "date": "05.04.2016",
    "now": "2,8324",
    "open": "2,8120",
    "highest": "2,8380",
    "lower": "2,8080",
    "difference": "0,70%"
  },
  {
    "date": "04.04.2016",
    "now": "2,8128",
    "open": "2,8247",
    "highest": "2,8291",
    "lower": "2,8047",
    "difference": "-0,33%"
  },
  {
    "date": "01.04.2016",
    "now": "2,8221",
    "open": "2,8165",
    "highest": "2,8370",
    "lower": "2,8128",
    "difference": "0,18%"
  },
  {
    "date": "31.03.2016",
    "now": "2,8170",
    "open": "2,8354",
    "highest": "2,8425",
    "lower": "2,8120",
    "difference": "-0,67%"
  },
  {
    "date": "30.03.2016",
    "now": "2,8359",
    "open": "2,8373",
    "highest": "2,8490",
    "lower": "2,8230",
    "difference": "-0,06%"
  },
  {
    "date": "29.03.2016",
    "now": "2,8377",
    "open": "2,8683",
    "highest": "2,8770",
    "lower": "2,8340",
    "difference": "-1,08%"
  },
  {
    "date": "28.03.2016",
    "now": "2,8688",
    "open": "2,8719",
    "highest": "2,8800",
    "lower": "2,8640",
    "difference": "-0,26%"
  },
  {
    "date": "25.03.2016",
    "now": "2,8763",
    "open": "2,8723",
    "highest": "2,8830",
    "lower": "2,8655",
    "difference": "0,14%"
  },
  {
    "date": "24.03.2016",
    "now": "2,8724",
    "open": "2,8759",
    "highest": "2,8910",
    "lower": "2,8697",
    "difference": "-0,18%"
  },
  {
    "date": "23.03.2016",
    "now": "2,8775",
    "open": "2,8672",
    "highest": "2,8829",
    "lower": "2,8635",
    "difference": "0,38%"
  },
  {
    "date": "22.03.2016",
    "now": "2,8667",
    "open": "2,8628",
    "highest": "2,8850",
    "lower": "2,8565",
    "difference": "0,29%"
  },
  {
    "date": "21.03.2016",
    "now": "2,8585",
    "open": "2,8636",
    "highest": "2,8815",
    "lower": "2,8550",
    "difference": "-0,32%"
  },
  {
    "date": "18.03.2016",
    "now": "2,8676",
    "open": "2,8398",
    "highest": "2,8694",
    "lower": "2,8380",
    "difference": "0,91%"
  },
  {
    "date": "17.03.2016",
    "now": "2,8417",
    "open": "2,8679",
    "highest": "2,8740",
    "lower": "2,8380",
    "difference": "-0,93%"
  },
  {
    "date": "16.03.2016",
    "now": "2,8684",
    "open": "2,8981",
    "highest": "2,9310",
    "lower": "2,8630",
    "difference": "-1,04%"
  },
  {
    "date": "15.03.2016",
    "now": "2,8986",
    "open": "2,8706",
    "highest": "2,9120",
    "lower": "2,8660",
    "difference": "0,98%"
  },
  {
    "date": "14.03.2016",
    "now": "2,8704",
    "open": "2,8685",
    "highest": "2,8880",
    "lower": "2,8620",
    "difference": "0,12%"
  },
  {
    "date": "11.03.2016",
    "now": "2,8670",
    "open": "2,8915",
    "highest": "2,8980",
    "lower": "2,8636",
    "difference": "-0,85%"
  },
  {
    "date": "10.03.2016",
    "now": "2,8915",
    "open": "2,8923",
    "highest": "2,9100",
    "lower": "2,8725",
    "difference": "0,03%"
  },
  {
    "date": "09.03.2016",
    "now": "2,8907",
    "open": "2,9162",
    "highest": "2,9212",
    "lower": "2,8867",
    "difference": "-0,81%"
  },
  {
    "date": "08.03.2016",
    "now": "2,9144",
    "open": "2,9146",
    "highest": "2,9306",
    "lower": "2,9061",
    "difference": "-0,05%"
  },
  {
    "date": "07.03.2016",
    "now": "2,9160",
    "open": "2,9089",
    "highest": "2,9326",
    "lower": "2,9039",
    "difference": "0,27%"
  },
  {
    "date": "04.03.2016",
    "now": "2,9082",
    "open": "2,9097",
    "highest": "2,9277",
    "lower": "2,9017",
    "difference": "-0,02%"
  },
  {
    "date": "03.03.2016",
    "now": "2,9088",
    "open": "2,9266",
    "highest": "2,9347",
    "lower": "2,9067",
    "difference": "-0,56%"
  },
  {
    "date": "02.03.2016",
    "now": "2,9253",
    "open": "2,9364",
    "highest": "2,9481",
    "lower": "2,9230",
    "difference": "-0,37%"
  },
  {
    "date": "01.03.2016",
    "now": "2,9361",
    "open": "2,9657",
    "highest": "2,9682",
    "lower": "2,9302",
    "difference": "-0,99%"
  },
  {
    "date": "29.02.2016",
    "now": "2,9654",
    "open": "2,9963",
    "highest": "2,9963",
    "lower": "2,9520",
    "difference": "-0,91%"
  },
  {
    "date": "26.02.2016",
    "now": "2,9925",
    "open": "2,9295",
    "highest": "3,0015",
    "lower": "2,9200",
    "difference": "2,20%"
  },
  {
    "date": "25.02.2016",
    "now": "2,9280",
    "open": "2,9358",
    "highest": "2,9428",
    "lower": "2,9170",
    "difference": "-0,28%"
  },
  {
    "date": "24.02.2016",
    "now": "2,9363",
    "open": "2,9437",
    "highest": "2,9550",
    "lower": "2,9320",
    "difference": "-0,25%"
  },
  {
    "date": "23.02.2016",
    "now": "2,9437",
    "open": "2,9368",
    "highest": "2,9470",
    "lower": "2,9270",
    "difference": "0,24%"
  },
  {
    "date": "22.02.2016",
    "now": "2,9367",
    "open": "2,9532",
    "highest": "2,9577",
    "lower": "2,9300",
    "difference": "-0,50%"
  },
  {
    "date": "19.02.2016",
    "now": "2,9516",
    "open": "2,9683",
    "highest": "2,9759",
    "lower": "2,9477",
    "difference": "-0,64%"
  },
  {
    "date": "18.02.2016",
    "now": "2,9705",
    "open": "2,9580",
    "highest": "2,9752",
    "lower": "2,9497",
    "difference": "0,49%"
  },
  {
    "date": "17.02.2016",
    "now": "2,9561",
    "open": "2,9754",
    "highest": "2,9843",
    "lower": "2,9410",
    "difference": "-0,72%"
  },
  {
    "date": "16.02.2016",
    "now": "2,9774",
    "open": "2,9466",
    "highest": "2,9818",
    "lower": "2,9420",
    "difference": "1,06%"
  },
  {
    "date": "15.02.2016",
    "now": "2,9461",
    "open": "2,9303",
    "highest": "2,9560",
    "lower": "2,9247",
    "difference": "0,57%"
  },
  {
    "date": "12.02.2016",
    "now": "2,9295",
    "open": "2,9307",
    "highest": "2,9398",
    "lower": "2,9177",
    "difference": "-0,05%"
  },
  {
    "date": "11.02.2016",
    "now": "2,9310",
    "open": "2,9223",
    "highest": "2,9470",
    "lower": "2,9160",
    "difference": "0,31%"
  },
  {
    "date": "10.02.2016",
    "now": "2,9218",
    "open": "2,9405",
    "highest": "2,9427",
    "lower": "2,9150",
    "difference": "-0,64%"
  },
  {
    "date": "09.02.2016",
    "now": "2,9407",
    "open": "2,9476",
    "highest": "2,9631",
    "lower": "2,9270",
    "difference": "-0,22%"
  },
  {
    "date": "08.02.2016",
    "now": "2,9473",
    "open": "2,9185",
    "highest": "2,9550",
    "lower": "2,9120",
    "difference": "0,82%"
  },
  {
    "date": "05.02.2016",
    "now": "2,9233",
    "open": "2,9135",
    "highest": "2,9268",
    "lower": "2,8918",
    "difference": "0,39%"
  },
  {
    "date": "04.02.2016",
    "now": "2,9118",
    "open": "2,9159",
    "highest": "2,9270",
    "lower": "2,8863",
    "difference": "-0,16%"
  },
  {
    "date": "03.02.2016",
    "now": "2,9164",
    "open": "2,9521",
    "highest": "2,9646",
    "lower": "2,9070",
    "difference": "-1,20%"
  },
  {
    "date": "02.02.2016",
    "now": "2,9519",
    "open": "2,9459",
    "highest": "2,9610",
    "lower": "2,9430",
    "difference": "0,21%"
  },
  {
    "date": "01.02.2016",
    "now": "2,9456",
    "open": "2,9561",
    "highest": "2,9780",
    "lower": "2,9410",
    "difference": "-0,33%"
  },
  {
    "date": "29.01.2016",
    "now": "2,9553",
    "open": "2,9694",
    "highest": "2,9780",
    "lower": "2,9510",
    "difference": "-0,47%"
  },
  {
    "date": "28.01.2016",
    "now": "2,9693",
    "open": "3,0014",
    "highest": "3,0030",
    "lower": "2,9650",
    "difference": "-1,07%"
  },
  {
    "date": "27.01.2016",
    "now": "3,0014",
    "open": "3,0083",
    "highest": "3,0190",
    "lower": "2,9850",
    "difference": "-0,25%"
  },
  {
    "date": "26.01.2016",
    "now": "3,0088",
    "open": "3,0209",
    "highest": "3,0356",
    "lower": "3,0020",
    "difference": "-0,42%"
  },
  {
    "date": "25.01.2016",
    "now": "3,0214",
    "open": "3,0010",
    "highest": "3,0245",
    "lower": "2,9984",
    "difference": "0,59%"
  },
  {
    "date": "22.01.2016",
    "now": "3,0038",
    "open": "3,0138",
    "highest": "3,0239",
    "lower": "3,0003",
    "difference": "-0,29%"
  },
  {
    "date": "21.01.2016",
    "now": "3,0126",
    "open": "3,0423",
    "highest": "3,0541",
    "lower": "3,0101",
    "difference": "-0,97%"
  },
  {
    "date": "20.01.2016",
    "now": "3,0422",
    "open": "3,0400",
    "highest": "3,0630",
    "lower": "3,0349",
    "difference": "0,07%"
  },
  {
    "date": "19.01.2016",
    "now": "3,0401",
    "open": "3,0342",
    "highest": "3,0466",
    "lower": "3,0167",
    "difference": "0,12%"
  },
  {
    "date": "18.01.2016",
    "now": "3,0365",
    "open": "3,0489",
    "highest": "3,0533",
    "lower": "3,0290",
    "difference": "-0,39%"
  },
  {
    "date": "15.01.2016",
    "now": "3,0484",
    "open": "3,0229",
    "highest": "3,0549",
    "lower": "3,0216",
    "difference": "0,82%"
  },
  {
    "date": "14.01.2016",
    "now": "3,0235",
    "open": "3,0265",
    "highest": "3,0435",
    "lower": "3,0165",
    "difference": "-0,17%"
  },
  {
    "date": "13.01.2016",
    "now": "3,0285",
    "open": "3,0345",
    "highest": "3,0365",
    "lower": "3,0050",
    "difference": "-0,15%"
  },
  {
    "date": "12.01.2016",
    "now": "3,0332",
    "open": "3,0377",
    "highest": "3,0490",
    "lower": "3,0215",
    "difference": "-0,15%"
  },
  {
    "date": "11.01.2016",
    "now": "3,0377",
    "open": "3,0207",
    "highest": "3,0437",
    "lower": "3,0090",
    "difference": "0,54%"
  },
  {
    "date": "08.01.2016",
    "now": "3,0214",
    "open": "2,9991",
    "highest": "3,0231",
    "lower": "2,9810",
    "difference": "0,74%"
  },
  {
    "date": "07.01.2016",
    "now": "2,9993",
    "open": "3,0007",
    "highest": "3,0290",
    "lower": "2,9850",
    "difference": "-0,10%"
  },
  {
    "date": "06.01.2016",
    "now": "3,0024",
    "open": "2,9849",
    "highest": "3,0160",
    "lower": "2,9820",
    "difference": "0,58%"
  },
  {
    "date": "05.01.2016",
    "now": "2,9852",
    "open": "2,9642",
    "highest": "2,9918",
    "lower": "2,9538",
    "difference": "0,71%"
  },
  {
    "date": "04.01.2016",
    "now": "2,9642",
    "open": "2,9185",
    "highest": "2,9810",
    "lower": "2,9137",
    "difference": "1,73%"
  },
  {
    "date": "01.01.2016",
    "now": "2,9139",
    "open": "2,9177",
    "highest": "2,9201",
    "lower": "2,9129",
    "difference": "-0,13%"
  },
  {
    "date": "31.12.2015",
    "now": "2,9177",
    "open": "2,9160",
    "highest": "2,9311",
    "lower": "2,9030",
    "difference": "-0,03%"
  },
  {
    "date": "30.12.2015",
    "now": "2,9185",
    "open": "2,9068",
    "highest": "2,9330",
    "lower": "2,9040",
    "difference": "0,42%"
  },
  {
    "date": "29.12.2015",
    "now": "2,9063",
    "open": "2,9060",
    "highest": "2,9155",
    "lower": "2,9010",
    "difference": "0,00%"
  },
  {
    "date": "28.12.2015",
    "now": "2,9062",
    "open": "2,9188",
    "highest": "2,9259",
    "lower": "2,9033",
    "difference": "-0,57%"
  },
  {
    "date": "25.12.2015",
    "now": "2,9230",
    "open": "2,9195",
    "highest": "2,9255",
    "lower": "2,9105",
    "difference": "0,15%"
  },
  {
    "date": "24.12.2015",
    "now": "2,9185",
    "open": "2,9164",
    "highest": "2,9272",
    "lower": "2,9120",
    "difference": "0,05%"
  },
  {
    "date": "23.12.2015",
    "now": "2,9169",
    "open": "2,9287",
    "highest": "2,9390",
    "lower": "2,9153",
    "difference": "-0,47%"
  },
  {
    "date": "22.12.2015",
    "now": "2,9307",
    "open": "2,9150",
    "highest": "2,9520",
    "lower": "2,9067",
    "difference": "0,56%"
  },
  {
    "date": "21.12.2015",
    "now": "2,9145",
    "open": "2,9084",
    "highest": "2,9235",
    "lower": "2,9025",
    "difference": "0,20%"
  },
  {
    "date": "18.12.2015",
    "now": "2,9088",
    "open": "2,9321",
    "highest": "2,9389",
    "lower": "2,9037",
    "difference": "-0,70%"
  },
  {
    "date": "17.12.2015",
    "now": "2,9292",
    "open": "2,9366",
    "highest": "2,9510",
    "lower": "2,9170",
    "difference": "-0,20%"
  },
  {
    "date": "16.12.2015",
    "now": "2,9352",
    "open": "2,9652",
    "highest": "2,9757",
    "lower": "2,9212",
    "difference": "-0,97%"
  },
  {
    "date": "15.12.2015",
    "now": "2,9640",
    "open": "2,9795",
    "highest": "2,9915",
    "lower": "2,9480",
    "difference": "-0,52%"
  },
  {
    "date": "14.12.2015",
    "now": "2,9796",
    "open": "2,9746",
    "highest": "2,9985",
    "lower": "2,9445",
    "difference": "-0,07%"
  },
  {
    "date": "11.12.2015",
    "now": "2,9817",
    "open": "2,9252",
    "highest": "2,9898",
    "lower": "2,9168",
    "difference": "1,99%"
  },
  {
    "date": "10.12.2015",
    "now": "2,9235",
    "open": "2,9161",
    "highest": "2,9296",
    "lower": "2,9010",
    "difference": "0,24%"
  },
  {
    "date": "09.12.2015",
    "now": "2,9165",
    "open": "2,9097",
    "highest": "2,9295",
    "lower": "2,9000",
    "difference": "0,22%"
  },
  {
    "date": "08.12.2015",
    "now": "2,9100",
    "open": "2,9130",
    "highest": "2,9258",
    "lower": "2,9008",
    "difference": "-0,12%"
  },
  {
    "date": "07.12.2015",
    "now": "2,9135",
    "open": "2,8937",
    "highest": "2,9180",
    "lower": "2,8760",
    "difference": "0,64%"
  },
  {
    "date": "04.12.2015",
    "now": "2,8950",
    "open": "2,8865",
    "highest": "2,9171",
    "lower": "2,8755",
    "difference": "0,36%"
  },
  {
    "date": "03.12.2015",
    "now": "2,8846",
    "open": "2,8895",
    "highest": "2,8980",
    "lower": "2,8680",
    "difference": "-0,16%"
  },
  {
    "date": "02.12.2015",
    "now": "2,8893",
    "open": "2,8907",
    "highest": "2,9010",
    "lower": "2,8700",
    "difference": "-0,05%"
  },
  {
    "date": "01.12.2015",
    "now": "2,8907",
    "open": "2,9136",
    "highest": "2,9146",
    "lower": "2,8760",
    "difference": "-0,77%"
  },
  {
    "date": "30.11.2015",
    "now": "2,9131",
    "open": "2,9211",
    "highest": "2,9365",
    "lower": "2,8950",
    "difference": "-0,39%"
  },
  {
    "date": "27.11.2015",
    "now": "2,9245",
    "open": "2,9218",
    "highest": "2,9353",
    "lower": "2,9080",
    "difference": "0,12%"
  },
  {
    "date": "26.11.2015",
    "now": "2,9211",
    "open": "2,8886",
    "highest": "2,9275",
    "lower": "2,8835",
    "difference": "1,13%"
  },
  {
    "date": "25.11.2015",
    "now": "2,8884",
    "open": "2,8774",
    "highest": "2,8941",
    "lower": "2,8720",
    "difference": "0,39%"
  },
  {
    "date": "24.11.2015",
    "now": "2,8773",
    "open": "2,8506",
    "highest": "2,8850",
    "lower": "2,8410",
    "difference": "0,93%"
  },
  {
    "date": "23.11.2015",
    "now": "2,8507",
    "open": "2,8292",
    "highest": "2,8538",
    "lower": "2,8258",
    "difference": "0,67%"
  },
  {
    "date": "20.11.2015",
    "now": "2,8317",
    "open": "2,8444",
    "highest": "2,8497",
    "lower": "2,8147",
    "difference": "-0,39%"
  },
  {
    "date": "19.11.2015",
    "now": "2,8427",
    "open": "2,8629",
    "highest": "2,8709",
    "lower": "2,8385",
    "difference": "-0,67%"
  },
  {
    "date": "18.11.2015",
    "now": "2,8619",
    "open": "2,8686",
    "highest": "2,8764",
    "lower": "2,8530",
    "difference": "-0,25%"
  },
  {
    "date": "17.11.2015",
    "now": "2,8691",
    "open": "2,8829",
    "highest": "2,8902",
    "lower": "2,8580",
    "difference": "-0,50%"
  },
  {
    "date": "16.11.2015",
    "now": "2,8834",
    "open": "2,8654",
    "highest": "2,8882",
    "lower": "2,8638",
    "difference": "0,69%"
  },
  {
    "date": "13.11.2015",
    "now": "2,8637",
    "open": "2,8646",
    "highest": "2,8786",
    "lower": "2,8550",
    "difference": "-0,05%"
  },
  {
    "date": "12.11.2015",
    "now": "2,8651",
    "open": "2,8743",
    "highest": "2,8920",
    "lower": "2,8565",
    "difference": "-0,34%"
  },
  {
    "date": "11.11.2015",
    "now": "2,8748",
    "open": "2,9148",
    "highest": "2,9158",
    "lower": "2,8714",
    "difference": "-1,41%"
  },
  {
    "date": "10.11.2015",
    "now": "2,9158",
    "open": "2,9228",
    "highest": "2,9263",
    "lower": "2,9028",
    "difference": "-0,17%"
  },
  {
    "date": "09.11.2015",
    "now": "2,9207",
    "open": "2,9135",
    "highest": "2,9289",
    "lower": "2,9110",
    "difference": "0,19%"
  },
  {
    "date": "06.11.2015",
    "now": "2,9153",
    "open": "2,8624",
    "highest": "2,9328",
    "lower": "2,8586",
    "difference": "1,91%"
  },
  {
    "date": "05.11.2015",
    "now": "2,8607",
    "open": "2,8626",
    "highest": "2,8779",
    "lower": "2,8540",
    "difference": "-0,08%"
  },
  {
    "date": "04.11.2015",
    "now": "2,8631",
    "open": "2,8278",
    "highest": "2,8700",
    "lower": "2,8220",
    "difference": "1,21%"
  },
  {
    "date": "03.11.2015",
    "now": "2,8290",
    "open": "2,8243",
    "highest": "2,8515",
    "lower": "2,8085",
    "difference": "0,18%"
  },
  {
    "date": "02.11.2015",
    "now": "2,8239",
    "open": "2,9154",
    "highest": "2,9156",
    "lower": "2,7550",
    "difference": "-3,13%"
  },
  {
    "date": "30.10.2015",
    "now": "2,9151",
    "open": "2,9380",
    "highest": "2,9422",
    "lower": "2,9070",
    "difference": "-0,76%"
  },
  {
    "date": "29.10.2015",
    "now": "2,9375",
    "open": "2,9242",
    "highest": "2,9435",
    "lower": "2,9151",
    "difference": "0,44%"
  },
  {
    "date": "28.10.2015",
    "now": "2,9247",
    "open": "2,9036",
    "highest": "2,9336",
    "lower": "2,8851",
    "difference": "0,71%"
  },
  {
    "date": "27.10.2015",
    "now": "2,9041",
    "open": "2,8904",
    "highest": "2,9180",
    "lower": "2,8853",
    "difference": "0,49%"
  },
  {
    "date": "26.10.2015",
    "now": "2,8900",
    "open": "2,9068",
    "highest": "2,9207",
    "lower": "2,8805",
    "difference": "-0,61%"
  },
  {
    "date": "23.10.2015",
    "now": "2,9078",
    "open": "2,8734",
    "highest": "2,9165",
    "lower": "2,8575",
    "difference": "1,23%"
  },
  {
    "date": "22.10.2015",
    "now": "2,8726",
    "open": "2,8951",
    "highest": "2,9026",
    "lower": "2,8622",
    "difference": "-0,79%"
  },
  {
    "date": "21.10.2015",
    "now": "2,8954",
    "open": "2,9005",
    "highest": "2,9155",
    "lower": "2,8902",
    "difference": "-0,17%"
  },
  {
    "date": "20.10.2015",
    "now": "2,9003",
    "open": "2,9062",
    "highest": "2,9101",
    "lower": "2,8839",
    "difference": "-0,18%"
  },
  {
    "date": "19.10.2015",
    "now": "2,9054",
    "open": "2,8943",
    "highest": "2,9075",
    "lower": "2,8775",
    "difference": "0,47%"
  },
  {
    "date": "16.10.2015",
    "now": "2,8917",
    "open": "2,8804",
    "highest": "2,9090",
    "lower": "2,8763",
    "difference": "0,40%"
  },
  {
    "date": "15.10.2015",
    "now": "2,8803",
    "open": "2,9138",
    "highest": "2,9148",
    "lower": "2,8750",
    "difference": "-1,15%"
  },
  {
    "date": "14.10.2015",
    "now": "2,9137",
    "open": "2,9581",
    "highest": "2,9640",
    "lower": "2,9100",
    "difference": "-1,52%"
  },
  {
    "date": "13.10.2015",
    "now": "2,9586",
    "open": "2,9259",
    "highest": "2,9620",
    "lower": "2,9230",
    "difference": "1,10%"
  },
  {
    "date": "12.10.2015",
    "now": "2,9264",
    "open": "2,9172",
    "highest": "2,9591",
    "lower": "2,9125",
    "difference": "0,50%"
  },
  {
    "date": "09.10.2015",
    "now": "2,9118",
    "open": "2,8938",
    "highest": "2,9212",
    "lower": "2,8878",
    "difference": "0,63%"
  },
  {
    "date": "08.10.2015",
    "now": "2,8935",
    "open": "2,9400",
    "highest": "2,9500",
    "lower": "2,8905",
    "difference": "-1,59%"
  },
  {
    "date": "07.10.2015",
    "now": "2,9402",
    "open": "2,9581",
    "highest": "2,9630",
    "lower": "2,9129",
    "difference": "-0,61%"
  },
  {
    "date": "06.10.2015",
    "now": "2,9583",
    "open": "2,9822",
    "highest": "2,9995",
    "lower": "2,9546",
    "difference": "-0,85%"
  },
  {
    "date": "05.10.2015",
    "now": "2,9837",
    "open": "2,9946",
    "highest": "3,0031",
    "lower": "2,9808",
    "difference": "-0,23%"
  },
  {
    "date": "02.10.2015",
    "now": "2,9906",
    "open": "3,0266",
    "highest": "3,0373",
    "lower": "2,9850",
    "difference": "-1,19%"
  },
  {
    "date": "01.10.2015",
    "now": "3,0267",
    "open": "3,0254",
    "highest": "3,0330",
    "lower": "3,0070",
    "difference": "0,03%"
  },
  {
    "date": "30.09.2015",
    "now": "3,0257",
    "open": "3,0369",
    "highest": "3,0443",
    "lower": "3,0155",
    "difference": "-0,37%"
  },
  {
    "date": "29.09.2015",
    "now": "3,0368",
    "open": "3,0557",
    "highest": "3,0705",
    "lower": "3,0305",
    "difference": "-0,69%"
  },
  {
    "date": "28.09.2015",
    "now": "3,0579",
    "open": "3,0471",
    "highest": "3,0625",
    "lower": "3,0270",
    "difference": "0,37%"
  },
  {
    "date": "25.09.2015",
    "now": "3,0467",
    "open": "3,0377",
    "highest": "3,0577",
    "lower": "3,0226",
    "difference": "0,21%"
  },
  {
    "date": "24.09.2015",
    "now": "3,0403",
    "open": "3,0386",
    "highest": "3,0754",
    "lower": "3,0271",
    "difference": "0,06%"
  },
  {
    "date": "23.09.2015",
    "now": "3,0385",
    "open": "3,0249",
    "highest": "3,0485",
    "lower": "3,0111",
    "difference": "0,41%"
  },
  {
    "date": "22.09.2015",
    "now": "3,0260",
    "open": "3,0065",
    "highest": "3,0410",
    "lower": "2,9870",
    "difference": "0,66%"
  },
  {
    "date": "21.09.2015",
    "now": "3,0062",
    "open": "3,0079",
    "highest": "3,0281",
    "lower": "2,9800",
    "difference": "0,04%"
  },
  {
    "date": "18.09.2015",
    "now": "3,0050",
    "open": "3,0124",
    "highest": "3,0152",
    "lower": "2,9756",
    "difference": "-0,25%"
  },
  {
    "date": "17.09.2015",
    "now": "3,0124",
    "open": "2,9988",
    "highest": "3,0295",
    "lower": "2,9747",
    "difference": "0,47%"
  },
  {
    "date": "16.09.2015",
    "now": "2,9984",
    "open": "3,0295",
    "highest": "3,0325",
    "lower": "2,9895",
    "difference": "-1,04%"
  },
  {
    "date": "15.09.2015",
    "now": "3,0300",
    "open": "3,0588",
    "highest": "3,0720",
    "lower": "3,0200",
    "difference": "-0,91%"
  },
  {
    "date": "14.09.2015",
    "now": "3,0578",
    "open": "3,0355",
    "highest": "3,0720",
    "lower": "3,0355",
    "difference": "0,37%"
  },
  {
    "date": "11.09.2015",
    "now": "3,0465",
    "open": "3,0225",
    "highest": "3,0610",
    "lower": "3,0159",
    "difference": "0,78%"
  },
  {
    "date": "10.09.2015",
    "now": "3,0228",
    "open": "3,0379",
    "highest": "3,0631",
    "lower": "3,0156",
    "difference": "-0,43%"
  },
  {
    "date": "09.09.2015",
    "now": "3,0360",
    "open": "3,0106",
    "highest": "3,0441",
    "lower": "2,9850",
    "difference": "0,83%"
  },
  {
    "date": "08.09.2015",
    "now": "3,0111",
    "open": "3,0315",
    "highest": "3,0350",
    "lower": "3,0007",
    "difference": "-0,63%"
  },
  {
    "date": "07.09.2015",
    "now": "3,0301",
    "open": "2,9987",
    "highest": "3,0464",
    "lower": "2,9987",
    "difference": "0,75%"
  },
  {
    "date": "04.09.2015",
    "now": "3,0074",
    "open": "2,9708",
    "highest": "3,0141",
    "lower": "2,9670",
    "difference": "1,24%"
  },
  {
    "date": "03.09.2015",
    "now": "2,9707",
    "open": "2,9418",
    "highest": "2,9785",
    "lower": "2,9375",
    "difference": "1,00%"
  },
  {
    "date": "02.09.2015",
    "now": "2,9414",
    "open": "2,9304",
    "highest": "2,9590",
    "lower": "2,9223",
    "difference": "0,38%"
  },
  {
    "date": "01.09.2015",
    "now": "2,9302",
    "open": "2,9144",
    "highest": "2,9329",
    "lower": "2,9050",
    "difference": "0,53%"
  },
  {
    "date": "31.08.2015",
    "now": "2,9148",
    "open": "2,9255",
    "highest": "2,9329",
    "lower": "2,9076",
    "difference": "-0,31%"
  },
  {
    "date": "28.08.2015",
    "now": "2,9238",
    "open": "2,9094",
    "highest": "2,9318",
    "lower": "2,9050",
    "difference": "0,48%"
  },
  {
    "date": "27.08.2015",
    "now": "2,9099",
    "open": "2,9317",
    "highest": "2,9348",
    "lower": "2,8950",
    "difference": "-0,75%"
  },
  {
    "date": "26.08.2015",
    "now": "2,9318",
    "open": "2,9397",
    "highest": "2,9511",
    "lower": "2,9150",
    "difference": "-0,29%"
  },
  {
    "date": "25.08.2015",
    "now": "2,9402",
    "open": "2,9416",
    "highest": "2,9509",
    "lower": "2,9090",
    "difference": "-0,06%"
  },
  {
    "date": "24.08.2015",
    "now": "2,9421",
    "open": "2,9200",
    "highest": "2,9865",
    "lower": "2,9159",
    "difference": "0,80%"
  },
  {
    "date": "21.08.2015",
    "now": "2,9187",
    "open": "2,9155",
    "highest": "2,9365",
    "lower": "2,9020",
    "difference": "0,09%"
  },
  {
    "date": "20.08.2015",
    "now": "2,9160",
    "open": "2,9256",
    "highest": "2,9999",
    "lower": "2,8870",
    "difference": "-0,32%"
  },
  {
    "date": "19.08.2015",
    "now": "2,9255",
    "open": "2,8941",
    "highest": "2,9450",
    "lower": "2,8830",
    "difference": "1,07%"
  },
  {
    "date": "18.08.2015",
    "now": "2,8946",
    "open": "2,8695",
    "highest": "2,9093",
    "lower": "2,8643",
    "difference": "0,92%"
  },
  {
    "date": "17.08.2015",
    "now": "2,8683",
    "open": "2,8365",
    "highest": "2,8734",
    "lower": "2,8242",
    "difference": "1,21%"
  },
  {
    "date": "14.08.2015",
    "now": "2,8340",
    "open": "2,8216",
    "highest": "2,8475",
    "lower": "2,8176",
    "difference": "0,50%"
  },
  {
    "date": "13.08.2015",
    "now": "2,8200",
    "open": "2,7771",
    "highest": "2,8300",
    "lower": "2,7690",
    "difference": "1,53%"
  },
  {
    "date": "12.08.2015",
    "now": "2,7776",
    "open": "2,7797",
    "highest": "2,7880",
    "lower": "2,7657",
    "difference": "-0,08%"
  },
  {
    "date": "11.08.2015",
    "now": "2,7797",
    "open": "2,7792",
    "highest": "2,7905",
    "lower": "2,7580",
    "difference": "0,01%"
  },
  {
    "date": "10.08.2015",
    "now": "2,7794",
    "open": "2,7812",
    "highest": "2,7970",
    "lower": "2,7740",
    "difference": "-0,03%"
  },
  {
    "date": "07.08.2015",
    "now": "2,7802",
    "open": "2,7762",
    "highest": "2,7940",
    "lower": "2,7720",
    "difference": "0,16%"
  },
  {
    "date": "06.08.2015",
    "now": "2,7757",
    "open": "2,7866",
    "highest": "2,7920",
    "lower": "2,7740",
    "difference": "-0,40%"
  },
  {
    "date": "05.08.2015",
    "now": "2,7868",
    "open": "2,7832",
    "highest": "2,7940",
    "lower": "2,7650",
    "difference": "0,15%"
  },
  {
    "date": "04.08.2015",
    "now": "2,7826",
    "open": "2,7811",
    "highest": "2,7842",
    "lower": "2,7640",
    "difference": "0,05%"
  },
  {
    "date": "03.08.2015",
    "now": "2,7812",
    "open": "2,7672",
    "highest": "2,7844",
    "lower": "2,7629",
    "difference": "0,37%"
  },
  {
    "date": "31.07.2015",
    "now": "2,7710",
    "open": "2,7828",
    "highest": "2,7981",
    "lower": "2,7520",
    "difference": "-0,42%"
  },
  {
    "date": "30.07.2015",
    "now": "2,7826",
    "open": "2,7657",
    "highest": "2,7932",
    "lower": "2,7592",
    "difference": "0,64%"
  },
  {
    "date": "29.07.2015",
    "now": "2,7650",
    "open": "2,7594",
    "highest": "2,7760",
    "lower": "2,7531",
    "difference": "0,18%"
  },
  {
    "date": "28.07.2015",
    "now": "2,7600",
    "open": "2,7714",
    "highest": "2,7740",
    "lower": "2,7420",
    "difference": "-0,41%"
  },
  {
    "date": "27.07.2015",
    "now": "2,7713",
    "open": "2,7409",
    "highest": "2,7780",
    "lower": "2,7330",
    "difference": "1,23%"
  },
  {
    "date": "24.07.2015",
    "now": "2,7377",
    "open": "2,7346",
    "highest": "2,7539",
    "lower": "2,7235",
    "difference": "0,12%"
  },
  {
    "date": "23.07.2015",
    "now": "2,7344",
    "open": "2,7084",
    "highest": "2,7397",
    "lower": "2,7060",
    "difference": "1,02%"
  },
  {
    "date": "22.07.2015",
    "now": "2,7067",
    "open": "2,6856",
    "highest": "2,7250",
    "lower": "2,6801",
    "difference": "0,83%"
  },
  {
    "date": "21.07.2015",
    "now": "2,6844",
    "open": "2,6985",
    "highest": "2,7002",
    "lower": "2,6790",
    "difference": "-0,52%"
  },
  {
    "date": "20.07.2015",
    "now": "2,6983",
    "open": "2,6528",
    "highest": "2,7020",
    "lower": "2,6528",
    "difference": "1,72%"
  },
  {
    "date": "17.07.2015",
    "now": "2,6526",
    "open": "2,6564",
    "highest": "2,6585",
    "lower": "2,6459",
    "difference": "-0,15%"
  },
  {
    "date": "16.07.2015",
    "now": "2,6565",
    "open": "2,6452",
    "highest": "2,6594",
    "lower": "2,6390",
    "difference": "0,38%"
  },
  {
    "date": "15.07.2015",
    "now": "2,6464",
    "open": "2,6315",
    "highest": "2,6521",
    "lower": "2,6260",
    "difference": "0,56%"
  },
  {
    "date": "14.07.2015",
    "now": "2,6317",
    "open": "2,6460",
    "highest": "2,6520",
    "lower": "2,6250",
    "difference": "-0,53%"
  },
  {
    "date": "13.07.2015",
    "now": "2,6456",
    "open": "2,6718",
    "highest": "2,6751",
    "lower": "2,6420",
    "difference": "-0,79%"
  },
  {
    "date": "10.07.2015",
    "now": "2,6667",
    "open": "2,6776",
    "highest": "2,6808",
    "lower": "2,6550",
    "difference": "-0,45%"
  },
  {
    "date": "09.07.2015",
    "now": "2,6788",
    "open": "2,6883",
    "highest": "2,6897",
    "lower": "2,6637",
    "difference": "-0,35%"
  },
  {
    "date": "08.07.2015",
    "now": "2,6882",
    "open": "2,6857",
    "highest": "2,7016",
    "lower": "2,6757",
    "difference": "0,10%"
  },
  {
    "date": "07.07.2015",
    "now": "2,6854",
    "open": "2,6784",
    "highest": "2,7002",
    "lower": "2,6702",
    "difference": "0,27%"
  },
  {
    "date": "06.07.2015",
    "now": "2,6781",
    "open": "2,6917",
    "highest": "2,7163",
    "lower": "2,6713",
    "difference": "-0,39%"
  },
  {
    "date": "03.07.2015",
    "now": "2,6885",
    "open": "2,6846",
    "highest": "2,6950",
    "lower": "2,6815",
    "difference": "0,16%"
  },
  {
    "date": "02.07.2015",
    "now": "2,6843",
    "open": "2,6910",
    "highest": "2,7070",
    "lower": "2,6800",
    "difference": "-0,27%"
  },
  {
    "date": "01.07.2015",
    "now": "2,6917",
    "open": "2,6817",
    "highest": "2,6970",
    "lower": "2,6680",
    "difference": "0,38%"
  },
  {
    "date": "30.06.2015",
    "now": "2,6816",
    "open": "2,7016",
    "highest": "2,7073",
    "lower": "2,6677",
    "difference": "-0,78%"
  },
  {
    "date": "29.06.2015",
    "now": "2,7028",
    "open": "2,6667",
    "highest": "2,7096",
    "lower": "2,6667",
    "difference": "1,42%"
  },
  {
    "date": "26.06.2015",
    "now": "2,6649",
    "open": "2,6552",
    "highest": "2,6750",
    "lower": "2,6535",
    "difference": "0,37%"
  },
  {
    "date": "25.06.2015",
    "now": "2,6550",
    "open": "2,6777",
    "highest": "2,6793",
    "lower": "2,6505",
    "difference": "-0,84%"
  },
  {
    "date": "24.06.2015",
    "now": "2,6776",
    "open": "2,6788",
    "highest": "2,6890",
    "lower": "2,6680",
    "difference": "-0,05%"
  },
  {
    "date": "23.06.2015",
    "now": "2,6789",
    "open": "2,6655",
    "highest": "2,6860",
    "lower": "2,6629",
    "difference": "0,50%"
  },
  {
    "date": "22.06.2015",
    "now": "2,6656",
    "open": "2,6953",
    "highest": "2,6976",
    "lower": "2,6590",
    "difference": "-1,09%"
  },
  {
    "date": "19.06.2015",
    "now": "2,6951",
    "open": "2,7138",
    "highest": "2,7255",
    "lower": "2,6921",
    "difference": "-0,63%"
  },
  {
    "date": "18.06.2015",
    "now": "2,7123",
    "open": "2,7048",
    "highest": "2,7212",
    "lower": "2,7030",
    "difference": "0,23%"
  },
  {
    "date": "17.06.2015",
    "now": "2,7061",
    "open": "2,7337",
    "highest": "2,7452",
    "lower": "2,7061",
    "difference": "-1,04%"
  },
  {
    "date": "16.06.2015",
    "now": "2,7345",
    "open": "2,7369",
    "highest": "2,7527",
    "lower": "2,7257",
    "difference": "-0,05%"
  },
  {
    "date": "15.06.2015",
    "now": "2,7358",
    "open": "2,7119",
    "highest": "2,7460",
    "lower": "2,7119",
    "difference": "0,85%"
  },
  {
    "date": "12.06.2015",
    "now": "2,7128",
    "open": "2,7027",
    "highest": "2,7262",
    "lower": "2,7004",
    "difference": "0,39%"
  },
  {
    "date": "11.06.2015",
    "now": "2,7022",
    "open": "2,7350",
    "highest": "2,7532",
    "lower": "2,7003",
    "difference": "-1,18%"
  },
  {
    "date": "10.06.2015",
    "now": "2,7345",
    "open": "2,7521",
    "highest": "2,7564",
    "lower": "2,7258",
    "difference": "-0,64%"
  },
  {
    "date": "09.06.2015",
    "now": "2,7521",
    "open": "2,7517",
    "highest": "2,7642",
    "lower": "2,7292",
    "difference": "0,02%"
  },
  {
    "date": "08.06.2015",
    "now": "2,7515",
    "open": "2,7710",
    "highest": "2,8117",
    "lower": "2,7443",
    "difference": "3,36%"
  },
  {
    "date": "05.06.2015",
    "now": "2,6621",
    "open": "2,6674",
    "highest": "2,6920",
    "lower": "2,6530",
    "difference": "-0,21%"
  },
  {
    "date": "04.06.2015",
    "now": "2,6677",
    "open": "2,6853",
    "highest": "2,7080",
    "lower": "2,6570",
    "difference": "-0,67%"
  },
  {
    "date": "03.06.2015",
    "now": "2,6856",
    "open": "2,6742",
    "highest": "2,6930",
    "lower": "2,6707",
    "difference": "0,42%"
  },
  {
    "date": "02.06.2015",
    "now": "2,6743",
    "open": "2,6830",
    "highest": "2,6940",
    "lower": "2,6690",
    "difference": "-0,32%"
  },
  {
    "date": "01.06.2015",
    "now": "2,6829",
    "open": "2,6615",
    "highest": "2,6865",
    "lower": "2,6589",
    "difference": "0,75%"
  },
  {
    "date": "29.05.2015",
    "now": "2,6630",
    "open": "2,6550",
    "highest": "2,6687",
    "lower": "2,6450",
    "difference": "0,33%"
  },
  {
    "date": "28.05.2015",
    "now": "2,6543",
    "open": "2,6416",
    "highest": "2,6679",
    "lower": "2,6389",
    "difference": "0,46%"
  },
  {
    "date": "27.05.2015",
    "now": "2,6421",
    "open": "2,6407",
    "highest": "2,6670",
    "lower": "2,6310",
    "difference": "0,02%"
  },
  {
    "date": "26.05.2015",
    "now": "2,6417",
    "open": "2,6139",
    "highest": "2,6450",
    "lower": "2,6130",
    "difference": "1,00%"
  },
  {
    "date": "25.05.2015",
    "now": "2,6155",
    "open": "2,5996",
    "highest": "2,6200",
    "lower": "2,5923",
    "difference": "0,63%"
  },
  {
    "date": "22.05.2015",
    "now": "2,5991",
    "open": "2,5887",
    "highest": "2,6080",
    "lower": "2,5820",
    "difference": "0,39%"
  },
  {
    "date": "21.05.2015",
    "now": "2,5889",
    "open": "2,5771",
    "highest": "2,5960",
    "lower": "2,5580",
    "difference": "0,44%"
  },
  {
    "date": "20.05.2015",
    "now": "2,5776",
    "open": "2,5933",
    "highest": "2,6130",
    "lower": "2,5693",
    "difference": "-0,61%"
  },
  {
    "date": "19.05.2015",
    "now": "2,5935",
    "open": "2,5807",
    "highest": "2,6049",
    "lower": "2,5720",
    "difference": "0,50%"
  },
  {
    "date": "18.05.2015",
    "now": "2,5806",
    "open": "2,5760",
    "highest": "2,5900",
    "lower": "2,5710",
    "difference": "0,18%"
  },
  {
    "date": "15.05.2015",
    "now": "2,5759",
    "open": "2,5908",
    "highest": "2,6007",
    "lower": "2,5738",
    "difference": "-0,58%"
  },
  {
    "date": "14.05.2015",
    "now": "2,5909",
    "open": "2,6306",
    "highest": "2,6337",
    "lower": "2,5870",
    "difference": "-1,51%"
  },
  {
    "date": "13.05.2015",
    "now": "2,6307",
    "open": "2,6634",
    "highest": "2,6730",
    "lower": "2,6197",
    "difference": "-1,23%"
  },
  {
    "date": "12.05.2015",
    "now": "2,6635",
    "open": "2,6935",
    "highest": "2,7050",
    "lower": "2,6587",
    "difference": "-1,12%"
  },
  {
    "date": "11.05.2015",
    "now": "2,6938",
    "open": "2,6890",
    "highest": "2,7050",
    "lower": "2,6780",
    "difference": "-0,06%"
  },
  {
    "date": "08.05.2015",
    "now": "2,6953",
    "open": "2,6863",
    "highest": "2,7038",
    "lower": "2,6741",
    "difference": "0,38%"
  },
  {
    "date": "07.05.2015",
    "now": "2,6852",
    "open": "2,6926",
    "highest": "2,7150",
    "lower": "2,6760",
    "difference": "-0,28%"
  },
  {
    "date": "06.05.2015",
    "now": "2,6928",
    "open": "2,7040",
    "highest": "2,7220",
    "lower": "2,6850",
    "difference": "-0,43%"
  },
  {
    "date": "05.05.2015",
    "now": "2,7045",
    "open": "2,7109",
    "highest": "2,7250",
    "lower": "2,7000",
    "difference": "-0,31%"
  },
  {
    "date": "04.05.2015",
    "now": "2,7130",
    "open": "2,7142",
    "highest": "2,7244",
    "lower": "2,6951",
    "difference": "0,19%"
  },
  {
    "date": "01.05.2015",
    "now": "2,7079",
    "open": "2,6718",
    "highest": "2,7124",
    "lower": "2,6636",
    "difference": "1,33%"
  },
  {
    "date": "30.04.2015",
    "now": "2,6723",
    "open": "2,6604",
    "highest": "2,6850",
    "lower": "2,6480",
    "difference": "0,44%"
  },
  {
    "date": "29.04.2015",
    "now": "2,6605",
    "open": "2,6583",
    "highest": "2,6750",
    "lower": "2,6430",
    "difference": "0,08%"
  },
  {
    "date": "28.04.2015",
    "now": "2,6584",
    "open": "2,6748",
    "highest": "2,6945",
    "lower": "2,6495",
    "difference": "-0,60%"
  },
  {
    "date": "27.04.2015",
    "now": "2,6744",
    "open": "2,7252",
    "highest": "2,7390",
    "lower": "2,6662",
    "difference": "-1,47%"
  },
  {
    "date": "24.04.2015",
    "now": "2,7144",
    "open": "2,7010",
    "highest": "2,7438",
    "lower": "2,6980",
    "difference": "0,48%"
  },
  {
    "date": "23.04.2015",
    "now": "2,7015",
    "open": "2,7119",
    "highest": "2,7349",
    "lower": "2,6960",
    "difference": "-0,40%"
  },
  {
    "date": "22.04.2015",
    "now": "2,7123",
    "open": "2,6854",
    "highest": "2,7220",
    "lower": "2,6759",
    "difference": "0,99%"
  },
  {
    "date": "21.04.2015",
    "now": "2,6858",
    "open": "2,7001",
    "highest": "2,7159",
    "lower": "2,6770",
    "difference": "-0,50%"
  },
  {
    "date": "20.04.2015",
    "now": "2,6993",
    "open": "2,6879",
    "highest": "2,7119",
    "lower": "2,6702",
    "difference": "0,79%"
  },
  {
    "date": "17.04.2015",
    "now": "2,6782",
    "open": "2,6781",
    "highest": "2,7010",
    "lower": "2,6718",
    "difference": "-0,01%"
  },
  {
    "date": "16.04.2015",
    "now": "2,6786",
    "open": "2,6984",
    "highest": "2,7150",
    "lower": "2,6702",
    "difference": "-0,75%"
  },
  {
    "date": "15.04.2015",
    "now": "2,6989",
    "open": "2,6884",
    "highest": "2,7316",
    "lower": "2,6810",
    "difference": "0,39%"
  },
  {
    "date": "14.04.2015",
    "now": "2,6883",
    "open": "2,6705",
    "highest": "2,6949",
    "lower": "2,6595",
    "difference": "0,67%"
  },
  {
    "date": "13.04.2015",
    "now": "2,6705",
    "open": "2,6198",
    "highest": "2,6740",
    "lower": "2,6198",
    "difference": "1,59%"
  },
  {
    "date": "10.04.2015",
    "now": "2,6287",
    "open": "2,6205",
    "highest": "2,6425",
    "lower": "2,6125",
    "difference": "0,34%"
  },
  {
    "date": "09.04.2015",
    "now": "2,6199",
    "open": "2,5984",
    "highest": "2,6240",
    "lower": "2,5830",
    "difference": "0,78%"
  },
  {
    "date": "08.04.2015",
    "now": "2,5995",
    "open": "2,6018",
    "highest": "2,6038",
    "lower": "2,5830",
    "difference": "-0,11%"
  },
  {
    "date": "07.04.2015",
    "now": "2,6023",
    "open": "2,5745",
    "highest": "2,6049",
    "lower": "2,5640",
    "difference": "1,22%"
  },
  {
    "date": "06.04.2015",
    "now": "2,5710",
    "open": "2,5692",
    "highest": "2,5785",
    "lower": "2,5540",
    "difference": "-0,03%"
  },
  {
    "date": "03.04.2015",
    "now": "2,5719",
    "open": "2,5856",
    "highest": "2,5982",
    "lower": "2,5547",
    "difference": "-0,53%"
  },
  {
    "date": "02.04.2015",
    "now": "2,5855",
    "open": "2,6003",
    "highest": "2,6021",
    "lower": "2,5826",
    "difference": "-0,52%"
  },
  {
    "date": "01.04.2015",
    "now": "2,5990",
    "open": "2,5980",
    "highest": "2,6140",
    "lower": "2,5875",
    "difference": "0,05%"
  },
  {
    "date": "31.03.2015",
    "now": "2,5978",
    "open": "2,6095",
    "highest": "2,6235",
    "lower": "2,5915",
    "difference": "-0,38%"
  },
  {
    "date": "30.03.2015",
    "now": "2,6078",
    "open": "2,6108",
    "highest": "2,6195",
    "lower": "2,5965",
    "difference": "-0,09%"
  },
  {
    "date": "27.03.2015",
    "now": "2,6102",
    "open": "2,5920",
    "highest": "2,6247",
    "lower": "2,5920",
    "difference": "0,56%"
  },
  {
    "date": "26.03.2015",
    "now": "2,5957",
    "open": "2,5868",
    "highest": "2,6180",
    "lower": "2,5830",
    "difference": "0,34%"
  },
  {
    "date": "25.03.2015",
    "now": "2,5870",
    "open": "2,5520",
    "highest": "2,5940",
    "lower": "2,5499",
    "difference": "1,38%"
  },
  {
    "date": "24.03.2015",
    "now": "2,5519",
    "open": "2,5422",
    "highest": "2,5700",
    "lower": "2,5400",
    "difference": "0,38%"
  },
  {
    "date": "23.03.2015",
    "now": "2,5423",
    "open": "2,5754",
    "highest": "2,5926",
    "lower": "2,5419",
    "difference": "-1,19%"
  },
  {
    "date": "20.03.2015",
    "now": "2,5730",
    "open": "2,6040",
    "highest": "2,6070",
    "lower": "2,5692",
    "difference": "-1,30%"
  },
  {
    "date": "19.03.2015",
    "now": "2,6070",
    "open": "2,5697",
    "highest": "2,6190",
    "lower": "2,5607",
    "difference": "1,43%"
  },
  {
    "date": "18.03.2015",
    "now": "2,5702",
    "open": "2,6115",
    "highest": "2,6270",
    "lower": "2,5642",
    "difference": "-1,59%"
  },
  {
    "date": "17.03.2015",
    "now": "2,6117",
    "open": "2,6261",
    "highest": "2,6330",
    "lower": "2,6040",
    "difference": "-0,55%"
  },
  {
    "date": "16.03.2015",
    "now": "2,6261",
    "open": "2,6307",
    "highest": "2,6433",
    "lower": "2,5990",
    "difference": "-0,52%"
  },
  {
    "date": "13.03.2015",
    "now": "2,6397",
    "open": "2,5846",
    "highest": "2,6496",
    "lower": "2,5826",
    "difference": "2,16%"
  },
  {
    "date": "12.03.2015",
    "now": "2,5840",
    "open": "2,6103",
    "highest": "2,6156",
    "lower": "2,5825",
    "difference": "-1,02%"
  },
  {
    "date": "11.03.2015",
    "now": "2,6105",
    "open": "2,6384",
    "highest": "2,6450",
    "lower": "2,6030",
    "difference": "-1,06%"
  },
  {
    "date": "10.03.2015",
    "now": "2,6385",
    "open": "2,6014",
    "highest": "2,6470",
    "lower": "2,5986",
    "difference": "1,42%"
  },
  {
    "date": "09.03.2015",
    "now": "2,6016",
    "open": "2,6274",
    "highest": "2,6335",
    "lower": "2,5880",
    "difference": "-0,86%"
  },
  {
    "date": "06.03.2015",
    "now": "2,6243",
    "open": "2,6076",
    "highest": "2,6474",
    "lower": "2,5708",
    "difference": "0,67%"
  },
  {
    "date": "05.03.2015",
    "now": "2,6069",
    "open": "2,5640",
    "highest": "2,6290",
    "lower": "2,5610",
    "difference": "1,67%"
  },
  {
    "date": "04.03.2015",
    "now": "2,5640",
    "open": "2,5375",
    "highest": "2,5725",
    "lower": "2,5315",
    "difference": "1,12%"
  },
  {
    "date": "03.03.2015",
    "now": "2,5357",
    "open": "2,5192",
    "highest": "2,5413",
    "lower": "2,5053",
    "difference": "0,75%"
  },
  {
    "date": "02.03.2015",
    "now": "2,5169",
    "open": "2,5117",
    "highest": "2,5240",
    "lower": "2,5020",
    "difference": "0,32%"
  },
  {
    "date": "27.02.2015",
    "now": "2,5088",
    "open": "2,5061",
    "highest": "2,5278",
    "lower": "2,4918",
    "difference": "0,19%"
  },
  {
    "date": "26.02.2015",
    "now": "2,5040",
    "open": "2,4884",
    "highest": "2,5080",
    "lower": "2,4720",
    "difference": "0,62%"
  },
  {
    "date": "25.02.2015",
    "now": "2,4886",
    "open": "2,4632",
    "highest": "2,4933",
    "lower": "2,4512",
    "difference": "1,01%"
  },
  {
    "date": "24.02.2015",
    "now": "2,4637",
    "open": "2,4773",
    "highest": "2,4907",
    "lower": "2,4627",
    "difference": "-0,47%"
  },
  {
    "date": "23.02.2015",
    "now": "2,4753",
    "open": "2,4686",
    "highest": "2,4862",
    "lower": "2,4492",
    "difference": "0,93%"
  },
  {
    "date": "20.02.2015",
    "now": "2,4526",
    "open": "2,4542",
    "highest": "2,4682",
    "lower": "2,4482",
    "difference": "-0,18%"
  },
  {
    "date": "19.02.2015",
    "now": "2,4570",
    "open": "2,4432",
    "highest": "2,4602",
    "lower": "2,4312",
    "difference": "0,62%"
  },
  {
    "date": "18.02.2015",
    "now": "2,4418",
    "open": "2,4525",
    "highest": "2,4700",
    "lower": "2,4418",
    "difference": "-0,42%"
  },
  {
    "date": "17.02.2015",
    "now": "2,4520",
    "open": "2,4564",
    "highest": "2,4591",
    "lower": "2,4382",
    "difference": "-0,19%"
  },
  {
    "date": "16.02.2015",
    "now": "2,4566",
    "open": "2,4578",
    "highest": "2,4642",
    "lower": "2,4422",
    "difference": "-0,06%"
  },
  {
    "date": "13.02.2015",
    "now": "2,4581",
    "open": "2,4672",
    "highest": "2,4787",
    "lower": "2,4552",
    "difference": "-0,34%"
  },
  {
    "date": "12.02.2015",
    "now": "2,4666",
    "open": "2,4998",
    "highest": "2,5084",
    "lower": "2,4639",
    "difference": "-1,35%"
  },
  {
    "date": "11.02.2015",
    "now": "2,5004",
    "open": "2,4957",
    "highest": "2,5144",
    "lower": "2,4792",
    "difference": "0,16%"
  },
  {
    "date": "10.02.2015",
    "now": "2,4964",
    "open": "2,4762",
    "highest": "2,5097",
    "lower": "2,4672",
    "difference": "0,80%"
  },
  {
    "date": "09.02.2015",
    "now": "2,4766",
    "open": "2,4800",
    "highest": "2,5032",
    "lower": "2,4710",
    "difference": "0,11%"
  },
  {
    "date": "06.02.2015",
    "now": "2,4740",
    "open": "2,4375",
    "highest": "2,4829",
    "lower": "2,4268",
    "difference": "1,50%"
  },
  {
    "date": "05.02.2015",
    "now": "2,4375",
    "open": "2,4657",
    "highest": "2,4668",
    "lower": "2,4338",
    "difference": "-1,18%"
  },
  {
    "date": "04.02.2015",
    "now": "2,4665",
    "open": "2,4013",
    "highest": "2,4687",
    "lower": "2,3917",
    "difference": "2,71%"
  },
  {
    "date": "03.02.2015",
    "now": "2,4014",
    "open": "2,4306",
    "highest": "2,4416",
    "lower": "2,3919",
    "difference": "-1,20%"
  },
  {
    "date": "02.02.2015",
    "now": "2,4306",
    "open": "2,4453",
    "highest": "2,4453",
    "lower": "2,4137",
    "difference": "-0,65%"
  },
  {
    "date": "30.01.2015",
    "now": "2,4464",
    "open": "2,4155",
    "highest": "2,4502",
    "lower": "2,4032",
    "difference": "1,25%"
  },
  {
    "date": "29.01.2015",
    "now": "2,4161",
    "open": "2,3844",
    "highest": "2,4212",
    "lower": "2,3835",
    "difference": "1,27%"
  },
  {
    "date": "28.01.2015",
    "now": "2,3859",
    "open": "2,3640",
    "highest": "2,3873",
    "lower": "2,3528",
    "difference": "0,92%"
  },
  {
    "date": "27.01.2015",
    "now": "2,3642",
    "open": "2,3549",
    "highest": "2,3739",
    "lower": "2,3389",
    "difference": "0,43%"
  },
  {
    "date": "26.01.2015",
    "now": "2,3541",
    "open": "2,3643",
    "highest": "2,3735",
    "lower": "2,3454",
    "difference": "0,25%"
  },
  {
    "date": "23.01.2015",
    "now": "2,3483",
    "open": "2,3222",
    "highest": "2,3558",
    "lower": "2,3187",
    "difference": "1,04%"
  },
  {
    "date": "22.01.2015",
    "now": "2,3242",
    "open": "2,3522",
    "highest": "2,3617",
    "lower": "2,3164",
    "difference": "-1,11%"
  },
  {
    "date": "21.01.2015",
    "now": "2,3503",
    "open": "2,3457",
    "highest": "2,3545",
    "lower": "2,3312",
    "difference": "0,17%"
  },
  {
    "date": "20.01.2015",
    "now": "2,3463",
    "open": "2,3374",
    "highest": "2,3632",
    "lower": "2,3222",
    "difference": "0,35%"
  },
  {
    "date": "19.01.2015",
    "now": "2,3380",
    "open": "2,3323",
    "highest": "2,3482",
    "lower": "2,3252",
    "difference": "0,65%"
  },
  {
    "date": "16.01.2015",
    "now": "2,3229",
    "open": "2,3130",
    "highest": "2,3420",
    "lower": "2,3020",
    "difference": "0,55%"
  },
  {
    "date": "15.01.2015",
    "now": "2,3103",
    "open": "2,2818",
    "highest": "2,3317",
    "lower": "2,2707",
    "difference": "1,28%"
  },
  {
    "date": "14.01.2015",
    "now": "2,2811",
    "open": "2,2849",
    "highest": "2,3087",
    "lower": "2,2757",
    "difference": "-0,21%"
  },
  {
    "date": "13.01.2015",
    "now": "2,2858",
    "open": "2,2849",
    "highest": "2,2888",
    "lower": "2,2712",
    "difference": "0,02%"
  },
  {
    "date": "12.01.2015",
    "now": "2,2853",
    "open": "2,2905",
    "highest": "2,2982",
    "lower": "2,2811",
    "difference": "-0,42%"
  },
  {
    "date": "09.01.2015",
    "now": "2,2950",
    "open": "2,2992",
    "highest": "2,3110",
    "lower": "2,2825",
    "difference": "-0,18%"
  },
  {
    "date": "08.01.2015",
    "now": "2,2992",
    "open": "2,3190",
    "highest": "2,3229",
    "lower": "2,2952",
    "difference": "-0,85%"
  },
  {
    "date": "07.01.2015",
    "now": "2,3189",
    "open": "2,3234",
    "highest": "2,3342",
    "lower": "2,3182",
    "difference": "-0,17%"
  },
  {
    "date": "06.01.2015",
    "now": "2,3228",
    "open": "2,3312",
    "highest": "2,3367",
    "lower": "2,3132",
    "difference": "-0,39%"
  },
  {
    "date": "05.01.2015",
    "now": "2,3318",
    "open": "2,3519",
    "highest": "2,3524",
    "lower": "2,3250",
    "difference": "-0,53%"
  },
  {
    "date": "02.01.2015",
    "now": "2,3442",
    "open": "2,3322",
    "highest": "2,3586",
    "lower": "2,3312",
    "difference": "0,57%"
  },
  {
    "date": "01.01.2015",
    "now": "2,3309",
    "open": "2,3365",
    "highest": "2,3365",
    "lower": "2,3309",
    "difference": "-0,15%"
  },
  {
    "date": "31.12.2014",
    "now": "2,3345",
    "open": "2,3287",
    "highest": "2,3400",
    "lower": "2,3210",
    "difference": "0,24%"
  },
  {
    "date": "30.12.2014",
    "now": "2,3289",
    "open": "2,3180",
    "highest": "2,3510",
    "lower": "2,3119",
    "difference": "0,49%"
  },
  {
    "date": "29.12.2014",
    "now": "2,3176",
    "open": "2,3166",
    "highest": "2,3292",
    "lower": "2,3137",
    "difference": "0,00%"
  },
  {
    "date": "26.12.2014",
    "now": "2,3175",
    "open": "2,3197",
    "highest": "2,3232",
    "lower": "2,3132",
    "difference": "-0,15%"
  },
  {
    "date": "25.12.2014",
    "now": "2,3210",
    "open": "2,3181",
    "highest": "2,3230",
    "lower": "2,3130",
    "difference": "0,16%"
  },
  {
    "date": "24.12.2014",
    "now": "2,3173",
    "open": "2,3218",
    "highest": "2,3262",
    "lower": "2,3112",
    "difference": "-0,23%"
  },
  {
    "date": "23.12.2014",
    "now": "2,3226",
    "open": "2,3151",
    "highest": "2,3267",
    "lower": "2,3117",
    "difference": "0,34%"
  },
  {
    "date": "22.12.2014",
    "now": "2,3148",
    "open": "2,3091",
    "highest": "2,3237",
    "lower": "2,3082",
    "difference": "0,12%"
  },
  {
    "date": "19.12.2014",
    "now": "2,3121",
    "open": "2,3218",
    "highest": "2,3347",
    "lower": "2,3077",
    "difference": "-0,47%"
  },
  {
    "date": "18.12.2014",
    "now": "2,3230",
    "open": "2,3392",
    "highest": "2,3419",
    "lower": "2,3102",
    "difference": "-0,65%"
  },
  {
    "date": "17.12.2014",
    "now": "2,3381",
    "open": "2,3602",
    "highest": "2,3777",
    "lower": "2,3082",
    "difference": "-1,14%"
  },
  {
    "date": "16.12.2014",
    "now": "2,3650",
    "open": "2,3771",
    "highest": "2,4150",
    "lower": "2,3420",
    "difference": "-0,46%"
  },
  {
    "date": "15.12.2014",
    "now": "2,3760",
    "open": "2,2977",
    "highest": "2,3946",
    "lower": "2,2917",
    "difference": "3,35%"
  },
  {
    "date": "12.12.2014",
    "now": "2,2990",
    "open": "2,2777",
    "highest": "2,3117",
    "lower": "2,2667",
    "difference": "0,90%"
  },
  {
    "date": "11.12.2014",
    "now": "2,2784",
    "open": "2,2667",
    "highest": "2,2827",
    "lower": "2,2562",
    "difference": "0,53%"
  },
  {
    "date": "10.12.2014",
    "now": "2,2663",
    "open": "2,2670",
    "highest": "2,2702",
    "lower": "2,2562",
    "difference": "-0,05%"
  },
  {
    "date": "09.12.2014",
    "now": "2,2674",
    "open": "2,2694",
    "highest": "2,2721",
    "lower": "2,2542",
    "difference": "-0,05%"
  },
  {
    "date": "08.12.2014",
    "now": "2,2686",
    "open": "2,2650",
    "highest": "2,2822",
    "lower": "2,2570",
    "difference": "0,34%"
  },
  {
    "date": "05.12.2014",
    "now": "2,2610",
    "open": "2,2347",
    "highest": "2,2662",
    "lower": "2,2312",
    "difference": "1,20%"
  },
  {
    "date": "04.12.2014",
    "now": "2,2342",
    "open": "2,2402",
    "highest": "2,2452",
    "lower": "2,2290",
    "difference": "-0,35%"
  },
  {
    "date": "03.12.2014",
    "now": "2,2420",
    "open": "2,2327",
    "highest": "2,2465",
    "lower": "2,2275",
    "difference": "0,48%"
  },
  {
    "date": "02.12.2014",
    "now": "2,2312",
    "open": "2,2152",
    "highest": "2,2342",
    "lower": "2,2127",
    "difference": "0,74%"
  },
  {
    "date": "01.12.2014",
    "now": "2,2149",
    "open": "2,2228",
    "highest": "2,2302",
    "lower": "2,2132",
    "difference": "-0,21%"
  },
  {
    "date": "28.11.2014",
    "now": "2,2196",
    "open": "2,2067",
    "highest": "2,2236",
    "lower": "2,2042",
    "difference": "0,56%"
  },
  {
    "date": "27.11.2014",
    "now": "2,2072",
    "open": "2,2108",
    "highest": "2,2202",
    "lower": "2,2046",
    "difference": "-0,15%"
  },
  {
    "date": "26.11.2014",
    "now": "2,2106",
    "open": "2,2192",
    "highest": "2,2291",
    "lower": "2,2087",
    "difference": "-0,41%"
  },
  {
    "date": "25.11.2014",
    "now": "2,2197",
    "open": "2,2301",
    "highest": "2,2392",
    "lower": "2,2190",
    "difference": "-0,46%"
  },
  {
    "date": "24.11.2014",
    "now": "2,2300",
    "open": "2,2210",
    "highest": "2,2332",
    "lower": "2,2157",
    "difference": "0,37%"
  },
  {
    "date": "21.11.2014",
    "now": "2,2218",
    "open": "2,2193",
    "highest": "2,2294",
    "lower": "2,2138",
    "difference": "0,10%"
  },
  {
    "date": "20.11.2014",
    "now": "2,2196",
    "open": "2,2324",
    "highest": "2,2433",
    "lower": "2,2187",
    "difference": "-0,56%"
  },
  {
    "date": "19.11.2014",
    "now": "2,2320",
    "open": "2,2215",
    "highest": "2,2432",
    "lower": "2,2192",
    "difference": "0,48%"
  },
  {
    "date": "18.11.2014",
    "now": "2,2214",
    "open": "2,2313",
    "highest": "2,2322",
    "lower": "2,2157",
    "difference": "-0,44%"
  },
  {
    "date": "17.11.2014",
    "now": "2,2312",
    "open": "2,2286",
    "highest": "2,2347",
    "lower": "2,2232",
    "difference": "0,07%"
  },
  {
    "date": "14.11.2014",
    "now": "2,2296",
    "open": "2,2416",
    "highest": "2,2497",
    "lower": "2,2290",
    "difference": "-0,56%"
  },
  {
    "date": "13.11.2014",
    "now": "2,2422",
    "open": "2,2532",
    "highest": "2,2557",
    "lower": "2,2338",
    "difference": "-0,41%"
  },
  {
    "date": "12.11.2014",
    "now": "2,2514",
    "open": "2,2570",
    "highest": "2,2662",
    "lower": "2,2462",
    "difference": "-0,24%"
  },
  {
    "date": "11.11.2014",
    "now": "2,2568",
    "open": "2,2597",
    "highest": "2,2732",
    "lower": "2,2553",
    "difference": "-0,12%"
  },
  {
    "date": "10.11.2014",
    "now": "2,2594",
    "open": "2,2571",
    "highest": "2,2612",
    "lower": "2,2432",
    "difference": "0,06%"
  },
  {
    "date": "07.11.2014",
    "now": "2,2580",
    "open": "2,2636",
    "highest": "2,2820",
    "lower": "2,2560",
    "difference": "-0,25%"
  },
  {
    "date": "06.11.2014",
    "now": "2,2636",
    "open": "2,2441",
    "highest": "2,2662",
    "lower": "2,2332",
    "difference": "0,86%"
  },
  {
    "date": "05.11.2014",
    "now": "2,2443",
    "open": "2,2212",
    "highest": "2,2497",
    "lower": "2,2207",
    "difference": "0,94%"
  },
  {
    "date": "04.11.2014",
    "now": "2,2235",
    "open": "2,2349",
    "highest": "2,2386",
    "lower": "2,2185",
    "difference": "-0,54%"
  },
  {
    "date": "03.11.2014",
    "now": "2,2355",
    "open": "2,2194",
    "highest": "2,2435",
    "lower": "2,2194",
    "difference": "0,52%"
  },
  {
    "date": "31.10.2014",
    "now": "2,2240",
    "open": "2,1996",
    "highest": "2,2275",
    "lower": "2,1900",
    "difference": "1,15%"
  },
  {
    "date": "30.10.2014",
    "now": "2,1988",
    "open": "2,2150",
    "highest": "2,2267",
    "lower": "2,1966",
    "difference": "-0,74%"
  },
  {
    "date": "29.10.2014",
    "now": "2,2153",
    "open": "2,2067",
    "highest": "2,2193",
    "lower": "2,1902",
    "difference": "0,39%"
  },
  {
    "date": "28.10.2014",
    "now": "2,2066",
    "open": "2,2300",
    "highest": "2,2335",
    "lower": "2,2012",
    "difference": "-1,02%"
  },
  {
    "date": "27.10.2014",
    "now": "2,2294",
    "open": "2,2282",
    "highest": "2,2437",
    "lower": "2,2282",
    "difference": "-0,09%"
  },
  {
    "date": "24.10.2014",
    "now": "2,2313",
    "open": "2,2365",
    "highest": "2,2442",
    "lower": "2,2302",
    "difference": "-0,21%"
  },
  {
    "date": "23.10.2014",
    "now": "2,2360",
    "open": "2,2468",
    "highest": "2,2520",
    "lower": "2,2280",
    "difference": "-0,46%"
  },
  {
    "date": "22.10.2014",
    "now": "2,2463",
    "open": "2,2457",
    "highest": "2,2512",
    "lower": "2,2392",
    "difference": "0,05%"
  },
  {
    "date": "21.10.2014",
    "now": "2,2451",
    "open": "2,2444",
    "highest": "2,2482",
    "lower": "2,2342",
    "difference": "0,06%"
  },
  {
    "date": "20.10.2014",
    "now": "2,2437",
    "open": "2,2448",
    "highest": "2,2529",
    "lower": "2,2379",
    "difference": "-0,10%"
  },
  {
    "date": "17.10.2014",
    "now": "2,2460",
    "open": "2,2627",
    "highest": "2,2682",
    "lower": "2,2427",
    "difference": "-0,75%"
  },
  {
    "date": "16.10.2014",
    "now": "2,2629",
    "open": "2,2696",
    "highest": "2,2857",
    "lower": "2,2582",
    "difference": "-0,28%"
  },
  {
    "date": "15.10.2014",
    "now": "2,2693",
    "open": "2,2728",
    "highest": "2,2862",
    "lower": "2,2537",
    "difference": "-0,16%"
  },
  {
    "date": "14.10.2014",
    "now": "2,2730",
    "open": "2,2696",
    "highest": "2,2882",
    "lower": "2,2662",
    "difference": "0,14%"
  },
  {
    "date": "13.10.2014",
    "now": "2,2698",
    "open": "2,2870",
    "highest": "2,2875",
    "lower": "2,2642",
    "difference": "-0,81%"
  },
  {
    "date": "10.10.2014",
    "now": "2,2884",
    "open": "2,2704",
    "highest": "2,2892",
    "lower": "2,2692",
    "difference": "0,83%"
  },
  {
    "date": "09.10.2014",
    "now": "2,2695",
    "open": "2,2614",
    "highest": "2,2704",
    "lower": "2,2495",
    "difference": "0,29%"
  },
  {
    "date": "08.10.2014",
    "now": "2,2630",
    "open": "2,2765",
    "highest": "2,2977",
    "lower": "2,2619",
    "difference": "-0,54%"
  },
  {
    "date": "07.10.2014",
    "now": "2,2753",
    "open": "2,2682",
    "highest": "2,2798",
    "lower": "2,2640",
    "difference": "0,33%"
  },
  {
    "date": "06.10.2014",
    "now": "2,2678",
    "open": "2,2916",
    "highest": "2,2931",
    "lower": "2,2662",
    "difference": "-1,15%"
  },
  {
    "date": "03.10.2014",
    "now": "2,2942",
    "open": "2,2668",
    "highest": "2,3071",
    "lower": "2,2637",
    "difference": "1,22%"
  },
  {
    "date": "02.10.2014",
    "now": "2,2665",
    "open": "2,2834",
    "highest": "2,2852",
    "lower": "2,2632",
    "difference": "-0,74%"
  },
  {
    "date": "01.10.2014",
    "now": "2,2833",
    "open": "2,2784",
    "highest": "2,2937",
    "lower": "2,2737",
    "difference": "0,22%"
  },
  {
    "date": "30.09.2014",
    "now": "2,2782",
    "open": "2,2801",
    "highest": "2,2887",
    "lower": "2,2687",
    "difference": "-0,02%"
  },
  {
    "date": "29.09.2014",
    "now": "2,2786",
    "open": "2,2620",
    "highest": "2,2907",
    "lower": "2,2602",
    "difference": "0,72%"
  },
  {
    "date": "26.09.2014",
    "now": "2,2623",
    "open": "2,2611",
    "highest": "2,2687",
    "lower": "2,2522",
    "difference": "0,06%"
  },
  {
    "date": "25.09.2014",
    "now": "2,2610",
    "open": "2,2363",
    "highest": "2,2677",
    "lower": "2,2352",
    "difference": "1,09%"
  },
  {
    "date": "24.09.2014",
    "now": "2,2366",
    "open": "2,2403",
    "highest": "2,2427",
    "lower": "2,2277",
    "difference": "-0,12%"
  },
  {
    "date": "23.09.2014",
    "now": "2,2393",
    "open": "2,2410",
    "highest": "2,2421",
    "lower": "2,2265",
    "difference": "-0,06%"
  },
  {
    "date": "22.09.2014",
    "now": "2,2407",
    "open": "2,2328",
    "highest": "2,2497",
    "lower": "2,2277",
    "difference": "0,27%"
  },
  {
    "date": "19.09.2014",
    "now": "2,2347",
    "open": "2,2252",
    "highest": "2,2407",
    "lower": "2,2161",
    "difference": "0,39%"
  },
  {
    "date": "18.09.2014",
    "now": "2,2260",
    "open": "2,2248",
    "highest": "2,2372",
    "lower": "2,2137",
    "difference": "0,08%"
  },
  {
    "date": "17.09.2014",
    "now": "2,2243",
    "open": "2,2041",
    "highest": "2,2288",
    "lower": "2,2007",
    "difference": "0,95%"
  },
  {
    "date": "16.09.2014",
    "now": "2,2033",
    "open": "2,2119",
    "highest": "2,2207",
    "lower": "2,1977",
    "difference": "-0,40%"
  },
  {
    "date": "15.09.2014",
    "now": "2,2121",
    "open": "2,2203",
    "highest": "2,2234",
    "lower": "2,2057",
    "difference": "-0,49%"
  },
  {
    "date": "12.09.2014",
    "now": "2,2230",
    "open": "2,2011",
    "highest": "2,2234",
    "lower": "2,1972",
    "difference": "1,01%"
  },
  {
    "date": "11.09.2014",
    "now": "2,2007",
    "open": "2,1930",
    "highest": "2,2029",
    "lower": "2,1852",
    "difference": "0,36%"
  },
  {
    "date": "10.09.2014",
    "now": "2,1929",
    "open": "2,1969",
    "highest": "2,2152",
    "lower": "2,1917",
    "difference": "-0,15%"
  },
  {
    "date": "09.09.2014",
    "now": "2,1963",
    "open": "2,1730",
    "highest": "2,2050",
    "lower": "2,1679",
    "difference": "1,05%"
  },
  {
    "date": "08.09.2014",
    "now": "2,1735",
    "open": "2,1582",
    "highest": "2,1744",
    "lower": "2,1554",
    "difference": "0,67%"
  },
  {
    "date": "05.09.2014",
    "now": "2,1590",
    "open": "2,1638",
    "highest": "2,1709",
    "lower": "2,1522",
    "difference": "-0,19%"
  },
  {
    "date": "04.09.2014",
    "now": "2,1632",
    "open": "2,1568",
    "highest": "2,1649",
    "lower": "2,1437",
    "difference": "0,25%"
  },
  {
    "date": "03.09.2014",
    "now": "2,1577",
    "open": "2,1724",
    "highest": "2,1742",
    "lower": "2,1537",
    "difference": "-0,69%"
  },
  {
    "date": "02.09.2014",
    "now": "2,1726",
    "open": "2,1602",
    "highest": "2,1797",
    "lower": "2,1584",
    "difference": "0,55%"
  },
  {
    "date": "01.09.2014",
    "now": "2,1607",
    "open": "2,1602",
    "highest": "2,1664",
    "lower": "2,1534",
    "difference": "-0,15%"
  },
  {
    "date": "29.08.2014",
    "now": "2,1639",
    "open": "2,1576",
    "highest": "2,1653",
    "lower": "2,1497",
    "difference": "0,26%"
  },
  {
    "date": "28.08.2014",
    "now": "2,1583",
    "open": "2,1542",
    "highest": "2,1727",
    "lower": "2,1517",
    "difference": "0,20%"
  },
  {
    "date": "27.08.2014",
    "now": "2,1539",
    "open": "2,1652",
    "highest": "2,1687",
    "lower": "2,1480",
    "difference": "-0,54%"
  },
  {
    "date": "26.08.2014",
    "now": "2,1655",
    "open": "2,1792",
    "highest": "2,1822",
    "lower": "2,1607",
    "difference": "-0,62%"
  },
  {
    "date": "25.08.2014",
    "now": "2,1790",
    "open": "2,1799",
    "highest": "2,1840",
    "lower": "2,1745",
    "difference": "0,16%"
  },
  {
    "date": "22.08.2014",
    "now": "2,1755",
    "open": "2,1772",
    "highest": "2,1857",
    "lower": "2,1677",
    "difference": "-0,11%"
  },
  {
    "date": "21.08.2014",
    "now": "2,1779",
    "open": "2,1862",
    "highest": "2,1893",
    "lower": "2,1667",
    "difference": "-0,37%"
  },
  {
    "date": "20.08.2014",
    "now": "2,1860",
    "open": "2,1613",
    "highest": "2,1863",
    "lower": "2,1582",
    "difference": "1,10%"
  },
  {
    "date": "19.08.2014",
    "now": "2,1622",
    "open": "2,1646",
    "highest": "2,1692",
    "lower": "2,1567",
    "difference": "-0,07%"
  },
  {
    "date": "18.08.2014",
    "now": "2,1638",
    "open": "2,1623",
    "highest": "2,1757",
    "lower": "2,1617",
    "difference": "-0,15%"
  },
  {
    "date": "15.08.2014",
    "now": "2,1671",
    "open": "2,1524",
    "highest": "2,1782",
    "lower": "2,1462",
    "difference": "0,71%"
  },
  {
    "date": "14.08.2014",
    "now": "2,1518",
    "open": "2,1568",
    "highest": "2,1647",
    "lower": "2,1447",
    "difference": "-0,24%"
  },
  {
    "date": "13.08.2014",
    "now": "2,1569",
    "open": "2,1646",
    "highest": "2,1657",
    "lower": "2,1497",
    "difference": "-0,34%"
  },
  {
    "date": "12.08.2014",
    "now": "2,1642",
    "open": "2,1506",
    "highest": "2,1695",
    "lower": "2,1487",
    "difference": "0,64%"
  },
  {
    "date": "11.08.2014",
    "now": "2,1505",
    "open": "2,1439",
    "highest": "2,1587",
    "lower": "2,1327",
    "difference": "0,26%"
  },
  {
    "date": "08.08.2014",
    "now": "2,1450",
    "open": "2,1657",
    "highest": "2,1885",
    "lower": "2,1412",
    "difference": "-1,02%"
  },
  {
    "date": "07.08.2014",
    "now": "2,1671",
    "open": "2,1592",
    "highest": "2,1722",
    "lower": "2,1526",
    "difference": "0,37%"
  },
  {
    "date": "06.08.2014",
    "now": "2,1592",
    "open": "2,1533",
    "highest": "2,1772",
    "lower": "2,1516",
    "difference": "0,31%"
  },
  {
    "date": "05.08.2014",
    "now": "2,1525",
    "open": "2,1307",
    "highest": "2,1535",
    "lower": "2,1207",
    "difference": "0,99%"
  },
  {
    "date": "04.08.2014",
    "now": "2,1313",
    "open": "2,1311",
    "highest": "2,1392",
    "lower": "2,1257",
    "difference": "-0,10%"
  },
  {
    "date": "01.08.2014",
    "now": "2,1334",
    "open": "2,1427",
    "highest": "2,1523",
    "lower": "2,1237",
    "difference": "-0,39%"
  },
  {
    "date": "31.07.2014",
    "now": "2,1418",
    "open": "2,1326",
    "highest": "2,1487",
    "lower": "2,1267",
    "difference": "0,42%"
  },
  {
    "date": "30.07.2014",
    "now": "2,1328",
    "open": "2,1163",
    "highest": "2,1422",
    "lower": "2,1090",
    "difference": "0,79%"
  },
  {
    "date": "29.07.2014",
    "now": "2,1161",
    "open": "2,0991",
    "highest": "2,1187",
    "lower": "2,0984",
    "difference": "0,80%"
  },
  {
    "date": "28.07.2014",
    "now": "2,0993",
    "open": "2,0907",
    "highest": "2,1039",
    "lower": "2,0903",
    "difference": "0,26%"
  },
  {
    "date": "25.07.2014",
    "now": "2,0939",
    "open": "2,0953",
    "highest": "2,0987",
    "lower": "2,0887",
    "difference": "0,10%"
  },
  {
    "date": "24.07.2014",
    "now": "2,0918",
    "open": "2,0880",
    "highest": "2,0985",
    "lower": "2,0847",
    "difference": "0,15%"
  },
  {
    "date": "23.07.2014",
    "now": "2,0886",
    "open": "2,1081",
    "highest": "2,1085",
    "lower": "2,0857",
    "difference": "-0,85%"
  },
  {
    "date": "22.07.2014",
    "now": "2,1065",
    "open": "2,1199",
    "highest": "2,1232",
    "lower": "2,1046",
    "difference": "-0,56%"
  },
  {
    "date": "21.07.2014",
    "now": "2,1183",
    "open": "2,1215",
    "highest": "2,1263",
    "lower": "2,1135",
    "difference": "-0,30%"
  },
  {
    "date": "18.07.2014",
    "now": "2,1247",
    "open": "2,1409",
    "highest": "2,1431",
    "lower": "2,1194",
    "difference": "-0,76%"
  },
  {
    "date": "17.07.2014",
    "now": "2,1410",
    "open": "2,1189",
    "highest": "2,1433",
    "lower": "2,1177",
    "difference": "1,02%"
  },
  {
    "date": "16.07.2014",
    "now": "2,1193",
    "open": "2,1244",
    "highest": "2,1282",
    "lower": "2,1152",
    "difference": "-0,23%"
  },
  {
    "date": "15.07.2014",
    "now": "2,1241",
    "open": "2,1168",
    "highest": "2,1282",
    "lower": "2,1142",
    "difference": "0,37%"
  },
  {
    "date": "14.07.2014",
    "now": "2,1162",
    "open": "2,1176",
    "highest": "2,1227",
    "lower": "2,1107",
    "difference": "-0,06%"
  },
  {
    "date": "11.07.2014",
    "now": "2,1175",
    "open": "2,1235",
    "highest": "2,1299",
    "lower": "2,1157",
    "difference": "-0,32%"
  },
  {
    "date": "10.07.2014",
    "now": "2,1244",
    "open": "2,1154",
    "highest": "2,1332",
    "lower": "2,1132",
    "difference": "0,43%"
  },
  {
    "date": "09.07.2014",
    "now": "2,1154",
    "open": "2,1246",
    "highest": "2,1287",
    "lower": "2,1146",
    "difference": "-0,46%"
  },
  {
    "date": "08.07.2014",
    "now": "2,1251",
    "open": "2,1292",
    "highest": "2,1322",
    "lower": "2,1207",
    "difference": "-0,20%"
  },
  {
    "date": "07.07.2014",
    "now": "2,1293",
    "open": "2,1296",
    "highest": "2,1377",
    "lower": "2,1267",
    "difference": "-0,17%"
  },
  {
    "date": "04.07.2014",
    "now": "2,1329",
    "open": "2,1279",
    "highest": "2,1362",
    "lower": "2,1232",
    "difference": "0,24%"
  },
  {
    "date": "03.07.2014",
    "now": "2,1278",
    "open": "2,1309",
    "highest": "2,1442",
    "lower": "2,1252",
    "difference": "-0,11%"
  },
  {
    "date": "02.07.2014",
    "now": "2,1302",
    "open": "2,1280",
    "highest": "2,1337",
    "lower": "2,1217",
    "difference": "0,08%"
  },
  {
    "date": "01.07.2014",
    "now": "2,1285",
    "open": "2,1191",
    "highest": "2,1317",
    "lower": "2,1137",
    "difference": "0,44%"
  },
  {
    "date": "30.06.2014",
    "now": "2,1191",
    "open": "2,1241",
    "highest": "2,1272",
    "lower": "2,1172",
    "difference": "-0,17%"
  },
  {
    "date": "27.06.2014",
    "now": "2,1228",
    "open": "2,1264",
    "highest": "2,1302",
    "lower": "2,1202",
    "difference": "-0,14%"
  },
  {
    "date": "26.06.2014",
    "now": "2,1258",
    "open": "2,1317",
    "highest": "2,1347",
    "lower": "2,1217",
    "difference": "-0,31%"
  },
  {
    "date": "25.06.2014",
    "now": "2,1325",
    "open": "2,1434",
    "highest": "2,1470",
    "lower": "2,1280",
    "difference": "-0,43%"
  },
  {
    "date": "24.06.2014",
    "now": "2,1418",
    "open": "2,1370",
    "highest": "2,1442",
    "lower": "2,1247",
    "difference": "0,21%"
  },
  {
    "date": "23.06.2014",
    "now": "2,1373",
    "open": "2,1393",
    "highest": "2,1482",
    "lower": "2,1322",
    "difference": "-0,15%"
  },
  {
    "date": "20.06.2014",
    "now": "2,1405",
    "open": "2,1418",
    "highest": "2,1512",
    "lower": "2,1325",
    "difference": "-0,10%"
  },
  {
    "date": "19.06.2014",
    "now": "2,1426",
    "open": "2,1261",
    "highest": "2,1457",
    "lower": "2,1192",
    "difference": "0,81%"
  },
  {
    "date": "18.06.2014",
    "now": "2,1254",
    "open": "2,1500",
    "highest": "2,1532",
    "lower": "2,1238",
    "difference": "-1,12%"
  },
  {
    "date": "17.06.2014",
    "now": "2,1495",
    "open": "2,1423",
    "highest": "2,1562",
    "lower": "2,1282",
    "difference": "0,33%"
  },
  {
    "date": "16.06.2014",
    "now": "2,1424",
    "open": "2,1259",
    "highest": "2,1462",
    "lower": "2,1241",
    "difference": "0,90%"
  },
  {
    "date": "13.06.2014",
    "now": "2,1233",
    "open": "2,1119",
    "highest": "2,1312",
    "lower": "2,1087",
    "difference": "0,55%"
  },
  {
    "date": "12.06.2014",
    "now": "2,1117",
    "open": "2,1142",
    "highest": "2,1249",
    "lower": "2,0972",
    "difference": "-0,24%"
  },
  {
    "date": "11.06.2014",
    "now": "2,1167",
    "open": "2,0794",
    "highest": "2,1186",
    "lower": "2,0777",
    "difference": "1,77%"
  },
  {
    "date": "10.06.2014",
    "now": "2,0798",
    "open": "2,0859",
    "highest": "2,0942",
    "lower": "2,0772",
    "difference": "-0,31%"
  },
  {
    "date": "09.06.2014",
    "now": "2,0863",
    "open": "2,0766",
    "highest": "2,0892",
    "lower": "2,0732",
    "difference": "0,39%"
  },
  {
    "date": "06.06.2014",
    "now": "2,0781",
    "open": "2,0960",
    "highest": "2,1022",
    "lower": "2,0737",
    "difference": "-0,87%"
  },
  {
    "date": "05.06.2014",
    "now": "2,0963",
    "open": "2,1161",
    "highest": "2,1173",
    "lower": "2,0942",
    "difference": "-0,91%"
  },
  {
    "date": "04.06.2014",
    "now": "2,1156",
    "open": "2,1174",
    "highest": "2,1287",
    "lower": "2,1097",
    "difference": "-0,08%"
  },
  {
    "date": "03.06.2014",
    "now": "2,1173",
    "open": "2,1072",
    "highest": "2,1214",
    "lower": "2,0927",
    "difference": "0,43%"
  },
  {
    "date": "02.06.2014",
    "now": "2,1083",
    "open": "2,0971",
    "highest": "2,1102",
    "lower": "2,0902",
    "difference": "0,53%"
  },
  {
    "date": "30.05.2014",
    "now": "2,0971",
    "open": "2,0867",
    "highest": "2,0993",
    "lower": "2,0851",
    "difference": "0,51%"
  },
  {
    "date": "29.05.2014",
    "now": "2,0865",
    "open": "2,0996",
    "highest": "2,1042",
    "lower": "2,0832",
    "difference": "-0,63%"
  },
  {
    "date": "28.05.2014",
    "now": "2,0998",
    "open": "2,1033",
    "highest": "2,1143",
    "lower": "2,0983",
    "difference": "-0,10%"
  },
  {
    "date": "27.05.2014",
    "now": "2,1018",
    "open": "2,0843",
    "highest": "2,1093",
    "lower": "2,0839",
    "difference": "0,91%"
  },
  {
    "date": "26.05.2014",
    "now": "2,0829",
    "open": "2,0813",
    "highest": "2,0902",
    "lower": "2,0799",
    "difference": "0,05%"
  },
  {
    "date": "23.05.2014",
    "now": "2,0818",
    "open": "2,0821",
    "highest": "2,0955",
    "lower": "2,0752",
    "difference": "0,02%"
  },
  {
    "date": "22.05.2014",
    "now": "2,0813",
    "open": "2,0929",
    "highest": "2,1017",
    "lower": "2,0782",
    "difference": "-0,61%"
  },
  {
    "date": "21.05.2014",
    "now": "2,0940",
    "open": "2,1136",
    "highest": "2,1200",
    "lower": "2,0902",
    "difference": "-0,92%"
  },
  {
    "date": "20.05.2014",
    "now": "2,1134",
    "open": "2,0971",
    "highest": "2,1172",
    "lower": "2,0902",
    "difference": "0,81%"
  },
  {
    "date": "19.05.2014",
    "now": "2,0965",
    "open": "2,0963",
    "highest": "2,1037",
    "lower": "2,0881",
    "difference": "-0,16%"
  },
  {
    "date": "16.05.2014",
    "now": "2,0998",
    "open": "2,0982",
    "highest": "2,1065",
    "lower": "2,0882",
    "difference": "0,07%"
  },
  {
    "date": "15.05.2014",
    "now": "2,0983",
    "open": "2,0693",
    "highest": "2,1037",
    "lower": "2,0677",
    "difference": "1,33%"
  },
  {
    "date": "14.05.2014",
    "now": "2,0707",
    "open": "2,0683",
    "highest": "2,0822",
    "lower": "2,0582",
    "difference": "0,11%"
  },
  {
    "date": "13.05.2014",
    "now": "2,0684",
    "open": "2,0809",
    "highest": "2,0828",
    "lower": "2,0617",
    "difference": "-0,60%"
  },
  {
    "date": "12.05.2014",
    "now": "2,0809",
    "open": "2,0761",
    "highest": "2,0882",
    "lower": "2,0677",
    "difference": "0,17%"
  },
  {
    "date": "09.05.2014",
    "now": "2,0773",
    "open": "2,0733",
    "highest": "2,0867",
    "lower": "2,0687",
    "difference": "0,17%"
  },
  {
    "date": "08.05.2014",
    "now": "2,0738",
    "open": "2,0819",
    "highest": "2,0862",
    "lower": "2,0647",
    "difference": "-0,39%"
  },
  {
    "date": "07.05.2014",
    "now": "2,0819",
    "open": "2,0904",
    "highest": "2,1002",
    "lower": "2,0797",
    "difference": "-0,39%"
  },
  {
    "date": "06.05.2014",
    "now": "2,0900",
    "open": "2,0999",
    "highest": "2,1021",
    "lower": "2,0872",
    "difference": "-0,49%"
  },
  {
    "date": "05.05.2014",
    "now": "2,1003",
    "open": "2,1075",
    "highest": "2,1075",
    "lower": "2,0922",
    "difference": "-0,17%"
  },
  {
    "date": "02.05.2014",
    "now": "2,1038",
    "open": "2,1058",
    "highest": "2,1148",
    "lower": "2,0947",
    "difference": "-0,08%"
  },
  {
    "date": "01.05.2014",
    "now": "2,1054",
    "open": "2,1122",
    "highest": "2,1147",
    "lower": "2,1012",
    "difference": "-0,34%"
  },
  {
    "date": "30.04.2014",
    "now": "2,1125",
    "open": "2,1207",
    "highest": "2,1272",
    "lower": "2,1082",
    "difference": "-0,41%"
  },
  {
    "date": "29.04.2014",
    "now": "2,1212",
    "open": "2,1257",
    "highest": "2,1295",
    "lower": "2,1132",
    "difference": "-0,21%"
  },
  {
    "date": "28.04.2014",
    "now": "2,1256",
    "open": "2,1389",
    "highest": "2,1467",
    "lower": "2,1247",
    "difference": "-0,39%"
  },
  {
    "date": "25.04.2014",
    "now": "2,1340",
    "open": "2,1356",
    "highest": "2,1426",
    "lower": "2,1282",
    "difference": "-0,07%"
  },
  {
    "date": "24.04.2014",
    "now": "2,1356",
    "open": "2,1500",
    "highest": "2,1525",
    "lower": "2,1247",
    "difference": "-0,69%"
  },
  {
    "date": "23.04.2014",
    "now": "2,1504",
    "open": "2,1419",
    "highest": "2,1547",
    "lower": "2,1377",
    "difference": "0,42%"
  },
  {
    "date": "22.04.2014",
    "now": "2,1415",
    "open": "2,1335",
    "highest": "2,1452",
    "lower": "2,1292",
    "difference": "0,35%"
  },
  {
    "date": "21.04.2014",
    "now": "2,1341",
    "open": "2,1297",
    "highest": "2,1407",
    "lower": "2,1264",
    "difference": "0,21%"
  },
  {
    "date": "18.04.2014",
    "now": "2,1296",
    "open": "2,1291",
    "highest": "2,1379",
    "lower": "2,1261",
    "difference": "0,15%"
  },
  {
    "date": "17.04.2014",
    "now": "2,1265",
    "open": "2,1372",
    "highest": "2,1387",
    "lower": "2,1196",
    "difference": "-0,44%"
  },
  {
    "date": "16.04.2014",
    "now": "2,1360",
    "open": "2,1456",
    "highest": "2,1481",
    "lower": "2,1296",
    "difference": "-0,32%"
  },
  {
    "date": "15.04.2014",
    "now": "2,1428",
    "open": "2,1166",
    "highest": "2,1463",
    "lower": "2,1128",
    "difference": "1,04%"
  },
  {
    "date": "14.04.2014",
    "now": "2,1208",
    "open": "2,1201",
    "highest": "2,1390",
    "lower": "2,1143",
    "difference": "0,37%"
  },
  {
    "date": "11.04.2014",
    "now": "2,1129",
    "open": "2,1092",
    "highest": "2,1307",
    "lower": "2,1027",
    "difference": "0,17%"
  },
  {
    "date": "10.04.2014",
    "now": "2,1093",
    "open": "2,1032",
    "highest": "2,1142",
    "lower": "2,0885",
    "difference": "0,26%"
  },
  {
    "date": "09.04.2014",
    "now": "2,1038",
    "open": "2,0971",
    "highest": "2,1257",
    "lower": "2,0940",
    "difference": "0,36%"
  },
  {
    "date": "08.04.2014",
    "now": "2,0962",
    "open": "2,1104",
    "highest": "2,1144",
    "lower": "2,0847",
    "difference": "-0,67%"
  },
  {
    "date": "07.04.2014",
    "now": "2,1103",
    "open": "2,1145",
    "highest": "2,1262",
    "lower": "2,1057",
    "difference": "-0,15%"
  },
  {
    "date": "04.04.2014",
    "now": "2,1135",
    "open": "2,1341",
    "highest": "2,1496",
    "lower": "2,1061",
    "difference": "-0,90%"
  },
  {
    "date": "03.04.2014",
    "now": "2,1327",
    "open": "2,1307",
    "highest": "2,1452",
    "lower": "2,1243",
    "difference": "0,24%"
  },
  {
    "date": "02.04.2014",
    "now": "2,1276",
    "open": "2,1394",
    "highest": "2,1531",
    "lower": "2,1193",
    "difference": "-0,48%"
  },
  {
    "date": "01.04.2014",
    "now": "2,1378",
    "open": "2,1397",
    "highest": "2,1567",
    "lower": "2,1323",
    "difference": "-0,14%"
  },
  {
    "date": "31.03.2014",
    "now": "2,1407",
    "open": "2,1887",
    "highest": "2,1887",
    "lower": "2,1316",
    "difference": "-2,29%"
  },
  {
    "date": "28.03.2014",
    "now": "2,1909",
    "open": "2,1882",
    "highest": "2,2012",
    "lower": "2,1829",
    "difference": "0,17%"
  },
  {
    "date": "27.03.2014",
    "now": "2,1872",
    "open": "2,1952",
    "highest": "2,2045",
    "lower": "2,1735",
    "difference": "-0,22%"
  },
  {
    "date": "26.03.2014",
    "now": "2,1921",
    "open": "2,2217",
    "highest": "2,2279",
    "lower": "2,1902",
    "difference": "-1,10%"
  },
  {
    "date": "25.03.2014",
    "now": "2,2165",
    "open": "2,2419",
    "highest": "2,2460",
    "lower": "2,2165",
    "difference": "-0,93%"
  },
  {
    "date": "24.03.2014",
    "now": "2,2372",
    "open": "2,2373",
    "highest": "2,2470",
    "lower": "2,2329",
    "difference": "0,17%"
  },
  {
    "date": "21.03.2014",
    "now": "2,2335",
    "open": "2,2301",
    "highest": "2,2457",
    "lower": "2,2231",
    "difference": "0,18%"
  },
  {
    "date": "20.03.2014",
    "now": "2,2294",
    "open": "2,2422",
    "highest": "2,2510",
    "lower": "2,2261",
    "difference": "-0,48%"
  },
  {
    "date": "19.03.2014",
    "now": "2,2401",
    "open": "2,2191",
    "highest": "2,2443",
    "lower": "2,2142",
    "difference": "0,96%"
  },
  {
    "date": "18.03.2014",
    "now": "2,2188",
    "open": "2,2239",
    "highest": "2,2359",
    "lower": "2,2168",
    "difference": "-0,05%"
  },
  {
    "date": "17.03.2014",
    "now": "2,2198",
    "open": "2,2200",
    "highest": "2,2311",
    "lower": "2,2144",
    "difference": "0,31%"
  },
  {
    "date": "14.03.2014",
    "now": "2,2130",
    "open": "2,2341",
    "highest": "2,2443",
    "lower": "2,2099",
    "difference": "-0,88%"
  },
  {
    "date": "13.03.2014",
    "now": "2,2327",
    "open": "2,2331",
    "highest": "2,2380",
    "lower": "2,2171",
    "difference": "0,02%"
  },
  {
    "date": "12.03.2014",
    "now": "2,2323",
    "open": "2,2516",
    "highest": "2,2642",
    "lower": "2,2323",
    "difference": "-0,64%"
  },
  {
    "date": "11.03.2014",
    "now": "2,2466",
    "open": "2,2193",
    "highest": "2,2475",
    "lower": "2,2112",
    "difference": "1,26%"
  },
  {
    "date": "10.03.2014",
    "now": "2,2186",
    "open": "2,2042",
    "highest": "2,2252",
    "lower": "2,2012",
    "difference": "0,59%"
  },
  {
    "date": "07.03.2014",
    "now": "2,2055",
    "open": "2,1805",
    "highest": "2,2077",
    "lower": "2,1780",
    "difference": "1,16%"
  },
  {
    "date": "06.03.2014",
    "now": "2,1803",
    "open": "2,2036",
    "highest": "2,2092",
    "lower": "2,1748",
    "difference": "-1,03%"
  },
  {
    "date": "05.03.2014",
    "now": "2,2031",
    "open": "2,2063",
    "highest": "2,2132",
    "lower": "2,1982",
    "difference": "-0,15%"
  },
  {
    "date": "04.03.2014",
    "now": "2,2065",
    "open": "2,2321",
    "highest": "2,2324",
    "lower": "2,2022",
    "difference": "-1,15%"
  },
  {
    "date": "03.03.2014",
    "now": "2,2321",
    "open": "2,2016",
    "highest": "2,2352",
    "lower": "2,2016",
    "difference": "1,03%"
  },
  {
    "date": "28.02.2014",
    "now": "2,2093",
    "open": "2,2129",
    "highest": "2,2247",
    "lower": "2,2004",
    "difference": "-0,20%"
  },
  {
    "date": "27.02.2014",
    "now": "2,2138",
    "open": "2,2264",
    "highest": "2,2477",
    "lower": "2,2110",
    "difference": "-0,63%"
  },
  {
    "date": "26.02.2014",
    "now": "2,2279",
    "open": "2,2127",
    "highest": "2,2548",
    "lower": "2,1968",
    "difference": "0,71%"
  },
  {
    "date": "25.02.2014",
    "now": "2,2122",
    "open": "2,2058",
    "highest": "2,2261",
    "lower": "2,1926",
    "difference": "0,46%"
  },
  {
    "date": "24.02.2014",
    "now": "2,2021",
    "open": "2,1806",
    "highest": "2,2027",
    "lower": "2,1688",
    "difference": "1,07%"
  },
  {
    "date": "21.02.2014",
    "now": "2,1787",
    "open": "2,2026",
    "highest": "2,2075",
    "lower": "2,1750",
    "difference": "-1,03%"
  },
  {
    "date": "20.02.2014",
    "now": "2,2013",
    "open": "2,2136",
    "highest": "2,2213",
    "lower": "2,1940",
    "difference": "-0,60%"
  },
  {
    "date": "19.02.2014",
    "now": "2,2145",
    "open": "2,1809",
    "highest": "2,2166",
    "lower": "2,1730",
    "difference": "1,56%"
  },
  {
    "date": "18.02.2014",
    "now": "2,1804",
    "open": "2,1810",
    "highest": "2,1911",
    "lower": "2,1753",
    "difference": "0,17%"
  },
  {
    "date": "17.02.2014",
    "now": "2,1767",
    "open": "2,1839",
    "highest": "2,1940",
    "lower": "2,1750",
    "difference": "-0,20%"
  },
  {
    "date": "14.02.2014",
    "now": "2,1810",
    "open": "2,1843",
    "highest": "2,1991",
    "lower": "2,1757",
    "difference": "-0,21%"
  },
  {
    "date": "13.02.2014",
    "now": "2,1856",
    "open": "2,1930",
    "highest": "2,2122",
    "lower": "2,1847",
    "difference": "-0,32%"
  },
  {
    "date": "12.02.2014",
    "now": "2,1926",
    "open": "2,1929",
    "highest": "2,2022",
    "lower": "2,1772",
    "difference": "-0,03%"
  },
  {
    "date": "11.02.2014",
    "now": "2,1932",
    "open": "2,2167",
    "highest": "2,2242",
    "lower": "2,1915",
    "difference": "-1,10%"
  },
  {
    "date": "10.02.2014",
    "now": "2,2176",
    "open": "2,2246",
    "highest": "2,2391",
    "lower": "2,2092",
    "difference": "-0,10%"
  },
  {
    "date": "07.02.2014",
    "now": "2,2199",
    "open": "2,2129",
    "highest": "2,2289",
    "lower": "2,1889",
    "difference": "0,47%"
  },
  {
    "date": "06.02.2014",
    "now": "2,2096",
    "open": "2,2380",
    "highest": "2,2387",
    "lower": "2,2022",
    "difference": "-1,30%"
  },
  {
    "date": "05.02.2014",
    "now": "2,2386",
    "open": "2,2374",
    "highest": "2,2534",
    "lower": "2,2303",
    "difference": "0,03%"
  },
  {
    "date": "04.02.2014",
    "now": "2,2380",
    "open": "2,2830",
    "highest": "2,2862",
    "lower": "2,2347",
    "difference": "-1,95%"
  },
  {
    "date": "03.02.2014",
    "now": "2,2824",
    "open": "2,2545",
    "highest": "2,2859",
    "lower": "2,2544",
    "difference": "0,96%"
  },
  {
    "date": "31.01.2014",
    "now": "2,2607",
    "open": "2,2665",
    "highest": "2,2962",
    "lower": "2,2402",
    "difference": "-0,38%"
  },
  {
    "date": "30.01.2014",
    "now": "2,2693",
    "open": "2,2617",
    "highest": "2,3027",
    "lower": "2,2397",
    "difference": "0,38%"
  },
  {
    "date": "29.01.2014",
    "now": "2,2607",
    "open": "2,2503",
    "highest": "2,3197",
    "lower": "2,1646",
    "difference": "0,39%"
  },
  {
    "date": "28.01.2014",
    "now": "2,2520",
    "open": "2,2853",
    "highest": "2,2900",
    "lower": "2,2505",
    "difference": "-1,36%"
  },
  {
    "date": "27.01.2014",
    "now": "2,2830",
    "open": "2,3334",
    "highest": "2,3930",
    "lower": "2,2828",
    "difference": "-2,08%"
  },
  {
    "date": "24.01.2014",
    "now": "2,3315",
    "open": "2,2934",
    "highest": "2,3392",
    "lower": "2,2843",
    "difference": "1,69%"
  },
  {
    "date": "23.01.2014",
    "now": "2,2928",
    "open": "2,2589",
    "highest": "2,3048",
    "lower": "2,2575",
    "difference": "1,53%"
  },
  {
    "date": "22.01.2014",
    "now": "2,2582",
    "open": "2,2516",
    "highest": "2,2687",
    "lower": "2,2352",
    "difference": "0,29%"
  },
  {
    "date": "21.01.2014",
    "now": "2,2517",
    "open": "2,2410",
    "highest": "2,2710",
    "lower": "2,2346",
    "difference": "0,51%"
  },
  {
    "date": "20.01.2014",
    "now": "2,2403",
    "open": "2,2326",
    "highest": "2,2529",
    "lower": "2,2306",
    "difference": "0,39%"
  },
  {
    "date": "17.01.2014",
    "now": "2,2317",
    "open": "2,2098",
    "highest": "2,2355",
    "lower": "2,2043",
    "difference": "1,12%"
  },
  {
    "date": "16.01.2014",
    "now": "2,2069",
    "open": "2,1923",
    "highest": "2,2157",
    "lower": "2,1904",
    "difference": "0,71%"
  },
  {
    "date": "15.01.2014",
    "now": "2,1913",
    "open": "2,1864",
    "highest": "2,2011",
    "lower": "2,1831",
    "difference": "0,34%"
  },
  {
    "date": "14.01.2014",
    "now": "2,1838",
    "open": "2,1794",
    "highest": "2,1989",
    "lower": "2,1775",
    "difference": "0,20%"
  },
  {
    "date": "13.01.2014",
    "now": "2,1795",
    "open": "2,1644",
    "highest": "2,1881",
    "lower": "2,1621",
    "difference": "0,67%"
  },
  {
    "date": "10.01.2014",
    "now": "2,1650",
    "open": "2,1785",
    "highest": "2,1831",
    "lower": "2,1570",
    "difference": "-0,60%"
  },
  {
    "date": "09.01.2014",
    "now": "2,1780",
    "open": "2,1862",
    "highest": "2,1948",
    "lower": "2,1768",
    "difference": "-0,35%"
  },
  {
    "date": "08.01.2014",
    "now": "2,1856",
    "open": "2,1694",
    "highest": "2,1885",
    "lower": "2,1607",
    "difference": "0,82%"
  },
  {
    "date": "07.01.2014",
    "now": "2,1678",
    "open": "2,1731",
    "highest": "2,1842",
    "lower": "2,1572",
    "difference": "-0,17%"
  },
  {
    "date": "06.01.2014",
    "now": "2,1715",
    "open": "2,1757",
    "highest": "2,1955",
    "lower": "2,1700",
    "difference": "-0,32%"
  },
  {
    "date": "03.01.2014",
    "now": "2,1785",
    "open": "2,1713",
    "highest": "2,1835",
    "lower": "2,1610",
    "difference": "0,33%"
  },
  {
    "date": "02.01.2014",
    "now": "2,1713",
    "open": "2,1481",
    "highest": "2,1900",
    "lower": "2,1456",
    "difference": "1,07%"
  },
  {
    "date": "01.01.2014",
    "now": "2,1483",
    "open": "2,1447",
    "highest": "2,1483",
    "lower": "2,1447",
    "difference": "0,12%"
  },
  {
    "date": "31.12.2013",
    "now": "2,1458",
    "open": "2,1237",
    "highest": "2,1587",
    "lower": "2,1109",
    "difference": "1,07%"
  },
  {
    "date": "30.12.2013",
    "now": "2,1231",
    "open": "2,1505",
    "highest": "2,1576",
    "lower": "2,1185",
    "difference": "-1,31%"
  },
  {
    "date": "27.12.2013",
    "now": "2,1513",
    "open": "2,1290",
    "highest": "2,1796",
    "lower": "2,1141",
    "difference": "1,14%"
  },
  {
    "date": "26.12.2013",
    "now": "2,1271",
    "open": "2,0962",
    "highest": "2,1433",
    "lower": "2,0863",
    "difference": "1,50%"
  },
  {
    "date": "25.12.2013",
    "now": "2,0956",
    "open": "2,0790",
    "highest": "2,0956",
    "lower": "2,0607",
    "difference": "0,87%"
  },
  {
    "date": "24.12.2013",
    "now": "2,0775",
    "open": "2,0986",
    "highest": "2,1003",
    "lower": "2,0757",
    "difference": "-0,96%"
  },
  {
    "date": "23.12.2013",
    "now": "2,0977",
    "open": "2,0905",
    "highest": "2,0982",
    "lower": "2,0822",
    "difference": "0,28%"
  },
  {
    "date": "20.12.2013",
    "now": "2,0918",
    "open": "2,0737",
    "highest": "2,1012",
    "lower": "2,0728",
    "difference": "0,92%"
  },
  {
    "date": "19.12.2013",
    "now": "2,0728",
    "open": "2,0592",
    "highest": "2,0827",
    "lower": "2,0457",
    "difference": "0,73%"
  },
  {
    "date": "18.12.2013",
    "now": "2,0578",
    "open": "2,0376",
    "highest": "2,0606",
    "lower": "2,0360",
    "difference": "1,07%"
  },
  {
    "date": "17.12.2013",
    "now": "2,0360",
    "open": "2,0278",
    "highest": "2,0452",
    "lower": "2,0232",
    "difference": "0,42%"
  },
  {
    "date": "16.12.2013",
    "now": "2,0274",
    "open": "2,0432",
    "highest": "2,0438",
    "lower": "2,0252",
    "difference": "-0,64%"
  },
  {
    "date": "13.12.2013",
    "now": "2,0404",
    "open": "2,0444",
    "highest": "2,0488",
    "lower": "2,0366",
    "difference": "-0,14%"
  },
  {
    "date": "12.12.2013",
    "now": "2,0433",
    "open": "2,0427",
    "highest": "2,0480",
    "lower": "2,0330",
    "difference": "0,02%"
  },
  {
    "date": "11.12.2013",
    "now": "2,0429",
    "open": "2,0301",
    "highest": "2,0482",
    "lower": "2,0242",
    "difference": "0,74%"
  },
  {
    "date": "10.12.2013",
    "now": "2,0278",
    "open": "2,0322",
    "highest": "2,0356",
    "lower": "2,0210",
    "difference": "-0,23%"
  },
  {
    "date": "09.12.2013",
    "now": "2,0324",
    "open": "2,0251",
    "highest": "2,0385",
    "lower": "2,0219",
    "difference": "0,36%"
  },
  {
    "date": "06.12.2013",
    "now": "2,0252",
    "open": "2,0387",
    "highest": "2,0562",
    "lower": "2,0183",
    "difference": "-0,57%"
  },
  {
    "date": "05.12.2013",
    "now": "2,0368",
    "open": "2,0486",
    "highest": "2,0549",
    "lower": "2,0324",
    "difference": "-0,58%"
  },
  {
    "date": "04.12.2013",
    "now": "2,0486",
    "open": "2,0444",
    "highest": "2,0575",
    "lower": "2,0408",
    "difference": "0,25%"
  },
  {
    "date": "03.12.2013",
    "now": "2,0434",
    "open": "2,0396",
    "highest": "2,0488",
    "lower": "2,0294",
    "difference": "0,22%"
  },
  {
    "date": "02.12.2013",
    "now": "2,0389",
    "open": "2,0212",
    "highest": "2,0452",
    "lower": "2,0162",
    "difference": "0,95%"
  },
  {
    "date": "29.11.2013",
    "now": "2,0198",
    "open": "2,0152",
    "highest": "2,0262",
    "lower": "2,0121",
    "difference": "0,25%"
  },
  {
    "date": "28.11.2013",
    "now": "2,0147",
    "open": "2,0276",
    "highest": "2,0278",
    "lower": "2,0130",
    "difference": "-0,53%"
  },
  {
    "date": "27.11.2013",
    "now": "2,0254",
    "open": "2,0139",
    "highest": "2,0307",
    "lower": "2,0107",
    "difference": "0,59%"
  },
  {
    "date": "26.11.2013",
    "now": "2,0136",
    "open": "2,0098",
    "highest": "2,0253",
    "lower": "2,0019",
    "difference": "0,29%"
  },
  {
    "date": "25.11.2013",
    "now": "2,0078",
    "open": "2,0046",
    "highest": "2,0095",
    "lower": "1,9909",
    "difference": "0,10%"
  },
  {
    "date": "22.11.2013",
    "now": "2,0057",
    "open": "2,0166",
    "highest": "2,0229",
    "lower": "2,0034",
    "difference": "-0,55%"
  },
  {
    "date": "21.11.2013",
    "now": "2,0168",
    "open": "2,0151",
    "highest": "2,0272",
    "lower": "2,0122",
    "difference": "0,07%"
  },
  {
    "date": "20.11.2013",
    "now": "2,0154",
    "open": "2,0112",
    "highest": "2,0166",
    "lower": "1,9990",
    "difference": "0,21%"
  },
  {
    "date": "19.11.2013",
    "now": "2,0112",
    "open": "2,0217",
    "highest": "2,0242",
    "lower": "2,0027",
    "difference": "-0,53%"
  },
  {
    "date": "18.11.2013",
    "now": "2,0219",
    "open": "2,0316",
    "highest": "2,0358",
    "lower": "2,0162",
    "difference": "-0,36%"
  },
  {
    "date": "15.11.2013",
    "now": "2,0293",
    "open": "2,0330",
    "highest": "2,0440",
    "lower": "2,0265",
    "difference": "-0,20%"
  },
  {
    "date": "14.11.2013",
    "now": "2,0333",
    "open": "2,0442",
    "highest": "2,0528",
    "lower": "2,0317",
    "difference": "-0,53%"
  },
  {
    "date": "13.11.2013",
    "now": "2,0442",
    "open": "2,0550",
    "highest": "2,0612",
    "lower": "2,0429",
    "difference": "-0,50%"
  },
  {
    "date": "12.11.2013",
    "now": "2,0545",
    "open": "2,0446",
    "highest": "2,0623",
    "lower": "2,0423",
    "difference": "0,55%"
  },
  {
    "date": "11.11.2013",
    "now": "2,0433",
    "open": "2,0393",
    "highest": "2,0492",
    "lower": "2,0327",
    "difference": "0,21%"
  },
  {
    "date": "08.11.2013",
    "now": "2,0390",
    "open": "2,0344",
    "highest": "2,0530",
    "lower": "2,0200",
    "difference": "0,19%"
  },
  {
    "date": "07.11.2013",
    "now": "2,0352",
    "open": "2,0356",
    "highest": "2,0405",
    "lower": "2,0192",
    "difference": "-0,02%"
  },
  {
    "date": "06.11.2013",
    "now": "2,0356",
    "open": "2,0322",
    "highest": "2,0417",
    "lower": "2,0237",
    "difference": "0,29%"
  },
  {
    "date": "05.11.2013",
    "now": "2,0298",
    "open": "2,0176",
    "highest": "2,0377",
    "lower": "2,0147",
    "difference": "0,67%"
  },
  {
    "date": "04.11.2013",
    "now": "2,0162",
    "open": "2,0140",
    "highest": "2,0242",
    "lower": "2,0112",
    "difference": "-0,04%"
  },
  {
    "date": "01.11.2013",
    "now": "2,0170",
    "open": "1,9969",
    "highest": "2,0247",
    "lower": "1,9917",
    "difference": "1,05%"
  },
  {
    "date": "31.10.2013",
    "now": "1,9960",
    "open": "1,9945",
    "highest": "1,9992",
    "lower": "1,9852",
    "difference": "0,07%"
  },
  {
    "date": "30.10.2013",
    "now": "1,9947",
    "open": "1,9930",
    "highest": "1,9994",
    "lower": "1,9802",
    "difference": "0,17%"
  },
  {
    "date": "29.10.2013",
    "now": "1,9914",
    "open": "1,9852",
    "highest": "1,9957",
    "lower": "1,9831",
    "difference": "0,37%"
  },
  {
    "date": "28.10.2013",
    "now": "1,9841",
    "open": "1,9835",
    "highest": "1,9907",
    "lower": "1,9767",
    "difference": "0,03%"
  },
  {
    "date": "25.10.2013",
    "now": "1,9835",
    "open": "1,9805",
    "highest": "1,9917",
    "lower": "1,9767",
    "difference": "0,20%"
  },
  {
    "date": "24.10.2013",
    "now": "1,9796",
    "open": "1,9743",
    "highest": "1,9842",
    "lower": "1,9672",
    "difference": "0,19%"
  },
  {
    "date": "23.10.2013",
    "now": "1,9758",
    "open": "1,9680",
    "highest": "1,9808",
    "lower": "1,9665",
    "difference": "0,37%"
  },
  {
    "date": "22.10.2013",
    "now": "1,9685",
    "open": "1,9821",
    "highest": "1,9900",
    "lower": "1,9650",
    "difference": "-0,64%"
  },
  {
    "date": "21.10.2013",
    "now": "1,9812",
    "open": "1,9681",
    "highest": "1,9853",
    "lower": "1,9634",
    "difference": "0,64%"
  },
  {
    "date": "18.10.2013",
    "now": "1,9686",
    "open": "1,9667",
    "highest": "1,9748",
    "lower": "1,9623",
    "difference": "0,14%"
  },
  {
    "date": "17.10.2013",
    "now": "1,9659",
    "open": "1,9740",
    "highest": "1,9808",
    "lower": "1,9620",
    "difference": "-0,35%"
  },
  {
    "date": "16.10.2013",
    "now": "1,9728",
    "open": "1,9877",
    "highest": "1,9886",
    "lower": "1,9709",
    "difference": "-0,77%"
  },
  {
    "date": "15.10.2013",
    "now": "1,9882",
    "open": "1,9827",
    "highest": "1,9918",
    "lower": "1,9802",
    "difference": "0,32%"
  },
  {
    "date": "14.10.2013",
    "now": "1,9818",
    "open": "1,9836",
    "highest": "1,9925",
    "lower": "1,9782",
    "difference": "-0,03%"
  },
  {
    "date": "11.10.2013",
    "now": "1,9823",
    "open": "1,9774",
    "highest": "1,9897",
    "lower": "1,9717",
    "difference": "0,40%"
  },
  {
    "date": "10.10.2013",
    "now": "1,9745",
    "open": "1,9827",
    "highest": "1,9882",
    "lower": "1,9722",
    "difference": "-0,38%"
  },
  {
    "date": "09.10.2013",
    "now": "1,9820",
    "open": "1,9907",
    "highest": "1,9937",
    "lower": "1,9787",
    "difference": "-0,35%"
  },
  {
    "date": "08.10.2013",
    "now": "1,9889",
    "open": "1,9936",
    "highest": "1,9974",
    "lower": "1,9774",
    "difference": "-0,24%"
  },
  {
    "date": "07.10.2013",
    "now": "1,9937",
    "open": "1,9879",
    "highest": "2,0042",
    "lower": "1,9862",
    "difference": "0,33%"
  },
  {
    "date": "04.10.2013",
    "now": "1,9871",
    "open": "2,0029",
    "highest": "2,0047",
    "lower": "1,9857",
    "difference": "-0,79%"
  },
  {
    "date": "03.10.2013",
    "now": "2,0029",
    "open": "1,9953",
    "highest": "2,0098",
    "lower": "1,9908",
    "difference": "0,45%"
  },
  {
    "date": "02.10.2013",
    "now": "1,9939",
    "open": "2,0079",
    "highest": "2,0242",
    "lower": "1,9932",
    "difference": "-0,77%"
  },
  {
    "date": "01.10.2013",
    "now": "2,0094",
    "open": "2,0198",
    "highest": "2,0228",
    "lower": "2,0013",
    "difference": "-0,46%"
  },
  {
    "date": "30.09.2013",
    "now": "2,0186",
    "open": "2,0418",
    "highest": "2,0477",
    "lower": "2,0127",
    "difference": "-0,61%"
  },
  {
    "date": "27.09.2013",
    "now": "2,0309",
    "open": "2,0227",
    "highest": "2,0442",
    "lower": "2,0132",
    "difference": "0,40%"
  },
  {
    "date": "26.09.2013",
    "now": "2,0228",
    "open": "2,0179",
    "highest": "2,0263",
    "lower": "2,0062",
    "difference": "0,34%"
  },
  {
    "date": "25.09.2013",
    "now": "2,0160",
    "open": "1,9971",
    "highest": "2,0164",
    "lower": "1,9931",
    "difference": "0,86%"
  },
  {
    "date": "24.09.2013",
    "now": "1,9989",
    "open": "1,9853",
    "highest": "2,0059",
    "lower": "1,9818",
    "difference": "0,69%"
  },
  {
    "date": "23.09.2013",
    "now": "1,9853",
    "open": "1,9778",
    "highest": "1,9955",
    "lower": "1,9712",
    "difference": "0,27%"
  },
  {
    "date": "20.09.2013",
    "now": "1,9799",
    "open": "1,9618",
    "highest": "1,9896",
    "lower": "1,9587",
    "difference": "0,99%"
  },
  {
    "date": "19.09.2013",
    "now": "1,9605",
    "open": "1,9511",
    "highest": "1,9927",
    "lower": "1,9322",
    "difference": "0,53%"
  },
  {
    "date": "18.09.2013",
    "now": "1,9501",
    "open": "2,0022",
    "highest": "2,0102",
    "lower": "1,9422",
    "difference": "-2,58%"
  },
  {
    "date": "17.09.2013",
    "now": "2,0018",
    "open": "2,0061",
    "highest": "2,0157",
    "lower": "1,9967",
    "difference": "-0,13%"
  },
  {
    "date": "16.09.2013",
    "now": "2,0045",
    "open": "2,0277",
    "highest": "2,0292",
    "lower": "1,9858",
    "difference": "-1,16%"
  },
  {
    "date": "13.09.2013",
    "now": "2,0280",
    "open": "2,0315",
    "highest": "2,0410",
    "lower": "2,0210",
    "difference": "-0,13%"
  },
  {
    "date": "12.09.2013",
    "now": "2,0306",
    "open": "2,0124",
    "highest": "2,0338",
    "lower": "2,0082",
    "difference": "0,94%"
  },
  {
    "date": "11.09.2013",
    "now": "2,0117",
    "open": "2,0145",
    "highest": "2,0290",
    "lower": "2,0020",
    "difference": "-0,12%"
  },
  {
    "date": "10.09.2013",
    "now": "2,0141",
    "open": "2,0264",
    "highest": "2,0388",
    "lower": "2,0038",
    "difference": "-0,62%"
  },
  {
    "date": "09.09.2013",
    "now": "2,0266",
    "open": "2,0460",
    "highest": "2,0551",
    "lower": "2,0244",
    "difference": "-0,97%"
  },
  {
    "date": "06.09.2013",
    "now": "2,0465",
    "open": "2,0704",
    "highest": "2,0785",
    "lower": "2,0435",
    "difference": "-1,09%"
  },
  {
    "date": "05.09.2013",
    "now": "2,0691",
    "open": "2,0502",
    "highest": "2,0872",
    "lower": "2,0464",
    "difference": "0,91%"
  },
  {
    "date": "04.09.2013",
    "now": "2,0505",
    "open": "2,0595",
    "highest": "2,0690",
    "lower": "2,0320",
    "difference": "-0,38%"
  },
  {
    "date": "03.09.2013",
    "now": "2,0584",
    "open": "2,0235",
    "highest": "2,0657",
    "lower": "2,0150",
    "difference": "1,84%"
  },
  {
    "date": "02.09.2013",
    "now": "2,0213",
    "open": "2,0359",
    "highest": "2,0368",
    "lower": "2,0098",
    "difference": "-0,93%"
  },
  {
    "date": "30.08.2013",
    "now": "2,0403",
    "open": "2,0366",
    "highest": "2,0475",
    "lower": "2,0246",
    "difference": "0,22%"
  },
  {
    "date": "29.08.2013",
    "now": "2,0358",
    "open": "2,0400",
    "highest": "2,0422",
    "lower": "2,0228",
    "difference": "-0,08%"
  },
  {
    "date": "28.08.2013",
    "now": "2,0374",
    "open": "2,0365",
    "highest": "2,0750",
    "lower": "2,0327",
    "difference": "0,05%"
  },
  {
    "date": "27.08.2013",
    "now": "2,0363",
    "open": "1,9987",
    "highest": "2,0437",
    "lower": "1,9968",
    "difference": "1,92%"
  },
  {
    "date": "26.08.2013",
    "now": "1,9980",
    "open": "1,9878",
    "highest": "2,0020",
    "lower": "1,9850",
    "difference": "0,51%"
  },
  {
    "date": "23.08.2013",
    "now": "1,9878",
    "open": "1,9942",
    "highest": "2,0027",
    "lower": "1,9797",
    "difference": "-0,29%"
  },
  {
    "date": "22.08.2013",
    "now": "1,9936",
    "open": "1,9782",
    "highest": "1,9990",
    "lower": "1,9757",
    "difference": "0,76%"
  },
  {
    "date": "21.08.2013",
    "now": "1,9785",
    "open": "1,9496",
    "highest": "1,9820",
    "lower": "1,9470",
    "difference": "1,48%"
  },
  {
    "date": "20.08.2013",
    "now": "1,9496",
    "open": "1,9545",
    "highest": "1,9570",
    "lower": "1,9410",
    "difference": "-0,25%"
  },
  {
    "date": "19.08.2013",
    "now": "1,9544",
    "open": "1,9450",
    "highest": "1,9580",
    "lower": "1,9350",
    "difference": "0,50%"
  },
  {
    "date": "16.08.2013",
    "now": "1,9446",
    "open": "1,9337",
    "highest": "1,9463",
    "lower": "1,9302",
    "difference": "0,52%"
  },
  {
    "date": "15.08.2013",
    "now": "1,9345",
    "open": "1,9366",
    "highest": "1,9490",
    "lower": "1,9245",
    "difference": "0,01%"
  },
  {
    "date": "14.08.2013",
    "now": "1,9344",
    "open": "1,9343",
    "highest": "1,9443",
    "lower": "1,9307",
    "difference": "0,02%"
  },
  {
    "date": "13.08.2013",
    "now": "1,9340",
    "open": "1,9251",
    "highest": "1,9370",
    "lower": "1,9190",
    "difference": "0,46%"
  },
  {
    "date": "12.08.2013",
    "now": "1,9251",
    "open": "1,9225",
    "highest": "1,9290",
    "lower": "1,9130",
    "difference": "0,24%"
  },
  {
    "date": "09.08.2013",
    "now": "1,9204",
    "open": "1,9215",
    "highest": "1,9249",
    "lower": "1,9129",
    "difference": "-0,11%"
  },
  {
    "date": "08.08.2013",
    "now": "1,9225",
    "open": "1,9319",
    "highest": "1,9329",
    "lower": "1,9160",
    "difference": "-0,50%"
  },
  {
    "date": "07.08.2013",
    "now": "1,9322",
    "open": "1,9244",
    "highest": "1,9352",
    "lower": "1,9240",
    "difference": "0,36%"
  },
  {
    "date": "06.08.2013",
    "now": "1,9252",
    "open": "1,9295",
    "highest": "1,9362",
    "lower": "1,9232",
    "difference": "-0,26%"
  },
  {
    "date": "05.08.2013",
    "now": "1,9303",
    "open": "1,9235",
    "highest": "1,9370",
    "lower": "1,9210",
    "difference": "0,25%"
  },
  {
    "date": "02.08.2013",
    "now": "1,9255",
    "open": "1,9465",
    "highest": "1,9532",
    "lower": "1,9212",
    "difference": "-1,10%"
  },
  {
    "date": "01.08.2013",
    "now": "1,9470",
    "open": "1,9345",
    "highest": "1,9520",
    "lower": "1,9320",
    "difference": "0,60%"
  },
  {
    "date": "31.07.2013",
    "now": "1,9353",
    "open": "1,9232",
    "highest": "1,9480",
    "lower": "1,9220",
    "difference": "0,64%"
  },
  {
    "date": "30.07.2013",
    "now": "1,9229",
    "open": "1,9255",
    "highest": "1,9307",
    "lower": "1,9187",
    "difference": "-0,18%"
  },
  {
    "date": "29.07.2013",
    "now": "1,9263",
    "open": "1,9269",
    "highest": "1,9310",
    "lower": "1,9194",
    "difference": "0,02%"
  },
  {
    "date": "26.07.2013",
    "now": "1,9260",
    "open": "1,9215",
    "highest": "1,9327",
    "lower": "1,9177",
    "difference": "0,28%"
  },
  {
    "date": "25.07.2013",
    "now": "1,9206",
    "open": "1,9195",
    "highest": "1,9332",
    "lower": "1,9142",
    "difference": "-0,04%"
  },
  {
    "date": "24.07.2013",
    "now": "1,9213",
    "open": "1,9004",
    "highest": "1,9265",
    "lower": "1,8983",
    "difference": "1,10%"
  },
  {
    "date": "23.07.2013",
    "now": "1,9004",
    "open": "1,9130",
    "highest": "1,9210",
    "lower": "1,8998",
    "difference": "-0,61%"
  },
  {
    "date": "22.07.2013",
    "now": "1,9120",
    "open": "1,9189",
    "highest": "1,9210",
    "lower": "1,9100",
    "difference": "-0,32%"
  },
  {
    "date": "19.07.2013",
    "now": "1,9181",
    "open": "1,9211",
    "highest": "1,9297",
    "lower": "1,9152",
    "difference": "-0,17%"
  },
  {
    "date": "18.07.2013",
    "now": "1,9214",
    "open": "1,9098",
    "highest": "1,9266",
    "lower": "1,9090",
    "difference": "0,55%"
  },
  {
    "date": "17.07.2013",
    "now": "1,9108",
    "open": "1,9200",
    "highest": "1,9320",
    "lower": "1,9066",
    "difference": "-0,53%"
  },
  {
    "date": "16.07.2013",
    "now": "1,9210",
    "open": "1,9335",
    "highest": "1,9400",
    "lower": "1,9170",
    "difference": "-0,65%"
  },
  {
    "date": "15.07.2013",
    "now": "1,9335",
    "open": "1,9560",
    "highest": "1,9564",
    "lower": "1,9318",
    "difference": "-0,97%"
  },
  {
    "date": "12.07.2013",
    "now": "1,9525",
    "open": "1,9506",
    "highest": "1,9685",
    "lower": "1,9455",
    "difference": "0,07%"
  },
  {
    "date": "11.07.2013",
    "now": "1,9511",
    "open": "1,9497",
    "highest": "1,9594",
    "lower": "1,9201",
    "difference": "0,07%"
  },
  {
    "date": "10.07.2013",
    "now": "1,9497",
    "open": "1,9405",
    "highest": "1,9640",
    "lower": "1,9350",
    "difference": "0,42%"
  },
  {
    "date": "09.07.2013",
    "now": "1,9415",
    "open": "1,9463",
    "highest": "1,9540",
    "lower": "1,9320",
    "difference": "-0,30%"
  },
  {
    "date": "08.07.2013",
    "now": "1,9473",
    "open": "1,9679",
    "highest": "1,9755",
    "lower": "1,9420",
    "difference": "-1,07%"
  },
  {
    "date": "05.07.2013",
    "now": "1,9683",
    "open": "1,9420",
    "highest": "1,9730",
    "lower": "1,9415",
    "difference": "1,30%"
  },
  {
    "date": "04.07.2013",
    "now": "1,9430",
    "open": "1,9460",
    "highest": "1,9600",
    "lower": "1,9355",
    "difference": "-0,21%"
  },
  {
    "date": "03.07.2013",
    "now": "1,9470",
    "open": "1,9339",
    "highest": "1,9570",
    "lower": "1,9319",
    "difference": "0,72%"
  },
  {
    "date": "02.07.2013",
    "now": "1,9331",
    "open": "1,9230",
    "highest": "1,9387",
    "lower": "1,9164",
    "difference": "0,47%"
  },
  {
    "date": "01.07.2013",
    "now": "1,9240",
    "open": "1,9303",
    "highest": "1,9321",
    "lower": "1,9185",
    "difference": "-0,25%"
  },
  {
    "date": "28.06.2013",
    "now": "1,9288",
    "open": "1,9220",
    "highest": "1,9390",
    "lower": "1,9130",
    "difference": "0,46%"
  },
  {
    "date": "27.06.2013",
    "now": "1,9199",
    "open": "1,9354",
    "highest": "1,9383",
    "lower": "1,9160",
    "difference": "-0,80%"
  },
  {
    "date": "26.06.2013",
    "now": "1,9354",
    "open": "1,9311",
    "highest": "1,9460",
    "lower": "1,9220",
    "difference": "0,22%"
  },
  {
    "date": "25.06.2013",
    "now": "1,9311",
    "open": "1,9438",
    "highest": "1,9495",
    "lower": "1,9235",
    "difference": "-0,65%"
  },
  {
    "date": "24.06.2013",
    "now": "1,9438",
    "open": "1,9376",
    "highest": "1,9630",
    "lower": "1,9320",
    "difference": "0,26%"
  },
  {
    "date": "21.06.2013",
    "now": "1,9388",
    "open": "1,9376",
    "highest": "1,9500",
    "lower": "1,9230",
    "difference": "0,10%"
  },
  {
    "date": "20.06.2013",
    "now": "1,9369",
    "open": "1,9030",
    "highest": "1,9525",
    "lower": "1,8990",
    "difference": "1,83%"
  },
  {
    "date": "19.06.2013",
    "now": "1,9020",
    "open": "1,8865",
    "highest": "1,9107",
    "lower": "1,8770",
    "difference": "0,82%"
  },
  {
    "date": "18.06.2013",
    "now": "1,8865",
    "open": "1,8733",
    "highest": "1,8910",
    "lower": "1,8680",
    "difference": "0,66%"
  },
  {
    "date": "17.06.2013",
    "now": "1,8741",
    "open": "1,8576",
    "highest": "1,8774",
    "lower": "1,8566",
    "difference": "0,81%"
  },
  {
    "date": "14.06.2013",
    "now": "1,8590",
    "open": "1,8620",
    "highest": "1,8650",
    "lower": "1,8490",
    "difference": "-0,14%"
  },
  {
    "date": "13.06.2013",
    "now": "1,8616",
    "open": "1,8750",
    "highest": "1,8795",
    "lower": "1,8594",
    "difference": "-0,73%"
  },
  {
    "date": "12.06.2013",
    "now": "1,8752",
    "open": "1,8916",
    "highest": "1,8965",
    "lower": "1,8680",
    "difference": "-0,88%"
  },
  {
    "date": "11.06.2013",
    "now": "1,8918",
    "open": "1,9018",
    "highest": "1,9110",
    "lower": "1,8844",
    "difference": "-0,53%"
  },
  {
    "date": "10.06.2013",
    "now": "1,9018",
    "open": "1,8770",
    "highest": "1,9050",
    "lower": "1,8746",
    "difference": "1,54%"
  },
  {
    "date": "07.06.2013",
    "now": "1,8730",
    "open": "1,8935",
    "highest": "1,9030",
    "lower": "1,8730",
    "difference": "-1,07%"
  },
  {
    "date": "06.06.2013",
    "now": "1,8932",
    "open": "1,8921",
    "highest": "1,9088",
    "lower": "1,8798",
    "difference": "0,05%"
  },
  {
    "date": "05.06.2013",
    "now": "1,8923",
    "open": "1,8785",
    "highest": "1,8951",
    "lower": "1,8707",
    "difference": "0,82%"
  },
  {
    "date": "04.06.2013",
    "now": "1,8769",
    "open": "1,8848",
    "highest": "1,8912",
    "lower": "1,8690",
    "difference": "-0,31%"
  },
  {
    "date": "03.06.2013",
    "now": "1,8828",
    "open": "1,8794",
    "highest": "1,9021",
    "lower": "1,8792",
    "difference": "0,38%"
  },
  {
    "date": "31.05.2013",
    "now": "1,8756",
    "open": "1,8723",
    "highest": "1,8978",
    "lower": "1,8638",
    "difference": "0,11%"
  },
  {
    "date": "30.05.2013",
    "now": "1,8735",
    "open": "1,8605",
    "highest": "1,8830",
    "lower": "1,8574",
    "difference": "0,70%"
  },
  {
    "date": "29.05.2013",
    "now": "1,8605",
    "open": "1,8604",
    "highest": "1,8730",
    "lower": "1,8570",
    "difference": "0,13%"
  },
  {
    "date": "28.05.2013",
    "now": "1,8580",
    "open": "1,8458",
    "highest": "1,8630",
    "lower": "1,8435",
    "difference": "0,66%"
  },
  {
    "date": "27.05.2013",
    "now": "1,8458",
    "open": "1,8501",
    "highest": "1,8501",
    "lower": "1,8395",
    "difference": "-0,04%"
  },
  {
    "date": "24.05.2013",
    "now": "1,8466",
    "open": "1,8449",
    "highest": "1,8515",
    "lower": "1,8399",
    "difference": "0,01%"
  },
  {
    "date": "23.05.2013",
    "now": "1,8464",
    "open": "1,8481",
    "highest": "1,8610",
    "lower": "1,8425",
    "difference": "-0,15%"
  },
  {
    "date": "22.05.2013",
    "now": "1,8491",
    "open": "1,8431",
    "highest": "1,8527",
    "lower": "1,8320",
    "difference": "0,33%"
  },
  {
    "date": "21.05.2013",
    "now": "1,8431",
    "open": "1,8408",
    "highest": "1,8580",
    "lower": "1,8405",
    "difference": "0,12%"
  },
  {
    "date": "20.05.2013",
    "now": "1,8408",
    "open": "1,8427",
    "highest": "1,8510",
    "lower": "1,8375",
    "difference": "-0,07%"
  },
  {
    "date": "17.05.2013",
    "now": "1,8421",
    "open": "1,8233",
    "highest": "1,8482",
    "lower": "1,8210",
    "difference": "0,99%"
  },
  {
    "date": "16.05.2013",
    "now": "1,8241",
    "open": "1,8226",
    "highest": "1,8410",
    "lower": "1,8195",
    "difference": "0,08%"
  },
  {
    "date": "15.05.2013",
    "now": "1,8226",
    "open": "1,8170",
    "highest": "1,8295",
    "lower": "1,8160",
    "difference": "0,39%"
  },
  {
    "date": "14.05.2013",
    "now": "1,8155",
    "open": "1,8130",
    "highest": "1,8200",
    "lower": "1,8078",
    "difference": "0,19%"
  },
  {
    "date": "13.05.2013",
    "now": "1,8120",
    "open": "1,8013",
    "highest": "1,8160",
    "lower": "1,8004",
    "difference": "0,59%"
  },
  {
    "date": "10.05.2013",
    "now": "1,8013",
    "open": "1,7987",
    "highest": "1,8090",
    "lower": "1,7960",
    "difference": "0,14%"
  },
  {
    "date": "09.05.2013",
    "now": "1,7987",
    "open": "1,7924",
    "highest": "1,8013",
    "lower": "1,7880",
    "difference": "0,49%"
  },
  {
    "date": "08.05.2013",
    "now": "1,7900",
    "open": "1,7964",
    "highest": "1,8020",
    "lower": "1,7880",
    "difference": "-0,38%"
  },
  {
    "date": "07.05.2013",
    "now": "1,7968",
    "open": "1,7961",
    "highest": "1,8039",
    "lower": "1,7930",
    "difference": "-0,02%"
  },
  {
    "date": "06.05.2013",
    "now": "1,7972",
    "open": "1,7976",
    "highest": "1,8030",
    "lower": "1,7930",
    "difference": "0,16%"
  },
  {
    "date": "03.05.2013",
    "now": "1,7943",
    "open": "1,7915",
    "highest": "1,8007",
    "lower": "1,7898",
    "difference": "0,08%"
  },
  {
    "date": "02.05.2013",
    "now": "1,7928",
    "open": "1,7927",
    "highest": "1,7990",
    "lower": "1,7860",
    "difference": "0,01%"
  },
  {
    "date": "01.05.2013",
    "now": "1,7927",
    "open": "1,7940",
    "highest": "1,7972",
    "lower": "1,7910",
    "difference": "-0,02%"
  },
  {
    "date": "30.04.2013",
    "now": "1,7930",
    "open": "1,7956",
    "highest": "1,8030",
    "lower": "1,7915",
    "difference": "-0,14%"
  },
  {
    "date": "29.04.2013",
    "now": "1,7956",
    "open": "1,7981",
    "highest": "1,8010",
    "lower": "1,7910",
    "difference": "-0,11%"
  },
  {
    "date": "26.04.2013",
    "now": "1,7975",
    "open": "1,7985",
    "highest": "1,8060",
    "lower": "1,7947",
    "difference": "-0,07%"
  },
  {
    "date": "25.04.2013",
    "now": "1,7988",
    "open": "1,8028",
    "highest": "1,8064",
    "lower": "1,7959",
    "difference": "-0,20%"
  },
  {
    "date": "24.04.2013",
    "now": "1,8024",
    "open": "1,8054",
    "highest": "1,8105",
    "lower": "1,8020",
    "difference": "-0,12%"
  },
  {
    "date": "23.04.2013",
    "now": "1,8046",
    "open": "1,8038",
    "highest": "1,8119",
    "lower": "1,8010",
    "difference": "0,02%"
  },
  {
    "date": "22.04.2013",
    "now": "1,8043",
    "open": "1,8020",
    "highest": "1,8110",
    "lower": "1,7959",
    "difference": "0,25%"
  },
  {
    "date": "19.04.2013",
    "now": "1,7998",
    "open": "1,7980",
    "highest": "1,8030",
    "lower": "1,7935",
    "difference": "0,18%"
  },
  {
    "date": "18.04.2013",
    "now": "1,7965",
    "open": "1,8008",
    "highest": "1,8033",
    "lower": "1,7928",
    "difference": "-0,17%"
  },
  {
    "date": "17.04.2013",
    "now": "1,7995",
    "open": "1,7882",
    "highest": "1,8023",
    "lower": "1,7850",
    "difference": "0,64%"
  },
  {
    "date": "16.04.2013",
    "now": "1,7880",
    "open": "1,7921",
    "highest": "1,7994",
    "lower": "1,7843",
    "difference": "-0,27%"
  },
  {
    "date": "15.04.2013",
    "now": "1,7929",
    "open": "1,7891",
    "highest": "1,7944",
    "lower": "1,7859",
    "difference": "0,27%"
  },
  {
    "date": "12.04.2013",
    "now": "1,7881",
    "open": "1,7839",
    "highest": "1,7941",
    "lower": "1,7829",
    "difference": "0,18%"
  },
  {
    "date": "11.04.2013",
    "now": "1,7848",
    "open": "1,7895",
    "highest": "1,7920",
    "lower": "1,7830",
    "difference": "-0,26%"
  },
  {
    "date": "10.04.2013",
    "now": "1,7895",
    "open": "1,7846",
    "highest": "1,7910",
    "lower": "1,7805",
    "difference": "0,29%"
  },
  {
    "date": "09.04.2013",
    "now": "1,7843",
    "open": "1,7847",
    "highest": "1,7906",
    "lower": "1,7784",
    "difference": "-0,10%"
  },
  {
    "date": "08.04.2013",
    "now": "1,7860",
    "open": "1,7963",
    "highest": "1,7987",
    "lower": "1,7845",
    "difference": "-0,42%"
  },
  {
    "date": "05.04.2013",
    "now": "1,7936",
    "open": "1,8034",
    "highest": "1,8090",
    "lower": "1,7926",
    "difference": "-0,54%"
  },
  {
    "date": "04.04.2013",
    "now": "1,8034",
    "open": "1,8089",
    "highest": "1,8160",
    "lower": "1,8023",
    "difference": "-0,30%"
  },
  {
    "date": "03.04.2013",
    "now": "1,8089",
    "open": "1,8049",
    "highest": "1,8150",
    "lower": "1,8005",
    "difference": "0,31%"
  },
  {
    "date": "02.04.2013",
    "now": "1,8033",
    "open": "1,8062",
    "highest": "1,8120",
    "lower": "1,8000",
    "difference": "-0,10%"
  },
  {
    "date": "01.04.2013",
    "now": "1,8051",
    "open": "1,8097",
    "highest": "1,8156",
    "lower": "1,8046",
    "difference": "-0,22%"
  },
  {
    "date": "29.03.2013",
    "now": "1,8090",
    "open": "1,8110",
    "highest": "1,8145",
    "lower": "1,8064",
    "difference": "-0,08%"
  },
  {
    "date": "28.03.2013",
    "now": "1,8104",
    "open": "1,8133",
    "highest": "1,8190",
    "lower": "1,8068",
    "difference": "-0,22%"
  },
  {
    "date": "27.03.2013",
    "now": "1,8144",
    "open": "1,8148",
    "highest": "1,8260",
    "lower": "1,8111",
    "difference": "0,01%"
  },
  {
    "date": "26.03.2013",
    "now": "1,8143",
    "open": "1,8238",
    "highest": "1,8250",
    "lower": "1,8120",
    "difference": "-0,45%"
  },
  {
    "date": "25.03.2013",
    "now": "1,8225",
    "open": "1,8107",
    "highest": "1,8252",
    "lower": "1,8077",
    "difference": "0,44%"
  },
  {
    "date": "22.03.2013",
    "now": "1,8146",
    "open": "1,8165",
    "highest": "1,8231",
    "lower": "1,8111",
    "difference": "-0,21%"
  },
  {
    "date": "21.03.2013",
    "now": "1,8184",
    "open": "1,8180",
    "highest": "1,8226",
    "lower": "1,8091",
    "difference": "0,04%"
  },
  {
    "date": "20.03.2013",
    "now": "1,8176",
    "open": "1,8276",
    "highest": "1,8298",
    "lower": "1,8157",
    "difference": "-0,41%"
  },
  {
    "date": "19.03.2013",
    "now": "1,8251",
    "open": "1,8129",
    "highest": "1,8270",
    "lower": "1,8095",
    "difference": "0,67%"
  },
  {
    "date": "18.03.2013",
    "now": "1,8130",
    "open": "1,8083",
    "highest": "1,8191",
    "lower": "1,8056",
    "difference": "0,37%"
  },
  {
    "date": "15.03.2013",
    "now": "1,8063",
    "open": "1,8095",
    "highest": "1,8147",
    "lower": "1,8037",
    "difference": "-0,19%"
  },
  {
    "date": "14.03.2013",
    "now": "1,8098",
    "open": "1,8128",
    "highest": "1,8180",
    "lower": "1,8090",
    "difference": "-0,15%"
  },
  {
    "date": "13.03.2013",
    "now": "1,8126",
    "open": "1,8026",
    "highest": "1,8167",
    "lower": "1,7967",
    "difference": "0,54%"
  },
  {
    "date": "12.03.2013",
    "now": "1,8029",
    "open": "1,7994",
    "highest": "1,8090",
    "lower": "1,7957",
    "difference": "0,22%"
  },
  {
    "date": "11.03.2013",
    "now": "1,7990",
    "open": "1,8078",
    "highest": "1,8102",
    "lower": "1,7989",
    "difference": "-0,30%"
  },
  {
    "date": "08.03.2013",
    "now": "1,8045",
    "open": "1,7973",
    "highest": "1,8087",
    "lower": "1,7896",
    "difference": "0,40%"
  },
  {
    "date": "07.03.2013",
    "now": "1,7973",
    "open": "1,7983",
    "highest": "1,8017",
    "lower": "1,7927",
    "difference": "-0,06%"
  },
  {
    "date": "06.03.2013",
    "now": "1,7984",
    "open": "1,7918",
    "highest": "1,7992",
    "lower": "1,7877",
    "difference": "0,38%"
  },
  {
    "date": "05.03.2013",
    "now": "1,7916",
    "open": "1,7994",
    "highest": "1,7996",
    "lower": "1,7907",
    "difference": "-0,41%"
  },
  {
    "date": "04.03.2013",
    "now": "1,7989",
    "open": "1,7990",
    "highest": "1,8066",
    "lower": "1,7966",
    "difference": "0,08%"
  },
  {
    "date": "01.03.2013",
    "now": "1,7974",
    "open": "1,7985",
    "highest": "1,8077",
    "lower": "1,7941",
    "difference": "-0,06%"
  },
  {
    "date": "28.02.2013",
    "now": "1,7985",
    "open": "1,7963",
    "highest": "1,8016",
    "lower": "1,7926",
    "difference": "0,04%"
  },
  {
    "date": "27.02.2013",
    "now": "1,7977",
    "open": "1,8054",
    "highest": "1,8110",
    "lower": "1,7977",
    "difference": "-0,43%"
  },
  {
    "date": "26.02.2013",
    "now": "1,8054",
    "open": "1,8091",
    "highest": "1,8166",
    "lower": "1,8030",
    "difference": "-0,22%"
  },
  {
    "date": "25.02.2013",
    "now": "1,8094",
    "open": "1,8005",
    "highest": "1,8099",
    "lower": "1,7904",
    "difference": "0,42%"
  },
  {
    "date": "22.02.2013",
    "now": "1,8019",
    "open": "1,7932",
    "highest": "1,8050",
    "lower": "1,7854",
    "difference": "0,43%"
  },
  {
    "date": "21.02.2013",
    "now": "1,7942",
    "open": "1,7843",
    "highest": "1,7980",
    "lower": "1,7825",
    "difference": "0,61%"
  },
  {
    "date": "20.02.2013",
    "now": "1,7833",
    "open": "1,7768",
    "highest": "1,7864",
    "lower": "1,7710",
    "difference": "0,38%"
  },
  {
    "date": "19.02.2013",
    "now": "1,7765",
    "open": "1,7668",
    "highest": "1,7820",
    "lower": "1,7640",
    "difference": "0,53%"
  },
  {
    "date": "18.02.2013",
    "now": "1,7672",
    "open": "1,7664",
    "highest": "1,7709",
    "lower": "1,7618",
    "difference": "0,04%"
  },
  {
    "date": "15.02.2013",
    "now": "1,7665",
    "open": "1,7675",
    "highest": "1,7730",
    "lower": "1,7640",
    "difference": "-0,10%"
  },
  {
    "date": "14.02.2013",
    "now": "1,7683",
    "open": "1,7620",
    "highest": "1,7735",
    "lower": "1,7620",
    "difference": "0,27%"
  },
  {
    "date": "13.02.2013",
    "now": "1,7635",
    "open": "1,7724",
    "highest": "1,7740",
    "lower": "1,7610",
    "difference": "-0,50%"
  },
  {
    "date": "12.02.2013",
    "now": "1,7724",
    "open": "1,7755",
    "highest": "1,7790",
    "lower": "1,7695",
    "difference": "-0,17%"
  },
  {
    "date": "11.02.2013",
    "now": "1,7755",
    "open": "1,7710",
    "highest": "1,7790",
    "lower": "1,7670",
    "difference": "0,23%"
  },
  {
    "date": "08.02.2013",
    "now": "1,7715",
    "open": "1,7750",
    "highest": "1,7770",
    "lower": "1,7665",
    "difference": "-0,14%"
  },
  {
    "date": "07.02.2013",
    "now": "1,7740",
    "open": "1,7687",
    "highest": "1,7760",
    "lower": "1,7630",
    "difference": "0,25%"
  },
  {
    "date": "06.02.2013",
    "now": "1,7695",
    "open": "1,7597",
    "highest": "1,7700",
    "lower": "1,7587",
    "difference": "0,47%"
  },
  {
    "date": "05.02.2013",
    "now": "1,7612",
    "open": "1,7613",
    "highest": "1,7670",
    "lower": "1,7550",
    "difference": "-0,01%"
  },
  {
    "date": "04.02.2013",
    "now": "1,7613",
    "open": "1,7488",
    "highest": "1,7660",
    "lower": "1,7440",
    "difference": "0,80%"
  },
  {
    "date": "01.02.2013",
    "now": "1,7473",
    "open": "1,7589",
    "highest": "1,7607",
    "lower": "1,7460",
    "difference": "-0,66%"
  },
  {
    "date": "31.01.2013",
    "now": "1,7589",
    "open": "1,7678",
    "highest": "1,7720",
    "lower": "1,7555",
    "difference": "-0,50%"
  },
  {
    "date": "30.01.2013",
    "now": "1,7678",
    "open": "1,7685",
    "highest": "1,7750",
    "lower": "1,7630",
    "difference": "-0,04%"
  },
  {
    "date": "29.01.2013",
    "now": "1,7685",
    "open": "1,7743",
    "highest": "1,7770",
    "lower": "1,7670",
    "difference": "-0,25%"
  },
  {
    "date": "28.01.2013",
    "now": "1,7730",
    "open": "1,7652",
    "highest": "1,7747",
    "lower": "1,7627",
    "difference": "0,31%"
  },
  {
    "date": "25.01.2013",
    "now": "1,7675",
    "open": "1,7686",
    "highest": "1,7735",
    "lower": "1,7620",
    "difference": "-0,06%"
  },
  {
    "date": "24.01.2013",
    "now": "1,7686",
    "open": "1,7716",
    "highest": "1,7760",
    "lower": "1,7670",
    "difference": "-0,17%"
  },
  {
    "date": "23.01.2013",
    "now": "1,7716",
    "open": "1,7690",
    "highest": "1,7765",
    "lower": "1,7665",
    "difference": "0,15%"
  },
  {
    "date": "22.01.2013",
    "now": "1,7690",
    "open": "1,7643",
    "highest": "1,7760",
    "lower": "1,7580",
    "difference": "0,27%"
  },
  {
    "date": "21.01.2013",
    "now": "1,7643",
    "open": "1,7633",
    "highest": "1,7680",
    "lower": "1,7570",
    "difference": "0,23%"
  },
  {
    "date": "18.01.2013",
    "now": "1,7603",
    "open": "1,7524",
    "highest": "1,7650",
    "lower": "1,7520",
    "difference": "0,45%"
  },
  {
    "date": "17.01.2013",
    "now": "1,7524",
    "open": "1,7653",
    "highest": "1,7685",
    "lower": "1,7518",
    "difference": "-0,73%"
  },
  {
    "date": "16.01.2013",
    "now": "1,7653",
    "open": "1,7699",
    "highest": "1,7750",
    "lower": "1,7635",
    "difference": "-0,21%"
  },
  {
    "date": "15.01.2013",
    "now": "1,7691",
    "open": "1,7689",
    "highest": "1,7748",
    "lower": "1,7658",
    "difference": "0,02%"
  },
  {
    "date": "14.01.2013",
    "now": "1,7688",
    "open": "1,7708",
    "highest": "1,7750",
    "lower": "1,7660",
    "difference": "-0,04%"
  },
  {
    "date": "11.01.2013",
    "now": "1,7695",
    "open": "1,7662",
    "highest": "1,7760",
    "lower": "1,7650",
    "difference": "0,13%"
  },
  {
    "date": "10.01.2013",
    "now": "1,7672",
    "open": "1,7753",
    "highest": "1,7794",
    "lower": "1,7670",
    "difference": "-0,46%"
  },
  {
    "date": "09.01.2013",
    "now": "1,7753",
    "open": "1,7802",
    "highest": "1,7830",
    "lower": "1,7730",
    "difference": "-0,17%"
  },
  {
    "date": "08.01.2013",
    "now": "1,7783",
    "open": "1,7798",
    "highest": "1,7840",
    "lower": "1,7715",
    "difference": "-0,08%"
  },
  {
    "date": "07.01.2013",
    "now": "1,7798",
    "open": "1,7826",
    "highest": "1,7881",
    "lower": "1,7770",
    "difference": "-0,11%"
  },
  {
    "date": "04.01.2013",
    "now": "1,7818",
    "open": "1,7851",
    "highest": "1,7926",
    "lower": "1,7818",
    "difference": "-0,16%"
  },
  {
    "date": "03.01.2013",
    "now": "1,7847",
    "open": "1,7787",
    "highest": "1,7862",
    "lower": "1,7756",
    "difference": "0,34%"
  },
  {
    "date": "02.01.2013",
    "now": "1,7787",
    "open": "1,7838",
    "highest": "1,7854",
    "lower": "1,7750",
    "difference": "-0,29%"
  },
  {
    "date": "01.01.2013",
    "now": "1,7838",
    "open": "1,7837",
    "highest": "1,7870",
    "lower": "1,7836",
    "difference": "0,01%"
  },
  {
    "date": "31.12.2012",
    "now": "1,7837",
    "open": "1,7919",
    "highest": "1,7928",
    "lower": "1,7810",
    "difference": "-0,32%"
  },
  {
    "date": "28.12.2012",
    "now": "1,7894",
    "open": "1,7888",
    "highest": "1,7950",
    "lower": "1,7840",
    "difference": "0,03%"
  },
  {
    "date": "27.12.2012",
    "now": "1,7888",
    "open": "1,7949",
    "highest": "1,7970",
    "lower": "1,7870",
    "difference": "-0,29%"
  },
  {
    "date": "26.12.2012",
    "now": "1,7940",
    "open": "1,7940",
    "highest": "1,7980",
    "lower": "1,7895",
    "difference": "0,00%"
  },
  {
    "date": "25.12.2012",
    "now": "1,7940",
    "open": "1,7971",
    "highest": "1,8010",
    "lower": "1,7920",
    "difference": "-0,17%"
  },
  {
    "date": "24.12.2012",
    "now": "1,7971",
    "open": "1,7979",
    "highest": "1,8030",
    "lower": "1,7920",
    "difference": "-0,02%"
  },
  {
    "date": "21.12.2012",
    "now": "1,7975",
    "open": "1,7851",
    "highest": "1,7986",
    "lower": "1,7851",
    "difference": "0,64%"
  },
  {
    "date": "20.12.2012",
    "now": "1,7861",
    "open": "1,7837",
    "highest": "1,7900",
    "lower": "1,7810",
    "difference": "0,13%"
  },
  {
    "date": "19.12.2012",
    "now": "1,7837",
    "open": "1,7791",
    "highest": "1,7847",
    "lower": "1,7752",
    "difference": "0,27%"
  },
  {
    "date": "18.12.2012",
    "now": "1,7789",
    "open": "1,7839",
    "highest": "1,7880",
    "lower": "1,7780",
    "difference": "-0,28%"
  },
  {
    "date": "17.12.2012",
    "now": "1,7839",
    "open": "1,7788",
    "highest": "1,7880",
    "lower": "1,7765",
    "difference": "0,28%"
  },
  {
    "date": "14.12.2012",
    "now": "1,7790",
    "open": "1,7800",
    "highest": "1,7850",
    "lower": "1,7767",
    "difference": "-0,13%"
  },
  {
    "date": "13.12.2012",
    "now": "1,7813",
    "open": "1,7758",
    "highest": "1,7839",
    "lower": "1,7726",
    "difference": "0,23%"
  },
  {
    "date": "12.12.2012",
    "now": "1,7772",
    "open": "1,7813",
    "highest": "1,7847",
    "lower": "1,7737",
    "difference": "-0,30%"
  },
  {
    "date": "11.12.2012",
    "now": "1,7826",
    "open": "1,7898",
    "highest": "1,7923",
    "lower": "1,7810",
    "difference": "-0,37%"
  },
  {
    "date": "10.12.2012",
    "now": "1,7892",
    "open": "1,7890",
    "highest": "1,7928",
    "lower": "1,7848",
    "difference": "0,04%"
  },
  {
    "date": "07.12.2012",
    "now": "1,7884",
    "open": "1,7897",
    "highest": "1,7950",
    "lower": "1,7878",
    "difference": "-0,03%"
  },
  {
    "date": "06.12.2012",
    "now": "1,7889",
    "open": "1,7851",
    "highest": "1,7923",
    "lower": "1,7846",
    "difference": "0,13%"
  },
  {
    "date": "05.12.2012",
    "now": "1,7865",
    "open": "1,7841",
    "highest": "1,7913",
    "lower": "1,7810",
    "difference": "0,13%"
  },
  {
    "date": "04.12.2012",
    "now": "1,7841",
    "open": "1,7869",
    "highest": "1,7900",
    "lower": "1,7820",
    "difference": "-0,16%"
  },
  {
    "date": "03.12.2012",
    "now": "1,7869",
    "open": "1,7867",
    "highest": "1,7910",
    "lower": "1,7830",
    "difference": "-0,02%"
  },
  {
    "date": "30.11.2012",
    "now": "1,7873",
    "open": "1,7860",
    "highest": "1,7910",
    "lower": "1,7830",
    "difference": "0,07%"
  },
  {
    "date": "29.11.2012",
    "now": "1,7860",
    "open": "1,7925",
    "highest": "1,7935",
    "lower": "1,7850",
    "difference": "-0,35%"
  },
  {
    "date": "28.11.2012",
    "now": "1,7923",
    "open": "1,7923",
    "highest": "1,7965",
    "lower": "1,7890",
    "difference": "0,00%"
  },
  {
    "date": "27.11.2012",
    "now": "1,7923",
    "open": "1,7959",
    "highest": "1,7986",
    "lower": "1,7900",
    "difference": "-0,20%"
  },
  {
    "date": "26.11.2012",
    "now": "1,7959",
    "open": "1,7941",
    "highest": "1,7990",
    "lower": "1,7905",
    "difference": "0,09%"
  },
  {
    "date": "23.11.2012",
    "now": "1,7942",
    "open": "1,7963",
    "highest": "1,8017",
    "lower": "1,7897",
    "difference": "-0,18%"
  },
  {
    "date": "22.11.2012",
    "now": "1,7975",
    "open": "1,8033",
    "highest": "1,8042",
    "lower": "1,7960",
    "difference": "-0,27%"
  },
  {
    "date": "21.11.2012",
    "now": "1,8023",
    "open": "1,7927",
    "highest": "1,8050",
    "lower": "1,7920",
    "difference": "0,48%"
  },
  {
    "date": "20.11.2012",
    "now": "1,7937",
    "open": "1,7978",
    "highest": "1,8050",
    "lower": "1,7928",
    "difference": "-0,23%"
  },
  {
    "date": "19.11.2012",
    "now": "1,7978",
    "open": "1,8008",
    "highest": "1,8060",
    "lower": "1,7970",
    "difference": "-0,15%"
  },
  {
    "date": "16.11.2012",
    "now": "1,8005",
    "open": "1,7995",
    "highest": "1,8050",
    "lower": "1,7955",
    "difference": "-0,03%"
  },
  {
    "date": "15.11.2012",
    "now": "1,8010",
    "open": "1,8055",
    "highest": "1,8086",
    "lower": "1,7950",
    "difference": "-0,25%"
  },
  {
    "date": "14.11.2012",
    "now": "1,8055",
    "open": "1,8079",
    "highest": "1,8098",
    "lower": "1,7990",
    "difference": "-0,11%"
  },
  {
    "date": "13.11.2012",
    "now": "1,8074",
    "open": "1,7996",
    "highest": "1,8095",
    "lower": "1,7990",
    "difference": "0,35%"
  },
  {
    "date": "12.11.2012",
    "now": "1,8011",
    "open": "1,7906",
    "highest": "1,8040",
    "lower": "1,7865",
    "difference": "0,55%"
  },
  {
    "date": "09.11.2012",
    "now": "1,7912",
    "open": "1,7858",
    "highest": "1,7960",
    "lower": "1,7780",
    "difference": "0,30%"
  },
  {
    "date": "08.11.2012",
    "now": "1,7859",
    "open": "1,7850",
    "highest": "1,7880",
    "lower": "1,7775",
    "difference": "0,01%"
  },
  {
    "date": "07.11.2012",
    "now": "1,7858",
    "open": "1,7725",
    "highest": "1,7873",
    "lower": "1,7670",
    "difference": "0,69%"
  },
  {
    "date": "06.11.2012",
    "now": "1,7735",
    "open": "1,7818",
    "highest": "1,7844",
    "lower": "1,7715",
    "difference": "-0,47%"
  },
  {
    "date": "05.11.2012",
    "now": "1,7818",
    "open": "1,7956",
    "highest": "1,7980",
    "lower": "1,7790",
    "difference": "-0,61%"
  },
  {
    "date": "02.11.2012",
    "now": "1,7927",
    "open": "1,7873",
    "highest": "1,7947",
    "lower": "1,7841",
    "difference": "0,26%"
  },
  {
    "date": "01.11.2012",
    "now": "1,7881",
    "open": "1,7936",
    "highest": "1,7977",
    "lower": "1,7870",
    "difference": "-0,31%"
  },
  {
    "date": "31.10.2012",
    "now": "1,7936",
    "open": "1,7968",
    "highest": "1,7991",
    "lower": "1,7890",
    "difference": "-0,16%"
  },
  {
    "date": "30.10.2012",
    "now": "1,7965",
    "open": "1,8027",
    "highest": "1,8055",
    "lower": "1,7925",
    "difference": "-0,43%"
  },
  {
    "date": "29.10.2012",
    "now": "1,8042",
    "open": "1,8005",
    "highest": "1,8067",
    "lower": "1,8003",
    "difference": "0,20%"
  },
  {
    "date": "26.10.2012",
    "now": "1,8006",
    "open": "1,8011",
    "highest": "1,8079",
    "lower": "1,7972",
    "difference": "-0,04%"
  },
  {
    "date": "25.10.2012",
    "now": "1,8014",
    "open": "1,8032",
    "highest": "1,8035",
    "lower": "1,7965",
    "difference": "-0,12%"
  },
  {
    "date": "24.10.2012",
    "now": "1,8035",
    "open": "1,8015",
    "highest": "1,8107",
    "lower": "1,7965",
    "difference": "0,11%"
  },
  {
    "date": "23.10.2012",
    "now": "1,8015",
    "open": "1,7957",
    "highest": "1,8091",
    "lower": "1,7915",
    "difference": "0,32%"
  },
  {
    "date": "22.10.2012",
    "now": "1,7957",
    "open": "1,7940",
    "highest": "1,7990",
    "lower": "1,7910",
    "difference": "0,03%"
  },
  {
    "date": "19.10.2012",
    "now": "1,7951",
    "open": "1,7981",
    "highest": "1,8020",
    "lower": "1,7915",
    "difference": "-0,10%"
  },
  {
    "date": "18.10.2012",
    "now": "1,7969",
    "open": "1,7991",
    "highest": "1,8038",
    "lower": "1,7918",
    "difference": "-0,13%"
  },
  {
    "date": "17.10.2012",
    "now": "1,7993",
    "open": "1,8043",
    "highest": "1,8060",
    "lower": "1,7960",
    "difference": "-0,28%"
  },
  {
    "date": "16.10.2012",
    "now": "1,8043",
    "open": "1,8115",
    "highest": "1,8138",
    "lower": "1,8027",
    "difference": "-0,40%"
  },
  {
    "date": "15.10.2012",
    "now": "1,8115",
    "open": "1,8116",
    "highest": "1,8150",
    "lower": "1,8045",
    "difference": "0,25%"
  },
  {
    "date": "12.10.2012",
    "now": "1,8069",
    "open": "1,8075",
    "highest": "1,8130",
    "lower": "1,8020",
    "difference": "-0,03%"
  },
  {
    "date": "11.10.2012",
    "now": "1,8075",
    "open": "1,8180",
    "highest": "1,8214",
    "lower": "1,8067",
    "difference": "-0,59%"
  },
  {
    "date": "10.10.2012",
    "now": "1,8182",
    "open": "1,8224",
    "highest": "1,8264",
    "lower": "1,8055",
    "difference": "-0,31%"
  },
  {
    "date": "09.10.2012",
    "now": "1,8239",
    "open": "1,8107",
    "highest": "1,8263",
    "lower": "1,8050",
    "difference": "0,73%"
  },
  {
    "date": "08.10.2012",
    "now": "1,8107",
    "open": "1,8050",
    "highest": "1,8183",
    "lower": "1,8010",
    "difference": "0,31%"
  },
  {
    "date": "05.10.2012",
    "now": "1,8051",
    "open": "1,7981",
    "highest": "1,8092",
    "lower": "1,7920",
    "difference": "0,37%"
  },
  {
    "date": "04.10.2012",
    "now": "1,7984",
    "open": "1,8043",
    "highest": "1,8117",
    "lower": "1,7957",
    "difference": "-0,38%"
  },
  {
    "date": "03.10.2012",
    "now": "1,8052",
    "open": "1,7920",
    "highest": "1,8088",
    "lower": "1,7890",
    "difference": "0,74%"
  },
  {
    "date": "02.10.2012",
    "now": "1,7920",
    "open": "1,7917",
    "highest": "1,7970",
    "lower": "1,7890",
    "difference": "0,02%"
  },
  {
    "date": "01.10.2012",
    "now": "1,7917",
    "open": "1,7982",
    "highest": "1,8005",
    "lower": "1,7888",
    "difference": "-0,26%"
  },
  {
    "date": "28.09.2012",
    "now": "1,7964",
    "open": "1,7883",
    "highest": "1,8020",
    "lower": "1,7840",
    "difference": "0,45%"
  },
  {
    "date": "27.09.2012",
    "now": "1,7883",
    "open": "1,7928",
    "highest": "1,7960",
    "lower": "1,7860",
    "difference": "-0,21%"
  },
  {
    "date": "26.09.2012",
    "now": "1,7921",
    "open": "1,7922",
    "highest": "1,7979",
    "lower": "1,7887",
    "difference": "0,01%"
  },
  {
    "date": "25.09.2012",
    "now": "1,7919",
    "open": "1,7996",
    "highest": "1,8020",
    "lower": "1,7855",
    "difference": "-0,36%"
  },
  {
    "date": "24.09.2012",
    "now": "1,7984",
    "open": "1,7939",
    "highest": "1,8047",
    "lower": "1,7923",
    "difference": "0,22%"
  },
  {
    "date": "21.09.2012",
    "now": "1,7945",
    "open": "1,7983",
    "highest": "1,8010",
    "lower": "1,7910",
    "difference": "-0,21%"
  },
  {
    "date": "20.09.2012",
    "now": "1,7983",
    "open": "1,7956",
    "highest": "1,8070",
    "lower": "1,7941",
    "difference": "0,23%"
  },
  {
    "date": "19.09.2012",
    "now": "1,7941",
    "open": "1,7958",
    "highest": "1,7975",
    "lower": "1,7855",
    "difference": "-0,18%"
  },
  {
    "date": "18.09.2012",
    "now": "1,7973",
    "open": "1,7979",
    "highest": "1,8070",
    "lower": "1,7895",
    "difference": "-0,03%"
  },
  {
    "date": "17.09.2012",
    "now": "1,7979",
    "open": "1,7981",
    "highest": "1,8020",
    "lower": "1,7920",
    "difference": "0,07%"
  },
  {
    "date": "14.09.2012",
    "now": "1,7967",
    "open": "1,8015",
    "highest": "1,8032",
    "lower": "1,7885",
    "difference": "-0,20%"
  },
  {
    "date": "13.09.2012",
    "now": "1,8003",
    "open": "1,8067",
    "highest": "1,8145",
    "lower": "1,7971",
    "difference": "-0,40%"
  },
  {
    "date": "12.09.2012",
    "now": "1,8075",
    "open": "1,8050",
    "highest": "1,8102",
    "lower": "1,7950",
    "difference": "0,17%"
  },
  {
    "date": "11.09.2012",
    "now": "1,8045",
    "open": "1,8015",
    "highest": "1,8064",
    "lower": "1,7967",
    "difference": "0,09%"
  },
  {
    "date": "10.09.2012",
    "now": "1,8029",
    "open": "1,8000",
    "highest": "1,8064",
    "lower": "1,7960",
    "difference": "0,34%"
  },
  {
    "date": "07.09.2012",
    "now": "1,7968",
    "open": "1,8093",
    "highest": "1,8124",
    "lower": "1,7950",
    "difference": "-0,69%"
  },
  {
    "date": "06.09.2012",
    "now": "1,8093",
    "open": "1,8191",
    "highest": "1,8230",
    "lower": "1,8077",
    "difference": "-0,54%"
  },
  {
    "date": "05.09.2012",
    "now": "1,8191",
    "open": "1,8215",
    "highest": "1,8300",
    "lower": "1,8160",
    "difference": "-0,13%"
  },
  {
    "date": "04.09.2012",
    "now": "1,8215",
    "open": "1,8185",
    "highest": "1,8231",
    "lower": "1,8130",
    "difference": "0,16%"
  },
  {
    "date": "03.09.2012",
    "now": "1,8185",
    "open": "1,8171",
    "highest": "1,8237",
    "lower": "1,8140",
    "difference": "-0,01%"
  },
  {
    "date": "31.08.2012",
    "now": "1,8186",
    "open": "1,8276",
    "highest": "1,8298",
    "lower": "1,8110",
    "difference": "-0,44%"
  },
  {
    "date": "30.08.2012",
    "now": "1,8267",
    "open": "1,8215",
    "highest": "1,8315",
    "lower": "1,8187",
    "difference": "0,27%"
  },
  {
    "date": "29.08.2012",
    "now": "1,8218",
    "open": "1,8095",
    "highest": "1,8227",
    "lower": "1,8026",
    "difference": "0,60%"
  },
  {
    "date": "28.08.2012",
    "now": "1,8110",
    "open": "1,8001",
    "highest": "1,8129",
    "lower": "1,7960",
    "difference": "0,61%"
  },
  {
    "date": "27.08.2012",
    "now": "1,8001",
    "open": "1,8022",
    "highest": "1,8050",
    "lower": "1,7960",
    "difference": "0,09%"
  },
  {
    "date": "24.08.2012",
    "now": "1,7985",
    "open": "1,7947",
    "highest": "1,8040",
    "lower": "1,7920",
    "difference": "0,28%"
  },
  {
    "date": "23.08.2012",
    "now": "1,7935",
    "open": "1,7940",
    "highest": "1,8000",
    "lower": "1,7890",
    "difference": "-0,08%"
  },
  {
    "date": "22.08.2012",
    "now": "1,7950",
    "open": "1,7953",
    "highest": "1,8020",
    "lower": "1,7910",
    "difference": "0,03%"
  },
  {
    "date": "21.08.2012",
    "now": "1,7945",
    "open": "1,8029",
    "highest": "1,8049",
    "lower": "1,7908",
    "difference": "-0,48%"
  },
  {
    "date": "20.08.2012",
    "now": "1,8032",
    "open": "1,7997",
    "highest": "1,8040",
    "lower": "1,7968",
    "difference": "0,14%"
  },
  {
    "date": "17.08.2012",
    "now": "1,8006",
    "open": "1,7939",
    "highest": "1,8070",
    "lower": "1,7910",
    "difference": "0,37%"
  },
  {
    "date": "16.08.2012",
    "now": "1,7939",
    "open": "1,7981",
    "highest": "1,8035",
    "lower": "1,7900",
    "difference": "-0,23%"
  },
  {
    "date": "15.08.2012",
    "now": "1,7981",
    "open": "1,8056",
    "highest": "1,8090",
    "lower": "1,7920",
    "difference": "-0,32%"
  },
  {
    "date": "14.08.2012",
    "now": "1,8039",
    "open": "1,7952",
    "highest": "1,8058",
    "lower": "1,7860",
    "difference": "0,48%"
  },
  {
    "date": "13.08.2012",
    "now": "1,7952",
    "open": "1,7840",
    "highest": "1,7986",
    "lower": "1,7810",
    "difference": "0,74%"
  },
  {
    "date": "10.08.2012",
    "now": "1,7820",
    "open": "1,7812",
    "highest": "1,7928",
    "lower": "1,7785",
    "difference": "-0,04%"
  },
  {
    "date": "09.08.2012",
    "now": "1,7827",
    "open": "1,7828",
    "highest": "1,7910",
    "lower": "1,7770",
    "difference": "0,11%"
  },
  {
    "date": "08.08.2012",
    "now": "1,7808",
    "open": "1,7863",
    "highest": "1,7941",
    "lower": "1,7770",
    "difference": "-0,31%"
  },
  {
    "date": "07.08.2012",
    "now": "1,7863",
    "open": "1,7772",
    "highest": "1,7890",
    "lower": "1,7725",
    "difference": "0,51%"
  },
  {
    "date": "06.08.2012",
    "now": "1,7772",
    "open": "1,7800",
    "highest": "1,7870",
    "lower": "1,7710",
    "difference": "-0,12%"
  },
  {
    "date": "03.08.2012",
    "now": "1,7793",
    "open": "1,8014",
    "highest": "1,8036",
    "lower": "1,7740",
    "difference": "-1,23%"
  },
  {
    "date": "02.08.2012",
    "now": "1,8014",
    "open": "1,8080",
    "highest": "1,8103",
    "lower": "1,7880",
    "difference": "-0,39%"
  },
  {
    "date": "01.08.2012",
    "now": "1,8085",
    "open": "1,7949",
    "highest": "1,8096",
    "lower": "1,7869",
    "difference": "0,75%"
  },
  {
    "date": "31.07.2012",
    "now": "1,7951",
    "open": "1,8009",
    "highest": "1,8042",
    "lower": "1,7860",
    "difference": "-0,32%"
  },
  {
    "date": "30.07.2012",
    "now": "1,8009",
    "open": "1,8099",
    "highest": "1,8170",
    "lower": "1,7980",
    "difference": "-0,61%"
  },
  {
    "date": "27.07.2012",
    "now": "1,8120",
    "open": "1,8118",
    "highest": "1,8264",
    "lower": "1,8054",
    "difference": "-0,02%"
  },
  {
    "date": "26.07.2012",
    "now": "1,8124",
    "open": "1,8215",
    "highest": "1,8330",
    "lower": "1,8105",
    "difference": "-0,50%"
  },
  {
    "date": "25.07.2012",
    "now": "1,8215",
    "open": "1,8280",
    "highest": "1,8321",
    "lower": "1,8180",
    "difference": "-0,36%"
  },
  {
    "date": "24.07.2012",
    "now": "1,8280",
    "open": "1,8195",
    "highest": "1,8340",
    "lower": "1,8160",
    "difference": "0,47%"
  },
  {
    "date": "23.07.2012",
    "now": "1,8195",
    "open": "1,8049",
    "highest": "1,8264",
    "lower": "1,8049",
    "difference": "0,62%"
  },
  {
    "date": "20.07.2012",
    "now": "1,8083",
    "open": "1,8021",
    "highest": "1,8140",
    "lower": "1,7960",
    "difference": "0,33%"
  },
  {
    "date": "19.07.2012",
    "now": "1,8023",
    "open": "1,7998",
    "highest": "1,8085",
    "lower": "1,7945",
    "difference": "0,03%"
  },
  {
    "date": "18.07.2012",
    "now": "1,8017",
    "open": "1,8039",
    "highest": "1,8125",
    "lower": "1,7995",
    "difference": "-0,20%"
  },
  {
    "date": "17.07.2012",
    "now": "1,8054",
    "open": "1,8078",
    "highest": "1,8149",
    "lower": "1,8029",
    "difference": "-0,21%"
  },
  {
    "date": "16.07.2012",
    "now": "1,8092",
    "open": "1,8102",
    "highest": "1,8169",
    "lower": "1,8069",
    "difference": "-0,12%"
  },
  {
    "date": "13.07.2012",
    "now": "1,8114",
    "open": "1,8199",
    "highest": "1,8240",
    "lower": "1,8096",
    "difference": "-0,47%"
  },
  {
    "date": "12.07.2012",
    "now": "1,8199",
    "open": "1,8097",
    "highest": "1,8261",
    "lower": "1,8063",
    "difference": "0,56%"
  },
  {
    "date": "11.07.2012",
    "now": "1,8097",
    "open": "1,8175",
    "highest": "1,8196",
    "lower": "1,8030",
    "difference": "-0,43%"
  },
  {
    "date": "10.07.2012",
    "now": "1,8175",
    "open": "1,8216",
    "highest": "1,8285",
    "lower": "1,8115",
    "difference": "-0,23%"
  },
  {
    "date": "09.07.2012",
    "now": "1,8216",
    "open": "1,8212",
    "highest": "1,8310",
    "lower": "1,8120",
    "difference": "0,14%"
  },
  {
    "date": "06.07.2012",
    "now": "1,8190",
    "open": "1,8093",
    "highest": "1,8288",
    "lower": "1,8070",
    "difference": "0,55%"
  },
  {
    "date": "05.07.2012",
    "now": "1,8091",
    "open": "1,8051",
    "highest": "1,8139",
    "lower": "1,7999",
    "difference": "0,17%"
  },
  {
    "date": "04.07.2012",
    "now": "1,8060",
    "open": "1,7967",
    "highest": "1,8110",
    "lower": "1,7920",
    "difference": "0,52%"
  },
  {
    "date": "03.07.2012",
    "now": "1,7967",
    "open": "1,8071",
    "highest": "1,8083",
    "lower": "1,7930",
    "difference": "-0,51%"
  },
  {
    "date": "02.07.2012",
    "now": "1,8059",
    "open": "1,8053",
    "highest": "1,8137",
    "lower": "1,7977",
    "difference": "-0,21%"
  },
  {
    "date": "29.06.2012",
    "now": "1,8097",
    "open": "1,8278",
    "highest": "1,8293",
    "lower": "1,8021",
    "difference": "-0,98%"
  },
  {
    "date": "28.06.2012",
    "now": "1,8277",
    "open": "1,8140",
    "highest": "1,8370",
    "lower": "1,8060",
    "difference": "0,76%"
  },
  {
    "date": "27.06.2012",
    "now": "1,8139",
    "open": "1,8073",
    "highest": "1,8164",
    "lower": "1,8028",
    "difference": "0,34%"
  },
  {
    "date": "26.06.2012",
    "now": "1,8078",
    "open": "1,8222",
    "highest": "1,8246",
    "lower": "1,8078",
    "difference": "-0,80%"
  },
  {
    "date": "25.06.2012",
    "now": "1,8223",
    "open": "1,8156",
    "highest": "1,8270",
    "lower": "1,8130",
    "difference": "0,40%"
  },
  {
    "date": "22.06.2012",
    "now": "1,8150",
    "open": "1,8075",
    "highest": "1,8220",
    "lower": "1,8000",
    "difference": "0,42%"
  },
  {
    "date": "21.06.2012",
    "now": "1,8074",
    "open": "1,7937",
    "highest": "1,8074",
    "lower": "1,7865",
    "difference": "0,78%"
  },
  {
    "date": "20.06.2012",
    "now": "1,7935",
    "open": "1,8000",
    "highest": "1,8009",
    "lower": "1,7835",
    "difference": "-0,36%"
  },
  {
    "date": "19.06.2012",
    "now": "1,7999",
    "open": "1,8117",
    "highest": "1,8150",
    "lower": "1,7985",
    "difference": "-0,65%"
  },
  {
    "date": "18.06.2012",
    "now": "1,8117",
    "open": "1,8056",
    "highest": "1,8200",
    "lower": "1,7970",
    "difference": "0,01%"
  },
  {
    "date": "15.06.2012",
    "now": "1,8115",
    "open": "1,8167",
    "highest": "1,8210",
    "lower": "1,8100",
    "difference": "-0,19%"
  },
  {
    "date": "14.06.2012",
    "now": "1,8149",
    "open": "1,8170",
    "highest": "1,8275",
    "lower": "1,8125",
    "difference": "-0,20%"
  },
  {
    "date": "13.06.2012",
    "now": "1,8185",
    "open": "1,8250",
    "highest": "1,8310",
    "lower": "1,8151",
    "difference": "-0,25%"
  },
  {
    "date": "12.06.2012",
    "now": "1,8230",
    "open": "1,8304",
    "highest": "1,8370",
    "lower": "1,8210",
    "difference": "-0,34%"
  },
  {
    "date": "11.06.2012",
    "now": "1,8293",
    "open": "1,8112",
    "highest": "1,8327",
    "lower": "1,8070",
    "difference": "0,30%"
  },
  {
    "date": "08.06.2012",
    "now": "1,8238",
    "open": "1,8269",
    "highest": "1,8425",
    "lower": "1,8220",
    "difference": "-0,17%"
  },
  {
    "date": "07.06.2012",
    "now": "1,8269",
    "open": "1,8281",
    "highest": "1,8370",
    "lower": "1,8150",
    "difference": "-0,11%"
  },
  {
    "date": "06.06.2012",
    "now": "1,8290",
    "open": "1,8459",
    "highest": "1,8464",
    "lower": "1,8262",
    "difference": "-0,93%"
  },
  {
    "date": "05.06.2012",
    "now": "1,8461",
    "open": "1,8511",
    "highest": "1,8538",
    "lower": "1,8418",
    "difference": "-0,35%"
  },
  {
    "date": "04.06.2012",
    "now": "1,8526",
    "open": "1,8573",
    "highest": "1,8620",
    "lower": "1,8417",
    "difference": "-0,24%"
  },
  {
    "date": "01.06.2012",
    "now": "1,8570",
    "open": "1,8676",
    "highest": "1,8793",
    "lower": "1,8530",
    "difference": "-0,49%"
  },
  {
    "date": "31.05.2012",
    "now": "1,8661",
    "open": "1,8565",
    "highest": "1,8720",
    "lower": "1,8430",
    "difference": "0,51%"
  },
  {
    "date": "30.05.2012",
    "now": "1,8566",
    "open": "1,8326",
    "highest": "1,8585",
    "lower": "1,8290",
    "difference": "1,34%"
  },
  {
    "date": "29.05.2012",
    "now": "1,8321",
    "open": "1,8377",
    "highest": "1,8410",
    "lower": "1,8255",
    "difference": "-0,27%"
  },
  {
    "date": "28.05.2012",
    "now": "1,8370",
    "open": "1,8458",
    "highest": "1,8478",
    "lower": "1,8269",
    "difference": "-0,64%"
  },
  {
    "date": "25.05.2012",
    "now": "1,8489",
    "open": "1,8468",
    "highest": "1,8527",
    "lower": "1,8340",
    "difference": "0,00%"
  },
  {
    "date": "24.05.2012",
    "now": "1,8489",
    "open": "1,8512",
    "highest": "1,8590",
    "lower": "1,8370",
    "difference": "-0,11%"
  },
  {
    "date": "23.05.2012",
    "now": "1,8510",
    "open": "1,8344",
    "highest": "1,8600",
    "lower": "1,8344",
    "difference": "0,90%"
  },
  {
    "date": "22.05.2012",
    "now": "1,8344",
    "open": "1,8246",
    "highest": "1,8361",
    "lower": "1,8190",
    "difference": "0,58%"
  },
  {
    "date": "21.05.2012",
    "now": "1,8238",
    "open": "1,8368",
    "highest": "1,8381",
    "lower": "1,8210",
    "difference": "-0,70%"
  },
  {
    "date": "18.05.2012",
    "now": "1,8366",
    "open": "1,8313",
    "highest": "1,8431",
    "lower": "1,8250",
    "difference": "0,29%"
  },
  {
    "date": "17.05.2012",
    "now": "1,8313",
    "open": "1,8263",
    "highest": "1,8330",
    "lower": "1,8120",
    "difference": "0,27%"
  },
  {
    "date": "16.05.2012",
    "now": "1,8263",
    "open": "1,8273",
    "highest": "1,8345",
    "lower": "1,8160",
    "difference": "0,10%"
  },
  {
    "date": "15.05.2012",
    "now": "1,8245",
    "open": "1,8112",
    "highest": "1,8274",
    "lower": "1,7980",
    "difference": "0,77%"
  },
  {
    "date": "14.05.2012",
    "now": "1,8105",
    "open": "1,7863",
    "highest": "1,8138",
    "lower": "1,7837",
    "difference": "1,43%"
  },
  {
    "date": "11.05.2012",
    "now": "1,7850",
    "open": "1,7866",
    "highest": "1,7964",
    "lower": "1,7805",
    "difference": "-0,03%"
  },
  {
    "date": "10.05.2012",
    "now": "1,7856",
    "open": "1,7935",
    "highest": "1,7953",
    "lower": "1,7791",
    "difference": "-0,49%"
  },
  {
    "date": "09.05.2012",
    "now": "1,7944",
    "open": "1,7774",
    "highest": "1,8012",
    "lower": "1,7760",
    "difference": "0,96%"
  },
  {
    "date": "08.05.2012",
    "now": "1,7774",
    "open": "1,7610",
    "highest": "1,7844",
    "lower": "1,7580",
    "difference": "0,93%"
  },
  {
    "date": "07.05.2012",
    "now": "1,7610",
    "open": "1,7665",
    "highest": "1,7725",
    "lower": "1,7585",
    "difference": "0,14%"
  },
  {
    "date": "04.05.2012",
    "now": "1,7585",
    "open": "1,7628",
    "highest": "1,7649",
    "lower": "1,7520",
    "difference": "-0,24%"
  },
  {
    "date": "03.05.2012",
    "now": "1,7628",
    "open": "1,7606",
    "highest": "1,7651",
    "lower": "1,7510",
    "difference": "0,15%"
  },
  {
    "date": "02.05.2012",
    "now": "1,7601",
    "open": "1,7546",
    "highest": "1,7670",
    "lower": "1,7529",
    "difference": "0,29%"
  },
  {
    "date": "01.05.2012",
    "now": "1,7550",
    "open": "1,7570",
    "highest": "1,7641",
    "lower": "1,7528",
    "difference": "-0,09%"
  },
  {
    "date": "30.04.2012",
    "now": "1,7565",
    "open": "1,7607",
    "highest": "1,7651",
    "lower": "1,7501",
    "difference": "-0,24%"
  },
  {
    "date": "27.04.2012",
    "now": "1,7608",
    "open": "1,7667",
    "highest": "1,7720",
    "lower": "1,7560",
    "difference": "-0,18%"
  },
  {
    "date": "26.04.2012",
    "now": "1,7640",
    "open": "1,7698",
    "highest": "1,7727",
    "lower": "1,7590",
    "difference": "-0,33%"
  },
  {
    "date": "25.04.2012",
    "now": "1,7698",
    "open": "1,7811",
    "highest": "1,7838",
    "lower": "1,7680",
    "difference": "-0,63%"
  },
  {
    "date": "24.04.2012",
    "now": "1,7811",
    "open": "1,7962",
    "highest": "1,7971",
    "lower": "1,7780",
    "difference": "-0,80%"
  },
  {
    "date": "23.04.2012",
    "now": "1,7955",
    "open": "1,7916",
    "highest": "1,7988",
    "lower": "1,7911",
    "difference": "0,19%"
  },
  {
    "date": "20.04.2012",
    "now": "1,7921",
    "open": "1,7917",
    "highest": "1,7954",
    "lower": "1,7860",
    "difference": "-0,03%"
  },
  {
    "date": "19.04.2012",
    "now": "1,7926",
    "open": "1,7870",
    "highest": "1,7952",
    "lower": "1,7833",
    "difference": "0,27%"
  },
  {
    "date": "18.04.2012",
    "now": "1,7877",
    "open": "1,7890",
    "highest": "1,8010",
    "lower": "1,7850",
    "difference": "-0,07%"
  },
  {
    "date": "17.04.2012",
    "now": "1,7890",
    "open": "1,7963",
    "highest": "1,8007",
    "lower": "1,7850",
    "difference": "-0,41%"
  },
  {
    "date": "16.04.2012",
    "now": "1,7963",
    "open": "1,7980",
    "highest": "1,8070",
    "lower": "1,7930",
    "difference": "-0,01%"
  },
  {
    "date": "13.04.2012",
    "now": "1,7965",
    "open": "1,7945",
    "highest": "1,8001",
    "lower": "1,7855",
    "difference": "0,11%"
  },
  {
    "date": "12.04.2012",
    "now": "1,7945",
    "open": "1,8083",
    "highest": "1,8098",
    "lower": "1,7930",
    "difference": "-0,76%"
  },
  {
    "date": "11.04.2012",
    "now": "1,8083",
    "open": "1,8145",
    "highest": "1,8175",
    "lower": "1,7990",
    "difference": "-0,31%"
  },
  {
    "date": "10.04.2012",
    "now": "1,8140",
    "open": "1,7982",
    "highest": "1,8184",
    "lower": "1,7902",
    "difference": "0,87%"
  },
  {
    "date": "09.04.2012",
    "now": "1,7983",
    "open": "1,7930",
    "highest": "1,8052",
    "lower": "1,7902",
    "difference": "0,28%"
  },
  {
    "date": "06.04.2012",
    "now": "1,7932",
    "open": "1,7926",
    "highest": "1,7966",
    "lower": "1,7867",
    "difference": "0,03%"
  },
  {
    "date": "05.04.2012",
    "now": "1,7927",
    "open": "1,7927",
    "highest": "1,8005",
    "lower": "1,7835",
    "difference": "-0,08%"
  },
  {
    "date": "04.04.2012",
    "now": "1,7942",
    "open": "1,7821",
    "highest": "1,7986",
    "lower": "1,7820",
    "difference": "0,68%"
  },
  {
    "date": "03.04.2012",
    "now": "1,7821",
    "open": "1,7770",
    "highest": "1,7860",
    "lower": "1,7720",
    "difference": "0,29%"
  },
  {
    "date": "02.04.2012",
    "now": "1,7770",
    "open": "1,7809",
    "highest": "1,7872",
    "lower": "1,7740",
    "difference": "-0,31%"
  },
  {
    "date": "30.03.2012",
    "now": "1,7825",
    "open": "1,7869",
    "highest": "1,7883",
    "lower": "1,7740",
    "difference": "-0,17%"
  },
  {
    "date": "29.03.2012",
    "now": "1,7855",
    "open": "1,7809",
    "highest": "1,7893",
    "lower": "1,7650",
    "difference": "0,20%"
  },
  {
    "date": "28.03.2012",
    "now": "1,7819",
    "open": "1,7885",
    "highest": "1,7920",
    "lower": "1,7760",
    "difference": "-0,33%"
  },
  {
    "date": "27.03.2012",
    "now": "1,7878",
    "open": "1,7854",
    "highest": "1,7902",
    "lower": "1,7762",
    "difference": "0,09%"
  },
  {
    "date": "26.03.2012",
    "now": "1,7862",
    "open": "1,8016",
    "highest": "1,8030",
    "lower": "1,7830",
    "difference": "-0,77%"
  },
  {
    "date": "23.03.2012",
    "now": "1,8000",
    "open": "1,8090",
    "highest": "1,8111",
    "lower": "1,7940",
    "difference": "-0,50%"
  },
  {
    "date": "22.03.2012",
    "now": "1,8090",
    "open": "1,8140",
    "highest": "1,8195",
    "lower": "1,8020",
    "difference": "-0,22%"
  },
  {
    "date": "21.03.2012",
    "now": "1,8130",
    "open": "1,8240",
    "highest": "1,8242",
    "lower": "1,8050",
    "difference": "-0,60%"
  },
  {
    "date": "20.03.2012",
    "now": "1,8239",
    "open": "1,8048",
    "highest": "1,8270",
    "lower": "1,8048",
    "difference": "1,06%"
  },
  {
    "date": "19.03.2012",
    "now": "1,8048",
    "open": "1,7963",
    "highest": "1,8130",
    "lower": "1,7905",
    "difference": "0,55%"
  },
  {
    "date": "16.03.2012",
    "now": "1,7949",
    "open": "1,7970",
    "highest": "1,8061",
    "lower": "1,7900",
    "difference": "-0,12%"
  },
  {
    "date": "15.03.2012",
    "now": "1,7970",
    "open": "1,8078",
    "highest": "1,8114",
    "lower": "1,7930",
    "difference": "-0,60%"
  },
  {
    "date": "14.03.2012",
    "now": "1,8078",
    "open": "1,7916",
    "highest": "1,8155",
    "lower": "1,7850",
    "difference": "0,96%"
  },
  {
    "date": "13.03.2012",
    "now": "1,7906",
    "open": "1,7957",
    "highest": "1,8059",
    "lower": "1,7830",
    "difference": "-0,22%"
  },
  {
    "date": "12.03.2012",
    "now": "1,7945",
    "open": "1,7872",
    "highest": "1,8020",
    "lower": "1,7850",
    "difference": "0,42%"
  },
  {
    "date": "09.03.2012",
    "now": "1,7870",
    "open": "1,7758",
    "highest": "1,7890",
    "lower": "1,7740",
    "difference": "0,63%"
  },
  {
    "date": "08.03.2012",
    "now": "1,7758",
    "open": "1,7803",
    "highest": "1,7839",
    "lower": "1,7690",
    "difference": "-0,35%"
  },
  {
    "date": "07.03.2012",
    "now": "1,7820",
    "open": "1,7913",
    "highest": "1,7960",
    "lower": "1,7810",
    "difference": "-0,67%"
  },
  {
    "date": "06.03.2012",
    "now": "1,7940",
    "open": "1,7718",
    "highest": "1,7970",
    "lower": "1,7699",
    "difference": "1,36%"
  },
  {
    "date": "05.03.2012",
    "now": "1,7699",
    "open": "1,7681",
    "highest": "1,7790",
    "lower": "1,7620",
    "difference": "0,12%"
  },
  {
    "date": "02.03.2012",
    "now": "1,7677",
    "open": "1,7525",
    "highest": "1,7702",
    "lower": "1,7517",
    "difference": "0,81%"
  },
  {
    "date": "01.03.2012",
    "now": "1,7535",
    "open": "1,7509",
    "highest": "1,7610",
    "lower": "1,7470",
    "difference": "0,25%"
  },
  {
    "date": "29.02.2012",
    "now": "1,7491",
    "open": "1,7554",
    "highest": "1,7554",
    "lower": "1,7370",
    "difference": "-0,34%"
  },
  {
    "date": "28.02.2012",
    "now": "1,7550",
    "open": "1,7664",
    "highest": "1,7671",
    "lower": "1,7501",
    "difference": "-0,53%"
  },
  {
    "date": "27.02.2012",
    "now": "1,7643",
    "open": "1,7652",
    "highest": "1,7770",
    "lower": "1,7624",
    "difference": "-0,11%"
  },
  {
    "date": "24.02.2012",
    "now": "1,7662",
    "open": "1,7607",
    "highest": "1,7721",
    "lower": "1,7519",
    "difference": "0,29%"
  },
  {
    "date": "23.02.2012",
    "now": "1,7611",
    "open": "1,7609",
    "highest": "1,7690",
    "lower": "1,7490",
    "difference": "0,01%"
  },
  {
    "date": "22.02.2012",
    "now": "1,7609",
    "open": "1,7512",
    "highest": "1,7635",
    "lower": "1,7455",
    "difference": "0,55%"
  },
  {
    "date": "21.02.2012",
    "now": "1,7512",
    "open": "1,7429",
    "highest": "1,7580",
    "lower": "1,7340",
    "difference": "0,48%"
  },
  {
    "date": "20.02.2012",
    "now": "1,7429",
    "open": "1,7484",
    "highest": "1,7550",
    "lower": "1,7330",
    "difference": "-0,54%"
  },
  {
    "date": "17.02.2012",
    "now": "1,7523",
    "open": "1,7612",
    "highest": "1,7710",
    "lower": "1,7500",
    "difference": "-0,54%"
  },
  {
    "date": "16.02.2012",
    "now": "1,7619",
    "open": "1,7690",
    "highest": "1,7832",
    "lower": "1,7604",
    "difference": "-0,39%"
  },
  {
    "date": "15.02.2012",
    "now": "1,7688",
    "open": "1,7709",
    "highest": "1,7709",
    "lower": "1,7532",
    "difference": "-0,07%"
  },
  {
    "date": "14.02.2012",
    "now": "1,7701",
    "open": "1,7657",
    "highest": "1,7782",
    "lower": "1,7610",
    "difference": "0,25%"
  },
  {
    "date": "13.02.2012",
    "now": "1,7657",
    "open": "1,7625",
    "highest": "1,7682",
    "lower": "1,7495",
    "difference": "0,15%"
  },
  {
    "date": "10.02.2012",
    "now": "1,7630",
    "open": "1,7526",
    "highest": "1,7737",
    "lower": "1,7510",
    "difference": "0,56%"
  },
  {
    "date": "09.02.2012",
    "now": "1,7531",
    "open": "1,7504",
    "highest": "1,7660",
    "lower": "1,7400",
    "difference": "0,12%"
  },
  {
    "date": "08.02.2012",
    "now": "1,7510",
    "open": "1,7497",
    "highest": "1,7555",
    "lower": "1,7370",
    "difference": "0,17%"
  },
  {
    "date": "07.02.2012",
    "now": "1,7481",
    "open": "1,7587",
    "highest": "1,7650",
    "lower": "1,7480",
    "difference": "-0,60%"
  },
  {
    "date": "06.02.2012",
    "now": "1,7587",
    "open": "1,7576",
    "highest": "1,7700",
    "lower": "1,7548",
    "difference": "0,33%"
  },
  {
    "date": "03.02.2012",
    "now": "1,7530",
    "open": "1,7577",
    "highest": "1,7637",
    "lower": "1,7412",
    "difference": "-0,30%"
  },
  {
    "date": "02.02.2012",
    "now": "1,7582",
    "open": "1,7547",
    "highest": "1,7674",
    "lower": "1,7487",
    "difference": "0,06%"
  },
  {
    "date": "01.02.2012",
    "now": "1,7571",
    "open": "1,7758",
    "highest": "1,7848",
    "lower": "1,7503",
    "difference": "-1,14%"
  },
  {
    "date": "31.01.2012",
    "now": "1,7773",
    "open": "1,7859",
    "highest": "1,7896",
    "lower": "1,7632",
    "difference": "-0,59%"
  },
  {
    "date": "30.01.2012",
    "now": "1,7878",
    "open": "1,7782",
    "highest": "1,7952",
    "lower": "1,7767",
    "difference": "0,62%"
  },
  {
    "date": "27.01.2012",
    "now": "1,7768",
    "open": "1,7936",
    "highest": "1,7983",
    "lower": "1,7733",
    "difference": "-0,94%"
  },
  {
    "date": "26.01.2012",
    "now": "1,7936",
    "open": "1,8064",
    "highest": "1,8106",
    "lower": "1,7832",
    "difference": "-0,72%"
  },
  {
    "date": "25.01.2012",
    "now": "1,8066",
    "open": "1,8195",
    "highest": "1,8325",
    "lower": "1,8054",
    "difference": "-0,85%"
  },
  {
    "date": "24.01.2012",
    "now": "1,8220",
    "open": "1,8173",
    "highest": "1,8325",
    "lower": "1,8140",
    "difference": "0,22%"
  },
  {
    "date": "23.01.2012",
    "now": "1,8180",
    "open": "1,8320",
    "highest": "1,8410",
    "lower": "1,8150",
    "difference": "-0,66%"
  },
  {
    "date": "20.01.2012",
    "now": "1,8300",
    "open": "1,8250",
    "highest": "1,8350",
    "lower": "1,8225",
    "difference": "0,21%"
  },
  {
    "date": "19.01.2012",
    "now": "1,8261",
    "open": "1,8306",
    "highest": "1,8392",
    "lower": "1,8202",
    "difference": "-0,26%"
  },
  {
    "date": "18.01.2012",
    "now": "1,8308",
    "open": "1,8426",
    "highest": "1,8446",
    "lower": "1,8303",
    "difference": "-0,76%"
  },
  {
    "date": "17.01.2012",
    "now": "1,8449",
    "open": "1,8534",
    "highest": "1,8538",
    "lower": "1,8332",
    "difference": "-0,45%"
  },
  {
    "date": "16.01.2012",
    "now": "1,8533",
    "open": "1,8638",
    "highest": "1,8677",
    "lower": "1,8479",
    "difference": "-0,41%"
  },
  {
    "date": "13.01.2012",
    "now": "1,8609",
    "open": "1,8510",
    "highest": "1,8692",
    "lower": "1,8422",
    "difference": "0,53%"
  },
  {
    "date": "12.01.2012",
    "now": "1,8510",
    "open": "1,8542",
    "highest": "1,8602",
    "lower": "1,8352",
    "difference": "-0,22%"
  },
  {
    "date": "11.01.2012",
    "now": "1,8550",
    "open": "1,8683",
    "highest": "1,8726",
    "lower": "1,8512",
    "difference": "-0,73%"
  },
  {
    "date": "10.01.2012",
    "now": "1,8686",
    "open": "1,8700",
    "highest": "1,8782",
    "lower": "1,8587",
    "difference": "0,03%"
  },
  {
    "date": "09.01.2012",
    "now": "1,8680",
    "open": "1,8812",
    "highest": "1,8820",
    "lower": "1,8640",
    "difference": "-0,51%"
  },
  {
    "date": "06.01.2012",
    "now": "1,8776",
    "open": "1,8815",
    "highest": "1,8880",
    "lower": "1,8665",
    "difference": "-0,29%"
  },
  {
    "date": "05.01.2012",
    "now": "1,8830",
    "open": "1,8770",
    "highest": "1,8890",
    "lower": "1,8715",
    "difference": "0,24%"
  },
  {
    "date": "04.01.2012",
    "now": "1,8785",
    "open": "1,8761",
    "highest": "1,8925",
    "lower": "1,8600",
    "difference": "0,29%"
  },
  {
    "date": "03.01.2012",
    "now": "1,8730",
    "open": "1,8895",
    "highest": "1,8960",
    "lower": "1,8665",
    "difference": "-1,19%"
  },
  {
    "date": "02.01.2012",
    "now": "1,8955",
    "open": "1,8822",
    "highest": "1,9005",
    "lower": "1,8725",
    "difference": "0,56%"
  },
  {
    "date": "30.12.2011",
    "now": "1,8850",
    "open": "1,9175",
    "highest": "1,9220",
    "lower": "1,8510",
    "difference": "-1,69%"
  },
  {
    "date": "29.12.2011",
    "now": "1,9175",
    "open": "1,9225",
    "highest": "1,9245",
    "lower": "1,9075",
    "difference": "-0,16%"
  },
  {
    "date": "28.12.2011",
    "now": "1,9205",
    "open": "1,8988",
    "highest": "1,9221",
    "lower": "1,8925",
    "difference": "1,19%"
  },
  {
    "date": "27.12.2011",
    "now": "1,8980",
    "open": "1,8935",
    "highest": "1,9050",
    "lower": "1,8860",
    "difference": "0,34%"
  },
  {
    "date": "26.12.2011",
    "now": "1,8915",
    "open": "1,8975",
    "highest": "1,9045",
    "lower": "1,8875",
    "difference": "-0,42%"
  },
  {
    "date": "23.12.2011",
    "now": "1,8995",
    "open": "1,8932",
    "highest": "1,9045",
    "lower": "1,8795",
    "difference": "0,45%"
  },
  {
    "date": "22.12.2011",
    "now": "1,8910",
    "open": "1,8855",
    "highest": "1,8946",
    "lower": "1,8780",
    "difference": "0,11%"
  },
  {
    "date": "21.12.2011",
    "now": "1,8890",
    "open": "1,8820",
    "highest": "1,8920",
    "lower": "1,8715",
    "difference": "0,33%"
  },
  {
    "date": "20.12.2011",
    "now": "1,8828",
    "open": "1,9043",
    "highest": "1,9047",
    "lower": "1,8758",
    "difference": "-1,06%"
  },
  {
    "date": "19.12.2011",
    "now": "1,9030",
    "open": "1,8871",
    "highest": "1,9053",
    "lower": "1,8780",
    "difference": "0,89%"
  },
  {
    "date": "16.12.2011",
    "now": "1,8863",
    "open": "1,8747",
    "highest": "1,8894",
    "lower": "1,8697",
    "difference": "0,46%"
  },
  {
    "date": "15.12.2011",
    "now": "1,8777",
    "open": "1,8882",
    "highest": "1,8886",
    "lower": "1,8679",
    "difference": "-0,54%"
  },
  {
    "date": "14.12.2011",
    "now": "1,8879",
    "open": "1,8810",
    "highest": "1,8886",
    "lower": "1,8730",
    "difference": "0,31%"
  },
  {
    "date": "13.12.2011",
    "now": "1,8820",
    "open": "1,8706",
    "highest": "1,8848",
    "lower": "1,8581",
    "difference": "0,49%"
  },
  {
    "date": "12.12.2011",
    "now": "1,8728",
    "open": "1,8440",
    "highest": "1,8744",
    "lower": "1,8345",
    "difference": "1,62%"
  },
  {
    "date": "09.12.2011",
    "now": "1,8430",
    "open": "1,8481",
    "highest": "1,8598",
    "lower": "1,8382",
    "difference": "-0,26%"
  },
  {
    "date": "08.12.2011",
    "now": "1,8478",
    "open": "1,8313",
    "highest": "1,8552",
    "lower": "1,8258",
    "difference": "0,96%"
  },
  {
    "date": "07.12.2011",
    "now": "1,8302",
    "open": "1,8341",
    "highest": "1,8399",
    "lower": "1,8199",
    "difference": "-0,21%"
  },
  {
    "date": "06.12.2011",
    "now": "1,8340",
    "open": "1,8337",
    "highest": "1,8461",
    "lower": "1,8279",
    "difference": "0,12%"
  },
  {
    "date": "05.12.2011",
    "now": "1,8318",
    "open": "1,8291",
    "highest": "1,8347",
    "lower": "1,8197",
    "difference": "0,05%"
  },
  {
    "date": "02.12.2011",
    "now": "1,8308",
    "open": "1,8302",
    "highest": "1,8340",
    "lower": "1,8100",
    "difference": "0,18%"
  },
  {
    "date": "01.12.2011",
    "now": "1,8275",
    "open": "1,8290",
    "highest": "1,8406",
    "lower": "1,8245",
    "difference": "-0,10%"
  },
  {
    "date": "30.11.2011",
    "now": "1,8293",
    "open": "1,8516",
    "highest": "1,8630",
    "lower": "1,8190",
    "difference": "-1,16%"
  },
  {
    "date": "29.11.2011",
    "now": "1,8508",
    "open": "1,8595",
    "highest": "1,8628",
    "lower": "1,8405",
    "difference": "-0,52%"
  },
  {
    "date": "28.11.2011",
    "now": "1,8605",
    "open": "1,8795",
    "highest": "1,8826",
    "lower": "1,8510",
    "difference": "-1,34%"
  },
  {
    "date": "25.11.2011",
    "now": "1,8858",
    "open": "1,8699",
    "highest": "1,8916",
    "lower": "1,8681",
    "difference": "0,74%"
  },
  {
    "date": "24.11.2011",
    "now": "1,8719",
    "open": "1,8752",
    "highest": "1,8755",
    "lower": "1,8564",
    "difference": "-0,07%"
  },
  {
    "date": "23.11.2011",
    "now": "1,8733",
    "open": "1,8522",
    "highest": "1,8779",
    "lower": "1,8477",
    "difference": "1,15%"
  },
  {
    "date": "22.11.2011",
    "now": "1,8520",
    "open": "1,8564",
    "highest": "1,8604",
    "lower": "1,8322",
    "difference": "-0,40%"
  },
  {
    "date": "21.11.2011",
    "now": "1,8594",
    "open": "1,8336",
    "highest": "1,8624",
    "lower": "1,8209",
    "difference": "1,55%"
  },
  {
    "date": "18.11.2011",
    "now": "1,8311",
    "open": "1,8233",
    "highest": "1,8317",
    "lower": "1,8075",
    "difference": "0,70%"
  },
  {
    "date": "17.11.2011",
    "now": "1,8183",
    "open": "1,8076",
    "highest": "1,8183",
    "lower": "1,7962",
    "difference": "0,71%"
  },
  {
    "date": "16.11.2011",
    "now": "1,8055",
    "open": "1,7985",
    "highest": "1,8115",
    "lower": "1,7926",
    "difference": "0,33%"
  },
  {
    "date": "15.11.2011",
    "now": "1,7996",
    "open": "1,7842",
    "highest": "1,8056",
    "lower": "1,7805",
    "difference": "0,86%"
  },
  {
    "date": "14.11.2011",
    "now": "1,7843",
    "open": "1,7726",
    "highest": "1,7892",
    "lower": "1,7642",
    "difference": "0,52%"
  },
  {
    "date": "11.11.2011",
    "now": "1,7751",
    "open": "1,7863",
    "highest": "1,7937",
    "lower": "1,7682",
    "difference": "-0,63%"
  },
  {
    "date": "10.11.2011",
    "now": "1,7864",
    "open": "1,8003",
    "highest": "1,8071",
    "lower": "1,7737",
    "difference": "-0,78%"
  },
  {
    "date": "09.11.2011",
    "now": "1,8005",
    "open": "1,7708",
    "highest": "1,8010",
    "lower": "1,7662",
    "difference": "1,80%"
  },
  {
    "date": "08.11.2011",
    "now": "1,7687",
    "open": "1,7766",
    "highest": "1,7857",
    "lower": "1,7684",
    "difference": "-0,47%"
  },
  {
    "date": "07.11.2011",
    "now": "1,7771",
    "open": "1,7646",
    "highest": "1,7847",
    "lower": "1,7624",
    "difference": "0,50%"
  },
  {
    "date": "04.11.2011",
    "now": "1,7682",
    "open": "1,7541",
    "highest": "1,7702",
    "lower": "1,7392",
    "difference": "0,84%"
  },
  {
    "date": "03.11.2011",
    "now": "1,7535",
    "open": "1,7786",
    "highest": "1,7980",
    "lower": "1,7490",
    "difference": "-1,45%"
  },
  {
    "date": "02.11.2011",
    "now": "1,7793",
    "open": "1,7937",
    "highest": "1,7962",
    "lower": "1,7692",
    "difference": "-0,68%"
  },
  {
    "date": "01.11.2011",
    "now": "1,7915",
    "open": "1,7713",
    "highest": "1,8076",
    "lower": "1,7634",
    "difference": "1,16%"
  },
  {
    "date": "31.10.2011",
    "now": "1,7710",
    "open": "1,7443",
    "highest": "1,7722",
    "lower": "1,7415",
    "difference": "1,47%"
  },
  {
    "date": "28.10.2011",
    "now": "1,7453",
    "open": "1,7475",
    "highest": "1,7565",
    "lower": "1,7421",
    "difference": "-0,13%"
  },
  {
    "date": "27.10.2011",
    "now": "1,7475",
    "open": "1,7582",
    "highest": "1,7702",
    "lower": "1,7403",
    "difference": "-0,72%"
  },
  {
    "date": "26.10.2011",
    "now": "1,7601",
    "open": "1,7811",
    "highest": "1,7849",
    "lower": "1,7525",
    "difference": "-1,15%"
  },
  {
    "date": "25.10.2011",
    "now": "1,7806",
    "open": "1,7997",
    "highest": "1,8098",
    "lower": "1,7736",
    "difference": "-1,07%"
  },
  {
    "date": "24.10.2011",
    "now": "1,7998",
    "open": "1,8403",
    "highest": "1,8405",
    "lower": "1,7979",
    "difference": "-1,86%"
  },
  {
    "date": "21.10.2011",
    "now": "1,8339",
    "open": "1,8589",
    "highest": "1,8641",
    "lower": "1,8297",
    "difference": "-1,34%"
  },
  {
    "date": "20.10.2011",
    "now": "1,8588",
    "open": "1,8695",
    "highest": "1,8786",
    "lower": "1,8486",
    "difference": "-0,50%"
  },
  {
    "date": "19.10.2011",
    "now": "1,8681",
    "open": "1,8579",
    "highest": "1,8729",
    "lower": "1,8415",
    "difference": "0,46%"
  },
  {
    "date": "18.10.2011",
    "now": "1,8595",
    "open": "1,8665",
    "highest": "1,8769",
    "lower": "1,8449",
    "difference": "-0,38%"
  },
  {
    "date": "17.10.2011",
    "now": "1,8666",
    "open": "1,8300",
    "highest": "1,8704",
    "lower": "1,8277",
    "difference": "1,97%"
  },
  {
    "date": "14.10.2011",
    "now": "1,8306",
    "open": "1,8356",
    "highest": "1,8470",
    "lower": "1,8270",
    "difference": "-0,33%"
  },
  {
    "date": "13.10.2011",
    "now": "1,8366",
    "open": "1,8192",
    "highest": "1,8416",
    "lower": "1,8145",
    "difference": "0,85%"
  },
  {
    "date": "12.10.2011",
    "now": "1,8211",
    "open": "1,8399",
    "highest": "1,8440",
    "lower": "1,8161",
    "difference": "-1,04%"
  },
  {
    "date": "11.10.2011",
    "now": "1,8403",
    "open": "1,8301",
    "highest": "1,8505",
    "lower": "1,8245",
    "difference": "0,58%"
  },
  {
    "date": "10.10.2011",
    "now": "1,8296",
    "open": "1,8510",
    "highest": "1,8527",
    "lower": "1,8270",
    "difference": "-1,09%"
  },
  {
    "date": "07.10.2011",
    "now": "1,8497",
    "open": "1,8489",
    "highest": "1,8532",
    "lower": "1,8323",
    "difference": "0,11%"
  },
  {
    "date": "06.10.2011",
    "now": "1,8476",
    "open": "1,8669",
    "highest": "1,8733",
    "lower": "1,8313",
    "difference": "-1,20%"
  },
  {
    "date": "05.10.2011",
    "now": "1,8701",
    "open": "1,8917",
    "highest": "1,8987",
    "lower": "1,8587",
    "difference": "-1,55%"
  },
  {
    "date": "04.10.2011",
    "now": "1,8995",
    "open": "1,8886",
    "highest": "1,9108",
    "lower": "1,8790",
    "difference": "0,54%"
  },
  {
    "date": "03.10.2011",
    "now": "1,8893",
    "open": "1,8575",
    "highest": "1,8897",
    "lower": "1,8535",
    "difference": "1,58%"
  },
  {
    "date": "30.09.2011",
    "now": "1,8599",
    "open": "1,8529",
    "highest": "1,8658",
    "lower": "1,8478",
    "difference": "0,36%"
  },
  {
    "date": "29.09.2011",
    "now": "1,8533",
    "open": "1,8643",
    "highest": "1,8664",
    "lower": "1,8448",
    "difference": "-0,55%"
  },
  {
    "date": "28.09.2011",
    "now": "1,8636",
    "open": "1,8455",
    "highest": "1,8685",
    "lower": "1,8393",
    "difference": "1,01%"
  },
  {
    "date": "27.09.2011",
    "now": "1,8449",
    "open": "1,8529",
    "highest": "1,8615",
    "lower": "1,8365",
    "difference": "-0,48%"
  },
  {
    "date": "26.09.2011",
    "now": "1,8538",
    "open": "1,8359",
    "highest": "1,8720",
    "lower": "1,8359",
    "difference": "0,98%"
  },
  {
    "date": "23.09.2011",
    "now": "1,8358",
    "open": "1,8432",
    "highest": "1,8517",
    "lower": "1,8252",
    "difference": "-0,37%"
  },
  {
    "date": "22.09.2011",
    "now": "1,8426",
    "open": "1,8218",
    "highest": "1,8494",
    "lower": "1,8108",
    "difference": "1,00%"
  },
  {
    "date": "21.09.2011",
    "now": "1,8243",
    "open": "1,7866",
    "highest": "1,8287",
    "lower": "1,7839",
    "difference": "2,10%"
  },
  {
    "date": "20.09.2011",
    "now": "1,7868",
    "open": "1,8068",
    "highest": "1,8171",
    "lower": "1,7660",
    "difference": "-1,15%"
  },
  {
    "date": "19.09.2011",
    "now": "1,8076",
    "open": "1,7816",
    "highest": "1,8170",
    "lower": "1,7812",
    "difference": "1,71%"
  },
  {
    "date": "16.09.2011",
    "now": "1,7772",
    "open": "1,7820",
    "highest": "1,7892",
    "lower": "1,7751",
    "difference": "-0,25%"
  },
  {
    "date": "15.09.2011",
    "now": "1,7816",
    "open": "1,7758",
    "highest": "1,7925",
    "lower": "1,7695",
    "difference": "0,25%"
  },
  {
    "date": "14.09.2011",
    "now": "1,7772",
    "open": "1,7644",
    "highest": "1,7867",
    "lower": "1,7632",
    "difference": "0,62%"
  },
  {
    "date": "13.09.2011",
    "now": "1,7663",
    "open": "1,7868",
    "highest": "1,7904",
    "lower": "1,7608",
    "difference": "-1,19%"
  },
  {
    "date": "12.09.2011",
    "now": "1,7876",
    "open": "1,7914",
    "highest": "1,8058",
    "lower": "1,7858",
    "difference": "-0,21%"
  },
  {
    "date": "09.09.2011",
    "now": "1,7913",
    "open": "1,7690",
    "highest": "1,8022",
    "lower": "1,7636",
    "difference": "1,24%"
  },
  {
    "date": "08.09.2011",
    "now": "1,7693",
    "open": "1,7580",
    "highest": "1,7737",
    "lower": "1,7555",
    "difference": "0,63%"
  },
  {
    "date": "07.09.2011",
    "now": "1,7583",
    "open": "1,7603",
    "highest": "1,7654",
    "lower": "1,7463",
    "difference": "-0,14%"
  },
  {
    "date": "06.09.2011",
    "now": "1,7608",
    "open": "1,7710",
    "highest": "1,7832",
    "lower": "1,7582",
    "difference": "-0,56%"
  },
  {
    "date": "05.09.2011",
    "now": "1,7708",
    "open": "1,7516",
    "highest": "1,7737",
    "lower": "1,7512",
    "difference": "1,06%"
  },
  {
    "date": "02.09.2011",
    "now": "1,7522",
    "open": "1,7228",
    "highest": "1,7612",
    "lower": "1,7202",
    "difference": "1,70%"
  },
  {
    "date": "01.09.2011",
    "now": "1,7229",
    "open": "1,7158",
    "highest": "1,7323",
    "lower": "1,7104",
    "difference": "0,39%"
  },
  {
    "date": "31.08.2011",
    "now": "1,7162",
    "open": "1,7330",
    "highest": "1,7340",
    "lower": "1,7125",
    "difference": "-0,94%"
  },
  {
    "date": "30.08.2011",
    "now": "1,7325",
    "open": "1,7298",
    "highest": "1,7413",
    "lower": "1,7279",
    "difference": "0,01%"
  },
  {
    "date": "29.08.2011",
    "now": "1,7323",
    "open": "1,7496",
    "highest": "1,7570",
    "lower": "1,7289",
    "difference": "-1,05%"
  },
  {
    "date": "26.08.2011",
    "now": "1,7506",
    "open": "1,7550",
    "highest": "1,7607",
    "lower": "1,7439",
    "difference": "-0,35%"
  },
  {
    "date": "25.08.2011",
    "now": "1,7567",
    "open": "1,7799",
    "highest": "1,7850",
    "lower": "1,7475",
    "difference": "-1,56%"
  },
  {
    "date": "24.08.2011",
    "now": "1,7846",
    "open": "1,7725",
    "highest": "1,7887",
    "lower": "1,7698",
    "difference": "0,80%"
  },
  {
    "date": "23.08.2011",
    "now": "1,7704",
    "open": "1,7860",
    "highest": "1,7902",
    "lower": "1,7681",
    "difference": "-0,87%"
  },
  {
    "date": "22.08.2011",
    "now": "1,7860",
    "open": "1,7859",
    "highest": "1,7960",
    "lower": "1,7780",
    "difference": "-0,09%"
  },
  {
    "date": "19.08.2011",
    "now": "1,7876",
    "open": "1,7844",
    "highest": "1,7977",
    "lower": "1,7787",
    "difference": "0,16%"
  },
  {
    "date": "18.08.2011",
    "now": "1,7847",
    "open": "1,7704",
    "highest": "1,7965",
    "lower": "1,7685",
    "difference": "0,82%"
  },
  {
    "date": "17.08.2011",
    "now": "1,7702",
    "open": "1,7764",
    "highest": "1,7824",
    "lower": "1,7584",
    "difference": "-0,35%"
  },
  {
    "date": "16.08.2011",
    "now": "1,7764",
    "open": "1,7654",
    "highest": "1,7863",
    "lower": "1,7613",
    "difference": "0,64%"
  },
  {
    "date": "15.08.2011",
    "now": "1,7651",
    "open": "1,7785",
    "highest": "1,7825",
    "lower": "1,7605",
    "difference": "-0,74%"
  },
  {
    "date": "12.08.2011",
    "now": "1,7783",
    "open": "1,7810",
    "highest": "1,7967",
    "lower": "1,7721",
    "difference": "-0,21%"
  },
  {
    "date": "11.08.2011",
    "now": "1,7821",
    "open": "1,7774",
    "highest": "1,8022",
    "lower": "1,7542",
    "difference": "0,32%"
  },
  {
    "date": "10.08.2011",
    "now": "1,7765",
    "open": "1,7516",
    "highest": "1,7795",
    "lower": "1,7354",
    "difference": "1,39%"
  },
  {
    "date": "09.08.2011",
    "now": "1,7521",
    "open": "1,8115",
    "highest": "1,8115",
    "lower": "1,7520",
    "difference": "-0,88%"
  },
  {
    "date": "08.08.2011",
    "now": "1,7677",
    "open": "1,7458",
    "highest": "1,7685",
    "lower": "1,7326",
    "difference": "1,29%"
  },
  {
    "date": "05.08.2011",
    "now": "1,7452",
    "open": "1,7405",
    "highest": "1,7504",
    "lower": "1,7233",
    "difference": "0,26%"
  },
  {
    "date": "04.08.2011",
    "now": "1,7407",
    "open": "1,6972",
    "highest": "1,7414",
    "lower": "1,6856",
    "difference": "2,70%"
  },
  {
    "date": "03.08.2011",
    "now": "1,6949",
    "open": "1,7111",
    "highest": "1,7228",
    "lower": "1,6945",
    "difference": "-0,88%"
  },
  {
    "date": "02.08.2011",
    "now": "1,7100",
    "open": "1,6930",
    "highest": "1,7175",
    "lower": "1,6890",
    "difference": "0,88%"
  },
  {
    "date": "01.08.2011",
    "now": "1,6950",
    "open": "1,6918",
    "highest": "1,7005",
    "lower": "1,6670",
    "difference": "0,37%"
  },
  {
    "date": "29.07.2011",
    "now": "1,6887",
    "open": "1,6752",
    "highest": "1,6992",
    "lower": "1,6732",
    "difference": "0,69%"
  },
  {
    "date": "28.07.2011",
    "now": "1,6771",
    "open": "1,6896",
    "highest": "1,6989",
    "lower": "1,6672",
    "difference": "-0,84%"
  },
  {
    "date": "27.07.2011",
    "now": "1,6913",
    "open": "1,6982",
    "highest": "1,7097",
    "lower": "1,6817",
    "difference": "-0,42%"
  },
  {
    "date": "26.07.2011",
    "now": "1,6985",
    "open": "1,7163",
    "highest": "1,7281",
    "lower": "1,6954",
    "difference": "-1,03%"
  },
  {
    "date": "25.07.2011",
    "now": "1,7161",
    "open": "1,7008",
    "highest": "1,7347",
    "lower": "1,6987",
    "difference": "1,11%"
  },
  {
    "date": "22.07.2011",
    "now": "1,6972",
    "open": "1,6667",
    "highest": "1,7008",
    "lower": "1,6608",
    "difference": "1,90%"
  },
  {
    "date": "21.07.2011",
    "now": "1,6656",
    "open": "1,6612",
    "highest": "1,6785",
    "lower": "1,6565",
    "difference": "0,23%"
  },
  {
    "date": "20.07.2011",
    "now": "1,6617",
    "open": "1,6572",
    "highest": "1,6667",
    "lower": "1,6512",
    "difference": "0,21%"
  },
  {
    "date": "19.07.2011",
    "now": "1,6583",
    "open": "1,6592",
    "highest": "1,6629",
    "lower": "1,6509",
    "difference": "-0,07%"
  },
  {
    "date": "18.07.2011",
    "now": "1,6594",
    "open": "1,6520",
    "highest": "1,6718",
    "lower": "1,6509",
    "difference": "0,49%"
  },
  {
    "date": "15.07.2011",
    "now": "1,6513",
    "open": "1,6446",
    "highest": "1,6541",
    "lower": "1,6411",
    "difference": "0,29%"
  },
  {
    "date": "14.07.2011",
    "now": "1,6466",
    "open": "1,6436",
    "highest": "1,6487",
    "lower": "1,6357",
    "difference": "0,21%"
  },
  {
    "date": "13.07.2011",
    "now": "1,6431",
    "open": "1,6512",
    "highest": "1,6567",
    "lower": "1,6390",
    "difference": "-0,49%"
  },
  {
    "date": "12.07.2011",
    "now": "1,6512",
    "open": "1,6477",
    "highest": "1,6598",
    "lower": "1,6448",
    "difference": "0,28%"
  },
  {
    "date": "11.07.2011",
    "now": "1,6466",
    "open": "1,6246",
    "highest": "1,6490",
    "lower": "1,6246",
    "difference": "1,17%"
  },
  {
    "date": "08.07.2011",
    "now": "1,6276",
    "open": "1,6178",
    "highest": "1,6337",
    "lower": "1,6127",
    "difference": "0,62%"
  },
  {
    "date": "07.07.2011",
    "now": "1,6176",
    "open": "1,6328",
    "highest": "1,6406",
    "lower": "1,6150",
    "difference": "-0,95%"
  },
  {
    "date": "06.07.2011",
    "now": "1,6331",
    "open": "1,6277",
    "highest": "1,6382",
    "lower": "1,6210",
    "difference": "0,33%"
  },
  {
    "date": "05.07.2011",
    "now": "1,6277",
    "open": "1,6164",
    "highest": "1,6324",
    "lower": "1,6149",
    "difference": "0,72%"
  },
  {
    "date": "04.07.2011",
    "now": "1,6160",
    "open": "1,6068",
    "highest": "1,6195",
    "lower": "1,6040",
    "difference": "0,54%"
  },
  {
    "date": "01.07.2011",
    "now": "1,6074",
    "open": "1,6224",
    "highest": "1,6244",
    "lower": "1,6053",
    "difference": "-0,81%"
  },
  {
    "date": "30.06.2011",
    "now": "1,6206",
    "open": "1,6213",
    "highest": "1,6275",
    "lower": "1,6135",
    "difference": "-0,09%"
  },
  {
    "date": "29.06.2011",
    "now": "1,6220",
    "open": "1,6421",
    "highest": "1,6460",
    "lower": "1,6210",
    "difference": "-1,24%"
  },
  {
    "date": "28.06.2011",
    "now": "1,6424",
    "open": "1,6379",
    "highest": "1,6527",
    "lower": "1,6282",
    "difference": "0,29%"
  },
  {
    "date": "27.06.2011",
    "now": "1,6376",
    "open": "1,6335",
    "highest": "1,6478",
    "lower": "1,6318",
    "difference": "0,06%"
  },
  {
    "date": "24.06.2011",
    "now": "1,6366",
    "open": "1,6288",
    "highest": "1,6391",
    "lower": "1,6227",
    "difference": "0,51%"
  },
  {
    "date": "23.06.2011",
    "now": "1,6283",
    "open": "1,6185",
    "highest": "1,6384",
    "lower": "1,6175",
    "difference": "1,00%"
  },
  {
    "date": "22.06.2011",
    "now": "1,6121",
    "open": "1,6107",
    "highest": "1,6225",
    "lower": "1,6025",
    "difference": "0,05%"
  },
  {
    "date": "21.06.2011",
    "now": "1,6113",
    "open": "1,6006",
    "highest": "1,6165",
    "lower": "1,5935",
    "difference": "0,69%"
  },
  {
    "date": "20.06.2011",
    "now": "1,6003",
    "open": "1,5950",
    "highest": "1,6146",
    "lower": "1,5934",
    "difference": "0,23%"
  },
  {
    "date": "17.06.2011",
    "now": "1,5967",
    "open": "1,6108",
    "highest": "1,6161",
    "lower": "1,5917",
    "difference": "-0,90%"
  },
  {
    "date": "16.06.2011",
    "now": "1,6112",
    "open": "1,6090",
    "highest": "1,6280",
    "lower": "1,6040",
    "difference": "0,19%"
  },
  {
    "date": "15.06.2011",
    "now": "1,6081",
    "open": "1,5855",
    "highest": "1,6127",
    "lower": "1,5827",
    "difference": "1,44%"
  },
  {
    "date": "14.06.2011",
    "now": "1,5852",
    "open": "1,5746",
    "highest": "1,5892",
    "lower": "1,5665",
    "difference": "0,66%"
  },
  {
    "date": "13.06.2011",
    "now": "1,5748",
    "open": "1,5743",
    "highest": "1,5795",
    "lower": "1,5645",
    "difference": "-0,04%"
  },
  {
    "date": "10.06.2011",
    "now": "1,5755",
    "open": "1,5722",
    "highest": "1,5833",
    "lower": "1,5673",
    "difference": "0,29%"
  },
  {
    "date": "09.06.2011",
    "now": "1,5710",
    "open": "1,5821",
    "highest": "1,5835",
    "lower": "1,5695",
    "difference": "-0,73%"
  },
  {
    "date": "08.06.2011",
    "now": "1,5825",
    "open": "1,5814",
    "highest": "1,5919",
    "lower": "1,5749",
    "difference": "0,08%"
  },
  {
    "date": "07.06.2011",
    "now": "1,5813",
    "open": "1,5869",
    "highest": "1,5885",
    "lower": "1,5747",
    "difference": "-0,38%"
  },
  {
    "date": "06.06.2011",
    "now": "1,5873",
    "open": "1,5715",
    "highest": "1,5883",
    "lower": "1,5690",
    "difference": "0,88%"
  },
  {
    "date": "03.06.2011",
    "now": "1,5734",
    "open": "1,5817",
    "highest": "1,5897",
    "lower": "1,5703",
    "difference": "-0,93%"
  },
  {
    "date": "02.06.2011",
    "now": "1,5882",
    "open": "1,6002",
    "highest": "1,6005",
    "lower": "1,5795",
    "difference": "-0,72%"
  },
  {
    "date": "01.06.2011",
    "now": "1,5997",
    "open": "1,5936",
    "highest": "1,6007",
    "lower": "1,5827",
    "difference": "0,36%"
  },
  {
    "date": "31.05.2011",
    "now": "1,5939",
    "open": "1,6042",
    "highest": "1,6058",
    "lower": "1,5858",
    "difference": "-0,64%"
  },
  {
    "date": "30.05.2011",
    "now": "1,6042",
    "open": "1,6062",
    "highest": "1,6114",
    "lower": "1,5964",
    "difference": "0,07%"
  },
  {
    "date": "27.05.2011",
    "now": "1,6030",
    "open": "1,6031",
    "highest": "1,6135",
    "lower": "1,5935",
    "difference": "0,03%"
  },
  {
    "date": "26.05.2011",
    "now": "1,6025",
    "open": "1,6059",
    "highest": "1,6085",
    "lower": "1,5925",
    "difference": "-0,05%"
  },
  {
    "date": "25.05.2011",
    "now": "1,6033",
    "open": "1,5980",
    "highest": "1,6115",
    "lower": "1,5962",
    "difference": "0,36%"
  },
  {
    "date": "24.05.2011",
    "now": "1,5975",
    "open": "1,6035",
    "highest": "1,6073",
    "lower": "1,5925",
    "difference": "-0,36%"
  },
  {
    "date": "23.05.2011",
    "now": "1,6033",
    "open": "1,5894",
    "highest": "1,6115",
    "lower": "1,5805",
    "difference": "1,08%"
  },
  {
    "date": "20.05.2011",
    "now": "1,5862",
    "open": "1,5764",
    "highest": "1,5937",
    "lower": "1,5712",
    "difference": "0,74%"
  },
  {
    "date": "19.05.2011",
    "now": "1,5746",
    "open": "1,5728",
    "highest": "1,5807",
    "lower": "1,5703",
    "difference": "0,12%"
  },
  {
    "date": "18.05.2011",
    "now": "1,5727",
    "open": "1,5846",
    "highest": "1,5866",
    "lower": "1,5712",
    "difference": "-1,03%"
  },
  {
    "date": "17.05.2011",
    "now": "1,5890",
    "open": "1,5915",
    "highest": "1,5945",
    "lower": "1,5780",
    "difference": "-0,17%"
  },
  {
    "date": "16.05.2011",
    "now": "1,5917",
    "open": "1,5959",
    "highest": "1,5993",
    "lower": "1,5825",
    "difference": "-0,35%"
  },
  {
    "date": "13.05.2011",
    "now": "1,5973",
    "open": "1,5786",
    "highest": "1,5983",
    "lower": "1,5726",
    "difference": "1,21%"
  },
  {
    "date": "12.05.2011",
    "now": "1,5782",
    "open": "1,5871",
    "highest": "1,5920",
    "lower": "1,5724",
    "difference": "-0,58%"
  },
  {
    "date": "11.05.2011",
    "now": "1,5874",
    "open": "1,5592",
    "highest": "1,5876",
    "lower": "1,5554",
    "difference": "1,78%"
  },
  {
    "date": "10.05.2011",
    "now": "1,5596",
    "open": "1,5465",
    "highest": "1,5677",
    "lower": "1,5459",
    "difference": "0,91%"
  },
  {
    "date": "09.05.2011",
    "now": "1,5455",
    "open": "1,5444",
    "highest": "1,5534",
    "lower": "1,5353",
    "difference": "-0,01%"
  },
  {
    "date": "06.05.2011",
    "now": "1,5456",
    "open": "1,5495",
    "highest": "1,5504",
    "lower": "1,5315",
    "difference": "-0,28%"
  },
  {
    "date": "05.05.2011",
    "now": "1,5500",
    "open": "1,5479",
    "highest": "1,5517",
    "lower": "1,5320",
    "difference": "0,15%"
  },
  {
    "date": "04.05.2011",
    "now": "1,5477",
    "open": "1,5335",
    "highest": "1,5491",
    "lower": "1,5275",
    "difference": "0,93%"
  },
  {
    "date": "03.05.2011",
    "now": "1,5335",
    "open": "1,5202",
    "highest": "1,5385",
    "lower": "1,5185",
    "difference": "0,80%"
  },
  {
    "date": "02.05.2011",
    "now": "1,5213",
    "open": "1,5203",
    "highest": "1,5235",
    "lower": "1,5140",
    "difference": "0,01%"
  },
  {
    "date": "29.04.2011",
    "now": "1,5211",
    "open": "1,5244",
    "highest": "1,5275",
    "lower": "1,5125",
    "difference": "-0,22%"
  },
  {
    "date": "28.04.2011",
    "now": "1,5244",
    "open": "1,5170",
    "highest": "1,5286",
    "lower": "1,5052",
    "difference": "0,48%"
  },
  {
    "date": "27.04.2011",
    "now": "1,5171",
    "open": "1,5225",
    "highest": "1,5275",
    "lower": "1,5155",
    "difference": "-0,52%"
  },
  {
    "date": "26.04.2011",
    "now": "1,5251",
    "open": "1,5245",
    "highest": "1,5350",
    "lower": "1,5210",
    "difference": "-0,05%"
  },
  {
    "date": "25.04.2011",
    "now": "1,5259",
    "open": "1,5197",
    "highest": "1,5290",
    "lower": "1,5050",
    "difference": "0,55%"
  },
  {
    "date": "22.04.2011",
    "now": "1,5175",
    "open": "1,5177",
    "highest": "1,5210",
    "lower": "1,5115",
    "difference": "-0,17%"
  },
  {
    "date": "21.04.2011",
    "now": "1,5201",
    "open": "1,5181",
    "highest": "1,5215",
    "lower": "1,4975",
    "difference": "0,03%"
  },
  {
    "date": "20.04.2011",
    "now": "1,5197",
    "open": "1,5305",
    "highest": "1,5308",
    "lower": "1,5123",
    "difference": "-0,65%"
  },
  {
    "date": "19.04.2011",
    "now": "1,5296",
    "open": "1,5417",
    "highest": "1,5430",
    "lower": "1,5250",
    "difference": "-0,72%"
  },
  {
    "date": "18.04.2011",
    "now": "1,5407",
    "open": "1,5099",
    "highest": "1,5454",
    "lower": "1,5093",
    "difference": "1,86%"
  },
  {
    "date": "15.04.2011",
    "now": "1,5126",
    "open": "1,5170",
    "highest": "1,5255",
    "lower": "1,5090",
    "difference": "-0,38%"
  },
  {
    "date": "14.04.2011",
    "now": "1,5184",
    "open": "1,5200",
    "highest": "1,5299",
    "lower": "1,5070",
    "difference": "-0,07%"
  },
  {
    "date": "13.04.2011",
    "now": "1,5195",
    "open": "1,5241",
    "highest": "1,5243",
    "lower": "1,5075",
    "difference": "-0,30%"
  },
  {
    "date": "12.04.2011",
    "now": "1,5241",
    "open": "1,5144",
    "highest": "1,5246",
    "lower": "1,5075",
    "difference": "0,57%"
  },
  {
    "date": "11.04.2011",
    "now": "1,5154",
    "open": "1,5084",
    "highest": "1,5205",
    "lower": "1,5005",
    "difference": "0,32%"
  },
  {
    "date": "08.04.2011",
    "now": "1,5106",
    "open": "1,5100",
    "highest": "1,5128",
    "lower": "1,4980",
    "difference": "0,00%"
  },
  {
    "date": "07.04.2011",
    "now": "1,5106",
    "open": "1,5140",
    "highest": "1,5201",
    "lower": "1,5036",
    "difference": "-0,17%"
  },
  {
    "date": "06.04.2011",
    "now": "1,5131",
    "open": "1,5286",
    "highest": "1,5292",
    "lower": "1,5090",
    "difference": "-1,03%"
  },
  {
    "date": "05.04.2011",
    "now": "1,5288",
    "open": "1,5309",
    "highest": "1,5390",
    "lower": "1,5259",
    "difference": "-0,18%"
  },
  {
    "date": "04.04.2011",
    "now": "1,5316",
    "open": "1,5245",
    "highest": "1,5385",
    "lower": "1,5205",
    "difference": "0,10%"
  },
  {
    "date": "01.04.2011",
    "now": "1,5300",
    "open": "1,5452",
    "highest": "1,5519",
    "lower": "1,5293",
    "difference": "-1,00%"
  },
  {
    "date": "31.03.2011",
    "now": "1,5454",
    "open": "1,5522",
    "highest": "1,5538",
    "lower": "1,5334",
    "difference": "-0,43%"
  },
  {
    "date": "30.03.2011",
    "now": "1,5521",
    "open": "1,5557",
    "highest": "1,5585",
    "lower": "1,5485",
    "difference": "-0,25%"
  },
  {
    "date": "29.03.2011",
    "now": "1,5560",
    "open": "1,5617",
    "highest": "1,5679",
    "lower": "1,5510",
    "difference": "-0,38%"
  },
  {
    "date": "28.03.2011",
    "now": "1,5620",
    "open": "1,5571",
    "highest": "1,5620",
    "lower": "1,5475",
    "difference": "0,42%"
  },
  {
    "date": "25.03.2011",
    "now": "1,5555",
    "open": "1,5501",
    "highest": "1,5573",
    "lower": "1,5425",
    "difference": "0,27%"
  },
  {
    "date": "24.03.2011",
    "now": "1,5513",
    "open": "1,5565",
    "highest": "1,5615",
    "lower": "1,5465",
    "difference": "-0,39%"
  },
  {
    "date": "23.03.2011",
    "now": "1,5573",
    "open": "1,5627",
    "highest": "1,5685",
    "lower": "1,5505",
    "difference": "-0,29%"
  },
  {
    "date": "22.03.2011",
    "now": "1,5619",
    "open": "1,5764",
    "highest": "1,5770",
    "lower": "1,5601",
    "difference": "-0,88%"
  },
  {
    "date": "21.03.2011",
    "now": "1,5757",
    "open": "1,5783",
    "highest": "1,5809",
    "lower": "1,5685",
    "difference": "-0,20%"
  },
  {
    "date": "18.03.2011",
    "now": "1,5788",
    "open": "1,5868",
    "highest": "1,5935",
    "lower": "1,5715",
    "difference": "-0,57%"
  },
  {
    "date": "17.03.2011",
    "now": "1,5878",
    "open": "1,5951",
    "highest": "1,5970",
    "lower": "1,5785",
    "difference": "-0,34%"
  },
  {
    "date": "16.03.2011",
    "now": "1,5932",
    "open": "1,5798",
    "highest": "1,5964",
    "lower": "1,5739",
    "difference": "0,92%"
  },
  {
    "date": "15.03.2011",
    "now": "1,5787",
    "open": "1,5684",
    "highest": "1,5922",
    "lower": "1,5655",
    "difference": "0,62%"
  },
  {
    "date": "14.03.2011",
    "now": "1,5689",
    "open": "1,5833",
    "highest": "1,5859",
    "lower": "1,5619",
    "difference": "-0,90%"
  },
  {
    "date": "11.03.2011",
    "now": "1,5832",
    "open": "1,5836",
    "highest": "1,5919",
    "lower": "1,5710",
    "difference": "-0,04%"
  },
  {
    "date": "10.03.2011",
    "now": "1,5839",
    "open": "1,5804",
    "highest": "1,5881",
    "lower": "1,5752",
    "difference": "0,22%"
  },
  {
    "date": "09.03.2011",
    "now": "1,5804",
    "open": "1,5895",
    "highest": "1,5966",
    "lower": "1,5766",
    "difference": "-0,55%"
  },
  {
    "date": "08.03.2011",
    "now": "1,5891",
    "open": "1,5984",
    "highest": "1,6009",
    "lower": "1,5835",
    "difference": "-0,56%"
  },
  {
    "date": "07.03.2011",
    "now": "1,5980",
    "open": "1,6009",
    "highest": "1,6066",
    "lower": "1,5929",
    "difference": "-0,09%"
  },
  {
    "date": "04.03.2011",
    "now": "1,5995",
    "open": "1,5959",
    "highest": "1,6055",
    "lower": "1,5885",
    "difference": "0,18%"
  },
  {
    "date": "03.03.2011",
    "now": "1,5967",
    "open": "1,6187",
    "highest": "1,6193",
    "lower": "1,5915",
    "difference": "-1,42%"
  },
  {
    "date": "02.03.2011",
    "now": "1,6197",
    "open": "1,6148",
    "highest": "1,6211",
    "lower": "1,6015",
    "difference": "0,26%"
  },
  {
    "date": "01.03.2011",
    "now": "1,6155",
    "open": "1,5990",
    "highest": "1,6163",
    "lower": "1,5924",
    "difference": "1,06%"
  },
  {
    "date": "28.02.2011",
    "now": "1,5986",
    "open": "1,5914",
    "highest": "1,6059",
    "lower": "1,5914",
    "difference": "0,07%"
  },
  {
    "date": "25.02.2011",
    "now": "1,5975",
    "open": "1,6022",
    "highest": "1,6065",
    "lower": "1,5895",
    "difference": "-0,34%"
  },
  {
    "date": "24.02.2011",
    "now": "1,6029",
    "open": "1,6090",
    "highest": "1,6162",
    "lower": "1,5966",
    "difference": "-0,37%"
  },
  {
    "date": "23.02.2011",
    "now": "1,6089",
    "open": "1,5978",
    "highest": "1,6129",
    "lower": "1,5805",
    "difference": "0,69%"
  },
  {
    "date": "22.02.2011",
    "now": "1,5978",
    "open": "1,5909",
    "highest": "1,6065",
    "lower": "1,5855",
    "difference": "0,38%"
  },
  {
    "date": "21.02.2011",
    "now": "1,5917",
    "open": "1,5751",
    "highest": "1,5933",
    "lower": "1,5723",
    "difference": "0,90%"
  },
  {
    "date": "18.02.2011",
    "now": "1,5775",
    "open": "1,5744",
    "highest": "1,5863",
    "lower": "1,5744",
    "difference": "0,17%"
  },
  {
    "date": "17.02.2011",
    "now": "1,5749",
    "open": "1,5835",
    "highest": "1,5875",
    "lower": "1,5699",
    "difference": "-0,47%"
  },
  {
    "date": "16.02.2011",
    "now": "1,5824",
    "open": "1,6018",
    "highest": "1,6020",
    "lower": "1,5772",
    "difference": "-0,93%"
  },
  {
    "date": "15.02.2011",
    "now": "1,5973",
    "open": "1,5910",
    "highest": "1,6039",
    "lower": "1,5810",
    "difference": "0,07%"
  },
  {
    "date": "14.02.2011",
    "now": "1,5962",
    "open": "1,5850",
    "highest": "1,6029",
    "lower": "1,5755",
    "difference": "0,52%"
  },
  {
    "date": "11.02.2011",
    "now": "1,5880",
    "open": "1,5909",
    "highest": "1,6010",
    "lower": "1,5830",
    "difference": "-0,13%"
  },
  {
    "date": "10.02.2011",
    "now": "1,5900",
    "open": "1,5897",
    "highest": "1,6065",
    "lower": "1,5855",
    "difference": "-0,11%"
  },
  {
    "date": "09.02.2011",
    "now": "1,5917",
    "open": "1,5749",
    "highest": "1,5941",
    "lower": "1,5695",
    "difference": "1,05%"
  },
  {
    "date": "08.02.2011",
    "now": "1,5751",
    "open": "1,5766",
    "highest": "1,5806",
    "lower": "1,5646",
    "difference": "-0,12%"
  },
  {
    "date": "07.02.2011",
    "now": "1,5770",
    "open": "1,5855",
    "highest": "1,5899",
    "lower": "1,5685",
    "difference": "-0,45%"
  },
  {
    "date": "04.02.2011",
    "now": "1,5841",
    "open": "1,5945",
    "highest": "1,6105",
    "lower": "1,5830",
    "difference": "-0,65%"
  },
  {
    "date": "03.02.2011",
    "now": "1,5944",
    "open": "1,5767",
    "highest": "1,6005",
    "lower": "1,5695",
    "difference": "1,12%"
  },
  {
    "date": "02.02.2011",
    "now": "1,5767",
    "open": "1,5785",
    "highest": "1,5866",
    "lower": "1,5696",
    "difference": "-0,11%"
  },
  {
    "date": "01.02.2011",
    "now": "1,5784",
    "open": "1,6037",
    "highest": "1,6065",
    "lower": "1,5765",
    "difference": "-1,63%"
  },
  {
    "date": "31.01.2011",
    "now": "1,6045",
    "open": "1,6102",
    "highest": "1,6193",
    "lower": "1,5955",
    "difference": "-0,61%"
  },
  {
    "date": "28.01.2011",
    "now": "1,6143",
    "open": "1,5773",
    "highest": "1,6176",
    "lower": "1,5750",
    "difference": "2,07%"
  },
  {
    "date": "27.01.2011",
    "now": "1,5816",
    "open": "1,5807",
    "highest": "1,5870",
    "lower": "1,5702",
    "difference": "0,21%"
  },
  {
    "date": "26.01.2011",
    "now": "1,5783",
    "open": "1,5691",
    "highest": "1,5835",
    "lower": "1,5630",
    "difference": "0,59%"
  },
  {
    "date": "25.01.2011",
    "now": "1,5691",
    "open": "1,5633",
    "highest": "1,5736",
    "lower": "1,5510",
    "difference": "0,36%"
  },
  {
    "date": "24.01.2011",
    "now": "1,5635",
    "open": "1,5684",
    "highest": "1,5791",
    "lower": "1,5559",
    "difference": "-0,63%"
  },
  {
    "date": "21.01.2011",
    "now": "1,5734",
    "open": "1,5844",
    "highest": "1,5878",
    "lower": "1,5635",
    "difference": "-0,69%"
  },
  {
    "date": "20.01.2011",
    "now": "1,5844",
    "open": "1,5494",
    "highest": "1,5857",
    "lower": "1,5454",
    "difference": "2,15%"
  },
  {
    "date": "19.01.2011",
    "now": "1,5511",
    "open": "1,5415",
    "highest": "1,5526",
    "lower": "1,5279",
    "difference": "0,62%"
  },
  {
    "date": "18.01.2011",
    "now": "1,5415",
    "open": "1,5423",
    "highest": "1,5437",
    "lower": "1,5255",
    "difference": "-0,06%"
  },
  {
    "date": "17.01.2011",
    "now": "1,5425",
    "open": "1,5517",
    "highest": "1,5623",
    "lower": "1,5413",
    "difference": "-0,69%"
  },
  {
    "date": "14.01.2011",
    "now": "1,5532",
    "open": "1,5458",
    "highest": "1,5549",
    "lower": "1,5379",
    "difference": "0,25%"
  },
  {
    "date": "13.01.2011",
    "now": "1,5493",
    "open": "1,5655",
    "highest": "1,5724",
    "lower": "1,5462",
    "difference": "-0,77%"
  },
  {
    "date": "12.01.2011",
    "now": "1,5614",
    "open": "1,5785",
    "highest": "1,5796",
    "lower": "1,5563",
    "difference": "-1,02%"
  },
  {
    "date": "11.01.2011",
    "now": "1,5775",
    "open": "1,5735",
    "highest": "1,5865",
    "lower": "1,5659",
    "difference": "-0,03%"
  },
  {
    "date": "10.01.2011",
    "now": "1,5779",
    "open": "1,5732",
    "highest": "1,5944",
    "lower": "1,5699",
    "difference": "0,34%"
  },
  {
    "date": "07.01.2011",
    "now": "1,5726",
    "open": "1,5542",
    "highest": "1,5780",
    "lower": "1,5477",
    "difference": "1,22%"
  },
  {
    "date": "06.01.2011",
    "now": "1,5537",
    "open": "1,5444",
    "highest": "1,5569",
    "lower": "1,5399",
    "difference": "0,54%"
  },
  {
    "date": "05.01.2011",
    "now": "1,5454",
    "open": "1,5407",
    "highest": "1,5541",
    "lower": "1,5334",
    "difference": "0,31%"
  },
  {
    "date": "04.01.2011",
    "now": "1,5407",
    "open": "1,5571",
    "highest": "1,5621",
    "lower": "1,5382",
    "difference": "-1,05%"
  },
  {
    "date": "03.01.2011",
    "now": "1,5570",
    "open": "1,5374",
    "highest": "1,5640",
    "lower": "1,5374",
    "difference": "0,98%"
  },
  {
    "date": "31.12.2010",
    "now": "1,5419",
    "open": "1,5547",
    "highest": "1,5592",
    "lower": "1,5352",
    "difference": "-0,82%"
  },
  {
    "date": "30.12.2010",
    "now": "1,5547",
    "open": "1,5577",
    "highest": "1,5622",
    "lower": "1,5492",
    "difference": "-0,03%"
  },
  {
    "date": "29.12.2010",
    "now": "1,5551",
    "open": "1,5646",
    "highest": "1,5694",
    "lower": "1,5546",
    "difference": "-0,46%"
  },
  {
    "date": "28.12.2010",
    "now": "1,5623",
    "open": "1,5457",
    "highest": "1,5650",
    "lower": "1,5359",
    "difference": "1,01%"
  },
  {
    "date": "27.12.2010",
    "now": "1,5467",
    "open": "1,5435",
    "highest": "1,5506",
    "lower": "1,5410",
    "difference": "-0,02%"
  },
  {
    "date": "24.12.2010",
    "now": "1,5470",
    "open": "1,5465",
    "highest": "1,5535",
    "lower": "1,5405",
    "difference": "0,05%"
  },
  {
    "date": "23.12.2010",
    "now": "1,5462",
    "open": "1,5514",
    "highest": "1,5552",
    "lower": "1,5450",
    "difference": "-0,32%"
  },
  {
    "date": "22.12.2010",
    "now": "1,5512",
    "open": "1,5566",
    "highest": "1,5574",
    "lower": "1,5450",
    "difference": "-0,35%"
  },
  {
    "date": "21.12.2010",
    "now": "1,5567",
    "open": "1,5597",
    "highest": "1,5615",
    "lower": "1,5470",
    "difference": "-0,21%"
  },
  {
    "date": "20.12.2010",
    "now": "1,5599",
    "open": "1,5467",
    "highest": "1,5682",
    "lower": "1,5398",
    "difference": "1,00%"
  },
  {
    "date": "17.12.2010",
    "now": "1,5445",
    "open": "1,5245",
    "highest": "1,5536",
    "lower": "1,5140",
    "difference": "1,35%"
  },
  {
    "date": "16.12.2010",
    "now": "1,5239",
    "open": "1,5252",
    "highest": "1,5289",
    "lower": "1,5110",
    "difference": "-0,07%"
  },
  {
    "date": "15.12.2010",
    "now": "1,5250",
    "open": "1,5138",
    "highest": "1,5260",
    "lower": "1,5086",
    "difference": "0,74%"
  },
  {
    "date": "14.12.2010",
    "now": "1,5138",
    "open": "1,5057",
    "highest": "1,5138",
    "lower": "1,4914",
    "difference": "0,52%"
  },
  {
    "date": "13.12.2010",
    "now": "1,5059",
    "open": "1,5055",
    "highest": "1,5154",
    "lower": "1,4960",
    "difference": "0,23%"
  },
  {
    "date": "10.12.2010",
    "now": "1,5024",
    "open": "1,5105",
    "highest": "1,5105",
    "lower": "1,4929",
    "difference": "-0,56%"
  },
  {
    "date": "09.12.2010",
    "now": "1,5109",
    "open": "1,4945",
    "highest": "1,5129",
    "lower": "1,4851",
    "difference": "1,10%"
  },
  {
    "date": "08.12.2010",
    "now": "1,4945",
    "open": "1,4835",
    "highest": "1,4978",
    "lower": "1,4796",
    "difference": "0,75%"
  },
  {
    "date": "07.12.2010",
    "now": "1,4834",
    "open": "1,4810",
    "highest": "1,4837",
    "lower": "1,4646",
    "difference": "0,17%"
  },
  {
    "date": "06.12.2010",
    "now": "1,4809",
    "open": "1,4722",
    "highest": "1,4894",
    "lower": "1,4689",
    "difference": "0,32%"
  },
  {
    "date": "03.12.2010",
    "now": "1,4762",
    "open": "1,4820",
    "highest": "1,5010",
    "lower": "1,4709",
    "difference": "-0,54%"
  },
  {
    "date": "02.12.2010",
    "now": "1,4842",
    "open": "1,4894",
    "highest": "1,4965",
    "lower": "1,4793",
    "difference": "-0,32%"
  },
  {
    "date": "01.12.2010",
    "now": "1,4889",
    "open": "1,5048",
    "highest": "1,5064",
    "lower": "1,4860",
    "difference": "-1,06%"
  },
  {
    "date": "30.11.2010",
    "now": "1,5049",
    "open": "1,5018",
    "highest": "1,5130",
    "lower": "1,4948",
    "difference": "0,05%"
  },
  {
    "date": "29.11.2010",
    "now": "1,5042",
    "open": "1,4835",
    "highest": "1,5113",
    "lower": "1,4775",
    "difference": "1,13%"
  },
  {
    "date": "26.11.2010",
    "now": "1,4874",
    "open": "1,4746",
    "highest": "1,4998",
    "lower": "1,4720",
    "difference": "1,15%"
  },
  {
    "date": "25.11.2010",
    "now": "1,4705",
    "open": "1,4784",
    "highest": "1,4809",
    "lower": "1,4665",
    "difference": "-0,61%"
  },
  {
    "date": "24.11.2010",
    "now": "1,4795",
    "open": "1,4847",
    "highest": "1,4883",
    "lower": "1,4655",
    "difference": "-0,25%"
  },
  {
    "date": "23.11.2010",
    "now": "1,4832",
    "open": "1,4550",
    "highest": "1,4852",
    "lower": "1,4520",
    "difference": "1,98%"
  },
  {
    "date": "22.11.2010",
    "now": "1,4544",
    "open": "1,4353",
    "highest": "1,4590",
    "lower": "1,4300",
    "difference": "0,69%"
  },
  {
    "date": "19.11.2010",
    "now": "1,4445",
    "open": "1,4437",
    "highest": "1,4483",
    "lower": "1,4354",
    "difference": "0,10%"
  },
  {
    "date": "18.11.2010",
    "now": "1,4430",
    "open": "1,4569",
    "highest": "1,4582",
    "lower": "1,4426",
    "difference": "-0,93%"
  },
  {
    "date": "17.11.2010",
    "now": "1,4566",
    "open": "1,4628",
    "highest": "1,4663",
    "lower": "1,4518",
    "difference": "-0,51%"
  },
  {
    "date": "16.11.2010",
    "now": "1,4640",
    "open": "1,4480",
    "highest": "1,4678",
    "lower": "1,4440",
    "difference": "1,21%"
  },
  {
    "date": "15.11.2010",
    "now": "1,4465",
    "open": "1,4391",
    "highest": "1,4511",
    "lower": "1,4340",
    "difference": "0,35%"
  },
  {
    "date": "12.11.2010",
    "now": "1,4414",
    "open": "1,4373",
    "highest": "1,4482",
    "lower": "1,4209",
    "difference": "0,33%"
  },
  {
    "date": "11.11.2010",
    "now": "1,4366",
    "open": "1,4161",
    "highest": "1,4385",
    "lower": "1,4072",
    "difference": "1,50%"
  },
  {
    "date": "10.11.2010",
    "now": "1,4154",
    "open": "1,4167",
    "highest": "1,4247",
    "lower": "1,4017",
    "difference": "-0,06%"
  },
  {
    "date": "09.11.2010",
    "now": "1,4162",
    "open": "1,4092",
    "highest": "1,4167",
    "lower": "1,3957",
    "difference": "0,53%"
  },
  {
    "date": "08.11.2010",
    "now": "1,4087",
    "open": "1,3915",
    "highest": "1,4155",
    "lower": "1,3915",
    "difference": "0,84%"
  },
  {
    "date": "05.11.2010",
    "now": "1,3970",
    "open": "1,3945",
    "highest": "1,4039",
    "lower": "1,3855",
    "difference": "0,12%"
  },
  {
    "date": "04.11.2010",
    "now": "1,3953",
    "open": "1,4045",
    "highest": "1,4076",
    "lower": "1,3847",
    "difference": "-0,61%"
  },
  {
    "date": "03.11.2010",
    "now": "1,4039",
    "open": "1,4076",
    "highest": "1,4206",
    "lower": "1,4023",
    "difference": "-0,59%"
  },
  {
    "date": "02.11.2010",
    "now": "1,4122",
    "open": "1,4224",
    "highest": "1,4268",
    "lower": "1,4072",
    "difference": "-1,00%"
  },
  {
    "date": "01.11.2010",
    "now": "1,4264",
    "open": "1,4305",
    "highest": "1,4338",
    "lower": "1,4192",
    "difference": "-0,46%"
  },
  {
    "date": "29.10.2010",
    "now": "1,4330",
    "open": "1,4301",
    "highest": "1,4403",
    "lower": "1,4275",
    "difference": "0,17%"
  },
  {
    "date": "28.10.2010",
    "now": "1,4305",
    "open": "1,4414",
    "highest": "1,4453",
    "lower": "1,4215",
    "difference": "-0,79%"
  },
  {
    "date": "27.10.2010",
    "now": "1,4419",
    "open": "1,4273",
    "highest": "1,4485",
    "lower": "1,4226",
    "difference": "0,98%"
  },
  {
    "date": "26.10.2010",
    "now": "1,4279",
    "open": "1,4152",
    "highest": "1,4302",
    "lower": "1,4105",
    "difference": "0,72%"
  },
  {
    "date": "25.10.2010",
    "now": "1,4177",
    "open": "1,4167",
    "highest": "1,4245",
    "lower": "1,4080",
    "difference": "-0,48%"
  },
  {
    "date": "22.10.2010",
    "now": "1,4245",
    "open": "1,4281",
    "highest": "1,4326",
    "lower": "1,4145",
    "difference": "-0,26%"
  },
  {
    "date": "21.10.2010",
    "now": "1,4282",
    "open": "1,4233",
    "highest": "1,4294",
    "lower": "1,4130",
    "difference": "0,37%"
  },
  {
    "date": "20.10.2010",
    "now": "1,4230",
    "open": "1,4383",
    "highest": "1,4404",
    "lower": "1,4190",
    "difference": "-1,07%"
  },
  {
    "date": "19.10.2010",
    "now": "1,4384",
    "open": "1,4160",
    "highest": "1,4397",
    "lower": "1,4114",
    "difference": "1,55%"
  },
  {
    "date": "18.10.2010",
    "now": "1,4165",
    "open": "1,4084",
    "highest": "1,4298",
    "lower": "1,4080",
    "difference": "0,17%"
  },
  {
    "date": "15.10.2010",
    "now": "1,4141",
    "open": "1,4075",
    "highest": "1,4185",
    "lower": "1,3895",
    "difference": "0,45%"
  },
  {
    "date": "14.10.2010",
    "now": "1,4077",
    "open": "1,4014",
    "highest": "1,4137",
    "lower": "1,3848",
    "difference": "0,01%"
  },
  {
    "date": "13.10.2010",
    "now": "1,4075",
    "open": "1,4101",
    "highest": "1,4187",
    "lower": "1,4025",
    "difference": "-0,38%"
  },
  {
    "date": "12.10.2010",
    "now": "1,4129",
    "open": "1,4166",
    "highest": "1,4323",
    "lower": "1,4127",
    "difference": "-0,23%"
  },
  {
    "date": "11.10.2010",
    "now": "1,4162",
    "open": "1,4136",
    "highest": "1,4211",
    "lower": "1,4052",
    "difference": "0,21%"
  },
  {
    "date": "08.10.2010",
    "now": "1,4133",
    "open": "1,4266",
    "highest": "1,4320",
    "lower": "1,4097",
    "difference": "-0,94%"
  },
  {
    "date": "07.10.2010",
    "now": "1,4267",
    "open": "1,4184",
    "highest": "1,4301",
    "lower": "1,4049",
    "difference": "0,48%"
  },
  {
    "date": "06.10.2010",
    "now": "1,4199",
    "open": "1,4266",
    "highest": "1,4293",
    "lower": "1,4063",
    "difference": "-0,60%"
  },
  {
    "date": "05.10.2010",
    "now": "1,4284",
    "open": "1,4587",
    "highest": "1,4613",
    "lower": "1,4275",
    "difference": "-1,86%"
  },
  {
    "date": "04.10.2010",
    "now": "1,4554",
    "open": "1,4409",
    "highest": "1,4592",
    "lower": "1,4333",
    "difference": "0,77%"
  },
  {
    "date": "01.10.2010",
    "now": "1,4443",
    "open": "1,4455",
    "highest": "1,4508",
    "lower": "1,4357",
    "difference": "-0,27%"
  },
  {
    "date": "30.09.2010",
    "now": "1,4482",
    "open": "1,4552",
    "highest": "1,4621",
    "lower": "1,4422",
    "difference": "-0,29%"
  },
  {
    "date": "29.09.2010",
    "now": "1,4524",
    "open": "1,4621",
    "highest": "1,4645",
    "lower": "1,4475",
    "difference": "-0,83%"
  },
  {
    "date": "28.09.2010",
    "now": "1,4645",
    "open": "1,4696",
    "highest": "1,4779",
    "lower": "1,4600",
    "difference": "-0,56%"
  },
  {
    "date": "27.09.2010",
    "now": "1,4728",
    "open": "1,4776",
    "highest": "1,4801",
    "lower": "1,4678",
    "difference": "-0,23%"
  },
  {
    "date": "24.09.2010",
    "now": "1,4762",
    "open": "1,4869",
    "highest": "1,4905",
    "lower": "1,4762",
    "difference": "-0,66%"
  },
  {
    "date": "23.09.2010",
    "now": "1,4860",
    "open": "1,4855",
    "highest": "1,4911",
    "lower": "1,4755",
    "difference": "0,01%"
  },
  {
    "date": "22.09.2010",
    "now": "1,4859",
    "open": "1,4870",
    "highest": "1,4912",
    "lower": "1,4787",
    "difference": "-0,09%"
  },
  {
    "date": "21.09.2010",
    "now": "1,4872",
    "open": "1,4889",
    "highest": "1,4968",
    "lower": "1,4805",
    "difference": "-0,27%"
  },
  {
    "date": "20.09.2010",
    "now": "1,4912",
    "open": "1,4974",
    "highest": "1,5038",
    "lower": "1,4872",
    "difference": "-0,19%"
  },
  {
    "date": "17.09.2010",
    "now": "1,4940",
    "open": "1,4955",
    "highest": "1,5031",
    "lower": "1,4881",
    "difference": "-0,09%"
  },
  {
    "date": "16.09.2010",
    "now": "1,4954",
    "open": "1,4880",
    "highest": "1,5028",
    "lower": "1,4850",
    "difference": "0,40%"
  },
  {
    "date": "15.09.2010",
    "now": "1,4895",
    "open": "1,4929",
    "highest": "1,4981",
    "lower": "1,4845",
    "difference": "-0,18%"
  },
  {
    "date": "14.09.2010",
    "now": "1,4922",
    "open": "1,4954",
    "highest": "1,5045",
    "lower": "1,4843",
    "difference": "-0,22%"
  },
  {
    "date": "13.09.2010",
    "now": "1,4955",
    "open": "1,4952",
    "highest": "1,4990",
    "lower": "1,4860",
    "difference": "-0,93%"
  },
  {
    "date": "10.09.2010",
    "now": "1,5095",
    "open": "1,5127",
    "highest": "1,5165",
    "lower": "1,5041",
    "difference": "-0,16%"
  },
  {
    "date": "09.09.2010",
    "now": "1,5119",
    "open": "1,5152",
    "highest": "1,5194",
    "lower": "1,5060",
    "difference": "-0,24%"
  },
  {
    "date": "08.09.2010",
    "now": "1,5156",
    "open": "1,5173",
    "highest": "1,5232",
    "lower": "1,5011",
    "difference": "-0,13%"
  },
  {
    "date": "07.09.2010",
    "now": "1,5176",
    "open": "1,5026",
    "highest": "1,5189",
    "lower": "1,4978",
    "difference": "0,48%"
  },
  {
    "date": "06.09.2010",
    "now": "1,5103",
    "open": "1,5000",
    "highest": "1,5103",
    "lower": "1,4928",
    "difference": "0,67%"
  },
  {
    "date": "03.09.2010",
    "now": "1,5002",
    "open": "1,5107",
    "highest": "1,5145",
    "lower": "1,4960",
    "difference": "-0,70%"
  },
  {
    "date": "02.09.2010",
    "now": "1,5108",
    "open": "1,5139",
    "highest": "1,5185",
    "lower": "1,5010",
    "difference": "-0,38%"
  },
  {
    "date": "01.09.2010",
    "now": "1,5165",
    "open": "1,5218",
    "highest": "1,5277",
    "lower": "1,5101",
    "difference": "-0,67%"
  },
  {
    "date": "31.08.2010",
    "now": "1,5267",
    "open": "1,5300",
    "highest": "1,5354",
    "lower": "1,5232",
    "difference": "0,10%"
  },
  {
    "date": "30.08.2010",
    "now": "1,5252",
    "open": "1,5158",
    "highest": "1,5270",
    "lower": "1,5111",
    "difference": "0,55%"
  },
  {
    "date": "27.08.2010",
    "now": "1,5168",
    "open": "1,5235",
    "highest": "1,5283",
    "lower": "1,5096",
    "difference": "-0,26%"
  },
  {
    "date": "26.08.2010",
    "now": "1,5207",
    "open": "1,5316",
    "highest": "1,5387",
    "lower": "1,5172",
    "difference": "-0,45%"
  },
  {
    "date": "25.08.2010",
    "now": "1,5276",
    "open": "1,5322",
    "highest": "1,5338",
    "lower": "1,5160",
    "difference": "-0,37%"
  },
  {
    "date": "24.08.2010",
    "now": "1,5333",
    "open": "1,5297",
    "highest": "1,5362",
    "lower": "1,5223",
    "difference": "0,27%"
  },
  {
    "date": "23.08.2010",
    "now": "1,5291",
    "open": "1,5167",
    "highest": "1,5310",
    "lower": "1,5081",
    "difference": "0,85%"
  },
  {
    "date": "20.08.2010",
    "now": "1,5162",
    "open": "1,5094",
    "highest": "1,5207",
    "lower": "1,4982",
    "difference": "0,42%"
  },
  {
    "date": "19.08.2010",
    "now": "1,5099",
    "open": "1,5011",
    "highest": "1,5145",
    "lower": "1,4949",
    "difference": "0,51%"
  },
  {
    "date": "18.08.2010",
    "now": "1,5023",
    "open": "1,4939",
    "highest": "1,5024",
    "lower": "1,4909",
    "difference": "0,29%"
  },
  {
    "date": "17.08.2010",
    "now": "1,4979",
    "open": "1,5083",
    "highest": "1,5103",
    "lower": "1,4845",
    "difference": "-0,83%"
  },
  {
    "date": "16.08.2010",
    "now": "1,5105",
    "open": "1,5184",
    "highest": "1,5242",
    "lower": "1,5067",
    "difference": "-0,47%"
  },
  {
    "date": "13.08.2010",
    "now": "1,5177",
    "open": "1,5199",
    "highest": "1,5206",
    "lower": "1,5065",
    "difference": "-0,23%"
  },
  {
    "date": "12.08.2010",
    "now": "1,5212",
    "open": "1,5192",
    "highest": "1,5287",
    "lower": "1,5100",
    "difference": "-0,03%"
  },
  {
    "date": "11.08.2010",
    "now": "1,5217",
    "open": "1,5018",
    "highest": "1,5282",
    "lower": "1,4992",
    "difference": "1,57%"
  },
  {
    "date": "10.08.2010",
    "now": "1,4982",
    "open": "1,4943",
    "highest": "1,5055",
    "lower": "1,4867",
    "difference": "0,39%"
  },
  {
    "date": "09.08.2010",
    "now": "1,4924",
    "open": "1,4873",
    "highest": "1,4939",
    "lower": "1,4807",
    "difference": "0,15%"
  },
  {
    "date": "06.08.2010",
    "now": "1,4902",
    "open": "1,5030",
    "highest": "1,5043",
    "lower": "1,4821",
    "difference": "-0,85%"
  },
  {
    "date": "05.08.2010",
    "now": "1,5029",
    "open": "1,4987",
    "highest": "1,5078",
    "lower": "1,4940",
    "difference": "0,25%"
  },
  {
    "date": "04.08.2010",
    "now": "1,4992",
    "open": "1,4889",
    "highest": "1,5048",
    "lower": "1,4849",
    "difference": "0,42%"
  },
  {
    "date": "03.08.2010",
    "now": "1,4930",
    "open": "1,4897",
    "highest": "1,4990",
    "lower": "1,4872",
    "difference": "-0,13%"
  },
  {
    "date": "02.08.2010",
    "now": "1,4949",
    "open": "1,5016",
    "highest": "1,5085",
    "lower": "1,4869",
    "difference": "-0,86%"
  },
  {
    "date": "30.07.2010",
    "now": "1,5078",
    "open": "1,5086",
    "highest": "1,5162",
    "lower": "1,5027",
    "difference": "-0,29%"
  },
  {
    "date": "29.07.2010",
    "now": "1,5122",
    "open": "1,5086",
    "highest": "1,5157",
    "lower": "1,5000",
    "difference": "-0,05%"
  },
  {
    "date": "28.07.2010",
    "now": "1,5129",
    "open": "1,5112",
    "highest": "1,5190",
    "lower": "1,5052",
    "difference": "0,17%"
  },
  {
    "date": "27.07.2010",
    "now": "1,5103",
    "open": "1,5181",
    "highest": "1,5213",
    "lower": "1,5101",
    "difference": "-0,28%"
  },
  {
    "date": "26.07.2010",
    "now": "1,5146",
    "open": "1,5185",
    "highest": "1,5233",
    "lower": "1,5102",
    "difference": "-0,53%"
  },
  {
    "date": "23.07.2010",
    "now": "1,5226",
    "open": "1,5199",
    "highest": "1,5316",
    "lower": "1,5162",
    "difference": "0,14%"
  },
  {
    "date": "22.07.2010",
    "now": "1,5204",
    "open": "1,5299",
    "highest": "1,5349",
    "lower": "1,5141",
    "difference": "-0,91%"
  },
  {
    "date": "21.07.2010",
    "now": "1,5343",
    "open": "1,5294",
    "highest": "1,5349",
    "lower": "1,5185",
    "difference": "0,32%"
  },
  {
    "date": "20.07.2010",
    "now": "1,5294",
    "open": "1,5389",
    "highest": "1,5426",
    "lower": "1,5252",
    "difference": "-0,63%"
  },
  {
    "date": "19.07.2010",
    "now": "1,5391",
    "open": "1,5368",
    "highest": "1,5498",
    "lower": "1,5312",
    "difference": "-0,06%"
  },
  {
    "date": "16.07.2010",
    "now": "1,5401",
    "open": "1,5329",
    "highest": "1,5484",
    "lower": "1,5307",
    "difference": "0,36%"
  },
  {
    "date": "15.07.2010",
    "now": "1,5345",
    "open": "1,5402",
    "highest": "1,5450",
    "lower": "1,5311",
    "difference": "-0,34%"
  },
  {
    "date": "14.07.2010",
    "now": "1,5398",
    "open": "1,5444",
    "highest": "1,5474",
    "lower": "1,5377",
    "difference": "-0,32%"
  },
  {
    "date": "13.07.2010",
    "now": "1,5448",
    "open": "1,5554",
    "highest": "1,5622",
    "lower": "1,5435",
    "difference": "-0,66%"
  },
  {
    "date": "12.07.2010",
    "now": "1,5551",
    "open": "1,5509",
    "highest": "1,5638",
    "lower": "1,5481",
    "difference": "0,13%"
  },
  {
    "date": "09.07.2010",
    "now": "1,5531",
    "open": "1,5512",
    "highest": "1,5596",
    "lower": "1,5447",
    "difference": "0,12%"
  },
  {
    "date": "08.07.2010",
    "now": "1,5513",
    "open": "1,5520",
    "highest": "1,5564",
    "lower": "1,5451",
    "difference": "-0,17%"
  },
  {
    "date": "07.07.2010",
    "now": "1,5539",
    "open": "1,5589",
    "highest": "1,5677",
    "lower": "1,5495",
    "difference": "-0,03%"
  },
  {
    "date": "06.07.2010",
    "now": "1,5543",
    "open": "1,5604",
    "highest": "1,5694",
    "lower": "1,5472",
    "difference": "-0,68%"
  },
  {
    "date": "05.07.2010",
    "now": "1,5650",
    "open": "1,5646",
    "highest": "1,5694",
    "lower": "1,5564",
    "difference": "-0,04%"
  },
  {
    "date": "02.07.2010",
    "now": "1,5657",
    "open": "1,5826",
    "highest": "1,5849",
    "lower": "1,5642",
    "difference": "-0,88%"
  },
  {
    "date": "01.07.2010",
    "now": "1,5796",
    "open": "1,5821",
    "highest": "1,5909",
    "lower": "1,5766",
    "difference": "-0,46%"
  },
  {
    "date": "30.06.2010",
    "now": "1,5869",
    "open": "1,5918",
    "highest": "1,5956",
    "lower": "1,5792",
    "difference": "-0,32%"
  },
  {
    "date": "29.06.2010",
    "now": "1,5920",
    "open": "1,5709",
    "highest": "1,5926",
    "lower": "1,5709",
    "difference": "1,10%"
  },
  {
    "date": "28.06.2010",
    "now": "1,5747",
    "open": "1,5732",
    "highest": "1,5777",
    "lower": "1,5619",
    "difference": "0,07%"
  },
  {
    "date": "25.06.2010",
    "now": "1,5736",
    "open": "1,5759",
    "highest": "1,5890",
    "lower": "1,5726",
    "difference": "-0,35%"
  },
  {
    "date": "24.06.2010",
    "now": "1,5792",
    "open": "1,5760",
    "highest": "1,5914",
    "lower": "1,5694",
    "difference": "0,46%"
  },
  {
    "date": "23.06.2010",
    "now": "1,5719",
    "open": "1,5716",
    "highest": "1,5854",
    "lower": "1,5602",
    "difference": "0,30%"
  },
  {
    "date": "22.06.2010",
    "now": "1,5672",
    "open": "1,5566",
    "highest": "1,5683",
    "lower": "1,5514",
    "difference": "0,60%"
  },
  {
    "date": "21.06.2010",
    "now": "1,5579",
    "open": "1,5484",
    "highest": "1,5594",
    "lower": "1,5410",
    "difference": "0,17%"
  },
  {
    "date": "18.06.2010",
    "now": "1,5552",
    "open": "1,5648",
    "highest": "1,5665",
    "lower": "1,5527",
    "difference": "-0,37%"
  },
  {
    "date": "17.06.2010",
    "now": "1,5610",
    "open": "1,5593",
    "highest": "1,5714",
    "lower": "1,5564",
    "difference": "-0,11%"
  },
  {
    "date": "16.06.2010",
    "now": "1,5627",
    "open": "1,5684",
    "highest": "1,5784",
    "lower": "1,5610",
    "difference": "-0,05%"
  },
  {
    "date": "15.06.2010",
    "now": "1,5635",
    "open": "1,5772",
    "highest": "1,5849",
    "lower": "1,5594",
    "difference": "-0,82%"
  },
  {
    "date": "14.06.2010",
    "now": "1,5765",
    "open": "1,5730",
    "highest": "1,5775",
    "lower": "1,5595",
    "difference": "-0,17%"
  },
  {
    "date": "11.06.2010",
    "now": "1,5792",
    "open": "1,5844",
    "highest": "1,5908",
    "lower": "1,5762",
    "difference": "-0,06%"
  },
  {
    "date": "10.06.2010",
    "now": "1,5801",
    "open": "1,6031",
    "highest": "1,6042",
    "lower": "1,5773",
    "difference": "-1,48%"
  },
  {
    "date": "09.06.2010",
    "now": "1,6039",
    "open": "1,6026",
    "highest": "1,6065",
    "lower": "1,5921",
    "difference": "0,17%"
  },
  {
    "date": "08.06.2010",
    "now": "1,6012",
    "open": "1,6182",
    "highest": "1,6184",
    "lower": "1,5952",
    "difference": "-0,77%"
  },
  {
    "date": "07.06.2010",
    "now": "1,6137",
    "open": "1,6104",
    "highest": "1,6227",
    "lower": "1,5982",
    "difference": "0,36%"
  },
  {
    "date": "04.06.2010",
    "now": "1,6079",
    "open": "1,5892",
    "highest": "1,6115",
    "lower": "1,5782",
    "difference": "1,34%"
  },
  {
    "date": "03.06.2010",
    "now": "1,5867",
    "open": "1,5779",
    "highest": "1,5939",
    "lower": "1,5646",
    "difference": "0,50%"
  },
  {
    "date": "02.06.2010",
    "now": "1,5788",
    "open": "1,5848",
    "highest": "1,5922",
    "lower": "1,5752",
    "difference": "-0,38%"
  },
  {
    "date": "01.06.2010",
    "now": "1,5848",
    "open": "1,5766",
    "highest": "1,5988",
    "lower": "1,5732",
    "difference": "0,68%"
  },
  {
    "date": "31.05.2010",
    "now": "1,5741",
    "open": "1,5651",
    "highest": "1,5780",
    "lower": "1,5575",
    "difference": "0,46%"
  },
  {
    "date": "28.05.2010",
    "now": "1,5669",
    "open": "1,5634",
    "highest": "1,5740",
    "lower": "1,5517",
    "difference": "0,46%"
  },
  {
    "date": "27.05.2010",
    "now": "1,5597",
    "open": "1,5930",
    "highest": "1,5932",
    "lower": "1,5576",
    "difference": "-1,71%"
  },
  {
    "date": "26.05.2010",
    "now": "1,5869",
    "open": "1,5844",
    "highest": "1,5942",
    "lower": "1,5742",
    "difference": "0,47%"
  },
  {
    "date": "25.05.2010",
    "now": "1,5794",
    "open": "1,5779",
    "highest": "1,6067",
    "lower": "1,5773",
    "difference": "0,15%"
  },
  {
    "date": "24.05.2010",
    "now": "1,5770",
    "open": "1,5751",
    "highest": "1,5839",
    "lower": "1,5652",
    "difference": "0,11%"
  },
  {
    "date": "21.05.2010",
    "now": "1,5753",
    "open": "1,6039",
    "highest": "1,6052",
    "lower": "1,5729",
    "difference": "-1,43%"
  },
  {
    "date": "20.05.2010",
    "now": "1,5982",
    "open": "1,5810",
    "highest": "1,6124",
    "lower": "1,5692",
    "difference": "1,51%"
  },
  {
    "date": "19.05.2010",
    "now": "1,5744",
    "open": "1,5655",
    "highest": "1,6034",
    "lower": "1,5600",
    "difference": "0,66%"
  },
  {
    "date": "18.05.2010",
    "now": "1,5640",
    "open": "1,5459",
    "highest": "1,5714",
    "lower": "1,5332",
    "difference": "1,34%"
  },
  {
    "date": "17.05.2010",
    "now": "1,5433",
    "open": "1,5411",
    "highest": "1,5594",
    "lower": "1,5345",
    "difference": "0,02%"
  },
  {
    "date": "14.05.2010",
    "now": "1,5430",
    "open": "1,5255",
    "highest": "1,5519",
    "lower": "1,5207",
    "difference": "1,31%"
  },
  {
    "date": "13.05.2010",
    "now": "1,5230",
    "open": "1,5255",
    "highest": "1,5269",
    "lower": "1,5129",
    "difference": "-0,22%"
  },
  {
    "date": "12.05.2010",
    "now": "1,5264",
    "open": "1,5384",
    "highest": "1,5490",
    "lower": "1,5219",
    "difference": "-0,67%"
  },
  {
    "date": "11.05.2010",
    "now": "1,5367",
    "open": "1,5269",
    "highest": "1,5417",
    "lower": "1,5212",
    "difference": "0,64%"
  },
  {
    "date": "10.05.2010",
    "now": "1,5270",
    "open": "1,5552",
    "highest": "1,5568",
    "lower": "1,5097",
    "difference": "-2,16%"
  },
  {
    "date": "07.05.2010",
    "now": "1,5607",
    "open": "1,5974",
    "highest": "1,6019",
    "lower": "1,5552",
    "difference": "-2,25%"
  },
  {
    "date": "06.05.2010",
    "now": "1,5967",
    "open": "1,5379",
    "highest": "1,6014",
    "lower": "1,5302",
    "difference": "3,95%"
  },
  {
    "date": "05.05.2010",
    "now": "1,5360",
    "open": "1,5180",
    "highest": "1,5388",
    "lower": "1,5055",
    "difference": "0,83%"
  },
  {
    "date": "04.05.2010",
    "now": "1,5234",
    "open": "1,4965",
    "highest": "1,5277",
    "lower": "1,4842",
    "difference": "2,10%"
  },
  {
    "date": "03.05.2010",
    "now": "1,4920",
    "open": "1,4839",
    "highest": "1,4982",
    "lower": "1,4821",
    "difference": "0,15%"
  },
  {
    "date": "30.04.2010",
    "now": "1,4897",
    "open": "1,4829",
    "highest": "1,4922",
    "lower": "1,4714",
    "difference": "0,37%"
  },
  {
    "date": "29.04.2010",
    "now": "1,4842",
    "open": "1,4983",
    "highest": "1,5011",
    "lower": "1,4781",
    "difference": "-0,79%"
  },
  {
    "date": "28.04.2010",
    "now": "1,4960",
    "open": "1,5044",
    "highest": "1,5185",
    "lower": "1,4914",
    "difference": "-0,53%"
  },
  {
    "date": "27.04.2010",
    "now": "1,5040",
    "open": "1,4744",
    "highest": "1,5057",
    "lower": "1,4697",
    "difference": "2,02%"
  },
  {
    "date": "26.04.2010",
    "now": "1,4742",
    "open": "1,4838",
    "highest": "1,4848",
    "lower": "1,4656",
    "difference": "-0,60%"
  },
  {
    "date": "23.04.2010",
    "now": "1,4831",
    "open": "1,4940",
    "highest": "1,4980",
    "lower": "1,4824",
    "difference": "-0,28%"
  },
  {
    "date": "22.04.2010",
    "now": "1,4873",
    "open": "1,4835",
    "highest": "1,4924",
    "lower": "1,4735",
    "difference": "0,31%"
  },
  {
    "date": "21.04.2010",
    "now": "1,4827",
    "open": "1,4821",
    "highest": "1,4870",
    "lower": "1,4755",
    "difference": "-0,32%"
  },
  {
    "date": "20.04.2010",
    "now": "1,4874",
    "open": "1,4868",
    "highest": "1,4952",
    "lower": "1,4806",
    "difference": "-0,27%"
  },
  {
    "date": "19.04.2010",
    "now": "1,4914",
    "open": "1,4854",
    "highest": "1,5057",
    "lower": "1,4853",
    "difference": "0,56%"
  },
  {
    "date": "16.04.2010",
    "now": "1,4831",
    "open": "1,4728",
    "highest": "1,4877",
    "lower": "1,4659",
    "difference": "0,82%"
  },
  {
    "date": "15.04.2010",
    "now": "1,4711",
    "open": "1,4753",
    "highest": "1,4825",
    "lower": "1,4677",
    "difference": "-0,29%"
  },
  {
    "date": "14.04.2010",
    "now": "1,4754",
    "open": "1,4861",
    "highest": "1,4865",
    "lower": "1,4710",
    "difference": "-0,71%"
  },
  {
    "date": "13.04.2010",
    "now": "1,4859",
    "open": "1,4832",
    "highest": "1,4949",
    "lower": "1,4806",
    "difference": "-0,13%"
  },
  {
    "date": "12.04.2010",
    "now": "1,4878",
    "open": "1,4852",
    "highest": "1,4953",
    "lower": "1,4817",
    "difference": "-0,07%"
  },
  {
    "date": "09.04.2010",
    "now": "1,4889",
    "open": "1,4929",
    "highest": "1,4995",
    "lower": "1,4823",
    "difference": "-0,57%"
  },
  {
    "date": "08.04.2010",
    "now": "1,4974",
    "open": "1,5048",
    "highest": "1,5132",
    "lower": "1,4967",
    "difference": "-0,19%"
  },
  {
    "date": "07.04.2010",
    "now": "1,5002",
    "open": "1,5008",
    "highest": "1,5080",
    "lower": "1,4907",
    "difference": "-0,32%"
  },
  {
    "date": "06.04.2010",
    "now": "1,5050",
    "open": "1,5058",
    "highest": "1,5175",
    "lower": "1,5015",
    "difference": "-0,19%"
  },
  {
    "date": "05.04.2010",
    "now": "1,5079",
    "open": "1,5143",
    "highest": "1,5227",
    "lower": "1,5079",
    "difference": "-0,44%"
  },
  {
    "date": "02.04.2010",
    "now": "1,5146",
    "open": "1,5123",
    "highest": "1,5203",
    "lower": "1,5113",
    "difference": "-0,14%"
  },
  {
    "date": "01.04.2010",
    "now": "1,5167",
    "open": "1,5178",
    "highest": "1,5264",
    "lower": "1,5152",
    "difference": "-0,16%"
  },
  {
    "date": "31.03.2010",
    "now": "1,5192",
    "open": "1,5256",
    "highest": "1,5318",
    "lower": "1,5146",
    "difference": "-0,73%"
  },
  {
    "date": "30.03.2010",
    "now": "1,5303",
    "open": "1,5300",
    "highest": "1,5447",
    "lower": "1,5202",
    "difference": "0,05%"
  },
  {
    "date": "29.03.2010",
    "now": "1,5296",
    "open": "1,5306",
    "highest": "1,5352",
    "lower": "1,5195",
    "difference": "-0,59%"
  },
  {
    "date": "26.03.2010",
    "now": "1,5387",
    "open": "1,5416",
    "highest": "1,5462",
    "lower": "1,5264",
    "difference": "-0,39%"
  },
  {
    "date": "25.03.2010",
    "now": "1,5447",
    "open": "1,5505",
    "highest": "1,5542",
    "lower": "1,5372",
    "difference": "-0,48%"
  },
  {
    "date": "24.03.2010",
    "now": "1,5522",
    "open": "1,5372",
    "highest": "1,5539",
    "lower": "1,5280",
    "difference": "0,98%"
  },
  {
    "date": "23.03.2010",
    "now": "1,5372",
    "open": "1,5350",
    "highest": "1,5488",
    "lower": "1,5293",
    "difference": "-0,09%"
  },
  {
    "date": "22.03.2010",
    "now": "1,5386",
    "open": "1,5316",
    "highest": "1,5529",
    "lower": "1,5304",
    "difference": "0,14%"
  },
  {
    "date": "19.03.2010",
    "now": "1,5364",
    "open": "1,5229",
    "highest": "1,5385",
    "lower": "1,5216",
    "difference": "0,64%"
  },
  {
    "date": "18.03.2010",
    "now": "1,5266",
    "open": "1,5132",
    "highest": "1,5333",
    "lower": "1,5080",
    "difference": "0,91%"
  },
  {
    "date": "17.03.2010",
    "now": "1,5128",
    "open": "1,5168",
    "highest": "1,5212",
    "lower": "1,5085",
    "difference": "-0,55%"
  },
  {
    "date": "16.03.2010",
    "now": "1,5211",
    "open": "1,5326",
    "highest": "1,5352",
    "lower": "1,5211",
    "difference": "-0,46%"
  },
  {
    "date": "15.03.2010",
    "now": "1,5282",
    "open": "1,5255",
    "highest": "1,5326",
    "lower": "1,5206",
    "difference": "-0,04%"
  },
  {
    "date": "12.03.2010",
    "now": "1,5288",
    "open": "1,5284",
    "highest": "1,5335",
    "lower": "1,5207",
    "difference": "-0,25%"
  },
  {
    "date": "11.03.2010",
    "now": "1,5326",
    "open": "1,5328",
    "highest": "1,5427",
    "lower": "1,5326",
    "difference": "-0,05%"
  },
  {
    "date": "10.03.2010",
    "now": "1,5333",
    "open": "1,5359",
    "highest": "1,5453",
    "lower": "1,5277",
    "difference": "-0,06%"
  },
  {
    "date": "09.03.2010",
    "now": "1,5342",
    "open": "1,5323",
    "highest": "1,5446",
    "lower": "1,5279",
    "difference": "0,13%"
  },
  {
    "date": "08.03.2010",
    "now": "1,5322",
    "open": "1,5333",
    "highest": "1,5431",
    "lower": "1,5206",
    "difference": "-0,39%"
  },
  {
    "date": "05.03.2010",
    "now": "1,5382",
    "open": "1,5512",
    "highest": "1,5575",
    "lower": "1,5379",
    "difference": "-0,92%"
  },
  {
    "date": "04.03.2010",
    "now": "1,5525",
    "open": "1,5350",
    "highest": "1,5550",
    "lower": "1,5327",
    "difference": "0,94%"
  },
  {
    "date": "03.03.2010",
    "now": "1,5381",
    "open": "1,5322",
    "highest": "1,5440",
    "lower": "1,5290",
    "difference": "0,22%"
  },
  {
    "date": "02.03.2010",
    "now": "1,5347",
    "open": "1,5313",
    "highest": "1,5438",
    "lower": "1,5274",
    "difference": "-0,11%"
  },
  {
    "date": "01.03.2010",
    "now": "1,5364",
    "open": "1,5469",
    "highest": "1,5505",
    "lower": "1,5347",
    "difference": "-0,67%"
  },
  {
    "date": "26.02.2010",
    "now": "1,5467",
    "open": "1,5479",
    "highest": "1,5560",
    "lower": "1,5352",
    "difference": "-0,08%"
  },
  {
    "date": "25.02.2010",
    "now": "1,5479",
    "open": "1,5413",
    "highest": "1,5649",
    "lower": "1,5378",
    "difference": "0,34%"
  },
  {
    "date": "24.02.2010",
    "now": "1,5427",
    "open": "1,5516",
    "highest": "1,5581",
    "lower": "1,5366",
    "difference": "-0,57%"
  },
  {
    "date": "23.02.2010",
    "now": "1,5516",
    "open": "1,5299",
    "highest": "1,5529",
    "lower": "1,5139",
    "difference": "1,39%"
  },
  {
    "date": "22.02.2010",
    "now": "1,5303",
    "open": "1,5074",
    "highest": "1,5317",
    "lower": "1,5050",
    "difference": "1,16%"
  },
  {
    "date": "19.02.2010",
    "now": "1,5128",
    "open": "1,5222",
    "highest": "1,5354",
    "lower": "1,5128",
    "difference": "-0,28%"
  },
  {
    "date": "18.02.2010",
    "now": "1,5170",
    "open": "1,5129",
    "highest": "1,5240",
    "lower": "1,5067",
    "difference": "0,29%"
  },
  {
    "date": "17.02.2010",
    "now": "1,5126",
    "open": "1,5057",
    "highest": "1,5139",
    "lower": "1,4955",
    "difference": "0,44%"
  },
  {
    "date": "16.02.2010",
    "now": "1,5059",
    "open": "1,5166",
    "highest": "1,5166",
    "lower": "1,5005",
    "difference": "-0,71%"
  },
  {
    "date": "15.02.2010",
    "now": "1,5166",
    "open": "1,5089",
    "highest": "1,5188",
    "lower": "1,5089",
    "difference": "-0,12%"
  },
  {
    "date": "12.02.2010",
    "now": "1,5184",
    "open": "1,5123",
    "highest": "1,5291",
    "lower": "1,5102",
    "difference": "0,42%"
  },
  {
    "date": "11.02.2010",
    "now": "1,5121",
    "open": "1,5165",
    "highest": "1,5257",
    "lower": "1,5067",
    "difference": "-0,30%"
  },
  {
    "date": "10.02.2010",
    "now": "1,5167",
    "open": "1,5052",
    "highest": "1,5203",
    "lower": "1,5007",
    "difference": "0,50%"
  },
  {
    "date": "09.02.2010",
    "now": "1,5092",
    "open": "1,5216",
    "highest": "1,5216",
    "lower": "1,5042",
    "difference": "-0,93%"
  },
  {
    "date": "08.02.2010",
    "now": "1,5233",
    "open": "1,5252",
    "highest": "1,5283",
    "lower": "1,5108",
    "difference": "-0,37%"
  },
  {
    "date": "05.02.2010",
    "now": "1,5289",
    "open": "1,5206",
    "highest": "1,5383",
    "lower": "1,5061",
    "difference": "0,80%"
  },
  {
    "date": "04.02.2010",
    "now": "1,5168",
    "open": "1,4932",
    "highest": "1,5169",
    "lower": "1,4887",
    "difference": "1,52%"
  },
  {
    "date": "03.02.2010",
    "now": "1,4941",
    "open": "1,4871",
    "highest": "1,4951",
    "lower": "1,4705",
    "difference": "0,42%"
  },
  {
    "date": "02.02.2010",
    "now": "1,4878",
    "open": "1,4826",
    "highest": "1,4927",
    "lower": "1,4759",
    "difference": "0,45%"
  },
  {
    "date": "01.02.2010",
    "now": "1,4812",
    "open": "1,4930",
    "highest": "1,4950",
    "lower": "1,4803",
    "difference": "-1,06%"
  },
  {
    "date": "29.01.2010",
    "now": "1,4970",
    "open": "1,4917",
    "highest": "1,4993",
    "lower": "1,4797",
    "difference": "-0,08%"
  },
  {
    "date": "28.01.2010",
    "now": "1,4982",
    "open": "1,5004",
    "highest": "1,5054",
    "lower": "1,4902",
    "difference": "-0,19%"
  },
  {
    "date": "27.01.2010",
    "now": "1,5011",
    "open": "1,4924",
    "highest": "1,5078",
    "lower": "1,4892",
    "difference": "0,68%"
  },
  {
    "date": "26.01.2010",
    "now": "1,4909",
    "open": "1,4862",
    "highest": "1,5088",
    "lower": "1,4862",
    "difference": "0,30%"
  },
  {
    "date": "25.01.2010",
    "now": "1,4864",
    "open": "1,4909",
    "highest": "1,4968",
    "lower": "1,4812",
    "difference": "-0,21%"
  },
  {
    "date": "22.01.2010",
    "now": "1,4895",
    "open": "1,4882",
    "highest": "1,5031",
    "lower": "1,4760",
    "difference": "0,19%"
  },
  {
    "date": "21.01.2010",
    "now": "1,4867",
    "open": "1,4745",
    "highest": "1,4894",
    "lower": "1,4659",
    "difference": "0,82%"
  },
  {
    "date": "20.01.2010",
    "now": "1,4746",
    "open": "1,4547",
    "highest": "1,4786",
    "lower": "1,4507",
    "difference": "1,27%"
  },
  {
    "date": "19.01.2010",
    "now": "1,4561",
    "open": "1,4470",
    "highest": "1,4647",
    "lower": "1,4457",
    "difference": "0,29%"
  },
  {
    "date": "18.01.2010",
    "now": "1,4519",
    "open": "1,4614",
    "highest": "1,4632",
    "lower": "1,4497",
    "difference": "-0,37%"
  },
  {
    "date": "15.01.2010",
    "now": "1,4573",
    "open": "1,4542",
    "highest": "1,4659",
    "lower": "1,4480",
    "difference": "0,07%"
  },
  {
    "date": "14.01.2010",
    "now": "1,4563",
    "open": "1,4568",
    "highest": "1,4697",
    "lower": "1,4492",
    "difference": "0,24%"
  },
  {
    "date": "13.01.2010",
    "now": "1,4528",
    "open": "1,4543",
    "highest": "1,4588",
    "lower": "1,4418",
    "difference": "-0,06%"
  },
  {
    "date": "12.01.2010",
    "now": "1,4537",
    "open": "1,4501",
    "highest": "1,4672",
    "lower": "1,4465",
    "difference": "0,21%"
  },
  {
    "date": "11.01.2010",
    "now": "1,4506",
    "open": "1,4558",
    "highest": "1,4621",
    "lower": "1,4443",
    "difference": "-0,62%"
  },
  {
    "date": "08.01.2010",
    "now": "1,4596",
    "open": "1,4724",
    "highest": "1,4745",
    "lower": "1,4556",
    "difference": "-0,86%"
  },
  {
    "date": "07.01.2010",
    "now": "1,4723",
    "open": "1,4722",
    "highest": "1,4837",
    "lower": "1,4657",
    "difference": "-0,07%"
  },
  {
    "date": "06.01.2010",
    "now": "1,4734",
    "open": "1,4738",
    "highest": "1,4825",
    "lower": "1,4662",
    "difference": "0,03%"
  },
  {
    "date": "05.01.2010",
    "now": "1,4729",
    "open": "1,4741",
    "highest": "1,4792",
    "lower": "1,4607",
    "difference": "-0,07%"
  },
  {
    "date": "04.01.2010",
    "now": "1,4739",
    "open": "1,4930",
    "highest": "1,4987",
    "lower": "1,4680",
    "difference": "-1,65%"
  },
  {
    "date": "01.01.2010",
    "now": "1,4986",
    "open": "1,4965",
    "highest": "1,4996",
    "lower": "1,4951",
    "difference": "-0,11%"
  },
  {
    "date": "31.12.2009",
    "now": "1,5002",
    "open": "1,5117",
    "highest": "1,5151",
    "lower": "1,4902",
    "difference": "-0,70%"
  },
  {
    "date": "30.12.2009",
    "now": "1,5108",
    "open": "1,5120",
    "highest": "1,5212",
    "lower": "1,5092",
    "difference": "-0,02%"
  },
  {
    "date": "29.12.2009",
    "now": "1,5111",
    "open": "1,5164",
    "highest": "1,5181",
    "lower": "1,5072",
    "difference": "-0,05%"
  },
  {
    "date": "28.12.2009",
    "now": "1,5119",
    "open": "1,5226",
    "highest": "1,5226",
    "lower": "1,5082",
    "difference": "-0,02%"
  },
  {
    "date": "25.12.2009",
    "now": "1,5122",
    "open": "1,5157",
    "highest": "1,5191",
    "lower": "1,5063",
    "difference": "-0,17%"
  },
  {
    "date": "24.12.2009",
    "now": "1,5147",
    "open": "1,5177",
    "highest": "1,5227",
    "lower": "1,5067",
    "difference": "-0,40%"
  },
  {
    "date": "23.12.2009",
    "now": "1,5208",
    "open": "1,5258",
    "highest": "1,5357",
    "lower": "1,5202",
    "difference": "-0,32%"
  },
  {
    "date": "22.12.2009",
    "now": "1,5257",
    "open": "1,5295",
    "highest": "1,5340",
    "lower": "1,5202",
    "difference": "-0,09%"
  },
  {
    "date": "21.12.2009",
    "now": "1,5271",
    "open": "1,5200",
    "highest": "1,5281",
    "lower": "1,5153",
    "difference": "0,37%"
  },
  {
    "date": "18.12.2009",
    "now": "1,5215",
    "open": "1,5153",
    "highest": "1,5260",
    "lower": "1,5085",
    "difference": "-0,06%"
  },
  {
    "date": "17.12.2009",
    "now": "1,5224",
    "open": "1,5120",
    "highest": "1,5333",
    "lower": "1,5087",
    "difference": "0,93%"
  },
  {
    "date": "16.12.2009",
    "now": "1,5084",
    "open": "1,5106",
    "highest": "1,5166",
    "lower": "1,5009",
    "difference": "-0,09%"
  },
  {
    "date": "15.12.2009",
    "now": "1,5097",
    "open": "1,4995",
    "highest": "1,5164",
    "lower": "1,4957",
    "difference": "0,63%"
  },
  {
    "date": "14.12.2009",
    "now": "1,5002",
    "open": "1,5067",
    "highest": "1,5076",
    "lower": "1,4956",
    "difference": "-0,58%"
  },
  {
    "date": "11.12.2009",
    "now": "1,5089",
    "open": "1,5000",
    "highest": "1,5186",
    "lower": "1,4942",
    "difference": "0,51%"
  },
  {
    "date": "10.12.2009",
    "now": "1,5012",
    "open": "1,5075",
    "highest": "1,5141",
    "lower": "1,4952",
    "difference": "-0,46%"
  },
  {
    "date": "09.12.2009",
    "now": "1,5082",
    "open": "1,5119",
    "highest": "1,5186",
    "lower": "1,4982",
    "difference": "0,01%"
  },
  {
    "date": "08.12.2009",
    "now": "1,5080",
    "open": "1,4886",
    "highest": "1,5112",
    "lower": "1,4831",
    "difference": "1,26%"
  },
  {
    "date": "07.12.2009",
    "now": "1,4892",
    "open": "1,4865",
    "highest": "1,5003",
    "lower": "1,4820",
    "difference": "-0,07%"
  },
  {
    "date": "04.12.2009",
    "now": "1,4902",
    "open": "1,4872",
    "highest": "1,4931",
    "lower": "1,4724",
    "difference": "0,23%"
  },
  {
    "date": "03.12.2009",
    "now": "1,4868",
    "open": "1,4982",
    "highest": "1,5002",
    "lower": "1,4782",
    "difference": "-0,91%"
  },
  {
    "date": "02.12.2009",
    "now": "1,5005",
    "open": "1,5027",
    "highest": "1,5036",
    "lower": "1,4895",
    "difference": "-0,15%"
  },
  {
    "date": "01.12.2009",
    "now": "1,5027",
    "open": "1,5285",
    "highest": "1,5290",
    "lower": "1,4981",
    "difference": "-1,67%"
  },
  {
    "date": "30.11.2009",
    "now": "1,5282",
    "open": "1,5195",
    "highest": "1,5353",
    "lower": "1,5088",
    "difference": "0,30%"
  },
  {
    "date": "27.11.2009",
    "now": "1,5237",
    "open": "1,5326",
    "highest": "1,5602",
    "lower": "1,5169",
    "difference": "-0,33%"
  },
  {
    "date": "26.11.2009",
    "now": "1,5287",
    "open": "1,4883",
    "highest": "1,5379",
    "lower": "1,4883",
    "difference": "2,71%"
  },
  {
    "date": "25.11.2009",
    "now": "1,4884",
    "open": "1,4973",
    "highest": "1,4976",
    "lower": "1,4792",
    "difference": "-0,57%"
  },
  {
    "date": "24.11.2009",
    "now": "1,4969",
    "open": "1,4982",
    "highest": "1,5035",
    "lower": "1,4910",
    "difference": "-0,13%"
  },
  {
    "date": "23.11.2009",
    "now": "1,4988",
    "open": "1,4953",
    "highest": "1,5008",
    "lower": "1,4863",
    "difference": "0,05%"
  },
  {
    "date": "20.11.2009",
    "now": "1,4980",
    "open": "1,4930",
    "highest": "1,5027",
    "lower": "1,4870",
    "difference": "0,31%"
  },
  {
    "date": "19.11.2009",
    "now": "1,4933",
    "open": "1,4798",
    "highest": "1,4943",
    "lower": "1,4760",
    "difference": "0,87%"
  },
  {
    "date": "18.11.2009",
    "now": "1,4804",
    "open": "1,4808",
    "highest": "1,4829",
    "lower": "1,4705",
    "difference": "-0,02%"
  },
  {
    "date": "17.11.2009",
    "now": "1,4807",
    "open": "1,4757",
    "highest": "1,4866",
    "lower": "1,4698",
    "difference": "0,42%"
  },
  {
    "date": "16.11.2009",
    "now": "1,4745",
    "open": "1,4732",
    "highest": "1,4823",
    "lower": "1,4690",
    "difference": "-0,25%"
  },
  {
    "date": "13.11.2009",
    "now": "1,4782",
    "open": "1,4845",
    "highest": "1,4867",
    "lower": "1,4708",
    "difference": "-0,45%"
  },
  {
    "date": "12.11.2009",
    "now": "1,4849",
    "open": "1,4751",
    "highest": "1,4861",
    "lower": "1,4682",
    "difference": "0,77%"
  },
  {
    "date": "11.11.2009",
    "now": "1,4735",
    "open": "1,4762",
    "highest": "1,4776",
    "lower": "1,4655",
    "difference": "-0,14%"
  },
  {
    "date": "10.11.2009",
    "now": "1,4755",
    "open": "1,4730",
    "highest": "1,4805",
    "lower": "1,4675",
    "difference": "0,14%"
  },
  {
    "date": "09.11.2009",
    "now": "1,4734",
    "open": "1,4800",
    "highest": "1,4844",
    "lower": "1,4658",
    "difference": "-0,78%"
  },
  {
    "date": "06.11.2009",
    "now": "1,4850",
    "open": "1,4853",
    "highest": "1,4881",
    "lower": "1,4765",
    "difference": "-0,03%"
  },
  {
    "date": "05.11.2009",
    "now": "1,4855",
    "open": "1,4921",
    "highest": "1,4972",
    "lower": "1,4805",
    "difference": "-0,41%"
  },
  {
    "date": "04.11.2009",
    "now": "1,4916",
    "open": "1,5027",
    "highest": "1,5039",
    "lower": "1,4860",
    "difference": "-0,84%"
  },
  {
    "date": "03.11.2009",
    "now": "1,5042",
    "open": "1,5037",
    "highest": "1,5162",
    "lower": "1,4983",
    "difference": "0,01%"
  },
  {
    "date": "02.11.2009",
    "now": "1,5040",
    "open": "1,5003",
    "highest": "1,5127",
    "lower": "1,4920",
    "difference": "-0,16%"
  },
  {
    "date": "30.10.2009",
    "now": "1,5064",
    "open": "1,4890",
    "highest": "1,5091",
    "lower": "1,4810",
    "difference": "1,13%"
  },
  {
    "date": "29.10.2009",
    "now": "1,4895",
    "open": "1,5095",
    "highest": "1,5110",
    "lower": "1,4870",
    "difference": "-1,28%"
  },
  {
    "date": "28.10.2009",
    "now": "1,5088",
    "open": "1,4990",
    "highest": "1,5147",
    "lower": "1,4929",
    "difference": "0,96%"
  },
  {
    "date": "27.10.2009",
    "now": "1,4944",
    "open": "1,4883",
    "highest": "1,4996",
    "lower": "1,4806",
    "difference": "0,26%"
  },
  {
    "date": "26.10.2009",
    "now": "1,4905",
    "open": "1,4648",
    "highest": "1,4941",
    "lower": "1,4634",
    "difference": "1,26%"
  },
  {
    "date": "23.10.2009",
    "now": "1,4720",
    "open": "1,4646",
    "highest": "1,4725",
    "lower": "1,4545",
    "difference": "0,50%"
  },
  {
    "date": "22.10.2009",
    "now": "1,4647",
    "open": "1,4648",
    "highest": "1,4756",
    "lower": "1,4601",
    "difference": "0,03%"
  },
  {
    "date": "21.10.2009",
    "now": "1,4642",
    "open": "1,4612",
    "highest": "1,4702",
    "lower": "1,4507",
    "difference": "-0,06%"
  },
  {
    "date": "20.10.2009",
    "now": "1,4651",
    "open": "1,4534",
    "highest": "1,4717",
    "lower": "1,4466",
    "difference": "0,87%"
  },
  {
    "date": "19.10.2009",
    "now": "1,4525",
    "open": "1,4563",
    "highest": "1,4632",
    "lower": "1,4480",
    "difference": "-0,60%"
  },
  {
    "date": "16.10.2009",
    "now": "1,4612",
    "open": "1,4483",
    "highest": "1,4710",
    "lower": "1,4465",
    "difference": "1,16%"
  },
  {
    "date": "15.10.2009",
    "now": "1,4445",
    "open": "1,4393",
    "highest": "1,4499",
    "lower": "1,4339",
    "difference": "0,03%"
  },
  {
    "date": "14.10.2009",
    "now": "1,4440",
    "open": "1,4553",
    "highest": "1,4574",
    "lower": "1,4359",
    "difference": "-0,74%"
  },
  {
    "date": "13.10.2009",
    "now": "1,4548",
    "open": "1,4570",
    "highest": "1,4627",
    "lower": "1,4505",
    "difference": "-0,18%"
  },
  {
    "date": "12.10.2009",
    "now": "1,4574",
    "open": "1,4601",
    "highest": "1,4700",
    "lower": "1,4532",
    "difference": "-0,57%"
  },
  {
    "date": "09.10.2009",
    "now": "1,4657",
    "open": "1,4607",
    "highest": "1,4760",
    "lower": "1,4607",
    "difference": "0,43%"
  },
  {
    "date": "08.10.2009",
    "now": "1,4594",
    "open": "1,4666",
    "highest": "1,4680",
    "lower": "1,4516",
    "difference": "-0,73%"
  },
  {
    "date": "07.10.2009",
    "now": "1,4701",
    "open": "1,4674",
    "highest": "1,4775",
    "lower": "1,4593",
    "difference": "0,04%"
  },
  {
    "date": "06.10.2009",
    "now": "1,4695",
    "open": "1,4805",
    "highest": "1,4806",
    "lower": "1,4582",
    "difference": "-0,78%"
  },
  {
    "date": "05.10.2009",
    "now": "1,4810",
    "open": "1,4912",
    "highest": "1,4966",
    "lower": "1,4772",
    "difference": "-0,82%"
  },
  {
    "date": "02.10.2009",
    "now": "1,4932",
    "open": "1,5027",
    "highest": "1,5122",
    "lower": "1,4912",
    "difference": "-0,43%"
  },
  {
    "date": "01.10.2009",
    "now": "1,4996",
    "open": "1,4845",
    "highest": "1,5035",
    "lower": "1,4789",
    "difference": "1,06%"
  },
  {
    "date": "30.09.2009",
    "now": "1,4839",
    "open": "1,4882",
    "highest": "1,4942",
    "lower": "1,4762",
    "difference": "-0,57%"
  },
  {
    "date": "29.09.2009",
    "now": "1,4924",
    "open": "1,4923",
    "highest": "1,4946",
    "lower": "1,4811",
    "difference": "0,03%"
  },
  {
    "date": "28.09.2009",
    "now": "1,4919",
    "open": "1,4803",
    "highest": "1,4983",
    "lower": "1,4803",
    "difference": "0,35%"
  },
  {
    "date": "25.09.2009",
    "now": "1,4867",
    "open": "1,4871",
    "highest": "1,4970",
    "lower": "1,4837",
    "difference": "-0,11%"
  },
  {
    "date": "24.09.2009",
    "now": "1,4884",
    "open": "1,4869",
    "highest": "1,4942",
    "lower": "1,4762",
    "difference": "0,35%"
  },
  {
    "date": "23.09.2009",
    "now": "1,4832",
    "open": "1,4774",
    "highest": "1,4883",
    "lower": "1,4716",
    "difference": "0,39%"
  },
  {
    "date": "22.09.2009",
    "now": "1,4775",
    "open": "1,4900",
    "highest": "1,4900",
    "lower": "1,4726",
    "difference": "-0,93%"
  },
  {
    "date": "21.09.2009",
    "now": "1,4914",
    "open": "1,4811",
    "highest": "1,4977",
    "lower": "1,4801",
    "difference": "0,68%"
  },
  {
    "date": "18.09.2009",
    "now": "1,4814",
    "open": "1,4721",
    "highest": "1,4825",
    "lower": "1,4663",
    "difference": "0,71%"
  },
  {
    "date": "17.09.2009",
    "now": "1,4710",
    "open": "1,4691",
    "highest": "1,4778",
    "lower": "1,4595",
    "difference": "0,05%"
  },
  {
    "date": "16.09.2009",
    "now": "1,4703",
    "open": "1,4776",
    "highest": "1,4856",
    "lower": "1,4659",
    "difference": "-0,47%"
  },
  {
    "date": "15.09.2009",
    "now": "1,4773",
    "open": "1,4963",
    "highest": "1,4991",
    "lower": "1,4738",
    "difference": "-1,10%"
  },
  {
    "date": "14.09.2009",
    "now": "1,4938",
    "open": "1,4922",
    "highest": "1,5070",
    "lower": "1,4909",
    "difference": "0,09%"
  },
  {
    "date": "11.09.2009",
    "now": "1,4925",
    "open": "1,4962",
    "highest": "1,5020",
    "lower": "1,4885",
    "difference": "-0,29%"
  },
  {
    "date": "10.09.2009",
    "now": "1,4969",
    "open": "1,4990",
    "highest": "1,5104",
    "lower": "1,4910",
    "difference": "-0,19%"
  },
  {
    "date": "09.09.2009",
    "now": "1,4998",
    "open": "1,4864",
    "highest": "1,5025",
    "lower": "1,4825",
    "difference": "0,95%"
  },
  {
    "date": "08.09.2009",
    "now": "1,4857",
    "open": "1,4882",
    "highest": "1,4905",
    "lower": "1,4785",
    "difference": "-0,19%"
  },
  {
    "date": "07.09.2009",
    "now": "1,4885",
    "open": "1,4894",
    "highest": "1,4928",
    "lower": "1,4845",
    "difference": "-0,20%"
  },
  {
    "date": "04.09.2009",
    "now": "1,4915",
    "open": "1,5046",
    "highest": "1,5097",
    "lower": "1,4893",
    "difference": "-0,88%"
  },
  {
    "date": "03.09.2009",
    "now": "1,5048",
    "open": "1,5091",
    "highest": "1,5132",
    "lower": "1,4992",
    "difference": "-0,43%"
  },
  {
    "date": "02.09.2009",
    "now": "1,5113",
    "open": "1,5186",
    "highest": "1,5221",
    "lower": "1,5082",
    "difference": "-0,42%"
  },
  {
    "date": "01.09.2009",
    "now": "1,5177",
    "open": "1,5007",
    "highest": "1,5220",
    "lower": "1,4932",
    "difference": "1,15%"
  },
  {
    "date": "31.08.2009",
    "now": "1,5004",
    "open": "1,4941",
    "highest": "1,5071",
    "lower": "1,4941",
    "difference": "0,09%"
  },
  {
    "date": "28.08.2009",
    "now": "1,4990",
    "open": "1,4991",
    "highest": "1,5065",
    "lower": "1,4906",
    "difference": "-0,05%"
  },
  {
    "date": "27.08.2009",
    "now": "1,4997",
    "open": "1,5038",
    "highest": "1,5111",
    "lower": "1,4950",
    "difference": "-0,56%"
  },
  {
    "date": "26.08.2009",
    "now": "1,5082",
    "open": "1,4924",
    "highest": "1,5122",
    "lower": "1,4877",
    "difference": "1,06%"
  },
  {
    "date": "25.08.2009",
    "now": "1,4924",
    "open": "1,4975",
    "highest": "1,5002",
    "lower": "1,4810",
    "difference": "-0,33%"
  },
  {
    "date": "24.08.2009",
    "now": "1,4974",
    "open": "1,4830",
    "highest": "1,4976",
    "lower": "1,4756",
    "difference": "0,83%"
  },
  {
    "date": "21.08.2009",
    "now": "1,4851",
    "open": "1,4911",
    "highest": "1,4981",
    "lower": "1,4756",
    "difference": "-0,49%"
  },
  {
    "date": "20.08.2009",
    "now": "1,4924",
    "open": "1,4990",
    "highest": "1,4994",
    "lower": "1,4853",
    "difference": "-0,37%"
  },
  {
    "date": "19.08.2009",
    "now": "1,4979",
    "open": "1,4966",
    "highest": "1,5099",
    "lower": "1,4912",
    "difference": "0,26%"
  },
  {
    "date": "18.08.2009",
    "now": "1,4940",
    "open": "1,5073",
    "highest": "1,5077",
    "lower": "1,4902",
    "difference": "-0,86%"
  },
  {
    "date": "17.08.2009",
    "now": "1,5070",
    "open": "1,4894",
    "highest": "1,5133",
    "lower": "1,4894",
    "difference": "1,09%"
  },
  {
    "date": "14.08.2009",
    "now": "1,4908",
    "open": "1,4777",
    "highest": "1,4978",
    "lower": "1,4757",
    "difference": "0,88%"
  },
  {
    "date": "13.08.2009",
    "now": "1,4778",
    "open": "1,4945",
    "highest": "1,4945",
    "lower": "1,4700",
    "difference": "-1,06%"
  },
  {
    "date": "12.08.2009",
    "now": "1,4937",
    "open": "1,5004",
    "highest": "1,5197",
    "lower": "1,4893",
    "difference": "-0,48%"
  },
  {
    "date": "11.08.2009",
    "now": "1,5009",
    "open": "1,4814",
    "highest": "1,5092",
    "lower": "1,4792",
    "difference": "1,27%"
  },
  {
    "date": "10.08.2009",
    "now": "1,4821",
    "open": "1,4661",
    "highest": "1,4886",
    "lower": "1,4619",
    "difference": "1,24%"
  },
  {
    "date": "07.08.2009",
    "now": "1,4639",
    "open": "1,4781",
    "highest": "1,4852",
    "lower": "1,4595",
    "difference": "-0,99%"
  },
  {
    "date": "06.08.2009",
    "now": "1,4785",
    "open": "1,4646",
    "highest": "1,4827",
    "lower": "1,4585",
    "difference": "0,94%"
  },
  {
    "date": "05.08.2009",
    "now": "1,4647",
    "open": "1,4607",
    "highest": "1,4742",
    "lower": "1,4505",
    "difference": "0,23%"
  },
  {
    "date": "04.08.2009",
    "now": "1,4613",
    "open": "1,4537",
    "highest": "1,4695",
    "lower": "1,4495",
    "difference": "0,49%"
  },
  {
    "date": "03.08.2009",
    "now": "1,4542",
    "open": "1,4729",
    "highest": "1,4774",
    "lower": "1,4510",
    "difference": "-1,15%"
  },
  {
    "date": "31.07.2009",
    "now": "1,4711",
    "open": "1,4775",
    "highest": "1,4834",
    "lower": "1,4692",
    "difference": "-0,45%"
  },
  {
    "date": "30.07.2009",
    "now": "1,4777",
    "open": "1,4967",
    "highest": "1,4987",
    "lower": "1,4727",
    "difference": "-1,44%"
  },
  {
    "date": "29.07.2009",
    "now": "1,4993",
    "open": "1,4788",
    "highest": "1,5027",
    "lower": "1,4770",
    "difference": "1,31%"
  },
  {
    "date": "28.07.2009",
    "now": "1,4799",
    "open": "1,4752",
    "highest": "1,4849",
    "lower": "1,4635",
    "difference": "0,28%"
  },
  {
    "date": "27.07.2009",
    "now": "1,4757",
    "open": "1,4827",
    "highest": "1,4858",
    "lower": "1,4712",
    "difference": "-0,19%"
  },
  {
    "date": "24.07.2009",
    "now": "1,4785",
    "open": "1,4877",
    "highest": "1,4933",
    "lower": "1,4755",
    "difference": "-0,51%"
  },
  {
    "date": "23.07.2009",
    "now": "1,4861",
    "open": "1,4905",
    "highest": "1,4955",
    "lower": "1,4760",
    "difference": "-0,20%"
  },
  {
    "date": "22.07.2009",
    "now": "1,4891",
    "open": "1,5071",
    "highest": "1,5105",
    "lower": "1,4840",
    "difference": "-1,24%"
  },
  {
    "date": "21.07.2009",
    "now": "1,5078",
    "open": "1,5055",
    "highest": "1,5144",
    "lower": "1,4942",
    "difference": "0,17%"
  },
  {
    "date": "20.07.2009",
    "now": "1,5052",
    "open": "1,5252",
    "highest": "1,5267",
    "lower": "1,5017",
    "difference": "-1,32%"
  },
  {
    "date": "17.07.2009",
    "now": "1,5253",
    "open": "1,5242",
    "highest": "1,5326",
    "lower": "1,5182",
    "difference": "0,01%"
  },
  {
    "date": "16.07.2009",
    "now": "1,5252",
    "open": "1,5284",
    "highest": "1,5351",
    "lower": "1,5182",
    "difference": "-0,22%"
  },
  {
    "date": "15.07.2009",
    "now": "1,5286",
    "open": "1,5442",
    "highest": "1,5459",
    "lower": "1,5251",
    "difference": "-0,95%"
  },
  {
    "date": "14.07.2009",
    "now": "1,5432",
    "open": "1,5437",
    "highest": "1,5510",
    "lower": "1,5347",
    "difference": "-0,07%"
  },
  {
    "date": "13.07.2009",
    "now": "1,5443",
    "open": "1,5513",
    "highest": "1,5633",
    "lower": "1,5434",
    "difference": "-0,43%"
  },
  {
    "date": "10.07.2009",
    "now": "1,5509",
    "open": "1,5418",
    "highest": "1,5583",
    "lower": "1,5400",
    "difference": "0,47%"
  },
  {
    "date": "09.07.2009",
    "now": "1,5437",
    "open": "1,5631",
    "highest": "1,5631",
    "lower": "1,5382",
    "difference": "-1,24%"
  },
  {
    "date": "08.07.2009",
    "now": "1,5631",
    "open": "1,5500",
    "highest": "1,5704",
    "lower": "1,5471",
    "difference": "0,85%"
  },
  {
    "date": "07.07.2009",
    "now": "1,5499",
    "open": "1,5436",
    "highest": "1,5499",
    "lower": "1,5332",
    "difference": "0,37%"
  },
  {
    "date": "06.07.2009",
    "now": "1,5442",
    "open": "1,5349",
    "highest": "1,5560",
    "lower": "1,5345",
    "difference": "0,51%"
  },
  {
    "date": "03.07.2009",
    "now": "1,5363",
    "open": "1,5413",
    "highest": "1,5413",
    "lower": "1,5272",
    "difference": "-0,07%"
  },
  {
    "date": "02.07.2009",
    "now": "1,5374",
    "open": "1,5248",
    "highest": "1,5414",
    "lower": "1,5226",
    "difference": "0,88%"
  },
  {
    "date": "01.07.2009",
    "now": "1,5240",
    "open": "1,5412",
    "highest": "1,5442",
    "lower": "1,5198",
    "difference": "-1,14%"
  },
  {
    "date": "30.06.2009",
    "now": "1,5415",
    "open": "1,5410",
    "highest": "1,5430",
    "lower": "1,5243",
    "difference": "0,08%"
  },
  {
    "date": "29.06.2009",
    "now": "1,5403",
    "open": "1,5370",
    "highest": "1,5515",
    "lower": "1,5305",
    "difference": "0,41%"
  },
  {
    "date": "26.06.2009",
    "now": "1,5340",
    "open": "1,5484",
    "highest": "1,5550",
    "lower": "1,5305",
    "difference": "-0,96%"
  },
  {
    "date": "25.06.2009",
    "now": "1,5489",
    "open": "1,5560",
    "highest": "1,5615",
    "lower": "1,5445",
    "difference": "-0,49%"
  },
  {
    "date": "24.06.2009",
    "now": "1,5565",
    "open": "1,5650",
    "highest": "1,5690",
    "lower": "1,5435",
    "difference": "-0,62%"
  },
  {
    "date": "23.06.2009",
    "now": "1,5662",
    "open": "1,5816",
    "highest": "1,5893",
    "lower": "1,5587",
    "difference": "-0,87%"
  },
  {
    "date": "22.06.2009",
    "now": "1,5799",
    "open": "1,5583",
    "highest": "1,5807",
    "lower": "1,5455",
    "difference": "1,84%"
  },
  {
    "date": "19.06.2009",
    "now": "1,5514",
    "open": "1,5527",
    "highest": "1,5605",
    "lower": "1,5415",
    "difference": "-0,06%"
  },
  {
    "date": "18.06.2009",
    "now": "1,5523",
    "open": "1,5591",
    "highest": "1,5705",
    "lower": "1,5456",
    "difference": "-0,47%"
  },
  {
    "date": "17.06.2009",
    "now": "1,5597",
    "open": "1,5530",
    "highest": "1,5687",
    "lower": "1,5435",
    "difference": "0,58%"
  },
  {
    "date": "16.06.2009",
    "now": "1,5507",
    "open": "1,5482",
    "highest": "1,5528",
    "lower": "1,5355",
    "difference": "0,08%"
  },
  {
    "date": "15.06.2009",
    "now": "1,5495",
    "open": "1,5360",
    "highest": "1,5534",
    "lower": "1,5272",
    "difference": "1,12%"
  },
  {
    "date": "12.06.2009",
    "now": "1,5323",
    "open": "1,5305",
    "highest": "1,5430",
    "lower": "1,5255",
    "difference": "-0,05%"
  },
  {
    "date": "11.06.2009",
    "now": "1,5330",
    "open": "1,5521",
    "highest": "1,5521",
    "lower": "1,5293",
    "difference": "-1,27%"
  },
  {
    "date": "10.06.2009",
    "now": "1,5527",
    "open": "1,5467",
    "highest": "1,5560",
    "lower": "1,5315",
    "difference": "0,36%"
  },
  {
    "date": "09.06.2009",
    "now": "1,5471",
    "open": "1,5553",
    "highest": "1,5620",
    "lower": "1,5413",
    "difference": "-0,62%"
  },
  {
    "date": "08.06.2009",
    "now": "1,5567",
    "open": "1,5393",
    "highest": "1,5674",
    "lower": "1,5345",
    "difference": "1,24%"
  },
  {
    "date": "05.06.2009",
    "now": "1,5377",
    "open": "1,5360",
    "highest": "1,5465",
    "lower": "1,5204",
    "difference": "0,10%"
  },
  {
    "date": "04.06.2009",
    "now": "1,5361",
    "open": "1,5488",
    "highest": "1,5496",
    "lower": "1,5332",
    "difference": "-0,83%"
  },
  {
    "date": "03.06.2009",
    "now": "1,5490",
    "open": "1,5202",
    "highest": "1,5494",
    "lower": "1,5153",
    "difference": "1,79%"
  },
  {
    "date": "02.06.2009",
    "now": "1,5217",
    "open": "1,5214",
    "highest": "1,5408",
    "lower": "1,5171",
    "difference": "-0,11%"
  },
  {
    "date": "01.06.2009",
    "now": "1,5233",
    "open": "1,5302",
    "highest": "1,5355",
    "lower": "1,5142",
    "difference": "-0,80%"
  },
  {
    "date": "29.05.2009",
    "now": "1,5356",
    "open": "1,5652",
    "highest": "1,5688",
    "lower": "1,5288",
    "difference": "-2,00%"
  },
  {
    "date": "28.05.2009",
    "now": "1,5670",
    "open": "1,5670",
    "highest": "1,5792",
    "lower": "1,5540",
    "difference": "0,04%"
  },
  {
    "date": "27.05.2009",
    "now": "1,5664",
    "open": "1,5570",
    "highest": "1,5750",
    "lower": "1,5517",
    "difference": "0,60%"
  },
  {
    "date": "26.05.2009",
    "now": "1,5570",
    "open": "1,5375",
    "highest": "1,5728",
    "lower": "1,5345",
    "difference": "1,25%"
  },
  {
    "date": "25.05.2009",
    "now": "1,5378",
    "open": "1,5439",
    "highest": "1,5501",
    "lower": "1,5350",
    "difference": "-0,56%"
  },
  {
    "date": "22.05.2009",
    "now": "1,5465",
    "open": "1,5360",
    "highest": "1,5538",
    "lower": "1,5220",
    "difference": "0,64%"
  },
  {
    "date": "21.05.2009",
    "now": "1,5367",
    "open": "1,5260",
    "highest": "1,5440",
    "lower": "1,5215",
    "difference": "0,75%"
  },
  {
    "date": "20.05.2009",
    "now": "1,5253",
    "open": "1,5330",
    "highest": "1,5413",
    "lower": "1,5185",
    "difference": "-0,47%"
  },
  {
    "date": "19.05.2009",
    "now": "1,5325",
    "open": "1,5443",
    "highest": "1,5470",
    "lower": "1,5257",
    "difference": "-0,49%"
  },
  {
    "date": "18.05.2009",
    "now": "1,5401",
    "open": "1,5706",
    "highest": "1,5781",
    "lower": "1,5379",
    "difference": "-1,85%"
  },
  {
    "date": "15.05.2009",
    "now": "1,5692",
    "open": "1,5640",
    "highest": "1,5753",
    "lower": "1,5549",
    "difference": "0,26%"
  },
  {
    "date": "14.05.2009",
    "now": "1,5651",
    "open": "1,5791",
    "highest": "1,5857",
    "lower": "1,5597",
    "difference": "-0,87%"
  },
  {
    "date": "13.05.2009",
    "now": "1,5789",
    "open": "1,5625",
    "highest": "1,5795",
    "lower": "1,5440",
    "difference": "1,15%"
  },
  {
    "date": "12.05.2009",
    "now": "1,5610",
    "open": "1,5650",
    "highest": "1,5738",
    "lower": "1,5525",
    "difference": "-0,38%"
  },
  {
    "date": "11.05.2009",
    "now": "1,5669",
    "open": "1,5406",
    "highest": "1,5707",
    "lower": "1,5358",
    "difference": "1,81%"
  },
  {
    "date": "08.05.2009",
    "now": "1,5390",
    "open": "1,5616",
    "highest": "1,5655",
    "lower": "1,5386",
    "difference": "-1,25%"
  },
  {
    "date": "07.05.2009",
    "now": "1,5585",
    "open": "1,5561",
    "highest": "1,5639",
    "lower": "1,5305",
    "difference": "0,03%"
  },
  {
    "date": "06.05.2009",
    "now": "1,5580",
    "open": "1,5657",
    "highest": "1,5763",
    "lower": "1,5530",
    "difference": "-0,57%"
  },
  {
    "date": "05.05.2009",
    "now": "1,5670",
    "open": "1,5606",
    "highest": "1,5750",
    "lower": "1,5505",
    "difference": "0,33%"
  },
  {
    "date": "04.05.2009",
    "now": "1,5618",
    "open": "1,5935",
    "highest": "1,5935",
    "lower": "1,5579",
    "difference": "-1,88%"
  },
  {
    "date": "01.05.2009",
    "now": "1,5917",
    "open": "1,5954",
    "highest": "1,5987",
    "lower": "1,5878",
    "difference": "-0,41%"
  },
  {
    "date": "30.04.2009",
    "now": "1,5983",
    "open": "1,5894",
    "highest": "1,6059",
    "lower": "1,5705",
    "difference": "0,64%"
  },
  {
    "date": "29.04.2009",
    "now": "1,5882",
    "open": "1,6134",
    "highest": "1,6175",
    "lower": "1,5857",
    "difference": "-1,61%"
  },
  {
    "date": "28.04.2009",
    "now": "1,6142",
    "open": "1,6310",
    "highest": "1,6433",
    "lower": "1,6122",
    "difference": "-1,04%"
  },
  {
    "date": "27.04.2009",
    "now": "1,6311",
    "open": "1,6065",
    "highest": "1,6353",
    "lower": "1,6065",
    "difference": "1,47%"
  },
  {
    "date": "24.04.2009",
    "now": "1,6075",
    "open": "1,6381",
    "highest": "1,6408",
    "lower": "1,6000",
    "difference": "-1,80%"
  },
  {
    "date": "23.04.2009",
    "now": "1,6370",
    "open": "1,6353",
    "highest": "1,6505",
    "lower": "1,6322",
    "difference": "0,00%"
  },
  {
    "date": "22.04.2009",
    "now": "1,6370",
    "open": "1,6378",
    "highest": "1,6526",
    "lower": "1,6275",
    "difference": "-0,17%"
  },
  {
    "date": "21.04.2009",
    "now": "1,6398",
    "open": "1,6561",
    "highest": "1,6737",
    "lower": "1,6367",
    "difference": "-1,03%"
  },
  {
    "date": "20.04.2009",
    "now": "1,6568",
    "open": "1,6181",
    "highest": "1,6601",
    "lower": "1,6101",
    "difference": "2,89%"
  },
  {
    "date": "17.04.2009",
    "now": "1,6103",
    "open": "1,6052",
    "highest": "1,6178",
    "lower": "1,5985",
    "difference": "0,29%"
  },
  {
    "date": "16.04.2009",
    "now": "1,6057",
    "open": "1,6011",
    "highest": "1,6178",
    "lower": "1,5910",
    "difference": "0,51%"
  },
  {
    "date": "15.04.2009",
    "now": "1,5975",
    "open": "1,5932",
    "highest": "1,6088",
    "lower": "1,5835",
    "difference": "0,14%"
  },
  {
    "date": "14.04.2009",
    "now": "1,5953",
    "open": "1,5670",
    "highest": "1,5993",
    "lower": "1,5648",
    "difference": "1,57%"
  },
  {
    "date": "13.04.2009",
    "now": "1,5707",
    "open": "1,5741",
    "highest": "1,5797",
    "lower": "1,5640",
    "difference": "0,15%"
  },
  {
    "date": "10.04.2009",
    "now": "1,5683",
    "open": "1,5677",
    "highest": "1,5765",
    "lower": "1,5585",
    "difference": "-0,11%"
  },
  {
    "date": "09.04.2009",
    "now": "1,5701",
    "open": "1,5825",
    "highest": "1,5844",
    "lower": "1,5604",
    "difference": "-0,80%"
  },
  {
    "date": "08.04.2009",
    "now": "1,5827",
    "open": "1,6010",
    "highest": "1,6226",
    "lower": "1,5773",
    "difference": "-1,22%"
  },
  {
    "date": "07.04.2009",
    "now": "1,6023",
    "open": "1,5880",
    "highest": "1,6170",
    "lower": "1,5840",
    "difference": "0,87%"
  },
  {
    "date": "06.04.2009",
    "now": "1,5885",
    "open": "1,5767",
    "highest": "1,5967",
    "lower": "1,5560",
    "difference": "0,56%"
  },
  {
    "date": "03.04.2009",
    "now": "1,5797",
    "open": "1,5912",
    "highest": "1,6075",
    "lower": "1,5740",
    "difference": "-1,08%"
  },
  {
    "date": "02.04.2009",
    "now": "1,5970",
    "open": "1,6220",
    "highest": "1,6294",
    "lower": "1,5894",
    "difference": "-1,49%"
  },
  {
    "date": "01.04.2009",
    "now": "1,6211",
    "open": "1,6640",
    "highest": "1,6745",
    "lower": "1,6196",
    "difference": "-2,46%"
  },
  {
    "date": "31.03.2009",
    "now": "1,6620",
    "open": "1,6830",
    "highest": "1,6965",
    "lower": "1,6527",
    "difference": "-1,34%"
  },
  {
    "date": "30.03.2009",
    "now": "1,6846",
    "open": "1,6772",
    "highest": "1,7153",
    "lower": "1,6761",
    "difference": "0,81%"
  },
  {
    "date": "27.03.2009",
    "now": "1,6710",
    "open": "1,6557",
    "highest": "1,6811",
    "lower": "1,6495",
    "difference": "1,01%"
  },
  {
    "date": "26.03.2009",
    "now": "1,6543",
    "open": "1,6603",
    "highest": "1,6658",
    "lower": "1,6450",
    "difference": "-0,43%"
  },
  {
    "date": "25.03.2009",
    "now": "1,6615",
    "open": "1,6520",
    "highest": "1,6711",
    "lower": "1,6445",
    "difference": "0,61%"
  },
  {
    "date": "24.03.2009",
    "now": "1,6515",
    "open": "1,6577",
    "highest": "1,6667",
    "lower": "1,6400",
    "difference": "-0,60%"
  },
  {
    "date": "23.03.2009",
    "now": "1,6615",
    "open": "1,6883",
    "highest": "1,6886",
    "lower": "1,6548",
    "difference": "-1,72%"
  },
  {
    "date": "20.03.2009",
    "now": "1,6906",
    "open": "1,7157",
    "highest": "1,7239",
    "lower": "1,6699",
    "difference": "-1,32%"
  },
  {
    "date": "19.03.2009",
    "now": "1,7133",
    "open": "1,6841",
    "highest": "1,7156",
    "lower": "1,6695",
    "difference": "1,64%"
  },
  {
    "date": "18.03.2009",
    "now": "1,6857",
    "open": "1,6987",
    "highest": "1,7240",
    "lower": "1,6720",
    "difference": "-0,83%"
  },
  {
    "date": "17.03.2009",
    "now": "1,6998",
    "open": "1,6943",
    "highest": "1,7169",
    "lower": "1,6875",
    "difference": "0,06%"
  },
  {
    "date": "16.03.2009",
    "now": "1,6987",
    "open": "1,7085",
    "highest": "1,7100",
    "lower": "1,6785",
    "difference": "-0,52%"
  },
  {
    "date": "13.03.2009",
    "now": "1,7075",
    "open": "1,6945",
    "highest": "1,7191",
    "lower": "1,6885",
    "difference": "0,78%"
  },
  {
    "date": "12.03.2009",
    "now": "1,6943",
    "open": "1,7427",
    "highest": "1,7667",
    "lower": "1,6835",
    "difference": "-2,88%"
  },
  {
    "date": "11.03.2009",
    "now": "1,7445",
    "open": "1,7559",
    "highest": "1,7663",
    "lower": "1,7205",
    "difference": "-0,68%"
  },
  {
    "date": "10.03.2009",
    "now": "1,7565",
    "open": "1,8062",
    "highest": "1,8075",
    "lower": "1,7510",
    "difference": "-2,85%"
  },
  {
    "date": "09.03.2009",
    "now": "1,8080",
    "open": "1,7905",
    "highest": "1,8270",
    "lower": "1,7790",
    "difference": "0,99%"
  },
  {
    "date": "06.03.2009",
    "now": "1,7903",
    "open": "1,7845",
    "highest": "1,7955",
    "lower": "1,7635",
    "difference": "0,10%"
  },
  {
    "date": "05.03.2009",
    "now": "1,7885",
    "open": "1,7179",
    "highest": "1,7911",
    "lower": "1,7157",
    "difference": "3,98%"
  },
  {
    "date": "04.03.2009",
    "now": "1,7201",
    "open": "1,7355",
    "highest": "1,7413",
    "lower": "1,7169",
    "difference": "-1,03%"
  },
  {
    "date": "03.03.2009",
    "now": "1,7380",
    "open": "1,7317",
    "highest": "1,7407",
    "lower": "1,7095",
    "difference": "0,27%"
  },
  {
    "date": "02.03.2009",
    "now": "1,7333",
    "open": "1,7041",
    "highest": "1,7350",
    "lower": "1,6993",
    "difference": "1,95%"
  },
  {
    "date": "27.02.2009",
    "now": "1,7001",
    "open": "1,6882",
    "highest": "1,7125",
    "lower": "1,6825",
    "difference": "0,52%"
  },
  {
    "date": "26.02.2009",
    "now": "1,6913",
    "open": "1,6907",
    "highest": "1,6950",
    "lower": "1,6765",
    "difference": "0,01%"
  },
  {
    "date": "25.02.2009",
    "now": "1,6911",
    "open": "1,6829",
    "highest": "1,6977",
    "lower": "1,6760",
    "difference": "0,46%"
  },
  {
    "date": "24.02.2009",
    "now": "1,6833",
    "open": "1,6969",
    "highest": "1,7048",
    "lower": "1,6818",
    "difference": "-0,78%"
  },
  {
    "date": "23.02.2009",
    "now": "1,6966",
    "open": "1,6876",
    "highest": "1,7014",
    "lower": "1,6736",
    "difference": "-0,35%"
  },
  {
    "date": "20.02.2009",
    "now": "1,7025",
    "open": "1,6951",
    "highest": "1,7183",
    "lower": "1,6925",
    "difference": "0,15%"
  },
  {
    "date": "19.02.2009",
    "now": "1,7000",
    "open": "1,7009",
    "highest": "1,7038",
    "lower": "1,6680",
    "difference": "0,09%"
  },
  {
    "date": "18.02.2009",
    "now": "1,6985",
    "open": "1,7071",
    "highest": "1,7174",
    "lower": "1,6805",
    "difference": "-0,31%"
  },
  {
    "date": "17.02.2009",
    "now": "1,7037",
    "open": "1,6686",
    "highest": "1,7037",
    "lower": "1,6677",
    "difference": "2,07%"
  },
  {
    "date": "16.02.2009",
    "now": "1,6691",
    "open": "1,6485",
    "highest": "1,6731",
    "lower": "1,6455",
    "difference": "1,31%"
  },
  {
    "date": "13.02.2009",
    "now": "1,6475",
    "open": "1,6555",
    "highest": "1,6555",
    "lower": "1,6350",
    "difference": "-0,68%"
  },
  {
    "date": "12.02.2009",
    "now": "1,6587",
    "open": "1,6341",
    "highest": "1,6652",
    "lower": "1,6280",
    "difference": "1,41%"
  },
  {
    "date": "11.02.2009",
    "now": "1,6357",
    "open": "1,6413",
    "highest": "1,6450",
    "lower": "1,6270",
    "difference": "-0,37%"
  },
  {
    "date": "10.02.2009",
    "now": "1,6417",
    "open": "1,6150",
    "highest": "1,6423",
    "lower": "1,6096",
    "difference": "1,75%"
  },
  {
    "date": "09.02.2009",
    "now": "1,6134",
    "open": "1,6187",
    "highest": "1,6245",
    "lower": "1,6040",
    "difference": "-0,22%"
  },
  {
    "date": "06.02.2009",
    "now": "1,6170",
    "open": "1,6275",
    "highest": "1,6354",
    "lower": "1,6127",
    "difference": "-0,59%"
  },
  {
    "date": "05.02.2009",
    "now": "1,6266",
    "open": "1,6440",
    "highest": "1,6457",
    "lower": "1,6229",
    "difference": "-1,08%"
  },
  {
    "date": "04.02.2009",
    "now": "1,6443",
    "open": "1,6366",
    "highest": "1,6463",
    "lower": "1,6255",
    "difference": "0,30%"
  },
  {
    "date": "03.02.2009",
    "now": "1,6394",
    "open": "1,6519",
    "highest": "1,6580",
    "lower": "1,6363",
    "difference": "-0,63%"
  },
  {
    "date": "02.02.2009",
    "now": "1,6498",
    "open": "1,6462",
    "highest": "1,6690",
    "lower": "1,6452",
    "difference": "0,40%"
  },
  {
    "date": "30.01.2009",
    "now": "1,6433",
    "open": "1,6361",
    "highest": "1,6525",
    "lower": "1,6241",
    "difference": "0,32%"
  },
  {
    "date": "29.01.2009",
    "now": "1,6381",
    "open": "1,6166",
    "highest": "1,6385",
    "lower": "1,6096",
    "difference": "1,29%"
  },
  {
    "date": "28.01.2009",
    "now": "1,6172",
    "open": "1,6277",
    "highest": "1,6300",
    "lower": "1,6094",
    "difference": "-0,51%"
  },
  {
    "date": "27.01.2009",
    "now": "1,6255",
    "open": "1,6267",
    "highest": "1,6451",
    "lower": "1,6025",
    "difference": "-0,40%"
  },
  {
    "date": "26.01.2009",
    "now": "1,6320",
    "open": "1,6693",
    "highest": "1,6752",
    "lower": "1,6167",
    "difference": "-2,28%"
  },
  {
    "date": "23.01.2009",
    "now": "1,6700",
    "open": "1,6526",
    "highest": "1,6841",
    "lower": "1,6512",
    "difference": "1,06%"
  },
  {
    "date": "22.01.2009",
    "now": "1,6525",
    "open": "1,6435",
    "highest": "1,6629",
    "lower": "1,6347",
    "difference": "0,27%"
  },
  {
    "date": "21.01.2009",
    "now": "1,6480",
    "open": "1,6709",
    "highest": "1,6754",
    "lower": "1,6447",
    "difference": "-1,46%"
  },
  {
    "date": "20.01.2009",
    "now": "1,6724",
    "open": "1,6463",
    "highest": "1,6791",
    "lower": "1,6444",
    "difference": "1,62%"
  },
  {
    "date": "19.01.2009",
    "now": "1,6457",
    "open": "1,6206",
    "highest": "1,6532",
    "lower": "1,6126",
    "difference": "0,96%"
  },
  {
    "date": "16.01.2009",
    "now": "1,6300",
    "open": "1,6082",
    "highest": "1,6421",
    "lower": "1,5901",
    "difference": "1,34%"
  },
  {
    "date": "15.01.2009",
    "now": "1,6085",
    "open": "1,6270",
    "highest": "1,6313",
    "lower": "1,6026",
    "difference": "-1,02%"
  },
  {
    "date": "14.01.2009",
    "now": "1,6250",
    "open": "1,5931",
    "highest": "1,6316",
    "lower": "1,5771",
    "difference": "1,82%"
  },
  {
    "date": "13.01.2009",
    "now": "1,5960",
    "open": "1,6012",
    "highest": "1,6119",
    "lower": "1,5854",
    "difference": "-0,24%"
  },
  {
    "date": "12.01.2009",
    "now": "1,5999",
    "open": "1,5648",
    "highest": "1,6048",
    "lower": "1,5596",
    "difference": "2,52%"
  },
  {
    "date": "09.01.2009",
    "now": "1,5605",
    "open": "1,5653",
    "highest": "1,5653",
    "lower": "1,5365",
    "difference": "-0,31%"
  },
  {
    "date": "08.01.2009",
    "now": "1,5653",
    "open": "1,5533",
    "highest": "1,5660",
    "lower": "1,5345",
    "difference": "0,73%"
  },
  {
    "date": "07.01.2009",
    "now": "1,5540",
    "open": "1,5137",
    "highest": "1,5595",
    "lower": "1,5005",
    "difference": "2,64%"
  },
  {
    "date": "06.01.2009",
    "now": "1,5140",
    "open": "1,5317",
    "highest": "1,5365",
    "lower": "1,5081",
    "difference": "-1,17%"
  },
  {
    "date": "05.01.2009",
    "now": "1,5320",
    "open": "1,5355",
    "highest": "1,5398",
    "lower": "1,5145",
    "difference": "-0,23%"
  },
  {
    "date": "02.01.2009",
    "now": "1,5355",
    "open": "1,5345",
    "highest": "1,5429",
    "lower": "1,5240",
    "difference": "-0,16%"
  },
  {
    "date": "01.01.2009",
    "now": "1,5380",
    "open": "1,5405",
    "highest": "1,5405",
    "lower": "1,5380",
    "difference": "-0,16%"
  },
  {
    "date": "31.12.2008",
    "now": "1,5405",
    "open": "1,5210",
    "highest": "1,5435",
    "lower": "1,5090",
    "difference": "1,28%"
  },
  {
    "date": "30.12.2008",
    "now": "1,5210",
    "open": "1,5174",
    "highest": "1,5355",
    "lower": "1,5085",
    "difference": "0,14%"
  },
  {
    "date": "29.12.2008",
    "now": "1,5188",
    "open": "1,5145",
    "highest": "1,5192",
    "lower": "1,4975",
    "difference": "0,58%"
  },
  {
    "date": "26.12.2008",
    "now": "1,5100",
    "open": "1,5177",
    "highest": "1,5178",
    "lower": "1,4935",
    "difference": "-0,11%"
  },
  {
    "date": "25.12.2008",
    "now": "1,5116",
    "open": "1,5212",
    "highest": "1,5242",
    "lower": "1,5055",
    "difference": "-0,55%"
  },
  {
    "date": "24.12.2008",
    "now": "1,5199",
    "open": "1,5181",
    "highest": "1,5257",
    "lower": "1,5090",
    "difference": "0,06%"
  },
  {
    "date": "23.12.2008",
    "now": "1,5190",
    "open": "1,5310",
    "highest": "1,5345",
    "lower": "1,5125",
    "difference": "-0,72%"
  },
  {
    "date": "22.12.2008",
    "now": "1,5300",
    "open": "1,5167",
    "highest": "1,5333",
    "lower": "1,5090",
    "difference": "0,16%"
  },
  {
    "date": "19.12.2008",
    "now": "1,5275",
    "open": "1,5165",
    "highest": "1,5354",
    "lower": "1,5040",
    "difference": "1,07%"
  },
  {
    "date": "18.12.2008",
    "now": "1,5113",
    "open": "1,5281",
    "highest": "1,5347",
    "lower": "1,4865",
    "difference": "-1,01%"
  },
  {
    "date": "17.12.2008",
    "now": "1,5267",
    "open": "1,5408",
    "highest": "1,5503",
    "lower": "1,5244",
    "difference": "-0,90%"
  },
  {
    "date": "16.12.2008",
    "now": "1,5405",
    "open": "1,5611",
    "highest": "1,5720",
    "lower": "1,5386",
    "difference": "-1,32%"
  },
  {
    "date": "15.12.2008",
    "now": "1,5611",
    "open": "1,5631",
    "highest": "1,5746",
    "lower": "1,5486",
    "difference": "0,24%"
  },
  {
    "date": "12.12.2008",
    "now": "1,5573",
    "open": "1,5274",
    "highest": "1,5746",
    "lower": "1,5271",
    "difference": "1,34%"
  },
  {
    "date": "11.12.2008",
    "now": "1,5367",
    "open": "1,5537",
    "highest": "1,5596",
    "lower": "1,5227",
    "difference": "-1,12%"
  },
  {
    "date": "10.12.2008",
    "now": "1,5541",
    "open": "1,5762",
    "highest": "1,5779",
    "lower": "1,5510",
    "difference": "-1,26%"
  },
  {
    "date": "09.12.2008",
    "now": "1,5739",
    "open": "1,5737",
    "highest": "1,5913",
    "lower": "1,5593",
    "difference": "0,16%"
  },
  {
    "date": "08.12.2008",
    "now": "1,5714",
    "open": "1,5772",
    "highest": "1,5866",
    "lower": "1,5567",
    "difference": "-1,69%"
  },
  {
    "date": "05.12.2008",
    "now": "1,5984",
    "open": "1,5596",
    "highest": "1,6168",
    "lower": "1,5488",
    "difference": "2,36%"
  },
  {
    "date": "04.12.2008",
    "now": "1,5615",
    "open": "1,5753",
    "highest": "1,5845",
    "lower": "1,5476",
    "difference": "-0,80%"
  },
  {
    "date": "03.12.2008",
    "now": "1,5741",
    "open": "1,5840",
    "highest": "1,5928",
    "lower": "1,5621",
    "difference": "-0,66%"
  },
  {
    "date": "02.12.2008",
    "now": "1,5845",
    "open": "1,6014",
    "highest": "1,6255",
    "lower": "1,5760",
    "difference": "-1,05%"
  },
  {
    "date": "01.12.2008",
    "now": "1,6013",
    "open": "1,5702",
    "highest": "1,6074",
    "lower": "1,5613",
    "difference": "2,31%"
  },
  {
    "date": "28.11.2008",
    "now": "1,5652",
    "open": "1,5703",
    "highest": "1,5883",
    "lower": "1,5563",
    "difference": "-0,46%"
  },
  {
    "date": "27.11.2008",
    "now": "1,5725",
    "open": "1,5749",
    "highest": "1,5820",
    "lower": "1,5653",
    "difference": "-0,16%"
  },
  {
    "date": "26.11.2008",
    "now": "1,5750",
    "open": "1,5811",
    "highest": "1,6080",
    "lower": "1,5698",
    "difference": "-0,16%"
  },
  {
    "date": "25.11.2008",
    "now": "1,5775",
    "open": "1,5844",
    "highest": "1,5900",
    "lower": "1,5565",
    "difference": "-0,47%"
  },
  {
    "date": "24.11.2008",
    "now": "1,5850",
    "open": "1,6762",
    "highest": "1,6762",
    "lower": "1,5819",
    "difference": "-5,37%"
  },
  {
    "date": "21.11.2008",
    "now": "1,6750",
    "open": "1,7313",
    "highest": "1,7313",
    "lower": "1,6635",
    "difference": "-3,31%"
  },
  {
    "date": "20.11.2008",
    "now": "1,7323",
    "open": "1,7348",
    "highest": "1,7528",
    "lower": "1,6866",
    "difference": "-0,14%"
  },
  {
    "date": "19.11.2008",
    "now": "1,7347",
    "open": "1,6569",
    "highest": "1,7352",
    "lower": "1,6518",
    "difference": "4,89%"
  },
  {
    "date": "18.11.2008",
    "now": "1,6539",
    "open": "1,6356",
    "highest": "1,6771",
    "lower": "1,6350",
    "difference": "1,08%"
  },
  {
    "date": "17.11.2008",
    "now": "1,6362",
    "open": "1,6286",
    "highest": "1,6464",
    "lower": "1,5976",
    "difference": "1,31%"
  },
  {
    "date": "14.11.2008",
    "now": "1,6150",
    "open": "1,6332",
    "highest": "1,6515",
    "lower": "1,6062",
    "difference": "-0,90%"
  },
  {
    "date": "13.11.2008",
    "now": "1,6296",
    "open": "1,6473",
    "highest": "1,6821",
    "lower": "1,6168",
    "difference": "-1,19%"
  },
  {
    "date": "12.11.2008",
    "now": "1,6492",
    "open": "1,5905",
    "highest": "1,6648",
    "lower": "1,5855",
    "difference": "2,61%"
  },
  {
    "date": "11.11.2008",
    "now": "1,6072",
    "open": "1,5459",
    "highest": "1,6204",
    "lower": "1,5446",
    "difference": "3,96%"
  },
  {
    "date": "10.11.2008",
    "now": "1,5460",
    "open": "1,5445",
    "highest": "1,5515",
    "lower": "1,5126",
    "difference": "-0,11%"
  },
  {
    "date": "07.11.2008",
    "now": "1,5477",
    "open": "1,5676",
    "highest": "1,5676",
    "lower": "1,5286",
    "difference": "-1,26%"
  },
  {
    "date": "06.11.2008",
    "now": "1,5675",
    "open": "1,5311",
    "highest": "1,5705",
    "lower": "1,5140",
    "difference": "2,32%"
  },
  {
    "date": "05.11.2008",
    "now": "1,5320",
    "open": "1,4838",
    "highest": "1,5322",
    "lower": "1,4798",
    "difference": "3,26%"
  },
  {
    "date": "04.11.2008",
    "now": "1,4837",
    "open": "1,5492",
    "highest": "1,5577",
    "lower": "1,4816",
    "difference": "-4,14%"
  },
  {
    "date": "03.11.2008",
    "now": "1,5478",
    "open": "1,5126",
    "highest": "1,5557",
    "lower": "1,5046",
    "difference": "0,36%"
  },
  {
    "date": "31.10.2008",
    "now": "1,5422",
    "open": "1,5253",
    "highest": "1,5911",
    "lower": "1,5253",
    "difference": "1,21%"
  },
  {
    "date": "30.10.2008",
    "now": "1,5237",
    "open": "1,4946",
    "highest": "1,5584",
    "lower": "1,4626",
    "difference": "0,74%"
  },
  {
    "date": "29.10.2008",
    "now": "1,5125",
    "open": "1,5663",
    "highest": "1,5663",
    "lower": "1,4973",
    "difference": "-3,04%"
  },
  {
    "date": "28.10.2008",
    "now": "1,5600",
    "open": "1,6366",
    "highest": "1,6418",
    "lower": "1,5387",
    "difference": "-4,28%"
  },
  {
    "date": "27.10.2008",
    "now": "1,6297",
    "open": "1,6930",
    "highest": "1,7197",
    "lower": "1,6201",
    "difference": "-3,85%"
  },
  {
    "date": "24.10.2008",
    "now": "1,6950",
    "open": "1,6896",
    "highest": "1,7276",
    "lower": "1,6705",
    "difference": "0,00%"
  },
  {
    "date": "23.10.2008",
    "now": "1,6950",
    "open": "1,6990",
    "highest": "1,7445",
    "lower": "1,6550",
    "difference": "0,05%"
  },
  {
    "date": "22.10.2008",
    "now": "1,6942",
    "open": "1,5825",
    "highest": "1,6948",
    "lower": "1,5825",
    "difference": "7,07%"
  },
  {
    "date": "21.10.2008",
    "now": "1,5824",
    "open": "1,5093",
    "highest": "1,5998",
    "lower": "1,5074",
    "difference": "4,91%"
  },
  {
    "date": "20.10.2008",
    "now": "1,5083",
    "open": "1,4911",
    "highest": "1,5259",
    "lower": "1,4796",
    "difference": "0,39%"
  },
  {
    "date": "17.10.2008",
    "now": "1,5025",
    "open": "1,4756",
    "highest": "1,5362",
    "lower": "1,4756",
    "difference": "-0,96%"
  },
  {
    "date": "16.10.2008",
    "now": "1,5170",
    "open": "1,4956",
    "highest": "1,5439",
    "lower": "1,4666",
    "difference": "5,42%"
  },
  {
    "date": "15.10.2008",
    "now": "1,4390",
    "open": "1,3836",
    "highest": "1,4446",
    "lower": "1,3783",
    "difference": "4,03%"
  },
  {
    "date": "14.10.2008",
    "now": "1,3832",
    "open": "1,3842",
    "highest": "1,3882",
    "lower": "1,3651",
    "difference": "-0,11%"
  },
  {
    "date": "13.10.2008",
    "now": "1,3847",
    "open": "1,4003",
    "highest": "1,4148",
    "lower": "1,3798",
    "difference": "-3,36%"
  },
  {
    "date": "10.10.2008",
    "now": "1,4329",
    "open": "1,4446",
    "highest": "1,4477",
    "lower": "1,4131",
    "difference": "1,61%"
  },
  {
    "date": "09.10.2008",
    "now": "1,4102",
    "open": "1,4271",
    "highest": "1,4271",
    "lower": "1,3683",
    "difference": "-1,07%"
  },
  {
    "date": "08.10.2008",
    "now": "1,4254",
    "open": "1,3859",
    "highest": "1,4289",
    "lower": "1,3822",
    "difference": "2,85%"
  },
  {
    "date": "07.10.2008",
    "now": "1,3859",
    "open": "1,3764",
    "highest": "1,3887",
    "lower": "1,3456",
    "difference": "0,77%"
  },
  {
    "date": "06.10.2008",
    "now": "1,3753",
    "open": "1,3091",
    "highest": "1,3838",
    "lower": "1,3068",
    "difference": "5,19%"
  },
  {
    "date": "03.10.2008",
    "now": "1,3074",
    "open": "1,3171",
    "highest": "1,3197",
    "lower": "1,2953",
    "difference": "-0,56%"
  },
  {
    "date": "02.10.2008",
    "now": "1,3148",
    "open": "1,2707",
    "highest": "1,3177",
    "lower": "1,2687",
    "difference": "3,48%"
  },
  {
    "date": "01.10.2008",
    "now": "1,2706",
    "open": "1,2721",
    "highest": "1,2791",
    "lower": "1,2625",
    "difference": "-0,46%"
  },
  {
    "date": "30.09.2008",
    "now": "1,2765",
    "open": "1,2612",
    "highest": "1,2832",
    "lower": "1,2612",
    "difference": "1,21%"
  },
  {
    "date": "29.09.2008",
    "now": "1,2613",
    "open": "1,2352",
    "highest": "1,2664",
    "lower": "1,2335",
    "difference": "2,11%"
  },
  {
    "date": "26.09.2008",
    "now": "1,2352",
    "open": "1,2290",
    "highest": "1,2429",
    "lower": "1,2290",
    "difference": "0,50%"
  },
  {
    "date": "25.09.2008",
    "now": "1,2290",
    "open": "1,2410",
    "highest": "1,2425",
    "lower": "1,2275",
    "difference": "-1,03%"
  },
  {
    "date": "24.09.2008",
    "now": "1,2418",
    "open": "1,2437",
    "highest": "1,2452",
    "lower": "1,2363",
    "difference": "-0,20%"
  },
  {
    "date": "23.09.2008",
    "now": "1,2443",
    "open": "1,2373",
    "highest": "1,2455",
    "lower": "1,2355",
    "difference": "0,57%"
  },
  {
    "date": "22.09.2008",
    "now": "1,2373",
    "open": "1,2520",
    "highest": "1,2520",
    "lower": "1,2345",
    "difference": "-1,17%"
  },
  {
    "date": "19.09.2008",
    "now": "1,2520",
    "open": "1,2807",
    "highest": "1,2807",
    "lower": "1,2445",
    "difference": "-2,24%"
  },
  {
    "date": "18.09.2008",
    "now": "1,2807",
    "open": "1,2881",
    "highest": "1,2960",
    "lower": "1,2710",
    "difference": "-0,49%"
  },
  {
    "date": "17.09.2008",
    "now": "1,2870",
    "open": "1,2610",
    "highest": "1,2882",
    "lower": "1,2560",
    "difference": "0,98%"
  },
  {
    "date": "16.09.2008",
    "now": "1,2745",
    "open": "1,2685",
    "highest": "1,2850",
    "lower": "1,2685",
    "difference": "1,09%"
  },
  {
    "date": "15.09.2008",
    "now": "1,2608",
    "open": "1,2478",
    "highest": "1,2683",
    "lower": "1,2478",
    "difference": "1,92%"
  },
  {
    "date": "12.09.2008",
    "now": "1,2370",
    "open": "1,2645",
    "highest": "1,2645",
    "lower": "1,2370",
    "difference": "-2,02%"
  },
  {
    "date": "11.09.2008",
    "now": "1,2625",
    "open": "1,2470",
    "highest": "1,2695",
    "lower": "1,2450",
    "difference": "1,41%"
  },
  {
    "date": "10.09.2008",
    "now": "1,2450",
    "open": "1,2305",
    "highest": "1,2450",
    "lower": "1,2270",
    "difference": "1,29%"
  },
  {
    "date": "09.09.2008",
    "now": "1,2292",
    "open": "1,2293",
    "highest": "1,2313",
    "lower": "1,2159",
    "difference": "-0,31%"
  },
  {
    "date": "08.09.2008",
    "now": "1,2330",
    "open": "1,2475",
    "highest": "1,2475",
    "lower": "1,2119",
    "difference": "-0,40%"
  },
  {
    "date": "05.09.2008",
    "now": "1,2380",
    "open": "1,2403",
    "highest": "1,2492",
    "lower": "1,2298",
    "difference": "-0,59%"
  },
  {
    "date": "04.09.2008",
    "now": "1,2454",
    "open": "1,2152",
    "highest": "1,2454",
    "lower": "1,2064",
    "difference": "2,44%"
  },
  {
    "date": "03.09.2008",
    "now": "1,2157",
    "open": "1,1987",
    "highest": "1,2207",
    "lower": "1,1947",
    "difference": "1,60%"
  },
  {
    "date": "02.09.2008",
    "now": "1,1965",
    "open": "1,1853",
    "highest": "1,1981",
    "lower": "1,1816",
    "difference": "0,84%"
  },
  {
    "date": "01.09.2008",
    "now": "1,1865",
    "open": "1,1837",
    "highest": "1,1891",
    "lower": "1,1787",
    "difference": "0,17%"
  },
  {
    "date": "29.08.2008",
    "now": "1,1845",
    "open": "1,1866",
    "highest": "1,1867",
    "lower": "1,1738",
    "difference": "-0,20%"
  },
  {
    "date": "28.08.2008",
    "now": "1,1869",
    "open": "1,1893",
    "highest": "1,1906",
    "lower": "1,1792",
    "difference": "-0,20%"
  },
  {
    "date": "27.08.2008",
    "now": "1,1893",
    "open": "1,1912",
    "highest": "1,1933",
    "lower": "1,1825",
    "difference": "-0,15%"
  },
  {
    "date": "26.08.2008",
    "now": "1,1911",
    "open": "1,1856",
    "highest": "1,1981",
    "lower": "1,1823",
    "difference": "0,30%"
  },
  {
    "date": "25.08.2008",
    "now": "1,1875",
    "open": "1,1929",
    "highest": "1,1929",
    "lower": "1,1810",
    "difference": "0,09%"
  },
  {
    "date": "22.08.2008",
    "now": "1,1864",
    "open": "1,1936",
    "highest": "1,1936",
    "lower": "1,1812",
    "difference": "-0,18%"
  },
  {
    "date": "21.08.2008",
    "now": "1,1885",
    "open": "1,1914",
    "highest": "1,1971",
    "lower": "1,1867",
    "difference": "-0,34%"
  },
  {
    "date": "20.08.2008",
    "now": "1,1925",
    "open": "1,1905",
    "highest": "1,1958",
    "lower": "1,1856",
    "difference": "0,19%"
  },
  {
    "date": "19.08.2008",
    "now": "1,1902",
    "open": "1,1875",
    "highest": "1,1997",
    "lower": "1,1827",
    "difference": "0,24%"
  },
  {
    "date": "18.08.2008",
    "now": "1,1873",
    "open": "1,1860",
    "highest": "1,1894",
    "lower": "1,1775",
    "difference": "-0,05%"
  },
  {
    "date": "15.08.2008",
    "now": "1,1879",
    "open": "1,1839",
    "highest": "1,1897",
    "lower": "1,1773",
    "difference": "0,33%"
  },
  {
    "date": "14.08.2008",
    "now": "1,1840",
    "open": "1,1796",
    "highest": "1,1898",
    "lower": "1,1748",
    "difference": "-0,05%"
  },
  {
    "date": "13.08.2008",
    "now": "1,1846",
    "open": "1,1824",
    "highest": "1,1921",
    "lower": "1,1740",
    "difference": "0,32%"
  },
  {
    "date": "12.08.2008",
    "now": "1,1808",
    "open": "1,1887",
    "highest": "1,1926",
    "lower": "1,1732",
    "difference": "-0,62%"
  },
  {
    "date": "11.08.2008",
    "now": "1,1882",
    "open": "1,1921",
    "highest": "1,1932",
    "lower": "1,1711",
    "difference": "0,02%"
  },
  {
    "date": "08.08.2008",
    "now": "1,1880",
    "open": "1,1771",
    "highest": "1,1974",
    "lower": "1,1657",
    "difference": "0,87%"
  },
  {
    "date": "07.08.2008",
    "now": "1,1777",
    "open": "1,1638",
    "highest": "1,1777",
    "lower": "1,1586",
    "difference": "1,12%"
  },
  {
    "date": "06.08.2008",
    "now": "1,1646",
    "open": "1,1554",
    "highest": "1,1697",
    "lower": "1,1490",
    "difference": "0,71%"
  },
  {
    "date": "05.08.2008",
    "now": "1,1564",
    "open": "1,1544",
    "highest": "1,1591",
    "lower": "1,1480",
    "difference": "0,28%"
  },
  {
    "date": "04.08.2008",
    "now": "1,1532",
    "open": "1,1547",
    "highest": "1,1611",
    "lower": "1,1445",
    "difference": "-0,30%"
  },
  {
    "date": "01.08.2008",
    "now": "1,1567",
    "open": "1,1606",
    "highest": "1,1669",
    "lower": "1,1526",
    "difference": "-0,42%"
  },
  {
    "date": "31.07.2008",
    "now": "1,1616",
    "open": "1,1663",
    "highest": "1,1697",
    "lower": "1,1502",
    "difference": "-0,30%"
  },
  {
    "date": "30.07.2008",
    "now": "1,1651",
    "open": "1,1915",
    "highest": "1,1979",
    "lower": "1,1630",
    "difference": "-2,12%"
  },
  {
    "date": "29.07.2008",
    "now": "1,1903",
    "open": "1,2057",
    "highest": "1,2078",
    "lower": "1,1881",
    "difference": "-1,39%"
  },
  {
    "date": "28.07.2008",
    "now": "1,2071",
    "open": "1,2120",
    "highest": "1,2120",
    "lower": "1,1995",
    "difference": "-0,10%"
  },
  {
    "date": "25.07.2008",
    "now": "1,2083",
    "open": "1,2080",
    "highest": "1,2108",
    "lower": "1,2003",
    "difference": "-0,06%"
  },
  {
    "date": "24.07.2008",
    "now": "1,2090",
    "open": "1,2065",
    "highest": "1,2140",
    "lower": "1,1980",
    "difference": "0,37%"
  },
  {
    "date": "23.07.2008",
    "now": "1,2045",
    "open": "1,1966",
    "highest": "1,2085",
    "lower": "1,1891",
    "difference": "0,67%"
  },
  {
    "date": "22.07.2008",
    "now": "1,1965",
    "open": "1,1928",
    "highest": "1,2023",
    "lower": "1,1889",
    "difference": "0,24%"
  },
  {
    "date": "21.07.2008",
    "now": "1,1936",
    "open": "1,1885",
    "highest": "1,1960",
    "lower": "1,1845",
    "difference": "0,34%"
  },
  {
    "date": "18.07.2008",
    "now": "1,1896",
    "open": "1,1953",
    "highest": "1,2022",
    "lower": "1,1848",
    "difference": "-0,74%"
  },
  {
    "date": "17.07.2008",
    "now": "1,1985",
    "open": "1,2087",
    "highest": "1,2105",
    "lower": "1,1935",
    "difference": "-0,76%"
  },
  {
    "date": "16.07.2008",
    "now": "1,2077",
    "open": "1,2162",
    "highest": "1,2222",
    "lower": "1,2072",
    "difference": "-0,80%"
  },
  {
    "date": "15.07.2008",
    "now": "1,2174",
    "open": "1,2197",
    "highest": "1,2247",
    "lower": "1,2142",
    "difference": "-0,07%"
  },
  {
    "date": "14.07.2008",
    "now": "1,2183",
    "open": "1,2217",
    "highest": "1,2235",
    "lower": "1,2095",
    "difference": "-0,33%"
  },
  {
    "date": "11.07.2008",
    "now": "1,2223",
    "open": "1,2229",
    "highest": "1,2294",
    "lower": "1,2134",
    "difference": "-0,01%"
  },
  {
    "date": "10.07.2008",
    "now": "1,2224",
    "open": "1,2247",
    "highest": "1,2295",
    "lower": "1,2135",
    "difference": "-0,19%"
  },
  {
    "date": "09.07.2008",
    "now": "1,2247",
    "open": "1,2241",
    "highest": "1,2285",
    "lower": "1,2145",
    "difference": "0,02%"
  },
  {
    "date": "08.07.2008",
    "now": "1,2244",
    "open": "1,2316",
    "highest": "1,2374",
    "lower": "1,2239",
    "difference": "-0,50%"
  },
  {
    "date": "07.07.2008",
    "now": "1,2306",
    "open": "1,2352",
    "highest": "1,2391",
    "lower": "1,2216",
    "difference": "-0,24%"
  },
  {
    "date": "04.07.2008",
    "now": "1,2336",
    "open": "1,2406",
    "highest": "1,2425",
    "lower": "1,2317",
    "difference": "-0,50%"
  },
  {
    "date": "03.07.2008",
    "now": "1,2398",
    "open": "1,2441",
    "highest": "1,2584",
    "lower": "1,2385",
    "difference": "-0,19%"
  },
  {
    "date": "02.07.2008",
    "now": "1,2422",
    "open": "1,2418",
    "highest": "1,2456",
    "lower": "1,2313",
    "difference": "0,01%"
  },
  {
    "date": "01.07.2008",
    "now": "1,2421",
    "open": "1,2239",
    "highest": "1,2517",
    "lower": "1,2207",
    "difference": "1,50%"
  },
  {
    "date": "30.06.2008",
    "now": "1,2237",
    "open": "1,2273",
    "highest": "1,2285",
    "lower": "1,2185",
    "difference": "-0,37%"
  },
  {
    "date": "27.06.2008",
    "now": "1,2283",
    "open": "1,2237",
    "highest": "1,2365",
    "lower": "1,2165",
    "difference": "0,38%"
  },
  {
    "date": "26.06.2008",
    "now": "1,2237",
    "open": "1,2147",
    "highest": "1,2269",
    "lower": "1,2060",
    "difference": "0,71%"
  },
  {
    "date": "25.06.2008",
    "now": "1,2151",
    "open": "1,2275",
    "highest": "1,2295",
    "lower": "1,2096",
    "difference": "-1,03%"
  },
  {
    "date": "24.06.2008",
    "now": "1,2277",
    "open": "1,2330",
    "highest": "1,2340",
    "lower": "1,2235",
    "difference": "-0,41%"
  },
  {
    "date": "23.06.2008",
    "now": "1,2327",
    "open": "1,2257",
    "highest": "1,2344",
    "lower": "1,2205",
    "difference": "0,62%"
  },
  {
    "date": "20.06.2008",
    "now": "1,2251",
    "open": "1,2235",
    "highest": "1,2317",
    "lower": "1,2125",
    "difference": "0,19%"
  },
  {
    "date": "19.06.2008",
    "now": "1,2228",
    "open": "1,2287",
    "highest": "1,2354",
    "lower": "1,2195",
    "difference": "-0,41%"
  },
  {
    "date": "18.06.2008",
    "now": "1,2278",
    "open": "1,2277",
    "highest": "1,2335",
    "lower": "1,2165",
    "difference": "-0,02%"
  },
  {
    "date": "17.06.2008",
    "now": "1,2280",
    "open": "1,2460",
    "highest": "1,2470",
    "lower": "1,2195",
    "difference": "-1,42%"
  },
  {
    "date": "16.06.2008",
    "now": "1,2457",
    "open": "1,2540",
    "highest": "1,2545",
    "lower": "1,2370",
    "difference": "-0,63%"
  },
  {
    "date": "13.06.2008",
    "now": "1,2536",
    "open": "1,2553",
    "highest": "1,2615",
    "lower": "1,2445",
    "difference": "-0,11%"
  },
  {
    "date": "12.06.2008",
    "now": "1,2550",
    "open": "1,2635",
    "highest": "1,2640",
    "lower": "1,2465",
    "difference": "-0,63%"
  },
  {
    "date": "11.06.2008",
    "now": "1,2630",
    "open": "1,2594",
    "highest": "1,2680",
    "lower": "1,2435",
    "difference": "0,32%"
  },
  {
    "date": "10.06.2008",
    "now": "1,2590",
    "open": "1,2413",
    "highest": "1,2648",
    "lower": "1,2350",
    "difference": "1,43%"
  },
  {
    "date": "09.06.2008",
    "now": "1,2413",
    "open": "1,2493",
    "highest": "1,2539",
    "lower": "1,2305",
    "difference": "-0,38%"
  },
  {
    "date": "06.06.2008",
    "now": "1,2460",
    "open": "1,2409",
    "highest": "1,2499",
    "lower": "1,2325",
    "difference": "0,38%"
  },
  {
    "date": "05.06.2008",
    "now": "1,2413",
    "open": "1,2380",
    "highest": "1,2475",
    "lower": "1,2205",
    "difference": "0,27%"
  },
  {
    "date": "04.06.2008",
    "now": "1,2380",
    "open": "1,2360",
    "highest": "1,2445",
    "lower": "1,2245",
    "difference": "0,20%"
  },
  {
    "date": "03.06.2008",
    "now": "1,2355",
    "open": "1,2297",
    "highest": "1,2401",
    "lower": "1,2185",
    "difference": "0,47%"
  },
  {
    "date": "02.06.2008",
    "now": "1,2297",
    "open": "1,2195",
    "highest": "1,2317",
    "lower": "1,2135",
    "difference": "0,89%"
  },
  {
    "date": "30.05.2008",
    "now": "1,2189",
    "open": "1,2083",
    "highest": "1,2207",
    "lower": "1,2028",
    "difference": "0,99%"
  },
  {
    "date": "29.05.2008",
    "now": "1,2070",
    "open": "1,2265",
    "highest": "1,2290",
    "lower": "1,2024",
    "difference": "-1,69%"
  },
  {
    "date": "28.05.2008",
    "now": "1,2278",
    "open": "1,2382",
    "highest": "1,2450",
    "lower": "1,2185",
    "difference": "-0,78%"
  },
  {
    "date": "27.05.2008",
    "now": "1,2375",
    "open": "1,2459",
    "highest": "1,2537",
    "lower": "1,2373",
    "difference": "-0,67%"
  },
  {
    "date": "26.05.2008",
    "now": "1,2458",
    "open": "1,2471",
    "highest": "1,2523",
    "lower": "1,2424",
    "difference": "-0,18%"
  },
  {
    "date": "23.05.2008",
    "now": "1,2480",
    "open": "1,2475",
    "highest": "1,2501",
    "lower": "1,2375",
    "difference": "0,06%"
  },
  {
    "date": "22.05.2008",
    "now": "1,2473",
    "open": "1,2509",
    "highest": "1,2547",
    "lower": "1,2395",
    "difference": "-0,37%"
  },
  {
    "date": "21.05.2008",
    "now": "1,2519",
    "open": "1,2405",
    "highest": "1,2533",
    "lower": "1,2335",
    "difference": "0,98%"
  },
  {
    "date": "20.05.2008",
    "now": "1,2397",
    "open": "1,2310",
    "highest": "1,2439",
    "lower": "1,2263",
    "difference": "0,63%"
  },
  {
    "date": "19.05.2008",
    "now": "1,2319",
    "open": "1,2323",
    "highest": "1,2390",
    "lower": "1,2257",
    "difference": "0,15%"
  },
  {
    "date": "16.05.2008",
    "now": "1,2300",
    "open": "1,2382",
    "highest": "1,2395",
    "lower": "1,2220",
    "difference": "-0,61%"
  },
  {
    "date": "15.05.2008",
    "now": "1,2375",
    "open": "1,2530",
    "highest": "1,2570",
    "lower": "1,2350",
    "difference": "-1,25%"
  },
  {
    "date": "14.05.2008",
    "now": "1,2532",
    "open": "1,2465",
    "highest": "1,2610",
    "lower": "1,2430",
    "difference": "0,50%"
  },
  {
    "date": "13.05.2008",
    "now": "1,2470",
    "open": "1,2562",
    "highest": "1,2569",
    "lower": "1,2445",
    "difference": "-0,67%"
  },
  {
    "date": "12.05.2008",
    "now": "1,2554",
    "open": "1,2690",
    "highest": "1,2702",
    "lower": "1,2515",
    "difference": "-0,84%"
  },
  {
    "date": "09.05.2008",
    "now": "1,2660",
    "open": "1,2628",
    "highest": "1,2754",
    "lower": "1,2593",
    "difference": "0,18%"
  },
  {
    "date": "08.05.2008",
    "now": "1,2637",
    "open": "1,2582",
    "highest": "1,2725",
    "lower": "1,2515",
    "difference": "0,27%"
  },
  {
    "date": "07.05.2008",
    "now": "1,2603",
    "open": "1,2520",
    "highest": "1,2612",
    "lower": "1,2425",
    "difference": "0,49%"
  },
  {
    "date": "06.05.2008",
    "now": "1,2541",
    "open": "1,2631",
    "highest": "1,2657",
    "lower": "1,2480",
    "difference": "-0,78%"
  },
  {
    "date": "05.05.2008",
    "now": "1,2639",
    "open": "1,2639",
    "highest": "1,2648",
    "lower": "1,2535",
    "difference": "0,05%"
  },
  {
    "date": "02.05.2008",
    "now": "1,2633",
    "open": "1,2751",
    "highest": "1,2775",
    "lower": "1,2500",
    "difference": "-1,05%"
  },
  {
    "date": "01.05.2008",
    "now": "1,2767",
    "open": "1,2721",
    "highest": "1,2817",
    "lower": "1,2715",
    "difference": "0,16%"
  },
  {
    "date": "30.04.2008",
    "now": "1,2747",
    "open": "1,2919",
    "highest": "1,2957",
    "lower": "1,2692",
    "difference": "-1,30%"
  },
  {
    "date": "29.04.2008",
    "now": "1,2915",
    "open": "1,2769",
    "highest": "1,2933",
    "lower": "1,2740",
    "difference": "1,14%"
  },
  {
    "date": "28.04.2008",
    "now": "1,2770",
    "open": "1,2825",
    "highest": "1,2855",
    "lower": "1,2725",
    "difference": "-0,49%"
  },
  {
    "date": "25.04.2008",
    "now": "1,2833",
    "open": "1,2876",
    "highest": "1,2960",
    "lower": "1,2805",
    "difference": "-0,34%"
  },
  {
    "date": "24.04.2008",
    "now": "1,2877",
    "open": "1,2935",
    "highest": "1,3022",
    "lower": "1,2812",
    "difference": "-0,49%"
  },
  {
    "date": "23.04.2008",
    "now": "1,2940",
    "open": "1,3072",
    "highest": "1,3072",
    "lower": "1,2883",
    "difference": "-0,98%"
  },
  {
    "date": "22.04.2008",
    "now": "1,3068",
    "open": "1,3146",
    "highest": "1,3196",
    "lower": "1,3016",
    "difference": "-0,53%"
  },
  {
    "date": "21.04.2008",
    "now": "1,3138",
    "open": "1,3142",
    "highest": "1,3188",
    "lower": "1,3040",
    "difference": "-0,32%"
  },
  {
    "date": "18.04.2008",
    "now": "1,3180",
    "open": "1,3275",
    "highest": "1,3360",
    "lower": "1,3045",
    "difference": "-0,70%"
  },
  {
    "date": "17.04.2008",
    "now": "1,3273",
    "open": "1,3221",
    "highest": "1,3342",
    "lower": "1,3145",
    "difference": "0,45%"
  },
  {
    "date": "16.04.2008",
    "now": "1,3213",
    "open": "1,3193",
    "highest": "1,3329",
    "lower": "1,3105",
    "difference": "0,17%"
  },
  {
    "date": "15.04.2008",
    "now": "1,3191",
    "open": "1,3119",
    "highest": "1,3243",
    "lower": "1,3035",
    "difference": "0,41%"
  },
  {
    "date": "14.04.2008",
    "now": "1,3137",
    "open": "1,3063",
    "highest": "1,3185",
    "lower": "1,3020",
    "difference": "0,55%"
  },
  {
    "date": "11.04.2008",
    "now": "1,3065",
    "open": "1,3020",
    "highest": "1,3137",
    "lower": "1,2890",
    "difference": "0,20%"
  },
  {
    "date": "10.04.2008",
    "now": "1,3039",
    "open": "1,3034",
    "highest": "1,3182",
    "lower": "1,2931",
    "difference": "-0,05%"
  },
  {
    "date": "09.04.2008",
    "now": "1,3045",
    "open": "1,2925",
    "highest": "1,3062",
    "lower": "1,2840",
    "difference": "0,94%"
  },
  {
    "date": "08.04.2008",
    "now": "1,2923",
    "open": "1,2855",
    "highest": "1,2947",
    "lower": "1,2773",
    "difference": "0,54%"
  },
  {
    "date": "07.04.2008",
    "now": "1,2853",
    "open": "1,2893",
    "highest": "1,2893",
    "lower": "1,2685",
    "difference": "-0,56%"
  },
  {
    "date": "04.04.2008",
    "now": "1,2926",
    "open": "1,3035",
    "highest": "1,3035",
    "lower": "1,2800",
    "difference": "-0,62%"
  },
  {
    "date": "03.04.2008",
    "now": "1,3007",
    "open": "1,2895",
    "highest": "1,3095",
    "lower": "1,2700",
    "difference": "0,70%"
  },
  {
    "date": "02.04.2008",
    "now": "1,2917",
    "open": "1,3060",
    "highest": "1,3060",
    "lower": "1,2800",
    "difference": "-1,02%"
  },
  {
    "date": "01.04.2008",
    "now": "1,3050",
    "open": "1,3313",
    "highest": "1,3467",
    "lower": "1,3023",
    "difference": "-2,23%"
  },
  {
    "date": "31.03.2008",
    "now": "1,3347",
    "open": "1,2955",
    "highest": "1,3400",
    "lower": "1,2916",
    "difference": "2,79%"
  },
  {
    "date": "28.03.2008",
    "now": "1,2985",
    "open": "1,2721",
    "highest": "1,3066",
    "lower": "1,2645",
    "difference": "1,52%"
  },
  {
    "date": "27.03.2008",
    "now": "1,2790",
    "open": "1,2787",
    "highest": "1,2820",
    "lower": "1,2522",
    "difference": "0,12%"
  },
  {
    "date": "26.03.2008",
    "now": "1,2775",
    "open": "1,2570",
    "highest": "1,2800",
    "lower": "1,2525",
    "difference": "1,55%"
  },
  {
    "date": "25.03.2008",
    "now": "1,2580",
    "open": "1,2355",
    "highest": "1,2600",
    "lower": "1,2270",
    "difference": "1,21%"
  },
  {
    "date": "24.03.2008",
    "now": "1,2430",
    "open": "1,2475",
    "highest": "1,2475",
    "lower": "1,2315",
    "difference": "-0,70%"
  },
  {
    "date": "21.03.2008",
    "now": "1,2518",
    "open": "1,2465",
    "highest": "1,2555",
    "lower": "1,2380",
    "difference": "0,42%"
  },
  {
    "date": "20.03.2008",
    "now": "1,2466",
    "open": "1,2428",
    "highest": "1,2589",
    "lower": "1,2328",
    "difference": "0,18%"
  },
  {
    "date": "19.03.2008",
    "now": "1,2443",
    "open": "1,2189",
    "highest": "1,2452",
    "lower": "1,2178",
    "difference": "2,22%"
  },
  {
    "date": "18.03.2008",
    "now": "1,2173",
    "open": "1,2602",
    "highest": "1,2637",
    "lower": "1,2163",
    "difference": "-3,49%"
  },
  {
    "date": "17.03.2008",
    "now": "1,2613",
    "open": "1,2430",
    "highest": "1,2760",
    "lower": "1,2395",
    "difference": "1,72%"
  },
  {
    "date": "14.03.2008",
    "now": "1,2400",
    "open": "1,2240",
    "highest": "1,2475",
    "lower": "1,2135",
    "difference": "1,37%"
  },
  {
    "date": "13.03.2008",
    "now": "1,2233",
    "open": "1,2218",
    "highest": "1,2489",
    "lower": "1,2161",
    "difference": "-0,24%"
  },
  {
    "date": "12.03.2008",
    "now": "1,2263",
    "open": "1,2223",
    "highest": "1,2300",
    "lower": "1,2125",
    "difference": "0,62%"
  },
  {
    "date": "11.03.2008",
    "now": "1,2187",
    "open": "1,2595",
    "highest": "1,2700",
    "lower": "1,2181",
    "difference": "-3,30%"
  },
  {
    "date": "10.03.2008",
    "now": "1,2603",
    "open": "1,2468",
    "highest": "1,2643",
    "lower": "1,2320",
    "difference": "0,72%"
  },
  {
    "date": "07.03.2008",
    "now": "1,2513",
    "open": "1,2547",
    "highest": "1,2648",
    "lower": "1,2324",
    "difference": "-0,12%"
  },
  {
    "date": "06.03.2008",
    "now": "1,2528",
    "open": "1,2105",
    "highest": "1,2533",
    "lower": "1,2030",
    "difference": "3,57%"
  },
  {
    "date": "05.03.2008",
    "now": "1,2096",
    "open": "1,2198",
    "highest": "1,2274",
    "lower": "1,2055",
    "difference": "-0,92%"
  },
  {
    "date": "04.03.2008",
    "now": "1,2208",
    "open": "1,2170",
    "highest": "1,2297",
    "lower": "1,2005",
    "difference": "0,42%"
  },
  {
    "date": "03.03.2008",
    "now": "1,2157",
    "open": "1,2248",
    "highest": "1,2389",
    "lower": "1,2077",
    "difference": "-0,39%"
  },
  {
    "date": "29.02.2008",
    "now": "1,2205",
    "open": "1,1790",
    "highest": "1,2225",
    "lower": "1,1765",
    "difference": "3,21%"
  },
  {
    "date": "28.02.2008",
    "now": "1,1825",
    "open": "1,1779",
    "highest": "1,1884",
    "lower": "1,1773",
    "difference": "0,36%"
  },
  {
    "date": "27.02.2008",
    "now": "1,1782",
    "open": "1,1852",
    "highest": "1,1915",
    "lower": "1,1767",
    "difference": "-0,67%"
  },
  {
    "date": "26.02.2008",
    "now": "1,1862",
    "open": "1,1938",
    "highest": "1,2010",
    "lower": "1,1814",
    "difference": "-0,87%"
  },
  {
    "date": "25.02.2008",
    "now": "1,1966",
    "open": "1,2047",
    "highest": "1,2069",
    "lower": "1,1887",
    "difference": "-0,50%"
  },
  {
    "date": "22.02.2008",
    "now": "1,2026",
    "open": "1,2114",
    "highest": "1,2141",
    "lower": "1,2007",
    "difference": "-0,44%"
  },
  {
    "date": "21.02.2008",
    "now": "1,2079",
    "open": "1,2058",
    "highest": "1,2110",
    "lower": "1,1955",
    "difference": "0,07%"
  },
  {
    "date": "20.02.2008",
    "now": "1,2071",
    "open": "1,1972",
    "highest": "1,2237",
    "lower": "1,1947",
    "difference": "0,87%"
  },
  {
    "date": "19.02.2008",
    "now": "1,1967",
    "open": "1,1876",
    "highest": "1,1985",
    "lower": "1,1820",
    "difference": "0,45%"
  },
  {
    "date": "18.02.2008",
    "now": "1,1913",
    "open": "1,1986",
    "highest": "1,1995",
    "lower": "1,1870",
    "difference": "-0,60%"
  },
  {
    "date": "15.02.2008",
    "now": "1,1985",
    "open": "1,1969",
    "highest": "1,2051",
    "lower": "1,1855",
    "difference": "-0,27%"
  },
  {
    "date": "14.02.2008",
    "now": "1,2018",
    "open": "1,2033",
    "highest": "1,2058",
    "lower": "1,1898",
    "difference": "0,15%"
  },
  {
    "date": "13.02.2008",
    "now": "1,2000",
    "open": "1,2100",
    "highest": "1,2165",
    "lower": "1,1940",
    "difference": "-1,03%"
  },
  {
    "date": "12.02.2008",
    "now": "1,2125",
    "open": "1,2229",
    "highest": "1,2275",
    "lower": "1,2035",
    "difference": "-0,95%"
  },
  {
    "date": "11.02.2008",
    "now": "1,2241",
    "open": "1,2248",
    "highest": "1,2437",
    "lower": "1,2193",
    "difference": "0,27%"
  },
  {
    "date": "08.02.2008",
    "now": "1,2208",
    "open": "1,2012",
    "highest": "1,2257",
    "lower": "1,1937",
    "difference": "1,45%"
  },
  {
    "date": "07.02.2008",
    "now": "1,2033",
    "open": "1,1879",
    "highest": "1,2157",
    "lower": "1,1839",
    "difference": "1,29%"
  },
  {
    "date": "06.02.2008",
    "now": "1,1880",
    "open": "1,1838",
    "highest": "1,1947",
    "lower": "1,1790",
    "difference": "0,08%"
  },
  {
    "date": "05.02.2008",
    "now": "1,1871",
    "open": "1,1709",
    "highest": "1,1915",
    "lower": "1,1637",
    "difference": "1,78%"
  },
  {
    "date": "04.02.2008",
    "now": "1,1663",
    "open": "1,1725",
    "highest": "1,1743",
    "lower": "1,1612",
    "difference": "-0,36%"
  },
  {
    "date": "01.02.2008",
    "now": "1,1705",
    "open": "1,1686",
    "highest": "1,1738",
    "lower": "1,1595",
    "difference": "-0,09%"
  },
  {
    "date": "31.01.2008",
    "now": "1,1715",
    "open": "1,1688",
    "highest": "1,1860",
    "lower": "1,1643",
    "difference": "0,16%"
  },
  {
    "date": "30.01.2008",
    "now": "1,1696",
    "open": "1,1755",
    "highest": "1,1850",
    "lower": "1,1627",
    "difference": "-0,63%"
  },
  {
    "date": "29.01.2008",
    "now": "1,1770",
    "open": "1,1813",
    "highest": "1,1871",
    "lower": "1,1700",
    "difference": "-0,69%"
  },
  {
    "date": "28.01.2008",
    "now": "1,1852",
    "open": "1,1886",
    "highest": "1,2012",
    "lower": "1,1844",
    "difference": "-0,44%"
  },
  {
    "date": "25.01.2008",
    "now": "1,1904",
    "open": "1,1789",
    "highest": "1,1952",
    "lower": "1,1747",
    "difference": "0,92%"
  },
  {
    "date": "24.01.2008",
    "now": "1,1795",
    "open": "1,1896",
    "highest": "1,2030",
    "lower": "1,1730",
    "difference": "-2,54%"
  },
  {
    "date": "23.01.2008",
    "now": "1,2102",
    "open": "1,1961",
    "highest": "1,2206",
    "lower": "1,1873",
    "difference": "1,02%"
  },
  {
    "date": "22.01.2008",
    "now": "1,1980",
    "open": "1,2184",
    "highest": "1,2485",
    "lower": "1,1904",
    "difference": "-1,98%"
  },
  {
    "date": "21.01.2008",
    "now": "1,2222",
    "open": "1,1907",
    "highest": "1,2243",
    "lower": "1,1867",
    "difference": "2,87%"
  },
  {
    "date": "18.01.2008",
    "now": "1,1881",
    "open": "1,1831",
    "highest": "1,1920",
    "lower": "1,1765",
    "difference": "0,22%"
  },
  {
    "date": "17.01.2008",
    "now": "1,1855",
    "open": "1,1771",
    "highest": "1,1893",
    "lower": "1,1675",
    "difference": "0,32%"
  },
  {
    "date": "16.01.2008",
    "now": "1,1817",
    "open": "1,1538",
    "highest": "1,1847",
    "lower": "1,1495",
    "difference": "2,22%"
  },
  {
    "date": "15.01.2008",
    "now": "1,1560",
    "open": "1,1476",
    "highest": "1,1577",
    "lower": "1,1430",
    "difference": "0,41%"
  },
  {
    "date": "14.01.2008",
    "now": "1,1513",
    "open": "1,1473",
    "highest": "1,1540",
    "lower": "1,1427",
    "difference": "-0,11%"
  },
  {
    "date": "11.01.2008",
    "now": "1,1526",
    "open": "1,1455",
    "highest": "1,1549",
    "lower": "1,1431",
    "difference": "0,21%"
  },
  {
    "date": "10.01.2008",
    "now": "1,1502",
    "open": "1,1549",
    "highest": "1,1630",
    "lower": "1,1456",
    "difference": "-0,80%"
  },
  {
    "date": "09.01.2008",
    "now": "1,1595",
    "open": "1,1635",
    "highest": "1,1662",
    "lower": "1,1520",
    "difference": "-0,44%"
  },
  {
    "date": "08.01.2008",
    "now": "1,1646",
    "open": "1,1645",
    "highest": "1,1684",
    "lower": "1,1524",
    "difference": "-0,39%"
  },
  {
    "date": "07.01.2008",
    "now": "1,1692",
    "open": "1,1658",
    "highest": "1,1744",
    "lower": "1,1647",
    "difference": "-0,35%"
  },
  {
    "date": "04.01.2008",
    "now": "1,1733",
    "open": "1,1663",
    "highest": "1,1738",
    "lower": "1,1533",
    "difference": "0,39%"
  },
  {
    "date": "03.01.2008",
    "now": "1,1688",
    "open": "1,1707",
    "highest": "1,1787",
    "lower": "1,1658",
    "difference": "-0,15%"
  },
  {
    "date": "02.01.2008",
    "now": "1,1705",
    "open": "1,1721",
    "highest": "1,1770",
    "lower": "1,1636",
    "difference": "-0,09%"
  },
  {
    "date": "01.01.2008",
    "now": "1,1715",
    "open": "1,1685",
    "highest": "1,1725",
    "lower": "1,1685",
    "difference": "0,33%"
  },
  {
    "date": "31.12.2007",
    "now": "1,1677",
    "open": "1,1671",
    "highest": "1,1763",
    "lower": "1,1603",
    "difference": "-0,24%"
  },
  {
    "date": "28.12.2007",
    "now": "1,1705",
    "open": "1,1705",
    "highest": "1,1784",
    "lower": "1,1654",
    "difference": "-0,49%"
  },
  {
    "date": "27.12.2007",
    "now": "1,1763",
    "open": "1,1763",
    "highest": "1,1793",
    "lower": "1,1688",
    "difference": "-0,25%"
  },
  {
    "date": "26.12.2007",
    "now": "1,1793",
    "open": "1,1808",
    "highest": "1,1818",
    "lower": "1,1698",
    "difference": "-0,25%"
  },
  {
    "date": "25.12.2007",
    "now": "1,1823",
    "open": "1,1845",
    "highest": "1,1857",
    "lower": "1,1783",
    "difference": "-0,19%"
  },
  {
    "date": "24.12.2007",
    "now": "1,1845",
    "open": "1,1889",
    "highest": "1,1925",
    "lower": "1,1805",
    "difference": "-0,30%"
  },
  {
    "date": "21.12.2007",
    "now": "1,1881",
    "open": "1,1894",
    "highest": "1,1946",
    "lower": "1,1845",
    "difference": "-0,39%"
  },
  {
    "date": "20.12.2007",
    "now": "1,1927",
    "open": "1,1877",
    "highest": "1,1973",
    "lower": "1,1877",
    "difference": "0,06%"
  },
  {
    "date": "19.12.2007",
    "now": "1,1920",
    "open": "1,1842",
    "highest": "1,1972",
    "lower": "1,1842",
    "difference": "0,31%"
  },
  {
    "date": "18.12.2007",
    "now": "1,1883",
    "open": "1,1915",
    "highest": "1,1947",
    "lower": "1,1813",
    "difference": "-0,45%"
  },
  {
    "date": "17.12.2007",
    "now": "1,1937",
    "open": "1,1826",
    "highest": "1,1949",
    "lower": "1,1825",
    "difference": "0,56%"
  },
  {
    "date": "14.12.2007",
    "now": "1,1870",
    "open": "1,1745",
    "highest": "1,1885",
    "lower": "1,1710",
    "difference": "1,03%"
  },
  {
    "date": "13.12.2007",
    "now": "1,1749",
    "open": "1,1688",
    "highest": "1,1803",
    "lower": "1,1641",
    "difference": "0,33%"
  },
  {
    "date": "12.12.2007",
    "now": "1,1710",
    "open": "1,1825",
    "highest": "1,1851",
    "lower": "1,1630",
    "difference": "-0,91%"
  },
  {
    "date": "11.12.2007",
    "now": "1,1818",
    "open": "1,1643",
    "highest": "1,1822",
    "lower": "1,1608",
    "difference": "1,32%"
  },
  {
    "date": "10.12.2007",
    "now": "1,1664",
    "open": "1,1730",
    "highest": "1,1776",
    "lower": "1,1650",
    "difference": "-0,57%"
  },
  {
    "date": "07.12.2007",
    "now": "1,1731",
    "open": "1,1732",
    "highest": "1,1788",
    "lower": "1,1671",
    "difference": "-0,16%"
  },
  {
    "date": "06.12.2007",
    "now": "1,1750",
    "open": "1,1778",
    "highest": "1,1806",
    "lower": "1,1717",
    "difference": "-0,30%"
  },
  {
    "date": "05.12.2007",
    "now": "1,1785",
    "open": "1,1822",
    "highest": "1,1855",
    "lower": "1,1724",
    "difference": "-0,62%"
  },
  {
    "date": "04.12.2007",
    "now": "1,1859",
    "open": "1,1795",
    "highest": "1,1899",
    "lower": "1,1749",
    "difference": "0,12%"
  },
  {
    "date": "03.12.2007",
    "now": "1,1845",
    "open": "1,1823",
    "highest": "1,1875",
    "lower": "1,1730",
    "difference": "0,08%"
  },
  {
    "date": "30.11.2007",
    "now": "1,1835",
    "open": "1,1835",
    "highest": "1,1865",
    "lower": "1,1687",
    "difference": "-0,15%"
  },
  {
    "date": "29.11.2007",
    "now": "1,1853",
    "open": "1,1858",
    "highest": "1,1984",
    "lower": "1,1816",
    "difference": "-0,08%"
  },
  {
    "date": "28.11.2007",
    "now": "1,1863",
    "open": "1,2143",
    "highest": "1,2193",
    "lower": "1,1819",
    "difference": "-2,61%"
  },
  {
    "date": "27.11.2007",
    "now": "1,2181",
    "open": "1,2215",
    "highest": "1,2342",
    "lower": "1,2070",
    "difference": "-0,32%"
  },
  {
    "date": "26.11.2007",
    "now": "1,2220",
    "open": "1,1986",
    "highest": "1,2282",
    "lower": "1,1865",
    "difference": "1,81%"
  },
  {
    "date": "23.11.2007",
    "now": "1,2003",
    "open": "1,1993",
    "highest": "1,2102",
    "lower": "1,1892",
    "difference": "0,19%"
  },
  {
    "date": "22.11.2007",
    "now": "1,1980",
    "open": "1,2075",
    "highest": "1,2075",
    "lower": "1,1915",
    "difference": "-0,82%"
  },
  {
    "date": "21.11.2007",
    "now": "1,2079",
    "open": "1,1833",
    "highest": "1,2136",
    "lower": "1,1828",
    "difference": "1,42%"
  },
  {
    "date": "20.11.2007",
    "now": "1,1910",
    "open": "1,1995",
    "highest": "1,2001",
    "lower": "1,1870",
    "difference": "-0,73%"
  },
  {
    "date": "19.11.2007",
    "now": "1,1997",
    "open": "1,1865",
    "highest": "1,2050",
    "lower": "1,1810",
    "difference": "1,11%"
  },
  {
    "date": "16.11.2007",
    "now": "1,1865",
    "open": "1,1905",
    "highest": "1,1965",
    "lower": "1,1795",
    "difference": "-0,46%"
  },
  {
    "date": "15.11.2007",
    "now": "1,1920",
    "open": "1,1755",
    "highest": "1,1955",
    "lower": "1,1685",
    "difference": "1,29%"
  },
  {
    "date": "14.11.2007",
    "now": "1,1768",
    "open": "1,1879",
    "highest": "1,1885",
    "lower": "1,1670",
    "difference": "-0,87%"
  },
  {
    "date": "13.11.2007",
    "now": "1,1871",
    "open": "1,2168",
    "highest": "1,2201",
    "lower": "1,1860",
    "difference": "-2,47%"
  },
  {
    "date": "12.11.2007",
    "now": "1,2172",
    "open": "1,2003",
    "highest": "1,2203",
    "lower": "1,1983",
    "difference": "1,31%"
  },
  {
    "date": "09.11.2007",
    "now": "1,2015",
    "open": "1,1814",
    "highest": "1,2049",
    "lower": "1,1725",
    "difference": "1,55%"
  },
  {
    "date": "08.11.2007",
    "now": "1,1832",
    "open": "1,1910",
    "highest": "1,1990",
    "lower": "1,1745",
    "difference": "-0,45%"
  },
  {
    "date": "07.11.2007",
    "now": "1,1885",
    "open": "1,1738",
    "highest": "1,1896",
    "lower": "1,1641",
    "difference": "1,34%"
  },
  {
    "date": "06.11.2007",
    "now": "1,1728",
    "open": "1,1885",
    "highest": "1,1896",
    "lower": "1,1685",
    "difference": "-1,32%"
  },
  {
    "date": "05.11.2007",
    "now": "1,1885",
    "open": "1,1810",
    "highest": "1,1957",
    "lower": "1,1810",
    "difference": "0,50%"
  },
  {
    "date": "02.11.2007",
    "now": "1,1826",
    "open": "1,1854",
    "highest": "1,1922",
    "lower": "1,1749",
    "difference": "0,17%"
  },
  {
    "date": "01.11.2007",
    "now": "1,1806",
    "open": "1,1652",
    "highest": "1,1890",
    "lower": "1,1625",
    "difference": "1,35%"
  },
  {
    "date": "31.10.2007",
    "now": "1,1649",
    "open": "1,1911",
    "highest": "1,1916",
    "lower": "1,1643",
    "difference": "-2,20%"
  },
  {
    "date": "30.10.2007",
    "now": "1,1911",
    "open": "1,1878",
    "highest": "1,1966",
    "lower": "1,1852",
    "difference": "0,25%"
  },
  {
    "date": "29.10.2007",
    "now": "1,1881",
    "open": "1,1898",
    "highest": "1,1943",
    "lower": "1,1872",
    "difference": "-0,14%"
  },
  {
    "date": "26.10.2007",
    "now": "1,1898",
    "open": "1,1927",
    "highest": "1,1967",
    "lower": "1,1807",
    "difference": "-0,25%"
  },
  {
    "date": "25.10.2007",
    "now": "1,1928",
    "open": "1,2135",
    "highest": "1,2153",
    "lower": "1,1903",
    "difference": "-1,59%"
  },
  {
    "date": "24.10.2007",
    "now": "1,2121",
    "open": "1,2097",
    "highest": "1,2248",
    "lower": "1,2063",
    "difference": "0,21%"
  },
  {
    "date": "23.10.2007",
    "now": "1,2096",
    "open": "1,2279",
    "highest": "1,2281",
    "lower": "1,2083",
    "difference": "-1,50%"
  },
  {
    "date": "22.10.2007",
    "now": "1,2280",
    "open": "1,2210",
    "highest": "1,2500",
    "lower": "1,2210",
    "difference": "0,95%"
  },
  {
    "date": "19.10.2007",
    "now": "1,2165",
    "open": "1,1977",
    "highest": "1,2210",
    "lower": "1,1963",
    "difference": "1,48%"
  },
  {
    "date": "18.10.2007",
    "now": "1,1988",
    "open": "1,2118",
    "highest": "1,2165",
    "lower": "1,1960",
    "difference": "-1,05%"
  },
  {
    "date": "17.10.2007",
    "now": "1,2115",
    "open": "1,2213",
    "highest": "1,2275",
    "lower": "1,1990",
    "difference": "-0,82%"
  },
  {
    "date": "16.10.2007",
    "now": "1,2215",
    "open": "1,2218",
    "highest": "1,2347",
    "lower": "1,2140",
    "difference": "0,05%"
  },
  {
    "date": "15.10.2007",
    "now": "1,2209",
    "open": "1,1941",
    "highest": "1,2310",
    "lower": "1,1920",
    "difference": "2,21%"
  },
  {
    "date": "12.10.2007",
    "now": "1,1945",
    "open": "1,1916",
    "highest": "1,2036",
    "lower": "1,1903",
    "difference": "0,30%"
  },
  {
    "date": "11.10.2007",
    "now": "1,1909",
    "open": "1,1876",
    "highest": "1,1985",
    "lower": "1,1816",
    "difference": "0,35%"
  },
  {
    "date": "10.10.2007",
    "now": "1,1868",
    "open": "1,1836",
    "highest": "1,1930",
    "lower": "1,1780",
    "difference": "0,33%"
  },
  {
    "date": "09.10.2007",
    "now": "1,1829",
    "open": "1,1897",
    "highest": "1,1970",
    "lower": "1,1815",
    "difference": "-0,45%"
  },
  {
    "date": "08.10.2007",
    "now": "1,1882",
    "open": "1,1781",
    "highest": "1,1930",
    "lower": "1,1781",
    "difference": "0,63%"
  },
  {
    "date": "05.10.2007",
    "now": "1,1808",
    "open": "1,2035",
    "highest": "1,2057",
    "lower": "1,1768",
    "difference": "-1,62%"
  },
  {
    "date": "04.10.2007",
    "now": "1,2002",
    "open": "1,2084",
    "highest": "1,2123",
    "lower": "1,1992",
    "difference": "-0,61%"
  },
  {
    "date": "03.10.2007",
    "now": "1,2076",
    "open": "1,2105",
    "highest": "1,2115",
    "lower": "1,1955",
    "difference": "-0,23%"
  },
  {
    "date": "02.10.2007",
    "now": "1,2104",
    "open": "1,2012",
    "highest": "1,2180",
    "lower": "1,1985",
    "difference": "0,77%"
  },
  {
    "date": "01.10.2007",
    "now": "1,2011",
    "open": "1,2070",
    "highest": "1,2119",
    "lower": "1,1990",
    "difference": "-0,50%"
  },
  {
    "date": "28.09.2007",
    "now": "1,2071",
    "open": "1,2147",
    "highest": "1,2194",
    "lower": "1,2025",
    "difference": "-0,72%"
  },
  {
    "date": "27.09.2007",
    "now": "1,2159",
    "open": "1,2202",
    "highest": "1,2236",
    "lower": "1,2095",
    "difference": "-0,40%"
  },
  {
    "date": "26.09.2007",
    "now": "1,2208",
    "open": "1,2298",
    "highest": "1,2300",
    "lower": "1,2160",
    "difference": "-0,75%"
  },
  {
    "date": "25.09.2007",
    "now": "1,2300",
    "open": "1,2305",
    "highest": "1,2398",
    "lower": "1,2270",
    "difference": "0,20%"
  },
  {
    "date": "24.09.2007",
    "now": "1,2275",
    "open": "1,2231",
    "highest": "1,2306",
    "lower": "1,2180",
    "difference": "0,03%"
  },
  {
    "date": "21.09.2007",
    "now": "1,2271",
    "open": "1,2398",
    "highest": "1,2433",
    "lower": "1,2206",
    "difference": "-1,21%"
  },
  {
    "date": "20.09.2007",
    "now": "1,2421",
    "open": "1,2348",
    "highest": "1,2436",
    "lower": "1,2311",
    "difference": "0,61%"
  },
  {
    "date": "19.09.2007",
    "now": "1,2346",
    "open": "1,2396",
    "highest": "1,2464",
    "lower": "1,2286",
    "difference": "-0,32%"
  },
  {
    "date": "18.09.2007",
    "now": "1,2386",
    "open": "1,2699",
    "highest": "1,2775",
    "lower": "1,2371",
    "difference": "-2,53%"
  },
  {
    "date": "17.09.2007",
    "now": "1,2708",
    "open": "1,2626",
    "highest": "1,2735",
    "lower": "1,2586",
    "difference": "0,74%"
  },
  {
    "date": "14.09.2007",
    "now": "1,2615",
    "open": "1,2655",
    "highest": "1,2708",
    "lower": "1,2546",
    "difference": "-0,22%"
  },
  {
    "date": "13.09.2007",
    "now": "1,2643",
    "open": "1,2727",
    "highest": "1,2789",
    "lower": "1,2581",
    "difference": "-0,72%"
  },
  {
    "date": "12.09.2007",
    "now": "1,2735",
    "open": "1,2801",
    "highest": "1,2850",
    "lower": "1,2714",
    "difference": "-0,50%"
  },
  {
    "date": "11.09.2007",
    "now": "1,2799",
    "open": "1,2991",
    "highest": "1,3003",
    "lower": "1,2792",
    "difference": "-1,49%"
  },
  {
    "date": "10.09.2007",
    "now": "1,2993",
    "open": "1,3083",
    "highest": "1,3116",
    "lower": "1,2946",
    "difference": "-0,73%"
  },
  {
    "date": "07.09.2007",
    "now": "1,3088",
    "open": "1,2953",
    "highest": "1,3123",
    "lower": "1,2871",
    "difference": "0,96%"
  },
  {
    "date": "06.09.2007",
    "now": "1,2963",
    "open": "1,3063",
    "highest": "1,3077",
    "lower": "1,2946",
    "difference": "-0,77%"
  },
  {
    "date": "05.09.2007",
    "now": "1,3063",
    "open": "1,2963",
    "highest": "1,3161",
    "lower": "1,2956",
    "difference": "0,83%"
  },
  {
    "date": "04.09.2007",
    "now": "1,2955",
    "open": "1,2996",
    "highest": "1,3126",
    "lower": "1,2955",
    "difference": "-0,35%"
  },
  {
    "date": "03.09.2007",
    "now": "1,3001",
    "open": "1,3003",
    "highest": "1,3060",
    "lower": "1,2931",
    "difference": "-0,02%"
  },
  {
    "date": "31.08.2007",
    "now": "1,3003",
    "open": "1,3135",
    "highest": "1,3135",
    "lower": "1,2917",
    "difference": "-0,99%"
  },
  {
    "date": "30.08.2007",
    "now": "1,3133",
    "open": "1,3186",
    "highest": "1,3219",
    "lower": "1,3095",
    "difference": "0,05%"
  },
  {
    "date": "29.08.2007",
    "now": "1,3126",
    "open": "1,3405",
    "highest": "1,3440",
    "lower": "1,3126",
    "difference": "-2,03%"
  },
  {
    "date": "28.08.2007",
    "now": "1,3398",
    "open": "1,3208",
    "highest": "1,3417",
    "lower": "1,3180",
    "difference": "1,45%"
  },
  {
    "date": "27.08.2007",
    "now": "1,3206",
    "open": "1,3165",
    "highest": "1,3253",
    "lower": "1,3080",
    "difference": "0,35%"
  },
  {
    "date": "24.08.2007",
    "now": "1,3160",
    "open": "1,3285",
    "highest": "1,3383",
    "lower": "1,3152",
    "difference": "-0,87%"
  },
  {
    "date": "23.08.2007",
    "now": "1,3275",
    "open": "1,3295",
    "highest": "1,3377",
    "lower": "1,3120",
    "difference": "-0,08%"
  },
  {
    "date": "22.08.2007",
    "now": "1,3285",
    "open": "1,3580",
    "highest": "1,3590",
    "lower": "1,3285",
    "difference": "-2,45%"
  },
  {
    "date": "21.08.2007",
    "now": "1,3618",
    "open": "1,3680",
    "highest": "1,3852",
    "lower": "1,3545",
    "difference": "-0,38%"
  },
  {
    "date": "20.08.2007",
    "now": "1,3670",
    "open": "1,3480",
    "highest": "1,3749",
    "lower": "1,3350",
    "difference": "1,33%"
  },
  {
    "date": "17.08.2007",
    "now": "1,3490",
    "open": "1,4065",
    "highest": "1,4240",
    "lower": "1,3460",
    "difference": "-4,01%"
  },
  {
    "date": "16.08.2007",
    "now": "1,4053",
    "open": "1,3638",
    "highest": "1,4210",
    "lower": "1,3565",
    "difference": "3,16%"
  },
  {
    "date": "15.08.2007",
    "now": "1,3623",
    "open": "1,3276",
    "highest": "1,3658",
    "lower": "1,3220",
    "difference": "2,54%"
  },
  {
    "date": "14.08.2007",
    "now": "1,3285",
    "open": "1,2985",
    "highest": "1,3286",
    "lower": "1,2970",
    "difference": "3,26%"
  },
  {
    "date": "13.08.2007",
    "now": "1,2865",
    "open": "1,2938",
    "highest": "1,2961",
    "lower": "1,2790",
    "difference": "-0,60%"
  },
  {
    "date": "10.08.2007",
    "now": "1,2943",
    "open": "1,3060",
    "highest": "1,3135",
    "lower": "1,2855",
    "difference": "-0,74%"
  },
  {
    "date": "09.08.2007",
    "now": "1,3040",
    "open": "1,2543",
    "highest": "1,3040",
    "lower": "1,2485",
    "difference": "3,93%"
  },
  {
    "date": "08.08.2007",
    "now": "1,2547",
    "open": "1,2745",
    "highest": "1,2745",
    "lower": "1,2520",
    "difference": "-1,28%"
  },
  {
    "date": "07.08.2007",
    "now": "1,2710",
    "open": "1,2730",
    "highest": "1,2809",
    "lower": "1,2660",
    "difference": "-0,04%"
  },
  {
    "date": "06.08.2007",
    "now": "1,2715",
    "open": "1,2750",
    "highest": "1,3010",
    "lower": "1,2715",
    "difference": "-0,38%"
  },
  {
    "date": "03.08.2007",
    "now": "1,2763",
    "open": "1,2763",
    "highest": "1,2803",
    "lower": "1,2623",
    "difference": "-0,02%"
  },
  {
    "date": "02.08.2007",
    "now": "1,2765",
    "open": "1,2870",
    "highest": "1,2918",
    "lower": "1,2720",
    "difference": "-0,93%"
  },
  {
    "date": "01.08.2007",
    "now": "1,2885",
    "open": "1,3030",
    "highest": "1,3270",
    "lower": "1,2810",
    "difference": "0,33%"
  },
  {
    "date": "31.07.2007",
    "now": "1,2843",
    "open": "1,2870",
    "highest": "1,2928",
    "lower": "1,2680",
    "difference": "-0,65%"
  },
  {
    "date": "30.07.2007",
    "now": "1,2927",
    "open": "1,3070",
    "highest": "1,3255",
    "lower": "1,2920",
    "difference": "-0,60%"
  },
  {
    "date": "27.07.2007",
    "now": "1,3005",
    "open": "1,3016",
    "highest": "1,3306",
    "lower": "1,2916",
    "difference": "0,11%"
  },
  {
    "date": "26.07.2007",
    "now": "1,2991",
    "open": "1,2490",
    "highest": "1,3020",
    "lower": "1,2463",
    "difference": "3,89%"
  },
  {
    "date": "25.07.2007",
    "now": "1,2504",
    "open": "1,2495",
    "highest": "1,2620",
    "lower": "1,2390",
    "difference": "-0,41%"
  },
  {
    "date": "24.07.2007",
    "now": "1,2555",
    "open": "1,2500",
    "highest": "1,2565",
    "lower": "1,2315",
    "difference": "0,66%"
  },
  {
    "date": "23.07.2007",
    "now": "1,2473",
    "open": "1,2600",
    "highest": "1,2637",
    "lower": "1,2445",
    "difference": "-1,75%"
  },
  {
    "date": "20.07.2007",
    "now": "1,2695",
    "open": "1,2640",
    "highest": "1,2760",
    "lower": "1,2610",
    "difference": "0,40%"
  },
  {
    "date": "19.07.2007",
    "now": "1,2644",
    "open": "1,2750",
    "highest": "1,2790",
    "lower": "1,2610",
    "difference": "-0,79%"
  },
  {
    "date": "18.07.2007",
    "now": "1,2745",
    "open": "1,2785",
    "highest": "1,2818",
    "lower": "1,2705",
    "difference": "0,13%"
  },
  {
    "date": "17.07.2007",
    "now": "1,2728",
    "open": "1,2730",
    "highest": "1,2835",
    "lower": "1,2698",
    "difference": "0,20%"
  },
  {
    "date": "16.07.2007",
    "now": "1,2703",
    "open": "1,2685",
    "highest": "1,2765",
    "lower": "1,2655",
    "difference": "-0,06%"
  },
  {
    "date": "13.07.2007",
    "now": "1,2711",
    "open": "1,2762",
    "highest": "1,2786",
    "lower": "1,2677",
    "difference": "0,13%"
  },
  {
    "date": "12.07.2007",
    "now": "1,2695",
    "open": "1,2855",
    "highest": "1,2945",
    "lower": "1,2695",
    "difference": "-1,32%"
  },
  {
    "date": "11.07.2007",
    "now": "1,2865",
    "open": "1,2900",
    "highest": "1,2995",
    "lower": "1,2858",
    "difference": "-0,36%"
  },
  {
    "date": "10.07.2007",
    "now": "1,2912",
    "open": "1,2840",
    "highest": "1,2945",
    "lower": "1,2810",
    "difference": "0,64%"
  },
  {
    "date": "09.07.2007",
    "now": "1,2830",
    "open": "1,2900",
    "highest": "1,2910",
    "lower": "1,2780",
    "difference": "-0,49%"
  },
  {
    "date": "06.07.2007",
    "now": "1,2893",
    "open": "1,2960",
    "highest": "1,3034",
    "lower": "1,2875",
    "difference": "-0,66%"
  },
  {
    "date": "05.07.2007",
    "now": "1,2979",
    "open": "1,2915",
    "highest": "1,3027",
    "lower": "1,2870",
    "difference": "0,54%"
  },
  {
    "date": "04.07.2007",
    "now": "1,2909",
    "open": "1,2955",
    "highest": "1,2981",
    "lower": "1,2875",
    "difference": "-0,25%"
  },
  {
    "date": "03.07.2007",
    "now": "1,2942",
    "open": "1,2960",
    "highest": "1,2983",
    "lower": "1,2880",
    "difference": "-0,04%"
  },
  {
    "date": "02.07.2007",
    "now": "1,2947",
    "open": "1,3100",
    "highest": "1,3100",
    "lower": "1,2928",
    "difference": "-1,36%"
  },
  {
    "date": "29.06.2007",
    "now": "1,3125",
    "open": "1,3095",
    "highest": "1,3148",
    "lower": "1,2995",
    "difference": "-0,09%"
  },
  {
    "date": "28.06.2007",
    "now": "1,3137",
    "open": "1,3203",
    "highest": "1,3293",
    "lower": "1,3113",
    "difference": "-0,74%"
  },
  {
    "date": "27.06.2007",
    "now": "1,3235",
    "open": "1,3255",
    "highest": "1,3345",
    "lower": "1,3235",
    "difference": "0,20%"
  },
  {
    "date": "26.06.2007",
    "now": "1,3209",
    "open": "1,3278",
    "highest": "1,3319",
    "lower": "1,3183",
    "difference": "0,33%"
  },
  {
    "date": "25.06.2007",
    "now": "1,3165",
    "open": "1,3115",
    "highest": "1,3250",
    "lower": "1,3105",
    "difference": "0,30%"
  },
  {
    "date": "22.06.2007",
    "now": "1,3125",
    "open": "1,3065",
    "highest": "1,3155",
    "lower": "1,3035",
    "difference": "0,17%"
  },
  {
    "date": "21.06.2007",
    "now": "1,3103",
    "open": "1,3075",
    "highest": "1,3175",
    "lower": "1,3035",
    "difference": "0,56%"
  },
  {
    "date": "20.06.2007",
    "now": "1,3030",
    "open": "1,3025",
    "highest": "1,3060",
    "lower": "1,2955",
    "difference": "0,01%"
  },
  {
    "date": "19.06.2007",
    "now": "1,3029",
    "open": "1,3005",
    "highest": "1,3070",
    "lower": "1,2965",
    "difference": "0,17%"
  },
  {
    "date": "18.06.2007",
    "now": "1,3007",
    "open": "1,3062",
    "highest": "1,3083",
    "lower": "1,2963",
    "difference": "-0,60%"
  },
  {
    "date": "15.06.2007",
    "now": "1,3085",
    "open": "1,3225",
    "highest": "1,3280",
    "lower": "1,3035",
    "difference": "-1,13%"
  },
  {
    "date": "14.06.2007",
    "now": "1,3235",
    "open": "1,3340",
    "highest": "1,3400",
    "lower": "1,3210",
    "difference": "-0,79%"
  },
  {
    "date": "13.06.2007",
    "now": "1,3340",
    "open": "1,3440",
    "highest": "1,3540",
    "lower": "1,3335",
    "difference": "-0,22%"
  },
  {
    "date": "12.06.2007",
    "now": "1,3370",
    "open": "1,3365",
    "highest": "1,3440",
    "lower": "1,3295",
    "difference": "0,19%"
  },
  {
    "date": "11.06.2007",
    "now": "1,3345",
    "open": "1,3375",
    "highest": "1,3430",
    "lower": "1,3305",
    "difference": "-0,91%"
  },
  {
    "date": "08.06.2007",
    "now": "1,3467",
    "open": "1,3425",
    "highest": "1,3675",
    "lower": "1,3355",
    "difference": "0,75%"
  },
  {
    "date": "07.06.2007",
    "now": "1,3367",
    "open": "1,3203",
    "highest": "1,3367",
    "lower": "1,3133",
    "difference": "0,87%"
  },
  {
    "date": "06.06.2007",
    "now": "1,3252",
    "open": "1,3165",
    "highest": "1,3285",
    "lower": "1,3105",
    "difference": "0,69%"
  },
  {
    "date": "05.06.2007",
    "now": "1,3161",
    "open": "1,3145",
    "highest": "1,3180",
    "lower": "1,3080",
    "difference": "0,16%"
  },
  {
    "date": "04.06.2007",
    "now": "1,3140",
    "open": "1,3105",
    "highest": "1,3155",
    "lower": "1,3055",
    "difference": "0,21%"
  },
  {
    "date": "01.06.2007",
    "now": "1,3113",
    "open": "1,3150",
    "highest": "1,3225",
    "lower": "1,3075",
    "difference": "-0,47%"
  },
  {
    "date": "31.05.2007",
    "now": "1,3175",
    "open": "1,3265",
    "highest": "1,3365",
    "lower": "1,3160",
    "difference": "-0,68%"
  },
  {
    "date": "30.05.2007",
    "now": "1,3265",
    "open": "1,3325",
    "highest": "1,3380",
    "lower": "1,3240",
    "difference": "-0,22%"
  },
  {
    "date": "29.05.2007",
    "now": "1,3294",
    "open": "1,3240",
    "highest": "1,3320",
    "lower": "1,3165",
    "difference": "0,48%"
  },
  {
    "date": "28.05.2007",
    "now": "1,3230",
    "open": "1,3245",
    "highest": "1,3270",
    "lower": "1,3200",
    "difference": "-0,64%"
  },
  {
    "date": "25.05.2007",
    "now": "1,3315",
    "open": "1,3390",
    "highest": "1,3395",
    "lower": "1,3245",
    "difference": "-0,54%"
  },
  {
    "date": "24.05.2007",
    "now": "1,3387",
    "open": "1,3275",
    "highest": "1,3402",
    "lower": "1,3256",
    "difference": "0,73%"
  },
  {
    "date": "23.05.2007",
    "now": "1,3290",
    "open": "1,3300",
    "highest": "1,3308",
    "lower": "1,3175",
    "difference": "0,00%"
  },
  {
    "date": "22.05.2007",
    "now": "1,3290",
    "open": "1,3210",
    "highest": "1,3290",
    "lower": "1,3130",
    "difference": "0,51%"
  },
  {
    "date": "21.05.2007",
    "now": "1,3222",
    "open": "1,3242",
    "highest": "1,3277",
    "lower": "1,3162",
    "difference": "-0,30%"
  },
  {
    "date": "18.05.2007",
    "now": "1,3262",
    "open": "1,3265",
    "highest": "1,3353",
    "lower": "1,3225",
    "difference": "0,02%"
  },
  {
    "date": "17.05.2007",
    "now": "1,3260",
    "open": "1,3255",
    "highest": "1,3328",
    "lower": "1,3170",
    "difference": "0,04%"
  },
  {
    "date": "16.05.2007",
    "now": "1,3255",
    "open": "1,3205",
    "highest": "1,3295",
    "lower": "1,3133",
    "difference": "0,30%"
  },
  {
    "date": "15.05.2007",
    "now": "1,3215",
    "open": "1,3325",
    "highest": "1,3403",
    "lower": "1,3215",
    "difference": "-0,71%"
  },
  {
    "date": "14.05.2007",
    "now": "1,3310",
    "open": "1,3345",
    "highest": "1,3464",
    "lower": "1,3270",
    "difference": "-0,50%"
  },
  {
    "date": "11.05.2007",
    "now": "1,3377",
    "open": "1,3505",
    "highest": "1,3525",
    "lower": "1,3325",
    "difference": "-0,95%"
  },
  {
    "date": "10.05.2007",
    "now": "1,3505",
    "open": "1,3350",
    "highest": "1,3505",
    "lower": "1,3300",
    "difference": "1,24%"
  },
  {
    "date": "09.05.2007",
    "now": "1,3340",
    "open": "1,3355",
    "highest": "1,3408",
    "lower": "1,3325",
    "difference": "-0,15%"
  },
  {
    "date": "08.05.2007",
    "now": "1,3360",
    "open": "1,3365",
    "highest": "1,3435",
    "lower": "1,3305",
    "difference": "-0,04%"
  },
  {
    "date": "07.05.2007",
    "now": "1,3365",
    "open": "1,3450",
    "highest": "1,3465",
    "lower": "1,3335",
    "difference": "-0,96%"
  },
  {
    "date": "04.05.2007",
    "now": "1,3495",
    "open": "1,3530",
    "highest": "1,3598",
    "lower": "1,3435",
    "difference": "-0,37%"
  },
  {
    "date": "03.05.2007",
    "now": "1,3545",
    "open": "1,3535",
    "highest": "1,3591",
    "lower": "1,3465",
    "difference": "-0,07%"
  },
  {
    "date": "02.05.2007",
    "now": "1,3555",
    "open": "1,3535",
    "highest": "1,3655",
    "lower": "1,3475",
    "difference": "-0,05%"
  },
  {
    "date": "01.05.2007",
    "now": "1,3562",
    "open": "1,3708",
    "highest": "1,3887",
    "lower": "1,3448",
    "difference": "-0,61%"
  },
  {
    "date": "30.04.2007",
    "now": "1,3645",
    "open": "1,3565",
    "highest": "1,3945",
    "lower": "1,3565",
    "difference": "2,44%"
  },
  {
    "date": "27.04.2007",
    "now": "1,3320",
    "open": "1,3345",
    "highest": "1,3400",
    "lower": "1,3265",
    "difference": "-0,06%"
  },
  {
    "date": "26.04.2007",
    "now": "1,3328",
    "open": "1,3265",
    "highest": "1,3380",
    "lower": "1,3225",
    "difference": "0,39%"
  },
  {
    "date": "25.04.2007",
    "now": "1,3276",
    "open": "1,3385",
    "highest": "1,3412",
    "lower": "1,3245",
    "difference": "-0,85%"
  },
  {
    "date": "24.04.2007",
    "now": "1,3390",
    "open": "1,3395",
    "highest": "1,3505",
    "lower": "1,3340",
    "difference": "-0,22%"
  },
  {
    "date": "23.04.2007",
    "now": "1,3420",
    "open": "1,3415",
    "highest": "1,3425",
    "lower": "1,3400",
    "difference": "-0,02%"
  },
  {
    "date": "20.04.2007",
    "now": "1,3423",
    "open": "1,3505",
    "highest": "1,3507",
    "lower": "1,3355",
    "difference": "-0,70%"
  },
  {
    "date": "19.04.2007",
    "now": "1,3517",
    "open": "1,3570",
    "highest": "1,3650",
    "lower": "1,3475",
    "difference": "-0,02%"
  },
  {
    "date": "18.04.2007",
    "now": "1,3520",
    "open": "1,3465",
    "highest": "1,3570",
    "lower": "1,3395",
    "difference": "0,11%"
  },
  {
    "date": "17.04.2007",
    "now": "1,3505",
    "open": "1,3565",
    "highest": "1,3620",
    "lower": "1,3450",
    "difference": "-0,44%"
  },
  {
    "date": "16.04.2007",
    "now": "1,3565",
    "open": "1,3675",
    "highest": "1,3685",
    "lower": "1,3515",
    "difference": "-1,09%"
  },
  {
    "date": "13.04.2007",
    "now": "1,3715",
    "open": "1,3745",
    "highest": "1,3768",
    "lower": "1,3675",
    "difference": "-0,22%"
  },
  {
    "date": "12.04.2007",
    "now": "1,3745",
    "open": "1,3735",
    "highest": "1,3815",
    "lower": "1,3655",
    "difference": "0,09%"
  },
  {
    "date": "11.04.2007",
    "now": "1,3733",
    "open": "1,3690",
    "highest": "1,3740",
    "lower": "1,3640",
    "difference": "0,13%"
  },
  {
    "date": "10.04.2007",
    "now": "1,3715",
    "open": "1,3705",
    "highest": "1,3806",
    "lower": "1,3685",
    "difference": "-0,04%"
  },
  {
    "date": "09.04.2007",
    "now": "1,3720",
    "open": "1,3655",
    "highest": "1,3735",
    "lower": "1,3655",
    "difference": "0,20%"
  },
  {
    "date": "06.04.2007",
    "now": "1,3693",
    "open": "1,3670",
    "highest": "1,3710",
    "lower": "1,3620",
    "difference": "0,32%"
  },
  {
    "date": "05.04.2007",
    "now": "1,3650",
    "open": "1,3680",
    "highest": "1,3741",
    "lower": "1,3625",
    "difference": "-0,56%"
  },
  {
    "date": "04.04.2007",
    "now": "1,3727",
    "open": "1,3718",
    "highest": "1,3807",
    "lower": "1,3647",
    "difference": "0,13%"
  },
  {
    "date": "03.04.2007",
    "now": "1,3709",
    "open": "1,3855",
    "highest": "1,3877",
    "lower": "1,3680",
    "difference": "-1,36%"
  },
  {
    "date": "02.04.2007",
    "now": "1,3898",
    "open": "1,3892",
    "highest": "1,3938",
    "lower": "1,3827",
    "difference": "-0,16%"
  },
  {
    "date": "30.03.2007",
    "now": "1,3920",
    "open": "1,3870",
    "highest": "1,3960",
    "lower": "1,3795",
    "difference": "-0,06%"
  },
  {
    "date": "29.03.2007",
    "now": "1,3928",
    "open": "1,3930",
    "highest": "1,3956",
    "lower": "1,3850",
    "difference": "-0,12%"
  },
  {
    "date": "28.03.2007",
    "now": "1,3945",
    "open": "1,3905",
    "highest": "1,3996",
    "lower": "1,3875",
    "difference": "0,32%"
  },
  {
    "date": "27.03.2007",
    "now": "1,3900",
    "open": "1,3885",
    "highest": "1,3945",
    "lower": "1,3830",
    "difference": "0,11%"
  },
  {
    "date": "26.03.2007",
    "now": "1,3885",
    "open": "1,3845",
    "highest": "1,3915",
    "lower": "1,3790",
    "difference": "0,22%"
  },
  {
    "date": "23.03.2007",
    "now": "1,3855",
    "open": "1,3845",
    "highest": "1,3940",
    "lower": "1,3790",
    "difference": "0,03%"
  },
  {
    "date": "22.03.2007",
    "now": "1,3851",
    "open": "1,3845",
    "highest": "1,3876",
    "lower": "1,3765",
    "difference": "-0,17%"
  },
  {
    "date": "21.03.2007",
    "now": "1,3875",
    "open": "1,3995",
    "highest": "1,4057",
    "lower": "1,3865",
    "difference": "-0,82%"
  },
  {
    "date": "20.03.2007",
    "now": "1,3990",
    "open": "1,3950",
    "highest": "1,4025",
    "lower": "1,3875",
    "difference": "0,11%"
  },
  {
    "date": "19.03.2007",
    "now": "1,3975",
    "open": "1,4075",
    "highest": "1,4075",
    "lower": "1,3915",
    "difference": "-0,82%"
  },
  {
    "date": "16.03.2007",
    "now": "1,4090",
    "open": "1,4020",
    "highest": "1,4145",
    "lower": "1,4000",
    "difference": "0,35%"
  },
  {
    "date": "15.03.2007",
    "now": "1,4041",
    "open": "1,4215",
    "highest": "1,4215",
    "lower": "1,4010",
    "difference": "-1,22%"
  },
  {
    "date": "14.03.2007",
    "now": "1,4215",
    "open": "1,4325",
    "highest": "1,4360",
    "lower": "1,4170",
    "difference": "-0,25%"
  },
  {
    "date": "13.03.2007",
    "now": "1,4250",
    "open": "1,4055",
    "highest": "1,4255",
    "lower": "1,4030",
    "difference": "1,46%"
  },
  {
    "date": "12.03.2007",
    "now": "1,4045",
    "open": "1,4045",
    "highest": "1,4155",
    "lower": "1,3965",
    "difference": "-0,25%"
  },
  {
    "date": "09.03.2007",
    "now": "1,4080",
    "open": "1,4215",
    "highest": "1,4250",
    "lower": "1,4055",
    "difference": "-1,02%"
  },
  {
    "date": "08.03.2007",
    "now": "1,4225",
    "open": "1,4305",
    "highest": "1,4333",
    "lower": "1,4160",
    "difference": "-0,44%"
  },
  {
    "date": "07.03.2007",
    "now": "1,4288",
    "open": "1,4298",
    "highest": "1,4367",
    "lower": "1,4207",
    "difference": "-0,29%"
  },
  {
    "date": "06.03.2007",
    "now": "1,4330",
    "open": "1,4465",
    "highest": "1,4485",
    "lower": "1,4285",
    "difference": "-1,07%"
  },
  {
    "date": "05.03.2007",
    "now": "1,4485",
    "open": "1,4460",
    "highest": "1,4645",
    "lower": "1,4415",
    "difference": "1,01%"
  },
  {
    "date": "02.03.2007",
    "now": "1,4340",
    "open": "1,4180",
    "highest": "1,4348",
    "lower": "1,4120",
    "difference": "0,58%"
  },
  {
    "date": "01.03.2007",
    "now": "1,4257",
    "open": "1,4140",
    "highest": "1,4425",
    "lower": "1,4065",
    "difference": "0,90%"
  },
  {
    "date": "28.02.2007",
    "now": "1,4130",
    "open": "1,4140",
    "highest": "1,4350",
    "lower": "1,4070",
    "difference": "-0,46%"
  },
  {
    "date": "27.02.2007",
    "now": "1,4195",
    "open": "1,3845",
    "highest": "1,4195",
    "lower": "1,3825",
    "difference": "2,45%"
  },
  {
    "date": "26.02.2007",
    "now": "1,3855",
    "open": "1,3805",
    "highest": "1,3895",
    "lower": "1,3755",
    "difference": "0,22%"
  },
  {
    "date": "23.02.2007",
    "now": "1,3825",
    "open": "1,3805",
    "highest": "1,3870",
    "lower": "1,3775",
    "difference": "0,07%"
  },
  {
    "date": "22.02.2007",
    "now": "1,3816",
    "open": "1,3806",
    "highest": "1,3864",
    "lower": "1,3756",
    "difference": "-0,10%"
  },
  {
    "date": "21.02.2007",
    "now": "1,3830",
    "open": "1,3820",
    "highest": "1,3898",
    "lower": "1,3765",
    "difference": "-0,11%"
  },
  {
    "date": "20.02.2007",
    "now": "1,3845",
    "open": "1,3800",
    "highest": "1,3885",
    "lower": "1,3750",
    "difference": "0,22%"
  },
  {
    "date": "19.02.2007",
    "now": "1,3815",
    "open": "1,3865",
    "highest": "1,3905",
    "lower": "1,3775",
    "difference": "-0,38%"
  },
  {
    "date": "16.02.2007",
    "now": "1,3868",
    "open": "1,3905",
    "highest": "1,3943",
    "lower": "1,3825",
    "difference": "-0,50%"
  },
  {
    "date": "15.02.2007",
    "now": "1,3937",
    "open": "1,3885",
    "highest": "1,3958",
    "lower": "1,3815",
    "difference": "0,37%"
  },
  {
    "date": "14.02.2007",
    "now": "1,3885",
    "open": "1,3965",
    "highest": "1,4015",
    "lower": "1,3825",
    "difference": "-0,90%"
  },
  {
    "date": "13.02.2007",
    "now": "1,4011",
    "open": "1,4140",
    "highest": "1,4155",
    "lower": "1,3990",
    "difference": "-0,74%"
  },
  {
    "date": "12.02.2007",
    "now": "1,4116",
    "open": "1,4065",
    "highest": "1,4170",
    "lower": "1,4030",
    "difference": "0,51%"
  },
  {
    "date": "09.02.2007",
    "now": "1,4045",
    "open": "1,4035",
    "highest": "1,4050",
    "lower": "1,3915",
    "difference": "0,11%"
  },
  {
    "date": "08.02.2007",
    "now": "1,4030",
    "open": "1,4065",
    "highest": "1,4090",
    "lower": "1,3995",
    "difference": "-0,08%"
  },
  {
    "date": "07.02.2007",
    "now": "1,4041",
    "open": "1,4015",
    "highest": "1,4068",
    "lower": "1,3945",
    "difference": "0,22%"
  },
  {
    "date": "06.02.2007",
    "now": "1,4010",
    "open": "1,4005",
    "highest": "1,4053",
    "lower": "1,3935",
    "difference": "0,04%"
  },
  {
    "date": "05.02.2007",
    "now": "1,4005",
    "open": "1,4055",
    "highest": "1,4138",
    "lower": "1,3990",
    "difference": "-0,28%"
  },
  {
    "date": "02.02.2007",
    "now": "1,4045",
    "open": "1,4030",
    "highest": "1,4090",
    "lower": "1,3915",
    "difference": "-0,02%"
  },
  {
    "date": "01.02.2007",
    "now": "1,4048",
    "open": "1,4075",
    "highest": "1,4121",
    "lower": "1,3975",
    "difference": "-0,12%"
  },
  {
    "date": "31.01.2007",
    "now": "1,4065",
    "open": "1,4205",
    "highest": "1,4243",
    "lower": "1,4065",
    "difference": "-1,10%"
  },
  {
    "date": "30.01.2007",
    "now": "1,4221",
    "open": "1,4305",
    "highest": "1,4338",
    "lower": "1,4200",
    "difference": "-0,62%"
  },
  {
    "date": "29.01.2007",
    "now": "1,4310",
    "open": "1,4360",
    "highest": "1,4360",
    "lower": "1,4205",
    "difference": "-0,21%"
  },
  {
    "date": "26.01.2007",
    "now": "1,4340",
    "open": "1,4335",
    "highest": "1,4393",
    "lower": "1,4215",
    "difference": "0,42%"
  },
  {
    "date": "25.01.2007",
    "now": "1,4280",
    "open": "1,4125",
    "highest": "1,4285",
    "lower": "1,4095",
    "difference": "0,97%"
  },
  {
    "date": "24.01.2007",
    "now": "1,4143",
    "open": "1,4107",
    "highest": "1,4196",
    "lower": "1,4047",
    "difference": "0,09%"
  },
  {
    "date": "23.01.2007",
    "now": "1,4130",
    "open": "1,4135",
    "highest": "1,4168",
    "lower": "1,4045",
    "difference": "-0,18%"
  },
  {
    "date": "22.01.2007",
    "now": "1,4155",
    "open": "1,4115",
    "highest": "1,4170",
    "lower": "1,4015",
    "difference": "-0,04%"
  },
  {
    "date": "19.01.2007",
    "now": "1,4160",
    "open": "1,4185",
    "highest": "1,4223",
    "lower": "1,4095",
    "difference": "-0,30%"
  },
  {
    "date": "18.01.2007",
    "now": "1,4203",
    "open": "1,4250",
    "highest": "1,4280",
    "lower": "1,4170",
    "difference": "-0,42%"
  },
  {
    "date": "17.01.2007",
    "now": "1,4263",
    "open": "1,4307",
    "highest": "1,4365",
    "lower": "1,4223",
    "difference": "-0,43%"
  },
  {
    "date": "16.01.2007",
    "now": "1,4325",
    "open": "1,4250",
    "highest": "1,4363",
    "lower": "1,4200",
    "difference": "0,49%"
  },
  {
    "date": "15.01.2007",
    "now": "1,4255",
    "open": "1,4300",
    "highest": "1,4338",
    "lower": "1,4215",
    "difference": "-0,37%"
  },
  {
    "date": "12.01.2007",
    "now": "1,4308",
    "open": "1,4268",
    "highest": "1,4396",
    "lower": "1,4268",
    "difference": "-0,31%"
  },
  {
    "date": "11.01.2007",
    "now": "1,4353",
    "open": "1,4430",
    "highest": "1,4463",
    "lower": "1,4320",
    "difference": "-0,64%"
  },
  {
    "date": "10.01.2007",
    "now": "1,4445",
    "open": "1,4465",
    "highest": "1,4595",
    "lower": "1,4410",
    "difference": "-0,41%"
  },
  {
    "date": "09.01.2007",
    "now": "1,4505",
    "open": "1,4360",
    "highest": "1,4510",
    "lower": "1,4260",
    "difference": "1,01%"
  },
  {
    "date": "08.01.2007",
    "now": "1,4360",
    "open": "1,4475",
    "highest": "1,4568",
    "lower": "1,4350",
    "difference": "-0,59%"
  },
  {
    "date": "05.01.2007",
    "now": "1,4445",
    "open": "1,4230",
    "highest": "1,4520",
    "lower": "1,4220",
    "difference": "1,69%"
  },
  {
    "date": "04.01.2007",
    "now": "1,4205",
    "open": "1,4110",
    "highest": "1,4243",
    "lower": "1,4070",
    "difference": "0,74%"
  },
  {
    "date": "03.01.2007",
    "now": "1,4100",
    "open": "1,4078",
    "highest": "1,4114",
    "lower": "1,4060",
    "difference": "0,18%"
  },
  {
    "date": "02.01.2007",
    "now": "1,4075",
    "open": "1,4168",
    "highest": "1,4168",
    "lower": "1,4060",
    "difference": "-0,57%"
  },
  {
    "date": "01.01.2007",
    "now": "1,4155",
    "open": "1,4155",
    "highest": "1,4155",
    "lower": "1,4155",
    "difference": "0,00%"
  },
  {
    "date": "29.12.2006",
    "now": "1,4155",
    "open": "1,4120",
    "highest": "1,4185",
    "lower": "1,4065",
    "difference": "0,07%"
  },
  {
    "date": "28.12.2006",
    "now": "1,4145",
    "open": "1,4265",
    "highest": "1,4275",
    "lower": "1,4095",
    "difference": "-0,67%"
  },
  {
    "date": "27.12.2006",
    "now": "1,4240",
    "open": "1,4255",
    "highest": "1,4278",
    "lower": "1,4200",
    "difference": "-0,16%"
  },
  {
    "date": "26.12.2006",
    "now": "1,4263",
    "open": "1,4273",
    "highest": "1,4307",
    "lower": "1,4233",
    "difference": "0,06%"
  },
  {
    "date": "25.12.2006",
    "now": "1,4255",
    "open": "1,4285",
    "highest": "1,4335",
    "lower": "1,4235",
    "difference": "-0,21%"
  },
  {
    "date": "22.12.2006",
    "now": "1,4285",
    "open": "1,4295",
    "highest": "1,4344",
    "lower": "1,4210",
    "difference": "0,01%"
  },
  {
    "date": "21.12.2006",
    "now": "1,4283",
    "open": "1,4300",
    "highest": "1,4319",
    "lower": "1,4250",
    "difference": "0,04%"
  },
  {
    "date": "20.12.2006",
    "now": "1,4278",
    "open": "1,4282",
    "highest": "1,4331",
    "lower": "1,4228",
    "difference": "-0,36%"
  },
  {
    "date": "19.12.2006",
    "now": "1,4330",
    "open": "1,4325",
    "highest": "1,4400",
    "lower": "1,4280",
    "difference": "0,00%"
  },
  {
    "date": "18.12.2006",
    "now": "1,4330",
    "open": "1,4250",
    "highest": "1,4331",
    "lower": "1,4220",
    "difference": "0,46%"
  },
  {
    "date": "15.12.2006",
    "now": "1,4265",
    "open": "1,4200",
    "highest": "1,4275",
    "lower": "1,4150",
    "difference": "0,39%"
  },
  {
    "date": "14.12.2006",
    "now": "1,4210",
    "open": "1,4190",
    "highest": "1,4263",
    "lower": "1,4160",
    "difference": "-0,04%"
  },
  {
    "date": "13.12.2006",
    "now": "1,4215",
    "open": "1,4295",
    "highest": "1,4305",
    "lower": "1,4165",
    "difference": "-0,50%"
  },
  {
    "date": "12.12.2006",
    "now": "1,4287",
    "open": "1,4207",
    "highest": "1,4323",
    "lower": "1,4178",
    "difference": "0,44%"
  },
  {
    "date": "11.12.2006",
    "now": "1,4225",
    "open": "1,4355",
    "highest": "1,4400",
    "lower": "1,4205",
    "difference": "-0,66%"
  },
  {
    "date": "08.12.2006",
    "now": "1,4320",
    "open": "1,4340",
    "highest": "1,4395",
    "lower": "1,4260",
    "difference": "0,10%"
  },
  {
    "date": "07.12.2006",
    "now": "1,4306",
    "open": "1,4455",
    "highest": "1,4505",
    "lower": "1,4215",
    "difference": "-1,10%"
  },
  {
    "date": "06.12.2006",
    "now": "1,4465",
    "open": "1,4460",
    "highest": "1,4540",
    "lower": "1,4400",
    "difference": "-0,07%"
  },
  {
    "date": "05.12.2006",
    "now": "1,4475",
    "open": "1,4470",
    "highest": "1,4590",
    "lower": "1,4430",
    "difference": "-0,14%"
  },
  {
    "date": "04.12.2006",
    "now": "1,4495",
    "open": "1,4555",
    "highest": "1,4605",
    "lower": "1,4455",
    "difference": "-0,32%"
  },
  {
    "date": "01.12.2006",
    "now": "1,4542",
    "open": "1,4520",
    "highest": "1,4625",
    "lower": "1,4380",
    "difference": "0,03%"
  },
  {
    "date": "30.11.2006",
    "now": "1,4537",
    "open": "1,4623",
    "highest": "1,4642",
    "lower": "1,4442",
    "difference": "-0,81%"
  },
  {
    "date": "29.11.2006",
    "now": "1,4655",
    "open": "1,4705",
    "highest": "1,4765",
    "lower": "1,4605",
    "difference": "-0,44%"
  },
  {
    "date": "28.11.2006",
    "now": "1,4720",
    "open": "1,4720",
    "highest": "1,4910",
    "lower": "1,4720",
    "difference": "-0,37%"
  },
  {
    "date": "27.11.2006",
    "now": "1,4775",
    "open": "1,4655",
    "highest": "1,4775",
    "lower": "1,4595",
    "difference": "0,75%"
  },
  {
    "date": "24.11.2006",
    "now": "1,4665",
    "open": "1,4795",
    "highest": "1,4877",
    "lower": "1,4645",
    "difference": "-0,81%"
  },
  {
    "date": "23.11.2006",
    "now": "1,4785",
    "open": "1,4735",
    "highest": "1,4885",
    "lower": "1,4690",
    "difference": "0,14%"
  },
  {
    "date": "22.11.2006",
    "now": "1,4764",
    "open": "1,4610",
    "highest": "1,4800",
    "lower": "1,4570",
    "difference": "0,57%"
  },
  {
    "date": "21.11.2006",
    "now": "1,4680",
    "open": "1,4490",
    "highest": "1,4720",
    "lower": "1,4450",
    "difference": "1,17%"
  },
  {
    "date": "20.11.2006",
    "now": "1,4510",
    "open": "1,4425",
    "highest": "1,4610",
    "lower": "1,4425",
    "difference": "0,35%"
  },
  {
    "date": "17.11.2006",
    "now": "1,4460",
    "open": "1,4420",
    "highest": "1,4537",
    "lower": "1,4370",
    "difference": "0,24%"
  },
  {
    "date": "16.11.2006",
    "now": "1,4426",
    "open": "1,4450",
    "highest": "1,4500",
    "lower": "1,4320",
    "difference": "-0,27%"
  },
  {
    "date": "15.11.2006",
    "now": "1,4465",
    "open": "1,4465",
    "highest": "1,4535",
    "lower": "1,4425",
    "difference": "-0,31%"
  },
  {
    "date": "14.11.2006",
    "now": "1,4510",
    "open": "1,4485",
    "highest": "1,4533",
    "lower": "1,4420",
    "difference": "-0,14%"
  },
  {
    "date": "13.11.2006",
    "now": "1,4530",
    "open": "1,4530",
    "highest": "1,4535",
    "lower": "1,4435",
    "difference": "0,28%"
  },
  {
    "date": "10.11.2006",
    "now": "1,4490",
    "open": "1,4490",
    "highest": "1,4560",
    "lower": "1,4390",
    "difference": "0,03%"
  },
  {
    "date": "09.11.2006",
    "now": "1,4485",
    "open": "1,4525",
    "highest": "1,4565",
    "lower": "1,4420",
    "difference": "-0,52%"
  },
  {
    "date": "08.11.2006",
    "now": "1,4560",
    "open": "1,4445",
    "highest": "1,4595",
    "lower": "1,4435",
    "difference": "0,62%"
  },
  {
    "date": "07.11.2006",
    "now": "1,4470",
    "open": "1,4405",
    "highest": "1,4495",
    "lower": "1,4330",
    "difference": "0,16%"
  },
  {
    "date": "06.11.2006",
    "now": "1,4447",
    "open": "1,4560",
    "highest": "1,4560",
    "lower": "1,4420",
    "difference": "-0,45%"
  },
  {
    "date": "03.11.2006",
    "now": "1,4513",
    "open": "1,4680",
    "highest": "1,4745",
    "lower": "1,4405",
    "difference": "-1,44%"
  },
  {
    "date": "02.11.2006",
    "now": "1,4725",
    "open": "1,4545",
    "highest": "1,4770",
    "lower": "1,4505",
    "difference": "1,10%"
  },
  {
    "date": "01.11.2006",
    "now": "1,4565",
    "open": "1,4555",
    "highest": "1,4615",
    "lower": "1,4480",
    "difference": "-0,05%"
  },
  {
    "date": "31.10.2006",
    "now": "1,4572",
    "open": "1,4587",
    "highest": "1,4698",
    "lower": "1,4472",
    "difference": "-0,16%"
  },
  {
    "date": "30.10.2006",
    "now": "1,4595",
    "open": "1,4445",
    "highest": "1,4625",
    "lower": "1,4445",
    "difference": "1,04%"
  },
  {
    "date": "27.10.2006",
    "now": "1,4445",
    "open": "1,4425",
    "highest": "1,4535",
    "lower": "1,4415",
    "difference": "0,07%"
  },
  {
    "date": "26.10.2006",
    "now": "1,4435",
    "open": "1,4560",
    "highest": "1,4585",
    "lower": "1,4410",
    "difference": "-1,12%"
  },
  {
    "date": "25.10.2006",
    "now": "1,4598",
    "open": "1,4697",
    "highest": "1,4697",
    "lower": "1,4577",
    "difference": "-0,54%"
  },
  {
    "date": "24.10.2006",
    "now": "1,4677",
    "open": "1,4785",
    "highest": "1,4820",
    "lower": "1,4670",
    "difference": "0,01%"
  },
  {
    "date": "23.10.2006",
    "now": "1,4675",
    "open": "1,4618",
    "highest": "1,4715",
    "lower": "1,4618",
    "difference": "0,39%"
  },
  {
    "date": "20.10.2006",
    "now": "1,4618",
    "open": "1,4570",
    "highest": "1,4650",
    "lower": "1,4530",
    "difference": "0,21%"
  },
  {
    "date": "19.10.2006",
    "now": "1,4587",
    "open": "1,4658",
    "highest": "1,4688",
    "lower": "1,4523",
    "difference": "-0,60%"
  },
  {
    "date": "18.10.2006",
    "now": "1,4675",
    "open": "1,4785",
    "highest": "1,4855",
    "lower": "1,4595",
    "difference": "-1,01%"
  },
  {
    "date": "17.10.2006",
    "now": "1,4825",
    "open": "1,4780",
    "highest": "1,4855",
    "lower": "1,4675",
    "difference": "0,58%"
  },
  {
    "date": "16.10.2006",
    "now": "1,4740",
    "open": "1,4785",
    "highest": "1,4805",
    "lower": "1,4655",
    "difference": "0,24%"
  },
  {
    "date": "13.10.2006",
    "now": "1,4705",
    "open": "1,4770",
    "highest": "1,4775",
    "lower": "1,4595",
    "difference": "-0,10%"
  },
  {
    "date": "12.10.2006",
    "now": "1,4720",
    "open": "1,4915",
    "highest": "1,4965",
    "lower": "1,4695",
    "difference": "-0,98%"
  },
  {
    "date": "11.10.2006",
    "now": "1,4865",
    "open": "1,4875",
    "highest": "1,4985",
    "lower": "1,4825",
    "difference": "-0,25%"
  },
  {
    "date": "10.10.2006",
    "now": "1,4903",
    "open": "1,4970",
    "highest": "1,5030",
    "lower": "1,4890",
    "difference": "-0,55%"
  },
  {
    "date": "09.10.2006",
    "now": "1,4985",
    "open": "1,5015",
    "highest": "1,5075",
    "lower": "1,4950",
    "difference": "0,00%"
  },
  {
    "date": "06.10.2006",
    "now": "1,4985",
    "open": "1,4930",
    "highest": "1,5030",
    "lower": "1,4860",
    "difference": "0,13%"
  },
  {
    "date": "05.10.2006",
    "now": "1,4965",
    "open": "1,4965",
    "highest": "1,5050",
    "lower": "1,4885",
    "difference": "-0,60%"
  },
  {
    "date": "04.10.2006",
    "now": "1,5055",
    "open": "1,5145",
    "highest": "1,5250",
    "lower": "1,5035",
    "difference": "-0,69%"
  },
  {
    "date": "03.10.2006",
    "now": "1,5160",
    "open": "1,4990",
    "highest": "1,5185",
    "lower": "1,4935",
    "difference": "1,24%"
  },
  {
    "date": "02.10.2006",
    "now": "1,4975",
    "open": "1,5120",
    "highest": "1,5190",
    "lower": "1,4975",
    "difference": "-1,12%"
  },
  {
    "date": "29.09.2006",
    "now": "1,5145",
    "open": "1,5010",
    "highest": "1,5240",
    "lower": "1,4930",
    "difference": "0,58%"
  },
  {
    "date": "28.09.2006",
    "now": "1,5057",
    "open": "1,4920",
    "highest": "1,5115",
    "lower": "1,4880",
    "difference": "0,74%"
  },
  {
    "date": "27.09.2006",
    "now": "1,4947",
    "open": "1,5080",
    "highest": "1,5105",
    "lower": "1,4880",
    "difference": "-1,11%"
  },
  {
    "date": "26.09.2006",
    "now": "1,5115",
    "open": "1,5185",
    "highest": "1,5315",
    "lower": "1,5095",
    "difference": "-1,40%"
  },
  {
    "date": "25.09.2006",
    "now": "1,5330",
    "open": "1,5180",
    "highest": "1,5355",
    "lower": "1,5010",
    "difference": "0,79%"
  },
  {
    "date": "22.09.2006",
    "now": "1,5210",
    "open": "1,5090",
    "highest": "1,5510",
    "lower": "1,5040",
    "difference": "0,76%"
  },
  {
    "date": "21.09.2006",
    "now": "1,5095",
    "open": "1,4780",
    "highest": "1,5115",
    "lower": "1,4665",
    "difference": "2,55%"
  },
  {
    "date": "20.09.2006",
    "now": "1,4720",
    "open": "1,4720",
    "highest": "1,4790",
    "lower": "1,4655",
    "difference": "0,41%"
  },
  {
    "date": "19.09.2006",
    "now": "1,4660",
    "open": "1,4615",
    "highest": "1,4730",
    "lower": "1,4595",
    "difference": "0,10%"
  },
  {
    "date": "18.09.2006",
    "now": "1,4645",
    "open": "1,4645",
    "highest": "1,4665",
    "lower": "1,4565",
    "difference": "-0,37%"
  },
  {
    "date": "15.09.2006",
    "now": "1,4700",
    "open": "1,4740",
    "highest": "1,4795",
    "lower": "1,4610",
    "difference": "-0,02%"
  },
  {
    "date": "14.09.2006",
    "now": "1,4703",
    "open": "1,4785",
    "highest": "1,4870",
    "lower": "1,4645",
    "difference": "-0,01%"
  },
  {
    "date": "13.09.2006",
    "now": "1,4705",
    "open": "1,4785",
    "highest": "1,4795",
    "lower": "1,4640",
    "difference": "-0,07%"
  },
  {
    "date": "12.09.2006",
    "now": "1,4715",
    "open": "1,4805",
    "highest": "1,4820",
    "lower": "1,4645",
    "difference": "-1,06%"
  },
  {
    "date": "11.09.2006",
    "now": "1,4872",
    "open": "1,4785",
    "highest": "1,4940",
    "lower": "1,4720",
    "difference": "0,55%"
  },
  {
    "date": "08.09.2006",
    "now": "1,4790",
    "open": "1,4770",
    "highest": "1,4920",
    "lower": "1,4650",
    "difference": "0,46%"
  },
  {
    "date": "07.09.2006",
    "now": "1,4723",
    "open": "1,4690",
    "highest": "1,4855",
    "lower": "1,4670",
    "difference": "0,02%"
  },
  {
    "date": "06.09.2006",
    "now": "1,4720",
    "open": "1,4500",
    "highest": "1,4740",
    "lower": "1,4480",
    "difference": "1,57%"
  },
  {
    "date": "05.09.2006",
    "now": "1,4493",
    "open": "1,4540",
    "highest": "1,4550",
    "lower": "1,4430",
    "difference": "0,19%"
  },
  {
    "date": "04.09.2006",
    "now": "1,4465",
    "open": "1,4595",
    "highest": "1,4635",
    "lower": "1,4385",
    "difference": "-1,11%"
  },
  {
    "date": "01.09.2006",
    "now": "1,4628",
    "open": "1,4637",
    "highest": "1,4737",
    "lower": "1,4602",
    "difference": "-0,13%"
  },
  {
    "date": "31.08.2006",
    "now": "1,4647",
    "open": "1,4620",
    "highest": "1,4690",
    "lower": "1,4465",
    "difference": "0,11%"
  },
  {
    "date": "30.08.2006",
    "now": "1,4631",
    "open": "1,4798",
    "highest": "1,4800",
    "lower": "1,4631",
    "difference": "-1,19%"
  },
  {
    "date": "29.08.2006",
    "now": "1,4807",
    "open": "1,4798",
    "highest": "1,4845",
    "lower": "1,4695",
    "difference": "-0,26%"
  },
  {
    "date": "28.08.2006",
    "now": "1,4845",
    "open": "1,4865",
    "highest": "1,4905",
    "lower": "1,4780",
    "difference": "-0,40%"
  },
  {
    "date": "25.08.2006",
    "now": "1,4905",
    "open": "1,4793",
    "highest": "1,4915",
    "lower": "1,4715",
    "difference": "-0,25%"
  },
  {
    "date": "24.08.2006",
    "now": "1,4943",
    "open": "1,4830",
    "highest": "1,4943",
    "lower": "1,4710",
    "difference": "1,14%"
  },
  {
    "date": "23.08.2006",
    "now": "1,4775",
    "open": "1,4550",
    "highest": "1,4775",
    "lower": "1,4525",
    "difference": "1,27%"
  },
  {
    "date": "22.08.2006",
    "now": "1,4590",
    "open": "1,4510",
    "highest": "1,4610",
    "lower": "1,4470",
    "difference": "0,66%"
  },
  {
    "date": "21.08.2006",
    "now": "1,4495",
    "open": "1,4520",
    "highest": "1,4685",
    "lower": "1,4430",
    "difference": "-0,31%"
  },
  {
    "date": "18.08.2006",
    "now": "1,4540",
    "open": "1,4410",
    "highest": "1,4570",
    "lower": "1,4365",
    "difference": "1,03%"
  },
  {
    "date": "17.08.2006",
    "now": "1,4392",
    "open": "1,4410",
    "highest": "1,4440",
    "lower": "1,4320",
    "difference": "-0,26%"
  },
  {
    "date": "16.08.2006",
    "now": "1,4430",
    "open": "1,4525",
    "highest": "1,4571",
    "lower": "1,4395",
    "difference": "-0,76%"
  },
  {
    "date": "15.08.2006",
    "now": "1,4540",
    "open": "1,4675",
    "highest": "1,4821",
    "lower": "1,4530",
    "difference": "-0,89%"
  },
  {
    "date": "14.08.2006",
    "now": "1,4670",
    "open": "1,4510",
    "highest": "1,4695",
    "lower": "1,4455",
    "difference": "0,89%"
  },
  {
    "date": "11.08.2006",
    "now": "1,4540",
    "open": "1,4520",
    "highest": "1,4597",
    "lower": "1,4415",
    "difference": "-0,51%"
  },
  {
    "date": "10.08.2006",
    "now": "1,4615",
    "open": "1,4520",
    "highest": "1,4625",
    "lower": "1,4400",
    "difference": "1,14%"
  },
  {
    "date": "09.08.2006",
    "now": "1,4450",
    "open": "1,4670",
    "highest": "1,4675",
    "lower": "1,4405",
    "difference": "-1,20%"
  },
  {
    "date": "08.08.2006",
    "now": "1,4625",
    "open": "1,4670",
    "highest": "1,4735",
    "lower": "1,4585",
    "difference": "-0,14%"
  },
  {
    "date": "07.08.2006",
    "now": "1,4645",
    "open": "1,4725",
    "highest": "1,4785",
    "lower": "1,4575",
    "difference": "-1,03%"
  },
  {
    "date": "04.08.2006",
    "now": "1,4798",
    "open": "1,4838",
    "highest": "1,4853",
    "lower": "1,4548",
    "difference": "-0,97%"
  },
  {
    "date": "03.08.2006",
    "now": "1,4943",
    "open": "1,4965",
    "highest": "1,5090",
    "lower": "1,4895",
    "difference": "-0,05%"
  },
  {
    "date": "02.08.2006",
    "now": "1,4950",
    "open": "1,5060",
    "highest": "1,5140",
    "lower": "1,4915",
    "difference": "-0,50%"
  },
  {
    "date": "01.08.2006",
    "now": "1,5025",
    "open": "1,4965",
    "highest": "1,5135",
    "lower": "1,4945",
    "difference": "0,33%"
  },
  {
    "date": "31.07.2006",
    "now": "1,4976",
    "open": "1,4850",
    "highest": "1,4980",
    "lower": "1,4790",
    "difference": "0,49%"
  },
  {
    "date": "28.07.2006",
    "now": "1,4903",
    "open": "1,4985",
    "highest": "1,5077",
    "lower": "1,4860",
    "difference": "-0,47%"
  },
  {
    "date": "27.07.2006",
    "now": "1,4973",
    "open": "1,5195",
    "highest": "1,5200",
    "lower": "1,4900",
    "difference": "-1,53%"
  },
  {
    "date": "26.07.2006",
    "now": "1,5205",
    "open": "1,5350",
    "highest": "1,5390",
    "lower": "1,5170",
    "difference": "-0,94%"
  },
  {
    "date": "25.07.2006",
    "now": "1,5350",
    "open": "1,5500",
    "highest": "1,5500",
    "lower": "1,5270",
    "difference": "-0,49%"
  },
  {
    "date": "24.07.2006",
    "now": "1,5425",
    "open": "1,5520",
    "highest": "1,5625",
    "lower": "1,5415",
    "difference": "-0,61%"
  },
  {
    "date": "21.07.2006",
    "now": "1,5520",
    "open": "1,5472",
    "highest": "1,5595",
    "lower": "1,5450",
    "difference": "0,31%"
  },
  {
    "date": "20.07.2006",
    "now": "1,5472",
    "open": "1,5535",
    "highest": "1,5655",
    "lower": "1,5455",
    "difference": "-0,41%"
  },
  {
    "date": "19.07.2006",
    "now": "1,5535",
    "open": "1,5834",
    "highest": "1,5885",
    "lower": "1,5535",
    "difference": "-1,89%"
  },
  {
    "date": "18.07.2006",
    "now": "1,5834",
    "open": "1,5835",
    "highest": "1,5930",
    "lower": "1,5725",
    "difference": "-0,32%"
  },
  {
    "date": "17.07.2006",
    "now": "1,5885",
    "open": "1,5875",
    "highest": "1,6080",
    "lower": "1,5820",
    "difference": "0,38%"
  },
  {
    "date": "14.07.2006",
    "now": "1,5825",
    "open": "1,5985",
    "highest": "1,6065",
    "lower": "1,5685",
    "difference": "-0,07%"
  },
  {
    "date": "13.07.2006",
    "now": "1,5836",
    "open": "1,5685",
    "highest": "1,5945",
    "lower": "1,5685",
    "difference": "1,43%"
  },
  {
    "date": "12.07.2006",
    "now": "1,5612",
    "open": "1,5445",
    "highest": "1,5630",
    "lower": "1,5365",
    "difference": "0,43%"
  },
  {
    "date": "11.07.2006",
    "now": "1,5545",
    "open": "1,5462",
    "highest": "1,5545",
    "lower": "1,5360",
    "difference": "0,41%"
  },
  {
    "date": "10.07.2006",
    "now": "1,5481",
    "open": "1,5550",
    "highest": "1,5665",
    "lower": "1,5410",
    "difference": "-0,56%"
  },
  {
    "date": "07.07.2006",
    "now": "1,5568",
    "open": "1,5590",
    "highest": "1,5830",
    "lower": "1,5370",
    "difference": "-0,46%"
  },
  {
    "date": "06.07.2006",
    "now": "1,5640",
    "open": "1,6090",
    "highest": "1,6160",
    "lower": "1,5570",
    "difference": "-2,14%"
  },
  {
    "date": "05.07.2006",
    "now": "1,5982",
    "open": "1,5480",
    "highest": "1,6120",
    "lower": "1,5450",
    "difference": "3,01%"
  },
  {
    "date": "04.07.2006",
    "now": "1,5515",
    "open": "1,5500",
    "highest": "1,5520",
    "lower": "1,5305",
    "difference": "0,29%"
  },
  {
    "date": "03.07.2006",
    "now": "1,5470",
    "open": "1,5845",
    "highest": "1,5865",
    "lower": "1,5395",
    "difference": "-2,24%"
  },
  {
    "date": "30.06.2006",
    "now": "1,5825",
    "open": "1,5835",
    "highest": "1,5925",
    "lower": "1,5605",
    "difference": "-0,35%"
  },
  {
    "date": "29.06.2006",
    "now": "1,5880",
    "open": "1,6075",
    "highest": "1,6215",
    "lower": "1,5880",
    "difference": "-1,34%"
  },
  {
    "date": "28.06.2006",
    "now": "1,6095",
    "open": "1,6345",
    "highest": "1,6475",
    "lower": "1,6015",
    "difference": "-1,56%"
  },
  {
    "date": "27.06.2006",
    "now": "1,6350",
    "open": "1,6715",
    "highest": "1,6790",
    "lower": "1,6255",
    "difference": "-2,01%"
  },
  {
    "date": "26.06.2006",
    "now": "1,6685",
    "open": "1,6995",
    "highest": "1,7230",
    "lower": "1,6465",
    "difference": "-2,48%"
  },
  {
    "date": "23.06.2006",
    "now": "1,7110",
    "open": "1,6805",
    "highest": "1,7595",
    "lower": "1,6745",
    "difference": "1,54%"
  },
  {
    "date": "22.06.2006",
    "now": "1,6850",
    "open": "1,6565",
    "highest": "1,7010",
    "lower": "1,6235",
    "difference": "1,19%"
  },
  {
    "date": "21.06.2006",
    "now": "1,6652",
    "open": "1,6315",
    "highest": "1,6768",
    "lower": "1,6175",
    "difference": "1,75%"
  },
  {
    "date": "20.06.2006",
    "now": "1,6365",
    "open": "1,6035",
    "highest": "1,6395",
    "lower": "1,6035",
    "difference": "2,25%"
  },
  {
    "date": "19.06.2006",
    "now": "1,6005",
    "open": "1,5865",
    "highest": "1,6125",
    "lower": "1,5865",
    "difference": "0,95%"
  },
  {
    "date": "16.06.2006",
    "now": "1,5855",
    "open": "1,6095",
    "highest": "1,6095",
    "lower": "1,5785",
    "difference": "-1,05%"
  },
  {
    "date": "15.06.2006",
    "now": "1,6024",
    "open": "1,5955",
    "highest": "1,6040",
    "lower": "1,5790",
    "difference": "0,21%"
  },
  {
    "date": "14.06.2006",
    "now": "1,5990",
    "open": "1,5925",
    "highest": "1,6145",
    "lower": "1,5785",
    "difference": "0,85%"
  },
  {
    "date": "13.06.2006",
    "now": "1,5855",
    "open": "1,5705",
    "highest": "1,6240",
    "lower": "1,5705",
    "difference": "1,31%"
  },
  {
    "date": "12.06.2006",
    "now": "1,5650",
    "open": "1,5465",
    "highest": "1,5715",
    "lower": "1,5325",
    "difference": "1,52%"
  },
  {
    "date": "09.06.2006",
    "now": "1,5415",
    "open": "1,5475",
    "highest": "1,5520",
    "lower": "1,5290",
    "difference": "-1,01%"
  },
  {
    "date": "08.06.2006",
    "now": "1,5573",
    "open": "1,5205",
    "highest": "1,5655",
    "lower": "1,5205",
    "difference": "2,62%"
  },
  {
    "date": "07.06.2006",
    "now": "1,5175",
    "open": "1,5605",
    "highest": "1,5685",
    "lower": "1,5065",
    "difference": "-3,00%"
  },
  {
    "date": "06.06.2006",
    "now": "1,5645",
    "open": "1,5865",
    "highest": "1,5905",
    "lower": "1,5460",
    "difference": "-0,82%"
  },
  {
    "date": "05.06.2006",
    "now": "1,5775",
    "open": "1,6085",
    "highest": "1,6085",
    "lower": "1,5705",
    "difference": "-1,99%"
  },
  {
    "date": "02.06.2006",
    "now": "1,6095",
    "open": "1,5430",
    "highest": "1,6195",
    "lower": "1,5205",
    "difference": "4,41%"
  },
  {
    "date": "01.06.2006",
    "now": "1,5415",
    "open": "1,5695",
    "highest": "1,5775",
    "lower": "1,5345",
    "difference": "-2,03%"
  },
  {
    "date": "31.05.2006",
    "now": "1,5735",
    "open": "1,5420",
    "highest": "1,5815",
    "lower": "1,5420",
    "difference": "1,58%"
  },
  {
    "date": "30.05.2006",
    "now": "1,5490",
    "open": "1,5425",
    "highest": "1,5545",
    "lower": "1,5315",
    "difference": "1,08%"
  },
  {
    "date": "29.05.2006",
    "now": "1,5325",
    "open": "1,5295",
    "highest": "1,5385",
    "lower": "1,5190",
    "difference": "0,13%"
  },
  {
    "date": "26.05.2006",
    "now": "1,5305",
    "open": "1,5325",
    "highest": "1,5525",
    "lower": "1,5025",
    "difference": "-0,13%"
  },
  {
    "date": "25.05.2006",
    "now": "1,5325",
    "open": "1,5565",
    "highest": "1,5605",
    "lower": "1,5245",
    "difference": "-1,54%"
  },
  {
    "date": "24.05.2006",
    "now": "1,5565",
    "open": "1,5415",
    "highest": "1,5675",
    "lower": "1,5270",
    "difference": "3,59%"
  },
  {
    "date": "23.05.2006",
    "now": "1,5025",
    "open": "1,5395",
    "highest": "1,5395",
    "lower": "1,4865",
    "difference": "-2,40%"
  },
  {
    "date": "22.05.2006",
    "now": "1,5395",
    "open": "1,4855",
    "highest": "1,5500",
    "lower": "1,4825",
    "difference": "3,64%"
  },
  {
    "date": "19.05.2006",
    "now": "1,4855",
    "open": "1,5005",
    "highest": "1,5005",
    "lower": "1,4795",
    "difference": "-1,00%"
  },
  {
    "date": "18.05.2006",
    "now": "1,5005",
    "open": "1,4852",
    "highest": "1,5225",
    "lower": "1,4740",
    "difference": "1,03%"
  },
  {
    "date": "17.05.2006",
    "now": "1,4852",
    "open": "1,4505",
    "highest": "1,4895",
    "lower": "1,4080",
    "difference": "2,39%"
  },
  {
    "date": "16.05.2006",
    "now": "1,4505",
    "open": "1,4865",
    "highest": "1,4895",
    "lower": "1,4245",
    "difference": "-2,42%"
  },
  {
    "date": "15.05.2006",
    "now": "1,4865",
    "open": "1,4230",
    "highest": "1,5360",
    "lower": "1,4155",
    "difference": "6,16%"
  },
  {
    "date": "12.05.2006",
    "now": "1,4003",
    "open": "1,3690",
    "highest": "1,4245",
    "lower": "1,3690",
    "difference": "2,19%"
  },
  {
    "date": "11.05.2006",
    "now": "1,3703",
    "open": "1,3580",
    "highest": "1,3726",
    "lower": "1,3525",
    "difference": "1,20%"
  },
  {
    "date": "10.05.2006",
    "now": "1,3540",
    "open": "1,3430",
    "highest": "1,3600",
    "lower": "1,3395",
    "difference": "0,56%"
  },
  {
    "date": "09.05.2006",
    "now": "1,3465",
    "open": "1,3250",
    "highest": "1,3495",
    "lower": "1,3245",
    "difference": "1,56%"
  },
  {
    "date": "08.05.2006",
    "now": "1,3258",
    "open": "1,3170",
    "highest": "1,3273",
    "lower": "1,3130",
    "difference": "0,58%"
  },
  {
    "date": "05.05.2006",
    "now": "1,3181",
    "open": "1,3170",
    "highest": "1,3222",
    "lower": "1,3150",
    "difference": "-0,08%"
  },
  {
    "date": "04.05.2006",
    "now": "1,3191",
    "open": "1,3210",
    "highest": "1,3277",
    "lower": "1,3165",
    "difference": "-0,20%"
  },
  {
    "date": "03.05.2006",
    "now": "1,3217",
    "open": "1,3170",
    "highest": "1,3243",
    "lower": "1,3130",
    "difference": "0,32%"
  },
  {
    "date": "02.05.2006",
    "now": "1,3175",
    "open": "1,3240",
    "highest": "1,3271",
    "lower": "1,3150",
    "difference": "-0,30%"
  },
  {
    "date": "01.05.2006",
    "now": "1,3215",
    "open": "1,3200",
    "highest": "1,3225",
    "lower": "1,3155",
    "difference": "-0,08%"
  },
  {
    "date": "28.04.2006",
    "now": "1,3225",
    "open": "1,3210",
    "highest": "1,3260",
    "lower": "1,3170",
    "difference": "0,15%"
  },
  {
    "date": "27.04.2006",
    "now": "1,3205",
    "open": "1,3245",
    "highest": "1,3317",
    "lower": "1,3205",
    "difference": "-0,49%"
  },
  {
    "date": "26.04.2006",
    "now": "1,3270",
    "open": "1,3255",
    "highest": "1,3310",
    "lower": "1,3235",
    "difference": "0,08%"
  },
  {
    "date": "25.04.2006",
    "now": "1,3260",
    "open": "1,3210",
    "highest": "1,3270",
    "lower": "1,3170",
    "difference": "0,09%"
  },
  {
    "date": "24.04.2006",
    "now": "1,3248",
    "open": "1,3240",
    "highest": "1,3267",
    "lower": "1,3210",
    "difference": "0,02%"
  },
  {
    "date": "21.04.2006",
    "now": "1,3245",
    "open": "1,3300",
    "highest": "1,3352",
    "lower": "1,3225",
    "difference": "-0,50%"
  },
  {
    "date": "20.04.2006",
    "now": "1,3312",
    "open": "1,3295",
    "highest": "1,3339",
    "lower": "1,3265",
    "difference": "0,20%"
  },
  {
    "date": "19.04.2006",
    "now": "1,3285",
    "open": "1,3305",
    "highest": "1,3340",
    "lower": "1,3265",
    "difference": "-0,64%"
  },
  {
    "date": "18.04.2006",
    "now": "1,3370",
    "open": "1,3450",
    "highest": "1,3471",
    "lower": "1,3365",
    "difference": "-0,65%"
  },
  {
    "date": "17.04.2006",
    "now": "1,3458",
    "open": "1,3478",
    "highest": "1,3513",
    "lower": "1,3428",
    "difference": "-0,37%"
  },
  {
    "date": "14.04.2006",
    "now": "1,3508",
    "open": "1,3538",
    "highest": "1,3558",
    "lower": "1,3468",
    "difference": "-0,13%"
  },
  {
    "date": "13.04.2006",
    "now": "1,3525",
    "open": "1,3455",
    "highest": "1,3555",
    "lower": "1,3405",
    "difference": "0,58%"
  },
  {
    "date": "12.04.2006",
    "now": "1,3447",
    "open": "1,3407",
    "highest": "1,3468",
    "lower": "1,3393",
    "difference": "0,09%"
  },
  {
    "date": "11.04.2006",
    "now": "1,3435",
    "open": "1,3405",
    "highest": "1,3463",
    "lower": "1,3365",
    "difference": "-0,09%"
  },
  {
    "date": "10.04.2006",
    "now": "1,3447",
    "open": "1,3393",
    "highest": "1,3474",
    "lower": "1,3393",
    "difference": "0,50%"
  },
  {
    "date": "07.04.2006",
    "now": "1,3380",
    "open": "1,3405",
    "highest": "1,3405",
    "lower": "1,3290",
    "difference": "0,11%"
  },
  {
    "date": "06.04.2006",
    "now": "1,3365",
    "open": "1,3360",
    "highest": "1,3404",
    "lower": "1,3330",
    "difference": "0,07%"
  },
  {
    "date": "05.04.2006",
    "now": "1,3355",
    "open": "1,3350",
    "highest": "1,3396",
    "lower": "1,3310",
    "difference": "0,15%"
  },
  {
    "date": "04.04.2006",
    "now": "1,3335",
    "open": "1,3410",
    "highest": "1,3426",
    "lower": "1,3305",
    "difference": "-0,83%"
  },
  {
    "date": "03.04.2006",
    "now": "1,3447",
    "open": "1,3443",
    "highest": "1,3494",
    "lower": "1,3407",
    "difference": "0,01%"
  },
  {
    "date": "31.03.2006",
    "now": "1,3445",
    "open": "1,3505",
    "highest": "1,3540",
    "lower": "1,3435",
    "difference": "-0,37%"
  },
  {
    "date": "30.03.2006",
    "now": "1,3495",
    "open": "1,3545",
    "highest": "1,3560",
    "lower": "1,3435",
    "difference": "-0,39%"
  },
  {
    "date": "29.03.2006",
    "now": "1,3548",
    "open": "1,3564",
    "highest": "1,3680",
    "lower": "1,3545",
    "difference": "0,13%"
  },
  {
    "date": "28.03.2006",
    "now": "1,3530",
    "open": "1,3520",
    "highest": "1,3585",
    "lower": "1,3455",
    "difference": "0,11%"
  },
  {
    "date": "27.03.2006",
    "now": "1,3515",
    "open": "1,3490",
    "highest": "1,3530",
    "lower": "1,3395",
    "difference": "0,88%"
  },
  {
    "date": "24.03.2006",
    "now": "1,3397",
    "open": "1,3465",
    "highest": "1,3515",
    "lower": "1,3388",
    "difference": "-0,21%"
  },
  {
    "date": "23.03.2006",
    "now": "1,3425",
    "open": "1,3440",
    "highest": "1,3468",
    "lower": "1,3340",
    "difference": "-0,04%"
  },
  {
    "date": "22.03.2006",
    "now": "1,3430",
    "open": "1,3480",
    "highest": "1,3560",
    "lower": "1,3405",
    "difference": "-0,13%"
  },
  {
    "date": "21.03.2006",
    "now": "1,3447",
    "open": "1,3353",
    "highest": "1,3478",
    "lower": "1,3333",
    "difference": "0,99%"
  },
  {
    "date": "20.03.2006",
    "now": "1,3315",
    "open": "1,3257",
    "highest": "1,3360",
    "lower": "1,3250",
    "difference": "0,45%"
  },
  {
    "date": "17.03.2006",
    "now": "1,3255",
    "open": "1,3190",
    "highest": "1,3305",
    "lower": "1,3170",
    "difference": "0,53%"
  },
  {
    "date": "16.03.2006",
    "now": "1,3185",
    "open": "1,3380",
    "highest": "1,3380",
    "lower": "1,3180",
    "difference": "-1,24%"
  },
  {
    "date": "15.03.2006",
    "now": "1,3351",
    "open": "1,3395",
    "highest": "1,3410",
    "lower": "1,3300",
    "difference": "-0,16%"
  },
  {
    "date": "14.03.2006",
    "now": "1,3372",
    "open": "1,3435",
    "highest": "1,3565",
    "lower": "1,3325",
    "difference": "-0,70%"
  },
  {
    "date": "13.03.2006",
    "now": "1,3466",
    "open": "1,3465",
    "highest": "1,3500",
    "lower": "1,3360",
    "difference": "0,14%"
  },
  {
    "date": "10.03.2006",
    "now": "1,3447",
    "open": "1,3483",
    "highest": "1,3603",
    "lower": "1,3397",
    "difference": "-0,47%"
  },
  {
    "date": "09.03.2006",
    "now": "1,3510",
    "open": "1,3583",
    "highest": "1,3583",
    "lower": "1,3370",
    "difference": "-0,54%"
  },
  {
    "date": "08.03.2006",
    "now": "1,3583",
    "open": "1,3305",
    "highest": "1,3600",
    "lower": "1,3260",
    "difference": "1,94%"
  },
  {
    "date": "07.03.2006",
    "now": "1,3325",
    "open": "1,3060",
    "highest": "1,3400",
    "lower": "1,3060",
    "difference": "1,35%"
  },
  {
    "date": "06.03.2006",
    "now": "1,3147",
    "open": "1,3075",
    "highest": "1,3147",
    "lower": "1,3020",
    "difference": "0,59%"
  },
  {
    "date": "03.03.2006",
    "now": "1,3070",
    "open": "1,3020",
    "highest": "1,3108",
    "lower": "1,2965",
    "difference": "0,27%"
  },
  {
    "date": "02.03.2006",
    "now": "1,3035",
    "open": "1,3095",
    "highest": "1,3095",
    "lower": "1,2990",
    "difference": "-0,50%"
  },
  {
    "date": "01.03.2006",
    "now": "1,3100",
    "open": "1,3192",
    "highest": "1,3192",
    "lower": "1,3033",
    "difference": "-0,30%"
  },
  {
    "date": "28.02.2006",
    "now": "1,3140",
    "open": "1,3150",
    "highest": "1,3172",
    "lower": "1,3075",
    "difference": "-0,09%"
  },
  {
    "date": "27.02.2006",
    "now": "1,3152",
    "open": "1,3192",
    "highest": "1,3240",
    "lower": "1,3130",
    "difference": "-0,44%"
  },
  {
    "date": "24.02.2006",
    "now": "1,3210",
    "open": "1,3177",
    "highest": "1,3234",
    "lower": "1,3160",
    "difference": "-0,02%"
  },
  {
    "date": "23.02.2006",
    "now": "1,3213",
    "open": "1,3245",
    "highest": "1,3256",
    "lower": "1,3135",
    "difference": "-0,20%"
  },
  {
    "date": "22.02.2006",
    "now": "1,3240",
    "open": "1,3187",
    "highest": "1,3360",
    "lower": "1,3177",
    "difference": "0,36%"
  },
  {
    "date": "21.02.2006",
    "now": "1,3192",
    "open": "1,3200",
    "highest": "1,3215",
    "lower": "1,3145",
    "difference": "0,21%"
  },
  {
    "date": "20.02.2006",
    "now": "1,3165",
    "open": "1,3205",
    "highest": "1,3210",
    "lower": "1,3095",
    "difference": "-0,30%"
  },
  {
    "date": "17.02.2006",
    "now": "1,3205",
    "open": "1,3280",
    "highest": "1,3310",
    "lower": "1,3180",
    "difference": "-0,60%"
  },
  {
    "date": "16.02.2006",
    "now": "1,3285",
    "open": "1,3340",
    "highest": "1,3358",
    "lower": "1,3253",
    "difference": "-0,45%"
  },
  {
    "date": "15.02.2006",
    "now": "1,3345",
    "open": "1,3270",
    "highest": "1,3425",
    "lower": "1,3230",
    "difference": "0,53%"
  },
  {
    "date": "14.02.2006",
    "now": "1,3275",
    "open": "1,3305",
    "highest": "1,3305",
    "lower": "1,3232",
    "difference": "-0,08%"
  },
  {
    "date": "13.02.2006",
    "now": "1,3285",
    "open": "1,3320",
    "highest": "1,3347",
    "lower": "1,3265",
    "difference": "-0,19%"
  },
  {
    "date": "10.02.2006",
    "now": "1,3310",
    "open": "1,3310",
    "highest": "1,3315",
    "lower": "1,3205",
    "difference": "0,00%"
  },
  {
    "date": "09.02.2006",
    "now": "1,3310",
    "open": "1,3310",
    "highest": "1,3335",
    "lower": "1,3260",
    "difference": "0,00%"
  },
  {
    "date": "08.02.2006",
    "now": "1,3310",
    "open": "1,3310",
    "highest": "1,3367",
    "lower": "1,3285",
    "difference": "0,00%"
  },
  {
    "date": "07.02.2006",
    "now": "1,3310",
    "open": "1,3300",
    "highest": "1,3325",
    "lower": "1,3240",
    "difference": "0,19%"
  },
  {
    "date": "06.02.2006",
    "now": "1,3285",
    "open": "1,3290",
    "highest": "1,3327",
    "lower": "1,3240",
    "difference": "0,08%"
  },
  {
    "date": "03.02.2006",
    "now": "1,3275",
    "open": "1,3240",
    "highest": "1,3305",
    "lower": "1,3205",
    "difference": "0,04%"
  },
  {
    "date": "02.02.2006",
    "now": "1,3270",
    "open": "1,3255",
    "highest": "1,3335",
    "lower": "1,3240",
    "difference": "0,11%"
  },
  {
    "date": "01.02.2006",
    "now": "1,3255",
    "open": "1,3235",
    "highest": "1,3265",
    "lower": "1,3185",
    "difference": "0,20%"
  },
  {
    "date": "31.01.2006",
    "now": "1,3228",
    "open": "1,3243",
    "highest": "1,3293",
    "lower": "1,3203",
    "difference": "-0,32%"
  },
  {
    "date": "30.01.2006",
    "now": "1,3270",
    "open": "1,3275",
    "highest": "1,3300",
    "lower": "1,3230",
    "difference": "0,23%"
  },
  {
    "date": "27.01.2006",
    "now": "1,3240",
    "open": "1,3240",
    "highest": "1,3280",
    "lower": "1,3185",
    "difference": "0,06%"
  },
  {
    "date": "26.01.2006",
    "now": "1,3232",
    "open": "1,3253",
    "highest": "1,3274",
    "lower": "1,3203",
    "difference": "-0,02%"
  },
  {
    "date": "25.01.2006",
    "now": "1,3235",
    "open": "1,3255",
    "highest": "1,3275",
    "lower": "1,3185",
    "difference": "-0,04%"
  },
  {
    "date": "24.01.2006",
    "now": "1,3240",
    "open": "1,3255",
    "highest": "1,3257",
    "lower": "1,3185",
    "difference": "-0,11%"
  },
  {
    "date": "23.01.2006",
    "now": "1,3255",
    "open": "1,3295",
    "highest": "1,3322",
    "lower": "1,3195",
    "difference": "-0,80%"
  },
  {
    "date": "20.01.2006",
    "now": "1,3362",
    "open": "1,3362",
    "highest": "1,3393",
    "lower": "1,3313",
    "difference": "0,05%"
  },
  {
    "date": "19.01.2006",
    "now": "1,3355",
    "open": "1,3360",
    "highest": "1,3401",
    "lower": "1,3310",
    "difference": "-0,19%"
  },
  {
    "date": "18.01.2006",
    "now": "1,3380",
    "open": "1,3385",
    "highest": "1,3407",
    "lower": "1,3305",
    "difference": "0,13%"
  },
  {
    "date": "17.01.2006",
    "now": "1,3362",
    "open": "1,3308",
    "highest": "1,3417",
    "lower": "1,3273",
    "difference": "0,33%"
  },
  {
    "date": "16.01.2006",
    "now": "1,3318",
    "open": "1,3365",
    "highest": "1,3390",
    "lower": "1,3290",
    "difference": "-0,50%"
  },
  {
    "date": "13.01.2006",
    "now": "1,3385",
    "open": "1,3375",
    "highest": "1,3441",
    "lower": "1,3375",
    "difference": "0,00%"
  },
  {
    "date": "12.01.2006",
    "now": "1,3385",
    "open": "1,3348",
    "highest": "1,3396",
    "lower": "1,3345",
    "difference": "0,16%"
  },
  {
    "date": "11.01.2006",
    "now": "1,3363",
    "open": "1,3460",
    "highest": "1,3460",
    "lower": "1,3363",
    "difference": "-0,65%"
  },
  {
    "date": "10.01.2006",
    "now": "1,3450",
    "open": "1,3355",
    "highest": "1,3565",
    "lower": "1,3355",
    "difference": "0,62%"
  },
  {
    "date": "09.01.2006",
    "now": "1,3367",
    "open": "1,3297",
    "highest": "1,3402",
    "lower": "1,3277",
    "difference": "0,58%"
  },
  {
    "date": "06.01.2006",
    "now": "1,3290",
    "open": "1,3350",
    "highest": "1,3388",
    "lower": "1,3255",
    "difference": "-0,41%"
  },
  {
    "date": "05.01.2006",
    "now": "1,3345",
    "open": "1,3355",
    "highest": "1,3404",
    "lower": "1,3320",
    "difference": "0,05%"
  },
  {
    "date": "04.01.2006",
    "now": "1,3338",
    "open": "1,3400",
    "highest": "1,3415",
    "lower": "1,3315",
    "difference": "-0,69%"
  },
  {
    "date": "03.01.2006",
    "now": "1,3430",
    "open": "1,3490",
    "highest": "1,3516",
    "lower": "1,3410",
    "difference": "-0,59%"
  },
  {
    "date": "02.01.2006",
    "now": "1,3510",
    "open": "1,3505",
    "highest": "1,3525",
    "lower": "1,3465",
    "difference": "0,04%"
  },
  {
    "date": "30.12.2005",
    "now": "1,3505",
    "open": "1,3470",
    "highest": "1,3526",
    "lower": "1,3430",
    "difference": "0,11%"
  },
  {
    "date": "29.12.2005",
    "now": "1,3490",
    "open": "1,3480",
    "highest": "1,3518",
    "lower": "1,3450",
    "difference": "-0,13%"
  },
  {
    "date": "28.12.2005",
    "now": "1,3507",
    "open": "1,3495",
    "highest": "1,3525",
    "lower": "1,3465",
    "difference": "-0,06%"
  },
  {
    "date": "27.12.2005",
    "now": "1,3515",
    "open": "1,3495",
    "highest": "1,3533",
    "lower": "1,3463",
    "difference": "0,22%"
  },
  {
    "date": "26.12.2005",
    "now": "1,3485",
    "open": "1,3495",
    "highest": "1,3515",
    "lower": "1,3465",
    "difference": "-0,19%"
  },
  {
    "date": "23.12.2005",
    "now": "1,3510",
    "open": "1,3505",
    "highest": "1,3528",
    "lower": "1,3460",
    "difference": "-0,04%"
  },
  {
    "date": "22.12.2005",
    "now": "1,3515",
    "open": "1,3525",
    "highest": "1,3558",
    "lower": "1,3470",
    "difference": "0,00%"
  },
  {
    "date": "21.12.2005",
    "now": "1,3515",
    "open": "1,3515",
    "highest": "1,3570",
    "lower": "1,3465",
    "difference": "0,00%"
  },
  {
    "date": "20.12.2005",
    "now": "1,3515",
    "open": "1,3515",
    "highest": "1,3530",
    "lower": "1,3460",
    "difference": "0,00%"
  },
  {
    "date": "19.12.2005",
    "now": "1,3515",
    "open": "1,3495",
    "highest": "1,3527",
    "lower": "1,3450",
    "difference": "0,15%"
  },
  {
    "date": "16.12.2005",
    "now": "1,3495",
    "open": "1,3490",
    "highest": "1,3545",
    "lower": "1,3455",
    "difference": "0,07%"
  },
  {
    "date": "15.12.2005",
    "now": "1,3485",
    "open": "1,3460",
    "highest": "1,3505",
    "lower": "1,3405",
    "difference": "0,15%"
  },
  {
    "date": "14.12.2005",
    "now": "1,3465",
    "open": "1,3465",
    "highest": "1,3475",
    "lower": "1,3385",
    "difference": "0,04%"
  },
  {
    "date": "13.12.2005",
    "now": "1,3460",
    "open": "1,3485",
    "highest": "1,3503",
    "lower": "1,3435",
    "difference": "-0,26%"
  },
  {
    "date": "12.12.2005",
    "now": "1,3495",
    "open": "1,3545",
    "highest": "1,3585",
    "lower": "1,3465",
    "difference": "-0,63%"
  },
  {
    "date": "09.12.2005",
    "now": "1,3580",
    "open": "1,3550",
    "highest": "1,3585",
    "lower": "1,3505",
    "difference": "0,18%"
  },
  {
    "date": "08.12.2005",
    "now": "1,3555",
    "open": "1,3565",
    "highest": "1,3600",
    "lower": "1,3510",
    "difference": "-0,07%"
  },
  {
    "date": "07.12.2005",
    "now": "1,3565",
    "open": "1,3525",
    "highest": "1,3595",
    "lower": "1,3510",
    "difference": "0,26%"
  },
  {
    "date": "06.12.2005",
    "now": "1,3530",
    "open": "1,3547",
    "highest": "1,3592",
    "lower": "1,3510",
    "difference": "-0,16%"
  },
  {
    "date": "05.12.2005",
    "now": "1,3552",
    "open": "1,3595",
    "highest": "1,3634",
    "lower": "1,3530",
    "difference": "-0,13%"
  },
  {
    "date": "02.12.2005",
    "now": "1,3570",
    "open": "1,3600",
    "highest": "1,3644",
    "lower": "1,3545",
    "difference": "-0,15%"
  },
  {
    "date": "01.12.2005",
    "now": "1,3590",
    "open": "1,3555",
    "highest": "1,3611",
    "lower": "1,3520",
    "difference": "0,18%"
  },
  {
    "date": "30.11.2005",
    "now": "1,3565",
    "open": "1,3580",
    "highest": "1,3597",
    "lower": "1,3520",
    "difference": "-0,04%"
  },
  {
    "date": "29.11.2005",
    "now": "1,3570",
    "open": "1,3540",
    "highest": "1,3580",
    "lower": "1,3505",
    "difference": "0,15%"
  },
  {
    "date": "28.11.2005",
    "now": "1,3550",
    "open": "1,3575",
    "highest": "1,3645",
    "lower": "1,3550",
    "difference": "-0,18%"
  },
  {
    "date": "25.11.2005",
    "now": "1,3575",
    "open": "1,3560",
    "highest": "1,3605",
    "lower": "1,3530",
    "difference": "0,30%"
  },
  {
    "date": "24.11.2005",
    "now": "1,3535",
    "open": "1,3570",
    "highest": "1,3620",
    "lower": "1,3535",
    "difference": "-0,33%"
  },
  {
    "date": "23.11.2005",
    "now": "1,3580",
    "open": "1,3645",
    "highest": "1,3645",
    "lower": "1,3550",
    "difference": "-0,44%"
  },
  {
    "date": "22.11.2005",
    "now": "1,3640",
    "open": "1,3640",
    "highest": "1,3718",
    "lower": "1,3625",
    "difference": "-0,11%"
  },
  {
    "date": "21.11.2005",
    "now": "1,3655",
    "open": "1,3645",
    "highest": "1,3695",
    "lower": "1,3600",
    "difference": "-0,07%"
  },
  {
    "date": "18.11.2005",
    "now": "1,3665",
    "open": "1,3550",
    "highest": "1,3751",
    "lower": "1,3525",
    "difference": "1,11%"
  },
  {
    "date": "17.11.2005",
    "now": "1,3515",
    "open": "1,3615",
    "highest": "1,3635",
    "lower": "1,3515",
    "difference": "-0,48%"
  },
  {
    "date": "16.11.2005",
    "now": "1,3580",
    "open": "1,3580",
    "highest": "1,3635",
    "lower": "1,3540",
    "difference": "0,04%"
  },
  {
    "date": "15.11.2005",
    "now": "1,3575",
    "open": "1,3635",
    "highest": "1,3665",
    "lower": "1,3545",
    "difference": "-0,48%"
  },
  {
    "date": "14.11.2005",
    "now": "1,3640",
    "open": "1,3600",
    "highest": "1,3680",
    "lower": "1,3555",
    "difference": "0,13%"
  },
  {
    "date": "11.11.2005",
    "now": "1,3622",
    "open": "1,3640",
    "highest": "1,3673",
    "lower": "1,3595",
    "difference": "-0,17%"
  },
  {
    "date": "10.11.2005",
    "now": "1,3645",
    "open": "1,3603",
    "highest": "1,3680",
    "lower": "1,3590",
    "difference": "0,31%"
  },
  {
    "date": "09.11.2005",
    "now": "1,3603",
    "open": "1,3610",
    "highest": "1,3660",
    "lower": "1,3545",
    "difference": "-0,05%"
  },
  {
    "date": "08.11.2005",
    "now": "1,3610",
    "open": "1,3595",
    "highest": "1,3700",
    "lower": "1,3575",
    "difference": "0,11%"
  },
  {
    "date": "07.11.2005",
    "now": "1,3595",
    "open": "1,3605",
    "highest": "1,3655",
    "lower": "1,3555",
    "difference": "-0,07%"
  },
  {
    "date": "04.11.2005",
    "now": "1,3605",
    "open": "1,3495",
    "highest": "1,3615",
    "lower": "1,3495",
    "difference": "0,85%"
  },
  {
    "date": "03.11.2005",
    "now": "1,3490",
    "open": "1,3465",
    "highest": "1,3525",
    "lower": "1,3450",
    "difference": "0,20%"
  },
  {
    "date": "02.11.2005",
    "now": "1,3463",
    "open": "1,3460",
    "highest": "1,3515",
    "lower": "1,3440",
    "difference": "-0,38%"
  },
  {
    "date": "01.11.2005",
    "now": "1,3515",
    "open": "1,3520",
    "highest": "1,3555",
    "lower": "1,3450",
    "difference": "0,00%"
  },
  {
    "date": "31.10.2005",
    "now": "1,3515",
    "open": "1,3515",
    "highest": "1,3535",
    "lower": "1,3425",
    "difference": "0,00%"
  },
  {
    "date": "28.10.2005",
    "now": "1,3515",
    "open": "1,3495",
    "highest": "1,3545",
    "lower": "1,3455",
    "difference": "0,00%"
  },
  {
    "date": "27.10.2005",
    "now": "1,3515",
    "open": "1,3545",
    "highest": "1,3590",
    "lower": "1,3475",
    "difference": "-0,33%"
  },
  {
    "date": "26.10.2005",
    "now": "1,3560",
    "open": "1,3595",
    "highest": "1,3605",
    "lower": "1,3485",
    "difference": "0,30%"
  },
  {
    "date": "25.10.2005",
    "now": "1,3520",
    "open": "1,3590",
    "highest": "1,3650",
    "lower": "1,3510",
    "difference": "-0,73%"
  },
  {
    "date": "24.10.2005",
    "now": "1,3620",
    "open": "1,3640",
    "highest": "1,3680",
    "lower": "1,3580",
    "difference": "-0,11%"
  },
  {
    "date": "21.10.2005",
    "now": "1,3635",
    "open": "1,3675",
    "highest": "1,3730",
    "lower": "1,3575",
    "difference": "-0,29%"
  },
  {
    "date": "20.10.2005",
    "now": "1,3675",
    "open": "1,3705",
    "highest": "1,3705",
    "lower": "1,3580",
    "difference": "-0,18%"
  },
  {
    "date": "19.10.2005",
    "now": "1,3700",
    "open": "1,3650",
    "highest": "1,3780",
    "lower": "1,3640",
    "difference": "0,00%"
  },
  {
    "date": "18.10.2005",
    "now": "1,3700",
    "open": "1,3620",
    "highest": "1,3710",
    "lower": "1,3580",
    "difference": "0,66%"
  },
  {
    "date": "17.10.2005",
    "now": "1,3610",
    "open": "1,3640",
    "highest": "1,3663",
    "lower": "1,3535",
    "difference": "-0,66%"
  },
  {
    "date": "14.10.2005",
    "now": "1,3700",
    "open": "1,3680",
    "highest": "1,3766",
    "lower": "1,3635",
    "difference": "0,18%"
  },
  {
    "date": "13.10.2005",
    "now": "1,3675",
    "open": "1,3615",
    "highest": "1,3762",
    "lower": "1,3565",
    "difference": "0,44%"
  },
  {
    "date": "12.10.2005",
    "now": "1,3615",
    "open": "1,3485",
    "highest": "1,3640",
    "lower": "1,3475",
    "difference": "0,93%"
  },
  {
    "date": "11.10.2005",
    "now": "1,3490",
    "open": "1,3500",
    "highest": "1,3555",
    "lower": "1,3420",
    "difference": "-0,11%"
  },
  {
    "date": "10.10.2005",
    "now": "1,3505",
    "open": "1,3450",
    "highest": "1,3525",
    "lower": "1,3395",
    "difference": "0,22%"
  },
  {
    "date": "07.10.2005",
    "now": "1,3475",
    "open": "1,3595",
    "highest": "1,3665",
    "lower": "1,3465",
    "difference": "-1,10%"
  },
  {
    "date": "06.10.2005",
    "now": "1,3625",
    "open": "1,3505",
    "highest": "1,3685",
    "lower": "1,3485",
    "difference": "0,74%"
  },
  {
    "date": "05.10.2005",
    "now": "1,3525",
    "open": "1,3515",
    "highest": "1,3610",
    "lower": "1,3460",
    "difference": "0,04%"
  },
  {
    "date": "04.10.2005",
    "now": "1,3520",
    "open": "1,3340",
    "highest": "1,3610",
    "lower": "1,3280",
    "difference": "1,16%"
  },
  {
    "date": "03.10.2005",
    "now": "1,3365",
    "open": "1,3540",
    "highest": "1,3735",
    "lower": "1,3355",
    "difference": "-0,74%"
  },
  {
    "date": "30.09.2005",
    "now": "1,3465",
    "open": "1,3495",
    "highest": "1,3556",
    "lower": "1,3420",
    "difference": "-0,30%"
  },
  {
    "date": "29.09.2005",
    "now": "1,3505",
    "open": "1,3475",
    "highest": "1,3555",
    "lower": "1,3425",
    "difference": "0,11%"
  },
  {
    "date": "28.09.2005",
    "now": "1,3490",
    "open": "1,3455",
    "highest": "1,3570",
    "lower": "1,3430",
    "difference": "-0,48%"
  },
  {
    "date": "27.09.2005",
    "now": "1,3555",
    "open": "1,3490",
    "highest": "1,3555",
    "lower": "1,3400",
    "difference": "0,56%"
  },
  {
    "date": "26.09.2005",
    "now": "1,3480",
    "open": "1,3455",
    "highest": "1,3535",
    "lower": "1,3425",
    "difference": "0,00%"
  },
  {
    "date": "23.09.2005",
    "now": "1,3480",
    "open": "1,3415",
    "highest": "1,3585",
    "lower": "1,3375",
    "difference": "0,48%"
  },
  {
    "date": "22.09.2005",
    "now": "1,3415",
    "open": "1,3340",
    "highest": "1,3480",
    "lower": "1,3320",
    "difference": "-0,89%"
  },
  {
    "date": "21.09.2005",
    "now": "1,3535",
    "open": "1,3415",
    "highest": "1,3535",
    "lower": "1,3355",
    "difference": "0,74%"
  },
  {
    "date": "20.09.2005",
    "now": "1,3435",
    "open": "1,3390",
    "highest": "1,3555",
    "lower": "1,3345",
    "difference": "-0,15%"
  },
  {
    "date": "19.09.2005",
    "now": "1,3455",
    "open": "1,3420",
    "highest": "1,3540",
    "lower": "1,3405",
    "difference": "0,22%"
  },
  {
    "date": "16.09.2005",
    "now": "1,3425",
    "open": "1,3395",
    "highest": "1,3460",
    "lower": "1,3330",
    "difference": "0,19%"
  },
  {
    "date": "15.09.2005",
    "now": "1,3400",
    "open": "1,3445",
    "highest": "1,3496",
    "lower": "1,3360",
    "difference": "-0,11%"
  },
  {
    "date": "14.09.2005",
    "now": "1,3415",
    "open": "1,3425",
    "highest": "1,3515",
    "lower": "1,3335",
    "difference": "-0,22%"
  },
  {
    "date": "13.09.2005",
    "now": "1,3445",
    "open": "1,3375",
    "highest": "1,3495",
    "lower": "1,3315",
    "difference": "0,45%"
  },
  {
    "date": "12.09.2005",
    "now": "1,3385",
    "open": "1,3365",
    "highest": "1,3415",
    "lower": "1,3310",
    "difference": "0,22%"
  },
  {
    "date": "09.09.2005",
    "now": "1,3355",
    "open": "1,3325",
    "highest": "1,3375",
    "lower": "1,3265",
    "difference": "0,13%"
  },
  {
    "date": "08.09.2005",
    "now": "1,3337",
    "open": "1,3342",
    "highest": "1,3399",
    "lower": "1,3282",
    "difference": "-0,06%"
  },
  {
    "date": "07.09.2005",
    "now": "1,3345",
    "open": "1,3295",
    "highest": "1,3385",
    "lower": "1,3260",
    "difference": "0,19%"
  },
  {
    "date": "06.09.2005",
    "now": "1,3320",
    "open": "1,3325",
    "highest": "1,3415",
    "lower": "1,3265",
    "difference": "-0,11%"
  },
  {
    "date": "05.09.2005",
    "now": "1,3335",
    "open": "1,3345",
    "highest": "1,3424",
    "lower": "1,3285",
    "difference": "-0,22%"
  },
  {
    "date": "02.09.2005",
    "now": "1,3365",
    "open": "1,3425",
    "highest": "1,3515",
    "lower": "1,3320",
    "difference": "-0,37%"
  },
  {
    "date": "01.09.2005",
    "now": "1,3415",
    "open": "1,3395",
    "highest": "1,3485",
    "lower": "1,3350",
    "difference": "-0,26%"
  },
  {
    "date": "31.08.2005",
    "now": "1,3450",
    "open": "1,3595",
    "highest": "1,3645",
    "lower": "1,3400",
    "difference": "-0,92%"
  },
  {
    "date": "30.08.2005",
    "now": "1,3575",
    "open": "1,3575",
    "highest": "1,3575",
    "lower": "1,3575",
    "difference": "-0,15%"
  },
  {
    "date": "29.08.2005",
    "now": "1,3595",
    "open": "1,3565",
    "highest": "1,3620",
    "lower": "1,3535",
    "difference": "0,10%"
  },
  {
    "date": "26.08.2005",
    "now": "1,3582",
    "open": "1,3603",
    "highest": "1,3653",
    "lower": "1,3527",
    "difference": "-0,68%"
  },
  {
    "date": "25.08.2005",
    "now": "1,3675",
    "open": "1,3735",
    "highest": "1,3810",
    "lower": "1,3625",
    "difference": "0,07%"
  },
  {
    "date": "24.08.2005",
    "now": "1,3665",
    "open": "1,3640",
    "highest": "1,3770",
    "lower": "1,3600",
    "difference": "-0,07%"
  },
  {
    "date": "23.08.2005",
    "now": "1,3675",
    "open": "1,3605",
    "highest": "1,3725",
    "lower": "1,3535",
    "difference": "0,44%"
  },
  {
    "date": "22.08.2005",
    "now": "1,3615",
    "open": "1,3795",
    "highest": "1,3795",
    "lower": "1,3595",
    "difference": "-1,45%"
  },
  {
    "date": "19.08.2005",
    "now": "1,3815",
    "open": "1,3740",
    "highest": "1,3827",
    "lower": "1,3670",
    "difference": "0,88%"
  },
  {
    "date": "18.08.2005",
    "now": "1,3695",
    "open": "1,3675",
    "highest": "1,3745",
    "lower": "1,3595",
    "difference": "0,00%"
  },
  {
    "date": "17.08.2005",
    "now": "1,3695",
    "open": "1,3475",
    "highest": "1,3755",
    "lower": "1,3475",
    "difference": "1,48%"
  },
  {
    "date": "16.08.2005",
    "now": "1,3495",
    "open": "1,3455",
    "highest": "1,3555",
    "lower": "1,3410",
    "difference": "0,30%"
  },
  {
    "date": "15.08.2005",
    "now": "1,3455",
    "open": "1,3505",
    "highest": "1,3685",
    "lower": "1,3430",
    "difference": "-0,30%"
  },
  {
    "date": "12.08.2005",
    "now": "1,3495",
    "open": "1,3315",
    "highest": "1,3551",
    "lower": "1,3275",
    "difference": "1,43%"
  },
  {
    "date": "11.08.2005",
    "now": "1,3305",
    "open": "1,3215",
    "highest": "1,3350",
    "lower": "1,3170",
    "difference": "0,53%"
  },
  {
    "date": "10.08.2005",
    "now": "1,3235",
    "open": "1,3255",
    "highest": "1,3255",
    "lower": "1,3145",
    "difference": "-0,23%"
  },
  {
    "date": "09.08.2005",
    "now": "1,3265",
    "open": "1,3245",
    "highest": "1,3295",
    "lower": "1,3195",
    "difference": "0,15%"
  },
  {
    "date": "08.08.2005",
    "now": "1,3245",
    "open": "1,3170",
    "highest": "1,3259",
    "lower": "1,3145",
    "difference": "0,61%"
  },
  {
    "date": "05.08.2005",
    "now": "1,3165",
    "open": "1,3135",
    "highest": "1,3215",
    "lower": "1,3095",
    "difference": "0,30%"
  },
  {
    "date": "04.08.2005",
    "now": "1,3125",
    "open": "1,3135",
    "highest": "1,3205",
    "lower": "1,3095",
    "difference": "0,00%"
  },
  {
    "date": "03.08.2005",
    "now": "1,3125",
    "open": "1,3230",
    "highest": "1,3250",
    "lower": "1,3105",
    "difference": "-0,68%"
  },
  {
    "date": "02.08.2005",
    "now": "1,3215",
    "open": "1,3195",
    "highest": "1,3279",
    "lower": "1,3170",
    "difference": "0,00%"
  },
  {
    "date": "01.08.2005",
    "now": "1,3215",
    "open": "1,3245",
    "highest": "1,3265",
    "lower": "1,3175",
    "difference": "-0,33%"
  },
  {
    "date": "29.07.2005",
    "now": "1,3259",
    "open": "1,3275",
    "highest": "1,3327",
    "lower": "1,3220",
    "difference": "-0,12%"
  },
  {
    "date": "28.07.2005",
    "now": "1,3275",
    "open": "1,3395",
    "highest": "1,3435",
    "lower": "1,3265",
    "difference": "-0,90%"
  },
  {
    "date": "27.07.2005",
    "now": "1,3395",
    "open": "1,3455",
    "highest": "1,3475",
    "lower": "1,3380",
    "difference": "-0,45%"
  },
  {
    "date": "26.07.2005",
    "now": "1,3455",
    "open": "1,3410",
    "highest": "1,3565",
    "lower": "1,3370",
    "difference": "0,60%"
  },
  {
    "date": "25.07.2005",
    "now": "1,3375",
    "open": "1,3395",
    "highest": "1,3445",
    "lower": "1,3350",
    "difference": "-0,15%"
  },
  {
    "date": "22.07.2005",
    "now": "1,3395",
    "open": "1,3245",
    "highest": "1,3491",
    "lower": "1,3190",
    "difference": "1,21%"
  },
  {
    "date": "21.07.2005",
    "now": "1,3235",
    "open": "1,3280",
    "highest": "1,3318",
    "lower": "1,3215",
    "difference": "-0,38%"
  },
  {
    "date": "20.07.2005",
    "now": "1,3285",
    "open": "1,3305",
    "highest": "1,3370",
    "lower": "1,3280",
    "difference": "-0,37%"
  },
  {
    "date": "19.07.2005",
    "now": "1,3335",
    "open": "1,3325",
    "highest": "1,3375",
    "lower": "1,3295",
    "difference": "0,00%"
  },
  {
    "date": "18.07.2005",
    "now": "1,3335",
    "open": "1,3335",
    "highest": "1,3375",
    "lower": "1,3295",
    "difference": "0,15%"
  },
  {
    "date": "15.07.2005",
    "now": "1,3315",
    "open": "1,3285",
    "highest": "1,3365",
    "lower": "1,3260",
    "difference": "0,11%"
  },
  {
    "date": "14.07.2005",
    "now": "1,3300",
    "open": "1,3355",
    "highest": "1,3430",
    "lower": "1,3265",
    "difference": "-0,34%"
  },
  {
    "date": "13.07.2005",
    "now": "1,3345",
    "open": "1,3285",
    "highest": "1,3380",
    "lower": "1,3275",
    "difference": "0,57%"
  },
  {
    "date": "12.07.2005",
    "now": "1,3270",
    "open": "1,3375",
    "highest": "1,3426",
    "lower": "1,3270",
    "difference": "-0,97%"
  },
  {
    "date": "11.07.2005",
    "now": "1,3400",
    "open": "1,3430",
    "highest": "1,3475",
    "lower": "1,3370",
    "difference": "-0,26%"
  },
  {
    "date": "08.07.2005",
    "now": "1,3435",
    "open": "1,3525",
    "highest": "1,3575",
    "lower": "1,3380",
    "difference": "-1,03%"
  },
  {
    "date": "07.07.2005",
    "now": "1,3575",
    "open": "1,3505",
    "highest": "1,3760",
    "lower": "1,3475",
    "difference": "0,56%"
  },
  {
    "date": "06.07.2005",
    "now": "1,3500",
    "open": "1,3475",
    "highest": "1,3540",
    "lower": "1,3430",
    "difference": "0,19%"
  },
  {
    "date": "05.07.2005",
    "now": "1,3475",
    "open": "1,3435",
    "highest": "1,3535",
    "lower": "1,3415",
    "difference": "0,48%"
  },
  {
    "date": "04.07.2005",
    "now": "1,3410",
    "open": "1,3405",
    "highest": "1,3465",
    "lower": "1,3380",
    "difference": "0,41%"
  },
  {
    "date": "01.07.2005",
    "now": "1,3355",
    "open": "1,3315",
    "highest": "1,3415",
    "lower": "1,3315",
    "difference": "0,38%"
  },
  {
    "date": "30.06.2005",
    "now": "1,3305",
    "open": "1,3405",
    "highest": "1,3455",
    "lower": "1,3295",
    "difference": "-0,71%"
  },
  {
    "date": "29.06.2005",
    "now": "1,3400",
    "open": "1,3485",
    "highest": "1,3515",
    "lower": "1,3390",
    "difference": "-0,48%"
  },
  {
    "date": "28.06.2005",
    "now": "1,3465",
    "open": "1,3525",
    "highest": "1,3545",
    "lower": "1,3445",
    "difference": "-0,33%"
  },
  {
    "date": "27.06.2005",
    "now": "1,3510",
    "open": "1,3495",
    "highest": "1,3565",
    "lower": "1,3455",
    "difference": "0,11%"
  },
  {
    "date": "24.06.2005",
    "now": "1,3495",
    "open": "1,3526",
    "highest": "1,3585",
    "lower": "1,3475",
    "difference": "-0,44%"
  },
  {
    "date": "23.06.2005",
    "now": "1,3555",
    "open": "1,3535",
    "highest": "1,3615",
    "lower": "1,3490",
    "difference": "0,07%"
  },
  {
    "date": "22.06.2005",
    "now": "1,3545",
    "open": "1,3545",
    "highest": "1,3605",
    "lower": "1,3505",
    "difference": "-0,29%"
  },
  {
    "date": "21.06.2005",
    "now": "1,3585",
    "open": "1,3640",
    "highest": "1,3695",
    "lower": "1,3535",
    "difference": "-0,29%"
  },
  {
    "date": "20.06.2005",
    "now": "1,3625",
    "open": "1,3595",
    "highest": "1,3675",
    "lower": "1,3545",
    "difference": "0,52%"
  },
  {
    "date": "17.06.2005",
    "now": "1,3555",
    "open": "1,3645",
    "highest": "1,3645",
    "lower": "1,3525",
    "difference": "-0,51%"
  },
  {
    "date": "16.06.2005",
    "now": "1,3625",
    "open": "1,3745",
    "highest": "1,3765",
    "lower": "1,3615",
    "difference": "-0,87%"
  },
  {
    "date": "15.06.2005",
    "now": "1,3745",
    "open": "1,3825",
    "highest": "1,3855",
    "lower": "1,3710",
    "difference": "-0,72%"
  },
  {
    "date": "14.06.2005",
    "now": "1,3845",
    "open": "1,3790",
    "highest": "1,3855",
    "lower": "1,3635",
    "difference": "0,47%"
  },
  {
    "date": "13.06.2005",
    "now": "1,3780",
    "open": "1,3675",
    "highest": "1,3840",
    "lower": "1,3675",
    "difference": "0,84%"
  },
  {
    "date": "10.06.2005",
    "now": "1,3665",
    "open": "1,3640",
    "highest": "1,3705",
    "lower": "1,3555",
    "difference": "0,29%"
  },
  {
    "date": "09.06.2005",
    "now": "1,3625",
    "open": "1,3625",
    "highest": "1,3705",
    "lower": "1,3565",
    "difference": "0,15%"
  },
  {
    "date": "08.06.2005",
    "now": "1,3605",
    "open": "1,3665",
    "highest": "1,3750",
    "lower": "1,3575",
    "difference": "-0,80%"
  },
  {
    "date": "07.06.2005",
    "now": "1,3715",
    "open": "1,3655",
    "highest": "1,3715",
    "lower": "1,3550",
    "difference": "0,37%"
  },
  {
    "date": "06.06.2005",
    "now": "1,3665",
    "open": "1,3645",
    "highest": "1,3785",
    "lower": "1,3615",
    "difference": "0,00%"
  },
  {
    "date": "03.06.2005",
    "now": "1,3665",
    "open": "1,3440",
    "highest": "1,3675",
    "lower": "1,3365",
    "difference": "1,49%"
  },
  {
    "date": "02.06.2005",
    "now": "1,3465",
    "open": "1,3605",
    "highest": "1,3645",
    "lower": "1,3415",
    "difference": "-1,03%"
  },
  {
    "date": "01.06.2005",
    "now": "1,3605",
    "open": "1,3625",
    "highest": "1,3720",
    "lower": "1,3525",
    "difference": "-0,29%"
  },
  {
    "date": "31.05.2005",
    "now": "1,3645",
    "open": "1,3715",
    "highest": "1,3755",
    "lower": "1,3510",
    "difference": "0,00%"
  },
  {
    "date": "30.05.2005",
    "now": "1,3645",
    "open": "1,3755",
    "highest": "1,3795",
    "lower": "1,3645",
    "difference": "-0,44%"
  },
  {
    "date": "27.05.2005",
    "now": "1,3705",
    "open": "1,3845",
    "highest": "1,3855",
    "lower": "1,3645",
    "difference": "-1,12%"
  },
  {
    "date": "26.05.2005",
    "now": "1,3860",
    "open": "1,3885",
    "highest": "1,3930",
    "lower": "1,3770",
    "difference": "-0,04%"
  },
  {
    "date": "25.05.2005",
    "now": "1,3865",
    "open": "1,3895",
    "highest": "1,3965",
    "lower": "1,3825",
    "difference": "-0,43%"
  },
  {
    "date": "24.05.2005",
    "now": "1,3925",
    "open": "1,3885",
    "highest": "1,3935",
    "lower": "1,3770",
    "difference": "0,49%"
  },
  {
    "date": "23.05.2005",
    "now": "1,3857",
    "open": "1,3798",
    "highest": "1,3963",
    "lower": "1,3782",
    "difference": "0,60%"
  },
  {
    "date": "20.05.2005",
    "now": "1,3775",
    "open": "1,3655",
    "highest": "1,3825",
    "lower": "1,3585",
    "difference": "0,95%"
  },
  {
    "date": "19.05.2005",
    "now": "1,3645",
    "open": "1,3675",
    "highest": "1,3725",
    "lower": "1,3645",
    "difference": "0,00%"
  },
  {
    "date": "18.05.2005",
    "now": "1,3645",
    "open": "1,3805",
    "highest": "1,3815",
    "lower": "1,3625",
    "difference": "-0,94%"
  },
  {
    "date": "17.05.2005",
    "now": "1,3775",
    "open": "1,3815",
    "highest": "1,3870",
    "lower": "1,3735",
    "difference": "-0,29%"
  },
  {
    "date": "16.05.2005",
    "now": "1,3815",
    "open": "1,3725",
    "highest": "1,3905",
    "lower": "1,3725",
    "difference": "0,58%"
  },
  {
    "date": "13.05.2005",
    "now": "1,3735",
    "open": "1,3695",
    "highest": "1,3755",
    "lower": "1,3625",
    "difference": "0,62%"
  },
  {
    "date": "12.05.2005",
    "now": "1,3650",
    "open": "1,3655",
    "highest": "1,3745",
    "lower": "1,3525",
    "difference": "-0,11%"
  },
  {
    "date": "11.05.2005",
    "now": "1,3665",
    "open": "1,3680",
    "highest": "1,3770",
    "lower": "1,3640",
    "difference": "-0,29%"
  },
  {
    "date": "10.05.2005",
    "now": "1,3705",
    "open": "1,3590",
    "highest": "1,3775",
    "lower": "1,3520",
    "difference": "0,85%"
  },
  {
    "date": "09.05.2005",
    "now": "1,3590",
    "open": "1,3555",
    "highest": "1,3655",
    "lower": "1,3525",
    "difference": "0,63%"
  },
  {
    "date": "06.05.2005",
    "now": "1,3505",
    "open": "1,3495",
    "highest": "1,3575",
    "lower": "1,3400",
    "difference": "0,60%"
  },
  {
    "date": "05.05.2005",
    "now": "1,3425",
    "open": "1,3475",
    "highest": "1,3515",
    "lower": "1,3355",
    "difference": "-0,67%"
  },
  {
    "date": "04.05.2005",
    "now": "1,3515",
    "open": "1,3585",
    "highest": "1,3585",
    "lower": "1,3435",
    "difference": "-0,81%"
  },
  {
    "date": "03.05.2005",
    "now": "1,3625",
    "open": "1,3855",
    "highest": "1,3855",
    "lower": "1,3625",
    "difference": "-1,48%"
  },
  {
    "date": "02.05.2005",
    "now": "1,3830",
    "open": "1,3960",
    "highest": "1,3970",
    "lower": "1,3790",
    "difference": "-0,61%"
  },
  {
    "date": "29.04.2005",
    "now": "1,3915",
    "open": "1,4015",
    "highest": "1,4080",
    "lower": "1,3825",
    "difference": "-1,05%"
  },
  {
    "date": "28.04.2005",
    "now": "1,4062",
    "open": "1,3722",
    "highest": "1,4098",
    "lower": "1,3698",
    "difference": "2,23%"
  },
  {
    "date": "27.04.2005",
    "now": "1,3755",
    "open": "1,3635",
    "highest": "1,3765",
    "lower": "1,3610",
    "difference": "0,95%"
  },
  {
    "date": "26.04.2005",
    "now": "1,3625",
    "open": "1,3625",
    "highest": "1,3676",
    "lower": "1,3580",
    "difference": "-0,22%"
  },
  {
    "date": "25.04.2005",
    "now": "1,3655",
    "open": "1,3605",
    "highest": "1,3685",
    "lower": "1,3570",
    "difference": "0,66%"
  },
  {
    "date": "22.04.2005",
    "now": "1,3565",
    "open": "1,3635",
    "highest": "1,3645",
    "lower": "1,3525",
    "difference": "-0,66%"
  },
  {
    "date": "21.04.2005",
    "now": "1,3655",
    "open": "1,3605",
    "highest": "1,3705",
    "lower": "1,3555",
    "difference": "0,55%"
  },
  {
    "date": "20.04.2005",
    "now": "1,3580",
    "open": "1,3635",
    "highest": "1,3680",
    "lower": "1,3550",
    "difference": "-0,40%"
  },
  {
    "date": "19.04.2005",
    "now": "1,3635",
    "open": "1,3715",
    "highest": "1,3795",
    "lower": "1,3635",
    "difference": "-0,58%"
  },
  {
    "date": "18.04.2005",
    "now": "1,3715",
    "open": "1,3690",
    "highest": "1,3860",
    "lower": "1,3690",
    "difference": "0,37%"
  },
  {
    "date": "15.04.2005",
    "now": "1,3665",
    "open": "1,3675",
    "highest": "1,3875",
    "lower": "1,3660",
    "difference": "-0,04%"
  },
  {
    "date": "14.04.2005",
    "now": "1,3670",
    "open": "1,3430",
    "highest": "1,3775",
    "lower": "1,3425",
    "difference": "1,71%"
  },
  {
    "date": "13.04.2005",
    "now": "1,3440",
    "open": "1,3450",
    "highest": "1,3486",
    "lower": "1,3370",
    "difference": "-0,26%"
  },
  {
    "date": "12.04.2005",
    "now": "1,3475",
    "open": "1,3445",
    "highest": "1,3597",
    "lower": "1,3395",
    "difference": "0,07%"
  },
  {
    "date": "11.04.2005",
    "now": "1,3465",
    "open": "1,3465",
    "highest": "1,3575",
    "lower": "1,3395",
    "difference": "-0,15%"
  },
  {
    "date": "08.04.2005",
    "now": "1,3485",
    "open": "1,3475",
    "highest": "1,3585",
    "lower": "1,3475",
    "difference": "0,19%"
  },
  {
    "date": "07.04.2005",
    "now": "1,3460",
    "open": "1,3545",
    "highest": "1,3545",
    "lower": "1,3365",
    "difference": "-0,55%"
  },
  {
    "date": "06.04.2005",
    "now": "1,3535",
    "open": "1,3595",
    "highest": "1,3595",
    "lower": "1,3415",
    "difference": "-0,59%"
  },
  {
    "date": "05.04.2005",
    "now": "1,3615",
    "open": "1,3675",
    "highest": "1,3795",
    "lower": "1,3555",
    "difference": "-0,49%"
  },
  {
    "date": "04.04.2005",
    "now": "1,3682",
    "open": "1,3538",
    "highest": "1,3733",
    "lower": "1,3518",
    "difference": "0,90%"
  },
  {
    "date": "01.04.2005",
    "now": "1,3560",
    "open": "1,3520",
    "highest": "1,3605",
    "lower": "1,3325",
    "difference": "0,26%"
  },
  {
    "date": "31.03.2005",
    "now": "1,3525",
    "open": "1,3610",
    "highest": "1,3620",
    "lower": "1,3370",
    "difference": "-0,77%"
  },
  {
    "date": "30.03.2005",
    "now": "1,3630",
    "open": "1,3870",
    "highest": "1,3870",
    "lower": "1,3605",
    "difference": "-2,12%"
  },
  {
    "date": "29.03.2005",
    "now": "1,3925",
    "open": "1,3805",
    "highest": "1,3995",
    "lower": "1,3725",
    "difference": "0,72%"
  },
  {
    "date": "28.03.2005",
    "now": "1,3825",
    "open": "1,3535",
    "highest": "1,3875",
    "lower": "1,3535",
    "difference": "2,07%"
  },
  {
    "date": "25.03.2005",
    "now": "1,3545",
    "open": "1,3615",
    "highest": "1,3620",
    "lower": "1,3475",
    "difference": "-0,22%"
  },
  {
    "date": "24.03.2005",
    "now": "1,3575",
    "open": "1,3645",
    "highest": "1,3675",
    "lower": "1,3455",
    "difference": "-0,51%"
  },
  {
    "date": "23.03.2005",
    "now": "1,3645",
    "open": "1,3675",
    "highest": "1,3755",
    "lower": "1,3515",
    "difference": "2,31%"
  },
  {
    "date": "22.03.2005",
    "now": "1,3337",
    "open": "1,3413",
    "highest": "1,3453",
    "lower": "1,3242",
    "difference": "-0,10%"
  },
  {
    "date": "21.03.2005",
    "now": "1,3350",
    "open": "1,3105",
    "highest": "1,3470",
    "lower": "1,3105",
    "difference": "1,71%"
  },
  {
    "date": "18.03.2005",
    "now": "1,3125",
    "open": "1,3155",
    "highest": "1,3255",
    "lower": "1,3045",
    "difference": "0,00%"
  },
  {
    "date": "17.03.2005",
    "now": "1,3125",
    "open": "1,3185",
    "highest": "1,3435",
    "lower": "1,3065",
    "difference": "-0,46%"
  },
  {
    "date": "16.03.2005",
    "now": "1,3185",
    "open": "1,3145",
    "highest": "1,3385",
    "lower": "1,3105",
    "difference": "0,38%"
  },
  {
    "date": "15.03.2005",
    "now": "1,3135",
    "open": "1,2945",
    "highest": "1,3135",
    "lower": "1,2865",
    "difference": "1,47%"
  },
  {
    "date": "14.03.2005",
    "now": "1,2945",
    "open": "1,2655",
    "highest": "1,2993",
    "lower": "1,2655",
    "difference": "1,33%"
  },
  {
    "date": "11.03.2005",
    "now": "1,2775",
    "open": "1,2785",
    "highest": "1,2800",
    "lower": "1,2585",
    "difference": "0,00%"
  },
  {
    "date": "10.03.2005",
    "now": "1,2775",
    "open": "1,2655",
    "highest": "1,2925",
    "lower": "1,2610",
    "difference": "0,83%"
  },
  {
    "date": "09.03.2005",
    "now": "1,2670",
    "open": "1,2610",
    "highest": "1,2795",
    "lower": "1,2485",
    "difference": "0,12%"
  },
  {
    "date": "08.03.2005",
    "now": "1,2655",
    "open": "1,2605",
    "highest": "1,2685",
    "lower": "1,2565",
    "difference": "0,44%"
  },
  {
    "date": "07.03.2005",
    "now": "1,2600",
    "open": "1,2570",
    "highest": "1,2655",
    "lower": "1,2545",
    "difference": "0,24%"
  },
  {
    "date": "04.03.2005",
    "now": "1,2570",
    "open": "1,2800",
    "highest": "1,2820",
    "lower": "1,2550",
    "difference": "-1,95%"
  },
  {
    "date": "03.03.2005",
    "now": "1,2820",
    "open": "1,2830",
    "highest": "1,2850",
    "lower": "1,2685",
    "difference": "-0,04%"
  },
  {
    "date": "02.03.2005",
    "now": "1,2825",
    "open": "1,2815",
    "highest": "1,2890",
    "lower": "1,2775",
    "difference": "0,08%"
  },
  {
    "date": "01.03.2005",
    "now": "1,2815",
    "open": "1,2810",
    "highest": "1,2885",
    "lower": "1,2770",
    "difference": "-0,12%"
  },
  {
    "date": "28.02.2005",
    "now": "1,2830",
    "open": "1,2925",
    "highest": "1,2940",
    "lower": "1,2765",
    "difference": "-0,70%"
  },
  {
    "date": "25.02.2005",
    "now": "1,2920",
    "open": "1,2980",
    "highest": "1,3020",
    "lower": "1,2895",
    "difference": "-0,42%"
  },
  {
    "date": "24.02.2005",
    "now": "1,2975",
    "open": "1,3015",
    "highest": "1,3045",
    "lower": "1,2905",
    "difference": "-0,38%"
  },
  {
    "date": "23.02.2005",
    "now": "1,3025",
    "open": "1,2985",
    "highest": "1,3081",
    "lower": "1,2965",
    "difference": "0,31%"
  },
  {
    "date": "22.02.2005",
    "now": "1,2985",
    "open": "1,3025",
    "highest": "1,3065",
    "lower": "1,2930",
    "difference": "-0,61%"
  },
  {
    "date": "21.02.2005",
    "now": "1,3065",
    "open": "1,3065",
    "highest": "1,3105",
    "lower": "1,3015",
    "difference": "-0,38%"
  },
  {
    "date": "18.02.2005",
    "now": "1,3115",
    "open": "1,3060",
    "highest": "1,3155",
    "lower": "1,3035",
    "difference": "0,38%"
  },
  {
    "date": "17.02.2005",
    "now": "1,3065",
    "open": "1,3140",
    "highest": "1,3190",
    "lower": "1,3045",
    "difference": "-0,76%"
  },
  {
    "date": "16.02.2005",
    "now": "1,3165",
    "open": "1,3135",
    "highest": "1,3235",
    "lower": "1,3075",
    "difference": "0,30%"
  },
  {
    "date": "15.02.2005",
    "now": "1,3125",
    "open": "1,3135",
    "highest": "1,3175",
    "lower": "1,3060",
    "difference": "-0,11%"
  },
  {
    "date": "14.02.2005",
    "now": "1,3140",
    "open": "1,3190",
    "highest": "1,3195",
    "lower": "1,3110",
    "difference": "-0,49%"
  },
  {
    "date": "11.02.2005",
    "now": "1,3205",
    "open": "1,3285",
    "highest": "1,3305",
    "lower": "1,3180",
    "difference": "-0,68%"
  },
  {
    "date": "10.02.2005",
    "now": "1,3295",
    "open": "1,3325",
    "highest": "1,3465",
    "lower": "1,3265",
    "difference": "-0,23%"
  },
  {
    "date": "09.02.2005",
    "now": "1,3325",
    "open": "1,3335",
    "highest": "1,3495",
    "lower": "1,3210",
    "difference": "0,00%"
  },
  {
    "date": "08.02.2005",
    "now": "1,3325",
    "open": "1,3210",
    "highest": "1,3389",
    "lower": "1,3155",
    "difference": "1,02%"
  },
  {
    "date": "07.02.2005",
    "now": "1,3190",
    "open": "1,3170",
    "highest": "1,3235",
    "lower": "1,3100",
    "difference": "0,42%"
  },
  {
    "date": "04.02.2005",
    "now": "1,3135",
    "open": "1,3215",
    "highest": "1,3249",
    "lower": "1,3075",
    "difference": "-0,64%"
  },
  {
    "date": "03.02.2005",
    "now": "1,3219",
    "open": "1,3271",
    "highest": "1,3288",
    "lower": "1,3160",
    "difference": "-0,42%"
  },
  {
    "date": "02.02.2005",
    "now": "1,3275",
    "open": "1,3285",
    "highest": "1,3405",
    "lower": "1,3220",
    "difference": "-0,19%"
  },
  {
    "date": "01.02.2005",
    "now": "1,3300",
    "open": "1,3375",
    "highest": "1,3385",
    "lower": "1,3265",
    "difference": "-0,41%"
  },
  {
    "date": "31.01.2005",
    "now": "1,3355",
    "open": "1,3375",
    "highest": "1,3455",
    "lower": "1,3295",
    "difference": "-0,11%"
  },
  {
    "date": "28.01.2005",
    "now": "1,3370",
    "open": "1,3370",
    "highest": "1,3405",
    "lower": "1,3280",
    "difference": "-0,04%"
  },
  {
    "date": "27.01.2005",
    "now": "1,3375",
    "open": "1,3215",
    "highest": "1,3523",
    "lower": "1,3170",
    "difference": "1,25%"
  },
  {
    "date": "26.01.2005",
    "now": "1,3210",
    "open": "1,3340",
    "highest": "1,3375",
    "lower": "1,3170",
    "difference": "-1,05%"
  },
  {
    "date": "25.01.2005",
    "now": "1,3350",
    "open": "1,3390",
    "highest": "1,3420",
    "lower": "1,3290",
    "difference": "-0,26%"
  },
  {
    "date": "24.01.2005",
    "now": "1,3385",
    "open": "1,3425",
    "highest": "1,3445",
    "lower": "1,3360",
    "difference": "-0,30%"
  },
  {
    "date": "21.01.2005",
    "now": "1,3425",
    "open": "1,3500",
    "highest": "1,3530",
    "lower": "1,3425",
    "difference": "-0,70%"
  },
  {
    "date": "20.01.2005",
    "now": "1,3520",
    "open": "1,3430",
    "highest": "1,3540",
    "lower": "1,3430",
    "difference": "0,56%"
  },
  {
    "date": "19.01.2005",
    "now": "1,3445",
    "open": "1,3425",
    "highest": "1,3495",
    "lower": "1,3360",
    "difference": "0,15%"
  },
  {
    "date": "18.01.2005",
    "now": "1,3425",
    "open": "1,3435",
    "highest": "1,3500",
    "lower": "1,3355",
    "difference": "0,37%"
  },
  {
    "date": "17.01.2005",
    "now": "1,3375",
    "open": "1,3515",
    "highest": "1,3515",
    "lower": "1,3325",
    "difference": "-0,74%"
  },
  {
    "date": "14.01.2005",
    "now": "1,3475",
    "open": "1,3545",
    "highest": "1,3775",
    "lower": "1,3475",
    "difference": "-0,48%"
  },
  {
    "date": "13.01.2005",
    "now": "1,3540",
    "open": "1,3580",
    "highest": "1,3640",
    "lower": "1,3435",
    "difference": "-0,44%"
  },
  {
    "date": "12.01.2005",
    "now": "1,3600",
    "open": "1,3770",
    "highest": "1,3840",
    "lower": "1,3320",
    "difference": "-1,41%"
  },
  {
    "date": "11.01.2005",
    "now": "1,3795",
    "open": "1,3855",
    "highest": "1,3920",
    "lower": "1,3795",
    "difference": "-1,08%"
  },
  {
    "date": "10.01.2005",
    "now": "1,3945",
    "open": "1,3965",
    "highest": "1,4125",
    "lower": "1,3770",
    "difference": "-0,14%"
  },
  {
    "date": "07.01.2005",
    "now": "1,3965",
    "open": "1,3945",
    "highest": "1,4025",
    "lower": "1,3625",
    "difference": "0,11%"
  },
  {
    "date": "06.01.2005",
    "now": "1,3950",
    "open": "1,3785",
    "highest": "1,4175",
    "lower": "1,3780",
    "difference": "1,31%"
  },
  {
    "date": "05.01.2005",
    "now": "1,3770",
    "open": "1,3650",
    "highest": "1,3990",
    "lower": "1,3275",
    "difference": "0,81%"
  },
  {
    "date": "04.01.2005",
    "now": "1,3660",
    "open": "1,3450",
    "highest": "1,3680",
    "lower": "1,3460",
    "difference": "1,56%"
  },
  {
    "date": "03.01.2005",
    "now": "1,3450",
    "open": "1,3475",
    "highest": "1,3635",
    "lower": "1,3450",
    "difference": "-0,26%"
  }
]